import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, Injectable, InjectionToken, Component, ViewEncapsulation, Inject, Directive, Input, HostListener, EventEmitter, Output, Pipe, ViewChild, ViewContainerRef, ContentChild, inject, NgZone, forwardRef, TemplateRef, HostBinding, ChangeDetectionStrategy, Optional, Host, ViewChildren, SecurityContext, APP_INITIALIZER } from '@angular/core';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i6$3 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i5$3 from '@angular/material/checkbox';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';
import * as i3$2 from '@angular/material/chips';
import { MatChipsModule, MatChip } from '@angular/material/chips';
import * as i1$2 from '@angular/material/core';
import { MatRippleModule, MatOptionModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import * as i8 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1$1 from '@angular/material/dialog';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i5$4 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i8$1 from '@angular/material/list';
import { MatListModule, MatListItem, MatSelectionList } from '@angular/material/list';
import * as i6$2 from '@angular/material/menu';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import * as i10 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i9 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i5$2 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i4$1 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i7$3 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i3$1 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i5$6 from '@angular/material/tree';
import { MatTreeModule } from '@angular/material/tree';
import * as i7$2 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i5 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i5$1 from '@alfresco/js-api';
import { ContentApi, TrashcanApi, NodesApi, PeopleApi, SitesApi, SearchApi, SharedlinksApi, FavoritesApi, SearchRequest, SiteMemberPaging, UploadApi, VersionsApi, DownloadsApi, RequestSortDefinitionInner, TagsApi, TagBody, Pagination as Pagination$1, SiteEntry, QueriesApi, CategoriesApi, RequestQuery, NodeBodyLock, RatingsApi, RatingBody, WebscriptApi, Site, ClassesApi, TypesApi, Category, CategoryLinkBody, AspectsApi, GroupsApi, Group, NodeEntry, RenditionsApi, CommentsApi, PersonPaging, Person, SecurityGroupsApi, SecurityMarksApi, AuthorityClearanceApi } from '@alfresco/js-api';
import { Subject, from, throwError, Observable, of, forkJoin, ReplaySubject, BehaviorSubject, merge, timer, EMPTY, defer, zip, iif } from 'rxjs';
import * as i1 from '@alfresco/adf-core';
import { BpmProductVersionModel, ObjectUtils, DataSorting, BaseEvent, UserPreferenceValues, MomentDateAdapter, MOMENT_DATE_FORMATS, DisplayMode, ShowHeaderMode, ObjectDataColumn, DataTableService, DataColumnListComponent, CustomLoadingContentTemplateDirective, CustomNoPermissionTemplateDirective, CustomEmptyContentTemplateDirective, TranslationService, FileUtils, NotificationService, EXTENDIBLE_COMPONENT, LogService, InfiniteSelectScrollDirective, HighlightDirective, InfinitePaginationComponent, CoreModule, ObjectDataTableAdapter, SearchTextModule, EditJsonDialogModule, UserInfoMode, PipeModule, CardViewTextItemModel, CardViewDateItemModel, CardViewSelectItemModel, CardViewBoolItemModel, CardViewDatetimeItemModel, CardViewFloatItemModel, CardViewIntItemModel, CommentModel, ADF_COMMENTS_SERVICE, ContextMenuModule, ViewUtilService, ViewerToolbarComponent, ViewerSidebarComponent, ViewerToolbarActionsComponent, ViewerMoreActionsComponent, ViewerOpenWithComponent, TRANSLATION_PROVIDER } from '@alfresco/adf-core';
import { map, catchError, filter, take, switchMap, takeUntil, tap, startWith, delay, debounceTime, retry, mergeMap, distinctUntilChanged, debounce, finalize, first, concatMap, toArray } from 'rxjs/operators';
import { Minimatch } from 'minimatch';
import * as i2 from '@alfresco/adf-core/api';
import * as i5$5 from '@angular/cdk/overlay';
import { ConnectionPositionPair } from '@angular/cdk/overlay';
import * as i9$1 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import * as i6$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import moment$1 from 'moment';
import * as i1$4 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i2$2 from '@angular/forms';
import { Validators, UntypedFormControl, UntypedFormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i6 from '@angular/material/form-field';
import * as i1$3 from '@mat-datetimepicker/core';
import { MAT_DATETIME_FORMATS, MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { MAT_MOMENT_DATETIME_FORMATS, MatMomentDatetimeModule } from '@mat-datetimepicker/moment';
import { ENTER } from '@angular/cdk/keycodes';
import * as i7$1 from '@angular/material/autocomplete';
import * as i3$3 from '@angular/material/divider';
import * as i1$5 from '@angular/platform-browser';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i4$2 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { TemplatePortal } from '@angular/cdk/portal';
import { add, format, endOfDay } from 'date-fns';
import * as i1$6 from '@angular/cdk/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { ExtensionsModule } from '@alfresco/adf-extensions';

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MaterialModule {
}
MaterialModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MaterialModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, imports: [MatButtonModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRippleModule,
        MatMenuModule,
        MatOptionModule,
        MatExpansionModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSliderModule,
        MatTreeModule,
        MatBadgeModule], exports: [MatButtonModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRippleModule,
        MatMenuModule,
        MatOptionModule,
        MatExpansionModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSliderModule,
        MatTreeModule,
        MatBadgeModule] });
MaterialModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, imports: [MatButtonModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRippleModule,
        MatMenuModule,
        MatOptionModule,
        MatExpansionModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSliderModule,
        MatTreeModule,
        MatBadgeModule, MatButtonModule,
        MatChipsModule,
        MatDialogModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatRippleModule,
        MatMenuModule,
        MatOptionModule,
        MatExpansionModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSliderModule,
        MatTreeModule,
        MatBadgeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: MaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        MatButtonModule,
                        MatChipsModule,
                        MatDialogModule,
                        MatIconModule,
                        MatCardModule,
                        MatInputModule,
                        MatListModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatRippleModule,
                        MatMenuModule,
                        MatOptionModule,
                        MatExpansionModule,
                        MatSelectModule,
                        MatCheckboxModule,
                        MatDatepickerModule,
                        MatSlideToggleModule,
                        MatRadioModule,
                        MatSliderModule,
                        MatTreeModule,
                        MatBadgeModule
                    ],
                    exports: [
                        MatButtonModule,
                        MatChipsModule,
                        MatDialogModule,
                        MatIconModule,
                        MatCardModule,
                        MatInputModule,
                        MatListModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatRippleModule,
                        MatMenuModule,
                        MatOptionModule,
                        MatExpansionModule,
                        MatSelectModule,
                        MatCheckboxModule,
                        MatDatepickerModule,
                        MatSlideToggleModule,
                        MatRadioModule,
                        MatSliderModule,
                        MatTreeModule,
                        MatBadgeModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* spellchecker: disable */
class PermissionsEnum extends String {
}
PermissionsEnum.CONTRIBUTOR = 'Contributor';
PermissionsEnum.CONSUMER = 'Consumer';
PermissionsEnum.COLLABORATOR = 'Collaborator';
PermissionsEnum.MANAGER = 'Manager';
PermissionsEnum.EDITOR = 'Editor';
PermissionsEnum.COORDINATOR = 'Coordinator';
PermissionsEnum.NOT_CONTRIBUTOR = '!Contributor';
PermissionsEnum.NOT_CONSUMER = '!Consumer';
PermissionsEnum.NOT_COLLABORATOR = '!Collaborator';
PermissionsEnum.NOT_MANAGER = '!Manager';
PermissionsEnum.NOT_EDITOR = '!Editor';
PermissionsEnum.NOT_COORDINATOR = '!Coordinator';

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* spellchecker: disable */
class AllowableOperationsEnum extends String {
}
AllowableOperationsEnum.DELETE = 'delete';
AllowableOperationsEnum.UPDATE = 'update';
AllowableOperationsEnum.CREATE = 'create';
AllowableOperationsEnum.COPY = 'copy';
AllowableOperationsEnum.LOCK = 'lock';
AllowableOperationsEnum.UPDATEPERMISSIONS = 'updatePermissions';
AllowableOperationsEnum.NOT_DELETE = '!delete';
AllowableOperationsEnum.NOT_UPDATE = '!update';
AllowableOperationsEnum.NOT_CREATE = '!create';
AllowableOperationsEnum.NOT_UPDATEPERMISSIONS = '!updatePermissions';

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentService {
    constructor(authService, apiService) {
        this.authService = authService;
        this.apiService = apiService;
        this.folderCreated = new Subject();
        this.folderCreate = new Subject();
        this.folderEdit = new Subject();
    }
    get contentApi() {
        this._contentApi = this._contentApi ?? new ContentApi(this.apiService.getInstance());
        return this._contentApi;
    }
    /**
     * Gets a content URL for the given node.
     *
     * @param node Node or Node ID to get URL for.
     * @param attachment Toggles whether to retrieve content as an attachment for download
     * @param ticket Custom ticket to use for authentication
     * @returns URL string or `null`
     */
    getContentUrl(node, attachment, ticket) {
        if (node) {
            let nodeId;
            if (typeof node === 'string') {
                nodeId = node;
            }
            else if (node.entry) {
                nodeId = node.entry.id;
            }
            return this.contentApi.getContentUrl(nodeId, attachment, ticket);
        }
        return null;
    }
    getDocumentThumbnailUrl(nodeId, attachment, ticket) {
        return this.contentApi.getDocumentThumbnailUrl(nodeId, attachment, ticket);
    }
    /**
     * Checks if the user has permission on that node
     *
     * @param node Node to check permissions
     * @param permission Required permission type
     * @param userId Optional current user id will be taken by default
     * @returns True if the user has the required permissions, false otherwise
     */
    hasPermissions(node, permission, userId) {
        let hasPermissions = false;
        userId = userId ?? this.authService.getEcmUsername();
        const permissions = [...(node.permissions?.locallySet || []), ...(node.permissions?.inherited || [])]
            .filter((currentPermission) => currentPermission.authorityId === userId);
        if (permissions.length) {
            if (permission && permission.startsWith('!')) {
                hasPermissions = !permissions.find((currentPermission) => currentPermission.name === permission.replace('!', ''));
            }
            else {
                hasPermissions = !!permissions.find((currentPermission) => currentPermission.name === permission);
            }
        }
        else {
            if (permission === PermissionsEnum.CONSUMER) {
                hasPermissions = true;
            }
            else if (permission === PermissionsEnum.NOT_CONSUMER) {
                hasPermissions = false;
            }
            else if (permission && permission.startsWith('!')) {
                hasPermissions = true;
            }
        }
        return hasPermissions;
    }
    /**
     * Checks if the user has permissions on that node
     *
     * @param node Node to check allowableOperations
     * @param allowableOperation Create, delete, update, updatePermissions, !create, !delete, !update, !updatePermissions
     * @returns True if the user has the required permissions, false otherwise
     */
    hasAllowableOperations(node, allowableOperation) {
        let hasAllowableOperations = false;
        if (node && node.allowableOperations) {
            if (allowableOperation && allowableOperation.startsWith('!')) {
                hasAllowableOperations = !node.allowableOperations.find((currentOperation) => currentOperation === allowableOperation.replace('!', ''));
            }
            else {
                hasAllowableOperations = !!node.allowableOperations.find((currentOperation) => currentOperation === allowableOperation);
            }
        }
        else {
            if (allowableOperation && allowableOperation.startsWith('!')) {
                hasAllowableOperations = true;
            }
        }
        if (allowableOperation === AllowableOperationsEnum.COPY) {
            hasAllowableOperations = true;
        }
        if (allowableOperation === AllowableOperationsEnum.LOCK) {
            hasAllowableOperations = node.isFile;
            if (node.isLocked && node.allowableOperations) {
                hasAllowableOperations = !!~node.allowableOperations.indexOf('updatePermissions');
            }
        }
        return hasAllowableOperations;
    }
}
ContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentService, deps: [{ token: i1.AuthenticationService }, { token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AuthenticationService }, { type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeMetadata {
    constructor(metadata, nodeType) {
        this.metadata = metadata;
        this.nodeType = nodeType;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodesApiService {
    constructor(apiService, preferences) {
        this.apiService = apiService;
        this.preferences = preferences;
        /**
         * Publish/subscribe to events related to node updates.
         */
        this.nodeUpdated = new Subject();
    }
    get trashcanApi() {
        this._trashcanApi = this._trashcanApi ?? new TrashcanApi(this.apiService.getInstance());
        return this._trashcanApi;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.apiService.getInstance());
        return this._nodesApi;
    }
    getEntryFromEntity(entity) {
        return entity.entry;
    }
    /**
     * Gets the stored information about a node.
     *
     * @param nodeId ID of the target node
     * @param options Optional parameters supported by JS-API
     * @returns Node information
     */
    getNode(nodeId, options = {}) {
        const defaults = {
            include: ['path', 'properties', 'allowableOperations', 'permissions']
        };
        const queryOptions = Object.assign(defaults, options);
        return from(this.nodesApi.getNode(nodeId, queryOptions)).pipe(map(this.getEntryFromEntity), catchError((err) => throwError(err)));
    }
    /**
     * Gets the items contained in a folder node.
     *
     * @param nodeId ID of the target node
     * @param options Optional parameters supported by JS-API
     * @returns List of child items from the folder
     */
    getNodeChildren(nodeId, options = {}) {
        const defaults = {
            maxItems: this.preferences.paginationSize,
            skipCount: 0,
            include: ['path', 'properties', 'allowableOperations', 'permissions']
        };
        const queryOptions = Object.assign(defaults, options);
        return from(this.nodesApi.listNodeChildren(nodeId, queryOptions)).pipe(catchError((err) => throwError(err)));
    }
    /**
     * Creates a new document node inside a folder.
     *
     * @param parentNodeId ID of the parent folder node
     * @param nodeBody Data for the new node
     * @param options Optional parameters supported by JS-API
     * @returns Details of the new node
     */
    createNode(parentNodeId, nodeBody, options = {}) {
        return from(this.nodesApi.createNode(parentNodeId, nodeBody, options)).pipe(map(this.getEntryFromEntity), catchError((err) => throwError(err)));
    }
    /**
     * Creates a new folder node inside a parent folder.
     *
     * @param parentNodeId ID of the parent folder node
     * @param nodeBody Data for the new folder
     * @param options Optional parameters supported by JS-API
     * @returns Details of the new folder
     */
    createFolder(parentNodeId, nodeBody, options = {}) {
        const body = Object.assign({ nodeType: 'cm:folder' }, nodeBody);
        return this.createNode(parentNodeId, body, options);
    }
    /**
     * Updates the information about a node.
     *
     * @param nodeId ID of the target node
     * @param nodeBody New data for the node
     * @param options Optional parameters supported by JS-API
     * @returns Updated node information
     */
    updateNode(nodeId, nodeBody, options = {}) {
        const defaults = {
            include: ['path', 'properties', 'allowableOperations', 'permissions', 'definition']
        };
        const queryOptions = Object.assign(defaults, options);
        return from(this.nodesApi.updateNode(nodeId, nodeBody, queryOptions)).pipe(map(this.getEntryFromEntity), catchError((err) => throwError(err)));
    }
    /**
     * Moves a node to the trashcan.
     *
     * @param nodeId ID of the target node
     * @param options Optional parameters supported by JS-API
     * @returns Empty result that notifies when the deletion is complete
     */
    deleteNode(nodeId, options = {}) {
        return from(this.nodesApi.deleteNode(nodeId, options)).pipe(catchError((err) => throwError(err)));
    }
    /**
     * Restores a node previously moved to the trashcan.
     *
     * @param nodeId ID of the node to restore
     * @returns Details of the restored node
     */
    restoreNode(nodeId) {
        return from(this.trashcanApi.restoreDeletedNode(nodeId)).pipe(map(this.getEntryFromEntity), catchError((err) => throwError(err)));
    }
    /**
     * Get the metadata and the nodeType for a nodeId cleaned by the prefix.
     *
     * @param nodeId ID of the target node
     * @returns Node metadata
     */
    getNodeMetadata(nodeId) {
        return from(this.nodesApi.getNode(nodeId))
            .pipe(map(this.cleanMetadataFromSemicolon));
    }
    /**
     * Create a new Node from form metadata.
     *
     * @param path Path to the node
     * @param nodeType Node type
     * @param name Node name
     * @param nameSpace Namespace for properties
     * @param data Property data to store in the node under namespace
     * @returns The created node
     */
    createNodeMetadata(nodeType, nameSpace, data, path, name) {
        const properties = {};
        for (const key in data) {
            if (data[key]) {
                properties[nameSpace + ':' + key] = data[key];
            }
        }
        return this.createNodeInsideRoot(name || this.generateUuid(), nodeType, properties, path);
    }
    /**
     * Gets content for the given node.
     *
     * @param nodeId ID of the target node
     * @returns Content data
     */
    getNodeContent(nodeId) {
        return from(this.nodesApi.getNodeContent(nodeId))
            .pipe(catchError((err) => throwError(err)));
    }
    /**
     * Create a new Node inside `-root-` folder
     *
     * @param name Node name
     * @param nodeType Node type
     * @param properties Node body properties
     * @param path Path to the node
     * @returns The created node
     */
    createNodeInsideRoot(name, nodeType, properties, path) {
        const body = {
            name,
            nodeType,
            properties,
            relativePath: path
        };
        return from(this.nodesApi.createNode('-root-', body, {}));
    }
    generateUuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    cleanMetadataFromSemicolon(nodeEntry) {
        const metadata = {};
        if (nodeEntry && nodeEntry.entry.properties) {
            for (const key in nodeEntry.entry.properties) {
                if (key) {
                    if (key.indexOf(':') !== -1) {
                        metadata[key.split(':')[1]] = nodeEntry.entry.properties[key];
                    }
                    else {
                        metadata[key] = nodeEntry.entry.properties[key];
                    }
                }
            }
        }
        return new NodeMetadata(metadata, nodeEntry.entry.nodeType);
    }
}
NodesApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodesApiService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
NodesApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodesApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DocumentLoaderNode {
    constructor(currentNode, children) {
        this.currentNode = currentNode;
        this.children = children;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const CREATE_PERMISSION = 'create';
class CustomResourcesService {
    constructor(apiService, logService) {
        this.apiService = apiService;
        this.logService = logService;
    }
    get peopleApi() {
        this._peopleApi = this._peopleApi ?? new PeopleApi(this.apiService.getInstance());
        return this._peopleApi;
    }
    get sitesApi() {
        this._sitesApi = this._sitesApi ?? new SitesApi(this.apiService.getInstance());
        return this._sitesApi;
    }
    get trashcanApi() {
        this._trashcanApi = this._trashcanApi ?? new TrashcanApi(this.apiService.getInstance());
        return this._trashcanApi;
    }
    get searchApi() {
        this._searchApi = this._searchApi ?? new SearchApi(this.apiService.getInstance());
        return this._searchApi;
    }
    get sharedLinksApi() {
        this._sharedLinksApi = this._sharedLinksApi ?? new SharedlinksApi(this.apiService.getInstance());
        return this._sharedLinksApi;
    }
    get favoritesApi() {
        this._favoritesApi = this._favoritesApi ?? new FavoritesApi(this.apiService.getInstance());
        return this._favoritesApi;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.apiService.getInstance());
        return this._nodesApi;
    }
    /**
     * Gets files recently accessed by a user.
     *
     * @param personId ID of the user
     * @param pagination Specifies how to paginate the results
     * @param filters Specifies additional filters to apply (joined with **AND**)
     * @returns List of nodes for the recently used files
     */
    getRecentFiles(personId, pagination, filters) {
        const defaultFilter = [
            'TYPE:"content"',
            '-PNAME:"0/wiki"',
            '-TYPE:"app:filelink"',
            '-TYPE:"cm:thumbnail"',
            '-TYPE:"cm:failedThumbnail"',
            '-TYPE:"cm:rating"',
            '-TYPE:"dl:dataList"',
            '-TYPE:"dl:todoList"',
            '-TYPE:"dl:issue"',
            '-TYPE:"dl:contact"',
            '-TYPE:"dl:eventAgenda"',
            '-TYPE:"dl:event"',
            '-TYPE:"dl:task"',
            '-TYPE:"dl:simpletask"',
            '-TYPE:"dl:meetingAgenda"',
            '-TYPE:"dl:location"',
            '-TYPE:"fm:topic"',
            '-TYPE:"fm:post"',
            '-TYPE:"ia:calendarEvent"',
            '-TYPE:"lnk:link"'
        ];
        return new Observable((observer) => {
            this.peopleApi.getPerson(personId)
                .then((person) => {
                const username = person.entry.id;
                const filterQueries = [
                    { query: `cm:modified:[NOW/DAY-30DAYS TO NOW/DAY+1DAY]` },
                    { query: `cm:modifier:'${username}' OR cm:creator:'${username}'` },
                    { query: defaultFilter.join(' AND ') }
                ];
                if (filters && filters.length > 0) {
                    filterQueries.push({
                        query: filters.join()
                    });
                }
                const query = new SearchRequest({
                    query: {
                        query: '*',
                        language: 'afts'
                    },
                    filterQueries,
                    include: ['path', 'properties', 'allowableOperations'],
                    sort: [{
                            type: 'FIELD',
                            field: 'cm:modified',
                            ascending: false
                        }],
                    paging: {
                        maxItems: pagination.maxItems,
                        skipCount: pagination.skipCount
                    }
                });
                return this.searchApi.search(query)
                    .then((searchResult) => {
                    observer.next(searchResult);
                    observer.complete();
                }, (err) => {
                    observer.error(err);
                    observer.complete();
                });
            }, (err) => {
                observer.error(err);
                observer.complete();
            });
        }).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets favorite files for the current user.
     *
     * @param pagination Specifies how to paginate the results
     * @param includeFields List of data field names to include in the results
     * @param where A string to restrict the returned objects by using a predicate
     * @returns List of favorite files
     */
    loadFavorites(pagination, includeFields = [], where) {
        const includeFieldsRequest = this.getIncludesFields(includeFields);
        const defaultPredicate = '(EXISTS(target/file) OR EXISTS(target/folder))';
        const options = {
            maxItems: pagination.maxItems,
            skipCount: pagination.skipCount,
            where: where ? `${where} AND ${defaultPredicate}` : defaultPredicate,
            include: includeFieldsRequest
        };
        return new Observable((observer) => {
            this.favoritesApi.listFavorites('-me-', options)
                .then((result) => {
                const page = {
                    list: {
                        entries: result.list.entries
                            .map(({ entry }) => {
                            const target = entry.target.file || entry.target.folder;
                            target.properties = {
                                ...(target.properties || {
                                    'cm:title': entry.title || target.title,
                                    'cm:description': entry.description || target.description
                                }),
                                ...(entry.properties || {})
                            };
                            return {
                                entry: target
                            };
                        }),
                        pagination: result.list.pagination
                    }
                };
                observer.next(page);
                observer.complete();
            }, (err) => {
                observer.error(err);
                observer.complete();
            });
        }).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets sites that the current user is a member of.
     *
     * @param pagination Specifies how to paginate the results
     * @param where A string to restrict the returned objects by using a predicate
     * @returns List of sites
     */
    loadMemberSites(pagination, where) {
        const options = {
            include: ['properties'],
            maxItems: pagination.maxItems,
            skipCount: pagination.skipCount,
            where
        };
        return new Observable((observer) => {
            this.sitesApi.listSiteMembershipsForPerson('-me-', options)
                .then((result) => {
                const page = new SiteMemberPaging({
                    list: {
                        entries: result.list.entries
                            .map(({ entry: { site } }) => {
                            site.allowableOperations = site.allowableOperations ? site.allowableOperations : [CREATE_PERMISSION];
                            site.name = site.name || site.title;
                            return {
                                entry: site
                            };
                        }),
                        pagination: result.list.pagination
                    }
                });
                observer.next(page);
                observer.complete();
            }, (err) => {
                observer.error(err);
                observer.complete();
            });
        }).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets all sites in the repository.
     *
     * @param pagination Specifies how to paginate the results
     * @param where A string to restrict the returned objects by using a predicate
     * @returns List of sites
     */
    loadSites(pagination, where) {
        const options = {
            include: ['properties', 'aspectNames'],
            maxItems: pagination.maxItems,
            skipCount: pagination.skipCount,
            where
        };
        return new Observable((observer) => {
            this.sitesApi
                .listSites(options)
                .then((page) => {
                page.list.entries.map(({ entry }) => {
                    entry.name = entry.name || entry.title;
                    return { entry };
                });
                observer.next(page);
                observer.complete();
            }, (err) => {
                observer.error(err);
                observer.complete();
            });
        }).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets all items currently in the trash.
     *
     * @param pagination Specifies how to paginate the results
     * @param includeFields List of data field names to include in the results
     * @returns List of deleted items
     */
    loadTrashcan(pagination, includeFields = []) {
        const includeFieldsRequest = this.getIncludesFields(includeFields);
        const options = {
            include: includeFieldsRequest,
            maxItems: pagination.maxItems,
            skipCount: pagination.skipCount
        };
        return from(this.trashcanApi.listDeletedNodes(options))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets shared links for the current user.
     *
     * @param pagination Specifies how to paginate the results
     * @param includeFields List of data field names to include in the results
     * @param where A string to restrict the returned objects by using a predicate
     * @returns List of shared links
     */
    loadSharedLinks(pagination, includeFields = [], where) {
        const includeFieldsRequest = this.getIncludesFields(includeFields);
        const options = {
            include: includeFieldsRequest,
            maxItems: pagination.maxItems,
            skipCount: pagination.skipCount,
            where
        };
        return from(this.sharedLinksApi.listSharedLinks(options))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Is the folder ID one of the well-known aliases?
     *
     * @param folderId Folder ID name to check
     * @returns True if the ID is a well-known name, false otherwise
     */
    isCustomSource(folderId) {
        let isCustomSources = false;
        const sources = ['-trashcan-', '-sharedlinks-', '-sites-', '-mysites-', '-favorites-', '-recent-'];
        if (sources.indexOf(folderId) > -1) {
            isCustomSources = true;
        }
        return isCustomSources;
    }
    /**
     * Is the folder ID a "-my", "-root-", or "-shared-" alias?
     *
     * @param folderId Folder ID name to check
     * @returns True if the ID is one of the supported sources, false otherwise
     */
    isSupportedSource(folderId) {
        let isSupportedSources = false;
        const sources = ['-my-', '-root-', '-shared-'];
        if (sources.indexOf(folderId) > -1) {
            isSupportedSources = true;
        }
        return isSupportedSources;
    }
    /**
     * Gets a folder's contents.
     *
     * @param nodeId ID of the target folder node
     * @param pagination Specifies how to paginate the results
     * @param includeFields List of data field names to include in the results
     * @param where  Filters the Node list using the *where* condition of the REST API (for example, isFolder=true). See the REST API documentation for more information.
     * @returns List of items contained in the folder
     */
    loadFolderByNodeId(nodeId, pagination, includeFields = [], where) {
        if (nodeId === '-trashcan-') {
            return this.loadTrashcan(pagination, includeFields);
        }
        else if (nodeId === '-sharedlinks-') {
            return this.loadSharedLinks(pagination, includeFields, where);
        }
        else if (nodeId === '-sites-') {
            return this.loadSites(pagination, where);
        }
        else if (nodeId === '-mysites-') {
            return this.loadMemberSites(pagination, where);
        }
        else if (nodeId === '-favorites-') {
            return this.loadFavorites(pagination, includeFields, where);
        }
        else if (nodeId === '-recent-') {
            return this.getRecentFiles('-me-', pagination);
        }
    }
    // TODO: remove it from here
    /**
     * Gets the contents of one of the well-known aliases in the form of node ID strings.
     *
     * @param nodeId ID of the target folder node
     * @param pagination Specifies how to paginate the results
     * @returns List of node IDs
     */
    getCorrespondingNodeIds(nodeId, pagination = {}) {
        if (this.isCustomSource(nodeId)) {
            return this.loadFolderByNodeId(nodeId, pagination)
                .pipe(map((result) => result.list.entries.map((node) => this.getIdFromEntry(node, nodeId))));
        }
        else if (nodeId) {
            // cases when nodeId is '-my-', '-root-' or '-shared-'
            return from(this.nodesApi.getNode(nodeId)
                .then((node) => [node.entry.id]));
        }
        return of([]);
    }
    /**
     * Chooses the correct ID for a node entry.
     *
     * @param node Node object
     * @param nodeId ID of the node object
     * @returns ID value
     */
    getIdFromEntry(node, nodeId) {
        if (nodeId === '-sharedlinks-') {
            return node.entry.nodeId;
        }
        else if (nodeId === '-sites-' || nodeId === '-mysites-') {
            return node.entry.guid;
        }
        else if (nodeId === '-favorites-') {
            return node.entry.targetGuid;
        }
        else {
            return node.entry.id;
        }
    }
    /**
     * Does the well-known alias have a corresponding node ID?
     *
     * @param nodeId Node to check
     * @returns True if the alias has a corresponding node ID, false otherwise
     */
    hasCorrespondingNodeIds(nodeId) {
        return this.isCustomSource(nodeId) || this.isSupportedSource(nodeId);
    }
    getIncludesFields(includeFields) {
        return ['path', 'properties', 'allowableOperations', 'permissions', 'aspectNames', ...includeFields]
            .filter((element, index, array) => index === array.indexOf(element));
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
CustomResourcesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomResourcesService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
CustomResourcesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomResourcesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CustomResourcesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ROOT_ID = '-root-';
class DocumentListService {
    constructor(nodesApiService, apiService, logService, customResourcesService) {
        this.nodesApiService = nodesApiService;
        this.apiService = apiService;
        this.logService = logService;
        this.customResourcesService = customResourcesService;
    }
    get nodes() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.apiService.getInstance());
        return this._nodesApi;
    }
    /**
     * Deletes a node.
     *
     * @param nodeId ID of the node to delete
     * @returns Empty response when the operation is complete
     */
    deleteNode(nodeId) {
        return from(this.nodes.deleteNode(nodeId));
    }
    /**
     * Copy a node to destination node
     *
     * @param nodeId The id of the node to be copied
     * @param targetParentId The id of the folder where the node will be copied
     * @returns NodeEntry for the copied node
     */
    copyNode(nodeId, targetParentId) {
        return from(this.nodes.copyNode(nodeId, { targetParentId })).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Moves a node to destination node.
     *
     * @param nodeId The id of the node to be moved
     * @param targetParentId The id of the folder where the node will be moved
     * @returns NodeEntry for the moved node
     */
    moveNode(nodeId, targetParentId) {
        return from(this.nodes.moveNode(nodeId, { targetParentId })).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets the folder node with the specified relative name path below the root node.
     *
     * @param folder Path to folder.
     * @param opts Options.
     * @param includeFields Extra information to include (available options are "aspectNames", "isLink" and "association")
     * @returns Details of the folder
     */
    getFolder(folder, opts, includeFields = []) {
        let rootNodeId = ROOT_ID;
        if (opts && opts.rootFolderId) {
            rootNodeId = opts.rootFolderId;
        }
        const includeFieldsRequest = ['path', 'properties', 'allowableOperations', 'permissions', 'aspectNames', ...includeFields]
            .filter((element, index, array) => index === array.indexOf(element));
        const params = {
            includeSource: true,
            include: includeFieldsRequest
        };
        if (folder) {
            params.relativePath = folder;
        }
        if (opts) {
            if (opts.maxItems) {
                params.maxItems = opts.maxItems;
            }
            if (opts.skipCount) {
                params.skipCount = opts.skipCount;
            }
            if (opts.where) {
                params.where = opts.where;
            }
            if (opts.orderBy) {
                params.orderBy = opts.orderBy;
            }
        }
        return from(this.nodes.listNodeChildren(rootNodeId, params)).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets a node via its node ID.
     *
     * @param nodeId ID of the target node
     * @param includeFields Extra information to include (available options are "aspectNames", "isLink" and "association")
     * @returns Details of the folder
     */
    getNode(nodeId, includeFields = []) {
        const includeFieldsRequest = ['path', 'properties', 'allowableOperations', 'permissions', 'definition', ...includeFields]
            .filter((element, index, array) => index === array.indexOf(element));
        const opts = {
            includeSource: true,
            include: includeFieldsRequest
        };
        return this.nodesApiService.getNode(nodeId, opts);
    }
    /**
     * Gets a folder node via its node ID.
     *
     * @param nodeId ID of the folder node
     * @param includeFields Extra information to include (available options are "aspectNames", "isLink" and "association")
     * @returns Details of the folder
     */
    getFolderNode(nodeId, includeFields = []) {
        const includeFieldsRequest = ['path', 'properties', 'allowableOperations', 'permissions', 'aspectNames', ...includeFields]
            .filter((element, index, array) => index === array.indexOf(element));
        const opts = {
            includeSource: true,
            include: includeFieldsRequest
        };
        return from(this.nodes.getNode(nodeId, opts)).pipe(catchError((err) => this.handleError(err)));
    }
    isCustomSourceService(nodeId) {
        return this.customResourcesService.isCustomSource(nodeId);
    }
    /**
     * Load a folder by Node Id.
     *
     * @param nodeId ID of the folder node
     * @param pagination
     * @param includeFields List of data field names to include in the results
     * @param where  Optionally filter the list
     * @param orderBy order by node property
     * @returns Details of the folder
     */
    loadFolderByNodeId(nodeId, pagination, includeFields, where, orderBy) {
        if (this.customResourcesService.isCustomSource(nodeId)) {
            return this.customResourcesService.loadFolderByNodeId(nodeId, pagination, includeFields, where).pipe(map((result) => new DocumentLoaderNode(null, result)));
        }
        else {
            return this.retrieveDocumentNode(nodeId, pagination, includeFields, where, orderBy);
        }
    }
    retrieveDocumentNode(nodeId, pagination, includeFields, where, orderBy) {
        return forkJoin([
            this.getFolderNode(nodeId, includeFields),
            this.getFolder(null, {
                maxItems: pagination.maxItems,
                skipCount: pagination.skipCount,
                orderBy,
                rootFolderId: nodeId,
                where
            }, includeFields)
        ]).pipe(map((results) => new DocumentLoaderNode(results[0], results[1])));
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
DocumentListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListService, deps: [{ token: NodesApiService }, { token: i1.AlfrescoApiService }, { token: i1.LogService }, { token: CustomResourcesService }], target: i0.ɵɵFactoryTarget.Injectable });
DocumentListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }, { type: i1.AlfrescoApiService }, { type: i1.LogService }, { type: CustomResourcesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUploadOptions {
}
// eslint-disable-next-line no-shadow
var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus[FileUploadStatus["Pending"] = 0] = "Pending";
    FileUploadStatus[FileUploadStatus["Complete"] = 1] = "Complete";
    FileUploadStatus[FileUploadStatus["Starting"] = 2] = "Starting";
    FileUploadStatus[FileUploadStatus["Progress"] = 3] = "Progress";
    FileUploadStatus[FileUploadStatus["Cancelled"] = 4] = "Cancelled";
    FileUploadStatus[FileUploadStatus["Aborted"] = 5] = "Aborted";
    FileUploadStatus[FileUploadStatus["Error"] = 6] = "Error";
    FileUploadStatus[FileUploadStatus["Deleted"] = 7] = "Deleted";
})(FileUploadStatus || (FileUploadStatus = {}));
class FileModel {
    constructor(file, options, id) {
        this.status = FileUploadStatus.Pending;
        this.file = file;
        this.id = id;
        this.name = file.name;
        this.size = file.size;
        this.data = null;
        this.errorCode = null;
        this.progress = {
            loaded: 0,
            total: 0,
            percent: 0
        };
        this.options = Object.assign({}, {
            newVersion: false
        }, options);
    }
    get extension() {
        return this.name.slice((Math.max(0, this.name.lastIndexOf('.')) || Infinity) + 1);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUploadEvent {
    constructor(file, status = FileUploadStatus.Pending, error = null) {
        this.file = file;
        this.status = status;
        this.error = error;
    }
}
class FileUploadCompleteEvent extends FileUploadEvent {
    constructor(file, totalComplete = 0, data, totalAborted = 0) {
        super(file, FileUploadStatus.Complete);
        this.totalComplete = totalComplete;
        this.data = data;
        this.totalAborted = totalAborted;
    }
}
class FileUploadDeleteEvent extends FileUploadEvent {
    constructor(file, totalComplete = 0) {
        super(file, FileUploadStatus.Deleted);
        this.totalComplete = totalComplete;
    }
}
class FileUploadErrorEvent extends FileUploadEvent {
    constructor(file, error, totalError = 0) {
        super(file, FileUploadStatus.Error);
        this.error = error;
        this.totalError = totalError;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DiscoveryApiService {
    constructor(apiService, authenticationService, apiClientsService) {
        this.apiService = apiService;
        this.authenticationService = authenticationService;
        this.apiClientsService = apiClientsService;
        /**
         * Gets product information for Content Services.
         */
        this.ecmProductInfo$ = new Subject();
        this.authenticationService.onLogin
            .pipe(filter(() => this.apiService.getInstance()?.isEcmLoggedIn()), take(1), switchMap(() => this.getEcmProductInfo()))
            .subscribe((info) => this.ecmProductInfo$.next(info));
    }
    /**
     * Gets product information for Content Services.
     *
     * @returns ProductVersionModel containing product details
     */
    getEcmProductInfo() {
        const discoveryApi = this.apiClientsService.get('DiscoveryClient.discovery');
        return from(discoveryApi.getRepositoryInformation())
            .pipe(map((res) => res.entry.repository), catchError((err) => throwError(err)));
    }
    /**
     * Gets product information for Process Services.
     *
     * @returns ProductVersionModel containing product details
     */
    getBpmProductInfo() {
        const aboutApi = this.apiClientsService.get('ActivitiClient.about');
        return from(aboutApi.getAppVersion())
            .pipe(map((res) => new BpmProductVersionModel(res)), catchError((err) => throwError(err)));
    }
    getBPMSystemProperties() {
        const systemPropertiesApi = this.apiClientsService.get('ActivitiClient.system-properties');
        return from(systemPropertiesApi.getProperties())
            .pipe(map((res) => {
            if ('string' === typeof (res)) {
                throw new Error('Not valid response');
            }
            return res;
        }), catchError((err) => throwError(err.error)));
    }
}
DiscoveryApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DiscoveryApiService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.AuthenticationService }, { token: i2.ApiClientsService }], target: i0.ɵɵFactoryTarget.Injectable });
DiscoveryApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DiscoveryApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DiscoveryApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.AuthenticationService }, { type: i2.ApiClientsService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MIN_CANCELLABLE_FILE_SIZE = 1000000;
const MAX_CANCELLABLE_FILE_PERCENTAGE = 50;
class UploadService {
    constructor(apiService, appConfigService, discoveryApiService) {
        this.apiService = apiService;
        this.appConfigService = appConfigService;
        this.discoveryApiService = discoveryApiService;
        this.queue = [];
        this.queueChanged = new Subject();
        this.fileUpload = new Subject();
        this.fileUploadStarting = new Subject();
        this.fileUploadCancelled = new Subject();
        this.fileUploadProgress = new Subject();
        this.fileUploadAborted = new Subject();
        this.fileUploadError = new Subject();
        this.fileUploadComplete = new Subject();
        this.fileUploadDeleted = new Subject();
        this.fileDeleted = new Subject();
        this.cache = {};
        this.totalComplete = 0;
        this.totalAborted = 0;
        this.totalError = 0;
        this.excludedFileList = [];
        this.excludedFoldersList = [];
        this.matchingOptions = null;
        this.folderMatchingOptions = null;
        this.discoveryApiService.ecmProductInfo$.pipe(filter(info => !!info))
            .subscribe(({ status }) => {
            this.isThumbnailGenerationEnabled = status.isThumbnailGenerationEnabled;
        });
    }
    get uploadApi() {
        this._uploadApi = this._uploadApi ?? new UploadApi(this.apiService.getInstance());
        return this._uploadApi;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.apiService.getInstance());
        return this._nodesApi;
    }
    get versionsApi() {
        this._versionsApi = this._versionsApi ?? new VersionsApi(this.apiService.getInstance());
        return this._versionsApi;
    }
    clearCache() {
        this.cache = {};
    }
    /**
     * Returns the number of concurrent threads for uploading.
     *
     * @returns Number of concurrent threads (default 1)
     */
    getThreadsCount() {
        return this.appConfigService.get('upload.threads', 1);
    }
    /**
     * Checks whether the service still has files uploading or awaiting upload.
     *
     * @returns True if files in the queue are still uploading, false otherwise
     */
    isUploading() {
        const finishedFileStates = [FileUploadStatus.Complete, FileUploadStatus.Cancelled, FileUploadStatus.Aborted, FileUploadStatus.Error, FileUploadStatus.Deleted];
        return this.queue.reduce((stillUploading, currentFile) => stillUploading || finishedFileStates.indexOf(currentFile.status) === -1, false);
    }
    /**
     * Gets the file Queue
     *
     * @returns Array of files that form the queue
     */
    getQueue() {
        return this.queue;
    }
    /**
     * Adds files to the uploading queue to be uploaded
     *
     * @param files One or more separate parameters or an array of files to queue
     * @returns Array of files that were not blocked from upload by the ignore list
     */
    addToQueue(...files) {
        const allowedFiles = files.filter((currentFile) => this.filterElement(currentFile));
        this.queue = this.queue.concat(allowedFiles);
        this.queueChanged.next(this.queue);
        return allowedFiles;
    }
    /**
     * Finds all the files in the queue that are not yet uploaded and uploads them into the directory folder.
     *
     * @param successEmitter Emitter to invoke on file success status change
     * @param errorEmitter Emitter to invoke on file error status change
     */
    uploadFilesInTheQueue(successEmitter, errorEmitter) {
        const files = this.getFilesToUpload();
        if (files && files.length > 0) {
            for (const file of files) {
                this.onUploadStarting(file);
                const promise = this.beginUpload(file, successEmitter, errorEmitter);
                this.cache[file.name] = promise;
                const next = () => {
                    setTimeout(() => this.uploadFilesInTheQueue(successEmitter, errorEmitter), 100);
                };
                promise.next = next;
                promise.then(() => next(), () => next());
            }
        }
    }
    /**
     * Cancels uploading of files.
     * If the file is smaller than 1 MB the file will be uploaded and then the node deleted
     * to prevent having files that were aborted but still uploaded.
     *
     * @param files One or more separate parameters or an array of files specifying uploads to cancel
     */
    cancelUpload(...files) {
        files.forEach((file) => {
            const promise = this.cache[file.name];
            if (promise) {
                if (this.isSaveToAbortFile(file)) {
                    promise.abort();
                }
                else {
                    this.abortedFile = file.name;
                }
                delete this.cache[file.name];
                promise.next();
            }
            else {
                const performAction = this.getAction(file);
                if (performAction) {
                    performAction();
                }
            }
        });
    }
    /** Clears the upload queue */
    clearQueue() {
        this.queue = [];
        this.totalComplete = 0;
        this.totalAborted = 0;
        this.totalError = 0;
    }
    /**
     * Gets an upload promise for a file.
     *
     * @param file The target file
     * @returns Promise that is resolved if the upload is successful or error otherwise
     */
    getUploadPromise(file) {
        const opts = {
            include: ['allowableOperations']
        };
        if (this.isThumbnailGenerationEnabled) {
            opts.renditions = 'doclib';
        }
        if (file.options && file.options.versioningEnabled !== undefined) {
            opts.versioningEnabled = file.options.versioningEnabled;
        }
        if (file.options.newVersion === true) {
            opts.overwrite = true;
            opts.majorVersion = file.options.majorVersion;
            opts.comment = file.options.comment;
            opts.name = file.name;
        }
        else {
            opts.autoRename = true;
        }
        if (file.options.nodeType) {
            opts.nodeType = file.options.nodeType;
        }
        if (file.id) {
            return this.nodesApi.updateNodeContent(file.id, file.file, opts);
        }
        else {
            const nodeBody = { ...file.options };
            delete nodeBody['versioningEnabled'];
            return this.uploadApi.uploadFile(file.file, file.options.path, file.options.parentId, nodeBody, opts);
        }
    }
    getFilesToUpload() {
        const cached = Object.keys(this.cache);
        const threadsCount = this.getThreadsCount();
        if (cached.length >= threadsCount) {
            return [];
        }
        const files = this.queue
            .filter(toUpload => !cached.includes(toUpload.name) && toUpload.status === FileUploadStatus.Pending)
            .slice(0, threadsCount);
        return files;
    }
    beginUpload(file, successEmitter, errorEmitter) {
        const promise = this.getUploadPromise(file);
        promise
            .on('progress', (progress) => {
            this.onUploadProgress(file, progress);
        })
            .on('abort', () => {
            this.onUploadAborted(file);
            if (successEmitter) {
                successEmitter.emit({ value: 'File aborted' });
            }
        })
            .on('error', (err) => {
            this.onUploadError(file, err);
            if (errorEmitter) {
                errorEmitter.emit({ value: 'Error file uploaded' });
            }
        })
            .on('success', (data) => {
            if (this.abortedFile === file.name) {
                this.onUploadAborted(file);
                if (file.id === undefined) {
                    this.deleteAbortedNode(data.entry.id);
                }
                else {
                    this.deleteAbortedNodeVersion(data.entry.id, data.entry.properties['cm:versionLabel']);
                }
                if (successEmitter) {
                    successEmitter.emit({ value: 'File deleted' });
                }
            }
            else {
                this.onUploadComplete(file, data);
                if (successEmitter) {
                    successEmitter.emit({ value: data });
                }
            }
        })
            .catch(() => {
        });
        return promise;
    }
    onUploadStarting(file) {
        if (file) {
            file.status = FileUploadStatus.Starting;
            const event = new FileUploadEvent(file, FileUploadStatus.Starting);
            this.fileUpload.next(event);
            this.fileUploadStarting.next(event);
        }
    }
    onUploadProgress(file, progress) {
        if (file) {
            file.progress = progress;
            file.status = FileUploadStatus.Progress;
            const event = new FileUploadEvent(file, FileUploadStatus.Progress);
            this.fileUpload.next(event);
            this.fileUploadProgress.next(event);
        }
    }
    onUploadError(file, error) {
        if (file) {
            file.errorCode = (error || {}).status;
            file.status = FileUploadStatus.Error;
            this.totalError++;
            const promise = this.cache[file.name];
            if (promise) {
                delete this.cache[file.name];
            }
            const event = new FileUploadErrorEvent(file, error, this.totalError);
            this.fileUpload.next(event);
            this.fileUploadError.next(event);
        }
    }
    onUploadComplete(file, data) {
        if (file) {
            file.status = FileUploadStatus.Complete;
            file.data = data;
            this.totalComplete++;
            const promise = this.cache[file.name];
            if (promise) {
                delete this.cache[file.name];
            }
            const event = new FileUploadCompleteEvent(file, this.totalComplete, data, this.totalAborted);
            this.fileUpload.next(event);
            this.fileUploadComplete.next(event);
        }
    }
    onUploadAborted(file) {
        if (file) {
            file.status = FileUploadStatus.Aborted;
            this.totalAborted++;
            const event = new FileUploadEvent(file, FileUploadStatus.Aborted);
            this.fileUpload.next(event);
            this.fileUploadAborted.next(event);
        }
    }
    onUploadCancelled(file) {
        if (file) {
            file.status = FileUploadStatus.Cancelled;
            const event = new FileUploadEvent(file, FileUploadStatus.Cancelled);
            this.fileUpload.next(event);
            this.fileUploadCancelled.next(event);
        }
    }
    onUploadDeleted(file) {
        if (file) {
            file.status = FileUploadStatus.Deleted;
            this.totalComplete--;
            const event = new FileUploadDeleteEvent(file, this.totalComplete);
            this.fileUpload.next(event);
            this.fileUploadDeleted.next(event);
        }
    }
    getAction(file) {
        const actions = {
            [FileUploadStatus.Pending]: () => this.onUploadCancelled(file),
            [FileUploadStatus.Deleted]: () => this.onUploadDeleted(file),
            [FileUploadStatus.Error]: () => this.onUploadError(file, null)
        };
        return actions[file.status];
    }
    deleteAbortedNode(nodeId) {
        this.nodesApi.deleteNode(nodeId, { permanent: true })
            .then(() => (this.abortedFile = undefined));
    }
    deleteAbortedNodeVersion(nodeId, versionId) {
        this.versionsApi.deleteVersion(nodeId, versionId)
            .then(() => (this.abortedFile = undefined));
    }
    isSaveToAbortFile(file) {
        return (file.size > MIN_CANCELLABLE_FILE_SIZE &&
            file.progress.percent < MAX_CANCELLABLE_FILE_PERCENTAGE);
    }
    filterElement(file) {
        this.excludedFileList = this.appConfigService.get('files.excluded');
        this.excludedFoldersList = this.appConfigService.get('folders.excluded');
        let isAllowed = true;
        if (this.excludedFileList) {
            this.matchingOptions = this.appConfigService.get('files.match-options');
            isAllowed = this.isFileNameAllowed(file);
        }
        if (isAllowed && this.excludedFoldersList) {
            this.folderMatchingOptions = this.appConfigService.get('folders.match-options');
            isAllowed = this.isParentFolderAllowed(file);
        }
        return isAllowed;
    }
    isParentFolderAllowed(file) {
        let isAllowed = true;
        const currentFile = file.file;
        const fileRelativePath = currentFile.webkitRelativePath ? currentFile.webkitRelativePath : file.options.path;
        if (currentFile && fileRelativePath) {
            isAllowed =
                this.excludedFoldersList.filter((folderToExclude) => fileRelativePath
                    .split('/')
                    .some((pathElement) => {
                    const minimatch = new Minimatch(folderToExclude, this.folderMatchingOptions);
                    return minimatch.match(pathElement);
                })).length === 0;
        }
        return isAllowed;
    }
    isFileNameAllowed(file) {
        return (this.excludedFileList.filter((pattern) => {
            const minimatch = new Minimatch(pattern, this.matchingOptions);
            return minimatch.match(file.name);
        }).length === 0);
    }
}
UploadService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.AppConfigService }, { token: DiscoveryApiService }], target: i0.ɵɵFactoryTarget.Injectable });
UploadService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.AppConfigService }, { type: DiscoveryApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
var NodeAction;
(function (NodeAction) {
    NodeAction["ATTACH"] = "ATTACH";
    NodeAction["CHOOSE"] = "CHOOSE";
    NodeAction["COPY"] = "COPY";
    NodeAction["MOVE"] = "MOVE";
    NodeAction["NEXT"] = "NEXT";
})(NodeAction || (NodeAction = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERR_OBJECT_NOT_FOUND = 'Object source not found';
class ShareDataRow {
    constructor(obj, contentService, permissionsStyle, thumbnailService, allowDropFiles) {
        this.obj = obj;
        this.contentService = contentService;
        this.permissionsStyle = permissionsStyle;
        this.thumbnailService = thumbnailService;
        this.allowDropFiles = allowDropFiles;
        this.cache = {};
        this.isSelected = false;
        this.cssClass = '';
        if (!obj) {
            throw new Error(ERR_OBJECT_NOT_FOUND);
        }
        this.isDropTarget = allowDropFiles !== undefined ? this.allowDropFiles && this.checkNodeTypeAndPermissions(obj) : this.checkNodeTypeAndPermissions(obj);
        if (permissionsStyle) {
            this.cssClass = this.getPermissionClass(obj);
        }
        this.id = this.getId();
    }
    get node() {
        return this.obj;
    }
    set node(value) {
        this.obj = value;
        this.cache = {};
    }
    checkNodeTypeAndPermissions(nodeEntry) {
        return this.isFolderAndHasPermissionToUpload(nodeEntry) || this.isFileAndHasParentFolderPermissionToUpload(nodeEntry);
    }
    getPermissionClass(nodeEntity) {
        let permissionsClasses = '';
        this.permissionsStyle.forEach((currentPermissionsStyle) => {
            if (this.applyPermissionStyleToFolder(nodeEntity.entry, currentPermissionsStyle) || this.applyPermissionStyleToFile(nodeEntity.entry, currentPermissionsStyle)) {
                if (this.contentService.hasAllowableOperations(nodeEntity.entry, currentPermissionsStyle.permission)) {
                    permissionsClasses += ` ${currentPermissionsStyle.css}`;
                }
            }
        });
        return permissionsClasses;
    }
    applyPermissionStyleToFile(node, currentPermissionsStyle) {
        return (currentPermissionsStyle.isFile && node.isFile);
    }
    applyPermissionStyleToFolder(node, currentPermissionsStyle) {
        return (currentPermissionsStyle.isFolder && node.isFolder);
    }
    isFolderAndHasPermissionToUpload(nodeEntry) {
        return this.isFolder(nodeEntry) && this.contentService.hasAllowableOperations(nodeEntry.entry, 'create');
    }
    isFileAndHasParentFolderPermissionToUpload(nodeEntry) {
        return this.isFile(nodeEntry) && this.contentService.hasAllowableOperations(nodeEntry.entry, 'update');
    }
    isFile(nodeEntry) {
        return nodeEntry.entry && nodeEntry.entry.isFile;
    }
    isFolder(nodeEntry) {
        return nodeEntry.entry && nodeEntry.entry.isFolder;
    }
    cacheValue(key, value) {
        this.cache[key] = value;
        return value;
    }
    getValue(key) {
        if (this.cache[key] !== undefined) {
            return this.cache[key];
        }
        return ObjectUtils.getValue(this.obj.entry, key);
    }
    imageErrorResolver() {
        if (this.obj.entry.content) {
            return this.thumbnailService.getMimeTypeIcon(this.obj.entry.content.mimeType);
        }
    }
    hasValue(key) {
        return this.getValue(key) !== undefined;
    }
    getId() {
        return this.obj.entry.id || undefined;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERR_ROW_NOT_FOUND = 'Row not found';
const ERR_COL_NOT_FOUND = 'Column not found';
class ShareDataTableAdapter {
    constructor(thumbnailService, contentService, schema = [], sorting, sortingMode = 'client', allowDropFiles = false) {
        this.thumbnailService = thumbnailService;
        this.contentService = contentService;
        this.thumbnails = false;
        this.rows = [];
        this.columns = schema || [];
        this.sorting = sorting;
        this.sortingMode = sortingMode;
        this.allowDropFiles = allowDropFiles;
    }
    set sortingMode(value) {
        let newValue = (value || 'client').toLowerCase();
        if (newValue !== 'client' && newValue !== 'server') {
            newValue = 'client';
        }
        this._sortingMode = newValue;
    }
    get sortingMode() {
        return this._sortingMode;
    }
    getColumnType(_row, col) {
        return col.type;
    }
    getRows() {
        return this.rows;
    }
    // TODO: disable this api
    setRows(rows) {
        this.rows = rows || [];
        this.sort();
    }
    getColumns() {
        return this.columns;
    }
    setColumns(columns) {
        this.columns = columns || [];
    }
    getValue(row, col) {
        if (!row) {
            throw new Error(ERR_ROW_NOT_FOUND);
        }
        if (!col) {
            throw new Error(ERR_COL_NOT_FOUND);
        }
        const dataRow = row;
        const value = row.getValue(col.key);
        if (dataRow.cache[col.key] !== undefined) {
            return dataRow.cache[col.key];
        }
        if (col.key === '$thumbnail') {
            if (this.imageResolver) {
                const resolved = this.imageResolver(row, col);
                if (resolved) {
                    return resolved;
                }
            }
            const node = row.node;
            if (node.entry.isFolder) {
                return this.getFolderIcon(node);
            }
            if (node.entry.isFile) {
                if (this.thumbnails) {
                    return this.getDocumentThumbnailUrl(node);
                }
            }
            if (node.entry.content) {
                const mimeType = node.entry.content.mimeType;
                if (mimeType) {
                    return this.thumbnailService.getMimeTypeIcon(mimeType);
                }
            }
            return this.thumbnailService.getDefaultMimeTypeIcon();
        }
        if (col.type === 'image') {
            if (this.imageResolver) {
                const resolved = this.imageResolver(row, col);
                if (resolved) {
                    return resolved;
                }
            }
        }
        return dataRow.cacheValue(col.key, value);
    }
    /**
     * Gets a thumbnail URL for the given document node.
     *
     * @param node Node or Node ID to get URL for.
     * @param attachment Toggles whether to retrieve content as an attachment for download
     * @param ticket Custom ticket to use for authentication
     * @returns URL string
     */
    getDocumentThumbnailUrl(node, attachment, ticket) {
        let resultUrl;
        if (node) {
            let nodeId;
            if (typeof node === 'string') {
                nodeId = node;
            }
            else if (node.entry) {
                nodeId = node.entry.id;
            }
            resultUrl = this.contentService.getDocumentThumbnailUrl(nodeId, attachment, ticket);
        }
        return resultUrl || this.thumbnailService.getMimeTypeIcon(node.entry.content.mimeType);
    }
    getSorting() {
        return this.sorting;
    }
    setSorting(sorting) {
        this.sorting = sorting;
        this.sortRows(this.rows, this.sorting);
    }
    sort(key, direction) {
        const sorting = this.sorting || new DataSorting();
        if (key) {
            sorting.key = key;
            sorting.direction = direction || 'asc';
        }
        this.setSorting(sorting);
    }
    setFilter(filter) {
        this.filter = filter;
    }
    setImageResolver(resolver) {
        this.imageResolver = resolver;
    }
    getFolderIcon(node) {
        if (this.isSmartFolder(node)) {
            return this.thumbnailService.getMimeTypeIcon('smartFolder');
        }
        else if (this.isRuleFolder(node)) {
            return this.thumbnailService.getMimeTypeIcon('ruleFolder');
        }
        else if (this.isALinkFolder(node)) {
            return this.thumbnailService.getMimeTypeIcon('linkFolder');
        }
        else {
            return this.thumbnailService.getMimeTypeIcon('folder');
        }
    }
    isSmartFolder(node) {
        const nodeAspects = this.getNodeAspectNames(node);
        return nodeAspects.indexOf('smf:customConfigSmartFolder') > -1 ||
            (nodeAspects.indexOf('smf:systemConfigSmartFolder') > -1);
    }
    isRuleFolder(node) {
        const nodeAspects = this.getNodeAspectNames(node);
        return nodeAspects.indexOf('rule:rules') > -1 ||
            (nodeAspects.indexOf('rule:rules') > -1);
    }
    isALinkFolder(node) {
        const nodeType = node.entry ? node.entry.nodeType : node.nodeType;
        return nodeType === 'app:folderlink';
    }
    getNodeAspectNames(node) {
        return node.entry?.aspectNames ? node.entry.aspectNames : (node.aspectNames ? node.aspectNames : []);
    }
    sortRows(rows, sorting) {
        if (this.sortingMode === 'server') {
            return;
        }
        const options = {};
        if (sorting?.key && rows?.length) {
            if (sorting.key.includes('sizeInBytes') || sorting.key === 'name') {
                options.numeric = true;
            }
            rows.sort((a, b) => {
                if (a.node.entry.isFolder !== b.node.entry.isFolder) {
                    return a.node.entry.isFolder ? -1 : 1;
                }
                let left = a.getValue(sorting.key);
                if (left) {
                    left = (left instanceof Date) ? left.valueOf().toString() : left.toString();
                }
                else {
                    left = '';
                }
                let right = b.getValue(sorting.key);
                if (right) {
                    right = (right instanceof Date) ? right.valueOf().toString() : right.toString();
                }
                else {
                    right = '';
                }
                return sorting.direction === 'asc'
                    ? left.localeCompare(right, undefined, options)
                    : right.localeCompare(left, undefined, options);
            });
        }
    }
    loadPage(nodePaging, merge = false, allowDropFiles) {
        let shareDataRows = [];
        if (allowDropFiles !== undefined) {
            this.allowDropFiles = allowDropFiles;
        }
        if (nodePaging?.list) {
            const nodeEntries = nodePaging.list.entries;
            if (nodeEntries?.length) {
                shareDataRows = nodeEntries.map((item) => new ShareDataRow(item, this.contentService, this.permissionsStyle, this.thumbnailService, this.allowDropFiles));
                if (this.filter) {
                    shareDataRows = shareDataRows.filter(this.filter);
                }
                if (this.sortingMode !== 'server') {
                    // Sort by first sortable or just first column
                    if (this.columns?.length) {
                        const sorting = this.getSorting();
                        if (sorting) {
                            this.sortRows(shareDataRows, sorting);
                        }
                        else {
                            const sortable = this.columns.filter((c) => c.sortable);
                            if (sortable.length > 0) {
                                this.sort(sortable[0].key, 'asc');
                            }
                            else {
                                this.sort(this.columns[0].key, 'asc');
                            }
                        }
                    }
                }
            }
        }
        if (merge) {
            const listPrunedDuplicate = shareDataRows.filter((elementToFilter) => {
                const isPresent = this.rows.find((currentRow) => currentRow.obj.entry.id === elementToFilter.obj.entry.id);
                return !isPresent;
            });
            this.rows = this.rows.concat(listPrunedDuplicate);
        }
        else {
            this.rows = shareDataRows;
        }
    }
    getSelectedRows() {
        return this.rows.filter((row) => row.isSelected);
    }
    getRowByNodeId(nodeId) {
        return this.rows.find((row) => row.node.entry.id === nodeId);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const presetsDefaultModel = {
    '-trashcan-': [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'name',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'path',
            type: 'location',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.LOCATION',
            sortable: true
        },
        {
            key: 'content.sizeInBytes',
            type: 'fileSize',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.SIZE',
            sortable: true
        },
        {
            key: 'archivedAt',
            type: 'date',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.DELETED_ON',
            format: 'timeAgo',
            sortable: true
        },
        {
            key: 'archivedByUser.displayName',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.DELETED_BY',
            sortable: true
        }
    ],
    '-sites-': [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'title',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'visibility',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.STATUS',
            sortable: true
        }
    ],
    '-mysites-': [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'title',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'visibility',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.STATUS',
            sortable: true
        }
    ],
    '-favorites-': [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'name',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'path',
            type: 'location',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.LOCATION',
            sortable: true
        },
        {
            key: 'content.sizeInBytes',
            type: 'fileSize',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.SIZE',
            sortable: true
        },
        {
            key: 'modifiedAt',
            type: 'date',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON',
            format: 'timeAgo',
            sortable: true
        },
        {
            key: 'modifiedByUser.displayName',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_BY',
            sortable: true
        }
    ],
    '-recent-': [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'name',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'path',
            type: 'location',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.LOCATION',
            cssClass: 'ellipsis-cell',
            sortable: true
        },
        {
            key: 'content.sizeInBytes',
            type: 'fileSize',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.SIZE',
            sortable: true
        },
        {
            key: 'modifiedAt',
            type: 'date',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON',
            format: 'timeAgo',
            sortable: true
        }
    ],
    '-sharedlinks-': [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'name',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'path',
            type: 'location',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.LOCATION',
            cssClass: 'ellipsis-cell',
            sortable: true
        },
        {
            key: 'content.sizeInBytes',
            type: 'fileSize',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.SIZE',
            sortable: true
        },
        {
            key: 'modifiedAt',
            type: 'date',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON',
            format: 'timeAgo',
            sortable: true
        },
        {
            key: 'modifiedByUser.displayName',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_BY',
            sortable: true
        },
        {
            key: 'sharedByUser.displayName',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.SHARED_BY',
            sortable: true
        }
    ],
    default: [
        {
            key: '$thumbnail',
            type: 'image',
            srTitle: 'ADF-DOCUMENT-LIST.LAYOUT.THUMBNAIL',
            sortable: false
        },
        {
            key: 'name',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.NAME',
            cssClass: 'full-width ellipsis-cell',
            sortable: true
        },
        {
            key: 'content.sizeInBytes',
            type: 'fileSize',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.SIZE',
            sortable: true
        },
        {
            key: 'modifiedAt',
            type: 'date',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON',
            format: 'timeAgo',
            sortable: true
        },
        {
            key: 'modifiedByUser.displayName',
            type: 'text',
            title: 'ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_BY',
            sortable: true
        }
    ]
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
class ContentActionModel {
    constructor(obj) {
        this.disableWithNoPermission = false;
        this.disabled = false;
        this.visible = true;
        if (obj) {
            this.icon = obj.icon;
            this.title = obj.title;
            this.handler = obj.handler;
            this.execute = obj.execute;
            this.target = obj.target;
            this.permission = obj.permission;
            this.disableWithNoPermission = obj.disableWithNoPermission;
            if (obj.hasOwnProperty('disabled')) {
                this.disabled = obj.disabled;
            }
            if (obj.hasOwnProperty('visible')) {
                this.visible = obj.visible;
            }
        }
    }
}
var ContentActionTarget;
(function (ContentActionTarget) {
    ContentActionTarget["Document"] = "document";
    ContentActionTarget["Folder"] = "folder";
    ContentActionTarget["All"] = "all";
})(ContentActionTarget || (ContentActionTarget = {}));
class DocumentActionModel extends ContentActionModel {
    constructor(json) {
        super(json);
        this.target = 'document';
    }
}
class FolderActionModel extends ContentActionModel {
    constructor(json) {
        super(json);
        this.target = 'folder';
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeEntityEvent extends BaseEvent {
    constructor(nodeEntry) {
        super();
        this.value = nodeEntry;
    }
}
class NodeEntryEvent extends BaseEvent {
    constructor(node) {
        super();
        this.value = node;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LockService {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
    }
    isLocked(node) {
        let isLocked = false;
        if (this.hasLockConfigured(node)) {
            if (this.isReadOnlyLock(node)) {
                isLocked = !this.isLockExpired(node);
            }
            else if (this.isLockOwnerAllowed(node)) {
                isLocked = this.alfrescoApiService.getInstance().getEcmUsername() !== node.properties['cm:lockOwner'].id;
                if (this.isLockExpired(node)) {
                    isLocked = false;
                }
            }
        }
        return isLocked;
    }
    hasLockConfigured(node) {
        return node.isFile && node.isLocked && node.properties['cm:lockType'];
    }
    isReadOnlyLock(node) {
        return node.properties['cm:lockType'] === 'READ_ONLY_LOCK' && node.properties['cm:lockLifetime'] === 'PERSISTENT';
    }
    isLockOwnerAllowed(node) {
        return node.properties['cm:lockType'] === 'WRITE_LOCK' && node.properties['cm:lockLifetime'] === 'PERSISTENT';
    }
    getLockExpiryTime(node) {
        if (node.properties['cm:expiryDate']) {
            return moment$1(node.properties['cm:expiryDate'], 'yyyy-MM-ddThh:mm:ssZ');
        }
        return undefined;
    }
    isLockExpired(node) {
        const expiryLockTime = this.getLockExpiryTime(node);
        if (expiryLockTime) {
            return moment$1().isAfter(expiryLockTime);
        }
        return false;
    }
}
LockService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LockService, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
LockService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LockService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LockService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ADF_DOCUMENT_PARENT_COMPONENT = new InjectionToken('ADF_DOCUMENT_PARENT_COMPONENT');

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DownloadZipService {
    constructor(apiService, logService) {
        this.apiService = apiService;
        this.logService = logService;
    }
    get downloadsApi() {
        this._downloadsApi = this._downloadsApi ?? new DownloadsApi(this.apiService.getInstance());
        return this._downloadsApi;
    }
    /**
     * Creates a new download.
     *
     * @param payload Object containing the node IDs of the items to add to the ZIP file
     * @returns Status object for the download
     */
    createDownload(payload) {
        return from(this.downloadsApi.createDownload(payload)).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets status information for a download node.
     *
     * @param downloadId ID of the download node
     * @returns Status object for the download
     */
    getDownload(downloadId) {
        return from(this.downloadsApi.getDownload(downloadId));
    }
    /**
     * Cancels a download.
     *
     * @param downloadId ID of the target download node
     */
    cancelDownload(downloadId) {
        this.downloadsApi.cancelDownload(downloadId);
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
DownloadZipService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
DownloadZipService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DownloadZipDialogComponent {
    constructor(dialogRef, data, logService, downloadZipService, nodeService, contentService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.logService = logService;
        this.downloadZipService = downloadZipService;
        this.nodeService = nodeService;
        this.contentService = contentService;
        // flag for async threads
        this.cancelled = false;
    }
    ngOnInit() {
        if (this.data && this.data.nodeIds && this.data.nodeIds.length > 0) {
            if (!this.cancelled) {
                this.downloadZip(this.data.nodeIds);
            }
            else {
                this.logService.log('Cancelled');
            }
        }
    }
    cancelDownload() {
        this.cancelled = true;
        this.downloadZipService.cancelDownload(this.downloadId);
        this.dialogRef.close(false);
    }
    downloadZip(nodeIds) {
        if (nodeIds && nodeIds.length > 0) {
            this.downloadZipService.createDownload({ nodeIds }).subscribe((data) => {
                if (data && data.entry && data.entry.id) {
                    const url = this.contentService.getContentUrl(data.entry.id, true);
                    this.nodeService.getNode(data.entry.id).subscribe((downloadNode) => {
                        this.logService.log(downloadNode);
                        const fileName = downloadNode.name;
                        this.downloadId = data.entry.id;
                        this.waitAndDownload(data.entry.id, url, fileName);
                    });
                }
            });
        }
    }
    waitAndDownload(downloadId, url, fileName) {
        if (this.cancelled) {
            return;
        }
        this.downloadZipService.getDownload(downloadId).subscribe((downloadEntry) => {
            if (downloadEntry.entry) {
                if (downloadEntry.entry.status === 'DONE') {
                    this.download(url, fileName);
                }
                else {
                    setTimeout(() => {
                        this.waitAndDownload(downloadId, url, fileName);
                    }, 1000);
                }
            }
        });
    }
    download(url, fileName) {
        if (url && fileName) {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.download = fileName;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        this.dialogRef.close(true);
    }
}
DownloadZipDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i1.LogService }, { token: DownloadZipService }, { token: NodesApiService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Component });
DownloadZipDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DownloadZipDialogComponent, selector: "adf-download-zip-dialog", host: { classAttribute: "adf-download-zip-dialog" }, ngImport: i0, template: "<h1 matDialogTitle>{{ 'CORE.DIALOG.DOWNLOAD_ZIP.TITLE' | translate }}</h1>\n<div mat-dialog-content>\n    <mat-progress-bar color=\"primary\" mode=\"indeterminate\"></mat-progress-bar>\n</div>\n<mat-dialog-actions align=\"end\">\n    <button mat-button color=\"primary\" id=\"cancel-button\" (click)=\"cancelDownload()\">\n        {{ 'CORE.DIALOG.DOWNLOAD_ZIP.ACTIONS.CANCEL' | translate }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-download-zip-dialog .mat-dialog-actions .mat-button-wrapper{text-transform:uppercase}\n"], dependencies: [{ kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i10.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-download-zip-dialog', host: { class: 'adf-download-zip-dialog' }, encapsulation: ViewEncapsulation.None, template: "<h1 matDialogTitle>{{ 'CORE.DIALOG.DOWNLOAD_ZIP.TITLE' | translate }}</h1>\n<div mat-dialog-content>\n    <mat-progress-bar color=\"primary\" mode=\"indeterminate\"></mat-progress-bar>\n</div>\n<mat-dialog-actions align=\"end\">\n    <button mat-button color=\"primary\" id=\"cancel-button\" (click)=\"cancelDownload()\">\n        {{ 'CORE.DIALOG.DOWNLOAD_ZIP.ACTIONS.CANCEL' | translate }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-download-zip-dialog .mat-dialog-actions .mat-button-wrapper{text-transform:uppercase}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1.LogService }, { type: DownloadZipService }, { type: NodesApiService }, { type: ContentService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Directive selectors without adf- prefix will be deprecated on 3.0.0
 */
class NodeDownloadDirective {
    constructor(apiService, downloadService, dialog) {
        this.apiService = apiService;
        this.downloadService = downloadService;
        this.dialog = dialog;
    }
    get contentApi() {
        this._contentApi = this._contentApi ?? new ContentApi(this.apiService.getInstance());
        return this._contentApi;
    }
    onClick() {
        this.downloadNodes(this.nodes);
    }
    /**
     * Downloads multiple selected nodes.
     * Packs result into a .ZIP archive if there is more than one node selected.
     *
     * @param selection Multiple selected nodes to download
     */
    downloadNodes(selection) {
        if (!this.isSelectionValid(selection)) {
            return;
        }
        if (selection instanceof Array) {
            if (selection.length === 1) {
                this.downloadNode(selection[0]);
            }
            else {
                this.downloadZip(selection);
            }
        }
        else {
            this.downloadNode(selection);
        }
    }
    /**
     * Downloads a single node.
     * Packs result into a .ZIP archive is the node is a Folder.
     *
     * @param node Node to download
     */
    downloadNode(node) {
        if (node && node.entry) {
            const entry = node.entry;
            if (entry.isFile) {
                this.downloadFile(node);
            }
            if (entry.isFolder) {
                this.downloadZip([node]);
            }
            // Check if there's nodeId for Shared Files
            if (!entry.isFile && !entry.isFolder && entry.nodeId) {
                this.downloadFile(node);
            }
        }
    }
    isSelectionValid(selection) {
        return selection || (selection instanceof Array && selection.length > 0);
    }
    downloadFile(node) {
        if (node && node.entry) {
            // nodeId for Shared node
            const id = node.entry.nodeId || node.entry.id;
            let url;
            let fileName;
            if (this.version) {
                url = this.contentApi.getVersionContentUrl(id, this.version.entry.id, true);
                fileName = this.version.entry.name;
            }
            else {
                url = this.contentApi.getContentUrl(id, true);
                fileName = node.entry.name;
            }
            this.downloadService.downloadUrl(url, fileName);
        }
    }
    downloadZip(selection) {
        if (selection && selection.length > 0) {
            // nodeId for Shared node
            const nodeIds = selection.map((node) => (node.entry.nodeId || node.entry.id));
            this.dialog.open(DownloadZipDialogComponent, {
                width: '600px',
                disableClose: true,
                data: {
                    nodeIds
                }
            });
        }
    }
}
NodeDownloadDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeDownloadDirective, deps: [{ token: i1.AlfrescoApiService }, { token: i1.DownloadService }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Directive });
NodeDownloadDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeDownloadDirective, selector: "[adfNodeDownload]", inputs: { nodes: ["adfNodeDownload", "nodes"], version: "version" }, host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeDownloadDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[adfNodeDownload]'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.DownloadService }, { type: i1$1.MatDialog }]; }, propDecorators: { nodes: [{
                type: Input,
                args: ['adfNodeDownload']
            }], version: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileAutoDownloadComponent {
    constructor(node) {
        this.node = node;
    }
}
FileAutoDownloadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileAutoDownloadComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
FileAutoDownloadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FileAutoDownloadComponent, selector: "adf-file-auto-download", ngImport: i0, template: "<div mat-dialog-title>\n    <h3>{{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.HEADER' | translate }}</h3>\n</div>\n<mat-dialog-content>\n    {{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.LABEL' | translate }}\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n    <button\n        mat-button\n        mat-dialog-close\n        id=\"cancelButton\"\n        [attr.aria-label]=\"'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.CANCEL' | translate\">\n        {{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.CANCEL' | translate }}\n    </button>\n    <button\n        mat-button\n        mat-dialog-close\n        id=\"downloadButton\"\n        color=\"primary\"\n        [attr.aria-label]=\"'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.DOWNLOAD' | translate\"\n        [adfNodeDownload]=\"node\">\n        {{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.DOWNLOAD' | translate }}\n    </button>\n</mat-dialog-actions>\n", dependencies: [{ kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: NodeDownloadDirective, selector: "[adfNodeDownload]", inputs: ["adfNodeDownload", "version"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileAutoDownloadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-file-auto-download', template: "<div mat-dialog-title>\n    <h3>{{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.HEADER' | translate }}</h3>\n</div>\n<mat-dialog-content>\n    {{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.LABEL' | translate }}\n</mat-dialog-content>\n<mat-dialog-actions align=\"end\">\n    <button\n        mat-button\n        mat-dialog-close\n        id=\"cancelButton\"\n        [attr.aria-label]=\"'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.CANCEL' | translate\">\n        {{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.CANCEL' | translate }}\n    </button>\n    <button\n        mat-button\n        mat-dialog-close\n        id=\"downloadButton\"\n        color=\"primary\"\n        [attr.aria-label]=\"'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.DOWNLOAD' | translate\"\n        [adfNodeDownload]=\"node\">\n        {{ 'ADF-DOCUMENT-LIST.FILE_AUTO_DOWNLOAD_DIALOG.ACTIONS.DOWNLOAD' | translate }}\n    </button>\n</mat-dialog-actions>\n" }]
        }], ctorParameters: function () { return [{ type: i5$1.NodeEntry, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SEARCH_QUERY_SERVICE_TOKEN = new InjectionToken('QueryService');

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BaseQueryBuilderService {
    constructor(appConfig, alfrescoApiService) {
        this.appConfig = appConfig;
        this.alfrescoApiService = alfrescoApiService;
        /*  Stream that emits the search configuration whenever the user change the search forms */
        this.configUpdated = new Subject();
        /*  Stream that emits the query before search whenever user search  */
        this.updated = new Subject();
        /*  Stream that emits the results whenever user search  */
        this.executed = new Subject();
        /*  Stream that emits the error whenever user search  */
        this.error = new Subject();
        /*  Stream that emits search forms  */
        this.searchForms = new ReplaySubject(1);
        this.categories = [];
        this.queryFragments = {};
        this.filterQueries = [];
        this.paging = null;
        this.sorting = [];
        this.sortingOptions = [];
        this._userQuery = '';
        this.userFacetBuckets = {};
        this.config = {
            categories: []
        };
        // TODO: to be supported in future iterations
        this.ranges = {};
        this.resetToDefaults();
    }
    get searchApi() {
        this._searchApi = this._searchApi ?? new SearchApi(this.alfrescoApiService.getInstance());
        return this._searchApi;
    }
    get userQuery() {
        return this._userQuery;
    }
    set userQuery(value) {
        value = (value || '').trim();
        this._userQuery = value ? `(${value})` : '';
    }
    resetToDefaults() {
        const currentConfig = this.getDefaultConfiguration();
        this.resetSearchOptions();
        this.configUpdated.next(currentConfig);
        this.searchForms.next(this.getSearchFormDetails());
        this.setUpSearchConfiguration(currentConfig);
    }
    getDefaultConfiguration() {
        const configurations = this.loadConfiguration();
        if (this.selectedConfiguration !== undefined) {
            return configurations[this.selectedConfiguration];
        }
        if (Array.isArray(configurations)) {
            return configurations.find((configuration) => configuration.default);
        }
        return configurations;
    }
    updateSelectedConfiguration(index) {
        const currentConfig = this.loadConfiguration();
        if (Array.isArray(currentConfig) && currentConfig[index] !== undefined) {
            this.selectedConfiguration = index;
            this.configUpdated.next(currentConfig[index]);
            this.searchForms.next(this.getSearchFormDetails());
            this.resetSearchOptions();
            this.setUpSearchConfiguration(currentConfig[index]);
            this.update();
        }
    }
    resetSearchOptions() {
        this.categories = [];
        this.queryFragments = {};
        this.filterQueries = [];
        this.sorting = [];
        this.sortingOptions = [];
        this.userFacetBuckets = {};
        this.scope = null;
    }
    getSearchFormDetails() {
        const configurations = this.loadConfiguration();
        if (Array.isArray(configurations)) {
            return configurations.map((configuration, index) => ({
                index,
                name: configuration.name || 'SEARCH.UNKNOWN_CONFIGURATION',
                default: configuration.default || false,
                selected: this.selectedConfiguration !== undefined ? index === this.selectedConfiguration : configuration.default
            }));
        }
        else if (!!configurations) {
            return [{
                    index: 0,
                    name: configurations.name || 'SEARCH.UNKNOWN_CONFIGURATION',
                    default: true,
                    selected: true
                }];
        }
        return [];
    }
    setUpSearchConfiguration(currentConfiguration) {
        if (currentConfiguration) {
            this.config = JSON.parse(JSON.stringify(currentConfiguration));
            this.categories = (this.config.categories || []).filter(category => category.enabled);
            this.filterQueries = this.config.filterQueries || [];
            this.userFacetBuckets = {};
            if (this.config.sorting) {
                this.sorting = this.config.sorting.defaults || [];
                this.sortingOptions = this.config.sorting.options || [];
            }
        }
    }
    /**
     * Adds a facet bucket to a field.
     *
     * @param field The target field
     * @param bucket Bucket to add
     */
    addUserFacetBucket(field, bucket) {
        if (field && field.field && bucket) {
            const buckets = this.userFacetBuckets[field.field] || [];
            const existing = buckets.find((facetBucket) => facetBucket.label === bucket.label);
            if (!existing) {
                buckets.push(bucket);
            }
            this.userFacetBuckets[field.field] = buckets;
        }
    }
    /**
     * Gets the buckets currently added to a field
     *
     * @param field The target fields
     * @returns Bucket array
     */
    getUserFacetBuckets(field) {
        return this.userFacetBuckets[field] || [];
    }
    /**
     * Removes an existing bucket from a field.
     *
     * @param field The target field
     * @param bucket Bucket to remove
     */
    removeUserFacetBucket(field, bucket) {
        if (field && field.field && bucket) {
            const buckets = this.userFacetBuckets[field.field] || [];
            this.userFacetBuckets[field.field] = buckets
                .filter((facetBucket) => facetBucket.label !== bucket.label);
        }
    }
    /**
     * Adds a filter query to the current query.
     *
     * @param query Query string to add
     */
    addFilterQuery(query) {
        if (query) {
            const existing = this.filterQueries.find((filterQuery) => filterQuery.query === query);
            if (!existing) {
                this.filterQueries.push({ query });
            }
        }
    }
    /**
     * Removes an existing filter query.
     *
     * @param query The query to remove
     */
    removeFilterQuery(query) {
        if (query) {
            this.filterQueries = this.filterQueries
                .filter((filterQuery) => filterQuery.query !== query);
        }
    }
    /**
     * Gets a facet query by label.
     *
     * @param label Label of the query
     * @returns Facet query data
     */
    getFacetQuery(label) {
        if (label && this.hasFacetQueries) {
            const result = this.config.facetQueries.queries.find((query) => query.label === label);
            if (result) {
                return { ...result };
            }
        }
        return null;
    }
    /**
     * Gets a facet field by label.
     *
     * @param label Label of the facet field
     * @returns Facet field data
     */
    getFacetField(label) {
        if (label) {
            const fields = this.config.facetFields.fields || [];
            const result = fields.find((field) => field.label === label);
            if (result) {
                result.label = this.getSupportedLabel(result.label);
                return { ...result };
            }
        }
        return null;
    }
    setScope(scope) {
        this.scope = scope;
    }
    getScope() {
        return this.scope;
    }
    /**
     * Builds the current query and triggers the `updated` event.
     */
    update(queryBody) {
        const query = queryBody ? queryBody : this.buildQuery();
        this.updated.next(query);
    }
    /**
     * Builds and executes the current query.
     *
     * @returns Nothing
     */
    async execute(queryBody) {
        try {
            const query = queryBody ? queryBody : this.buildQuery();
            if (query) {
                const resultSetPaging = await this.searchApi.search(query);
                this.executed.next(resultSetPaging);
            }
        }
        catch (error) {
            this.error.next(error);
            this.executed.next({
                list: {
                    pagination: {
                        totalItems: 0
                    },
                    entries: []
                }
            });
        }
    }
    search(queryBody) {
        const promise = this.searchApi.search(queryBody);
        promise.then((resultSetPaging) => {
            this.executed.next(resultSetPaging);
        });
        return from(promise);
    }
    /**
     * Builds the current query.
     *
     * @returns The finished query
     */
    buildQuery() {
        const query = this.getFinalQuery();
        const include = this.config.include || [];
        if (include.length === 0) {
            include.push('path', 'allowableOperations');
        }
        if (query) {
            const result = {
                query: {
                    query,
                    language: 'afts'
                },
                include,
                paging: this.paging,
                fields: this.config.fields,
                filterQueries: this.filterQueries,
                facetQueries: this.facetQueries,
                facetIntervals: this.facetIntervals,
                facetFields: this.facetFields,
                sort: this.sort,
                highlight: this.highlight
            };
            if (this.scope) {
                result['scope'] = this.scope;
            }
            result['facetFormat'] = 'V2';
            return result;
        }
        return null;
    }
    /**
     * Gets the primary sorting definition.
     *
     * @returns The primary sorting definition
     */
    getPrimarySorting() {
        if (this.sorting && this.sorting.length > 0) {
            return this.sorting[0];
        }
        return null;
    }
    /**
     * Gets all pre-configured sorting options that users can choose from.
     *
     * @returns Pre-configured sorting options
     */
    getSortingOptions() {
        if (this.config && this.config.sorting) {
            return this.config.sorting.options || [];
        }
        return [];
    }
    /**
     * Gets the query group.
     *
     * @param query Target query
     * @returns Query group
     */
    getQueryGroup(query) {
        return query.group || this.config.facetQueries.label || 'Facet Queries';
    }
    /**
     * Checks if FacetQueries has been defined
     *
     * @returns True if defined, false otherwise
     */
    get hasFacetQueries() {
        if (this.config
            && this.config.facetQueries
            && this.config.facetQueries.queries
            && this.config.facetQueries.queries.length > 0) {
            return true;
        }
        return false;
    }
    /**
     * Checks if FacetIntervals has been defined
     *
     * @returns True if defined, false otherwise
     */
    get hasFacetIntervals() {
        return this.config
            && this.config.facetIntervals
            && this.config.facetIntervals.intervals
            && this.config.facetIntervals.intervals.length > 0;
    }
    get hasFacetHighlight() {
        return !!(this.config && this.config.highlight);
    }
    get sort() {
        return this.sorting.map((def) => new RequestSortDefinitionInner({
            type: def.type,
            field: def.field,
            ascending: def.ascending
        }));
    }
    get facetQueries() {
        if (this.hasFacetQueries) {
            return this.config.facetQueries.queries.map((query) => {
                query.group = this.getQueryGroup(query);
                return { ...query };
            });
        }
        return null;
    }
    get facetIntervals() {
        if (this.hasFacetIntervals) {
            const configIntervals = this.config.facetIntervals;
            return {
                intervals: configIntervals.intervals.map((interval) => ({
                    label: this.getSupportedLabel(interval.label),
                    field: interval.field,
                    sets: interval.sets.map((set) => ({
                        label: this.getSupportedLabel(set.label),
                        start: set.start,
                        end: set.end,
                        startInclusive: set.startInclusive,
                        endInclusive: set.endInclusive
                    }))
                }))
            };
        }
        return null;
    }
    get highlight() {
        return this.hasFacetHighlight ? this.config.highlight : null;
    }
    getFinalQuery() {
        let query = '';
        this.categories.forEach((facet) => {
            const customQuery = this.queryFragments[facet.id];
            if (customQuery) {
                if (query.length > 0) {
                    query += ' AND ';
                }
                query += `(${customQuery})`;
            }
        });
        let result = [this.userQuery, query]
            .filter((entry) => entry)
            .join(' AND ');
        if (this.userFacetBuckets) {
            Object.keys(this.userFacetBuckets).forEach((key) => {
                const subQuery = (this.userFacetBuckets[key] || [])
                    .filter((bucket) => bucket.filterQuery)
                    .map((bucket) => bucket.filterQuery)
                    .join(' OR ');
                if (subQuery) {
                    if (result.length > 0) {
                        result += ' AND ';
                    }
                    result += `(${subQuery})`;
                }
            });
        }
        return result;
    }
    get facetFields() {
        const facetFields = this.config.facetFields && this.config.facetFields.fields;
        if (facetFields && facetFields.length > 0) {
            return {
                facets: facetFields.map((facet) => ({
                    field: facet.field,
                    mincount: facet.mincount,
                    label: this.getSupportedLabel(facet.label),
                    limit: facet.limit,
                    offset: facet.offset,
                    prefix: facet.prefix
                }))
            };
        }
        return null;
    }
    /**
     * Encloses a label name with double quotes if it contains whitespace characters.
     *
     * @param configLabel Original label text
     * @returns Label, possibly with quotes if it contains spaces
     */
    getSupportedLabel(configLabel) {
        const spaceInsideLabelIndex = configLabel.search(/\s/g);
        if (spaceInsideLabelIndex > -1) {
            return `"${configLabel}"`;
        }
        return configLabel;
    }
}
BaseQueryBuilderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseQueryBuilderService, deps: [{ token: i1.AppConfigService }, { token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
BaseQueryBuilderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseQueryBuilderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BaseQueryBuilderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AppConfigService }, { type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchHeaderQueryBuilderService extends BaseQueryBuilderService {
    constructor(appConfig, alfrescoApiService, nodeApiService) {
        super(appConfig, alfrescoApiService);
        this.nodeApiService = nodeApiService;
        this.customSources = ['-trashcan-', '-sharedlinks-', '-sites-', '-mysites-', '-favorites-', '-recent-', '-my-'];
        this.activeFilters = [];
        this.updated.pipe(filter((query) => !!query)).subscribe(() => {
            this.execute();
        });
    }
    isFilterServiceActive() {
        return true;
    }
    loadConfiguration() {
        return this.appConfig.get('search-headers');
    }
    setupCurrentPagination(maxItems, skipCount) {
        if (!this.paging ||
            (this.paging &&
                this.paging.maxItems !== maxItems || this.paging.skipCount !== skipCount)) {
            this.paging = { maxItems, skipCount };
            this.execute();
        }
    }
    setActiveFilter(columnActivated, filterValue) {
        const selectedFilter = this.activeFilters.find((activeFilter) => activeFilter.key === columnActivated);
        if (!selectedFilter) {
            this.activeFilters.push({
                key: columnActivated,
                value: filterValue
            });
        }
        else {
            selectedFilter.value = filterValue;
        }
    }
    resetActiveFilters() {
        this.activeFilters = [];
    }
    getActiveFilters() {
        return this.activeFilters;
    }
    isNoFilterActive() {
        return this.activeFilters.length === 0;
    }
    removeActiveFilter(columnRemoved) {
        const filterIndex = this.activeFilters.map((activeFilter) => activeFilter.key).indexOf(columnRemoved);
        if (filterIndex >= 0) {
            this.activeFilters.splice(filterIndex, 1);
        }
    }
    setSorting(dataSorting) {
        this.sorting = [];
        dataSorting.forEach((columnSorting) => {
            const fieldValue = this.getSortingFieldFromColumnName(columnSorting.key);
            if (fieldValue) {
                const optionAscending = columnSorting.direction.toLocaleLowerCase() === 'asc';
                const type = fieldValue === 'score' ? 'SCORE' : 'FIELD';
                const currentSort = {
                    key: columnSorting.key,
                    label: 'current',
                    type,
                    field: fieldValue,
                    ascending: optionAscending
                };
                this.sorting.push(currentSort);
            }
        });
        this.execute();
    }
    getSortingFieldFromColumnName(columnName) {
        if (this.sortingOptions.length > 0) {
            const sortOption = this.sortingOptions.find((option) => option.key === columnName);
            return sortOption ? sortOption.field : '';
        }
        return '';
    }
    getCategoryForColumn(columnKey) {
        let foundCategory = null;
        if (this.categories !== null) {
            foundCategory = this.categories.find(category => category.columnKey === columnKey);
        }
        return foundCategory;
    }
    setCurrentRootFolderId(currentFolderId) {
        const alreadyAddedFilter = this.filterQueries.find(filterQueries => filterQueries.query.includes(currentFolderId));
        if (alreadyAddedFilter !== undefined) {
            this.filterQueries = [];
        }
        this.filterQueries = [{
                query: `PARENT:"workspace://SpacesStore/${currentFolderId}"`
            }];
        this.execute();
    }
    isCustomSourceNode(currentNodeId) {
        return this.customSources.includes(currentNodeId);
    }
    getNodeIdForCustomSource(customSourceId) {
        return this.nodeApiService.getNode(customSourceId);
    }
}
SearchHeaderQueryBuilderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchHeaderQueryBuilderService, deps: [{ token: i1.AppConfigService }, { token: i1.AlfrescoApiService }, { token: NodesApiService }], target: i0.ɵɵFactoryTarget.Injectable });
SearchHeaderQueryBuilderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchHeaderQueryBuilderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchHeaderQueryBuilderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AppConfigService }, { type: i1.AlfrescoApiService }, { type: NodesApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchTextComponent {
    constructor() {
        /** The content of the text box. */
        this.value = '';
        this.isActive = false;
        this.enableChangeUpdate = true;
        this.displayValue$ = new Subject();
    }
    ngOnInit() {
        if (this.context && this.settings && this.settings.pattern) {
            const pattern = new RegExp(this.settings.pattern, 'g');
            const match = pattern.exec(this.context.queryFragments[this.id] || '');
            if (this.settings.allowUpdateOnChange !== undefined &&
                this.settings.allowUpdateOnChange !== null) {
                this.enableChangeUpdate = this.settings.allowUpdateOnChange;
            }
            if (match && match.length > 1) {
                this.value = match[1];
            }
            if (this.startValue) {
                this.setValue(this.startValue);
            }
        }
    }
    clear() {
        this.isActive = false;
        this.value = '';
        if (this.enableChangeUpdate) {
            this.updateQuery(null);
        }
    }
    reset() {
        this.value = '';
        this.updateQuery(null);
    }
    onChangedHandler(event) {
        this.value = event.target.value;
        this.isActive = !!this.value;
        if (this.enableChangeUpdate) {
            this.updateQuery(this.value);
        }
    }
    updateQuery(value) {
        this.displayValue$.next(value);
        if (this.context && this.settings && this.settings.field) {
            this.context.queryFragments[this.id] = value ? `${this.settings.field}:'${this.getSearchPrefix()}${value}${this.getSearchSuffix()}'` : '';
            this.context.update();
        }
    }
    submitValues() {
        this.updateQuery(this.value);
    }
    hasValidValue() {
        return !!this.value;
    }
    getCurrentValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        this.displayValue$.next(this.value);
        this.submitValues();
    }
    getSearchPrefix() {
        return this.settings.searchPrefix ? this.settings.searchPrefix : '';
    }
    getSearchSuffix() {
        return this.settings.searchSuffix ? this.settings.searchSuffix : '';
    }
}
SearchTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchTextComponent, selector: "adf-search-text", inputs: { value: "value" }, host: { classAttribute: "adf-search-text" }, ngImport: i0, template: "<mat-form-field>\n    <input\n        matInput\n        placeholder=\"{{ settings?.placeholder | translate }}\"\n        [(ngModel)]=\"value\"\n        (change)=\"onChangedHandler($event)\">\n    <button mat-button *ngIf=\"value\" matSuffix mat-icon-button (click)=\"clear()\">\n        <mat-icon>close</mat-icon>\n    </button>\n</mat-form-field>\n", styles: [".adf-search-text .mat-form-field{width:100%;max-width:168px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-text', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-text' }, template: "<mat-form-field>\n    <input\n        matInput\n        placeholder=\"{{ settings?.placeholder | translate }}\"\n        [(ngModel)]=\"value\"\n        (change)=\"onChangedHandler($event)\">\n    <button mat-button *ngIf=\"value\" matSuffix mat-icon-button (click)=\"clear()\">\n        <mat-icon>close</mat-icon>\n    </button>\n</mat-form-field>\n", styles: [".adf-search-text .mat-form-field{width:100%;max-width:168px}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_PAGE_SIZE$1 = 5;
class SearchFilterList {
    constructor(items = [], pageSize) {
        this.filteredItems = [];
        this._filterText = '';
        this.items = [];
        this.pageSize = DEFAULT_PAGE_SIZE$1;
        this.currentPageSize = DEFAULT_PAGE_SIZE$1;
        this._filter = () => true;
        this.items = items;
        this.filteredItems = items;
        this.pageSize = pageSize || DEFAULT_PAGE_SIZE$1;
        this.currentPageSize = pageSize || DEFAULT_PAGE_SIZE$1;
    }
    get filterText() {
        return this._filterText;
    }
    set filterText(value) {
        this._filterText = value;
        this.applyFilter();
    }
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
        this.applyFilter();
    }
    applyFilter() {
        if (this.filter) {
            this.filteredItems = this.items.filter(this.filter);
        }
        else {
            this.filteredItems = this.items;
        }
        this.currentPageSize = this.pageSize;
    }
    /** Returns visible portion of the items.  */
    get visibleItems() {
        return this.filteredItems.slice(0, this.currentPageSize);
    }
    /** Returns entire collection length including items not displayed on the page. */
    get length() {
        return this.items.length;
    }
    /** Detects whether more items can be displayed. */
    get canShowMoreItems() {
        return this.filteredItems.length > this.currentPageSize;
    }
    /** Detects whether less items can be displayed. */
    get canShowLessItems() {
        return this.currentPageSize > this.pageSize;
    }
    /** Detects whether content fits single page. */
    get fitsPage() {
        return this.pageSize >= this.filteredItems.length;
    }
    /** Display more items. */
    showMoreItems() {
        if (this.canShowMoreItems) {
            this.currentPageSize += this.pageSize;
        }
    }
    /** Display less items. */
    showLessItems() {
        if (this.canShowLessItems) {
            this.currentPageSize -= this.pageSize;
        }
    }
    /** Reset entire collection and page settings. */
    clear() {
        this.currentPageSize = this.pageSize;
        this.items = [];
        this.filteredItems = [];
        this.filterText = '';
    }
    addItem(item) {
        if (!item) {
            return;
        }
        this.items.push(item);
        this.applyFilter();
    }
    deleteItem(item) {
        const removeIndex = this.items.indexOf(item);
        if (removeIndex > -1) {
            this.items.splice(removeIndex, 1);
            this.filteredItems.splice(removeIndex, 1);
        }
    }
    [Symbol.iterator]() {
        let pointer = 0;
        const items = this.visibleItems;
        return {
            next: () => {
                if (pointer < items.length) {
                    return {
                        done: false,
                        value: items[pointer++]
                    };
                }
                else {
                    return {
                        done: true,
                        value: null
                    };
                }
            }
        };
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchRadioComponent {
    constructor() {
        this.pageSize = 5;
        this.isActive = false;
        this.displayValue$ = new Subject();
        this.options = new SearchFilterList();
    }
    ngOnInit() {
        if (this.settings) {
            this.pageSize = this.settings.pageSize || 5;
            if (this.settings.options && this.settings.options.length > 0) {
                this.options = new SearchFilterList(this.settings.options, this.pageSize);
            }
        }
        const initialValue = this.getSelectedValue();
        if (initialValue !== null) {
            this.value = initialValue;
            this.context.queryFragments[this.id] = initialValue;
        }
        else if (this.startValue !== null) {
            this.value = initialValue;
            this.context.queryFragments[this.id] = initialValue;
        }
        this.enableChangeUpdate = this.settings.allowUpdateOnChange ?? true;
        this.updateDisplayValue();
    }
    getSelectedValue() {
        const options = this.settings['options'] || [];
        if (options && options.length > 0) {
            this.isActive = true;
            let selected = options.find((opt) => opt.default);
            if (!selected) {
                selected = options[0];
            }
            return selected.value;
        }
        return null;
    }
    submitValues() {
        this.setValue(this.value);
        this.updateDisplayValue();
        this.context.update();
    }
    hasValidValue() {
        const currentValue = this.getSelectedValue();
        return !!currentValue;
    }
    setValue(newValue) {
        this.value = newValue;
        this.context.queryFragments[this.id] = newValue;
        if (this.enableChangeUpdate) {
            this.updateDisplayValue();
            this.context.update();
        }
    }
    getCurrentValue() {
        return this.getSelectedValue();
    }
    updateDisplayValue() {
        const selectOptions = this.options.items.find(({ value }) => value === this.value);
        if (selectOptions) {
            this.displayValue$.next(selectOptions.name);
        }
        else {
            this.displayValue$.next('');
        }
    }
    changeHandler(event) {
        this.setValue(event.value);
    }
    clear() {
        this.isActive = false;
        const initialValue = this.getSelectedValue();
        if (initialValue !== null) {
            this.setValue(initialValue);
        }
    }
    reset() {
        const initialValue = this.getSelectedValue();
        if (initialValue !== null) {
            this.setValue(initialValue);
            this.updateDisplayValue();
            this.context.update();
        }
    }
}
SearchRadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchRadioComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchRadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchRadioComponent, selector: "adf-search-radio", inputs: { value: "value" }, host: { classAttribute: "adf-search-radio" }, ngImport: i0, template: "<mat-radio-group\n    [(ngModel)]=\"value\"\n    (change)=\"changeHandler($event)\">\n    <mat-radio-button [attr.data-automation-id]=\"'search-radio-'+(option.name | translate)\"\n        *ngFor=\"let option of options\"\n        [value]=\"option.value\"\n        class=\"adf-facet-filter\">\n        <div\n            matTooltip=\"{{ option.name | translate }}\"\n            matTooltipPosition=\"right\"\n            class=\"filter-label\">\n            {{ option.name | translate }}\n        </div>\n    </mat-radio-button>\n</mat-radio-group>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!options.fitsPage\">\n    <button mat-icon-button\n        *ngIf=\"options.canShowLessItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-LESS' | translate }}\"\n        (click)=\"options.showLessItems()\">\n        <mat-icon>keyboard_arrow_up</mat-icon>\n    </button>\n    <button mat-icon-button\n        *ngIf=\"options.canShowMoreItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-MORE' | translate }}\"\n        (click)=\"options.showMoreItems()\">\n        <mat-icon>keyboard_arrow_down</mat-icon>\n    </button>\n</div>\n", styles: [".adf-search-radio .mat-radio-group{display:flex;flex-direction:column}.adf-search-radio .mat-radio-button{margin:5px}.adf-search-radio .adf-facet-filter .mat-radio-label-content{text-overflow:ellipsis;overflow:hidden;width:100%}.adf-search-radio .adf-facet-filter .mat-radio-label{width:100%}.adf-search-radio .adf-facet-filter .adf-filter-label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i5$2.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i5$2.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-radio', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-radio' }, template: "<mat-radio-group\n    [(ngModel)]=\"value\"\n    (change)=\"changeHandler($event)\">\n    <mat-radio-button [attr.data-automation-id]=\"'search-radio-'+(option.name | translate)\"\n        *ngFor=\"let option of options\"\n        [value]=\"option.value\"\n        class=\"adf-facet-filter\">\n        <div\n            matTooltip=\"{{ option.name | translate }}\"\n            matTooltipPosition=\"right\"\n            class=\"filter-label\">\n            {{ option.name | translate }}\n        </div>\n    </mat-radio-button>\n</mat-radio-group>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!options.fitsPage\">\n    <button mat-icon-button\n        *ngIf=\"options.canShowLessItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-LESS' | translate }}\"\n        (click)=\"options.showLessItems()\">\n        <mat-icon>keyboard_arrow_up</mat-icon>\n    </button>\n    <button mat-icon-button\n        *ngIf=\"options.canShowMoreItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-MORE' | translate }}\"\n        (click)=\"options.showMoreItems()\">\n        <mat-icon>keyboard_arrow_down</mat-icon>\n    </button>\n</div>\n", styles: [".adf-search-radio .mat-radio-group{display:flex;flex-direction:column}.adf-search-radio .mat-radio-button{margin:5px}.adf-search-radio .adf-facet-filter .mat-radio-label-content{text-overflow:ellipsis;overflow:hidden;width:100%}.adf-search-radio .adf-facet-filter .mat-radio-label{width:100%}.adf-search-radio .adf-facet-filter .adf-filter-label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchSliderComponent {
    constructor() {
        this.thumbLabel = false;
        this.displayValue$ = new Subject();
    }
    ngOnInit() {
        if (this.settings) {
            if (this.settings.hasOwnProperty('min')) {
                this.min = this.settings['min'];
            }
            if (this.settings.hasOwnProperty('max')) {
                this.max = this.settings['max'];
            }
            if (this.settings.hasOwnProperty('step')) {
                this.step = this.settings['step'];
            }
            this.thumbLabel = this.settings['thumbLabel'] ? true : false;
            this.enableChangeUpdate = this.settings.allowUpdateOnChange ?? true;
        }
        if (this.startValue) {
            this.setValue(this.startValue);
        }
    }
    clear() {
        this.value = this.min || 0;
        if (this.enableChangeUpdate) {
            this.updateQuery(null);
        }
    }
    reset() {
        this.value = this.min || 0;
        this.updateQuery(null);
    }
    onChangedHandler(event) {
        this.value = event.value;
        if (this.enableChangeUpdate) {
            this.updateQuery(this.value);
        }
    }
    submitValues() {
        this.updateQuery(this.value);
    }
    hasValidValue() {
        return !!this.value;
    }
    getCurrentValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        this.submitValues();
    }
    updateQuery(value) {
        this.displayValue$.next(this.value ? `${this.value} ${this.settings.unit ?? ''}` : '');
        if (this.id && this.context && this.settings && this.settings.field) {
            if (value === null) {
                this.context.queryFragments[this.id] = '';
            }
            else {
                this.context.queryFragments[this.id] = `${this.settings.field}:[0 TO ${value}]`;
            }
            this.context.update();
        }
    }
}
SearchSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchSliderComponent, selector: "adf-search-slider", inputs: { value: "value" }, host: { classAttribute: "adf-search-slider" }, ngImport: i0, template: "<mat-slider\n    [(value)]=\"value\"\n    [min]=\"min\"\n    [max]=\"max\"\n    [step]=\"step\"\n    [thumbLabel]=\"thumbLabel\"\n    (change)=\"onChangedHandler($event)\"\n    data-automation-id=\"slider-range\">\n</mat-slider>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!settings?.hideDefaultAction\">\n    <button mat-button color=\"primary\" (click)=\"clear()\" data-automation-id=\"slider-btn-clear\">\n        {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n    </button>\n</div>\n", styles: [".adf-search-slider .mat-slider{width:100%}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3$1.MatSlider, selector: "mat-slider", inputs: ["disabled", "color", "tabIndex", "invert", "max", "min", "step", "thumbLabel", "tickInterval", "value", "displayWith", "valueText", "vertical"], outputs: ["change", "input", "valueChange"], exportAs: ["matSlider"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-slider', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-slider' }, template: "<mat-slider\n    [(value)]=\"value\"\n    [min]=\"min\"\n    [max]=\"max\"\n    [step]=\"step\"\n    [thumbLabel]=\"thumbLabel\"\n    (change)=\"onChangedHandler($event)\"\n    data-automation-id=\"slider-range\">\n</mat-slider>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!settings?.hideDefaultAction\">\n    <button mat-button color=\"primary\" (click)=\"clear()\" data-automation-id=\"slider-btn-clear\">\n        {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n    </button>\n</div>\n", styles: [".adf-search-slider .mat-slider{width:100%}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LiveErrorStateMatcher {
    isErrorState(control, form) {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || (!control.pristine && isSubmitted)));
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchNumberRangeComponent {
    constructor() {
        this.matcher = new LiveErrorStateMatcher();
        this.format = '[{FROM} TO {TO}]';
        this.isActive = false;
        this.displayValue$ = new Subject();
    }
    ngOnInit() {
        if (this.settings) {
            this.field = this.settings.field;
            this.format = this.settings.format || '[{FROM} TO {TO}]';
        }
        this.validators = Validators.compose([
            Validators.required,
            Validators.pattern(/^-?(0|[1-9]\d*)?$/),
            Validators.min(0)
        ]);
        if (this.startValue) {
            this.from = new UntypedFormControl(this.startValue['from'], this.validators);
            this.to = new UntypedFormControl(this.startValue['to'], this.validators);
        }
        else {
            this.from = new UntypedFormControl('', this.validators);
            this.to = new UntypedFormControl('', this.validators);
        }
        this.form = new UntypedFormGroup({
            from: this.from,
            to: this.to
        }, this.formValidator);
        this.enableChangeUpdate = this.settings?.allowUpdateOnChange ?? true;
        this.updateDisplayValue();
    }
    formValidator(formGroup) {
        return parseInt(formGroup.get('from').value, 10) < parseInt(formGroup.get('to').value, 10) ? null : { mismatch: true };
    }
    apply(model, isValid) {
        if (isValid && this.id && this.context && this.field) {
            this.updateDisplayValue();
            this.isActive = true;
            const map = new Map();
            map.set('FROM', model.from);
            map.set('TO', model.to);
            const value = this.formatString(this.format, map);
            this.context.queryFragments[this.id] = `${this.field}:${value}`;
            this.context.update();
        }
    }
    formatString(str, map) {
        let result = str;
        map.forEach((value, key) => {
            const expr = new RegExp('{' + key + '}', 'gm');
            result = result.replace(expr, value);
        });
        return result;
    }
    submitValues() {
        this.apply(this.form.value, this.form.valid);
    }
    hasValidValue() {
        return this.form.valid;
    }
    getCurrentValue() {
        return this.form.value;
    }
    updateDisplayValue() {
        if (this.form.invalid || this.form.pristine) {
            this.displayValue$.next('');
        }
        else {
            this.displayValue$.next(`${this.form.value.from} - ${this.form.value.to} ${this.settings.unit ?? ''}`);
        }
    }
    setValue(value) {
        this.form['from'].setValue(value);
        this.form['to'].setValue(value);
        this.updateDisplayValue();
    }
    clear() {
        this.isActive = false;
        this.form.reset({
            from: '',
            to: ''
        });
        if (this.id && this.context) {
            this.context.queryFragments[this.id] = '';
            this.updateDisplayValue();
            if (this.enableChangeUpdate) {
                this.context.update();
            }
        }
    }
    reset() {
        this.clear();
        if (this.id && this.context) {
            this.context.update();
        }
    }
}
SearchNumberRangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchNumberRangeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchNumberRangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchNumberRangeComponent, selector: "adf-search-number-range", host: { classAttribute: "adf-search-number-range" }, ngImport: i0, template: "<form [formGroup]=\"form\" novalidate (ngSubmit)=\"apply(form.value, form.valid)\">\n\n    <mat-form-field>\n        <input\n            matInput [formControl]=\"from\" [errorStateMatcher]=\"matcher\"\n            placeholder=\"{{ 'SEARCH.FILTER.RANGE.FROM' | translate }}\"\n            autocomplete=\"off\"\n            data-automation-id=\"number-range-from-input\">\n        <mat-error *ngIf=\"from.hasError('pattern') || from.hasError('min')\" data-automation-id=\"number-range-from-error-invalid\">\n            {{ 'SEARCH.FILTER.VALIDATION.INVALID-FORMAT' | translate }}\n        </mat-error>\n        <mat-error *ngIf=\"from.hasError('required')\" data-automation-id=\"number-range-from-error-required\">\n            {{ 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' | translate }}\n        </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n        <input\n            matInput [formControl]=\"to\" [errorStateMatcher]=\"matcher\"\n            placeholder=\"{{ 'SEARCH.FILTER.RANGE.TO' | translate }}\"\n            autocomplete=\"off\"\n            data-automation-id=\"number-range-to-input\">\n        <mat-error *ngIf=\"to.hasError('pattern') || to.hasError('min')\" data-automation-id=\"number-range-to-error-invalid\">\n            {{ 'SEARCH.FILTER.VALIDATION.INVALID-FORMAT' | translate }}\n        </mat-error>\n        <mat-error *ngIf=\"to.hasError('required')\" data-automation-id=\"number-range-to-error-required\">\n            {{ 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' | translate }}\n        </mat-error>\n    </mat-form-field>\n\n\n    <div class=\"adf-facet-buttons\" *ngIf=\"!settings?.hideDefaultAction\">\n        <button mat-button color=\"primary\" type=\"button\" (click)=\"clear()\" data-automation-id=\"number-range-btn-clear\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n        </button>\n        <button mat-button color=\"primary\" type=\"submit\" [disabled]=\"!form.valid\" data-automation-id=\"number-range-btn-apply\">\n            {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n        </button>\n    </div>\n</form>\n", styles: [".adf-search-number-range>form{display:inline-flex;flex-direction:column;width:100%}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchNumberRangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-number-range', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-number-range' }, template: "<form [formGroup]=\"form\" novalidate (ngSubmit)=\"apply(form.value, form.valid)\">\n\n    <mat-form-field>\n        <input\n            matInput [formControl]=\"from\" [errorStateMatcher]=\"matcher\"\n            placeholder=\"{{ 'SEARCH.FILTER.RANGE.FROM' | translate }}\"\n            autocomplete=\"off\"\n            data-automation-id=\"number-range-from-input\">\n        <mat-error *ngIf=\"from.hasError('pattern') || from.hasError('min')\" data-automation-id=\"number-range-from-error-invalid\">\n            {{ 'SEARCH.FILTER.VALIDATION.INVALID-FORMAT' | translate }}\n        </mat-error>\n        <mat-error *ngIf=\"from.hasError('required')\" data-automation-id=\"number-range-from-error-required\">\n            {{ 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' | translate }}\n        </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n        <input\n            matInput [formControl]=\"to\" [errorStateMatcher]=\"matcher\"\n            placeholder=\"{{ 'SEARCH.FILTER.RANGE.TO' | translate }}\"\n            autocomplete=\"off\"\n            data-automation-id=\"number-range-to-input\">\n        <mat-error *ngIf=\"to.hasError('pattern') || to.hasError('min')\" data-automation-id=\"number-range-to-error-invalid\">\n            {{ 'SEARCH.FILTER.VALIDATION.INVALID-FORMAT' | translate }}\n        </mat-error>\n        <mat-error *ngIf=\"to.hasError('required')\" data-automation-id=\"number-range-to-error-required\">\n            {{ 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' | translate }}\n        </mat-error>\n    </mat-form-field>\n\n\n    <div class=\"adf-facet-buttons\" *ngIf=\"!settings?.hideDefaultAction\">\n        <button mat-button color=\"primary\" type=\"button\" (click)=\"clear()\" data-automation-id=\"number-range-btn-clear\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n        </button>\n        <button mat-button color=\"primary\" type=\"submit\" [disabled]=\"!form.valid\" data-automation-id=\"number-range-btn-apply\">\n            {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n        </button>\n    </div>\n</form>\n", styles: [".adf-search-number-range>form{display:inline-flex;flex-direction:column;width:100%}\n"] }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchCheckListComponent {
    constructor(translationService) {
        this.translationService = translationService;
        this.operator = 'OR';
        this.startValue = null;
        this.pageSize = 5;
        this.isActive = false;
        this.enableChangeUpdate = true;
        this.displayValue$ = new Subject();
        this.options = new SearchFilterList();
    }
    ngOnInit() {
        if (this.settings) {
            this.operator = this.settings.operator || 'OR';
            this.pageSize = this.settings.pageSize || 5;
            if (this.settings.options && this.settings.options.length > 0) {
                this.options = new SearchFilterList(this.settings.options, this.pageSize);
            }
            this.enableChangeUpdate = this.settings.allowUpdateOnChange ?? true;
        }
        if (this.startValue) {
            this.setValue(this.startValue);
        }
    }
    clear() {
        this.isActive = false;
        this.clearOptions();
        if (this.id && this.context && this.enableChangeUpdate) {
            this.updateDisplayValue();
            this.context.update();
        }
    }
    clearOptions() {
        this.options.items.forEach((opt) => {
            opt.checked = false;
        });
        if (this.id && this.context) {
            this.context.queryFragments[this.id] = '';
        }
    }
    reset() {
        this.isActive = false;
        this.clearOptions();
        if (this.id && this.context) {
            this.updateDisplayValue();
            this.context.update();
        }
    }
    updateDisplayValue() {
        const displayValue = this.options.items
            .filter((option) => option.checked)
            .map(({ name }) => this.translationService.instant(name))
            .join(', ');
        this.displayValue$.next(displayValue);
    }
    changeHandler(event, option) {
        option.checked = event.checked;
        const checkedValues = this.getCheckedValues();
        this.isActive = !!checkedValues.length;
        if (this.enableChangeUpdate) {
            this.submitValues();
        }
    }
    hasValidValue() {
        const checkedValues = this.getCheckedValues();
        return !!checkedValues.length;
    }
    getCurrentValue() {
        return this.getCheckedValues();
    }
    setValue(value) {
        this.options.items.filter((item) => value.includes(item.value))
            .map((item) => item.checked = true);
        this.submitValues();
    }
    getCheckedValues() {
        return this.options.items
            .filter((option) => option.checked)
            .map((option) => option.value);
    }
    submitValues() {
        const checkedValues = this.getCheckedValues();
        const query = checkedValues.join(` ${this.operator} `);
        if (this.id && this.context) {
            this.context.queryFragments[this.id] = query;
            this.updateDisplayValue();
            this.context.update();
        }
    }
}
SearchCheckListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchCheckListComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
SearchCheckListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchCheckListComponent, selector: "adf-search-check-list", host: { classAttribute: "adf-search-check-list" }, ngImport: i0, template: "<div class=\"checklist\">\n    <mat-checkbox\n        *ngFor=\"let option of options\"\n        [checked]=\"option.checked\"\n        (keydown.enter)=\"option.checked = !option.checked\"\n        [attr.data-automation-id]=\"'checkbox-' + (option.name)\"\n        [attr.aria-label]=\"option.name | translate\"\n        (change)=\"changeHandler($event, option)\"\n        class=\"adf-facet-filter\">\n        <div matTooltip=\"{{ option.name | translate }}\"\n            matTooltipPosition=\"right\"\n            class=\"facet-name\">\n            {{ option.name | translate }}\n        </div>\n\n    </mat-checkbox>\n</div>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"options.fitsPage && !settings?.hideDefaultAction\">\n    <button mat-button color=\"primary\" (click)=\"clear()\">\n        {{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\n    </button>\n</div>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!options.fitsPage\">\n    <button mat-icon-button\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\"\n        (click)=\"clear()\">\n        <mat-icon>clear</mat-icon>\n    </button>\n    <button mat-icon-button\n        *ngIf=\"options.canShowLessItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-LESS' | translate }}\"\n        (click)=\"options.showLessItems()\">\n        <mat-icon>keyboard_arrow_up</mat-icon>\n    </button>\n    <button mat-icon-button\n        *ngIf=\"options.canShowMoreItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-MORE' | translate }}\"\n        (click)=\"options.showMoreItems()\">\n        <mat-icon>keyboard_arrow_down</mat-icon>\n    </button>\n</div>\n", styles: [".adf-search-check-list>div{display:flex;flex-direction:column}.adf-search-check-list>div .adf-facet-filter.mat-checkbox{display:block}.adf-search-check-list>div .adf-facet-filter .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;width:100%}.adf-search-check-list>div .adf-facet-filter .mat-checkbox-layout{width:100%}.adf-search-check-list>div .adf-facet-filter .adf-facet-name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i5$3.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchCheckListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-check-list', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-check-list' }, template: "<div class=\"checklist\">\n    <mat-checkbox\n        *ngFor=\"let option of options\"\n        [checked]=\"option.checked\"\n        (keydown.enter)=\"option.checked = !option.checked\"\n        [attr.data-automation-id]=\"'checkbox-' + (option.name)\"\n        [attr.aria-label]=\"option.name | translate\"\n        (change)=\"changeHandler($event, option)\"\n        class=\"adf-facet-filter\">\n        <div matTooltip=\"{{ option.name | translate }}\"\n            matTooltipPosition=\"right\"\n            class=\"facet-name\">\n            {{ option.name | translate }}\n        </div>\n\n    </mat-checkbox>\n</div>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"options.fitsPage && !settings?.hideDefaultAction\">\n    <button mat-button color=\"primary\" (click)=\"clear()\">\n        {{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\n    </button>\n</div>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!options.fitsPage\">\n    <button mat-icon-button\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\"\n        (click)=\"clear()\">\n        <mat-icon>clear</mat-icon>\n    </button>\n    <button mat-icon-button\n        *ngIf=\"options.canShowLessItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-LESS' | translate }}\"\n        (click)=\"options.showLessItems()\">\n        <mat-icon>keyboard_arrow_up</mat-icon>\n    </button>\n    <button mat-icon-button\n        *ngIf=\"options.canShowMoreItems\"\n        title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-MORE' | translate }}\"\n        (click)=\"options.showMoreItems()\">\n        <mat-icon>keyboard_arrow_down</mat-icon>\n    </button>\n</div>\n", styles: [".adf-search-check-list>div{display:flex;flex-direction:column}.adf-search-check-list>div .adf-facet-filter.mat-checkbox{display:block}.adf-search-check-list>div .adf-facet-filter .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;width:100%}.adf-search-check-list>div .adf-facet-filter .mat-checkbox-layout{width:100%}.adf-search-check-list>div .adf-facet-filter .adf-facet-name{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_FORMAT_DATE = 'DD/MM/YYYY';
class SearchDateRangeComponent {
    constructor(dateAdapter, userPreferencesService) {
        this.dateAdapter = dateAdapter;
        this.userPreferencesService = userPreferencesService;
        this.matcher = new LiveErrorStateMatcher();
        this.isActive = false;
        this.displayValue$ = new Subject();
        this.onDestroy$ = new Subject();
    }
    getFromValidationMessage() {
        return this.from.hasError('invalidOnChange') || this.hasParseError(this.from) ? 'SEARCH.FILTER.VALIDATION.INVALID-DATE' :
            this.from.hasError('matDatepickerMax') ? 'SEARCH.FILTER.VALIDATION.BEYOND-MAX-DATE' :
                this.from.hasError('required') ? 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' :
                    '';
    }
    getToValidationMessage() {
        return this.to.hasError('invalidOnChange') || this.hasParseError(this.to) ? 'SEARCH.FILTER.VALIDATION.INVALID-DATE' :
            this.to.hasError('matDatepickerMin') ? 'SEARCH.FILTER.VALIDATION.NO-DAYS' :
                this.to.hasError('matDatepickerMax') ? 'SEARCH.FILTER.VALIDATION.BEYOND-MAX-DATE' :
                    this.to.hasError('required') ? 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' :
                        '';
    }
    ngOnInit() {
        this.datePickerFormat = this.settings?.dateFormat ? this.settings.dateFormat : DEFAULT_FORMAT_DATE;
        const customDateAdapter = this.dateAdapter;
        customDateAdapter.overrideDisplayFormat = this.datePickerFormat;
        this.userPreferencesService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => this.setLocale(locale));
        const validators = Validators.compose([
            Validators.required
        ]);
        if (this.settings && this.settings.maxDate) {
            if (this.settings.maxDate === 'today') {
                this.maxDate = this.dateAdapter.today().endOf('day');
            }
            else {
                this.maxDate = moment(this.settings.maxDate).endOf('day');
            }
        }
        if (this.startValue) {
            const splitValue = this.startValue.split('||');
            const fromValue = this.dateAdapter.parse(splitValue[0], this.datePickerFormat);
            const toValue = this.dateAdapter.parse(splitValue[1], this.datePickerFormat);
            this.from = new UntypedFormControl(fromValue, validators);
            this.to = new UntypedFormControl(toValue, validators);
        }
        else {
            this.from = new UntypedFormControl('', validators);
            this.to = new UntypedFormControl('', validators);
        }
        this.form = new UntypedFormGroup({
            from: this.from,
            to: this.to
        });
        this.setFromMaxDate();
        this.enableChangeUpdate = this.settings?.allowUpdateOnChange ?? true;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    apply(model, isValid) {
        if (isValid && this.id && this.context && this.settings && this.settings.field) {
            this.isActive = true;
            const start = moment(model.from).startOf('day').format();
            const end = moment(model.to).endOf('day').format();
            this.context.queryFragments[this.id] = `${this.settings.field}:['${start}' TO '${end}']`;
            this.updateDisplayValue();
            this.context.update();
        }
    }
    submitValues() {
        this.apply(this.form.value, this.form.valid);
    }
    hasValidValue() {
        return this.form.valid;
    }
    getCurrentValue() {
        return {
            from: this.dateAdapter.format(this.form.value.from, this.datePickerFormat),
            to: this.dateAdapter.format(this.form.value.from, this.datePickerFormat)
        };
    }
    updateDisplayValue() {
        if (this.form.invalid || this.form.pristine) {
            this.displayValue$.next('');
        }
        else {
            this.displayValue$.next(`${this.dateAdapter.format(this.form.value.from, this.datePickerFormat)} - ${this.dateAdapter.format(this.form.value.to, this.datePickerFormat)}`);
        }
    }
    setValue(parsedDate) {
        const splitValue = parsedDate.split('||');
        const fromValue = this.dateAdapter.parse(splitValue[0], this.datePickerFormat);
        const toValue = this.dateAdapter.parse(splitValue[1], this.datePickerFormat);
        this.from.setValue(fromValue);
        this.from.markAsDirty();
        this.from.markAsTouched();
        this.to.setValue(toValue);
        this.to.markAsDirty();
        this.to.markAsTouched();
        this.submitValues();
    }
    clear() {
        this.isActive = false;
        this.form.reset({
            from: '',
            to: ''
        });
        if (this.id && this.context) {
            this.context.queryFragments[this.id] = '';
            if (this.enableChangeUpdate) {
                this.updateQuery();
            }
        }
        this.setFromMaxDate();
    }
    reset() {
        this.clear();
        this.updateQuery();
    }
    updateQuery() {
        if (this.id && this.context) {
            this.updateDisplayValue();
            this.context.update();
        }
    }
    onChangedHandler(event, formControl) {
        const inputValue = event.value;
        const formatDate = this.dateAdapter.parse(inputValue, this.datePickerFormat);
        if (formatDate && formatDate.isValid()) {
            formControl.setValue(formatDate);
        }
        else if (formatDate) {
            formControl.setErrors({
                invalidOnChange: true
            });
        }
        this.setFromMaxDate();
    }
    setLocale(locale) {
        this.dateAdapter.setLocale(locale);
        moment.locale(locale);
    }
    hasParseError(formControl) {
        return formControl.hasError('matDatepickerParse') && formControl.getError('matDatepickerParse').text;
    }
    forcePlaceholder(event) {
        event.srcElement.click();
    }
    setFromMaxDate() {
        this.fromMaxDate = (!this.to.value || this.maxDate && (moment(this.maxDate).isBefore(this.to.value))) ? this.maxDate : moment(this.to.value);
    }
}
SearchDateRangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchDateRangeComponent, deps: [{ token: i1$2.DateAdapter }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
SearchDateRangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchDateRangeComponent, selector: "adf-search-date-range", host: { classAttribute: "adf-search-date-range" }, providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }
    ], ngImport: i0, template: "<form [formGroup]=\"form\" novalidate (ngSubmit)=\"apply(form.value, form.valid)\">\n    <mat-form-field>\n        <mat-label>{{ 'SEARCH.FILTER.RANGE.SELECT-FROM-DATE' | translate }}</mat-label>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"from\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.FROM-DATE' | translate }}\"\n                [attr.aria-label]=\"'SEARCH.FILTER.RANGE.FROM-DATE' | translate\"\n                [matDatepicker]=\"fromDatepicker\"\n                [max]=\"fromMaxDate\"\n                (dateChange)=\"onChangedHandler($event, from)\"\n                data-automation-id=\"date-range-from-input\">\n        <mat-datepicker-toggle matSuffix [for]=\"fromDatepicker\" data-automation-id=\"date-range-from-date-toggle\"></mat-datepicker-toggle>\n        <mat-datepicker #fromDatepicker color=\"accent\"></mat-datepicker>\n        <mat-error *ngIf=\"from.invalid\" data-automation-id=\"date-range-from-error\">\n            {{ getFromValidationMessage() | translate: { requiredFormat: datePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n        <mat-label>{{ 'SEARCH.FILTER.RANGE.SELECT-TO-DATE' | translate }}</mat-label>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"to\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.TO-DATE' | translate }}\"\n                [attr.aria-label]=\"'SEARCH.FILTER.RANGE.TO-DATE' | translate\"\n                [matDatepicker]=\"toDatepicker\"\n                [min]=\"from.value\"\n                [max]=\"maxDate\"\n                (dateChange)=\"onChangedHandler($event, to)\"\n                data-automation-id=\"date-range-to-input\">\n        <mat-datepicker-toggle matSuffix [for]=\"toDatepicker\" data-automation-id=\"date-range-to-date-toggle\"></mat-datepicker-toggle>\n        <mat-datepicker #toDatepicker color=\"accent\"></mat-datepicker>\n        <mat-error *ngIf=\"to.invalid\" data-automation-id=\"date-range-to-error\">\n            {{ getToValidationMessage() | translate: { requiredFormat: datePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <div class=\"adf-facet-buttons adf-facet-buttons--topSpace\" *ngIf=\"!settings?.hideDefaultAction\">\n        <button mat-button color=\"primary\" type=\"button\" (click)=\"clear()\" data-automation-id=\"date-range-clear-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n        </button>\n        <button mat-button color=\"primary\" type=\"submit\" [disabled]=\"!form.valid\" data-automation-id=\"date-range-apply-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n        </button>\n    </div>\n</form>\n", styles: [".adf-search-date-range>form{display:inline-flex;flex-direction:column;width:100%}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i8.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i8.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i8.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchDateRangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-date-range', providers: [
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }
                    ], encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-date-range' }, template: "<form [formGroup]=\"form\" novalidate (ngSubmit)=\"apply(form.value, form.valid)\">\n    <mat-form-field>\n        <mat-label>{{ 'SEARCH.FILTER.RANGE.SELECT-FROM-DATE' | translate }}</mat-label>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"from\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.FROM-DATE' | translate }}\"\n                [attr.aria-label]=\"'SEARCH.FILTER.RANGE.FROM-DATE' | translate\"\n                [matDatepicker]=\"fromDatepicker\"\n                [max]=\"fromMaxDate\"\n                (dateChange)=\"onChangedHandler($event, from)\"\n                data-automation-id=\"date-range-from-input\">\n        <mat-datepicker-toggle matSuffix [for]=\"fromDatepicker\" data-automation-id=\"date-range-from-date-toggle\"></mat-datepicker-toggle>\n        <mat-datepicker #fromDatepicker color=\"accent\"></mat-datepicker>\n        <mat-error *ngIf=\"from.invalid\" data-automation-id=\"date-range-from-error\">\n            {{ getFromValidationMessage() | translate: { requiredFormat: datePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n        <mat-label>{{ 'SEARCH.FILTER.RANGE.SELECT-TO-DATE' | translate }}</mat-label>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"to\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.TO-DATE' | translate }}\"\n                [attr.aria-label]=\"'SEARCH.FILTER.RANGE.TO-DATE' | translate\"\n                [matDatepicker]=\"toDatepicker\"\n                [min]=\"from.value\"\n                [max]=\"maxDate\"\n                (dateChange)=\"onChangedHandler($event, to)\"\n                data-automation-id=\"date-range-to-input\">\n        <mat-datepicker-toggle matSuffix [for]=\"toDatepicker\" data-automation-id=\"date-range-to-date-toggle\"></mat-datepicker-toggle>\n        <mat-datepicker #toDatepicker color=\"accent\"></mat-datepicker>\n        <mat-error *ngIf=\"to.invalid\" data-automation-id=\"date-range-to-error\">\n            {{ getToValidationMessage() | translate: { requiredFormat: datePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <div class=\"adf-facet-buttons adf-facet-buttons--topSpace\" *ngIf=\"!settings?.hideDefaultAction\">\n        <button mat-button color=\"primary\" type=\"button\" (click)=\"clear()\" data-automation-id=\"date-range-clear-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n        </button>\n        <button mat-button color=\"primary\" type=\"submit\" [disabled]=\"!form.valid\" data-automation-id=\"date-range-apply-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n        </button>\n    </div>\n</form>\n", styles: [".adf-search-date-range>form{display:inline-flex;flex-direction:column;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.DateAdapter }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';
class SearchDatetimeRangeComponent {
    constructor(dateAdapter, userPreferencesService) {
        this.dateAdapter = dateAdapter;
        this.userPreferencesService = userPreferencesService;
        this.matcher = new LiveErrorStateMatcher();
        this.isActive = false;
        this.displayValue$ = new Subject();
        this.onDestroy$ = new Subject();
    }
    getFromValidationMessage() {
        return this.from.hasError('invalidOnChange') || this.hasParseError(this.from) ? 'SEARCH.FILTER.VALIDATION.INVALID-DATETIME' :
            this.from.hasError('matDatepickerMax') ? 'SEARCH.FILTER.VALIDATION.BEYOND-MAX-DATETIME' :
                this.from.hasError('required') ? 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' :
                    '';
    }
    getToValidationMessage() {
        return this.to.hasError('invalidOnChange') || this.hasParseError(this.to) ? 'SEARCH.FILTER.VALIDATION.INVALID-DATETIME' :
            this.to.hasError('matDatepickerMin') ? 'SEARCH.FILTER.VALIDATION.NO-DAYS' :
                this.to.hasError('matDatepickerMax') ? 'SEARCH.FILTER.VALIDATION.BEYOND-MAX-DATETIME' :
                    this.to.hasError('required') ? 'SEARCH.FILTER.VALIDATION.REQUIRED-VALUE' :
                        '';
    }
    ngOnInit() {
        this.datetimePickerFormat = this.settings?.datetimeFormat ? this.settings.datetimeFormat : DEFAULT_DATETIME_FORMAT;
        this.userPreferencesService
            .select(UserPreferenceValues.Locale)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(locale => this.setLocale(locale));
        const validators = Validators.compose([
            Validators.required
        ]);
        if (this.settings && this.settings.maxDatetime) {
            this.maxDatetime = moment(this.settings.maxDatetime);
        }
        if (this.startValue) {
            const splitValue = this.startValue.split('||');
            const fromValue = this.dateAdapter.parse(splitValue[0], this.datetimePickerFormat);
            const toValue = this.dateAdapter.parse(splitValue[1], this.datetimePickerFormat);
            this.from = new UntypedFormControl(fromValue, validators);
            this.to = new UntypedFormControl(toValue, validators);
        }
        else {
            this.from = new UntypedFormControl('', validators);
            this.to = new UntypedFormControl('', validators);
        }
        this.form = new UntypedFormGroup({
            from: this.from,
            to: this.to
        });
        this.setFromMaxDatetime();
        this.enableChangeUpdate = this.settings?.allowUpdateOnChange ?? true;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    apply(model, isValid) {
        if (isValid && this.id && this.context && this.settings && this.settings.field) {
            this.isActive = true;
            const start = moment.utc(model.from).startOf('minute').format();
            const end = moment.utc(model.to).endOf('minute').format();
            this.context.queryFragments[this.id] = `${this.settings.field}:['${start}' TO '${end}']`;
            this.updateDisplayValue();
            this.context.update();
        }
    }
    submitValues() {
        this.apply(this.form.value, this.form.valid);
    }
    hasValidValue() {
        return this.form.valid;
    }
    getCurrentValue() {
        return {
            from: this.dateAdapter.format(this.form.value.from, this.datetimePickerFormat),
            to: this.dateAdapter.format(this.form.value.to, this.datetimePickerFormat)
        };
    }
    updateDisplayValue() {
        if (this.form.invalid || this.form.pristine) {
            this.displayValue$.next('');
        }
        else {
            this.displayValue$.next(`${this.dateAdapter.format(this.form.value.from, this.datetimePickerFormat)} - ${this.dateAdapter.format(this.form.value.to, this.datetimePickerFormat)}`);
        }
    }
    setValue(parsedDate) {
        const splitValue = parsedDate.split('||');
        const fromValue = this.dateAdapter.parse(splitValue[0], this.datetimePickerFormat);
        const toValue = this.dateAdapter.parse(splitValue[1], this.datetimePickerFormat);
        this.from.setValue(fromValue);
        this.from.markAsDirty();
        this.from.markAsTouched();
        this.to.setValue(toValue);
        this.to.markAsDirty();
        this.to.markAsTouched();
        this.submitValues();
    }
    clear() {
        this.isActive = false;
        this.form.reset({
            from: '',
            to: ''
        });
        if (this.id && this.context) {
            this.context.queryFragments[this.id] = '';
        }
        if (this.id && this.context && this.enableChangeUpdate) {
            this.updateQuery();
        }
        this.setFromMaxDatetime();
    }
    reset() {
        this.clear();
        this.updateQuery();
    }
    updateQuery() {
        if (this.id && this.context) {
            this.updateDisplayValue();
            this.context.update();
        }
    }
    onChangedHandler(event, formControl) {
        const inputValue = event.value;
        const formatDate = this.dateAdapter.parse(inputValue, this.datetimePickerFormat);
        if (formatDate && formatDate.isValid()) {
            formControl.setValue(formatDate);
        }
        else if (formatDate) {
            formControl.setErrors({
                invalidOnChange: true
            });
        }
        this.setFromMaxDatetime();
    }
    setLocale(locale) {
        this.dateAdapter.setLocale(locale);
        moment.locale(locale);
    }
    hasParseError(formControl) {
        return formControl.hasError('matDatepickerParse') && formControl.getError('matDatepickerParse').text;
    }
    forcePlaceholder(event) {
        event.srcElement.click();
    }
    setFromMaxDatetime() {
        this.fromMaxDatetime = (!this.to.value || this.maxDatetime && (moment(this.maxDatetime).isBefore(this.to.value))) ? this.maxDatetime : moment(this.to.value);
    }
}
SearchDatetimeRangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchDatetimeRangeComponent, deps: [{ token: i1$3.DatetimeAdapter }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
SearchDatetimeRangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchDatetimeRangeComponent, selector: "adf-search-datetime-range", host: { classAttribute: "adf-search-date-range" }, providers: [
        { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS }
    ], ngImport: i0, template: "<form [formGroup]=\"form\" novalidate (ngSubmit)=\"apply(form.value, form.valid)\">\n    <mat-form-field>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"from\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.FROM-DATE' | translate }}\"\n                [matDatetimepicker]=\"fromDatetimePicker\"\n                [max]=\"fromMaxDatetime\"\n                (dateChange)=\"onChangedHandler($event, from)\"\n                data-automation-id=\"datetime-range-from-input\">\n        <mat-datetimepicker-toggle matSuffix [for]=\"fromDatetimePicker\" data-automation-id=\"datetime-range-from-date-toggle\"></mat-datetimepicker-toggle>\n        <mat-datetimepicker #fromDatetimePicker color=\"accent\" type=\"datetime\"></mat-datetimepicker>\n        <mat-error *ngIf=\"from.invalid\" data-automation-id=\"datetime-range-from-error\">\n            {{ getFromValidationMessage() | translate: { requiredFormat: datetimePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"to\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.TO-DATE' | translate }}\"\n                [matDatetimepicker]=\"toDatetimePicker\"\n                [min]=\"from.value\"\n                [max]=\"maxDatetime\"\n                (dateChange)=\"onChangedHandler($event, to)\"\n                data-automation-id=\"datetime-range-to-input\">\n        <mat-datetimepicker-toggle matSuffix [for]=\"toDatetimePicker\" data-automation-id=\"datetime-range-to-date-toggle\"></mat-datetimepicker-toggle>\n        <mat-datetimepicker #toDatetimePicker color=\"accent\" type=\"datetime\"></mat-datetimepicker>\n        <mat-error *ngIf=\"to.invalid\" data-automation-id=\"datetime-range-to-error\">\n            {{ getToValidationMessage() | translate: { requiredFormat: datetimePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <div class=\"adf-facet-buttons adf-facet-buttons--topSpace\" *ngIf=\"!settings?.hideDefaultAction\">\n        <button mat-button color=\"primary\" type=\"button\" (click)=\"clear()\" data-automation-id=\"datetime-range-clear-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n        </button>\n        <button mat-button color=\"primary\" type=\"submit\" [disabled]=\"!form.valid\" data-automation-id=\"datetime-range-apply-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n        </button>\n    </div>\n</form>\n", styles: [".adf-search-date-range>form{display:inline-flex;flex-direction:column;width:100%}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i1$3.MatDatetimepickerComponent, selector: "mat-datetimepicker", inputs: ["multiYearSelector", "twelvehour", "startView", "mode", "timeInterval", "ariaNextMonthLabel", "ariaPrevMonthLabel", "ariaNextYearLabel", "ariaPrevYearLabel", "preventSameDateTimeSelection", "panelClass", "startAt", "openOnFocus", "type", "touchUi", "disabled"], outputs: ["selectedChanged", "opened", "closed", "viewChanged"], exportAs: ["matDatetimepicker"] }, { kind: "component", type: i1$3.MatDatetimepickerToggleComponent, selector: "mat-datetimepicker-toggle", inputs: ["for", "disabled"], exportAs: ["matDatetimepickerToggle"] }, { kind: "directive", type: i1$3.MatDatetimepickerInputDirective, selector: "input[matDatetimepicker]", inputs: ["matDatetimepicker", "matDatepickerFilter", "value", "min", "max", "disabled"], outputs: ["dateChange", "dateInput"], exportAs: ["matDatepickerInput"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchDatetimeRangeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-datetime-range', providers: [
                        { provide: MAT_DATETIME_FORMATS, useValue: MAT_MOMENT_DATETIME_FORMATS }
                    ], encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-date-range' }, template: "<form [formGroup]=\"form\" novalidate (ngSubmit)=\"apply(form.value, form.valid)\">\n    <mat-form-field>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"from\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.FROM-DATE' | translate }}\"\n                [matDatetimepicker]=\"fromDatetimePicker\"\n                [max]=\"fromMaxDatetime\"\n                (dateChange)=\"onChangedHandler($event, from)\"\n                data-automation-id=\"datetime-range-from-input\">\n        <mat-datetimepicker-toggle matSuffix [for]=\"fromDatetimePicker\" data-automation-id=\"datetime-range-from-date-toggle\"></mat-datetimepicker-toggle>\n        <mat-datetimepicker #fromDatetimePicker color=\"accent\" type=\"datetime\"></mat-datetimepicker>\n        <mat-error *ngIf=\"from.invalid\" data-automation-id=\"datetime-range-from-error\">\n            {{ getFromValidationMessage() | translate: { requiredFormat: datetimePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n        <input matInput\n                (input)=\"forcePlaceholder($event)\"\n                [formControl]=\"to\"\n                [errorStateMatcher]=\"matcher\"\n                placeholder=\"{{ 'SEARCH.FILTER.RANGE.TO-DATE' | translate }}\"\n                [matDatetimepicker]=\"toDatetimePicker\"\n                [min]=\"from.value\"\n                [max]=\"maxDatetime\"\n                (dateChange)=\"onChangedHandler($event, to)\"\n                data-automation-id=\"datetime-range-to-input\">\n        <mat-datetimepicker-toggle matSuffix [for]=\"toDatetimePicker\" data-automation-id=\"datetime-range-to-date-toggle\"></mat-datetimepicker-toggle>\n        <mat-datetimepicker #toDatetimePicker color=\"accent\" type=\"datetime\"></mat-datetimepicker>\n        <mat-error *ngIf=\"to.invalid\" data-automation-id=\"datetime-range-to-error\">\n            {{ getToValidationMessage() | translate: { requiredFormat: datetimePickerFormat } }}\n        </mat-error>\n    </mat-form-field>\n\n    <div class=\"adf-facet-buttons adf-facet-buttons--topSpace\" *ngIf=\"!settings?.hideDefaultAction\">\n        <button mat-button color=\"primary\" type=\"button\" (click)=\"clear()\" data-automation-id=\"datetime-range-clear-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n        </button>\n        <button mat-button color=\"primary\" type=\"submit\" [disabled]=\"!form.valid\" data-automation-id=\"datetime-range-apply-btn\">\n            {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n        </button>\n    </div>\n</form>\n", styles: [".adf-search-date-range>form{display:inline-flex;flex-direction:column;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.DatetimeAdapter }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchChipInputComponent {
    constructor() {
        this.addOnBlur = true;
        this.phrasesChanged = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.phrases = [];
        this.separatorKeysCodes = [ENTER];
    }
    ngOnInit() {
        this.onReset?.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.resetChips());
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    addPhrase(event) {
        const phrase = (event.value || '').trim();
        if (phrase) {
            this.phrases.push(phrase);
            this.phrasesChanged.emit(this.phrases);
        }
        event.chipInput.clear();
    }
    removePhrase(index) {
        this.phrases.splice(index, 1);
        this.phrasesChanged.emit(this.phrases);
    }
    resetChips() {
        this.phrases = [];
        this.phrasesChanged.emit(this.phrases);
    }
}
SearchChipInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchChipInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchChipInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchChipInputComponent, selector: "adf-search-chip-input", inputs: { label: "label", addOnBlur: "addOnBlur", onReset: "onReset" }, outputs: { phrasesChanged: "phrasesChanged" }, host: { classAttribute: "adf-search-chip-input" }, ngImport: i0, template: "<mat-label>{{label | translate}}</mat-label>\n<mat-chip-list #chipList [attr.aria-label]=\"label | translate\">\n    <mat-chip *ngFor=\"let phrase of phrases; let i = index\" (removed)=\"removePhrase(i)\">\n      <span>{{phrase}}</span>\n      <button matChipRemove [attr.aria-label]=\"('SEARCH.FILTER.BUTTONS.REMOVE' | translate) + ' ' + phrase\">\n        <mat-icon>cancel</mat-icon>\n      </button>\n    </mat-chip>\n    <input placeholder=\"{{ 'SEARCH.LOGICAL_SEARCH.SEARCH_CHIP_INPUT.ADD_PHRASE' | translate }}\"\n           [attr.aria-label]=\"'SEARCH.LOGICAL_SEARCH.SEARCH_CHIP_INPUT.ADD_PHRASE' | translate\"\n           [matChipInputFor]=\"chipList\"\n           [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n           [matChipInputAddOnBlur]=\"addOnBlur\"\n           (matChipInputTokenEnd)=\"addPhrase($event)\" />\n</mat-chip-list>\n", styles: [".adf-search-chip-input{padding-bottom:15px}.adf-search-chip-input .mat-chip-list-wrapper{border:1px solid var(--adf-theme-mat-grey-color-a400);border-radius:5px;margin-top:5px}.adf-search-chip-input .mat-chip-list-wrapper .mat-chip{word-break:break-all;height:unset}.adf-search-chip-input .mat-chip-list-wrapper input{height:25px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i3$2.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i3$2.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i3$2.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchChipInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-chip-input', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-chip-input' }, template: "<mat-label>{{label | translate}}</mat-label>\n<mat-chip-list #chipList [attr.aria-label]=\"label | translate\">\n    <mat-chip *ngFor=\"let phrase of phrases; let i = index\" (removed)=\"removePhrase(i)\">\n      <span>{{phrase}}</span>\n      <button matChipRemove [attr.aria-label]=\"('SEARCH.FILTER.BUTTONS.REMOVE' | translate) + ' ' + phrase\">\n        <mat-icon>cancel</mat-icon>\n      </button>\n    </mat-chip>\n    <input placeholder=\"{{ 'SEARCH.LOGICAL_SEARCH.SEARCH_CHIP_INPUT.ADD_PHRASE' | translate }}\"\n           [attr.aria-label]=\"'SEARCH.LOGICAL_SEARCH.SEARCH_CHIP_INPUT.ADD_PHRASE' | translate\"\n           [matChipInputFor]=\"chipList\"\n           [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n           [matChipInputAddOnBlur]=\"addOnBlur\"\n           (matChipInputTokenEnd)=\"addPhrase($event)\" />\n</mat-chip-list>\n", styles: [".adf-search-chip-input{padding-bottom:15px}.adf-search-chip-input .mat-chip-list-wrapper{border:1px solid var(--adf-theme-mat-grey-color-a400);border-radius:5px;margin-top:5px}.adf-search-chip-input .mat-chip-list-wrapper .mat-chip{word-break:break-all;height:unset}.adf-search-chip-input .mat-chip-list-wrapper input{height:25px}\n"] }]
        }], propDecorators: { label: [{
                type: Input
            }], addOnBlur: [{
                type: Input
            }], onReset: [{
                type: Input
            }], phrasesChanged: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LogicalSearchFields;
(function (LogicalSearchFields) {
    LogicalSearchFields["MATCH_ALL"] = "matchAll";
    LogicalSearchFields["MATCH_ANY"] = "matchAny";
    LogicalSearchFields["EXCLUDE"] = "exclude";
})(LogicalSearchFields || (LogicalSearchFields = {}));
class SearchLogicalFilterComponent {
    constructor(translationService) {
        this.translationService = translationService;
        this.reset$ = new Subject();
        this.displayValue$ = new Subject();
        this.resetObservable = this.reset$.asObservable();
        this.LogicalSearchFields = LogicalSearchFields;
    }
    ngOnInit() {
        this.searchCondition = { matchAll: [], matchAny: [], exclude: [] };
        this.updateDisplayValue();
    }
    onPhraseChange(phrases, field) {
        this.searchCondition[field] = phrases;
        this.updateDisplayValue();
    }
    submitValues() {
        if (this.hasValidValue() && this.id && this.context && this.settings && this.settings.field) {
            this.updateDisplayValue();
            const fields = this.settings.field.split(',').map((field) => field += ':');
            let query = '';
            Object.keys(this.searchCondition).forEach((key) => {
                if (this.searchCondition[key].length > 0) {
                    let connector = '';
                    let subQuery = '';
                    switch (key) {
                        case LogicalSearchFields.MATCH_ALL:
                            connector = 'AND';
                            break;
                        case LogicalSearchFields.MATCH_ANY:
                            connector = 'OR';
                            break;
                        case LogicalSearchFields.EXCLUDE:
                            connector = 'AND NOT';
                            break;
                        default:
                            break;
                    }
                    fields.forEach((field) => {
                        subQuery += subQuery === '' ? '' : key === LogicalSearchFields.EXCLUDE ? ' AND ' : ' OR ';
                        let fieldQuery = '(';
                        this.searchCondition[key].forEach((phrase) => {
                            const refinedPhrase = '\"' + phrase + '\"';
                            fieldQuery += fieldQuery === '(' ?
                                `${key === LogicalSearchFields.EXCLUDE ? 'NOT ' : ''}${field}${refinedPhrase}` :
                                ` ${connector} ${field}${refinedPhrase}`;
                        });
                        subQuery += `${fieldQuery})`;
                    });
                    query += query === '' ? `(${subQuery})` : ` AND (${subQuery})`;
                    subQuery = '';
                }
            });
            this.context.queryFragments[this.id] = query;
            this.context.update();
        }
    }
    hasValidValue() {
        return Object.keys(this.searchCondition).some((key) => this.searchCondition[key].length !== 0);
    }
    getCurrentValue() {
        return this.searchCondition;
    }
    setValue(value) {
        this.searchCondition = value;
        this.updateDisplayValue();
    }
    reset() {
        if (this.id && this.context) {
            this.reset$.next();
            this.context.queryFragments[this.id] = '';
            this.updateDisplayValue();
            this.context.update();
        }
    }
    updateDisplayValue() {
        if (this.hasValidValue()) {
            const displayValue = Object.keys(this.searchCondition).reduce((acc, key) => {
                const fieldIndex = Object.values(LogicalSearchFields).indexOf(key);
                const fieldKeyTranslated = this.translationService.instant(`SEARCH.LOGICAL_SEARCH.${Object.keys(LogicalSearchFields)[fieldIndex]}`);
                const stackedPhrases = this.searchCondition[key].reduce((phraseAcc, phrase) => `${phraseAcc === '' ? phraseAcc : phraseAcc + ','} ${phrase}`, '');
                return stackedPhrases !== '' ? `${acc} ${fieldKeyTranslated}: ${stackedPhrases}` : acc;
            }, '');
            this.displayValue$.next(displayValue);
        }
        else {
            this.displayValue$.next('');
        }
    }
}
SearchLogicalFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchLogicalFilterComponent, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
SearchLogicalFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchLogicalFilterComponent, selector: "adf-search-logical-filter", ngImport: i0, template: "<div class=\"adf-search-logical-filter-container\">\n    <adf-search-chip-input\n        [label]=\"'SEARCH.LOGICAL_SEARCH.MATCH_ALL_LABEL' | translate\"\n        [onReset]=\"resetObservable\"\n        (phrasesChanged)=\"onPhraseChange($event, LogicalSearchFields.MATCH_ALL)\">\n    </adf-search-chip-input>\n    <adf-search-chip-input\n        [label]=\"'SEARCH.LOGICAL_SEARCH.MATCH_ANY_LABEL' | translate\"\n        [onReset]=\"resetObservable\"\n        (phrasesChanged)=\"onPhraseChange($event, LogicalSearchFields.MATCH_ANY)\">\n    </adf-search-chip-input>\n    <adf-search-chip-input\n        [label]=\"'SEARCH.LOGICAL_SEARCH.EXCLUDE_LABEL' | translate\"\n        [onReset]=\"resetObservable\"\n        (phrasesChanged)=\"onPhraseChange($event, LogicalSearchFields.EXCLUDE)\">\n    </adf-search-chip-input>\n</div>\n", styles: [".adf-search-logical-filter-container{display:flex;flex-direction:column}\n"], dependencies: [{ kind: "component", type: SearchChipInputComponent, selector: "adf-search-chip-input", inputs: ["label", "addOnBlur", "onReset"], outputs: ["phrasesChanged"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchLogicalFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-logical-filter', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-search-logical-filter-container\">\n    <adf-search-chip-input\n        [label]=\"'SEARCH.LOGICAL_SEARCH.MATCH_ALL_LABEL' | translate\"\n        [onReset]=\"resetObservable\"\n        (phrasesChanged)=\"onPhraseChange($event, LogicalSearchFields.MATCH_ALL)\">\n    </adf-search-chip-input>\n    <adf-search-chip-input\n        [label]=\"'SEARCH.LOGICAL_SEARCH.MATCH_ANY_LABEL' | translate\"\n        [onReset]=\"resetObservable\"\n        (phrasesChanged)=\"onPhraseChange($event, LogicalSearchFields.MATCH_ANY)\">\n    </adf-search-chip-input>\n    <adf-search-chip-input\n        [label]=\"'SEARCH.LOGICAL_SEARCH.EXCLUDE_LABEL' | translate\"\n        [onReset]=\"resetObservable\"\n        (phrasesChanged)=\"onPhraseChange($event, LogicalSearchFields.EXCLUDE)\">\n    </adf-search-chip-input>\n</div>\n", styles: [".adf-search-logical-filter-container{display:flex;flex-direction:column}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TagService {
    constructor(apiService, logService, userPreferencesService) {
        this.apiService = apiService;
        this.logService = logService;
        this.userPreferencesService = userPreferencesService;
        /** Emitted when tag information is updated. */
        this.refresh = new EventEmitter();
    }
    get tagsApi() {
        this._tagsApi = this._tagsApi ?? new TagsApi(this.apiService.getInstance());
        return this._tagsApi;
    }
    /**
     * Gets a list of tags added to a node.
     *
     * @param nodeId ID of the target node
     * @returns TagPaging object (defined in JS-API) containing the tags
     */
    getTagsByNodeId(nodeId) {
        return from(this.tagsApi.listTagsForNode(nodeId)).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets a list of all the tags already defined in the repository.
     *
     * @param opts Options supported by JS-API
     * @param includedCounts True if count field should be included in response object for each tag, false otherwise.
     * @returns TagPaging object (defined in JS-API) containing the tags
     */
    getAllTheTags(opts, includedCounts) {
        return from(this.tagsApi.listTags({
            include: includedCounts ? ['count'] : undefined,
            ...opts
        })).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Adds a tag to a node.
     *
     * @param nodeId ID of the target node
     * @param tagName Name of the tag to add
     * @returns TagEntry object (defined in JS-API) with details of the new tag
     */
    addTag(nodeId, tagName) {
        const tagBody = new TagBody();
        tagBody.tag = tagName;
        const observableAdd = from(this.tagsApi.createTagForNode(nodeId, [tagBody]));
        observableAdd.subscribe((tagEntry) => {
            this.refresh.emit(tagEntry);
        }, (err) => {
            this.handleError(err);
        });
        return observableAdd;
    }
    /**
     * Removes a tag from a node.
     *
     * @param nodeId ID of the target node
     * @param tag Name of the tag to remove
     * @returns Null object when the operation completes
     */
    removeTag(nodeId, tag) {
        const observableRemove = from(this.tagsApi.deleteTagFromNode(nodeId, tag));
        observableRemove.subscribe((data) => {
            this.refresh.emit(data);
        }, (err) => {
            this.handleError(err);
        });
        return observableRemove;
    }
    /**
     * Creates tags.
     *
     * @param tags list of tags to create.
     * @returns Created tags.
     */
    createTags(tags) {
        const observableAdd$ = from(this.tagsApi.createTags(tags));
        observableAdd$.subscribe((tagsEntries) => this.refresh.emit(tagsEntries), (err) => this.handleError(err));
        return observableAdd$;
    }
    /**
     * Update a tag
     *
     * @param tagId The identifier of a tag.
     * @param tagBody The updated tag.
     * @returns Updated tag.
     */
    updateTag(tagId, tagBody) {
        const observableUpdate$ = from(this.tagsApi.updateTag(tagId, tagBody));
        observableUpdate$.subscribe((tagEntry) => this.refresh.emit(tagEntry), (err) => this.handleError(err));
        return observableUpdate$;
    }
    /**
     * Find tags which name contains searched name.
     *
     * @param name Value for name which should be used during searching tags.
     * @param sorting Object which configures sorting. OrderBy field specifies field used for sorting, direction specified ascending or descending direction.
     * Default sorting is ascending by tag field.
     * @param includedCounts True if count field should be included in response object for each tag, false otherwise.
     * @param skipCount Specify how many first results should be skipped. Default 0.
     * @param maxItems Specify max number of returned tags. Default is specified by UserPreferencesService.
     * @returns Found tags which name contains searched name.
     */
    searchTags(name, sorting = { orderBy: 'tag', direction: 'asc' }, includedCounts, skipCount = 0, maxItems) {
        maxItems = maxItems || this.userPreferencesService.paginationSize;
        return this.getAllTheTags({
            tag: `*${name}*`,
            skipCount,
            maxItems,
            sorting,
            matching: true
        }, includedCounts).pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Find tag which name matches exactly to passed name.
     *
     * @param name Value for name which should be used during finding exact tag.
     * @returns Found tag which name matches exactly to passed name.
     */
    findTagByName(name) {
        return this.getAllTheTags({ tag: name }).pipe(map((result) => result.list.entries[0]), catchError((error) => this.handleError(error)));
    }
    /**
     * Deletes a tag with tagId.
     * This will cause the tag to be removed from all nodes.
     * You must have admin rights to delete a tag.
     *
     * @param tagId of the tag to be deleted
     * @returns Null object when the operation completes
     */
    deleteTag(tagId) {
        return from(this.tagsApi.deleteTag(tagId)).pipe(tap((data) => this.refresh.emit(data)));
    }
    /**
     * Assign tags to node. If tag is new then tag is also created additionally, if tag already exists then it is just assigned.
     *
     * @param nodeId Id of node to which tags should be assigned.
     * @param tags List of tags to create and assign or just assign if they already exist.
     *
     * @return Just linked tags to node or single tag if linked only one tag.
     */
    assignTagsToNode(nodeId, tags) {
        return from(this.tagsApi.assignTagsToNode(nodeId, tags)).pipe(tap((data) => this.refresh.emit(data)));
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
TagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
TagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }, { type: i1.UserPreferencesService }]; }, propDecorators: { refresh: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IsIncludedPipe {
    transform(value, array) {
        return array.includes(value);
    }
}
IsIncludedPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IsIncludedPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
IsIncludedPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: IsIncludedPipe, name: "adfIsIncluded" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: IsIncludedPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfIsIncluded'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchChipAutocompleteInputComponent {
    constructor() {
        this.autocompleteOptions = [];
        this.allowOnlyPredefinedValues = true;
        this.optionsChanged = new EventEmitter();
        this.separatorKeysCodes = [ENTER];
        this.formCtrl = new FormControl('');
        this.selectedOptions = [];
        this.onDestroy$ = new Subject();
        this.filteredOptions$ = this.formCtrl.valueChanges.pipe(startWith(null), map((value) => (value ? this.filter(value) : [])));
    }
    ngOnInit() {
        this.onReset$?.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.reset());
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    add(event) {
        const value = (event.value || '').trim();
        if (value && this.isExists(value) && !this.isAdded(value)) {
            this.selectedOptions.push(value);
            this.optionsChanged.emit(this.selectedOptions);
            event.chipInput.clear();
            this.formCtrl.setValue(null);
        }
    }
    remove(value) {
        const index = this.selectedOptions.indexOf(value);
        if (index >= 0) {
            this.selectedOptions.splice(index, 1);
            this.optionsChanged.emit(this.selectedOptions);
        }
    }
    selected(event) {
        if (!this.isAdded(event.option.viewValue)) {
            this.selectedOptions.push(event.option.viewValue);
            this.optionInput.nativeElement.value = '';
            this.formCtrl.setValue(null);
            this.optionsChanged.emit(this.selectedOptions);
        }
    }
    filter(value) {
        const filterValue = value.toLowerCase();
        return this.autocompleteOptions.filter(option => option.toLowerCase().includes(filterValue)).slice(0, 15);
    }
    isAdded(value) {
        return this.selectedOptions.includes(value);
    }
    isExists(value) {
        return this.allowOnlyPredefinedValues
            ? this.autocompleteOptions.map(option => option.toLowerCase()).includes(value.toLowerCase())
            : true;
    }
    reset() {
        this.selectedOptions = [];
        this.optionsChanged.emit(this.selectedOptions);
        this.formCtrl.setValue(null);
        this.optionInput.nativeElement.value = '';
    }
}
SearchChipAutocompleteInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchChipAutocompleteInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchChipAutocompleteInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchChipAutocompleteInputComponent, selector: "adf-search-chip-autocomplete-input", inputs: { autocompleteOptions: "autocompleteOptions", onReset$: "onReset$", allowOnlyPredefinedValues: "allowOnlyPredefinedValues" }, outputs: { optionsChanged: "optionsChanged" }, viewQueries: [{ propertyName: "optionInput", first: true, predicate: ["optionInput"], descendants: true }], ngImport: i0, template: "<mat-form-field class=\"adf-chip-list\" appearance=\"outline\">\n    <mat-chip-list #chipList [attr.aria-label]=\"'SEARCH.FILTER.ARIA-LABEL.OPTIONS-SELECTION' | translate\">\n        <mat-chip\n            class=\"adf-option-chips\"\n            *ngFor=\"let option of selectedOptions\"\n            (removed)=\"remove(option)\">\n            <span>{{option}}</span>\n            <button matChipRemove class=\"adf-option-chips-delete-button\" [attr.aria-label]=\"('SEARCH.FILTER.BUTTONS.REMOVE' | translate) + ' ' + option\">\n                <mat-icon class=\"adf-option-chips-delete-icon\">close</mat-icon>\n            </button>\n        </mat-chip>\n        <input\n            placeholder=\"{{ 'SEARCH.FILTER.ACTIONS.ADD_OPTION' | translate }}\"\n            aria-controls=\"adf-search-chip-autocomplete\"\n            #optionInput\n            [formControl]=\"formCtrl\"\n            [matAutocomplete]=\"auto\"\n            [matChipInputFor]=\"chipList\"\n            [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n            [attr.aria-label]=\"'SEARCH.FILTER.ACTIONS.ADD_OPTION' | translate\"\n            (matChipInputTokenEnd)=\"add($event)\">\n    </mat-chip-list>\n    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\" id=\"adf-search-chip-autocomplete\">\n        <mat-option [disabled]=\"option | adfIsIncluded: selectedOptions\" *ngFor=\"let option of filteredOptions$ | async\"\n                    [ngClass]=\"(option | adfIsIncluded: selectedOptions) && 'adf-autocomplete-added-option'\">\n            {{option}}\n        </mat-option>\n    </mat-autocomplete>\n</mat-form-field>\n", styles: ["adf-search-chip-autocomplete-input .adf-chip-list{width:100%}adf-search-chip-autocomplete-input .mat-form-field-appearance-outline .mat-form-field-outline{top:0}adf-search-chip-autocomplete-input .mat-form-field-infix{border:none}adf-search-chip-autocomplete-input .mat-chip.adf-option-chips{border:1px solid var(--theme-text-color);border-radius:10px;background-color:var(--theme-primary-color-default-contrast);height:auto;word-break:break-word}adf-search-chip-autocomplete-input .mat-chip-remove.adf-option-chips-delete-button{font-size:13px;height:13px;width:13px}adf-search-chip-autocomplete-input .mat-chip-remove.adf-option-chips-delete-button .adf-option-chips-delete-icon.mat-icon{font-size:13px;height:13px;width:13px}adf-search-chip-autocomplete-input .mat-chip-list-wrapper{min-height:40px}adf-search-chip-autocomplete-input .mat-form-field-wrapper{padding:0}.mat-option.adf-autocomplete-added-option{background:var(--adf-theme-mat-grey-color-a200);color:var(--adf-theme-primary-300)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$2.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i3$2.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i3$2.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "component", type: i1$2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i7$1.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i7$1.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: IsIncludedPipe, name: "adfIsIncluded" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchChipAutocompleteInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-chip-autocomplete-input', encapsulation: ViewEncapsulation.None, template: "<mat-form-field class=\"adf-chip-list\" appearance=\"outline\">\n    <mat-chip-list #chipList [attr.aria-label]=\"'SEARCH.FILTER.ARIA-LABEL.OPTIONS-SELECTION' | translate\">\n        <mat-chip\n            class=\"adf-option-chips\"\n            *ngFor=\"let option of selectedOptions\"\n            (removed)=\"remove(option)\">\n            <span>{{option}}</span>\n            <button matChipRemove class=\"adf-option-chips-delete-button\" [attr.aria-label]=\"('SEARCH.FILTER.BUTTONS.REMOVE' | translate) + ' ' + option\">\n                <mat-icon class=\"adf-option-chips-delete-icon\">close</mat-icon>\n            </button>\n        </mat-chip>\n        <input\n            placeholder=\"{{ 'SEARCH.FILTER.ACTIONS.ADD_OPTION' | translate }}\"\n            aria-controls=\"adf-search-chip-autocomplete\"\n            #optionInput\n            [formControl]=\"formCtrl\"\n            [matAutocomplete]=\"auto\"\n            [matChipInputFor]=\"chipList\"\n            [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n            [attr.aria-label]=\"'SEARCH.FILTER.ACTIONS.ADD_OPTION' | translate\"\n            (matChipInputTokenEnd)=\"add($event)\">\n    </mat-chip-list>\n    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\" id=\"adf-search-chip-autocomplete\">\n        <mat-option [disabled]=\"option | adfIsIncluded: selectedOptions\" *ngFor=\"let option of filteredOptions$ | async\"\n                    [ngClass]=\"(option | adfIsIncluded: selectedOptions) && 'adf-autocomplete-added-option'\">\n            {{option}}\n        </mat-option>\n    </mat-autocomplete>\n</mat-form-field>\n", styles: ["adf-search-chip-autocomplete-input .adf-chip-list{width:100%}adf-search-chip-autocomplete-input .mat-form-field-appearance-outline .mat-form-field-outline{top:0}adf-search-chip-autocomplete-input .mat-form-field-infix{border:none}adf-search-chip-autocomplete-input .mat-chip.adf-option-chips{border:1px solid var(--theme-text-color);border-radius:10px;background-color:var(--theme-primary-color-default-contrast);height:auto;word-break:break-word}adf-search-chip-autocomplete-input .mat-chip-remove.adf-option-chips-delete-button{font-size:13px;height:13px;width:13px}adf-search-chip-autocomplete-input .mat-chip-remove.adf-option-chips-delete-button .adf-option-chips-delete-icon.mat-icon{font-size:13px;height:13px;width:13px}adf-search-chip-autocomplete-input .mat-chip-list-wrapper{min-height:40px}adf-search-chip-autocomplete-input .mat-form-field-wrapper{padding:0}.mat-option.adf-autocomplete-added-option{background:var(--adf-theme-mat-grey-color-a200);color:var(--adf-theme-primary-300)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { optionInput: [{
                type: ViewChild,
                args: ['optionInput']
            }], autocompleteOptions: [{
                type: Input
            }], onReset$: [{
                type: Input
            }], allowOnlyPredefinedValues: [{
                type: Input
            }], optionsChanged: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFilterAutocompleteChipsComponent {
    constructor(tagService) {
        this.tagService = tagService;
        this.startValue = null;
        this.displayValue$ = new Subject();
        this.resetSubject$ = new Subject();
        this.reset$ = this.resetSubject$.asObservable();
        this.autocompleteOptions = [];
        this.selectedOptions = [];
        this.options = new SearchFilterList();
    }
    ngOnInit() {
        if (this.settings) {
            this.setOptions();
            if (this.startValue) {
                this.setValue(this.startValue);
            }
            this.enableChangeUpdate = this.settings.allowUpdateOnChange ?? true;
        }
    }
    reset() {
        this.selectedOptions = [];
        this.resetSubject$.next();
        this.updateQuery();
    }
    submitValues() {
        this.updateQuery();
    }
    hasValidValue() {
        return !!this.selectedOptions;
    }
    getCurrentValue() {
        return this.selectedOptions;
    }
    onOptionsChange(selectedOptions) {
        this.selectedOptions = selectedOptions;
        if (this.enableChangeUpdate) {
            this.updateQuery();
            this.context.update();
        }
    }
    setValue(value) {
        this.selectedOptions = value;
        this.displayValue$.next(this.selectedOptions.join(', '));
        this.submitValues();
    }
    updateQuery() {
        this.displayValue$.next(this.selectedOptions.join(', '));
        if (this.context && this.settings && this.settings.field) {
            this.context.queryFragments[this.id] = this.selectedOptions.map(val => `${this.settings.field}: "${val}"`).join(' OR ');
            this.context.update();
        }
    }
    setOptions() {
        if (this.settings.field === 'TAG') {
            this.tagService.getAllTheTags().subscribe(res => {
                this.autocompleteOptions = res.list.entries.map(tag => tag.entry.tag);
            });
        }
        else {
            this.autocompleteOptions = this.settings.options;
        }
    }
}
SearchFilterAutocompleteChipsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterAutocompleteChipsComponent, deps: [{ token: TagService }], target: i0.ɵɵFactoryTarget.Component });
SearchFilterAutocompleteChipsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFilterAutocompleteChipsComponent, selector: "adf-search-filter-autocomplete-chips", ngImport: i0, template: "<adf-search-chip-autocomplete-input\n    [autocompleteOptions]=\"autocompleteOptions\"\n    [onReset$]=\"reset$\"\n    [allowOnlyPredefinedValues]=\"settings.allowOnlyPredefinedValues\"\n    (optionsChanged)=\"onOptionsChange($event)\">\n</adf-search-chip-autocomplete-input>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!settings?.hideDefaultAction\">\n    <button mat-button color=\"primary\" data-automation-id=\"adf-search-chip-autocomplete-btn-clear\" (click)=\"reset()\">\n        {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n    </button>\n    <button mat-button color=\"primary\" data-automation-id=\"adf-search-chip-autocomplete-btn-apply\" (click)=\"submitValues()\">\n        {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n    </button>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: SearchChipAutocompleteInputComponent, selector: "adf-search-chip-autocomplete-input", inputs: ["autocompleteOptions", "onReset$", "allowOnlyPredefinedValues"], outputs: ["optionsChanged"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterAutocompleteChipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-filter-autocomplete-chips', encapsulation: ViewEncapsulation.None, template: "<adf-search-chip-autocomplete-input\n    [autocompleteOptions]=\"autocompleteOptions\"\n    [onReset$]=\"reset$\"\n    [allowOnlyPredefinedValues]=\"settings.allowOnlyPredefinedValues\"\n    (optionsChanged)=\"onOptionsChange($event)\">\n</adf-search-chip-autocomplete-input>\n\n<div class=\"adf-facet-buttons\" *ngIf=\"!settings?.hideDefaultAction\">\n    <button mat-button color=\"primary\" data-automation-id=\"adf-search-chip-autocomplete-btn-clear\" (click)=\"reset()\">\n        {{ 'SEARCH.FILTER.ACTIONS.CLEAR' | translate }}\n    </button>\n    <button mat-button color=\"primary\" data-automation-id=\"adf-search-chip-autocomplete-btn-apply\" (click)=\"submitValues()\">\n        {{ 'SEARCH.FILTER.ACTIONS.APPLY' | translate }}\n    </button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: TagService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFilterService {
    constructor() {
        /**
         * Contains string-to-type mappings for registered widgets.
         */
        this.widgets = {
            text: SearchTextComponent,
            radio: SearchRadioComponent,
            slider: SearchSliderComponent,
            'number-range': SearchNumberRangeComponent,
            'check-list': SearchCheckListComponent,
            'date-range': SearchDateRangeComponent,
            'datetime-range': SearchDatetimeRangeComponent,
            'logical-filter': SearchLogicalFilterComponent,
            'autocomplete-chips': SearchFilterAutocompleteChipsComponent
        };
    }
}
SearchFilterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SearchFilterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchWidgetContainerComponent {
    constructor(searchFilterService, queryBuilder, componentFactoryResolver) {
        this.searchFilterService = searchFilterService;
        this.queryBuilder = queryBuilder;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngOnInit() {
        const componentType = this.searchFilterService.widgets[this.selector];
        if (componentType) {
            const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
            if (factory) {
                this.content.clear();
                this.componentRef = this.content.createComponent(factory, 0);
                this.setupWidget(this.componentRef);
            }
        }
    }
    ngOnChanges(changes) {
        if (changes['value']?.currentValue && this.componentRef?.instance) {
            this.componentRef.instance.isActive = true;
            this.componentRef.instance.setValue(changes['value'].currentValue);
        }
    }
    setupWidget(ref) {
        if (ref && ref.instance) {
            ref.instance.id = this.id;
            ref.instance.settings = { ...this.settings };
            ref.instance.context = this.queryBuilder;
            if (this.value) {
                ref.instance.isActive = true;
                ref.instance.startValue = this.value;
            }
        }
    }
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }
    applyInnerWidget() {
        this.componentRef.instance.submitValues();
    }
    setValue(currentValue) {
        this.componentRef.instance.isActive = true;
        this.componentRef.instance.setValue(currentValue);
    }
    hasValueSelected() {
        return this.componentRef.instance.hasValidValue();
    }
    getCurrentValue() {
        return this.componentRef.instance.getCurrentValue();
    }
    getDisplayValue() {
        if (!this.componentRef?.instance) {
            return null;
        }
        return this.componentRef.instance.displayValue$;
    }
    resetInnerWidget() {
        if (this.componentRef && this.componentRef.instance) {
            this.componentRef.instance.reset();
        }
    }
}
SearchWidgetContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchWidgetContainerComponent, deps: [{ token: SearchFilterService }, { token: SEARCH_QUERY_SERVICE_TOKEN }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Component });
SearchWidgetContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchWidgetContainerComponent, selector: "adf-search-widget-container", inputs: { id: "id", selector: "selector", settings: "settings", config: "config", value: "value" }, viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true, read: ViewContainerRef, static: true }], usesOnChanges: true, ngImport: i0, template: '<div #content></div>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchWidgetContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-search-widget-container',
                    template: '<div #content></div>'
                }]
        }], ctorParameters: function () { return [{ type: SearchFilterService }, { type: BaseQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { content: [{
                type: ViewChild,
                args: ['content', { read: ViewContainerRef, static: true }]
            }], id: [{
                type: Input
            }], selector: [{
                type: Input
            }], settings: [{
                type: Input
            }], config: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFilterContainerComponent {
    constructor(searchFilterQueryBuilder, translationService, focusTrapFactory) {
        this.searchFilterQueryBuilder = searchFilterQueryBuilder;
        this.translationService = translationService;
        this.focusTrapFactory = focusTrapFactory;
        /** Emitted when a filter value is selected */
        this.filterChange = new EventEmitter();
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.category = this.searchFilterQueryBuilder.getCategoryForColumn(this.col.key);
        this.initialValue = this.value && this.value[this.col.key] ? this.value[this.col.key] : undefined;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    onKeyPressed(event, menuTrigger) {
        if (event.key === 'Enter' && this.widgetContainer.selector !== 'check-list') {
            this.onApply();
            menuTrigger.closeMenu();
        }
    }
    onApply() {
        if (this.widgetContainer.hasValueSelected()) {
            this.searchFilterQueryBuilder.setActiveFilter(this.category.columnKey, this.widgetContainer.getCurrentValue());
            this.filterChange.emit();
            this.widgetContainer.applyInnerWidget();
        }
        else {
            this.resetSearchFilter();
        }
    }
    onClearButtonClick(event) {
        event.stopPropagation();
        this.resetSearchFilter();
    }
    resetSearchFilter() {
        this.widgetContainer.resetInnerWidget();
        this.searchFilterQueryBuilder.removeActiveFilter(this.category.columnKey);
        this.filterChange.emit();
    }
    getTooltipTranslation(columnTitle) {
        if (!columnTitle) {
            columnTitle = 'SEARCH.SEARCH_HEADER.TYPE';
        }
        return this.translationService.instant('SEARCH.SEARCH_HEADER.FILTER_BY', { category: this.translationService.instant(columnTitle) });
    }
    isActive() {
        return this.searchFilterQueryBuilder.getActiveFilters().findIndex((f) => f.key === this.category.columnKey) > -1;
    }
    onMenuOpen() {
        if (this.filterContainer && !this.focusTrap) {
            this.focusTrap = this.focusTrapFactory.create(this.filterContainer.nativeElement);
            this.focusTrap.focusInitialElement();
        }
    }
    onClosed() {
        this.focusTrap.destroy();
        this.focusTrap = null;
    }
}
SearchFilterContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterContainerComponent, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }, { token: i1.TranslationService }, { token: i1$4.ConfigurableFocusTrapFactory }], target: i0.ɵɵFactoryTarget.Component });
SearchFilterContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFilterContainerComponent, selector: "adf-search-filter-container", inputs: { col: "col", value: "value" }, outputs: { filterChange: "filterChange" }, viewQueries: [{ propertyName: "widgetContainer", first: true, predicate: SearchWidgetContainerComponent, descendants: true }, { propertyName: "filterContainer", first: true, predicate: ["filterContainer"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"!!category\"\n     class=\"adf-filter\">\n    <button mat-icon-button\n            [matMenuTriggerFor]=\"filter\"\n            data-automation-id=\"filter-menu-button\"\n            #menuTrigger=\"matMenuTrigger\"\n            (click)=\"$event.stopPropagation()\"\n            (menuOpened)=\"onMenuOpen()\"\n            (keyup.enter)=\"$event.stopPropagation()\"\n            class=\"adf-filter-button\"\n            [attr.aria-label]=\"getTooltipTranslation(col?.title)\"\n            [matTooltip]=\"getTooltipTranslation(col?.title)\">\n        <adf-icon value=\"filter_list\"\n                  [ngClass]=\"{ 'adf-icon-active': isActive() || menuTrigger.menuOpen }\"\n                  matBadge=\"filter\"\n                  matBadgeColor=\"warn\"\n                  [matBadgeHidden]=\"!isActive()\">\n        </adf-icon>\n    </button>\n\n    <mat-menu #filter=\"matMenu\"\n              class=\"adf-filter-menu\"\n              (closed)=\"onClosed()\">\n        <div #filterContainer\n              role=\"menuitem\"\n             (keydown.tab)=\"$event.stopPropagation();\">\n            <div (click)=\"$event.stopPropagation()\"\n                 class=\"adf-filter-container\">\n                <div class=\"adf-filter-title\">{{ category?.name | translate }}</div>\n                <adf-search-widget-container (keypress)=\"onKeyPressed($event, menuTrigger)\"\n                                             [id]=\"category?.id\"\n                                             [selector]=\"category?.component?.selector\"\n                                             [settings]=\"category?.component?.settings\"\n                                             [value]=\"initialValue\">\n                </adf-search-widget-container>\n            </div>\n            <mat-dialog-actions class=\"adf-filter-actions\">\n                <button mat-button\n                        id=\"clear-filter-button\"\n                        [attr.aria-label]=\"'SEARCH.SEARCH_HEADER.CLEAR' | translate\"\n                        (click)=\"onClearButtonClick($event)\">{{ 'SEARCH.SEARCH_HEADER.CLEAR' | translate | uppercase }}\n                </button>\n                <button mat-button\n                        color=\"primary\"\n                        id=\"apply-filter-button\"\n                        class=\"adf-filter-apply-button\"\n                        [attr.aria-label]=\"'SEARCH.SEARCH_HEADER.APPLY' | translate\"\n                        (click)=\"onApply()\">{{ 'SEARCH.SEARCH_HEADER.APPLY' | translate | uppercase }}\n                </button>\n            </mat-dialog-actions>\n        </div>\n    </mat-menu>\n</div>\n", styles: [".adf-filter-button{margin-left:-7px!important}.adf-filter-button .adf-icon{opacity:1;color:var(--adf-theme-foreground-icon-color)}.adf-filter-button .adf-icon-active{color:var(--theme-primary-color)}.adf-filter-button .adf-icon .mat-badge-active{border:2px solid var(--adf-theme-background-card-color)!important}.adf-filter-button .mat-badge-content{width:10px;height:10px;top:-3px!important;right:-6px!important}.adf-filter-container{display:flex;flex-direction:column;padding:15px 15px 10px;color:var(--adf-theme-foreground-text-color-087)!important}.adf-filter-container .adf-facet-buttons{display:none}.adf-filter-container .adf-search-check-list{padding:5px 0}.adf-filter-container input{background:2px solid var(--adf-theme-background-card-color)!important}.adf-filter-title{font-size:1.1em;padding-bottom:5px;color:var(--adf-theme-foreground-text-color-087)}.adf-filter-actions{display:flex;justify-content:flex-end;padding:15px;background-color:var(--adf-theme-background-hover-color)}.adf-filter-actions>button{font-size:.9em;color:var(--adf-theme-foreground-text-color-087)}.mat-menu-panel.adf-filter-menu .mat-menu-content{min-width:260px;padding:0}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i7$2.MatBadge, selector: "[matBadge]", inputs: ["matBadgeDisabled", "matBadgeColor", "matBadgeOverlap", "matBadgePosition", "matBadge", "matBadgeDescription", "matBadgeSize", "matBadgeHidden"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i1.IconComponent, selector: "adf-icon", inputs: ["color", "fontSet", "value"] }, { kind: "component", type: SearchWidgetContainerComponent, selector: "adf-search-widget-container", inputs: ["id", "selector", "settings", "config", "value"] }, { kind: "pipe", type: i2$1.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-filter-container', encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"!!category\"\n     class=\"adf-filter\">\n    <button mat-icon-button\n            [matMenuTriggerFor]=\"filter\"\n            data-automation-id=\"filter-menu-button\"\n            #menuTrigger=\"matMenuTrigger\"\n            (click)=\"$event.stopPropagation()\"\n            (menuOpened)=\"onMenuOpen()\"\n            (keyup.enter)=\"$event.stopPropagation()\"\n            class=\"adf-filter-button\"\n            [attr.aria-label]=\"getTooltipTranslation(col?.title)\"\n            [matTooltip]=\"getTooltipTranslation(col?.title)\">\n        <adf-icon value=\"filter_list\"\n                  [ngClass]=\"{ 'adf-icon-active': isActive() || menuTrigger.menuOpen }\"\n                  matBadge=\"filter\"\n                  matBadgeColor=\"warn\"\n                  [matBadgeHidden]=\"!isActive()\">\n        </adf-icon>\n    </button>\n\n    <mat-menu #filter=\"matMenu\"\n              class=\"adf-filter-menu\"\n              (closed)=\"onClosed()\">\n        <div #filterContainer\n              role=\"menuitem\"\n             (keydown.tab)=\"$event.stopPropagation();\">\n            <div (click)=\"$event.stopPropagation()\"\n                 class=\"adf-filter-container\">\n                <div class=\"adf-filter-title\">{{ category?.name | translate }}</div>\n                <adf-search-widget-container (keypress)=\"onKeyPressed($event, menuTrigger)\"\n                                             [id]=\"category?.id\"\n                                             [selector]=\"category?.component?.selector\"\n                                             [settings]=\"category?.component?.settings\"\n                                             [value]=\"initialValue\">\n                </adf-search-widget-container>\n            </div>\n            <mat-dialog-actions class=\"adf-filter-actions\">\n                <button mat-button\n                        id=\"clear-filter-button\"\n                        [attr.aria-label]=\"'SEARCH.SEARCH_HEADER.CLEAR' | translate\"\n                        (click)=\"onClearButtonClick($event)\">{{ 'SEARCH.SEARCH_HEADER.CLEAR' | translate | uppercase }}\n                </button>\n                <button mat-button\n                        color=\"primary\"\n                        id=\"apply-filter-button\"\n                        class=\"adf-filter-apply-button\"\n                        [attr.aria-label]=\"'SEARCH.SEARCH_HEADER.APPLY' | translate\"\n                        (click)=\"onApply()\">{{ 'SEARCH.SEARCH_HEADER.APPLY' | translate | uppercase }}\n                </button>\n            </mat-dialog-actions>\n        </div>\n    </mat-menu>\n</div>\n", styles: [".adf-filter-button{margin-left:-7px!important}.adf-filter-button .adf-icon{opacity:1;color:var(--adf-theme-foreground-icon-color)}.adf-filter-button .adf-icon-active{color:var(--theme-primary-color)}.adf-filter-button .adf-icon .mat-badge-active{border:2px solid var(--adf-theme-background-card-color)!important}.adf-filter-button .mat-badge-content{width:10px;height:10px;top:-3px!important;right:-6px!important}.adf-filter-container{display:flex;flex-direction:column;padding:15px 15px 10px;color:var(--adf-theme-foreground-text-color-087)!important}.adf-filter-container .adf-facet-buttons{display:none}.adf-filter-container .adf-search-check-list{padding:5px 0}.adf-filter-container input{background:2px solid var(--adf-theme-background-card-color)!important}.adf-filter-title{font-size:1.1em;padding-bottom:5px;color:var(--adf-theme-foreground-text-color-087)}.adf-filter-actions{display:flex;justify-content:flex-end;padding:15px;background-color:var(--adf-theme-background-hover-color)}.adf-filter-actions>button{font-size:.9em;color:var(--adf-theme-foreground-text-color-087)}.mat-menu-panel.adf-filter-menu .mat-menu-content{min-width:260px;padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchHeaderQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: i1.TranslationService }, { type: i1$4.ConfigurableFocusTrapFactory }]; }, propDecorators: { col: [{
                type: Input
            }], value: [{
                type: Input
            }], filterChange: [{
                type: Output
            }], widgetContainer: [{
                type: ViewChild,
                args: [SearchWidgetContainerComponent]
            }], filterContainer: [{
                type: ViewChild,
                args: ['filterContainer']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FilterHeaderComponent {
    constructor(documentList, searchFilterQueryBuilder) {
        this.documentList = documentList;
        this.searchFilterQueryBuilder = searchFilterQueryBuilder;
        /** (optional) Initial filter value to sort . */
        this.value = {};
        /** Emitted when a filter value is selected */
        this.filterSelection = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.isFilterServiceActive = this.searchFilterQueryBuilder.isFilterServiceActive();
    }
    ngOnInit() {
        this.searchFilterQueryBuilder.executed
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((newNodePaging) => {
            this.documentList.node = newNodePaging;
            this.documentList.reload();
        });
        this.initDataPagination();
        this.initDataSorting();
    }
    ngOnChanges(changes) {
        if (changes['currentFolderId'] && changes['currentFolderId'].currentValue) {
            this.resetFilterHeader();
            this.configureSearchParent(changes['currentFolderId'].currentValue);
        }
    }
    onFilterSelectionChange() {
        this.filterSelection.emit(this.searchFilterQueryBuilder.getActiveFilters());
        if (this.searchFilterQueryBuilder.isNoFilterActive()) {
            this.documentList.node = null;
            this.documentList.reload();
        }
    }
    resetFilterHeader() {
        this.searchFilterQueryBuilder.resetActiveFilters();
    }
    initDataPagination() {
        this.documentList.pagination
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((newPagination) => {
            this.searchFilterQueryBuilder.setupCurrentPagination(newPagination.maxItems, newPagination.skipCount);
        });
    }
    initDataSorting() {
        this.documentList.sortingSubject
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((sorting) => {
            this.searchFilterQueryBuilder.setSorting(sorting);
        });
    }
    configureSearchParent(currentFolderId) {
        if (this.searchFilterQueryBuilder.isCustomSourceNode(currentFolderId)) {
            this.searchFilterQueryBuilder.getNodeIdForCustomSource(currentFolderId).subscribe((node) => {
                this.initSearchHeader(node.id);
            });
        }
        else {
            this.initSearchHeader(currentFolderId);
        }
    }
    initSearchHeader(currentFolderId) {
        this.searchFilterQueryBuilder.setCurrentRootFolderId(currentFolderId);
        if (this.value) {
            Object.keys(this.value).forEach((columnKey) => {
                this.searchFilterQueryBuilder.setActiveFilter(columnKey, this.value[columnKey]);
            });
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
FilterHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FilterHeaderComponent, deps: [{ token: ADF_DOCUMENT_PARENT_COMPONENT }, { token: SEARCH_QUERY_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component });
FilterHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FilterHeaderComponent, selector: "adf-filter-header", inputs: { value: "value", currentFolderId: "currentFolderId" }, outputs: { filterSelection: "filterSelection" }, providers: [{ provide: SEARCH_QUERY_SERVICE_TOKEN, useClass: SearchHeaderQueryBuilderService }], usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"isFilterServiceActive\">\n    <adf-header-filter-template>\n        <ng-template let-col>\n            <adf-search-filter-container [col]=\"col\"\n                                         [value]=\"value\"\n                                         (filterChange)=\"onFilterSelectionChange()\">\n            </adf-search-filter-container>\n        </ng-template>\n    </adf-header-filter-template>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.HeaderFilterTemplateDirective, selector: "adf-header-filter-template" }, { kind: "component", type: SearchFilterContainerComponent, selector: "adf-search-filter-container", inputs: ["col", "value"], outputs: ["filterChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FilterHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-filter-header', providers: [{ provide: SEARCH_QUERY_SERVICE_TOKEN, useClass: SearchHeaderQueryBuilderService }], template: "<div *ngIf=\"isFilterServiceActive\">\n    <adf-header-filter-template>\n        <ng-template let-col>\n            <adf-search-filter-container [col]=\"col\"\n                                         [value]=\"value\"\n                                         (filterChange)=\"onFilterSelectionChange()\">\n            </adf-search-filter-container>\n        </ng-template>\n    </adf-header-filter-template>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ADF_DOCUMENT_PARENT_COMPONENT]
                }] }, { type: SearchHeaderQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }]; }, propDecorators: { value: [{
                type: Input
            }], currentFolderId: [{
                type: Input
            }], filterSelection: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const BYTES_TO_MB_CONVERSION_VALUE = 1048576;
class DocumentListComponent {
    constructor(documentListService, elementRef, appConfig, userPreferencesService, contentService, thumbnailService, alfrescoApiService, nodeService, dataTableService, lockService, dialog) {
        this.documentListService = documentListService;
        this.elementRef = elementRef;
        this.appConfig = appConfig;
        this.userPreferencesService = userPreferencesService;
        this.contentService = contentService;
        this.thumbnailService = thumbnailService;
        this.alfrescoApiService = alfrescoApiService;
        this.nodeService = nodeService;
        this.dataTableService = dataTableService;
        this.lockService = lockService;
        this.dialog = dialog;
        this.DEFAULT_PAGINATION = new Pagination$1({
            hasMoreItems: false,
            skipCount: 0,
            maxItems: 25,
            totalItems: 0
        });
        this.DEFAULT_SORTING = [
            new DataSorting('name', 'asc'),
            new DataSorting('isFolder', 'desc')
        ];
        /** Change the display mode of the table. Can be "list" or "gallery". */
        this.display = DisplayMode.List;
        /** Define a set of CSS styles to apply depending on the permission
         * of the user on that node. See the Permission Style model
         * page for further details and examples.
         */
        this.permissionsStyle = [];
        /** The default route for all the location-based columns (if declared). */
        this.locationFormat = '/';
        /** Toggles navigation to folder content or file preview */
        this.navigate = true;
        /** Toggles the header */
        this.showHeader = ShowHeaderMode.Data;
        /** User interaction for folder navigation or file preview.
         * Valid values are "click" and "dblclick". Default value: "dblclick"
         */
        this.navigationMode = DocumentListComponent.DOUBLE_CLICK_NAVIGATION; // click|dblclick
        /** Show document thumbnails rather than icons */
        this.thumbnails = false;
        /** Row selection mode. Can be null, `single` or `multiple`. For `multiple` mode,
         * you can use Cmd (macOS) or Ctrl (Win) modifier key to toggle selection for multiple rows.
         */
        this.selectionMode = 'single'; // null|single|multiple
        /** Toggles multiselect mode */
        this.multiselect = false;
        /** Toggles content actions for each row */
        this.contentActions = false;
        /** Position of the content actions dropdown menu. Can be set to "left" or "right". */
        this.contentActionsPosition = 'right'; // left|right
        /** Toggles context menus for each row */
        this.contextMenuActions = false;
        /** Custom image for empty folder. Default value: './assets/images/empty_doc_lib.svg' */
        this.emptyFolderImageUrl = './assets/images/empty_doc_lib.svg';
        /**
         * When true, this enables you to drop files directly into subfolders shown
         * as items in the list or into another file to trigger updating it's version.
         * When false, the dropped file will be added to the
         * current folder (ie, the one containing all the items shown in the list).
         * See the Upload directive for further details about how the file drop is
         * handled.
         */
        this.allowDropFiles = false;
        /** Defines default sorting. The format is an array of 2 strings `[key, direction]`
         * i.e. `['name', 'desc']` or `['name', 'asc']`. Set this value only if you want to
         * override the default sorting detected by the component based on columns.
         */
        this.sorting = ['name', 'asc'];
        /** Defines default sorting. The format is an array of strings `[key direction, otherKey otherDirection]`
         * i.e. `['name desc', 'nodeType asc']` or `['name asc']`. Set this value if you want a base
         * rule to be added to the sorting apart from the one driven by the header.
         */
        this.additionalSorting = new DataSorting('isFolder', 'desc');
        /** Defines sorting mode. Can be either `client` (items in the list
         * are sorted client-side) or `server` (the ordering supplied by the
         * server is used without further client-side sorting).
         * Note that the `server` option *does not* request the server to sort the data
         * before delivering it.
         */
        this.sortingMode = 'server';
        /** Toggles the loading state and animated spinners for the component. Used in
         * combination with `navigate=false` to perform custom navigation and loading
         * state indication.
         */
        this.loading = false;
        /** @hidden */
        this._rowFilter = null;
        /**
         * Custom function to choose image file paths to show. See the
         * [Image Resolver Model](image-resolver.model.md) page for
         * more information.
         */
        this.imageResolver = null;
        /** Toggles the sticky header mode. */
        this.stickyHeader = false;
        /** Toggles the header filters mode. */
        this.headerFilters = false;
        /** The ID of the folder node to display or a reserved string alias for special sources */
        this.currentFolderId = null;
        /** Array of nodes to be pre-selected. All nodes in the
         * array are pre-selected in multi selection mode, but only the first node
         * is pre-selected in single selection mode.
         */
        this.preselectNodes = [];
        /** The Document list will show all the nodes contained in the NodePaging entity */
        this.node = null;
        /** Default value is stored in the user preference settings. Use this only if you are not using pagination. */
        this.maxItems = this.DEFAULT_PAGINATION.maxItems;
        /** Emitted when the user clicks a list node */
        this.nodeClick = new EventEmitter();
        /** Emitted when the user double-clicks a list node */
        this.nodeDblClick = new EventEmitter();
        /** Emitted when the current display folder changes */
        this.folderChange = new EventEmitter();
        /** Emitted when the user acts upon files with either single or double click
         * (depends on `navigation-mode`). Useful for integration with the
         * Viewer component.
         */
        this.preview = new EventEmitter();
        /** Emitted when the Document List has loaded all items and is ready for use */
        this.ready = new EventEmitter();
        /** Emitted when the API fails to get the Document List data */
        this.error = new EventEmitter();
        /** Emitted when the node selection change */
        this.nodeSelected = new EventEmitter();
        /** Emitted when a filter value is selected */
        this.filterSelection = new EventEmitter();
        this.actions = [];
        this.contextActionHandler = new Subject();
        this.noPermission = false;
        this.selection = new Array();
        this.$folderNode = new Subject();
        this.allowFiltering = true;
        this.orderBy = null;
        this.preselectedRows = [];
        this._pagination = this.DEFAULT_PAGINATION;
        this.pagination = new BehaviorSubject(this.DEFAULT_PAGINATION);
        this.sortingSubject = new BehaviorSubject(this.DEFAULT_SORTING);
        this.layoutPresets = {};
        this.rowMenuCache = {};
        this.onDestroy$ = new Subject();
        this.nodeService.nodeUpdated.subscribe((node) => {
            this.dataTableService.rowUpdate.next({ id: node.id, obj: { entry: node } });
        });
        this.userPreferencesService
            .select(UserPreferenceValues.PaginationSize)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(pagSize => {
            this.maxItems = this._pagination.maxItems = pagSize;
        });
    }
    /**
     * Custom function to choose whether to show or hide rows.
     * See the [Row Filter Model](row-filter.model.md) page for
     * more information.
     */
    set rowFilter(rowFilter) {
        this._rowFilter = rowFilter;
        if (this.data) {
            this.data.setFilter(this._rowFilter);
            if (this.currentFolderId) {
                this.reload();
            }
        }
    }
    get rowFilter() {
        return this._rowFilter;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.alfrescoApiService.getInstance());
        return this._nodesApi;
    }
    getContextActions(node) {
        if (node && node.entry) {
            const actions = this.getNodeActions(node);
            if (actions && actions.length > 0) {
                return actions.map((currentAction) => ({
                    model: currentAction,
                    node,
                    subject: this.contextActionHandler
                }));
            }
        }
        return null;
    }
    get hasCustomLayout() {
        return this.columnList && this.columnList.columns && this.columnList.columns.length > 0;
    }
    getDefaultSorting() {
        let defaultSorting;
        if (Array.isArray(this.sorting)) {
            const [key, direction] = this.sorting;
            defaultSorting = new DataSorting(key, direction);
        }
        else {
            defaultSorting = new DataSorting(this.sorting.key, this.sorting.direction);
        }
        return defaultSorting;
    }
    getLayoutPreset(name = 'default') {
        return (this.layoutPresets[name] || this.layoutPresets['default']).map((col) => new ObjectDataColumn(col));
    }
    isMobile() {
        return !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    isEmpty() {
        return !this.data || this.data.getRows().length === 0;
    }
    ngOnInit() {
        this.rowMenuCache = {};
        this.loadLayoutPresets();
        this.data = new ShareDataTableAdapter(this.thumbnailService, this.contentService, null, this.getDefaultSorting(), this.sortingMode, this.allowDropFiles);
        this.data.thumbnails = this.thumbnails;
        this.data.permissionsStyle = this.permissionsStyle;
        if (this._rowFilter) {
            this.data.setFilter(this._rowFilter);
        }
        if (this.imageResolver) {
            this.data.setImageResolver(this.imageResolver);
        }
        this.contextActionHandler
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(val => this.contextActionCallback(val));
        this.enforceSingleClickNavigationForMobile();
    }
    ngAfterContentInit() {
        if (this.columnList) {
            this.columnList.columns.changes
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(() => this.setTableSchema());
        }
        this.setTableSchema();
    }
    setTableSchema() {
        let schema = [];
        if (this.hasCustomLayout) {
            schema = this.columnList.columns.map((c) => c);
        }
        if (!this.data) {
            this.data = new ShareDataTableAdapter(this.thumbnailService, this.contentService, schema, this.getDefaultSorting(), this.sortingMode);
        }
        else if (schema && schema.length > 0) {
            this.data.setColumns(schema);
        }
        const columns = this.data.getColumns();
        if (!columns || columns.length === 0) {
            this.setupDefaultColumns(this.currentFolderId);
        }
    }
    ngOnChanges(changes) {
        if (!changes['preselectNodes']) {
            this.resetSelection();
        }
        if (Array.isArray(this.sorting)) {
            const [key, direction] = this.sorting;
            this.orderBy = this.buildOrderByArray(key, direction);
        }
        else {
            this.orderBy = this.buildOrderByArray(this.sorting.key, this.sorting.direction);
        }
        if (this.data) {
            this.data.thumbnails = this.thumbnails;
        }
        if (changes.sortingMode && !changes.sortingMode.firstChange && this.data) {
            this.data.sortingMode = changes.sortingMode.currentValue;
        }
        if (changes.sorting && !changes.sorting.firstChange && this.data) {
            const newValue = changes.sorting.currentValue;
            if (newValue && newValue.length > 0) {
                const [key, direction] = newValue;
                this.data.setSorting(new DataSorting(key, direction));
            }
        }
        if (this.currentFolderId && changes['currentFolderId']?.currentValue !== changes['currentFolderId']?.previousValue) {
            this.loadFolder();
        }
        if (this.data) {
            if (changes.node && changes.node.currentValue) {
                const merge = this._pagination ? this._pagination.merge : false;
                this.data.loadPage(changes.node.currentValue, merge, null);
                this.preserveExistingSelection();
                this.onPreselectNodes();
                this.onDataReady(changes.node.currentValue);
            }
            else if (changes.imageResolver) {
                this.data.setImageResolver(changes.imageResolver.currentValue);
            }
        }
    }
    reload() {
        this.resetSelection();
        this.reloadWithoutResettingSelection();
    }
    reloadWithoutResettingSelection() {
        if (this.node) {
            if (this.data) {
                this.data.loadPage(this.node, this._pagination.merge, null);
                this.preserveExistingSelection();
            }
            this.onPreselectNodes();
            this.syncPagination();
            this.onDataReady(this.node);
        }
        else {
            this.loadFolder();
        }
    }
    contextActionCallback(action) {
        if (action) {
            this.executeContentAction(action.node, action.model);
        }
    }
    getNodeActions(node) {
        if (node && node.entry) {
            let target = null;
            if (node.entry.isFile) {
                target = 'document';
            }
            else if (node.entry.isFolder) {
                target = 'folder';
            }
            if (target) {
                const actions = this.rowMenuCache[node.entry.id];
                if (actions) {
                    actions.forEach((action) => {
                        this.refreshAction(action, node);
                    });
                    return actions;
                }
                const actionsByTarget = this.actions
                    .filter((entry) => {
                    const isVisible = (typeof entry.visible === 'function')
                        ? entry.visible(node)
                        : entry.visible;
                    return isVisible && entry.target.toLowerCase() === target;
                })
                    .map((action) => new ContentActionModel(action));
                actionsByTarget.forEach((action) => {
                    this.refreshAction(action, node);
                });
                this.rowMenuCache[node.entry.id] = actionsByTarget;
                return actionsByTarget;
            }
        }
        return [];
    }
    refreshAction(action, node) {
        action.disabled = this.isActionDisabled(action, node);
        action.visible = this.isActionVisible(action, node);
    }
    isActionVisible(action, node) {
        if (typeof action.visible === 'function') {
            return action.visible(node);
        }
        return action.visible;
    }
    isActionDisabled(action, node) {
        if (typeof action.disabled === 'function') {
            return action.disabled(node);
        }
        if ((action.permission &&
            action.disableWithNoPermission &&
            !this.contentService.hasAllowableOperations(node.entry, action.permission)) ||
            this.lockService.isLocked(node.entry)) {
            return true;
        }
        else {
            return action.disabled;
        }
    }
    onShowContextMenu(e) {
        if (e && this.contextMenuActions) {
            e.preventDefault();
        }
    }
    navigateTo(node) {
        if (typeof node === 'string') {
            this.resetNewFolderPagination();
            this.currentFolderId = node;
            this.folderChange.emit(new NodeEntryEvent({ id: node }));
            this.reload();
            return true;
        }
        else {
            if (this.canNavigateFolder(node)) {
                this.resetNewFolderPagination();
                this.currentFolderId = this.getNodeFolderDestinationId(node);
                this.folderChange.emit(new NodeEntryEvent({ id: this.currentFolderId }));
                this.reload();
                return true;
            }
        }
        return false;
    }
    getNodeFolderDestinationId(node) {
        return this.isLinkFolder(node) ? node.properties['cm:destination'] : node.id;
    }
    isLinkFolder(node) {
        return node.nodeType === 'app:folderlink' && node.properties &&
            node.properties['cm:destination'];
    }
    updateCustomSourceData(nodeId) {
        this.currentFolderId = nodeId;
    }
    /**
     * Invoked when executing content action for a document or folder.
     *
     * @param node Node to be the context of the execution.
     * @param action Action to be executed against the context.
     */
    executeContentAction(node, action) {
        if (node && node.entry && action) {
            const handlerSub = (typeof action.handler === 'function') ? action.handler(node, this, action.permission) : of(true);
            if (typeof action.execute === 'function' && handlerSub) {
                handlerSub
                    .pipe(takeUntil(this.onDestroy$))
                    .subscribe(() => action.execute(node));
            }
        }
    }
    setLoadingState(value) {
        if (this.data?.getRows().length > 0) {
            if (value) {
                clearTimeout(this.loadingTimeout);
                this.loadingTimeout = setTimeout(() => {
                    this.loading = true;
                }, 1000);
            }
            else {
                clearTimeout(this.loadingTimeout);
                this.loading = false;
            }
        }
        else {
            clearTimeout(this.loadingTimeout);
            this.loading = value;
        }
    }
    loadFolder() {
        if (!this._pagination.merge) {
            this.setLoadingState(true);
        }
        if (!this.hasCustomLayout) {
            this.setupDefaultColumns(this.currentFolderId);
        }
        if (this.documentListService.isCustomSourceService(this.currentFolderId)) {
            this.updateCustomSourceData(this.currentFolderId);
        }
        this.documentListService.loadFolderByNodeId(this.currentFolderId, this._pagination, this.includeFields, this.where, this.orderBy)
            .subscribe((documentNode) => {
            if (documentNode.currentNode) {
                this.folderNode = documentNode.currentNode.entry;
                this.$folderNode.next(documentNode.currentNode.entry);
            }
            this.onPageLoaded(documentNode.children);
        }, (err) => {
            this.handleError(err);
        });
    }
    resetSelection() {
        this.dataTable.resetSelection();
        this.selection = [];
        this.noPermission = false;
    }
    onPageLoaded(nodePaging) {
        if (nodePaging) {
            if (this.data) {
                this.data.loadPage(nodePaging, this._pagination.merge, this.allowDropFiles);
                this.preserveExistingSelection();
            }
            this.onPreselectNodes();
            this.setLoadingState(false);
            this.onDataReady(nodePaging);
        }
    }
    onSortingChanged(event) {
        this.orderBy = this.buildOrderByArray(event.detail.sortingKey, event.detail.direction);
        this.sortingSubject.next([this.additionalSorting, event.detail]);
        if (this.sortingMode === 'server') {
            this.reload();
        }
    }
    buildOrderByArray(currentKey, currentDirection) {
        return [
            `${this.additionalSorting.key} ${this.additionalSorting.direction}`,
            `${currentKey} ${currentDirection}`
        ];
    }
    /**
     * Creates a set of predefined columns.
     */
    setupDefaultColumns(preset = 'default') {
        if (this.data) {
            const columns = this.getLayoutPreset(preset);
            this.data.setColumns(columns);
        }
    }
    onPreviewFile(node) {
        if (node) {
            const sizeInMB = node.entry?.content?.sizeInBytes / BYTES_TO_MB_CONVERSION_VALUE;
            const fileAutoDownloadFlag = this.appConfig.get('viewer.enableFileAutoDownload', true);
            const sizeThreshold = this.appConfig.get('viewer.fileAutoDownloadSizeThresholdInMB', 15);
            if (fileAutoDownloadFlag && sizeInMB && sizeInMB > sizeThreshold) {
                this.dialog.open(FileAutoDownloadComponent, { disableClose: true, data: node });
            }
            else {
                this.preview.emit(new NodeEntityEvent(node));
            }
        }
    }
    onNodeClick(nodeEntry) {
        const domEvent = new CustomEvent('node-click', {
            detail: {
                sender: this,
                node: nodeEntry
            },
            bubbles: true
        });
        this.elementRef.nativeElement.dispatchEvent(domEvent);
        const event = new NodeEntityEvent(nodeEntry);
        this.nodeClick.emit(event);
        if (!event.defaultPrevented) {
            if (this.navigate && this.navigationMode === DocumentListComponent.SINGLE_CLICK_NAVIGATION) {
                this.executeActionClick(nodeEntry);
            }
        }
    }
    onNodeDblClick(nodeEntry) {
        const domEvent = new CustomEvent('node-dblclick', {
            detail: {
                sender: this,
                node: nodeEntry
            },
            bubbles: true
        });
        this.elementRef.nativeElement.dispatchEvent(domEvent);
        const event = new NodeEntityEvent(nodeEntry);
        this.nodeDblClick.emit(event);
        if (!event.defaultPrevented) {
            if (this.navigate && this.navigationMode === DocumentListComponent.DOUBLE_CLICK_NAVIGATION) {
                this.executeActionClick(nodeEntry);
            }
        }
    }
    executeActionClick(nodeEntry) {
        if (nodeEntry && nodeEntry.entry) {
            if (nodeEntry.entry.isFile) {
                this.onPreviewFile(nodeEntry);
            }
            if (nodeEntry.entry.isFolder) {
                this.navigateTo(nodeEntry.entry);
            }
            if (nodeEntry.entry['guid']) {
                const options = {
                    include: this.includeFields
                };
                this.nodesApi.getNode(nodeEntry.entry['guid'], options)
                    .then((node) => {
                    this.navigateTo(node.entry);
                });
            }
        }
    }
    onNodeSelect(event) {
        this.selection = event.selection.map((entry) => entry.node);
        const domEvent = new CustomEvent('node-select', {
            detail: {
                node: event.row ? event.row.node : null,
                selection: this.selection
            },
            bubbles: true
        });
        this.nodeSelected.emit(this.selection);
        this.elementRef.nativeElement.dispatchEvent(domEvent);
    }
    onNodeUnselect(event) {
        this.selection = event.selection.map((entry) => entry.node);
        const domEvent = new CustomEvent('node-unselect', {
            detail: {
                node: event.row ? event.row.node : null,
                selection: this.selection
            },
            bubbles: true
        });
        this.nodeSelected.emit(this.selection);
        this.elementRef.nativeElement.dispatchEvent(domEvent);
    }
    onShowRowContextMenu(event) {
        if (this.contextMenuActions) {
            const args = event.value;
            const node = args.row.node;
            if (node) {
                args.actions = this.getContextActions(node) || [];
            }
        }
    }
    onShowRowActionsMenu(event) {
        if (this.contentActions) {
            const args = event.value;
            const node = args.row.node;
            if (node) {
                args.actions = this.getNodeActions(node) || [];
            }
        }
    }
    onExecuteRowAction(event) {
        if (this.contentActions) {
            const args = event.value;
            const node = args.row.node;
            const action = args.action;
            this.executeContentAction(node, action);
        }
    }
    enforceSingleClickNavigationForMobile() {
        if (this.isMobile()) {
            this.navigationMode = DocumentListComponent.SINGLE_CLICK_NAVIGATION;
        }
    }
    canNavigateFolder(node) {
        let canNavigateFolder = false;
        if (node && node.isFolder) {
            canNavigateFolder = true;
        }
        return canNavigateFolder;
    }
    loadLayoutPresets() {
        const externalSettings = this.appConfig.get('document-list.presets', null);
        this.layoutPresets = externalSettings ? Object.assign({}, presetsDefaultModel, externalSettings) : presetsDefaultModel;
    }
    onDataReady(nodePaging) {
        this.ready.emit(nodePaging);
        this.pagination.next(nodePaging.list.pagination);
    }
    updatePagination(requestPaginationModel) {
        this._pagination.maxItems = requestPaginationModel.maxItems;
        this._pagination.merge = requestPaginationModel.merge;
        this._pagination.skipCount = requestPaginationModel.skipCount;
        this.reload();
    }
    syncPagination() {
        this.node.list.pagination.maxItems = this._pagination.maxItems;
        this.node.list.pagination.skipCount = this._pagination.skipCount;
    }
    onFilterSelectionChange(activeFilters) {
        this.filterSelection.emit(activeFilters);
    }
    resetNewFolderPagination() {
        this._pagination.skipCount = 0;
        this._pagination.maxItems = this.maxItems;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    handleError(err) {
        if (err.message) {
            try {
                if (JSON.parse(err.message).error.statusCode === 403) {
                    this.noPermission = true;
                }
            }
            catch (error) {
            }
        }
        this.setLoadingState(false);
        this.error.emit(err);
    }
    getPreselectedNodesBasedOnSelectionMode() {
        return this.hasPreselectedNodes() ? (this.isSingleSelectionMode() ? [this.preselectNodes[0]] : this.preselectNodes) : [];
    }
    getPreselectedRowsBasedOnSelectionMode() {
        return this.hasPreselectedRows() ? (this.isSingleSelectionMode() ? [this.preselectedRows[0]] : this.preselectedRows) : [];
    }
    getSelectionBasedOnSelectionMode() {
        return this.hasPreselectedRows() ? (this.isSingleSelectionMode() ? [this.preselectedRows[0]] : this.data.getSelectedRows()) : this.data.getSelectedRows();
    }
    onPreselectNodes() {
        if (this.hasPreselectedNodes()) {
            this.preselectRowsOfPreselectedNodes();
            const preselectedRows = this.getPreselectedRowsBasedOnSelectionMode();
            const selection = this.data.getSelectedRows();
            for (const node of preselectedRows) {
                this.dataTable.selectRow(node, true);
            }
            this.onNodeSelect({ row: undefined, selection });
        }
    }
    preserveExistingSelection() {
        if (this.isMultipleSelectionMode()) {
            for (const selection of this.selection) {
                const rowOfSelection = this.data.getRowByNodeId(selection.entry.id);
                if (rowOfSelection) {
                    rowOfSelection.isSelected = true;
                }
            }
        }
    }
    preselectRowsOfPreselectedNodes() {
        this.preselectedRows = [];
        const preselectedNodes = this.getPreselectedNodesBasedOnSelectionMode();
        preselectedNodes.forEach((preselectedNode) => {
            const rowOfPreselectedNode = this.data.getRowByNodeId(preselectedNode.entry.id);
            if (rowOfPreselectedNode) {
                rowOfPreselectedNode.isSelected = true;
                this.preselectedRows.push(rowOfPreselectedNode);
            }
        });
    }
    unselectRowFromNodeId(nodeId) {
        const rowToUnselect = this.data.getRowByNodeId(nodeId);
        if (rowToUnselect?.isSelected) {
            rowToUnselect.isSelected = false;
            this.dataTable.selectRow(rowToUnselect, false);
            const selection = this.getSelectionBasedOnSelectionMode();
            this.onNodeUnselect({ row: undefined, selection });
        }
    }
    isSingleSelectionMode() {
        return this.selectionMode === 'single';
    }
    isMultipleSelectionMode() {
        return this.selectionMode === 'multiple';
    }
    hasPreselectedNodes() {
        return this.preselectNodes?.length > 0;
    }
    hasPreselectedRows() {
        return this.preselectedRows?.length > 0;
    }
}
DocumentListComponent.SINGLE_CLICK_NAVIGATION = 'click';
DocumentListComponent.DOUBLE_CLICK_NAVIGATION = 'dblclick';
DocumentListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListComponent, deps: [{ token: DocumentListService }, { token: i0.ElementRef }, { token: i1.AppConfigService }, { token: i1.UserPreferencesService }, { token: ContentService }, { token: i1.ThumbnailService }, { token: i1.AlfrescoApiService }, { token: NodesApiService }, { token: i1.DataTableService }, { token: LockService }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
DocumentListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DocumentListComponent, selector: "adf-document-list", inputs: { includeFields: "includeFields", where: "where", display: "display", permissionsStyle: "permissionsStyle", locationFormat: "locationFormat", navigate: "navigate", showHeader: "showHeader", navigationMode: "navigationMode", thumbnails: "thumbnails", selectionMode: "selectionMode", multiselect: "multiselect", contentActions: "contentActions", contentActionsPosition: "contentActionsPosition", contextMenuActions: "contextMenuActions", emptyFolderImageUrl: "emptyFolderImageUrl", allowDropFiles: "allowDropFiles", sorting: "sorting", additionalSorting: "additionalSorting", sortingMode: "sortingMode", rowStyle: "rowStyle", rowStyleClass: "rowStyleClass", loading: "loading", _rowFilter: "_rowFilter", rowFilter: "rowFilter", imageResolver: "imageResolver", stickyHeader: "stickyHeader", headerFilters: "headerFilters", filterValue: "filterValue", currentFolderId: "currentFolderId", preselectNodes: "preselectNodes", node: "node", maxItems: "maxItems" }, outputs: { nodeClick: "nodeClick", nodeDblClick: "nodeDblClick", folderChange: "folderChange", preview: "preview", ready: "ready", error: "error", nodeSelected: "nodeSelected", filterSelection: "filterSelection" }, host: { listeners: { "contextmenu": "onShowContextMenu($event)" }, classAttribute: "adf-document-list" }, providers: [{
            provide: ADF_DOCUMENT_PARENT_COMPONENT,
            useExisting: DocumentListComponent
        }, DataTableService], queries: [{ propertyName: "columnList", first: true, predicate: DataColumnListComponent, descendants: true }, { propertyName: "customLoadingContent", first: true, predicate: CustomLoadingContentTemplateDirective, descendants: true }, { propertyName: "customNoPermissionsTemplate", first: true, predicate: CustomNoPermissionTemplateDirective, descendants: true }, { propertyName: "customNoContentTemplate", first: true, predicate: CustomEmptyContentTemplateDirective, descendants: true }], viewQueries: [{ propertyName: "dataTable", first: true, predicate: ["dataTable"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<adf-datatable\n    #dataTable\n    [selectionMode]=\"selectionMode\"\n    [data]=\"data\"\n    [actions]=\"contentActions\"\n    [actionsPosition]=\"contentActionsPosition\"\n    [multiselect]=\"multiselect\"\n    [contextMenu]=\"contextMenuActions\"\n    [rowStyle]=\"rowStyle\"\n    [rowStyleClass]=\"rowStyleClass\"\n    [loading]=\"loading\"\n    [display]=\"display\"\n    [noPermission]=\"noPermission\"\n    [showHeader]=\"showHeader\"\n    [rowMenuCacheEnabled]=\"false\"\n    [stickyHeader]=\"stickyHeader\"\n    [allowFiltering]=\"allowFiltering\"\n    (showRowContextMenu)=\"onShowRowContextMenu($event)\"\n    (showRowActionsMenu)=\"onShowRowActionsMenu($event)\"\n    (executeRowAction)=\"onExecuteRowAction($event)\"\n    (rowClick)=\"onNodeClick($event.value?.node)\"\n    (rowDblClick)=\"onNodeDblClick($event.value?.node)\"\n    (row-select)=\"onNodeSelect($any($event).detail)\"\n    (row-unselect)=\"onNodeUnselect($any($event).detail)\"\n    (sorting-changed)=\"onSortingChanged($any($event))\"\n    [class.adf-datatable-gallery-thumbnails]=\"data.thumbnails\">\n\n    <div *ngIf=\"headerFilters\">\n        <adf-filter-header\n            [currentFolderId]=\"currentFolderId\"\n            [value]=\"filterValue\"\n            (filterSelection)=\"onFilterSelectionChange($event)\">\n        </adf-filter-header>\n    </div>\n\n    <adf-no-content-template>\n        <ng-template>\n            <adf-empty-list *ngIf=\"!customNoContentTemplate\">\n                <div class=\"adf-empty-list_template adf-empty-folder\">\n                    <div class=\"adf-empty-folder-this-space-is-empty\">{{'ADF-DOCUMENT-LIST.EMPTY.HEADER' | translate}}</div>\n                    <div class=\"adf-empty-folder-drag-drop\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate }}</div>\n                    <div class=\"adf-empty-folder-any-files-here-to-add\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.SUBTITLE' | translate }}</div>\n                    <img [alt]=\"'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate\" class=\"adf-empty-folder-image\" [src]=\"emptyFolderImageUrl\">\n                </div>\n            </adf-empty-list>\n            <ng-content select=\"adf-custom-empty-content-template, empty-folder-content\"></ng-content>\n        </ng-template>\n    </adf-no-content-template>\n\n    <adf-no-permission-template>\n        <ng-template>\n            <div class=\"adf-no-permission__template\" *ngIf=\"!customNoPermissionsTemplate\">\n                <mat-icon>error</mat-icon>\n                <p class=\"adf-no-permission__template--text\">{{ 'ADF-DOCUMENT-LIST.NO_PERMISSION' | translate }}</p>\n            </div>\n            <ng-content select=\"adf-custom-no-permission-template, no-permission-content\"></ng-content>\n        </ng-template>\n    </adf-no-permission-template>\n\n    <adf-loading-content-template>\n        <ng-template>\n            <div class=\"adf-document-list-loading-container\" *ngIf=\"!customLoadingContent\">\n                <mat-progress-spinner\n                    id=\"adf-document-list-loading\"\n                    class=\"adf-document-list-loading-margin\"\n                    [attr.aria-label]=\"'ADF-DOCUMENT-LIST.LOADER_LABEL' | translate\"\n                    [color]=\"'primary'\"\n                    [mode]=\"'indeterminate'\">\n                </mat-progress-spinner>\n            </div>\n            <ng-content select=\"adf-custom-loading-content-template\"></ng-content>\n        </ng-template>\n    </adf-loading-content-template>\n\n</adf-datatable>\n", styles: [".adf-document-list{min-height:0;height:100%;background-color:var(--theme-background-color)}.mat-icon.adf-datatable-selected{height:100%;width:100%;margin-left:-2px;margin-top:2px}.adf-sticky-document-list{height:310px;overflow-y:auto}.adf-datatable-card .adf-datatable-selected>svg{fill:var(--theme-accent-color);width:30px;height:30px;position:absolute;top:10px}.adf-datatable-list .adf-datatable-selected>svg{fill:var(--theme-accent-color);width:30px;height:30px}.adf-document-list_empty_template{text-align:center;margin-top:20px;margin-bottom:20px}.adf-no-permission__template{display:flex;align-items:center;justify-content:center;flex-direction:column;width:100%;height:100%;min-height:300px}.adf-no-permission__template mat-icon{font-size:52px;height:52px;width:52px}.adf-no-permission__template--text{color:var(--adf-theme-foreground-text-color);font-size:var(--theme-subheading-2-font-size)}.adf-document-list__this-space-is-empty{height:32px;opacity:.26;font-size:var(--theme-headline-font-size);line-height:1.33;letter-spacing:-1px;color:var(--adf-theme-foreground-text-color)}.adf-document-list__drag-drop{height:56px;opacity:.54;font-size:56px;line-height:1;letter-spacing:-2px;color:var(--adf-theme-foreground-text-color);margin-top:40px}.adf-document-list__any-files-here-to-add{height:24px;opacity:.54;font-size:var(--theme-subheading-2-font-size);line-height:1.5;letter-spacing:-.4px;color:var(--adf-theme-foreground-text-color);margin-top:17px}.adf-document-list__empty_doc_lib{width:565px;height:161px;object-fit:contain;margin-top:17px}.adf-document-list-loading-margin{margin:auto}.adf-document-list-loading-container{min-height:300px;display:flex;flex-direction:row;height:100%}.adf-empty-list-header{height:32px;opacity:.26!important;font-size:var(--theme-headline-font-size);line-height:1.33;letter-spacing:-1px;color:var(--adf-theme-foreground-text-color)}.adf-documentlist-pagination{color:var(--adf-theme-foreground-text-color)}.adf-documentlist-pagination .adf-pagination__block{border-right:none}.adf-empty-folder-this-space-is-empty{height:32px;font-size:var(--theme-headline-font-size);line-height:1.33;letter-spacing:-1px;color:var(--adf-theme-foreground-text-color-054)}.adf-empty-folder-drag-drop{min-height:56px;font-size:53px;line-height:1;letter-spacing:-2px;color:var(--adf-theme-foreground-text-color);margin-top:40px;word-break:break-all;white-space:pre-line}@media screen and (max-width: 599px){.adf-empty-folder-drag-drop{font-size:48px}}.adf-empty-folder-any-files-here-to-add{min-height:24px;font-size:var(--theme-subheading-2-font-size);line-height:1.5;letter-spacing:-.4px;color:var(--adf-theme-foreground-text-color);margin-top:17px;word-break:break-all;white-space:pre-line}.adf-empty-folder-image{width:565px;max-width:100%;object-fit:contain;margin-top:17px}@media screen and (max-width: 599px){.adf-empty-folder-image{width:250px}}@media screen and (max-width: 960px){.adf-empty-folder-drag-drop,.adf-empty-folder-any-files-here-to-add{display:none}}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row{height:300px!important}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row img{height:130px}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row .adf-datatable-cell{overflow:visible}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row .adf-datatable-cell.adf-datatable-cell--image{flex:0 0 auto;display:flex;flex-direction:column-reverse;justify-content:space-between}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row .adf-datatable-cell.adf-datatable-cell--image .adf-cell-value{display:flex;justify-content:center}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i9.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: i1.DataTableComponent, selector: "adf-datatable", inputs: ["data", "display", "rows", "sorting", "columns", "selectionMode", "multiselect", "mainTableAction", "actions", "showMainDatatableActions", "actionsPosition", "actionsVisibleOnHover", "fallbackThumbnail", "contextMenu", "rowStyle", "rowStyleClass", "showHeader", "stickyHeader", "loading", "noPermission", "rowMenuCacheEnabled", "resolverFn", "allowFiltering", "isResizingEnabled"], outputs: ["rowClick", "rowDblClick", "showRowContextMenu", "showRowActionsMenu", "executeRowAction", "columnOrderChanged", "columnsWidthChanged"] }, { kind: "component", type: i1.EmptyListComponent, selector: "adf-empty-list" }, { kind: "directive", type: i1.NoContentTemplateDirective, selector: "adf-no-content-template, no-content-template" }, { kind: "directive", type: i1.NoPermissionTemplateDirective, selector: "adf-no-permission-template, no-permission-template" }, { kind: "directive", type: i1.LoadingContentTemplateDirective, selector: "adf-loading-content-template, loading-content-template" }, { kind: "component", type: FilterHeaderComponent, selector: "adf-filter-header", inputs: ["value", "currentFolderId"], outputs: ["filterSelection"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-document-list', providers: [{
                            provide: ADF_DOCUMENT_PARENT_COMPONENT,
                            useExisting: DocumentListComponent
                        }, DataTableService], encapsulation: ViewEncapsulation.None, host: { class: 'adf-document-list' }, template: "<adf-datatable\n    #dataTable\n    [selectionMode]=\"selectionMode\"\n    [data]=\"data\"\n    [actions]=\"contentActions\"\n    [actionsPosition]=\"contentActionsPosition\"\n    [multiselect]=\"multiselect\"\n    [contextMenu]=\"contextMenuActions\"\n    [rowStyle]=\"rowStyle\"\n    [rowStyleClass]=\"rowStyleClass\"\n    [loading]=\"loading\"\n    [display]=\"display\"\n    [noPermission]=\"noPermission\"\n    [showHeader]=\"showHeader\"\n    [rowMenuCacheEnabled]=\"false\"\n    [stickyHeader]=\"stickyHeader\"\n    [allowFiltering]=\"allowFiltering\"\n    (showRowContextMenu)=\"onShowRowContextMenu($event)\"\n    (showRowActionsMenu)=\"onShowRowActionsMenu($event)\"\n    (executeRowAction)=\"onExecuteRowAction($event)\"\n    (rowClick)=\"onNodeClick($event.value?.node)\"\n    (rowDblClick)=\"onNodeDblClick($event.value?.node)\"\n    (row-select)=\"onNodeSelect($any($event).detail)\"\n    (row-unselect)=\"onNodeUnselect($any($event).detail)\"\n    (sorting-changed)=\"onSortingChanged($any($event))\"\n    [class.adf-datatable-gallery-thumbnails]=\"data.thumbnails\">\n\n    <div *ngIf=\"headerFilters\">\n        <adf-filter-header\n            [currentFolderId]=\"currentFolderId\"\n            [value]=\"filterValue\"\n            (filterSelection)=\"onFilterSelectionChange($event)\">\n        </adf-filter-header>\n    </div>\n\n    <adf-no-content-template>\n        <ng-template>\n            <adf-empty-list *ngIf=\"!customNoContentTemplate\">\n                <div class=\"adf-empty-list_template adf-empty-folder\">\n                    <div class=\"adf-empty-folder-this-space-is-empty\">{{'ADF-DOCUMENT-LIST.EMPTY.HEADER' | translate}}</div>\n                    <div class=\"adf-empty-folder-drag-drop\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate }}</div>\n                    <div class=\"adf-empty-folder-any-files-here-to-add\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.SUBTITLE' | translate }}</div>\n                    <img [alt]=\"'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate\" class=\"adf-empty-folder-image\" [src]=\"emptyFolderImageUrl\">\n                </div>\n            </adf-empty-list>\n            <ng-content select=\"adf-custom-empty-content-template, empty-folder-content\"></ng-content>\n        </ng-template>\n    </adf-no-content-template>\n\n    <adf-no-permission-template>\n        <ng-template>\n            <div class=\"adf-no-permission__template\" *ngIf=\"!customNoPermissionsTemplate\">\n                <mat-icon>error</mat-icon>\n                <p class=\"adf-no-permission__template--text\">{{ 'ADF-DOCUMENT-LIST.NO_PERMISSION' | translate }}</p>\n            </div>\n            <ng-content select=\"adf-custom-no-permission-template, no-permission-content\"></ng-content>\n        </ng-template>\n    </adf-no-permission-template>\n\n    <adf-loading-content-template>\n        <ng-template>\n            <div class=\"adf-document-list-loading-container\" *ngIf=\"!customLoadingContent\">\n                <mat-progress-spinner\n                    id=\"adf-document-list-loading\"\n                    class=\"adf-document-list-loading-margin\"\n                    [attr.aria-label]=\"'ADF-DOCUMENT-LIST.LOADER_LABEL' | translate\"\n                    [color]=\"'primary'\"\n                    [mode]=\"'indeterminate'\">\n                </mat-progress-spinner>\n            </div>\n            <ng-content select=\"adf-custom-loading-content-template\"></ng-content>\n        </ng-template>\n    </adf-loading-content-template>\n\n</adf-datatable>\n", styles: [".adf-document-list{min-height:0;height:100%;background-color:var(--theme-background-color)}.mat-icon.adf-datatable-selected{height:100%;width:100%;margin-left:-2px;margin-top:2px}.adf-sticky-document-list{height:310px;overflow-y:auto}.adf-datatable-card .adf-datatable-selected>svg{fill:var(--theme-accent-color);width:30px;height:30px;position:absolute;top:10px}.adf-datatable-list .adf-datatable-selected>svg{fill:var(--theme-accent-color);width:30px;height:30px}.adf-document-list_empty_template{text-align:center;margin-top:20px;margin-bottom:20px}.adf-no-permission__template{display:flex;align-items:center;justify-content:center;flex-direction:column;width:100%;height:100%;min-height:300px}.adf-no-permission__template mat-icon{font-size:52px;height:52px;width:52px}.adf-no-permission__template--text{color:var(--adf-theme-foreground-text-color);font-size:var(--theme-subheading-2-font-size)}.adf-document-list__this-space-is-empty{height:32px;opacity:.26;font-size:var(--theme-headline-font-size);line-height:1.33;letter-spacing:-1px;color:var(--adf-theme-foreground-text-color)}.adf-document-list__drag-drop{height:56px;opacity:.54;font-size:56px;line-height:1;letter-spacing:-2px;color:var(--adf-theme-foreground-text-color);margin-top:40px}.adf-document-list__any-files-here-to-add{height:24px;opacity:.54;font-size:var(--theme-subheading-2-font-size);line-height:1.5;letter-spacing:-.4px;color:var(--adf-theme-foreground-text-color);margin-top:17px}.adf-document-list__empty_doc_lib{width:565px;height:161px;object-fit:contain;margin-top:17px}.adf-document-list-loading-margin{margin:auto}.adf-document-list-loading-container{min-height:300px;display:flex;flex-direction:row;height:100%}.adf-empty-list-header{height:32px;opacity:.26!important;font-size:var(--theme-headline-font-size);line-height:1.33;letter-spacing:-1px;color:var(--adf-theme-foreground-text-color)}.adf-documentlist-pagination{color:var(--adf-theme-foreground-text-color)}.adf-documentlist-pagination .adf-pagination__block{border-right:none}.adf-empty-folder-this-space-is-empty{height:32px;font-size:var(--theme-headline-font-size);line-height:1.33;letter-spacing:-1px;color:var(--adf-theme-foreground-text-color-054)}.adf-empty-folder-drag-drop{min-height:56px;font-size:53px;line-height:1;letter-spacing:-2px;color:var(--adf-theme-foreground-text-color);margin-top:40px;word-break:break-all;white-space:pre-line}@media screen and (max-width: 599px){.adf-empty-folder-drag-drop{font-size:48px}}.adf-empty-folder-any-files-here-to-add{min-height:24px;font-size:var(--theme-subheading-2-font-size);line-height:1.5;letter-spacing:-.4px;color:var(--adf-theme-foreground-text-color);margin-top:17px;word-break:break-all;white-space:pre-line}.adf-empty-folder-image{width:565px;max-width:100%;object-fit:contain;margin-top:17px}@media screen and (max-width: 599px){.adf-empty-folder-image{width:250px}}@media screen and (max-width: 960px){.adf-empty-folder-drag-drop,.adf-empty-folder-any-files-here-to-add{display:none}}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row{height:300px!important}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row img{height:130px}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row .adf-datatable-cell{overflow:visible}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row .adf-datatable-cell.adf-datatable-cell--image{flex:0 0 auto;display:flex;flex-direction:column-reverse;justify-content:space-between}.adf-datatable-gallery-thumbnails .adf-datatable-card .adf-datatable-row .adf-datatable-cell.adf-datatable-cell--image .adf-cell-value{display:flex;justify-content:center}\n"] }]
        }], ctorParameters: function () { return [{ type: DocumentListService }, { type: i0.ElementRef }, { type: i1.AppConfigService }, { type: i1.UserPreferencesService }, { type: ContentService }, { type: i1.ThumbnailService }, { type: i1.AlfrescoApiService }, { type: NodesApiService }, { type: i1.DataTableService }, { type: LockService }, { type: i1$1.MatDialog }]; }, propDecorators: { columnList: [{
                type: ContentChild,
                args: [DataColumnListComponent]
            }], customLoadingContent: [{
                type: ContentChild,
                args: [CustomLoadingContentTemplateDirective]
            }], customNoPermissionsTemplate: [{
                type: ContentChild,
                args: [CustomNoPermissionTemplateDirective]
            }], customNoContentTemplate: [{
                type: ContentChild,
                args: [CustomEmptyContentTemplateDirective]
            }], includeFields: [{
                type: Input
            }], where: [{
                type: Input
            }], display: [{
                type: Input
            }], permissionsStyle: [{
                type: Input
            }], locationFormat: [{
                type: Input
            }], navigate: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], navigationMode: [{
                type: Input
            }], thumbnails: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], multiselect: [{
                type: Input
            }], contentActions: [{
                type: Input
            }], contentActionsPosition: [{
                type: Input
            }], contextMenuActions: [{
                type: Input
            }], emptyFolderImageUrl: [{
                type: Input
            }], allowDropFiles: [{
                type: Input
            }], sorting: [{
                type: Input
            }], additionalSorting: [{
                type: Input
            }], sortingMode: [{
                type: Input
            }], rowStyle: [{
                type: Input
            }], rowStyleClass: [{
                type: Input
            }], loading: [{
                type: Input
            }], _rowFilter: [{
                type: Input
            }], rowFilter: [{
                type: Input
            }], imageResolver: [{
                type: Input
            }], stickyHeader: [{
                type: Input
            }], headerFilters: [{
                type: Input
            }], filterValue: [{
                type: Input
            }], currentFolderId: [{
                type: Input
            }], preselectNodes: [{
                type: Input
            }], node: [{
                type: Input
            }], maxItems: [{
                type: Input
            }], nodeClick: [{
                type: Output
            }], nodeDblClick: [{
                type: Output
            }], folderChange: [{
                type: Output
            }], preview: [{
                type: Output
            }], ready: [{
                type: Output
            }], error: [{
                type: Output
            }], nodeSelected: [{
                type: Output
            }], filterSelection: [{
                type: Output
            }], dataTable: [{
                type: ViewChild,
                args: ['dataTable', { static: true }]
            }], onShowContextMenu: [{
                type: HostListener,
                args: ['contextmenu', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BreadcrumbComponent {
    constructor() {
        /** Active node, builds UI based on folderNode.path.elements collection. */
        this.folderNode = null;
        /** (optional) Name of the root element of the breadcrumb. You can use
         * this property to rename "Company Home" to "Personal Files" for
         * example. You can use an i18n resource key for the property value.
         */
        this.root = null;
        /** (optional) The id of the root element. You can use this property
         * to set a custom element the breadcrumb should start with.
         */
        this.rootId = null;
        this.route = [];
        this.onDestroy$ = new Subject();
        /** If true, prevents the user from navigating away from the active node. */
        this.readOnly = false;
        /** Emitted when the user clicks on a breadcrumb. */
        this.navigate = new EventEmitter();
    }
    get hasRoot() {
        return !!this.root;
    }
    ngOnInit() {
        this.transform = this.transform ? this.transform : null;
        if (this.target) {
            this.target.$folderNode
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((folderNode) => {
                this.folderNode = folderNode;
                this.recalculateNodes();
            });
        }
    }
    ngOnChanges() {
        this.recalculateNodes();
    }
    recalculateNodes() {
        const node = this.transform ? this.transform(this.folderNode) : this.folderNode;
        this.route = this.parseRoute(node);
        if (this.maxItems && this.route.length > this.maxItems) {
            this.lastNodes = this.route.slice(this.route.length - this.maxItems);
            this.previousNodes = this.route.slice(0, this.route.length - this.maxItems);
            this.previousNodes.reverse();
        }
        else {
            this.lastNodes = this.route;
            this.previousNodes = null;
        }
    }
    open() {
        if (this.dropdown) {
            this.dropdown.open();
            this.dropdown.focus();
        }
    }
    hasPreviousNodes() {
        return !!this.previousNodes;
    }
    parseRoute(node) {
        if (node && node.path) {
            const route = (node.path.elements || []).slice();
            route.push({
                id: node.id,
                name: node.name,
                node
            });
            const rootPos = this.getElementPosition(route, this.rootId);
            if (rootPos > 0) {
                route.splice(0, rootPos);
            }
            if (rootPos === -1 && this.rootId) {
                route[0].id = this.rootId;
            }
            if (this.root) {
                route[0].name = this.root;
            }
            return route;
        }
        return [];
    }
    getElementPosition(route, nodeId) {
        let position = -1;
        if (route && route.length > 0 && nodeId) {
            position = route.findIndex((el) => el.id === nodeId);
        }
        return position;
    }
    breadcrumbItemIsAnchor(lastItem) {
        return !this.readOnly && !lastItem;
    }
    onRoutePathClick(route, event) {
        if (event && event.type === 'click') {
            event.preventDefault();
        }
        this.onRouteClick(route);
    }
    onRouteClick(route) {
        if (route && !this.readOnly) {
            this.navigate.emit(route);
            if (this.target) {
                this.target.navigateTo(route.id);
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
BreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BreadcrumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: BreadcrumbComponent, selector: "adf-breadcrumb", inputs: { folderNode: "folderNode", root: "root", rootId: "rootId", target: "target", transform: "transform", maxItems: "maxItems", readOnly: "readOnly" }, outputs: { navigate: "navigate" }, host: { classAttribute: "adf-breadcrumb" }, viewQueries: [{ propertyName: "dropdown", first: true, predicate: ["dropdown"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<nav\n    *ngIf=\"folderNode\"\n    data-automation-id=\"breadcrumb\"\n    class=\"adf-breadcrumb-container\"\n    role=\"navigation\"\n    [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.BREADCRUMB' | translate\"\n>\n    <button\n        *ngIf=\"hasPreviousNodes()\"\n        tabindex=\"0\"\n        class=\"adf-breadcrumb-dropdown-trigger\"\n        (click)=\"open()\"\n        [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.DROPDOWN' | translate\"\n    >\n        <div class=\"adf-breadcrumb-dropdown-trigger-icon\">\n            <mat-icon [class.adf-isRoot]=\"!hasPreviousNodes()\">folder</mat-icon>\n            <mat-icon\n                [class.adf-isRoot]=\"!hasPreviousNodes()\"\n                class=\"adf-breadcrumb-dropdown-trigger-arrow\"\n                >arrow_drop_down</mat-icon\n            >\n        </div>\n    </button>\n\n    <mat-select\n        #dropdown\n        *ngIf=\"hasPreviousNodes()\"\n        class=\"adf-breadcrumb-dropdown-path\"\n        tabindex=\"-1\"\n    >\n        <mat-option\n            *ngFor=\"let node of previousNodes\"\n            (click)=\"onRoutePathClick(node, $event)\"\n            (onSelectionChange)=\"onRouteClick(node)\"\n            class=\"adf-breadcrumb-path-option\"\n            [disabled]=\"readOnly\"\n        >\n            {{ node.name | translate }}\n        </mat-option>\n    </mat-select>\n\n    <div\n        *ngFor=\"let item of lastNodes; let last = last\"\n        [class.adf-active]=\"last\"\n        [ngSwitch]=\"breadcrumbItemIsAnchor(last)\"\n        title=\"{{ item.name | translate }}\"\n        class=\"adf-breadcrumb-item\">\n        <a\n            *ngSwitchCase=\"true\"\n            href=\"#\"\n            [attr.data-automation-id]=\"'breadcrumb_' + item.name\"\n            class=\"adf-breadcrumb-item-anchor\"\n            (click)=\"onRoutePathClick(item, $event)\"\n        >\n            {{ item.name | translate }}\n        </a>\n\n        <div *ngSwitchDefault class=\"adf-breadcrumb-item-current\" aria-current=\"location\">\n            {{ item.name | translate }}\n        </div>\n\n        <mat-icon class=\"adf-breadcrumb-item-chevron\" *ngIf=\"!last\">\n            chevron_right\n        </mat-icon>\n    </div>\n</nav>\n\n<nav\n    *ngIf=\"!folderNode && hasRoot\"\n    data-automation-id=\"breadcrumb\"\n    role=\"navigation\"\n    [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.BREADCRUMB' | translate\"\n>\n    <div class=\"adf-breadcrumb-item adf-active\" role=\"group\">\n        <div class=\"adf-breadcrumb-item-current\">\n            {{ root | translate }}\n        </div>\n    </div>\n</nav>\n", styles: [".adf-breadcrumb{display:flex;flex:1;line-height:24px;font-size:var(--theme-body-1-font-size);font-weight:600;letter-spacing:-.2px;color:var(--adf-theme-foreground-text-color-054);overflow:hidden}.adf-breadcrumb-container{margin:0;padding:0;list-style-type:none;cursor:default;display:flex;overflow:hidden}.adf-breadcrumb-dropdown-path{width:0;height:0;overflow:hidden;margin-top:35px}.adf-breadcrumb-dropdown-path.mat-select{width:0}.adf-breadcrumb-dropdown-trigger{cursor:pointer;padding:0;border:none;background:transparent;width:30px;margin-top:2px;margin-right:5px}.adf-breadcrumb-dropdown-trigger:focus{color:var(--theme-primary-color);outline:none}.adf-breadcrumb-dropdown-trigger-icon{position:relative}.adf-breadcrumb-dropdown-trigger-arrow{font-size:var(--theme-adf-icon-1-font-size);position:absolute;left:4px;top:4px;color:#fff;z-index:2}.adf-breadcrumb-dropdown-trigger-arrow.adf-isRoot{visibility:hidden}.adf-breadcrumb-dropdown-trigger-arrow.adf-focus{border:none}.adf-breadcrumb-dropdown-trigger.adf-isRoot{cursor:not-allowed}.adf-breadcrumb-item{padding-right:2px;overflow:hidden;display:flex;line-height:33px;font-size:var(--theme-body-1-font-size);font-weight:600;letter-spacing:-.2px;text-align:left;color:var(--adf-theme-foreground-text-color-054);flex:0 1 auto;min-width:35px;margin-top:auto;text-overflow:ellipsis}.adf-breadcrumb-item:hover,.adf-breadcrumb-item.adf-active{color:var(--adf-theme-foreground-text-color-064)}.adf-breadcrumb-item.adf-active{color:var(--adf-theme-foreground-text-color-087)}.adf-breadcrumb-item-chevron{opacity:1;margin-top:9px;font-size:var(--theme-adf-icon-1-font-size)}.adf-breadcrumb-item.mat-primary{color:var(--theme-primary-color)}.adf-breadcrumb-item.mat-accent{color:var(--theme-accent-color)}.adf-breadcrumb-item.mat-warn{color:var(--theme-warn-color)}.adf-breadcrumb-item-anchor{box-sizing:border-box;color:inherit;text-decoration:none;display:inline-block;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;flex:0 1 auto;padding:0 2px;text-align:center}.adf-breadcrumb-item-anchor:focus{outline:1px solid var(--theme-accent-color-a200);outline-offset:-1px}.adf-breadcrumb-item-current{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i2$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i1$2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-breadcrumb', encapsulation: ViewEncapsulation.None, host: { class: 'adf-breadcrumb' }, template: "<nav\n    *ngIf=\"folderNode\"\n    data-automation-id=\"breadcrumb\"\n    class=\"adf-breadcrumb-container\"\n    role=\"navigation\"\n    [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.BREADCRUMB' | translate\"\n>\n    <button\n        *ngIf=\"hasPreviousNodes()\"\n        tabindex=\"0\"\n        class=\"adf-breadcrumb-dropdown-trigger\"\n        (click)=\"open()\"\n        [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.DROPDOWN' | translate\"\n    >\n        <div class=\"adf-breadcrumb-dropdown-trigger-icon\">\n            <mat-icon [class.adf-isRoot]=\"!hasPreviousNodes()\">folder</mat-icon>\n            <mat-icon\n                [class.adf-isRoot]=\"!hasPreviousNodes()\"\n                class=\"adf-breadcrumb-dropdown-trigger-arrow\"\n                >arrow_drop_down</mat-icon\n            >\n        </div>\n    </button>\n\n    <mat-select\n        #dropdown\n        *ngIf=\"hasPreviousNodes()\"\n        class=\"adf-breadcrumb-dropdown-path\"\n        tabindex=\"-1\"\n    >\n        <mat-option\n            *ngFor=\"let node of previousNodes\"\n            (click)=\"onRoutePathClick(node, $event)\"\n            (onSelectionChange)=\"onRouteClick(node)\"\n            class=\"adf-breadcrumb-path-option\"\n            [disabled]=\"readOnly\"\n        >\n            {{ node.name | translate }}\n        </mat-option>\n    </mat-select>\n\n    <div\n        *ngFor=\"let item of lastNodes; let last = last\"\n        [class.adf-active]=\"last\"\n        [ngSwitch]=\"breadcrumbItemIsAnchor(last)\"\n        title=\"{{ item.name | translate }}\"\n        class=\"adf-breadcrumb-item\">\n        <a\n            *ngSwitchCase=\"true\"\n            href=\"#\"\n            [attr.data-automation-id]=\"'breadcrumb_' + item.name\"\n            class=\"adf-breadcrumb-item-anchor\"\n            (click)=\"onRoutePathClick(item, $event)\"\n        >\n            {{ item.name | translate }}\n        </a>\n\n        <div *ngSwitchDefault class=\"adf-breadcrumb-item-current\" aria-current=\"location\">\n            {{ item.name | translate }}\n        </div>\n\n        <mat-icon class=\"adf-breadcrumb-item-chevron\" *ngIf=\"!last\">\n            chevron_right\n        </mat-icon>\n    </div>\n</nav>\n\n<nav\n    *ngIf=\"!folderNode && hasRoot\"\n    data-automation-id=\"breadcrumb\"\n    role=\"navigation\"\n    [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.BREADCRUMB' | translate\"\n>\n    <div class=\"adf-breadcrumb-item adf-active\" role=\"group\">\n        <div class=\"adf-breadcrumb-item-current\">\n            {{ root | translate }}\n        </div>\n    </div>\n</nav>\n", styles: [".adf-breadcrumb{display:flex;flex:1;line-height:24px;font-size:var(--theme-body-1-font-size);font-weight:600;letter-spacing:-.2px;color:var(--adf-theme-foreground-text-color-054);overflow:hidden}.adf-breadcrumb-container{margin:0;padding:0;list-style-type:none;cursor:default;display:flex;overflow:hidden}.adf-breadcrumb-dropdown-path{width:0;height:0;overflow:hidden;margin-top:35px}.adf-breadcrumb-dropdown-path.mat-select{width:0}.adf-breadcrumb-dropdown-trigger{cursor:pointer;padding:0;border:none;background:transparent;width:30px;margin-top:2px;margin-right:5px}.adf-breadcrumb-dropdown-trigger:focus{color:var(--theme-primary-color);outline:none}.adf-breadcrumb-dropdown-trigger-icon{position:relative}.adf-breadcrumb-dropdown-trigger-arrow{font-size:var(--theme-adf-icon-1-font-size);position:absolute;left:4px;top:4px;color:#fff;z-index:2}.adf-breadcrumb-dropdown-trigger-arrow.adf-isRoot{visibility:hidden}.adf-breadcrumb-dropdown-trigger-arrow.adf-focus{border:none}.adf-breadcrumb-dropdown-trigger.adf-isRoot{cursor:not-allowed}.adf-breadcrumb-item{padding-right:2px;overflow:hidden;display:flex;line-height:33px;font-size:var(--theme-body-1-font-size);font-weight:600;letter-spacing:-.2px;text-align:left;color:var(--adf-theme-foreground-text-color-054);flex:0 1 auto;min-width:35px;margin-top:auto;text-overflow:ellipsis}.adf-breadcrumb-item:hover,.adf-breadcrumb-item.adf-active{color:var(--adf-theme-foreground-text-color-064)}.adf-breadcrumb-item.adf-active{color:var(--adf-theme-foreground-text-color-087)}.adf-breadcrumb-item-chevron{opacity:1;margin-top:9px;font-size:var(--theme-adf-icon-1-font-size)}.adf-breadcrumb-item.mat-primary{color:var(--theme-primary-color)}.adf-breadcrumb-item.mat-accent{color:var(--theme-accent-color)}.adf-breadcrumb-item.mat-warn{color:var(--theme-warn-color)}.adf-breadcrumb-item-anchor{box-sizing:border-box;color:inherit;text-decoration:none;display:inline-block;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;flex:0 1 auto;padding:0 2px;text-align:center}.adf-breadcrumb-item-anchor:focus{outline:1px solid var(--theme-accent-color-a200);outline-offset:-1px}.adf-breadcrumb-item-current{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}\n"] }]
        }], propDecorators: { folderNode: [{
                type: Input
            }], root: [{
                type: Input
            }], rootId: [{
                type: Input
            }], target: [{
                type: Input
            }], transform: [{
                type: Input
            }], dropdown: [{
                type: ViewChild,
                args: ['dropdown']
            }], maxItems: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], navigate: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DropdownBreadcrumbComponent extends BreadcrumbComponent {
    /**
     * Calculate the current and previous nodes from the route array
     */
    recalculateNodes() {
        const node = this.transform ? this.transform(this.folderNode) : this.folderNode;
        this.route = this.parseRoute(node);
        this.currentNode = this.route[this.route.length - 1];
        this.previousNodes = this.route.slice(0, this.route.length - 1).reverse();
    }
    /**
     * Opens the node picker menu
     */
    open() {
        if (this.dropdown) {
            this.dropdown.open();
            this.dropdown.focus();
        }
    }
    /**
     * Return if route has more than one element (means: we are not in the root directory)
     */
    hasPreviousNodes() {
        return this.previousNodes.length > 0;
    }
}
DropdownBreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DropdownBreadcrumbComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
DropdownBreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DropdownBreadcrumbComponent, selector: "adf-dropdown-breadcrumb", host: { classAttribute: "adf-dropdown-breadcrumb" }, viewQueries: [{ propertyName: "dropdown", first: true, predicate: ["dropdown"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<nav *ngIf=\"route.length > 0\" class=\"adf-dropdown-breadcrumb-container\"\n     role=\"navigation\"\n     [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.BREADCRUMB' | translate\">\n\n    <button\n        id=\"dropdown-breadcrumb-button\"\n        [tabindex]=\"hasPreviousNodes() ? 0 : -1\"\n        class=\"adf-dropdown-breadcrumb-trigger\"\n        (click)=\"open()\"\n        [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.DROPDOWN' | translate\"\n        data-automation-id=\"dropdown-breadcrumb-trigger\">\n        <mat-icon [class.adf-isRoot]=\"!hasPreviousNodes()\">folder</mat-icon>\n    </button>\n\n    <mat-icon class=\"adf-dropdown-breadcrumb-item-chevron\">chevron_right</mat-icon>\n\n    <div class=\"adf-dropdown-breadcrumb-path\">\n        <mat-select\n            #dropdown\n            *ngIf=\"hasPreviousNodes()\"\n            tabindex=\"-1\"\n            data-automation-id=\"dropdown-breadcrumb-path\"\n            aria-labelledby=\"dropdown-breadcrumb-button\">\n\n            <mat-option\n                *ngFor=\"let node of previousNodes;\"\n                (click)=\"onRoutePathClick(node, $event)\"\n                (onSelectionChange)=\"onRouteClick(node)\"\n                class=\"adf-dropdown-breadcrumb-path-option\"\n                data-automation-class=\"dropdown-breadcrumb-path-option\"\n                [disabled]=\"readOnly\">\n                {{ node.name | translate }}\n            </mat-option>\n        </mat-select>\n    </div>\n\n    <span\n        class=\"adf-current-folder\"\n        [class.adf-isRoot]=\"!hasPreviousNodes()\"\n        data-automation-id=\"current-folder\"\n        aria-current=\"location\">{{ currentNode.name }}\n    </span>\n</nav>\n", styles: [".adf-dropdown-breadcrumb{display:flex;flex:1;line-height:24px;font-size:var(--theme-body-1-font-size);font-weight:600;letter-spacing:-.2px;color:var(--adf-theme-foreground-text-color-054);overflow:hidden;margin-top:10px}.adf-dropdown-breadcrumb .mat-icon{height:35px}.adf-dropdown-breadcrumb-container{margin:0;padding:0;list-style-type:none;cursor:default;display:flex;overflow:hidden}.adf-dropdown-breadcrumb-trigger{cursor:pointer;padding:0;border:none;background:transparent;width:25px}.adf-dropdown-breadcrumb-trigger:focus{color:var(--theme-primary-color);outline:none}.adf-dropdown-breadcrumb-trigger.adf-isRoot{cursor:not-allowed}.adf-dropdown-breadcrumb-path{width:0;height:0;overflow:hidden;margin-top:35px}.adf-dropdown-breadcrumb-path.mat-select{width:0}.adf-current-folder{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;width:75%;color:var(--adf-theme-foreground-text-color)}.adf-dropdown-breadcrumb-path-option.mat-option{height:28px;line-height:28px;padding:0 12px;font-size:var(--theme-caption-font-size)}.adf-dropdown-breadcrumb-path-option.mat-option:first-child{padding-top:4px}.adf-dropdown-breadcrumb-path-option.mat-option:last-child{padding-bottom:4px}[dir=ltr] .adf-dropdown-breadcrumb-path{margin-left:-30px}[dir=ltr] .adf-current-folder{margin-left:30px}[dir=rtl] .adf-dropdown-breadcrumb-path{margin-right:-30px}[dir=rtl] .adf-current-folder{margin-right:30px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i1$2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DropdownBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-dropdown-breadcrumb', encapsulation: ViewEncapsulation.None, host: { class: 'adf-dropdown-breadcrumb' }, template: "<nav *ngIf=\"route.length > 0\" class=\"adf-dropdown-breadcrumb-container\"\n     role=\"navigation\"\n     [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.BREADCRUMB' | translate\">\n\n    <button\n        id=\"dropdown-breadcrumb-button\"\n        [tabindex]=\"hasPreviousNodes() ? 0 : -1\"\n        class=\"adf-dropdown-breadcrumb-trigger\"\n        (click)=\"open()\"\n        [attr.aria-label]=\"'BREADCRUMB.ARIA-LABEL.DROPDOWN' | translate\"\n        data-automation-id=\"dropdown-breadcrumb-trigger\">\n        <mat-icon [class.adf-isRoot]=\"!hasPreviousNodes()\">folder</mat-icon>\n    </button>\n\n    <mat-icon class=\"adf-dropdown-breadcrumb-item-chevron\">chevron_right</mat-icon>\n\n    <div class=\"adf-dropdown-breadcrumb-path\">\n        <mat-select\n            #dropdown\n            *ngIf=\"hasPreviousNodes()\"\n            tabindex=\"-1\"\n            data-automation-id=\"dropdown-breadcrumb-path\"\n            aria-labelledby=\"dropdown-breadcrumb-button\">\n\n            <mat-option\n                *ngFor=\"let node of previousNodes;\"\n                (click)=\"onRoutePathClick(node, $event)\"\n                (onSelectionChange)=\"onRouteClick(node)\"\n                class=\"adf-dropdown-breadcrumb-path-option\"\n                data-automation-class=\"dropdown-breadcrumb-path-option\"\n                [disabled]=\"readOnly\">\n                {{ node.name | translate }}\n            </mat-option>\n        </mat-select>\n    </div>\n\n    <span\n        class=\"adf-current-folder\"\n        [class.adf-isRoot]=\"!hasPreviousNodes()\"\n        data-automation-id=\"current-folder\"\n        aria-current=\"location\">{{ currentNode.name }}\n    </span>\n</nav>\n", styles: [".adf-dropdown-breadcrumb{display:flex;flex:1;line-height:24px;font-size:var(--theme-body-1-font-size);font-weight:600;letter-spacing:-.2px;color:var(--adf-theme-foreground-text-color-054);overflow:hidden;margin-top:10px}.adf-dropdown-breadcrumb .mat-icon{height:35px}.adf-dropdown-breadcrumb-container{margin:0;padding:0;list-style-type:none;cursor:default;display:flex;overflow:hidden}.adf-dropdown-breadcrumb-trigger{cursor:pointer;padding:0;border:none;background:transparent;width:25px}.adf-dropdown-breadcrumb-trigger:focus{color:var(--theme-primary-color);outline:none}.adf-dropdown-breadcrumb-trigger.adf-isRoot{cursor:not-allowed}.adf-dropdown-breadcrumb-path{width:0;height:0;overflow:hidden;margin-top:35px}.adf-dropdown-breadcrumb-path.mat-select{width:0}.adf-current-folder{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;width:75%;color:var(--adf-theme-foreground-text-color)}.adf-dropdown-breadcrumb-path-option.mat-option{height:28px;line-height:28px;padding:0 12px;font-size:var(--theme-caption-font-size)}.adf-dropdown-breadcrumb-path-option.mat-option:first-child{padding-top:4px}.adf-dropdown-breadcrumb-path-option.mat-option:last-child{padding-bottom:4px}[dir=ltr] .adf-dropdown-breadcrumb-path{margin-left:-30px}[dir=ltr] .adf-current-folder{margin-left:30px}[dir=rtl] .adf-dropdown-breadcrumb-path{margin-right:-30px}[dir=rtl] .adf-current-folder{margin-right:30px}\n"] }]
        }], propDecorators: { dropdown: [{
                type: ViewChild,
                args: ['dropdown']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadFilesEvent {
    constructor(files, uploadService, successEmitter, errorEmitter) {
        this.files = files;
        this.uploadService = uploadService;
        this.successEmitter = successEmitter;
        this.errorEmitter = errorEmitter;
        this.isDefaultPrevented = false;
    }
    get defaultPrevented() {
        return this.isDefaultPrevented;
    }
    preventDefault() {
        this.isDefaultPrevented = true;
    }
    pauseUpload() {
        this.preventDefault();
    }
    resumeUpload() {
        if (this.files && this.files.length > 0) {
            this.uploadService.addToQueue(...this.files);
            this.uploadService.uploadFilesInTheQueue(this.successEmitter, this.errorEmitter);
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class UploadBase {
    constructor() {
        this.uploadService = inject(UploadService);
        this.translationService = inject(TranslationService);
        this.ngZone = inject(NgZone);
        /** The ID of the root. Use the nodeId for
         * Content Services or the taskId/processId for Process Services.
         */
        this.rootFolderId = '-root-';
        /** Toggles component disabled state (if there is no node permission checking). */
        this.disabled = false;
        /** Filter for accepted file types. */
        this.acceptedFilesType = '*';
        /** Toggles versioning. */
        this.versioning = false;
        /** majorVersion boolean field to true to indicate a major version should be created. */
        this.majorVersion = false;
        /** Custom node type for uploaded file */
        this.nodeType = 'cm:content';
        /** Emitted when the file is uploaded successfully. */
        this.success = new EventEmitter();
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
        /** Emitted when the upload begins. */
        this.beginUpload = new EventEmitter();
        /** Emitted when dropping a file over another file to update the version. */
        this.updateFileVersion = new EventEmitter();
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.uploadService.fileUploadError
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(error => this.error.emit(error));
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    /**
     * Upload a list of file in the specified path
     *
     * @param files
     */
    uploadFiles(files) {
        const filteredFiles = files
            .map((file) => this.createFileModel(file, this.rootFolderId, (file.webkitRelativePath || '').replace(/\/[^\/]*$/, '')));
        this.uploadQueue(filteredFiles);
    }
    uploadFilesInfo(files) {
        const filteredFiles = files
            .map((fileInfo) => this.createFileModel(fileInfo.file, this.rootFolderId, fileInfo.relativeFolder));
        this.uploadQueue(filteredFiles);
    }
    uploadQueue(files) {
        const filteredFiles = files
            .filter(this.isFileAcceptable.bind(this))
            .filter(this.isFileSizeAcceptable.bind(this));
        this.ngZone.run(() => {
            const event = new UploadFilesEvent([...filteredFiles], this.uploadService, this.success, this.error);
            this.beginUpload.emit(event);
            if (!event.defaultPrevented) {
                if (filteredFiles.length > 0) {
                    this.uploadService.addToQueue(...filteredFiles);
                    this.uploadService.uploadFilesInTheQueue(this.success, this.error);
                }
            }
        });
    }
    /**
     * Checks if the given file is allowed by the extension filters
     *
     * @param file FileModel
     */
    isFileAcceptable(file) {
        if (this.acceptedFilesType === '*') {
            return true;
        }
        const allowedExtensions = this.acceptedFilesType
            .split(',')
            .map((ext) => ext.trim().replace(/^\./, ''));
        return allowedExtensions.indexOf(file.extension) !== -1;
    }
    /**
     * Creates FileModel from File
     *
     * @param file
     * @param parentId
     * @param path
     * @param id
     */
    createFileModel(file, parentId, path, id) {
        return new FileModel(file, {
            comment: this.comment,
            majorVersion: this.majorVersion,
            newVersion: this.versioning,
            parentId,
            path,
            nodeType: this.nodeType
        }, id);
    }
    isFileSizeAllowed(file) {
        let isFileSizeAllowed = true;
        if (this.isMaxFileSizeDefined()) {
            isFileSizeAllowed = this.isFileSizeCorrect(file);
        }
        return isFileSizeAllowed;
    }
    isMaxFileSizeDefined() {
        return this.maxFilesSize !== undefined && this.maxFilesSize !== null;
    }
    isFileSizeCorrect(file) {
        return this.maxFilesSize >= 0 && file.size <= this.maxFilesSize;
    }
    /**
     * Checks if the given file is an acceptable size
     *
     * @param file FileModel
     */
    isFileSizeAcceptable(file) {
        let acceptableSize = true;
        if (!this.isFileSizeAllowed(file)) {
            acceptableSize = false;
            const message = this.translationService.instant('FILE_UPLOAD.MESSAGES.EXCEED_MAX_FILE_SIZE', { fileName: file.name });
            this.error.emit(message);
        }
        return acceptableSize;
    }
}
UploadBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadBase, deps: [], target: i0.ɵɵFactoryTarget.Directive });
UploadBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: UploadBase, inputs: { maxFilesSize: "maxFilesSize", rootFolderId: "rootFolderId", disabled: "disabled", acceptedFilesType: "acceptedFilesType", versioning: "versioning", majorVersion: "majorVersion", comment: "comment", nodeType: "nodeType" }, outputs: { success: "success", error: "error", beginUpload: "beginUpload", updateFileVersion: "updateFileVersion" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadBase, decorators: [{
            type: Directive
        }], propDecorators: { maxFilesSize: [{
                type: Input
            }], rootFolderId: [{
                type: Input
            }], disabled: [{
                type: Input
            }], acceptedFilesType: [{
                type: Input
            }], versioning: [{
                type: Input
            }], majorVersion: [{
                type: Input
            }], comment: [{
                type: Input
            }], nodeType: [{
                type: Input
            }], success: [{
                type: Output
            }], error: [{
                type: Output
            }], beginUpload: [{
                type: Output
            }], updateFileVersion: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INPUT_FOCUS_CSS_CLASS = 'adf-file-draggable-input-focus';
const DROP_EFFECT = 'copy';
class FileDraggableDirective {
    constructor(el, ngZone) {
        this.ngZone = ngZone;
        /** Enables/disables drag-and-drop functionality. */
        this.enabled = true;
        /** Emitted when one or more files are dragged and dropped onto the draggable element. */
        this.filesDropped = new EventEmitter();
        /** Emitted when a directory is dragged and dropped onto the draggable element. */
        this.folderEntityDropped = new EventEmitter();
        this.element = el.nativeElement;
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            this.element.addEventListener('dragenter', this.onDragEnter.bind(this));
            this.element.addEventListener('dragover', this.onDragOver.bind(this));
            this.element.addEventListener('dragleave', this.onDragLeave.bind(this));
            this.element.addEventListener('drop', this.onDropFiles.bind(this));
        });
    }
    ngOnDestroy() {
        this.element.removeEventListener('dragenter', this.onDragEnter);
        this.element.removeEventListener('dragover', this.onDragOver);
        this.element.removeEventListener('dragleave', this.onDragLeave);
        this.element.removeEventListener('drop', this.onDropFiles);
    }
    /**
     * Method called when files is dropped in the drag and drop area.
     *
     * @param event DOM event.
     */
    onDropFiles(event) {
        if (this.enabled && !event.defaultPrevented) {
            this.preventDefault(event);
            // Chrome, Edge, Firefox, Opera (Files + Folders)
            const items = event.dataTransfer?.items;
            if (items) {
                const files = [];
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < items.length; i++) {
                    if (items[i].webkitGetAsEntry) {
                        const item = items[i].webkitGetAsEntry();
                        if (item) {
                            if (item.isFile) {
                                const file = items[i].getAsFile();
                                if (file) {
                                    files.push(file);
                                }
                            }
                            else if (item.isDirectory) {
                                this.folderEntityDropped.emit(item);
                            }
                        }
                    }
                }
                if (files.length > 0) {
                    this.filesDropped.emit(files);
                }
            }
            else if (event.dataTransfer?.files) {
                // IE, Safari, Chrome, Edge, Firefox, Opera (Files only)
                const files = FileUtils.toFileArray(event.dataTransfer.files);
                this.filesDropped.emit(files);
            }
            this.element.classList.remove(INPUT_FOCUS_CSS_CLASS);
        }
    }
    /**
     * Change the style of the drag area when a file drag in.
     *
     * @param event - DOM event.
     */
    onDragEnter(event) {
        if (this.enabled && !event.defaultPrevented) {
            this.preventDefault(event);
            if (event.dataTransfer) {
                event.dataTransfer.dropEffect = DROP_EFFECT;
            }
            this.element.classList.add(INPUT_FOCUS_CSS_CLASS);
        }
    }
    /**
     * Change the style of the drag area when a file drag out.
     *
     * @param event - DOM event.
     */
    onDragLeave(event) {
        if (this.enabled && !event.defaultPrevented) {
            this.preventDefault(event);
            this.element.classList.remove(INPUT_FOCUS_CSS_CLASS);
        }
    }
    /**
     * Change the style of the drag area when a file is over the drag area.
     *
     * @param event
     */
    onDragOver(event) {
        if (this.enabled && !event.defaultPrevented) {
            this.preventDefault(event);
            if (event.dataTransfer) {
                event.dataTransfer.dropEffect = DROP_EFFECT;
            }
            this.element.classList.add(INPUT_FOCUS_CSS_CLASS);
        }
    }
    /**
     * Prevent default and stop propagation of the DOM event.
     *
     * @param $event - DOM event.
     */
    preventDefault(event) {
        event.stopPropagation();
        event.preventDefault();
    }
}
FileDraggableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileDraggableDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
FileDraggableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: FileDraggableDirective, selector: "[adf-file-draggable]", inputs: { enabled: ["adf-file-draggable", "enabled"] }, outputs: { filesDropped: "filesDropped", folderEntityDropped: "folderEntityDropped" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileDraggableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-file-draggable]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { enabled: [{
                type: Input,
                args: ['adf-file-draggable']
            }], filesDropped: [{
                type: Output
            }], folderEntityDropped: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadDragAreaComponent extends UploadBase {
    constructor() {
        super(...arguments);
        this.notificationService = inject(NotificationService);
        this.contentService = inject(ContentService);
    }
    /**
     * Method called when files are dropped in the drag area.
     *
     * @param files - files dropped in the drag area.
     */
    onFilesDropped(files) {
        if (!this.disabled && files.length) {
            this.uploadFiles(files);
        }
    }
    /**
     * Called when a folder are dropped in the drag area
     *
     * @param folder - name of the dropped folder
     */
    onFolderEntityDropped(folder) {
        if (!this.disabled && folder.isDirectory) {
            FileUtils.flatten(folder).then((filesInfo) => {
                this.uploadFilesInfo(filesInfo);
            });
        }
    }
    /**
     * Show undo notification bar.
     *
     * @param latestFilesAdded - files in the upload queue enriched with status flag and xhr object.
     */
    showUndoNotificationBar(latestFilesAdded) {
        const messageTranslate = this.translationService.instant('FILE_UPLOAD.MESSAGES.PROGRESS');
        const actionTranslate = this.translationService.instant('FILE_UPLOAD.ACTION.UNDO');
        this.notificationService.openSnackMessageAction(messageTranslate, actionTranslate).onAction().subscribe(() => {
            this.uploadService.cancelUpload(...latestFilesAdded);
        });
    }
    /** Returns true or false considering the component options and node permissions */
    isDroppable() {
        return !this.disabled;
    }
    /**
     * Handles 'upload-files' events raised by child components.
     *
     * @param event DOM event
     */
    onUploadFiles(event) {
        event.stopPropagation();
        event.preventDefault();
        const isAllowed = this.isTargetNodeFolder(event) ?
            this.contentService.hasAllowableOperations(event.detail.data.obj.entry, AllowableOperationsEnum.CREATE)
            : this.contentService.hasAllowableOperations(event.detail.data.obj.entry, AllowableOperationsEnum.UPDATE);
        if (isAllowed) {
            if (!this.isTargetNodeFolder(event) && event.detail.files.length === 1) {
                this.updateFileVersion.emit(event);
            }
            else {
                const fileInfo = event.detail.files;
                if (this.isTargetNodeFolder(event)) {
                    const destinationFolderName = event.detail.data.obj.entry.name;
                    fileInfo.map((file) => file.relativeFolder = destinationFolderName ? destinationFolderName.concat(file.relativeFolder) : file.relativeFolder);
                }
                if (fileInfo && fileInfo.length > 0) {
                    this.uploadFilesInfo(fileInfo);
                }
            }
        }
    }
    isTargetNodeFolder(event) {
        return event.detail.data.obj && event.detail.data.obj.entry.isFolder;
    }
}
UploadDragAreaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadDragAreaComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
UploadDragAreaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UploadDragAreaComponent, selector: "adf-upload-drag-area", host: { classAttribute: "adf-upload-drag-area" }, usesInheritance: true, ngImport: i0, template: "<div [adf-file-draggable]=\"isDroppable()\" class=\"adf-upload-border\"\n     (filesDropped)=\"onFilesDropped($event)\"\n     (folderEntityDropped)=\"onFolderEntityDropped($event)\"\n     (upload-files)=\"onUploadFiles($any($event))\"\n     dropzone=\"\" webkitdropzone=\"*\" #droparea>\n    <ng-content></ng-content>\n</div>\n", styles: ["adf-upload-drag-area{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}adf-upload-drag-area .adf-upload-border{display:flex;flex-direction:column;height:100%;overflow:hidden;min-height:0;vertical-align:unset;text-align:unset;width:100%;box-sizing:border-box}adf-upload-drag-area .adf-file-draggable-input-focus{color:#2196f3;border:1px dashed #2196f3}adf-upload-drag-area .adf-file-draggable-input-focus adf-document-list{background:#e3f2fd}adf-upload-drag-area .adf-file-draggable-input-focus adf-document-list adf-datatable>table{background:inherit}adf-upload-drag-area .adf-upload__dragging{background:#e3f2fd;color:#2196f3}adf-upload-drag-area .adf-upload__dragging td{border-top:1px dashed #2196f3!important;border-bottom:1px dashed #2196f3!important}adf-upload-drag-area .adf-upload__dragging td:first-child{border-left:1px dashed #2196f3!important}adf-upload-drag-area .adf-upload__dragging td:last-child{border-right:1px dashed #2196f3!important}adf-upload-drag-area:first-child>div adf-upload-drag-area .adf-file-draggable-input-focus{color:#2196f3;border:1px dashed #2196f3!important;margin-left:0!important}adf-upload-drag-area:first-child .adf-upload-border{vertical-align:inherit!important;text-align:inherit!important}adf-upload-drag-area:first-child .adf-file-draggable-input-focus{color:#2196f3!important;border:1px dashed #2196f3!important;margin-left:0!important}adf-upload-drag-area:first-child .adf-file-draggable-input-focus adf-upload-drag-area>div{color:#2196f3;border:1px dashed #2196f3!important;margin-left:0!important}\n"], dependencies: [{ kind: "directive", type: FileDraggableDirective, selector: "[adf-file-draggable]", inputs: ["adf-file-draggable"], outputs: ["filesDropped", "folderEntityDropped"] }], viewProviders: [
        { provide: EXTENDIBLE_COMPONENT, useExisting: forwardRef(() => UploadDragAreaComponent) }
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadDragAreaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-upload-drag-area', host: { class: 'adf-upload-drag-area' }, viewProviders: [
                        { provide: EXTENDIBLE_COMPONENT, useExisting: forwardRef(() => UploadDragAreaComponent) }
                    ], encapsulation: ViewEncapsulation.None, template: "<div [adf-file-draggable]=\"isDroppable()\" class=\"adf-upload-border\"\n     (filesDropped)=\"onFilesDropped($event)\"\n     (folderEntityDropped)=\"onFolderEntityDropped($event)\"\n     (upload-files)=\"onUploadFiles($any($event))\"\n     dropzone=\"\" webkitdropzone=\"*\" #droparea>\n    <ng-content></ng-content>\n</div>\n", styles: ["adf-upload-drag-area{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}adf-upload-drag-area .adf-upload-border{display:flex;flex-direction:column;height:100%;overflow:hidden;min-height:0;vertical-align:unset;text-align:unset;width:100%;box-sizing:border-box}adf-upload-drag-area .adf-file-draggable-input-focus{color:#2196f3;border:1px dashed #2196f3}adf-upload-drag-area .adf-file-draggable-input-focus adf-document-list{background:#e3f2fd}adf-upload-drag-area .adf-file-draggable-input-focus adf-document-list adf-datatable>table{background:inherit}adf-upload-drag-area .adf-upload__dragging{background:#e3f2fd;color:#2196f3}adf-upload-drag-area .adf-upload__dragging td{border-top:1px dashed #2196f3!important;border-bottom:1px dashed #2196f3!important}adf-upload-drag-area .adf-upload__dragging td:first-child{border-left:1px dashed #2196f3!important}adf-upload-drag-area .adf-upload__dragging td:last-child{border-right:1px dashed #2196f3!important}adf-upload-drag-area:first-child>div adf-upload-drag-area .adf-file-draggable-input-focus{color:#2196f3;border:1px dashed #2196f3!important;margin-left:0!important}adf-upload-drag-area:first-child .adf-upload-border{vertical-align:inherit!important;text-align:inherit!important}adf-upload-drag-area:first-child .adf-file-draggable-input-focus{color:#2196f3!important;border:1px dashed #2196f3!important;margin-left:0!important}adf-upload-drag-area:first-child .adf-file-draggable-input-focus adf-upload-drag-area>div{color:#2196f3;border:1px dashed #2196f3!important;margin-left:0!important}\n"] }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PermissionModel {
    constructor(obj) {
        if (obj) {
            this.type = obj.type || null;
            this.action = obj.action || null;
            this.permission = obj.permission || null;
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadButtonComponent extends UploadBase {
    constructor() {
        super(...arguments);
        this.contentService = inject(ContentService);
        this.nodesApiService = inject(NodesApiService);
        this.logService = inject(LogService);
        /** Allows/disallows upload folders (only for Chrome). */
        this.uploadFolders = false;
        /** Allows/disallows multiple files */
        this.multipleFiles = false;
        /** Custom tooltip text. */
        this.tooltip = null;
        /** Emitted when create permission is missing. */
        this.permissionEvent = new EventEmitter();
        this.hasAllowableOperations = false;
        this.permissionValue = new Subject();
    }
    ngOnInit() {
        this.permissionValue.subscribe((permission) => {
            this.hasAllowableOperations = permission;
        });
    }
    ngOnChanges(changes) {
        const rootFolderId = changes['rootFolderId'];
        if (rootFolderId && rootFolderId.currentValue) {
            this.checkPermission();
        }
    }
    isButtonDisabled() {
        return this.disabled ? true : undefined;
    }
    onFilesAdded($event) {
        const files = FileUtils.toFileArray($event.currentTarget.files);
        if (this.hasAllowableOperations) {
            this.uploadFiles(files);
        }
        else {
            this.permissionEvent.emit(new PermissionModel({ type: 'content', action: 'upload', permission: 'create' }));
        }
        // reset the value of the input file
        $event.target.value = '';
    }
    onClickUploadButton() {
        if (this.file) {
            const files = [this.file];
            if (this.hasAllowableOperations) {
                this.uploadFiles(files);
            }
            else {
                this.permissionEvent.emit(new PermissionModel({ type: 'content', action: 'upload', permission: 'create' }));
            }
        }
    }
    onDirectoryAdded($event) {
        if (this.hasAllowableOperations) {
            const files = FileUtils.toFileArray($event.currentTarget.files);
            this.uploadFiles(files);
        }
        else {
            this.permissionEvent.emit(new PermissionModel({ type: 'content', action: 'upload', permission: 'create' }));
        }
        // reset the value of the input file
        $event.target.value = '';
    }
    checkPermission() {
        if (this.rootFolderId) {
            const opts = {
                includeSource: true,
                include: ['allowableOperations']
            };
            this.nodesApiService.getNode(this.rootFolderId, opts).subscribe((res) => this.permissionValue.next(this.nodeHasPermission(res, AllowableOperationsEnum.CREATE)), (error) => {
                if (error && error.error) {
                    this.error.emit({ error: error.error.message });
                }
                else {
                    this.error.emit({ error: 'FILE_UPLOAD.BUTTON.PERMISSION_CHECK_ERROR' });
                }
            });
        }
    }
    nodeHasPermission(node, permission) {
        return this.contentService.hasAllowableOperations(node, permission);
    }
}
UploadButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadButtonComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
UploadButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UploadButtonComponent, selector: "adf-upload-button", inputs: { uploadFolders: "uploadFolders", multipleFiles: "multipleFiles", staticTitle: "staticTitle", tooltip: "tooltip", file: "file" }, outputs: { permissionEvent: "permissionEvent" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<form class=\"adf-upload-button-file-container\">\n    <!--Files Upload-->\n    <div *ngIf=\"!uploadFolders\">\n\n        <!--Single Files Upload-->\n        <button *ngIf=\"!multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadSingleFile.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"upload-single-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span id=\"upload-single-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadSingleFile\n                id=\"upload-single-file\"\n                data-automation-id=\"upload-single-file\"\n                [type]=\"file ? 'button' : 'file'\"\n                name=\"uploadFiles\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\"\n                (click)=\"onClickUploadButton()\">\n        </button>\n\n        <!--Multiple Files Upload-->\n        <button *ngIf=\"multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadMultipleFiles.click()\">\n            <mat-icon>file_upload</mat-icon>\n\n            <span id=\"upload-multiple-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span\n                id=\"upload-multiple-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadMultipleFiles\n                id=\"upload-multiple-files\"\n                data-automation-id=\"upload-multiple-files\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\">\n        </button>\n    </div>\n\n    <!--Folders Upload-->\n    <div *ngIf=\"uploadFolders\">\n        <button\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadFolders.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"uploadFolder-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FOLDER' | translate }}</span>\n            <span id=\"uploadFolder-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadFolders\n                id=\"uploadFolder\"\n                data-automation-id=\"uploadFolder\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                webkitdirectory directory\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onDirectoryAdded($event)\">\n        </button>\n    </div>\n</form>\n", styles: [".adf-upload-button-file-container input{display:none}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], viewProviders: [
        { provide: EXTENDIBLE_COMPONENT, useExisting: forwardRef(() => UploadButtonComponent) }
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-upload-button', viewProviders: [
                        { provide: EXTENDIBLE_COMPONENT, useExisting: forwardRef(() => UploadButtonComponent) }
                    ], encapsulation: ViewEncapsulation.None, template: "<form class=\"adf-upload-button-file-container\">\n    <!--Files Upload-->\n    <div *ngIf=\"!uploadFolders\">\n\n        <!--Single Files Upload-->\n        <button *ngIf=\"!multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadSingleFile.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"upload-single-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span id=\"upload-single-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadSingleFile\n                id=\"upload-single-file\"\n                data-automation-id=\"upload-single-file\"\n                [type]=\"file ? 'button' : 'file'\"\n                name=\"uploadFiles\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\"\n                (click)=\"onClickUploadButton()\">\n        </button>\n\n        <!--Multiple Files Upload-->\n        <button *ngIf=\"multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadMultipleFiles.click()\">\n            <mat-icon>file_upload</mat-icon>\n\n            <span id=\"upload-multiple-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span\n                id=\"upload-multiple-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadMultipleFiles\n                id=\"upload-multiple-files\"\n                data-automation-id=\"upload-multiple-files\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\">\n        </button>\n    </div>\n\n    <!--Folders Upload-->\n    <div *ngIf=\"uploadFolders\">\n        <button\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadFolders.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"uploadFolder-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FOLDER' | translate }}</span>\n            <span id=\"uploadFolder-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadFolders\n                id=\"uploadFolder\"\n                data-automation-id=\"uploadFolder\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                webkitdirectory directory\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onDirectoryAdded($event)\">\n        </button>\n    </div>\n</form>\n", styles: [".adf-upload-button-file-container input{display:none}\n"] }]
        }], propDecorators: { uploadFolders: [{
                type: Input
            }], multipleFiles: [{
                type: Input
            }], staticTitle: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], file: [{
                type: Input
            }], permissionEvent: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUploadingListComponent {
    constructor(uploadService, translateService) {
        this.uploadService = uploadService;
        this.translateService = translateService;
        this.files = [];
        /** Emitted when a file in the list has an error. */
        this.error = new EventEmitter();
    }
    /**
     * Cancel file upload
     *
     * @param file File model to cancel upload for.
     *
     * @memberOf FileUploadingListComponent
     */
    cancelFile(file) {
        if (file.status === FileUploadStatus.Pending) {
            file.status = FileUploadStatus.Cancelled;
        }
        else {
            this.uploadService.cancelUpload(file);
        }
    }
    /**
     * Remove uploaded file
     *
     * @param file File model to remove upload for.
     *
     * @memberOf FileUploadingListComponent
     */
    removeFile(file) {
        if (file.status === FileUploadStatus.Error) {
            this.notifyError(file);
        }
        if (this.isUploadingFile(file)) {
            this.cancelNodeVersionInstances(file);
            this.uploadService.cancelUpload(file);
        }
        this.files = this.files.filter(entry => entry !== file);
    }
    /**
     * Calls the appropriate methods for each file, depending on state
     */
    cancelAllFiles() {
        const filesToCancel = this.files.filter(file => this.isUploadingFile(file));
        if (filesToCancel.length > 0) {
            this.uploadService.cancelUpload(...filesToCancel);
        }
    }
    /**
     * Checks if all the files are uploaded false if there is at least one file in Progress | Starting | Pending
     */
    isUploadCompleted() {
        return (!this.isUploadCancelled() &&
            Boolean(this.files.length) &&
            !this.files.some(({ status }) => status === FileUploadStatus.Starting ||
                status === FileUploadStatus.Progress ||
                status === FileUploadStatus.Pending));
    }
    /**
     * Check if all the files are Cancelled | Aborted | Error. false if there is at least one file in uploading states
     */
    isUploadCancelled() {
        return (!!this.files.length &&
            this.files.every(({ status }) => status === FileUploadStatus.Aborted ||
                status === FileUploadStatus.Cancelled ||
                status === FileUploadStatus.Deleted));
    }
    cancelNodeVersionInstances(file) {
        this.files
            .filter((item) => item.options.newVersion &&
            item.data.entry.id === file.data.entry.id)
            .map((item) => {
            item.status = FileUploadStatus.Deleted;
        });
    }
    notifyError(...files) {
        let messageError = null;
        if (files.length === 1) {
            messageError = this.translateService.instant('FILE_UPLOAD.MESSAGES.REMOVE_FILE_ERROR', { fileName: files[0].name });
        }
        else {
            messageError = this.translateService.instant('FILE_UPLOAD.MESSAGES.REMOVE_FILES_ERROR', { total: files.length });
        }
        this.error.emit(messageError);
    }
    isUploadingFile(file) {
        return file.status === FileUploadStatus.Pending ||
            file.status === FileUploadStatus.Starting ||
            file.status === FileUploadStatus.Progress;
    }
}
FileUploadingListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadingListComponent, deps: [{ token: UploadService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
FileUploadingListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FileUploadingListComponent, selector: "adf-file-uploading-list", inputs: { files: "files" }, outputs: { error: "error" }, queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<div class=\"upload-list\">\n    <ng-template\n        ngFor\n        [ngForOf]=\"files\"\n        [ngForTemplate]=\"template\">\n    </ng-template>\n</div>\n", styles: [":host{display:flex;flex-direction:column}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadingListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-file-uploading-list', template: "<div class=\"upload-list\">\n    <ng-template\n        ngFor\n        [ngForOf]=\"files\"\n        [ngForTemplate]=\"template\">\n    </ng-template>\n</div>\n", styles: [":host{display:flex;flex-direction:column}\n"] }]
        }], ctorParameters: function () { return [{ type: UploadService }, { type: i1.TranslationService }]; }, propDecorators: { template: [{
                type: ContentChild,
                args: [TemplateRef]
            }], files: [{
                type: Input
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ToggleIconDirective {
    constructor() {
        this.isFocus = false;
        this.toggle = false;
    }
    onMouseEnter() {
        if (!this.isFocus) {
            this.toggle = true;
        }
    }
    onMouseLeave() {
        if (!this.isFocus) {
            this.toggle = false;
        }
        if (this.isFocus && this.toggle) {
            this.isFocus = false;
            this.toggle = false;
        }
    }
    onFocus() {
        this.isFocus = true;
        this.toggle = true;
    }
    onBlur() {
        this.isFocus = false;
        this.toggle = false;
    }
    get isToggled() {
        return this.toggle;
    }
    get isFocused() {
        return this.isFocus;
    }
}
ToggleIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToggleIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ToggleIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ToggleIconDirective, selector: "[adf-toggle-icon]", host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()", "focus": "onFocus()", "blur": "onBlur()" } }, exportAs: ["toggleIcon"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ToggleIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-toggle-icon]',
                    exportAs: 'toggleIcon'
                }]
        }], propDecorators: { onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUploadErrorPipe {
    constructor(translation) {
        this.translation = translation;
    }
    transform(errorCode) {
        return this.translation.instant(`FILE_UPLOAD.ERRORS.${errorCode || 'GENERIC'}`);
    }
}
FileUploadErrorPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadErrorPipe, deps: [{ token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Pipe });
FileUploadErrorPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FileUploadErrorPipe, name: "adfFileUploadError" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadErrorPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfFileUploadError',
                    pure: true
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUploadingListRowComponent {
    constructor() {
        this.cancel = new EventEmitter();
    }
    onCancel(file) {
        this.cancel.emit(file);
    }
    showCancelledStatus() {
        return this.file.status === FileUploadStatus.Cancelled ||
            this.file.status === FileUploadStatus.Aborted ||
            this.file.status === FileUploadStatus.Deleted;
    }
    get versionNumber() {
        return this.file.data.entry.properties['cm:versionLabel'];
    }
    get mimeType() {
        if (this.file && this.file.file && this.file.file.type) {
            return this.file.file.type;
        }
        return 'default';
    }
    isUploadVersion() {
        return (!!this.file.data &&
            this.file.options &&
            this.file.options.newVersion &&
            this.file.data.entry.properties &&
            this.file.data.entry.properties['cm:versionLabel']);
    }
    canCancelUpload() {
        return this.file && this.file.status === FileUploadStatus.Pending;
    }
    isUploadError() {
        return this.file && this.file.status === FileUploadStatus.Error;
    }
    isUploading() {
        return this.file && (this.file.status === FileUploadStatus.Progress || this.file.status === FileUploadStatus.Starting);
    }
    isUploadComplete() {
        return this.file.status === FileUploadStatus.Complete && !this.isUploadVersion();
    }
    isUploadVersionComplete() {
        return this.file && (this.file.status === FileUploadStatus.Complete && this.isUploadVersion());
    }
}
FileUploadingListRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadingListRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FileUploadingListRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FileUploadingListRowComponent, selector: "adf-file-uploading-list-row", inputs: { file: "file" }, outputs: { cancel: "cancel" }, ngImport: i0, template: "<div class=\"adf-file-uploading-row\">\n    <mat-icon *ngIf=\"mimeType === 'default'\" mat-list-icon class=\"adf-file-uploading-row__type\">\n        insert_drive_file\n    </mat-icon>\n\n    <adf-icon *ngIf=\"mimeType !== 'default'\" value=\"adf:{{ mimeType }}\"></adf-icon>\n\n    <span\n        tabindex=\"0\"\n        class=\"adf-file-uploading-row__name\"\n        title=\"{{ file.name }}\">\n        {{ file.name }}\n    </span>\n\n    <span *ngIf=\"isUploadVersion()\" class=\"adf-file-uploading-row__version\" tabindex=\"0\" >\n        <mat-chip color=\"primary\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.VERSION' | translate: { version:  versionNumber }\"\n            [title]=\"'version' + versionNumber\" disabled\n        >{{ versionNumber }}</mat-chip>\n    </span>\n\n    <div\n        tabindex=\"0\"\n        role=\"button\"\n        #toggleIcon=\"toggleIcon\"\n        adf-toggle-icon\n        (keyup.enter)=\"onCancel(file)\"\n        (click)=\"onCancel(file)\"\n        data-automation-id=\"cancel-upload-progress\"\n        *ngIf=\"isUploading()\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.STOP_FILE_UPLOAD' | translate: { file: file.name }\"\n        class=\"adf-file-uploading-row__group adf-file-uploading-row__group--toggle\"\n        title=\"{{ 'ADF_FILE_UPLOAD.BUTTON.STOP_FILE' | translate }}\">\n\n        <span class=\"adf-file-uploading-row__status\" *ngIf=\"!toggleIcon.isToggled\">\n            {{ file.progress.loaded | adfFileSize }} / {{ file.progress.total | adfFileSize }}\n        </span>\n\n        <mat-icon *ngIf=\"toggleIcon.isToggled\"\n            class=\"adf-file-uploading-row__action adf-file-uploading-row__action--cancel\">\n            clear\n        </mat-icon>\n    </div>\n\n    <button mat-icon-button\n        adf-toggle-icon\n        #toggleIcon=\"toggleIcon\"\n        *ngIf=\"isUploadComplete()\"\n        class=\"adf-file-uploading-row__group\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.UPLOAD_SUCCESSFUL' | translate: { file: file.name }\"\n        title=\"{{ 'ADF_FILE_UPLOAD.BUTTON.UPLOAD_SUCCESSFUL' | translate }}\">\n\n        <mat-icon\n            class=\"adf-file-uploading-row__status adf-file-uploading-row__status--done\">\n            check_circle\n        </mat-icon>\n    </button>\n\n    <div\n        *ngIf=\"isUploadVersionComplete()\"\n        class=\"adf-file-uploading-row__file-version\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.STATUS.FILE_DONE_STATUS' | translate\"\n        role=\"status\"\n        >\n        <mat-icon\n            mat-list-icon\n            class=\"adf-file-uploading-row__status--done\">\n            check_circle\n        </mat-icon>\n    </div>\n\n    <button\n        adf-toggle-icon\n        #toggleIconCancel=\"toggleIcon\"\n        mat-icon-button\n        *ngIf=\"canCancelUpload()\"\n        (click)=\"onCancel(file)\"\n        data-automation-id=\"cancel-upload-queue\"\n        class=\"adf-file-uploading-row__group\"\n        title=\"{{ 'ADF_FILE_UPLOAD.BUTTON.STOP_FILE' | translate }}\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.STOP_FILE' | translate: { file: file.name }\">\n        <mat-icon\n            *ngIf=\"!toggleIconCancel.isToggled\"\n            class=\"adf-file-uploading-row__status adf-file-uploading-row__status--pending\">\n            schedule\n        </mat-icon>\n\n        <mat-icon\n            *ngIf=\"toggleIconCancel.isToggled\"\n            class=\"adf-file-uploading-row__action adf-file-uploading-row__action--remove\">\n            remove_circle\n        </mat-icon>\n    </button>\n\n    <div\n        tabindex=\"0\"\n        role=\"status\"\n        *ngIf=\"isUploadError()\"\n        class=\"adf-file-uploading-row__block adf-file-uploading-row__status--error\">\n        <mat-icon mat-list-icon\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.UPLOAD_FILE_ERROR' | translate: { error: file.errorCode | adfFileUploadError }\"\n            [matTooltip]=\"file.errorCode | adfFileUploadError\">\n            report_problem\n        </mat-icon>\n    </div>\n\n    <div\n        tabindex=\"0\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.STATUS.FILE_CANCELED_STATUS' | translate\"\n        role=\"status\"\n        *ngIf=\"showCancelledStatus()\"\n        class=\"adf-file-uploading-row__block adf-file-uploading-row__status--cancelled\">\n        {{ 'ADF_FILE_UPLOAD.STATUS.FILE_CANCELED_STATUS' | translate }}\n    </div>\n</div>\n", styles: ["adf-file-uploading-list-row:not(:first-child){display:block;border-top:1px solid var(--adf-theme-foreground-text-color-014)}.adf-file-uploading-row{display:flex;align-items:center;padding:.3em 1em;cursor:default}.adf-file-uploading-row:hover{background:#eee}.adf-file-uploading-row__name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1 1 auto;padding:0 1em 0 .5em}.adf-file-uploading-row__group,.adf-file-uploading-row__block,.adf-file-uploading-row__file-version{min-width:100px;display:flex!important;justify-content:flex-end;line-height:40px;height:40px;align-items:center}.adf-file-uploading-row__group--toggle{cursor:pointer;display:flex;align-items:center;height:40px;line-height:40px}.adf-file-uploading-row__status--done{color:var(--theme-accent-color)}.adf-file-uploading-row__status--error,.adf-file-uploading-row__action--cancel,.adf-file-uploading-row__action--remove{color:var(--theme-warn-color)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i8$1.MatListIconCssMatStyler, selector: "[mat-list-icon], [matListIcon]" }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i1.IconComponent, selector: "adf-icon", inputs: ["color", "fontSet", "value"] }, { kind: "directive", type: ToggleIconDirective, selector: "[adf-toggle-icon]", exportAs: ["toggleIcon"] }, { kind: "pipe", type: i1.FileSizePipe, name: "adfFileSize" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }, { kind: "pipe", type: FileUploadErrorPipe, name: "adfFileUploadError" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadingListRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-file-uploading-list-row', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-file-uploading-row\">\n    <mat-icon *ngIf=\"mimeType === 'default'\" mat-list-icon class=\"adf-file-uploading-row__type\">\n        insert_drive_file\n    </mat-icon>\n\n    <adf-icon *ngIf=\"mimeType !== 'default'\" value=\"adf:{{ mimeType }}\"></adf-icon>\n\n    <span\n        tabindex=\"0\"\n        class=\"adf-file-uploading-row__name\"\n        title=\"{{ file.name }}\">\n        {{ file.name }}\n    </span>\n\n    <span *ngIf=\"isUploadVersion()\" class=\"adf-file-uploading-row__version\" tabindex=\"0\" >\n        <mat-chip color=\"primary\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.VERSION' | translate: { version:  versionNumber }\"\n            [title]=\"'version' + versionNumber\" disabled\n        >{{ versionNumber }}</mat-chip>\n    </span>\n\n    <div\n        tabindex=\"0\"\n        role=\"button\"\n        #toggleIcon=\"toggleIcon\"\n        adf-toggle-icon\n        (keyup.enter)=\"onCancel(file)\"\n        (click)=\"onCancel(file)\"\n        data-automation-id=\"cancel-upload-progress\"\n        *ngIf=\"isUploading()\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.STOP_FILE_UPLOAD' | translate: { file: file.name }\"\n        class=\"adf-file-uploading-row__group adf-file-uploading-row__group--toggle\"\n        title=\"{{ 'ADF_FILE_UPLOAD.BUTTON.STOP_FILE' | translate }}\">\n\n        <span class=\"adf-file-uploading-row__status\" *ngIf=\"!toggleIcon.isToggled\">\n            {{ file.progress.loaded | adfFileSize }} / {{ file.progress.total | adfFileSize }}\n        </span>\n\n        <mat-icon *ngIf=\"toggleIcon.isToggled\"\n            class=\"adf-file-uploading-row__action adf-file-uploading-row__action--cancel\">\n            clear\n        </mat-icon>\n    </div>\n\n    <button mat-icon-button\n        adf-toggle-icon\n        #toggleIcon=\"toggleIcon\"\n        *ngIf=\"isUploadComplete()\"\n        class=\"adf-file-uploading-row__group\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.UPLOAD_SUCCESSFUL' | translate: { file: file.name }\"\n        title=\"{{ 'ADF_FILE_UPLOAD.BUTTON.UPLOAD_SUCCESSFUL' | translate }}\">\n\n        <mat-icon\n            class=\"adf-file-uploading-row__status adf-file-uploading-row__status--done\">\n            check_circle\n        </mat-icon>\n    </button>\n\n    <div\n        *ngIf=\"isUploadVersionComplete()\"\n        class=\"adf-file-uploading-row__file-version\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.STATUS.FILE_DONE_STATUS' | translate\"\n        role=\"status\"\n        >\n        <mat-icon\n            mat-list-icon\n            class=\"adf-file-uploading-row__status--done\">\n            check_circle\n        </mat-icon>\n    </div>\n\n    <button\n        adf-toggle-icon\n        #toggleIconCancel=\"toggleIcon\"\n        mat-icon-button\n        *ngIf=\"canCancelUpload()\"\n        (click)=\"onCancel(file)\"\n        data-automation-id=\"cancel-upload-queue\"\n        class=\"adf-file-uploading-row__group\"\n        title=\"{{ 'ADF_FILE_UPLOAD.BUTTON.STOP_FILE' | translate }}\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.STOP_FILE' | translate: { file: file.name }\">\n        <mat-icon\n            *ngIf=\"!toggleIconCancel.isToggled\"\n            class=\"adf-file-uploading-row__status adf-file-uploading-row__status--pending\">\n            schedule\n        </mat-icon>\n\n        <mat-icon\n            *ngIf=\"toggleIconCancel.isToggled\"\n            class=\"adf-file-uploading-row__action adf-file-uploading-row__action--remove\">\n            remove_circle\n        </mat-icon>\n    </button>\n\n    <div\n        tabindex=\"0\"\n        role=\"status\"\n        *ngIf=\"isUploadError()\"\n        class=\"adf-file-uploading-row__block adf-file-uploading-row__status--error\">\n        <mat-icon mat-list-icon\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.UPLOAD_FILE_ERROR' | translate: { error: file.errorCode | adfFileUploadError }\"\n            [matTooltip]=\"file.errorCode | adfFileUploadError\">\n            report_problem\n        </mat-icon>\n    </div>\n\n    <div\n        tabindex=\"0\"\n        [attr.aria-label]=\"'ADF_FILE_UPLOAD.STATUS.FILE_CANCELED_STATUS' | translate\"\n        role=\"status\"\n        *ngIf=\"showCancelledStatus()\"\n        class=\"adf-file-uploading-row__block adf-file-uploading-row__status--cancelled\">\n        {{ 'ADF_FILE_UPLOAD.STATUS.FILE_CANCELED_STATUS' | translate }}\n    </div>\n</div>\n", styles: ["adf-file-uploading-list-row:not(:first-child){display:block;border-top:1px solid var(--adf-theme-foreground-text-color-014)}.adf-file-uploading-row{display:flex;align-items:center;padding:.3em 1em;cursor:default}.adf-file-uploading-row:hover{background:#eee}.adf-file-uploading-row__name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1 1 auto;padding:0 1em 0 .5em}.adf-file-uploading-row__group,.adf-file-uploading-row__block,.adf-file-uploading-row__file-version{min-width:100px;display:flex!important;justify-content:flex-end;line-height:40px;height:40px;align-items:center}.adf-file-uploading-row__group--toggle{cursor:pointer;display:flex;align-items:center;height:40px;line-height:40px}.adf-file-uploading-row__status--done{color:var(--theme-accent-color)}.adf-file-uploading-row__status--error,.adf-file-uploading-row__action--cancel,.adf-file-uploading-row__action--remove{color:var(--theme-warn-color)}\n"] }]
        }], propDecorators: { file: [{
                type: Input
            }], cancel: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FileUploadingDialogComponent {
    constructor(uploadService, changeDetector, userPreferencesService, elementRef) {
        this.uploadService = uploadService;
        this.changeDetector = changeDetector;
        this.userPreferencesService = userPreferencesService;
        this.elementRef = elementRef;
        /** Dialog direction. Can be 'ltr' or 'rtl. */
        this.direction = 'ltr';
        this.onDestroy$ = new Subject();
        /** Dialog position. Can be 'left' or 'right'. */
        this.position = 'right';
        /** Makes the dialog always visible even when there are no uploads. */
        this.alwaysVisible = false;
        /** Emitted when a file in the list has an error. */
        this.error = new EventEmitter();
        this.filesUploadingList = [];
        this.isDialogActive = false;
        this.totalCompleted = 0;
        this.totalErrors = 0;
        this.isDialogMinimized = false;
        this.isConfirmation = false;
        this.dialogActive = new Subject();
    }
    get isPositionRight() {
        return (this.direction === 'ltr' && this.position === 'right')
            || (this.direction === 'rtl' && this.position === 'left')
            || null;
    }
    get isPositionLeft() {
        return (this.direction === 'ltr' && this.position === 'left')
            || (this.direction === 'rtl' && this.position === 'right')
            || null;
    }
    ngOnInit() {
        this.dialogActive
            .pipe(delay(100), takeUntil(this.onDestroy$))
            .subscribe(() => {
            const element = this.elementRef.nativeElement.querySelector('#upload-dialog');
            if (element) {
                element.focus();
            }
        });
        this.listSubscription = this.uploadService.queueChanged
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(fileList => {
            this.filesUploadingList = fileList;
            if (this.filesUploadingList.length && !this.isDialogActive) {
                this.isDialogActive = true;
                this.dialogActive.next();
            }
            else {
                this.dialogActive.next();
            }
        });
        this.counterSubscription = merge(this.uploadService.fileUploadComplete, this.uploadService.fileUploadDeleted)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((event) => {
            this.totalCompleted = event.totalComplete;
            this.changeDetector.detectChanges();
        });
        this.errorSubscription = this.uploadService.fileUploadError
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(event => {
            this.totalErrors = event.totalError;
            this.changeDetector.detectChanges();
        });
        this.fileUploadSubscription = this.uploadService.fileUpload
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
            this.changeDetector.detectChanges();
        });
        this.uploadService.fileDeleted
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(objId => {
            if (this.filesUploadingList) {
                const uploadedFile = this.filesUploadingList.find((file) => file.data ? file.data.entry.id === objId : false);
                if (uploadedFile) {
                    uploadedFile.status = FileUploadStatus.Cancelled;
                    this.changeDetector.detectChanges();
                }
            }
        });
        this.userPreferencesService.select('textOrientation')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((textOrientation) => {
            this.direction = textOrientation;
        });
    }
    /**
     * Toggle confirmation message.
     */
    toggleConfirmation() {
        this.isConfirmation = !this.isConfirmation;
        if (!this.isConfirmation) {
            this.dialogActive.next();
        }
        if (this.isDialogMinimized) {
            this.isDialogMinimized = false;
        }
    }
    /**
     * Cancel uploads and hide confirmation
     */
    cancelAllUploads() {
        this.toggleConfirmation();
        this.dialogActive.next();
        this.uploadList.cancelAllFiles();
    }
    /**
     * Toggle dialog minimized state.
     */
    toggleMinimized() {
        this.isDialogMinimized = !this.isDialogMinimized;
        this.changeDetector.detectChanges();
    }
    /**
     * Dismiss dialog
     */
    close() {
        this.isConfirmation = false;
        this.totalCompleted = 0;
        this.totalErrors = 0;
        this.filesUploadingList = [];
        this.isDialogActive = false;
        this.isDialogMinimized = false;
        this.uploadService.clearQueue();
        this.changeDetector.detectChanges();
    }
    ngOnDestroy() {
        this.uploadService.clearQueue();
        this.listSubscription.unsubscribe();
        this.counterSubscription.unsubscribe();
        this.fileUploadSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    canShowDialog() {
        return this.isDialogActive || this.alwaysVisible;
    }
    canShowCancelAll() {
        return this.filesUploadingList?.length && this.hasUploadInProgress();
    }
    canCloseDialog() {
        return !this.hasUploadInProgress() && !this.alwaysVisible;
    }
    hasUploadInProgress() {
        return (!this.uploadList?.isUploadCompleted() && !this.uploadList?.isUploadCancelled());
    }
}
FileUploadingDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadingDialogComponent, deps: [{ token: UploadService }, { token: i0.ChangeDetectorRef }, { token: i1.UserPreferencesService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FileUploadingDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FileUploadingDialogComponent, selector: "adf-file-uploading-dialog", inputs: { position: "position", alwaysVisible: "alwaysVisible" }, outputs: { error: "error" }, host: { properties: { "attr.adfUploadDialogRight": "this.isPositionRight", "attr.adfUploadDialogLeft": "this.isPositionLeft" } }, viewQueries: [{ propertyName: "uploadList", first: true, predicate: ["uploadList"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"canShowDialog()\"\n     role=\"dialog\"\n     [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG'| translate\"\n     tabindex=\"0\"\n     class=\"adf-upload-dialog\"\n     id=\"upload-dialog\"\n     [class.adf-upload-dialog--minimized]=\"isDialogMinimized\">\n    <header class=\"adf-upload-dialog__header\">\n        <button\n            mat-button\n            [attr.aria-label]=\"(isDialogMinimized ?\n                'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG_MAXIMIZE':\n                'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG_MINIMIZE') | translate\"\n            [disabled]=\"isConfirmation\"\n            [attr.aria-expanded]=\"!isDialogMinimized\"\n            (click)=\"toggleMinimized()\">\n            <mat-icon\n                mat-list-icon\n                title=\"{{ (isDialogMinimized ? 'ADF_FILE_UPLOAD.BUTTON.MAXIMIZE': 'ADF_FILE_UPLOAD.BUTTON.MINIMIZE') | translate }}\">\n                    {{ isDialogMinimized ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}\n            </mat-icon>\n        </button>\n\n        <span\n            tabindex=\"0\"\n            class=\"adf-upload-dialog__title\"\n            *ngIf=\"!uploadList.isUploadCancelled()\">\n            {{ 'FILE_UPLOAD.MESSAGES.UPLOAD_PROGRESS'\n                | translate: {\n                    completed: totalCompleted,\n                    total: filesUploadingList.length\n                }\n            }}\n        </span>\n\n        <span\n            tabindex=\"0\"\n            class=\"adf-upload-dialog__title\"\n            *ngIf=\"uploadList.isUploadCancelled()\">\n            {{ 'FILE_UPLOAD.MESSAGES.UPLOAD_CANCELED' | translate }}\n        </span>\n    </header>\n\n    <section class=\"adf-upload-dialog__info\"\n        tabindex=\"0\"\n        *ngIf=\"totalErrors\">\n        {{\n            (totalErrors > 1\n                 ? 'FILE_UPLOAD.MESSAGES.UPLOAD_ERRORS'\n                 : 'FILE_UPLOAD.MESSAGES.UPLOAD_ERROR')\n                 | translate: { total: totalErrors }\n        }}\n    </section>\n\n    <section class=\"adf-upload-dialog__content\"\n        [class.adf-upload-dialog--padding]=\"isConfirmation\">\n        <adf-file-uploading-list\n            [class.adf-upload-dialog--hide]=\"isConfirmation\"\n            #uploadList\n            [files]=\"filesUploadingList\">\n                <ng-template let-file=\"$implicit\">\n                     <adf-file-uploading-list-row\n                        [file]=\"file\"\n                        (cancel)=\"uploadList.cancelFile(file)\">\n                    </adf-file-uploading-list-row>\n                </ng-template>\n        </adf-file-uploading-list>\n\n        <div\n            aria-live=\"polite\"\n            aria-labelledby=\"confirmationTitle\"\n            aria-describedby=\"confirmationDescription\"\n            class=\"adf-upload-dialog__confirmation\"\n            [class.adf-upload-dialog--hide]=\"!isConfirmation\">\n                <p role=\"heading\" id=\"confirmationTitle\" class=\"adf-upload-dialog__confirmation--title\">\n                    {{ 'ADF_FILE_UPLOAD.CONFIRMATION.MESSAGE.TITLE' | translate }}\n                </p>\n                <p id=\"confirmationDescription\" class=\"adf-upload-dialog__confirmation--text\">\n                    {{ 'ADF_FILE_UPLOAD.CONFIRMATION.MESSAGE.TEXT' | translate }}\n                </p>\n        </div>\n    </section>\n\n    <footer class=\"adf-upload-dialog__actions\" *ngIf=\"!isConfirmation\">\n        <button\n            id=\"adf-upload-dialog-cancel-all\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.STOP_ALL' | translate\"\n            color=\"primary\"\n            mat-button\n            *ngIf=\"canShowCancelAll()\"\n            (click)=\"toggleConfirmation()\"\n        >{{ 'ADF_FILE_UPLOAD.BUTTON.STOP_ALL' | translate }}</button>\n\n        <button\n            id=\"adf-upload-dialog-close\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG_CLOSE' | translate\"\n            *ngIf=\"canCloseDialog()\"\n            mat-button\n            color=\"primary\"\n            (click)=\"close()\"\n        >{{ 'ADF_FILE_UPLOAD.BUTTON.CLOSE' | translate }}</button>\n    </footer>\n\n    <footer class=\"adf-upload-dialog__actions\"\n            *ngIf=\"isConfirmation\" cdkTrapFocus cdkTrapFocusAutoCapture>\n        <button\n            id=\"adf-upload-dialog-cancel\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.CONFIRMATION.CANCEL' | translate\"\n            mat-button\n            (click)=\"cancelAllUploads()\"\n        >{{ 'ADF_FILE_UPLOAD.CONFIRMATION.BUTTON.CANCEL' | translate }}</button>\n\n        <button\n            id=\"adf-upload-dialog-confirm\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.CONFIRMATION.CONTINUE' | translate\"\n            mat-button\n            color=\"primary\"\n            (click)=\"toggleConfirmation()\"\n        >{{ 'ADF_FILE_UPLOAD.CONFIRMATION.BUTTON.CONTINUE' | translate }}</button>\n    </footer>\n</div>\n", styles: [".adf-upload-dialog{background:var(--adf-theme-background-dialog-color);color:var(--adf-theme-foreground-text-color-054);position:fixed;bottom:20px;width:40%;box-shadow:1px 5px 15px #888;z-index:999}.adf-upload-dialog--padding{padding:1em}.adf-upload-dialog--hide{display:none!important}.adf-upload-dialog--minimized{width:20%}.adf-upload-dialog--minimized .adf-upload-dialog__content{display:none}.adf-upload-dialog__header{padding:1em;display:flex;align-items:center}.adf-upload-dialog__header button{min-width:0;padding:0;line-height:0;color:var(--adf-theme-foreground-text-color-054)!important}.adf-upload-dialog__title{margin-left:.5em;flex:1 1 auto}.adf-upload-dialog__info{padding:0 1em 1em}.adf-upload-dialog__content{overflow:auto;max-height:194px;border-top:1px solid var(--adf-theme-foreground-text-color-014);border-bottom:1px solid var(--adf-theme-foreground-text-color-014)}.adf-upload-dialog__confirmation{padding:0 .5em}.adf-upload-dialog__confirmation--title{font-size:var(--theme-subheading-2-font-size);line-height:1.5;letter-spacing:-.4px;color:var(--adf-theme-foreground-text-color-087)}.adf-upload-dialog__confirmation--text{margin-bottom:0}.adf-upload-dialog__actions{display:flex;justify-content:flex-end;padding:1em}.adf-upload-dialog__actions>button{text-transform:uppercase}[adfUploadDialogLeft] .adf-upload-dialog{left:25px}[adfUploadDialogRight] .adf-upload-dialog{right:25px}@media screen and (min-width: 380px) and (max-width: 768px){.adf-upload-dialog{width:60%}.adf-file-uploading-row .adf-file-uploading-row__group{min-width:0}}@media screen and (max-width: 380px){.adf-upload-dialog{width:85%}.adf-file-uploading-row .adf-file-uploading-row__group{min-width:0}}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i8$1.MatListIconCssMatStyler, selector: "[mat-list-icon], [matListIcon]" }, { kind: "directive", type: i1$4.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "component", type: FileUploadingListComponent, selector: "adf-file-uploading-list", inputs: ["files"], outputs: ["error"] }, { kind: "component", type: FileUploadingListRowComponent, selector: "adf-file-uploading-list-row", inputs: ["file"], outputs: ["cancel"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FileUploadingDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-file-uploading-dialog', encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"canShowDialog()\"\n     role=\"dialog\"\n     [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG'| translate\"\n     tabindex=\"0\"\n     class=\"adf-upload-dialog\"\n     id=\"upload-dialog\"\n     [class.adf-upload-dialog--minimized]=\"isDialogMinimized\">\n    <header class=\"adf-upload-dialog__header\">\n        <button\n            mat-button\n            [attr.aria-label]=\"(isDialogMinimized ?\n                'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG_MAXIMIZE':\n                'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG_MINIMIZE') | translate\"\n            [disabled]=\"isConfirmation\"\n            [attr.aria-expanded]=\"!isDialogMinimized\"\n            (click)=\"toggleMinimized()\">\n            <mat-icon\n                mat-list-icon\n                title=\"{{ (isDialogMinimized ? 'ADF_FILE_UPLOAD.BUTTON.MAXIMIZE': 'ADF_FILE_UPLOAD.BUTTON.MINIMIZE') | translate }}\">\n                    {{ isDialogMinimized ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}\n            </mat-icon>\n        </button>\n\n        <span\n            tabindex=\"0\"\n            class=\"adf-upload-dialog__title\"\n            *ngIf=\"!uploadList.isUploadCancelled()\">\n            {{ 'FILE_UPLOAD.MESSAGES.UPLOAD_PROGRESS'\n                | translate: {\n                    completed: totalCompleted,\n                    total: filesUploadingList.length\n                }\n            }}\n        </span>\n\n        <span\n            tabindex=\"0\"\n            class=\"adf-upload-dialog__title\"\n            *ngIf=\"uploadList.isUploadCancelled()\">\n            {{ 'FILE_UPLOAD.MESSAGES.UPLOAD_CANCELED' | translate }}\n        </span>\n    </header>\n\n    <section class=\"adf-upload-dialog__info\"\n        tabindex=\"0\"\n        *ngIf=\"totalErrors\">\n        {{\n            (totalErrors > 1\n                 ? 'FILE_UPLOAD.MESSAGES.UPLOAD_ERRORS'\n                 : 'FILE_UPLOAD.MESSAGES.UPLOAD_ERROR')\n                 | translate: { total: totalErrors }\n        }}\n    </section>\n\n    <section class=\"adf-upload-dialog__content\"\n        [class.adf-upload-dialog--padding]=\"isConfirmation\">\n        <adf-file-uploading-list\n            [class.adf-upload-dialog--hide]=\"isConfirmation\"\n            #uploadList\n            [files]=\"filesUploadingList\">\n                <ng-template let-file=\"$implicit\">\n                     <adf-file-uploading-list-row\n                        [file]=\"file\"\n                        (cancel)=\"uploadList.cancelFile(file)\">\n                    </adf-file-uploading-list-row>\n                </ng-template>\n        </adf-file-uploading-list>\n\n        <div\n            aria-live=\"polite\"\n            aria-labelledby=\"confirmationTitle\"\n            aria-describedby=\"confirmationDescription\"\n            class=\"adf-upload-dialog__confirmation\"\n            [class.adf-upload-dialog--hide]=\"!isConfirmation\">\n                <p role=\"heading\" id=\"confirmationTitle\" class=\"adf-upload-dialog__confirmation--title\">\n                    {{ 'ADF_FILE_UPLOAD.CONFIRMATION.MESSAGE.TITLE' | translate }}\n                </p>\n                <p id=\"confirmationDescription\" class=\"adf-upload-dialog__confirmation--text\">\n                    {{ 'ADF_FILE_UPLOAD.CONFIRMATION.MESSAGE.TEXT' | translate }}\n                </p>\n        </div>\n    </section>\n\n    <footer class=\"adf-upload-dialog__actions\" *ngIf=\"!isConfirmation\">\n        <button\n            id=\"adf-upload-dialog-cancel-all\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.STOP_ALL' | translate\"\n            color=\"primary\"\n            mat-button\n            *ngIf=\"canShowCancelAll()\"\n            (click)=\"toggleConfirmation()\"\n        >{{ 'ADF_FILE_UPLOAD.BUTTON.STOP_ALL' | translate }}</button>\n\n        <button\n            id=\"adf-upload-dialog-close\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.DIALOG_CLOSE' | translate\"\n            *ngIf=\"canCloseDialog()\"\n            mat-button\n            color=\"primary\"\n            (click)=\"close()\"\n        >{{ 'ADF_FILE_UPLOAD.BUTTON.CLOSE' | translate }}</button>\n    </footer>\n\n    <footer class=\"adf-upload-dialog__actions\"\n            *ngIf=\"isConfirmation\" cdkTrapFocus cdkTrapFocusAutoCapture>\n        <button\n            id=\"adf-upload-dialog-cancel\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.CONFIRMATION.CANCEL' | translate\"\n            mat-button\n            (click)=\"cancelAllUploads()\"\n        >{{ 'ADF_FILE_UPLOAD.CONFIRMATION.BUTTON.CANCEL' | translate }}</button>\n\n        <button\n            id=\"adf-upload-dialog-confirm\"\n            [attr.aria-label]=\"'ADF_FILE_UPLOAD.ARIA-LABEL.CONFIRMATION.CONTINUE' | translate\"\n            mat-button\n            color=\"primary\"\n            (click)=\"toggleConfirmation()\"\n        >{{ 'ADF_FILE_UPLOAD.CONFIRMATION.BUTTON.CONTINUE' | translate }}</button>\n    </footer>\n</div>\n", styles: [".adf-upload-dialog{background:var(--adf-theme-background-dialog-color);color:var(--adf-theme-foreground-text-color-054);position:fixed;bottom:20px;width:40%;box-shadow:1px 5px 15px #888;z-index:999}.adf-upload-dialog--padding{padding:1em}.adf-upload-dialog--hide{display:none!important}.adf-upload-dialog--minimized{width:20%}.adf-upload-dialog--minimized .adf-upload-dialog__content{display:none}.adf-upload-dialog__header{padding:1em;display:flex;align-items:center}.adf-upload-dialog__header button{min-width:0;padding:0;line-height:0;color:var(--adf-theme-foreground-text-color-054)!important}.adf-upload-dialog__title{margin-left:.5em;flex:1 1 auto}.adf-upload-dialog__info{padding:0 1em 1em}.adf-upload-dialog__content{overflow:auto;max-height:194px;border-top:1px solid var(--adf-theme-foreground-text-color-014);border-bottom:1px solid var(--adf-theme-foreground-text-color-014)}.adf-upload-dialog__confirmation{padding:0 .5em}.adf-upload-dialog__confirmation--title{font-size:var(--theme-subheading-2-font-size);line-height:1.5;letter-spacing:-.4px;color:var(--adf-theme-foreground-text-color-087)}.adf-upload-dialog__confirmation--text{margin-bottom:0}.adf-upload-dialog__actions{display:flex;justify-content:flex-end;padding:1em}.adf-upload-dialog__actions>button{text-transform:uppercase}[adfUploadDialogLeft] .adf-upload-dialog{left:25px}[adfUploadDialogRight] .adf-upload-dialog{right:25px}@media screen and (min-width: 380px) and (max-width: 768px){.adf-upload-dialog{width:60%}.adf-file-uploading-row .adf-file-uploading-row__group{min-width:0}}@media screen and (max-width: 380px){.adf-upload-dialog{width:85%}.adf-file-uploading-row .adf-file-uploading-row__group{min-width:0}}\n"] }]
        }], ctorParameters: function () { return [{ type: UploadService }, { type: i0.ChangeDetectorRef }, { type: i1.UserPreferencesService }, { type: i0.ElementRef }]; }, propDecorators: { uploadList: [{
                type: ViewChild,
                args: ['uploadList']
            }], position: [{
                type: Input
            }], alwaysVisible: [{
                type: Input
            }], error: [{
                type: Output
            }], isPositionRight: [{
                type: HostBinding,
                args: ['attr.adfUploadDialogRight']
            }], isPositionLeft: [{
                type: HostBinding,
                args: ['attr.adfUploadDialogLeft']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeCounterDirective {
    constructor(resolver, viewContainerRef) {
        this.resolver = resolver;
        this.viewContainerRef = viewContainerRef;
    }
    ngOnInit() {
        const componentFactory = this.resolver.resolveComponentFactory(NodeCounterComponent);
        this.componentRef = this.viewContainerRef.createComponent(componentFactory).instance;
        this.componentRef.counter = this.counter;
    }
    ngOnChanges() {
        if (this.componentRef) {
            this.componentRef.counter = this.counter;
        }
    }
}
NodeCounterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCounterDirective, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
NodeCounterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeCounterDirective, selector: "[adf-node-counter]", inputs: { counter: ["adf-node-counter", "counter"] }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCounterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-node-counter]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ViewContainerRef }]; }, propDecorators: { counter: [{
                type: Input,
                args: ['adf-node-counter']
            }] } });
class NodeCounterComponent {
}
NodeCounterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCounterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NodeCounterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NodeCounterComponent, selector: "adf-node-counter", ngImport: i0, template: `
        <div>{{ 'NODE_COUNTER.SELECTED_COUNT' | translate: { count: counter } }}</div>
    `, isInline: true, dependencies: [{ kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCounterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-node-counter',
                    template: `
        <div>{{ 'NODE_COUNTER.SELECTED_COUNT' | translate: { count: counter } }}</div>
    `
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchQueryBuilderService extends BaseQueryBuilderService {
    constructor(appConfig, alfrescoApiService) {
        super(appConfig, alfrescoApiService);
    }
    isFilterServiceActive() {
        return false;
    }
    loadConfiguration() {
        return this.appConfig.get('search');
    }
}
SearchQueryBuilderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchQueryBuilderService, deps: [{ token: i1.AppConfigService }, { token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
SearchQueryBuilderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchQueryBuilderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchQueryBuilderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.AppConfigService }, { type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentNodeSelectorPanelService {
    constructor() {
        this.propertyTypes = ['d:text', 'd:date', 'd:datetime'];
        this.modelPropertyTypeToSearchFilterTypeMap = new Map();
        this.modelPropertyTypeToSearchFilterTypeMap.set(this.propertyTypes[0], 'text');
        this.modelPropertyTypeToSearchFilterTypeMap.set(this.propertyTypes[1], 'date-range');
        this.modelPropertyTypeToSearchFilterTypeMap.set(this.propertyTypes[2], 'datetime-range');
    }
    convertCustomModelPropertiesToSearchCategories() {
        const searchConfig = [];
        this.customModels?.forEach((propertyModel) => {
            searchConfig.push(this.convertModelPropertyIntoSearchFilter(propertyModel));
        });
        return searchConfig;
    }
    convertModelPropertyIntoSearchFilter(modelProperty) {
        let filterSearch;
        if (this.isTypeSupported(modelProperty.dataType)) {
            filterSearch = {
                id: modelProperty.prefixedName,
                name: modelProperty.prefixedName,
                expanded: false,
                enabled: true,
                component: {
                    selector: this.modelPropertyTypeToSearchFilterTypeMap.get(modelProperty.dataType),
                    settings: {
                        pattern: `${modelProperty.prefixedName}:'(.*?)'`,
                        field: `${modelProperty.prefixedName}`,
                        placeholder: `Enter the ${modelProperty.name}`
                    }
                }
            };
        }
        return filterSearch;
    }
    isTypeSupported(dataType) {
        return this.propertyTypes.includes(dataType);
    }
}
ContentNodeSelectorPanelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorPanelService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ContentNodeSelectorPanelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorPanelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorPanelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SitesService {
    constructor(apiService, logService) {
        this.apiService = apiService;
        this.logService = logService;
    }
    get sitesApi() {
        this._sitesApi = this._sitesApi ?? new SitesApi(this.apiService.getInstance());
        return this._sitesApi;
    }
    /**
     * Create a site
     *
     * @param siteBody SiteBodyCreate to create site
     * @returns site SiteEntry
     */
    createSite(siteBody) {
        return from(this.sitesApi.createSite(siteBody))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets a list of all sites in the repository.
     *
     * @param opts Options supported by JS-API
     * @returns List of sites
     */
    getSites(opts = {}) {
        const defaultOptions = {
            skipCount: 0,
            include: ['properties']
        };
        const queryOptions = Object.assign({}, defaultOptions, opts);
        return from(this.sitesApi.listSites(queryOptions))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets the details for a site.
     *
     * @param siteId ID of the target site
     * @param opts Options supported by JS-API
     * @returns Information about the site
     */
    getSite(siteId, opts) {
        return from(this.sitesApi.getSite(siteId, opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Deletes a site.
     *
     * @param siteId Site to delete
     * @param permanentFlag True: deletion is permanent; False: site is moved to the trash
     * @returns Null response notifying when the operation is complete
     */
    deleteSite(siteId, permanentFlag = true) {
        const options = {};
        options.permanent = permanentFlag;
        return from(this.sitesApi.deleteSite(siteId, options))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Gets a site's content.
     *
     * @param siteId ID of the target site
     * @returns Site content
     */
    getSiteContent(siteId) {
        return this.getSite(siteId, { relations: ['containers'] });
    }
    /**
     * Gets a list of all a site's members.
     *
     * @param siteId ID of the target site
     * @returns Site members
     */
    getSiteMembers(siteId) {
        return this.getSite(siteId, { relations: ['members'] });
    }
    /**
     * Gets a list of all a site's members.
     *
     * @param siteId ID of the target site
     * @param opts Optional parameters supported by JS-API
     * @returns Observable<SiteMemberPaging>
     */
    listSiteMemberships(siteId, opts) {
        return from(this.sitesApi.listSiteMemberships(siteId, opts));
    }
    /**
     * Gets the username of the user currently logged into ACS.
     *
     * @returns Username string
     */
    getEcmCurrentLoggedUserName() {
        return this.apiService.getInstance().getEcmUsername();
    }
    /**
     * Looks for a site inside the path of a Node and returns its guid if it finds one.
     * (return an empty string if no site is found)
     *
     * @param node Node to look for parent site
     * @returns Site guid
     */
    getSiteNameFromNodePath(node) {
        let siteName = '';
        if (node.path && node.path.elements) {
            const foundNode = node.path
                .elements.find((pathNode) => pathNode.nodeType === 'st:site' &&
                pathNode.name !== 'Sites');
            siteName = foundNode ? foundNode.name : '';
        }
        return siteName.toLocaleLowerCase();
    }
    /**
     * Gets a list of site membership requests.
     *
     * @param opts Options supported by JS-API
     * @returns Site membership requests
     */
    getSiteMembershipRequests(opts) {
        return from(this.sitesApi.getSiteMembershipRequests(opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Creates a site membership for person **personId** on site **siteId**.
     *
     * @param siteId The identifier of a site
     * @param siteMembershipBodyCreate The person to add and their role
     * @param opts Optional parameters
     * @return Observable<SiteMemberEntry>
     */
    createSiteMembership(siteId, siteMembershipBodyCreate, opts) {
        return from(this.sitesApi.createSiteMembership(siteId, siteMembershipBodyCreate, opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Update a site membership
     *
     * @param siteId The identifier of a site.
     * @param personId The identifier of a person.
     * @param siteMembershipBodyUpdate The persons new role
     * @param opts Optional parameters
     * @return Observable<SiteMemberEntry>
     */
    updateSiteMembership(siteId, personId, siteMembershipBodyUpdate, opts) {
        return from(this.sitesApi.updateSiteMembership(siteId, personId, siteMembershipBodyUpdate, opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Delete a site membership
     *
     * @param siteId The identifier of a site.
     * @param personId The identifier of a person.
     * @return  Null response notifying when the operation is complete
     */
    deleteSiteMembership(siteId, personId) {
        return from(this.sitesApi.deleteSiteMembership(siteId, personId))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Accept site membership requests.
     *
     * @param siteId The identifier of a site.
     * @param inviteeId The invitee user name.
     * @param opts Options supported by JS-API
     * @returns  Null response notifying when the operation is complete
     */
    approveSiteMembershipRequest(siteId, inviteeId, opts) {
        return from(this.sitesApi.approveSiteMembershipRequest(siteId, inviteeId, opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Reject site membership requests.
     *
     * @param siteId The identifier of a site.
     * @param inviteeId The invitee user name.
     * @param opts Options supported by JS-API
     * @returns  Null response notifying when the operation is complete
     */
    rejectSiteMembershipRequest(siteId, inviteeId, opts) {
        return from(this.sitesApi.rejectSiteMembershipRequest(siteId, inviteeId, opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * List group membership for site
     *
     * @param siteId The identifier of a site.
     * @param opts Options supported by JS-API
     * @returns  Observable<SiteGroupPaging>
     */
    listSiteGroups(siteId, opts) {
        return from(this.sitesApi.listSiteGroups(siteId, opts))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Create a site membership for group
     *
     * @param siteId The identifier of a site.
     * @param siteMembershipBodyCreate The Group to add and its role
     * @returns Observable<SiteGroupEntry>
     */
    createSiteGroupMembership(siteId, siteMembershipBodyCreate) {
        return from(this.sitesApi.createSiteGroupMembership(siteId, siteMembershipBodyCreate))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Get information about site membership of group
     *
     * @param siteId The identifier of a site.
     * @param groupId The authorityId of a group.
     * @return Observable<SiteGroupEntry>
     */
    getSiteGroupMembership(siteId, groupId) {
        return from(this.sitesApi.getSiteGroupMembership(siteId, groupId))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Update site membership of group
     *
     * @param siteId The identifier of a site.
     * @param groupId The authorityId of a group.
     * @param siteMembershipBodyUpdate The group new role
     * @return Observable<SiteGroupEntry>
     */
    updateSiteGroupMembership(siteId, groupId, siteMembershipBodyUpdate) {
        return from(this.sitesApi.updateSiteGroupMembership(siteId, groupId, siteMembershipBodyUpdate))
            .pipe(catchError((err) => this.handleError(err)));
    }
    /**
     * Delete a group membership for site
     *
     * @param siteId The identifier of a site.
     * @param groupId The authorityId of a group.
     * @return Observable<void>
     */
    deleteSiteGroupMembership(siteId, groupId) {
        return from(this.sitesApi.deleteSiteGroupMembership(siteId, groupId))
            .pipe(catchError((err) => this.handleError(err)));
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
SitesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SitesService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
SitesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SitesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SitesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
var Relations;
(function (Relations) {
    Relations["Members"] = "members";
    Relations["Containers"] = "containers";
})(Relations || (Relations = {}));
class DropdownSitesComponent {
    constructor(sitesService, logService, liveAnnouncer, translateService) {
        this.sitesService = sitesService;
        this.logService = logService;
        this.liveAnnouncer = liveAnnouncer;
        this.translateService = translateService;
        /** Hide the "My Files" option. */
        this.hideMyFiles = false;
        /** A custom list of sites to be displayed by the dropdown. If no value
         * is given, the sites of the current user are displayed by default. A
         * list of objects only with properties 'title' and 'guid' is enough to
         * be able to display the dropdown.
         */
        this.siteList = null;
        /** Id of the selected site */
        this.value = null;
        /** Text or a translation key to act as a placeholder. Default value is the
         * key "DROPDOWN.PLACEHOLDER_LABEL".
         */
        this.placeholder = 'DROPDOWN.PLACEHOLDER_LABEL';
        /** Emitted when the user selects a site. When the default option is selected,
         * an empty model is emitted.
         */
        this.change = new EventEmitter();
        this.loading = true;
        this.skipCount = 0;
        this.selected = null;
        this.MY_FILES_VALUE = '-my-';
    }
    ngOnInit() {
        if (!this.siteList) {
            this.loadSiteList();
        }
    }
    loadAllOnScroll() {
        if (this.isInfiniteScrollingEnabled()) {
            this.loading = true;
            this.loadSiteList();
        }
    }
    selectedSite(event) {
        this.liveAnnouncer.announce(this.translateService.instant('ADF_DROPDOWN.SELECTION_ARIA_LABEL', {
            placeholder: this.translateService.instant(this.placeholder),
            selectedOption: this.translateService.instant(event.value.entry.title)
        }));
        this.change.emit(event.value);
    }
    loadSiteList() {
        const extendedOptions = {
            skipCount: this.skipCount,
            maxItems: InfiniteSelectScrollDirective.MAX_ITEMS
        };
        this.skipCount += InfiniteSelectScrollDirective.MAX_ITEMS;
        if (this.relations) {
            extendedOptions.relations = [this.relations];
        }
        this.sitesService.getSites(extendedOptions).subscribe((sitePaging) => {
            if (!this.siteList) {
                this.siteList = this.relations === Relations.Members ? this.filteredResultsByMember(sitePaging) : sitePaging;
                if (!this.hideMyFiles) {
                    const siteEntry = new SiteEntry({
                        entry: {
                            id: this.MY_FILES_VALUE,
                            guid: this.MY_FILES_VALUE,
                            title: 'DROPDOWN.MY_FILES_OPTION'
                        }
                    });
                    this.siteList.list.entries.unshift(siteEntry);
                    if (!this.value) {
                        this.value = this.MY_FILES_VALUE;
                    }
                }
            }
            else {
                const siteList = this.relations === Relations.Members ? this.filteredResultsByMember(sitePaging) : sitePaging;
                this.siteList.list.entries = this.siteList.list.entries.concat(siteList.list.entries);
                this.siteList.list.pagination = sitePaging.list.pagination;
            }
            this.selected = this.siteList.list.entries.find((site) => site.entry.id === this.value);
            if (this.value && !this.selected && this.siteListHasMoreItems()) {
                this.loadSiteList();
            }
            this.loading = false;
        }, (error) => {
            this.logService.error(error);
        });
    }
    showLoading() {
        return this.loading && this.siteListHasMoreItems();
    }
    isInfiniteScrollingEnabled() {
        return !this.loading && this.siteListHasMoreItems();
    }
    siteListHasMoreItems() {
        return this.siteList && this.siteList.list.pagination && this.siteList.list.pagination.hasMoreItems;
    }
    filteredResultsByMember(sites) {
        const loggedUserName = this.sitesService.getEcmCurrentLoggedUserName();
        sites.list.entries = sites.list.entries.filter((site) => this.isCurrentUserMember(site, loggedUserName));
        return sites;
    }
    isCurrentUserMember(site, loggedUserName) {
        return site.entry.visibility === 'PUBLIC' ||
            !!site.relations.members.list.entries.find((member) => member.entry.id.toLowerCase() === loggedUserName.toLowerCase());
    }
}
DropdownSitesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DropdownSitesComponent, deps: [{ token: SitesService }, { token: i1.LogService }, { token: i1$4.LiveAnnouncer }, { token: i5.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
DropdownSitesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: DropdownSitesComponent, selector: "adf-sites-dropdown", inputs: { hideMyFiles: "hideMyFiles", siteList: "siteList", value: "value", placeholder: "placeholder", relations: "relations" }, outputs: { change: "change" }, host: { classAttribute: "adf-sites-dropdown" }, ngImport: i0, template: "<div id=\"site-dropdown-container\" class=\"adf-site-dropdown-container\">\n    <mat-form-field>\n        <mat-label>{{ 'NODE_SELECTOR.LOCATION' | translate }}</mat-label>\n        <mat-select\n            adf-infinite-select-scroll\n            (scrollEnd)=\"loadAllOnScroll()\"\n            #siteSelect\n            data-automation-id=\"site-my-files-option\"\n            class=\"adf-site-dropdown-list-element\"\n            id=\"site-dropdown\"\n            placeholder=\"{{placeholder | translate}}\"\n            floatPlaceholder=\"never\"\n            [(value)]=\"selected\"\n            (selectionChange)=\"selectedSite($event)\">\n            <mat-option *ngFor=\"let site of siteList?.list.entries;\" [value]=\"site\">\n                {{ site.entry.title | translate}}\n            </mat-option>\n            <mat-option *ngIf=\"showLoading()\" disabled=\"true\" data-automation-id=\"site-loading\">\n                {{ 'ADF_DROPDOWN.LOADING' | translate}}\n            </mat-option>\n        </mat-select>\n    </mat-form-field>\n</div>\n", styles: [".adf-sites-dropdown.adf-full-width .mat-form-field{width:100%}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "component", type: i1$2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "directive", type: i1.InfiniteSelectScrollDirective, selector: "[adf-infinite-select-scroll]", outputs: ["scrollEnd"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DropdownSitesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-sites-dropdown', encapsulation: ViewEncapsulation.None, host: { class: 'adf-sites-dropdown' }, template: "<div id=\"site-dropdown-container\" class=\"adf-site-dropdown-container\">\n    <mat-form-field>\n        <mat-label>{{ 'NODE_SELECTOR.LOCATION' | translate }}</mat-label>\n        <mat-select\n            adf-infinite-select-scroll\n            (scrollEnd)=\"loadAllOnScroll()\"\n            #siteSelect\n            data-automation-id=\"site-my-files-option\"\n            class=\"adf-site-dropdown-list-element\"\n            id=\"site-dropdown\"\n            placeholder=\"{{placeholder | translate}}\"\n            floatPlaceholder=\"never\"\n            [(value)]=\"selected\"\n            (selectionChange)=\"selectedSite($event)\">\n            <mat-option *ngFor=\"let site of siteList?.list.entries;\" [value]=\"site\">\n                {{ site.entry.title | translate}}\n            </mat-option>\n            <mat-option *ngIf=\"showLoading()\" disabled=\"true\" data-automation-id=\"site-loading\">\n                {{ 'ADF_DROPDOWN.LOADING' | translate}}\n            </mat-option>\n        </mat-select>\n    </mat-form-field>\n</div>\n", styles: [".adf-sites-dropdown.adf-full-width .mat-form-field{width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: SitesService }, { type: i1.LogService }, { type: i1$4.LiveAnnouncer }, { type: i5.TranslateService }]; }, propDecorators: { hideMyFiles: [{
                type: Input
            }], siteList: [{
                type: Input
            }], value: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], relations: [{
                type: Input
            }], change: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var FacetBucketSortBy;
(function (FacetBucketSortBy) {
    FacetBucketSortBy["LABEL"] = "LABEL";
    FacetBucketSortBy["COUNT"] = "COUNT";
})(FacetBucketSortBy || (FacetBucketSortBy = {}));
// eslint-disable-next-line no-shadow
var FacetBucketSortDirection;
(function (FacetBucketSortDirection) {
    FacetBucketSortDirection["ASCENDING"] = "ASCENDING";
    FacetBucketSortDirection["DESCENDING"] = "DESCENDING";
})(FacetBucketSortDirection || (FacetBucketSortDirection = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchConfigurationService {
    /**
     * Generates a QueryBody object with custom search parameters.
     *
     * @param searchTerm Term text to search for
     * @param maxResults Maximum number of search results to show in a page
     * @param skipCount The offset of the start of the page within the results list
     * @returns Query body defined by the parameters
     */
    generateQueryBody(searchTerm, maxResults, skipCount) {
        const defaultQueryBody = {
            query: {
                query: searchTerm ? `'${searchTerm}*' OR name:'${searchTerm}*'` : searchTerm
            },
            include: ['path', 'allowableOperations'],
            paging: {
                maxItems: maxResults,
                skipCount
            },
            filterQueries: [
                { query: `TYPE:'cm:folder' OR TYPE:'cm:content'` },
                { query: 'NOT cm:creator:System' }
            ]
        };
        return defaultQueryBody;
    }
}
SearchConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchConfigurationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SearchConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchConfigurationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchConfigurationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchService {
    constructor(apiService, searchConfigurationService) {
        this.apiService = apiService;
        this.searchConfigurationService = searchConfigurationService;
        this.dataLoaded = new Subject();
    }
    get queriesApi() {
        this._queriesApi = this._queriesApi ?? new QueriesApi(this.apiService.getInstance());
        return this._queriesApi;
    }
    get searchApi() {
        this._searchApi = this._searchApi ?? new SearchApi(this.apiService.getInstance());
        return this._searchApi;
    }
    /**
     * Gets a list of nodes that match the given search criteria.
     *
     * @param term Term to search for
     * @param options Options for delivery of the search results
     * @returns List of nodes resulting from the search
     */
    getNodeQueryResults(term, options) {
        const promise = this.queriesApi.findNodes(term, options);
        promise.then((nodePaging) => {
            this.dataLoaded.next(nodePaging);
        }).catch((err) => this.handleError(err));
        return from(promise);
    }
    /**
     * Performs a search.
     *
     * @param searchTerm Term to search for
     * @param maxResults Maximum number of items in the list of results
     * @param skipCount Number of higher-ranked items to skip over in the list
     * @returns List of search results
     */
    search(searchTerm, maxResults, skipCount) {
        const searchQuery = Object.assign(this.searchConfigurationService.generateQueryBody(searchTerm, maxResults, skipCount));
        const promise = this.searchApi.search(searchQuery);
        promise.then((nodePaging) => {
            this.dataLoaded.next(nodePaging);
        }).catch((err) => this.handleError(err));
        return from(promise);
    }
    /**
     * Performs a search with its parameters supplied by a QueryBody object.
     *
     * @param queryBody Object containing the search parameters
     * @returns List of search results
     */
    searchByQueryBody(queryBody) {
        const promise = this.searchApi.search(queryBody);
        promise.then((nodePaging) => {
            this.dataLoaded.next(nodePaging);
        }).catch((err) => this.handleError(err));
        return from(promise);
    }
    handleError(error) {
        return throwError(error || 'Server error');
    }
}
SearchService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchService, deps: [{ token: i1.AlfrescoApiService }, { token: SearchConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
SearchService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: SearchConfigurationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CategoryService {
    constructor(apiService, userPreferencesService) {
        this.apiService = apiService;
        this.userPreferencesService = userPreferencesService;
    }
    get categoriesApi() {
        this._categoriesApi = this._categoriesApi ?? new CategoriesApi(this.apiService.getInstance());
        return this._categoriesApi;
    }
    get searchApi() {
        this._searchApi = this._searchApi ?? new SearchApi(this.apiService.getInstance());
        return this._searchApi;
    }
    /**
     * Get subcategories of a given parent category
     *
     * @param parentCategoryId The identifier of a parent category.
     * @param skipCount Number of top categories to skip.
     * @param maxItems Maximum number of subcategories returned from Observable.
     * @return Observable<CategoryPaging>
     */
    getSubcategories(parentCategoryId, skipCount, maxItems) {
        return from(this.categoriesApi.getSubcategories(parentCategoryId ?? '-root-', { skipCount, maxItems }));
    }
    /**
     * Get a category by ID
     *
     * @param categoryId The identifier of a category.
     * @param opts Optional parameters.
     * @param opts.fields A list of field names.
     * @param opts.include Returns additional information about the category. The following optional fields can be requested:
     * count
     * path
     * @return Observable<CategoryEntry>
     */
    getCategory(categoryId, opts) {
        return from(this.categoriesApi.getCategory(categoryId, opts));
    }
    /**
     * Creates subcategories under category with provided categoryId
     *
     * @param parentCategoryId The identifier of a parent category.
     * @param payload List of categories to be created.
     * @return Observable<CategoryPaging | CategoryEntry>
     */
    createSubcategories(parentCategoryId, payload) {
        return from(this.categoriesApi.createSubcategories(parentCategoryId, payload, {}));
    }
    /**
     * Updates category
     *
     * @param categoryId The identifier of a category.
     * @param payload Updated category body
     * @return Observable<CategoryEntry>
     */
    updateCategory(categoryId, payload) {
        return from(this.categoriesApi.updateCategory(categoryId, payload, {}));
    }
    /**
     * Deletes category
     *
     * @param categoryId The identifier of a category.
     * @return Observable<void>
     */
    deleteCategory(categoryId) {
        return from(this.categoriesApi.deleteCategory(categoryId));
    }
    /**
     * Searches categories by their name.
     *
     * @param name Value for name which should be used during searching categories.
     * @param skipCount Specify how many first results should be skipped. Default 0.
     * @param maxItems Specify max number of returned categories. Default is specified by UserPreferencesService.
     * @return Observable<ResultSetPaging> Found categories which name contains searched name.
     */
    searchCategories(name, skipCount = 0, maxItems) {
        maxItems = maxItems || this.userPreferencesService.paginationSize;
        return from(this.searchApi.search({
            query: {
                language: RequestQuery.LanguageEnum.Afts,
                query: `cm:name:"*${name}*" AND TYPE:'cm:category' AND PATH:"/cm:categoryRoot/cm:generalclassifiable//*"`
            },
            paging: {
                skipCount,
                maxItems
            },
            include: ['path']
        }));
    }
    /**
     * List of categories that node is assigned to
     *
     * @param nodeId The identifier of a node.
     * @return Observable<CategoryPaging> Categories that node is assigned to
     */
    getCategoryLinksForNode(nodeId) {
        return from(this.categoriesApi.getCategoryLinksForNode(nodeId, { include: ['path'] }));
    }
    /**
     * Unlink category from a node
     *
     * @param nodeId The identifier of a node.
     * @param categoryId The identifier of a category.
     * @return Observable<void>
     */
    unlinkNodeFromCategory(nodeId, categoryId) {
        return from(this.categoriesApi.unlinkNodeFromCategory(nodeId, categoryId));
    }
    /**
     * Link node to a category
     *
     * @param nodeId The identifier of a node.
     * @param categoryLinkBodyCreate Array of a categories that node will be linked to.
     * @return Observable<CategoryEntry>
     */
    linkNodeToCategory(nodeId, categoryLinkBodyCreate) {
        return from(this.categoriesApi.linkNodeToCategory(nodeId, categoryLinkBodyCreate));
    }
}
CategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoryService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
CategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoryService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_PAGE_SIZE = 5;
class SearchFacetFiltersService {
    constructor(queryBuilder, searchService, translationService, categoryService) {
        this.queryBuilder = queryBuilder;
        this.searchService = searchService;
        this.translationService = translationService;
        this.categoryService = categoryService;
        /** All facet field items to be displayed in the component. These are updated according to the response.
         *  When a new search is performed, the already existing items are updated with the new bucket count values and
         *  the newly received items are added to the responseFacets.
         */
        this.responseFacets = null;
        /** shows the facet chips */
        this.selectedBuckets = [];
        this.facetQueriesPageSize = DEFAULT_PAGE_SIZE;
        this.onDestroy$ = new Subject();
        if (queryBuilder.config && queryBuilder.config.facetQueries) {
            this.facetQueriesPageSize = queryBuilder.config.facetQueries.pageSize || DEFAULT_PAGE_SIZE;
        }
        this.queryBuilder.configUpdated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
            this.selectedBuckets = [];
            this.responseFacets = null;
        });
        this.queryBuilder.updated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((query) => this.queryBuilder.execute(query));
        this.queryBuilder.executed
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((resultSetPaging) => {
            this.onDataLoaded(resultSetPaging);
            this.searchService.dataLoaded.next(resultSetPaging);
        });
    }
    onDataLoaded(data) {
        const context = data.list.context;
        if (context) {
            this.parseFacets(context);
        }
        else {
            this.responseFacets = null;
        }
    }
    parseFacets(context) {
        this.parseFacetFields(context);
        this.parseFacetIntervals(context);
        this.parseFacetQueries(context);
        this.sortFacets();
    }
    parseFacetItems(context, configFacetFields, itemType) {
        configFacetFields.forEach((field) => {
            const responseField = this.findFacet(context, itemType, field.label);
            const responseBuckets = this.getResponseBuckets(responseField, field)
                .filter(this.getFilterByMinCount(field.mincount));
            this.sortFacetBuckets(responseBuckets, field.settings?.bucketSortBy, field.settings?.bucketSortDirection ?? FacetBucketSortDirection.ASCENDING);
            const alreadyExistingField = this.findResponseFacet(itemType, field.label);
            if (field.field === 'cm:categories') {
                this.loadCategoryNames(responseBuckets);
            }
            if (alreadyExistingField) {
                const alreadyExistingBuckets = alreadyExistingField.buckets && alreadyExistingField.buckets.items || [];
                this.updateExistingBuckets(responseField, responseBuckets, alreadyExistingField, alreadyExistingBuckets);
            }
            else if (responseField) {
                if (responseBuckets.length > 0) {
                    const bucketList = new SearchFilterList(responseBuckets, field.pageSize);
                    bucketList.filter = this.getBucketFilterFunction(bucketList);
                    if (!this.responseFacets) {
                        this.responseFacets = [];
                    }
                    this.responseFacets.push({
                        ...field,
                        type: responseField.type || itemType,
                        label: field.label,
                        pageSize: field.pageSize | DEFAULT_PAGE_SIZE,
                        currentPageSize: field.pageSize | DEFAULT_PAGE_SIZE,
                        buckets: bucketList
                    });
                }
            }
        });
    }
    parseFacetFields(context) {
        const configFacetFields = this.queryBuilder.config.facetFields && this.queryBuilder.config.facetFields.fields || [];
        this.parseFacetItems(context, configFacetFields, 'field');
    }
    parseFacetIntervals(context) {
        const configFacetIntervals = this.queryBuilder.config.facetIntervals && this.queryBuilder.config.facetIntervals.intervals || [];
        this.parseFacetItems(context, configFacetIntervals, 'interval');
    }
    parseFacetQueries(context) {
        const facetQuerySetting = this.queryBuilder.config.facetQueries?.settings || {};
        const configFacetQueries = this.queryBuilder.config.facetQueries && this.queryBuilder.config.facetQueries.queries || [];
        const configGroups = configFacetQueries.reduce((acc, query) => {
            const group = this.queryBuilder.getQueryGroup(query);
            if (acc[group]) {
                acc[group].push(query);
            }
            else {
                acc[group] = [query];
            }
            return acc;
        }, []);
        const mincount = this.queryBuilder.config.facetQueries && this.queryBuilder.config.facetQueries.mincount;
        const mincountFilter = this.getFilterByMinCount(mincount);
        Object.keys(configGroups).forEach((group) => {
            const responseField = this.findFacet(context, 'query', group);
            const responseBuckets = this.getResponseQueryBuckets(responseField, configGroups[group])
                .filter(mincountFilter);
            this.sortFacetBuckets(responseBuckets, facetQuerySetting?.bucketSortBy, facetQuerySetting.bucketSortDirection ?? FacetBucketSortDirection.ASCENDING);
            const alreadyExistingField = this.findResponseFacet('query', group);
            if (alreadyExistingField) {
                const alreadyExistingBuckets = alreadyExistingField.buckets && alreadyExistingField.buckets.items || [];
                this.updateExistingBuckets(responseField, responseBuckets, alreadyExistingField, alreadyExistingBuckets);
            }
            else if (responseField) {
                if (responseBuckets.length > 0) {
                    const bucketList = new SearchFilterList(responseBuckets, this.facetQueriesPageSize);
                    bucketList.filter = this.getBucketFilterFunction(bucketList);
                    if (!this.responseFacets) {
                        this.responseFacets = [];
                    }
                    this.responseFacets.push({
                        field: group,
                        type: responseField.type || 'query',
                        label: group,
                        pageSize: DEFAULT_PAGE_SIZE,
                        currentPageSize: DEFAULT_PAGE_SIZE,
                        buckets: bucketList,
                        settings: facetQuerySetting
                    });
                }
            }
        });
    }
    sortFacets() {
        this.responseFacets?.sort((facet1, facet2) => (facet1.settings?.facetOrder ?? 0) - (facet2.settings?.facetOrder ?? 0));
    }
    getResponseBuckets(responseField, configField) {
        return ((responseField && responseField.buckets) || []).map((respBucket) => {
            respBucket['count'] = this.getCountValue(respBucket);
            respBucket.filterQuery = respBucket.filterQuery || this.getCorrespondingFilterQuery(configField, respBucket.label);
            return {
                ...respBucket,
                checked: false,
                display: respBucket.display,
                label: respBucket.label
            };
        });
    }
    getResponseQueryBuckets(responseField, configGroup) {
        return (configGroup || []).map((query) => {
            const respBucket = ((responseField && responseField.buckets) || [])
                .find((bucket) => bucket.label === query.label) || {};
            respBucket['count'] = this.getCountValue(respBucket);
            return {
                ...respBucket,
                checked: false,
                display: respBucket.display,
                label: respBucket.label
            };
        });
    }
    sortFacetBuckets(buckets, sortBy, sortDirection) {
        switch (sortBy) {
            case FacetBucketSortBy.LABEL:
                buckets.sort((bucket1, bucket2) => sortDirection === FacetBucketSortDirection.ASCENDING ? bucket1.label.localeCompare(bucket2.label) : bucket2.label.localeCompare(bucket1.label));
                break;
            case FacetBucketSortBy.COUNT:
                buckets.sort((bucket1, bucket2) => sortDirection === FacetBucketSortDirection.ASCENDING ? bucket1.count - bucket2.count : bucket2.count - bucket1.count);
                break;
            default:
                return;
        }
    }
    getCountValue(bucket) {
        return (!!bucket && !!bucket.metrics && bucket.metrics[0]?.value?.count) || 0;
    }
    getBucketCountDisplay(bucket) {
        return bucket.count === null ? '' : `(${bucket.count})`;
    }
    getFilterByMinCount(mincountInput) {
        return (bucket) => {
            let mincount = mincountInput;
            if (mincount === undefined) {
                mincount = 1;
            }
            return bucket.count >= mincount;
        };
    }
    getCorrespondingFilterQuery(configFacetItem, bucketLabel) {
        let filterQuery = null;
        if (configFacetItem.field && bucketLabel) {
            if (configFacetItem.sets) {
                const configSet = configFacetItem.sets.find((set) => bucketLabel === set.label);
                if (configSet) {
                    filterQuery = this.buildIntervalQuery(configFacetItem.field, configSet);
                }
            }
            else {
                filterQuery = `${configFacetItem.field}:"${bucketLabel}"`;
            }
        }
        return filterQuery;
    }
    buildIntervalQuery(fieldName, interval) {
        const start = interval.start;
        const end = interval.end;
        const startLimit = (interval.startInclusive === undefined || interval.startInclusive === true) ? '[' : '<';
        const endLimit = (interval.endInclusive === undefined || interval.endInclusive === true) ? ']' : '>';
        return `${fieldName}:${startLimit}"${start}" TO "${end}"${endLimit}`;
    }
    findFacet(context, itemType, fieldLabel) {
        return (context.facets || []).find((response) => response.type === itemType && response.label === fieldLabel) || {};
    }
    findResponseFacet(itemType, fieldLabel) {
        return (this.responseFacets || []).find((response) => response.type === itemType && response.label === fieldLabel);
    }
    updateExistingBuckets(responseField, responseBuckets, alreadyExistingField, alreadyExistingBuckets) {
        const bucketsToDelete = [];
        alreadyExistingBuckets
            .map((bucket) => {
            const responseBucket = ((responseField && responseField.buckets) || []).find((respBucket) => respBucket.label === bucket.label);
            if (!responseBucket) {
                bucketsToDelete.push(bucket);
            }
            bucket.count = this.getCountValue(responseBucket);
            return bucket;
        });
        const hasSelection = this.selectedBuckets
            .find((selBuckets) => alreadyExistingField.label === selBuckets.field.label && alreadyExistingField.type === selBuckets.field.type);
        if (!hasSelection && bucketsToDelete.length) {
            bucketsToDelete.forEach((bucket) => {
                alreadyExistingField.buckets.deleteItem(bucket);
            });
        }
        responseBuckets.forEach((respBucket) => {
            const existingBucket = alreadyExistingBuckets.find((oldBucket) => oldBucket.label === respBucket.label);
            if (!existingBucket) {
                alreadyExistingField.buckets.addItem(respBucket);
            }
        });
    }
    getBucketFilterFunction(bucketList) {
        return (bucket) => {
            if (bucket && bucketList.filterText) {
                const pattern = (bucketList.filterText || '').toLowerCase();
                const label = (this.translationService.instant(bucket.display) || this.translationService.instant(bucket.label)).toLowerCase();
                return this.queryBuilder.config.filterWithContains ? label.indexOf(pattern) !== -1 : label.startsWith(pattern);
            }
            return true;
        };
    }
    loadCategoryNames(bucketList) {
        bucketList.forEach((item) => {
            const categoryId = item.label.split('/').pop();
            this.categoryService.getCategory(categoryId, { include: ['path'] })
                .pipe(catchError(error => throwError(error)))
                .subscribe(category => {
                const nextAfterGeneralPathPartIndex = 3;
                const pathSeparator = '/';
                const path = category.entry.path.split(pathSeparator).slice(nextAfterGeneralPathPartIndex).join('/');
                item.display = path ? `${path}/${category.entry.name}` : category.entry.name;
            });
        });
    }
    unselectFacetBucket(field, bucket) {
        if (bucket) {
            bucket.checked = false;
            this.queryBuilder.removeUserFacetBucket(field, bucket);
            this.updateSelectedBuckets();
            this.queryBuilder.update();
        }
    }
    /* update adf-search-chip-list component view */
    updateSelectedBuckets() {
        if (this.responseFacets) {
            this.selectedBuckets = [];
            for (const field of this.responseFacets) {
                if (field.buckets) {
                    this.selectedBuckets.push(...this.queryBuilder.getUserFacetBuckets(field.field)
                        .filter((bucket) => bucket.checked)
                        .map((bucket) => ({ field, bucket })));
                }
            }
        }
        else {
            this.selectedBuckets = [];
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    resetAllSelectedBuckets() {
        this.responseFacets.forEach((field) => {
            if (field && field.buckets) {
                for (const bucket of field.buckets.items) {
                    bucket.checked = false;
                    this.queryBuilder.removeUserFacetBucket(field, bucket);
                }
                this.updateSelectedBuckets();
            }
        });
        this.queryBuilder.update();
    }
    resetQueryFragments() {
        this.queryBuilder.queryFragments = {};
        this.queryBuilder.resetToDefaults();
    }
    reset() {
        this.responseFacets = [];
        this.selectedBuckets = [];
        this.queryBuilder.resetToDefaults();
        this.queryBuilder.update();
    }
}
SearchFacetFiltersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetFiltersService, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }, { token: SearchService }, { token: i1.TranslationService }, { token: CategoryService }], target: i0.ɵɵFactoryTarget.Injectable });
SearchFacetFiltersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetFiltersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetFiltersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: SearchService }, { type: i1.TranslationService }, { type: CategoryService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFacetFieldComponent {
    constructor(queryBuilder, searchFacetFiltersService, translationService) {
        this.queryBuilder = queryBuilder;
        this.searchFacetFiltersService = searchFacetFiltersService;
        this.translationService = translationService;
        this.displayValue$ = new Subject();
    }
    get canUpdateOnChange() {
        return this.field.settings?.allowUpdateOnChange ?? true;
    }
    onToggleBucket(event, field, bucket) {
        if (event && bucket) {
            if (event.checked) {
                this.selectFacetBucket(field, bucket);
            }
            else {
                this.unselectFacetBucket(field, bucket);
            }
        }
    }
    selectFacetBucket(field, bucket) {
        if (bucket) {
            bucket.checked = true;
            this.queryBuilder.addUserFacetBucket(field, bucket);
            this.searchFacetFiltersService.updateSelectedBuckets();
            if (this.canUpdateOnChange) {
                this.updateDisplayValue();
                this.queryBuilder.update();
            }
        }
    }
    unselectFacetBucket(field, bucket) {
        if (bucket) {
            bucket.checked = false;
            this.queryBuilder.removeUserFacetBucket(field, bucket);
            this.searchFacetFiltersService.updateSelectedBuckets();
            if (this.canUpdateOnChange) {
                this.updateDisplayValue();
                this.queryBuilder.update();
            }
        }
    }
    canResetSelectedBuckets(field) {
        if (field && field.buckets) {
            return field.buckets.items.some((bucket) => bucket.checked);
        }
        return false;
    }
    resetSelectedBuckets(field) {
        if (field && field.buckets) {
            for (const bucket of field.buckets.items) {
                bucket.checked = false;
                this.queryBuilder.removeUserFacetBucket(field, bucket);
            }
            this.searchFacetFiltersService.updateSelectedBuckets();
            if (this.canUpdateOnChange) {
                this.queryBuilder.update();
            }
        }
    }
    getBucketCountDisplay(bucket) {
        return bucket.count === null ? '' : `(${bucket.count})`;
    }
    updateDisplayValue() {
        if (!this.field.buckets?.items) {
            this.displayValue$.next('');
        }
        else {
            const displayValue = this.field.buckets?.items?.filter((item) => item.checked)
                .map((item) => this.translationService.instant(item.display || item.label))
                .join(', ');
            this.displayValue$.next(displayValue);
        }
    }
    reset() {
        this.resetSelectedBuckets(this.field);
        this.updateDisplayValue();
        this.queryBuilder.update();
    }
    submitValues() {
        this.updateDisplayValue();
        this.queryBuilder.update();
    }
}
SearchFacetFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetFieldComponent, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }, { token: SearchFacetFiltersService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
SearchFacetFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFacetFieldComponent, selector: "adf-search-facet-field", inputs: { field: "field" }, ngImport: i0, template: "<div class=\"adf-search-filter-facet\">\n    <div class=\"adf-facet-result-filter\">\n        <div class=\"adf-facet-search-container\">\n            <button mat-icon-button class=\"adf-facet-search-icon\" tabindex=\"-1\">\n                <mat-icon>search</mat-icon>\n            </button>\n            <mat-form-field class=\"adf-facet-search-field\" floatLabel=\"never\">\n                <input matInput placeholder=\"{{ 'SEARCH.FILTER.ACTIONS.SEARCH' | translate }}\"\n                       [attr.data-automation-id]=\"'facet-result-filter-'+field.label\" [(ngModel)]=\"field.buckets.filterText\">\n                <button *ngIf=\"field.buckets.filterText\" mat-button matSuffix mat-icon-button\n                        [attr.title]=\"'SEARCH.FILTER.BUTTONS.CLEAR' | translate\"\n                        (click)=\"field.buckets.filterText = ''\">\n                    <mat-icon role=\"button\" [attr.aria-label]=\"'SEARCH.FILTER.BUTTONS.CLEAR' | translate\">clear</mat-icon>\n                </button>\n            </mat-form-field>\n        </div>\n    </div>\n\n    <div class=\"adf-checklist\">\n        <mat-checkbox *ngFor=\"let bucket of field.buckets\" [checked]=\"bucket.checked\"\n            [attr.data-automation-id]=\"'checkbox-'+field.label+'-'+(bucket.display || bucket.label)\"\n            (change)=\"onToggleBucket($event, field, bucket)\">\n            <div matTooltip=\"{{ bucket.display || bucket.label | translate }} {{ getBucketCountDisplay(bucket) }}\"\n                matTooltipPosition=\"right\" class=\"adf-facet-label\">\n                {{ bucket.display || bucket.label | translate }} {{ getBucketCountDisplay(bucket) }}\n            </div>\n        </mat-checkbox>\n    </div>\n\n    <div class=\"adf-facet-buttons\" *ngIf=\"field.buckets.fitsPage && !field.settings?.hideDefaultAction\">\n        <button *ngIf=\"canResetSelectedBuckets(field)\" mat-button color=\"primary\" (click)=\"resetSelectedBuckets(field)\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\n        </button>\n    </div>\n\n    <div class=\"adf-facet-buttons\" *ngIf=\"!field.buckets.fitsPage\">\n        <button mat-icon-button *ngIf=\"canResetSelectedBuckets(field)\"\n            title=\"{{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\" (click)=\"resetSelectedBuckets(field)\">\n            <mat-icon>clear</mat-icon>\n        </button>\n        <button mat-icon-button *ngIf=\"field.buckets.canShowLessItems\" (click)=\"field.buckets.showLessItems()\"\n            title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-LESS' | translate }}\">\n            <mat-icon>keyboard_arrow_up</mat-icon>\n        </button>\n        <button mat-icon-button *ngIf=\"field.buckets.canShowMoreItems\" (click)=\"field.buckets.showMoreItems()\"\n            title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-MORE' | translate }}\">\n            <mat-icon>keyboard_arrow_down</mat-icon>\n        </button>\n    </div>\n</div>\n", styles: [".adf-search-filter-facet .adf-checklist{display:flex;flex-direction:column;max-height:180px;padding:5px 0;overflow-y:auto}.adf-search-filter-facet .adf-checklist .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;width:100%}.adf-search-filter-facet .adf-checklist .mat-checkbox-layout{width:100%}.adf-search-filter-facet .adf-checklist .adf-facet-label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.adf-search-filter-facet .adf-checklist .mat-checkbox{margin:5px}.adf-search-filter-facet .adf-checklist .mat-checkbox.mat-checkbox-checked .mat-checkbox-label{font-weight:700}.adf-search-filter-facet .adf-facet-result-filter{padding-bottom:16px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container{border-radius:6px;background:var(--theme-background-color);display:flex;height:32px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-icon{width:27px;margin-top:-4px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-icon .mat-icon{font-size:var(--theme-subheading-1-font-size)}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-field{padding:2px;flex:1;margin-top:-16px;font-size:var(--theme-body-1-font-size);line-height:24px;letter-spacing:.25px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-field .mat-form-field-underline{display:none}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-field .mat-form-field-suffix{padding-right:1px}.adf-search-filter-facet .adf-facet-buttons{text-align:right}.adf-search-filter-facet .adf-facet-buttons .mat-button{text-transform:uppercase}.adf-search-filter-facet .adf-facet-buttons--topSpace{padding-top:15px}.adf-search-filter-facet .mat-checkbox-label,.adf-search-filter-facet .mat-radio-label{color:var(--adf-theme-foreground-text-color-054)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i5$3.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-facet-field', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-search-filter-facet\">\n    <div class=\"adf-facet-result-filter\">\n        <div class=\"adf-facet-search-container\">\n            <button mat-icon-button class=\"adf-facet-search-icon\" tabindex=\"-1\">\n                <mat-icon>search</mat-icon>\n            </button>\n            <mat-form-field class=\"adf-facet-search-field\" floatLabel=\"never\">\n                <input matInput placeholder=\"{{ 'SEARCH.FILTER.ACTIONS.SEARCH' | translate }}\"\n                       [attr.data-automation-id]=\"'facet-result-filter-'+field.label\" [(ngModel)]=\"field.buckets.filterText\">\n                <button *ngIf=\"field.buckets.filterText\" mat-button matSuffix mat-icon-button\n                        [attr.title]=\"'SEARCH.FILTER.BUTTONS.CLEAR' | translate\"\n                        (click)=\"field.buckets.filterText = ''\">\n                    <mat-icon role=\"button\" [attr.aria-label]=\"'SEARCH.FILTER.BUTTONS.CLEAR' | translate\">clear</mat-icon>\n                </button>\n            </mat-form-field>\n        </div>\n    </div>\n\n    <div class=\"adf-checklist\">\n        <mat-checkbox *ngFor=\"let bucket of field.buckets\" [checked]=\"bucket.checked\"\n            [attr.data-automation-id]=\"'checkbox-'+field.label+'-'+(bucket.display || bucket.label)\"\n            (change)=\"onToggleBucket($event, field, bucket)\">\n            <div matTooltip=\"{{ bucket.display || bucket.label | translate }} {{ getBucketCountDisplay(bucket) }}\"\n                matTooltipPosition=\"right\" class=\"adf-facet-label\">\n                {{ bucket.display || bucket.label | translate }} {{ getBucketCountDisplay(bucket) }}\n            </div>\n        </mat-checkbox>\n    </div>\n\n    <div class=\"adf-facet-buttons\" *ngIf=\"field.buckets.fitsPage && !field.settings?.hideDefaultAction\">\n        <button *ngIf=\"canResetSelectedBuckets(field)\" mat-button color=\"primary\" (click)=\"resetSelectedBuckets(field)\">\n            {{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\n        </button>\n    </div>\n\n    <div class=\"adf-facet-buttons\" *ngIf=\"!field.buckets.fitsPage\">\n        <button mat-icon-button *ngIf=\"canResetSelectedBuckets(field)\"\n            title=\"{{ 'SEARCH.FILTER.ACTIONS.CLEAR-ALL' | translate }}\" (click)=\"resetSelectedBuckets(field)\">\n            <mat-icon>clear</mat-icon>\n        </button>\n        <button mat-icon-button *ngIf=\"field.buckets.canShowLessItems\" (click)=\"field.buckets.showLessItems()\"\n            title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-LESS' | translate }}\">\n            <mat-icon>keyboard_arrow_up</mat-icon>\n        </button>\n        <button mat-icon-button *ngIf=\"field.buckets.canShowMoreItems\" (click)=\"field.buckets.showMoreItems()\"\n            title=\"{{ 'SEARCH.FILTER.ACTIONS.SHOW-MORE' | translate }}\">\n            <mat-icon>keyboard_arrow_down</mat-icon>\n        </button>\n    </div>\n</div>\n", styles: [".adf-search-filter-facet .adf-checklist{display:flex;flex-direction:column;max-height:180px;padding:5px 0;overflow-y:auto}.adf-search-filter-facet .adf-checklist .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;width:100%}.adf-search-filter-facet .adf-checklist .mat-checkbox-layout{width:100%}.adf-search-filter-facet .adf-checklist .adf-facet-label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.adf-search-filter-facet .adf-checklist .mat-checkbox{margin:5px}.adf-search-filter-facet .adf-checklist .mat-checkbox.mat-checkbox-checked .mat-checkbox-label{font-weight:700}.adf-search-filter-facet .adf-facet-result-filter{padding-bottom:16px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container{border-radius:6px;background:var(--theme-background-color);display:flex;height:32px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-icon{width:27px;margin-top:-4px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-icon .mat-icon{font-size:var(--theme-subheading-1-font-size)}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-field{padding:2px;flex:1;margin-top:-16px;font-size:var(--theme-body-1-font-size);line-height:24px;letter-spacing:.25px}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-field .mat-form-field-underline{display:none}.adf-search-filter-facet .adf-facet-result-filter .adf-facet-search-container .adf-facet-search-field .mat-form-field-suffix{padding-right:1px}.adf-search-filter-facet .adf-facet-buttons{text-align:right}.adf-search-filter-facet .adf-facet-buttons .mat-button{text-transform:uppercase}.adf-search-filter-facet .adf-facet-buttons--topSpace{padding-top:15px}.adf-search-filter-facet .mat-checkbox-label,.adf-search-filter-facet .mat-radio-label{color:var(--adf-theme-foreground-text-color-054)}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: SearchFacetFiltersService }, { type: i1.TranslationService }]; }, propDecorators: { field: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ResetSearchDirective {
    constructor(filterService) {
        this.filterService = filterService;
    }
    onClick() {
        this.filterService.reset();
    }
}
ResetSearchDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResetSearchDirective, deps: [{ token: SearchFacetFiltersService }], target: i0.ɵɵFactoryTarget.Directive });
ResetSearchDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: ResetSearchDirective, selector: "[adf-reset-search]", host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ResetSearchDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-reset-search]'
                }]
        }], ctorParameters: function () { return [{ type: SearchFacetFiltersService }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFilterComponent {
    constructor(queryBuilder, facetFiltersService) {
        this.queryBuilder = queryBuilder;
        this.facetFiltersService = facetFiltersService;
        /** Toggles whether to show or not the context facet filters. */
        this.showContextFacets = true;
        this.facetQueriesLabel = 'Facet Queries';
        this.facetExpanded = {
            default: false
        };
        if (queryBuilder.config && queryBuilder.config.facetQueries) {
            this.facetQueriesLabel = queryBuilder.config.facetQueries.label || 'Facet Queries';
            this.facetExpanded['query'] = queryBuilder.config.facetQueries.expanded;
        }
        if (queryBuilder.config && queryBuilder.config.facetFields) {
            this.facetExpanded['field'] = queryBuilder.config.facetFields.expanded;
        }
        if (queryBuilder.config && queryBuilder.config.facetIntervals) {
            this.facetExpanded['interval'] = queryBuilder.config.facetIntervals.expanded;
        }
        this.displayResetButton = this.queryBuilder.config && !!this.queryBuilder.config.resetButton;
    }
    shouldExpand(field) {
        return this.facetExpanded[field.type] || this.facetExpanded['default'];
    }
    getBucketCountDisplay(bucket) {
        return bucket.count === null ? '' : `(${bucket.count})`;
    }
}
SearchFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterComponent, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }, { token: SearchFacetFiltersService }], target: i0.ɵɵFactoryTarget.Component });
SearchFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFilterComponent, selector: "adf-search-filter", inputs: { showContextFacets: "showContextFacets" }, host: { classAttribute: "adf-search-filter" }, ngImport: i0, template: "<mat-accordion multi=\"true\" displayMode=\"flat\">\n\n    <button *ngIf=\"displayResetButton && facetFiltersService.responseFacets\"\n            mat-button\n            color=\"primary\"\n            matTooltip=\"{{ 'SEARCH.FILTER.BUTTONS.RESET-ALL.TOOLTIP' | translate }}\"\n            matTooltipPosition=\"right\"\n            adf-reset-search>\n        {{ 'SEARCH.FILTER.BUTTONS.RESET-ALL.LABEL' | translate }}\n    </button>\n    <mat-expansion-panel\n        *ngFor=\"let category of queryBuilder.categories\"\n        [attr.data-automation-id]=\"'expansion-panel-'+category.name\"\n        [(expanded)]=\"category.expanded\">\n        <mat-expansion-panel-header>\n            <mat-panel-title>\n                {{ category.name | translate }}\n            </mat-panel-title>\n        </mat-expansion-panel-header>\n        <adf-search-widget-container\n            [id]=\"category.id\"\n            [selector]=\"category.component.selector\"\n            [settings]=\"category.component.settings\">\n        </adf-search-widget-container>\n    </mat-expansion-panel>\n\n    <ng-container *ngIf=\"facetFiltersService.responseFacets && showContextFacets\">\n        <mat-expansion-panel [attr.data-automation-id]=\"'expansion-panel-'+field.label\" *ngFor=\"let field of facetFiltersService.responseFacets\"\n                             [expanded]=\"shouldExpand(field)\">\n            <mat-expansion-panel-header>\n                <mat-panel-title>{{ field.label | translate }}</mat-panel-title>\n            </mat-expansion-panel-header>\n\n            <adf-search-facet-field [field]=\"field\"></adf-search-facet-field>\n\n        </mat-expansion-panel>\n    </ng-container>\n</mat-accordion>\n", styles: [".adf-search-filter .mat-expansion-panel-header-title{font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087)}.adf-search-filter .mat-checkbox-label,.adf-search-filter .mat-radio-label{color:var(--adf-theme-foreground-text-color-054)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i5$4.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i5$4.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i5$4.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i5$4.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: SearchWidgetContainerComponent, selector: "adf-search-widget-container", inputs: ["id", "selector", "settings", "config", "value"] }, { kind: "component", type: SearchFacetFieldComponent, selector: "adf-search-facet-field", inputs: ["field"] }, { kind: "directive", type: ResetSearchDirective, selector: "[adf-reset-search]" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-filter', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-filter' }, template: "<mat-accordion multi=\"true\" displayMode=\"flat\">\n\n    <button *ngIf=\"displayResetButton && facetFiltersService.responseFacets\"\n            mat-button\n            color=\"primary\"\n            matTooltip=\"{{ 'SEARCH.FILTER.BUTTONS.RESET-ALL.TOOLTIP' | translate }}\"\n            matTooltipPosition=\"right\"\n            adf-reset-search>\n        {{ 'SEARCH.FILTER.BUTTONS.RESET-ALL.LABEL' | translate }}\n    </button>\n    <mat-expansion-panel\n        *ngFor=\"let category of queryBuilder.categories\"\n        [attr.data-automation-id]=\"'expansion-panel-'+category.name\"\n        [(expanded)]=\"category.expanded\">\n        <mat-expansion-panel-header>\n            <mat-panel-title>\n                {{ category.name | translate }}\n            </mat-panel-title>\n        </mat-expansion-panel-header>\n        <adf-search-widget-container\n            [id]=\"category.id\"\n            [selector]=\"category.component.selector\"\n            [settings]=\"category.component.settings\">\n        </adf-search-widget-container>\n    </mat-expansion-panel>\n\n    <ng-container *ngIf=\"facetFiltersService.responseFacets && showContextFacets\">\n        <mat-expansion-panel [attr.data-automation-id]=\"'expansion-panel-'+field.label\" *ngFor=\"let field of facetFiltersService.responseFacets\"\n                             [expanded]=\"shouldExpand(field)\">\n            <mat-expansion-panel-header>\n                <mat-panel-title>{{ field.label | translate }}</mat-panel-title>\n            </mat-expansion-panel-header>\n\n            <adf-search-facet-field [field]=\"field\"></adf-search-facet-field>\n\n        </mat-expansion-panel>\n    </ng-container>\n</mat-accordion>\n", styles: [".adf-search-filter .mat-expansion-panel-header-title{font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087)}.adf-search-filter .mat-checkbox-label,.adf-search-filter .mat-radio-label{color:var(--adf-theme-foreground-text-color-054)}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: SearchFacetFiltersService }]; }, propDecorators: { showContextFacets: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchPanelComponent {
    constructor(contentNodeSelectorPanelService, queryBuilderService) {
        this.contentNodeSelectorPanelService = contentNodeSelectorPanelService;
        this.queryBuilderService = queryBuilderService;
    }
    ngOnInit() {
        this.queryBuilderService.categories = this.contentNodeSelectorPanelService.convertCustomModelPropertiesToSearchCategories();
    }
    hasCustomModels() {
        return this.contentNodeSelectorPanelService?.customModels?.length > 0;
    }
}
SearchPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchPanelComponent, deps: [{ token: ContentNodeSelectorPanelService }, { token: SEARCH_QUERY_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component });
SearchPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchPanelComponent, selector: "adf-search-panel", host: { classAttribute: "adf-search-panel" }, ngImport: i0, template: "<div class=\"adf-search-panel-scrollable\" data-automation-id=\"adf-search-panel-container\">\n    <adf-search-filter *ngIf=\"hasCustomModels()\"\n                       class=\"app-search-settings\"\n                       [showContextFacets]=\"false\">\n    </adf-search-filter>\n</div>\n", styles: [".adf-search-panel-scrollable{overflow:scroll;max-height:349px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SearchFilterComponent, selector: "adf-search-filter", inputs: ["showContextFacets"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-panel', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-panel' }, template: "<div class=\"adf-search-panel-scrollable\" data-automation-id=\"adf-search-panel-container\">\n    <adf-search-filter *ngIf=\"hasCustomModels()\"\n                       class=\"app-search-settings\"\n                       [showContextFacets]=\"false\">\n    </adf-search-filter>\n</div>\n", styles: [".adf-search-panel-scrollable{overflow:scroll;max-height:349px}\n"] }]
        }], ctorParameters: function () { return [{ type: ContentNodeSelectorPanelService }, { type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AutoFocusDirective {
    constructor(el) {
        this.el = el;
    }
    ngAfterContentInit() {
        setTimeout(() => {
            this.el.nativeElement.focus();
        }, 100);
    }
}
AutoFocusDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AutoFocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
AutoFocusDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: AutoFocusDirective, selector: "[adf-auto-focus]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AutoFocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-auto-focus]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NameLocationCellComponent {
    constructor() {
        this.name = '';
        this.path = '';
    }
    ngOnInit() {
        if (this.row) {
            this.name = this.row.getValue('name');
            const fullPath = this.row.getValue('path');
            if (fullPath) {
                this.path = fullPath.name || '';
            }
        }
    }
}
NameLocationCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NameLocationCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NameLocationCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NameLocationCellComponent, selector: "adf-name-location-cell", inputs: { row: "row" }, host: { classAttribute: "adf-name-location-cell adf-datatable-content-cell" }, ngImport: i0, template: `
        <div class="adf-name-location-cell-name adf-datatable-cell-value" [title]="name">{{ name }}</div>
        <div class="adf-name-location-cell-location adf-datatable-cell-value" [title]="path">{{ path }}</div>
    `, isInline: true, styles: [".adf-name-location-cell{display:grid}.adf-name-location-cell-location{color:var(--adf-theme-foreground-text-color-054);font-size:var(--theme-caption-font-size)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NameLocationCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-name-location-cell', template: `
        <div class="adf-name-location-cell-name adf-datatable-cell-value" [title]="name">{{ name }}</div>
        <div class="adf-name-location-cell-location adf-datatable-cell-value" [title]="path">{{ path }}</div>
    `, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, host: { class: 'adf-name-location-cell adf-datatable-content-cell' }, styles: [".adf-name-location-cell{display:grid}.adf-name-location-cell-location{color:var(--adf-theme-foreground-text-color-054);font-size:var(--theme-caption-font-size)}\n"] }]
        }], propDecorators: { row: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const defaultValidation = () => true;
class ContentNodeSelectorPanelComponent {
    constructor(customResourcesService, queryBuilderService, userPreferencesService, nodesApiService, uploadService, sitesService, appConfigService, contentNodeSelectorPanelService) {
        this.customResourcesService = customResourcesService;
        this.queryBuilderService = queryBuilderService;
        this.userPreferencesService = userPreferencesService;
        this.nodesApiService = nodesApiService;
        this.uploadService = uploadService;
        this.sitesService = sitesService;
        this.appConfigService = appConfigService;
        this.contentNodeSelectorPanelService = contentNodeSelectorPanelService;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.DEFAULT_PAGINATION = new Pagination$1({
            maxItems: 25,
            skipCount: 0
        });
        this.showSiteList = true;
        this.showSearchField = true;
        this.showCounter = false;
        this._emptyList = true;
        /** If true will restrict the search and breadcrumbs to the currentFolderId */
        this.restrictRootToCurrentFolderId = false;
        /** Node ID of the folder currently listed. */
        this.currentFolderId = null;
        /** Hide the "My Files" option added to the site list by default.
         * See the [Sites Dropdown component](sites-dropdown.component.md)
         * for more information.
         */
        this.dropdownHideMyFiles = false;
        /** Custom site for site dropdown. This is the same as the `siteList`.
         * property of the Sites Dropdown component (see its doc page
         * for more information).
         */
        this.dropdownSiteList = null;
        this._rowFilter = defaultValidation;
        this._excludeSiteContent = [];
        /**
         * Custom image resolver function. See the
         * [Image Resolver Model](image-resolver.model.md) page
         * for more information.
         */
        this.imageResolver = null;
        /** Number of items shown per page in the list. */
        this.pageSize = this.DEFAULT_PAGINATION.maxItems;
        /** Define the selection mode for document list. The allowed values are single or multiple */
        this.selectionMode = 'single';
        /** Function used to decide if the selected node has permission to be selected.
         * Default value is a function that always returns true.
         */
        this.isSelectionValid = defaultValidation;
        /** Emitted when the user has chosen an item. */
        this.select = new EventEmitter();
        /** Emitted when the navigation changes. */
        this.navigationChange = new EventEmitter();
        /** Emitted when the select site changes. */
        this.siteChange = new EventEmitter();
        /** Emitted when search is running. */
        this.showingSearch = new EventEmitter();
        /** Emitted when current folder loaded. */
        this.currentFolder = new EventEmitter();
        /** Emitted when folder loaded. */
        this.folderLoaded = new EventEmitter();
        this.nodePaging = null;
        this.searchTerm = '';
        this.showingSearchResults = false;
        this.loadingSearchResults = false;
        this.inDialog = false;
        this._chosenNode = null;
        this.selectionWithoutValidation = null;
        this.folderIdToShow = null;
        this.breadcrumbFolderTitle = null;
        this.startSiteGuid = null;
        this.hasValidQuery = false;
        this.showHeader = ShowHeaderMode.Never;
        this.infiniteScroll = false;
        this.debounceSearch = 200;
        this.searchInput = new UntypedFormControl();
        this.preselectedNodes = [];
        this.currentUploadBatch = [];
        this.searchPanelExpanded = false;
        this.onDestroy$ = new Subject();
    }
    /**
     * Custom row filter function. See the
     * [Row Filter Model](row-filter.model.md) page
     * for more information.
     */
    set rowFilter(rowFilter) {
        this.createRowFilter(rowFilter);
    }
    get rowFilter() {
        return this._rowFilter;
    }
    /** Custom list of site content componentIds.
     * Used to filter out the corresponding items from the displayed nodes
     */
    set excludeSiteContent(excludeSiteContent) {
        this._excludeSiteContent = excludeSiteContent;
        this.createRowFilter(this._rowFilter);
    }
    get excludeSiteContent() {
        return this._excludeSiteContent;
    }
    /** Toggle search input rendering */
    set showSearch(value) {
        if (value !== undefined && value !== null) {
            this.showSearchField = value;
        }
    }
    get showSearch() {
        return this.showSearchField;
    }
    /** Toggle sites list dropdown rendering */
    set showDropdownSiteList(value) {
        if (value !== undefined && value !== null) {
            this.showSiteList = value;
        }
    }
    get showDropdownSiteList() {
        return this.showSiteList;
    }
    /** Shows the files and folders in the search result */
    set showFilesInResult(value) {
        if (value !== undefined && value !== null) {
            const showFilesQuery = `TYPE:'cm:folder'${value ? ` OR TYPE:'cm:content'` : ''}`;
            this.queryBuilderService.addFilterQuery(showFilesQuery);
        }
    }
    /** Shows the node counter in the breadcrumb */
    set showNodeCounter(value) {
        this.showCounter = value ?? false;
    }
    get showNodeCounter() {
        return this.showCounter;
    }
    set chosenNode(value) {
        this._chosenNode = value;
        this.select.next(value);
    }
    get chosenNode() {
        return this._chosenNode;
    }
    get emptyList() {
        return this._emptyList;
    }
    getSelectedCount() {
        return this.chosenNode?.length || 0;
    }
    ngOnInit() {
        this.searchInput.valueChanges
            .pipe(debounceTime(this.debounceSearch), takeUntil(this.onDestroy$))
            .subscribe((searchValue) => {
            this.searchTerm = searchValue;
            this.queryBuilderService.userQuery = searchValue.length > 0 ? `${searchValue}*` : searchValue;
            this.queryBuilderService.update();
        });
        this.queryBuilderService.updated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((queryBody) => {
            if (queryBody) {
                this.hasValidQuery = true;
                this.prepareDialogForNewSearch(queryBody);
                this.queryBuilderService.execute(queryBody);
            }
            else {
                this.hasValidQuery = false;
                this.resetFolderToShow();
                this.clearSearch();
            }
        });
        this.queryBuilderService.executed
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((results) => {
            if (this.hasValidQuery) {
                this.showSearchResults(results);
            }
        });
        this.userPreferencesService
            .select(UserPreferenceValues.PaginationSize)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(pagSize => this.pageSize = pagSize);
        this.target = this.documentList;
        this.folderIdToShow = this.currentFolderId;
        if (this.currentFolderId) {
            if (this.restrictRootToCurrentFolderId) {
                this.breadcrumbRootId = this.currentFolderId;
                this.siteId = this.currentFolderId;
            }
            else {
                this.getStartSite();
            }
        }
        this.breadcrumbTransform = this.breadcrumbTransform ? this.breadcrumbTransform : null;
        this.isSelectionValid = this.isSelectionValid ? this.isSelectionValid : defaultValidation;
        this.onFileUploadEvent();
        this.onFileUploadDeletedEvent();
        this.resetPagination();
        this.setSearchScopeToNodes();
        this.documentList.$folderNode
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((currentNode) => {
            this.currentFolder.emit(currentNode);
        });
        this.sorting = this.appConfigService.get('adf-content-node-selector.sorting', ['createdAt', 'desc']);
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    toggleSearchPanel() {
        this.searchPanelExpanded = !this.searchPanelExpanded;
    }
    hasCustomModels() {
        return this.contentNodeSelectorPanelService?.customModels?.length > 0;
    }
    onFileUploadEvent() {
        this.uploadService.fileUploadComplete
            .pipe(debounceTime(500), takeUntil(this.onDestroy$))
            .subscribe((fileUploadEvent) => {
            this.currentUploadBatch.push(fileUploadEvent.data);
            if (!this.uploadService.isUploading()) {
                this.preselectedNodes = this.getPreselectNodesBasedOnSelectionMode();
                this.currentUploadBatch = [];
                this.documentList.reloadWithoutResettingSelection();
            }
        });
    }
    onFileUploadDeletedEvent() {
        this.uploadService.fileUploadDeleted
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((deletedFileEvent) => {
            this.documentList.unselectRowFromNodeId(deletedFileEvent.file.data.entry.id);
            this.documentList.reloadWithoutResettingSelection();
        });
    }
    getStartSite() {
        this.nodesApiService.getNode(this.currentFolderId).subscribe((startNodeEntry) => {
            this.startSiteGuid = this.sitesService.getSiteNameFromNodePath(startNodeEntry);
            if (this.startSiteGuid) {
                this.sitesService.getSite(this.startSiteGuid).subscribe((startSiteEntry) => {
                    if (startSiteEntry instanceof SiteEntry) {
                        this.siteChange.emit(startSiteEntry.entry.title);
                    }
                });
            }
        });
    }
    createRowFilter(filter) {
        if (!filter) {
            filter = () => true;
        }
        this._rowFilter = (value, index, array) => filter(value, index, array) &&
            !this.isExcludedSiteContent(value);
    }
    isExcludedSiteContent(row) {
        const entry = row.node.entry;
        if (this._excludeSiteContent && this._excludeSiteContent.length &&
            entry &&
            entry.properties &&
            entry.properties['st:componentId']) {
            const excludedItem = this._excludeSiteContent.find((id) => entry.properties['st:componentId'] === id);
            return !!excludedItem;
        }
        return false;
    }
    /**
     * Updates the site attribute and starts a new search
     *
     * @param chosenSite SiteEntry to search within
     */
    siteChanged(chosenSite) {
        this.siteId = chosenSite.entry.guid;
        this.setTitleIfCustomSite(chosenSite);
        this.siteChange.emit(chosenSite.entry.title);
        this.queryBuilderService.update();
    }
    /**
     * Returns the actually selected|entered folder node or null in case of searching for the breadcrumb
     */
    get breadcrumbFolderNode() {
        let folderNode;
        if (this.showingSearchResults && this.selectionWithoutValidation?.length) {
            folderNode = this.selectionWithoutValidation[0];
        }
        else {
            folderNode = this.documentList.folderNode;
        }
        return folderNode;
    }
    /**
     * Prepares the dialog for a new search
     */
    prepareDialogForNewSearch(queryBody) {
        this.target = queryBody ? null : this.documentList;
        if (this.target) {
            this.infinitePaginationComponent.reset();
        }
        this.folderIdToShow = null;
        this.preselectedNodes = [];
        this.loadingSearchResults = true;
        this.addCorrespondingNodeIdsQuery();
        this.resetChosenNode();
    }
    /**
     * Clear the search input and reset to last folder node in which search was performed
     */
    clear() {
        this.searchTerm = '';
        this.queryBuilderService.userQuery = '';
        this.queryBuilderService.update();
    }
    /**
     * Resets the folder to be shown with the site selection or the initial landing folder
     */
    resetFolderToShow() {
        this.folderIdToShow = this.siteId || this.currentFolderId;
    }
    /**
     * Clear the search input and search related data
     */
    clearSearch() {
        this.searchTerm = '';
        this.nodePaging = null;
        this.resetPagination();
        this.resetChosenNode();
        this.showingSearchResults = false;
        this.showingSearch.emit(this.showingSearchResults);
    }
    addCorrespondingNodeIdsQuery() {
        let extraParentFiltering = '';
        if (this.customResourcesService.hasCorrespondingNodeIds(this.siteId)) {
            this.customResourcesService.getCorrespondingNodeIds(this.siteId)
                .subscribe((nodeIds) => {
                if (nodeIds && nodeIds.length) {
                    nodeIds
                        .filter((id) => id !== this.siteId)
                        .forEach((extraId) => {
                        extraParentFiltering += ` OR ANCESTOR:'workspace://SpacesStore/${extraId}'`;
                    });
                }
                const parentFiltering = this.siteId ? `ANCESTOR:'workspace://SpacesStore/${this.siteId}'${extraParentFiltering}` : '';
                this.queryBuilderService.addFilterQuery(parentFiltering);
            });
        }
        else {
            const parentFiltering = this.siteId ? `ANCESTOR:'workspace://SpacesStore/${this.siteId}'` : '';
            this.queryBuilderService.addFilterQuery(parentFiltering);
        }
    }
    setSearchScopeToNodes() {
        const scope = {
            locations: 'nodes'
        };
        this.queryBuilderService.setScope(scope);
    }
    /**
     * Show the results of the search
     *
     * @param results Search results
     */
    showSearchResults(results) {
        this.showingSearchResults = true;
        this.loadingSearchResults = false;
        this.showingSearch.emit(this.showingSearchResults);
        this.nodePaging = results;
    }
    /**
     * Sets showingSearchResults state to be able to differentiate between search results or folder results
     */
    onFolderChange($event) {
        this.folderIdToShow = $event.value.id;
        this.showingSearchResults = false;
        this.infiniteScroll = false;
        this.breadcrumbFolderTitle = null;
        this.preselectedNodes = [];
        this.clearSearch();
        this.navigationChange.emit($event);
    }
    /**
     * Attempts to set the currently loaded node
     */
    onFolderLoaded(nodePaging) {
        setTimeout(() => {
            this._emptyList = !this.documentList.data.getRows().length;
        });
        this.updatePaginationAfterRowFilter(nodePaging);
        if (!this.showingSearchResults) {
            this.attemptNodeSelection(this.documentList.folderNode);
        }
        this.folderLoaded.emit();
    }
    /**
     * Updates pagination.hasMoreItems to false after filtering only folders during 'COPY' and 'MOVE' action
     */
    updatePaginationAfterRowFilter(nodePaging) {
        if (this.documentList.data.getRows().length < nodePaging.list.pagination.maxItems) {
            nodePaging.list.pagination.hasMoreItems = false;
        }
    }
    /**
     * Returns whether breadcrumb has to be shown or not
     */
    showBreadcrumbs() {
        return !this.showingSearchResults || this.chosenNode;
    }
    /**
     * Loads the next batch of search results
     *
     * @param pagination Pagination object
     */
    getNextPageOfSearch(pagination) {
        this.infiniteScroll = true;
        this.queryBuilderService.paging.maxItems = pagination.maxItems;
        this.queryBuilderService.paging.skipCount = pagination.skipCount;
        if (this.searchTerm.length > 0) {
            this.queryBuilderService.update();
        }
    }
    /**
     * Selects node as chosen if it has the right permission, clears the selection otherwise
     *
     * @param entry
     */
    attemptNodeSelection(entry) {
        if (entry && this.isSelectionValid(entry)) {
            this.chosenNode = [entry];
        }
    }
    /**
     * Clears the chosen node
     */
    resetChosenNode() {
        this.chosenNode = null;
    }
    /**
     * It filters and emit the selection coming from the document list
     *
     * @param nodesEntries
     */
    onCurrentSelection(nodesEntries) {
        const validNodesEntity = nodesEntries.filter((node) => this.isSelectionValid(node.entry));
        this.chosenNode = validNodesEntity.map((node) => node.entry);
        this.selectionWithoutValidation = nodesEntries.map(node => node.entry);
    }
    setTitleIfCustomSite(site) {
        if (this.customResourcesService.isCustomSource(site.entry.guid)) {
            this.breadcrumbFolderTitle = site.entry.title;
            if (this.documentList.folderNode.path.elements) {
                this.breadcrumbFolderNode.name = site.entry.title;
                this.documentList.folderNode.path.elements = null;
            }
        }
        else {
            this.breadcrumbFolderTitle = null;
        }
    }
    hasPreselectNodes() {
        return this.preselectedNodes?.length > 0;
    }
    isSingleSelectionMode() {
        return this.selectionMode === 'single';
    }
    getPreselectNodesBasedOnSelectionMode() {
        let selectedNodes = [];
        if (this.currentUploadBatch?.length) {
            if (this.isSingleSelectionMode()) {
                selectedNodes = [this.currentUploadBatch[this.currentUploadBatch.length - 1]];
            }
            else {
                selectedNodes = this.currentUploadBatch;
            }
        }
        return selectedNodes;
    }
    resetPagination() {
        this.queryBuilderService.paging = {
            maxItems: this.pageSize,
            skipCount: this.DEFAULT_PAGINATION.skipCount
        };
    }
}
ContentNodeSelectorPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorPanelComponent, deps: [{ token: CustomResourcesService }, { token: SEARCH_QUERY_SERVICE_TOKEN }, { token: i1.UserPreferencesService }, { token: NodesApiService }, { token: UploadService }, { token: SitesService }, { token: i1.AppConfigService }, { token: ContentNodeSelectorPanelService }], target: i0.ɵɵFactoryTarget.Component });
ContentNodeSelectorPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentNodeSelectorPanelComponent, selector: "adf-content-node-selector-panel", inputs: { restrictRootToCurrentFolderId: "restrictRootToCurrentFolderId", currentFolderId: "currentFolderId", dropdownHideMyFiles: "dropdownHideMyFiles", dropdownSiteList: "dropdownSiteList", where: "where", rowFilter: "rowFilter", excludeSiteContent: "excludeSiteContent", imageResolver: "imageResolver", pageSize: "pageSize", selectionMode: "selectionMode", isSelectionValid: "isSelectionValid", breadcrumbTransform: "breadcrumbTransform", showSearch: "showSearch", showDropdownSiteList: "showDropdownSiteList", showFilesInResult: "showFilesInResult", showNodeCounter: "showNodeCounter" }, outputs: { select: "select", navigationChange: "navigationChange", siteChange: "siteChange", showingSearch: "showingSearch", currentFolder: "currentFolder", folderLoaded: "folderLoaded" }, host: { classAttribute: "adf-content-node-selector-panel" }, providers: [{
            provide: SEARCH_QUERY_SERVICE_TOKEN,
            useClass: SearchQueryBuilderService
        }], viewQueries: [{ propertyName: "documentList", first: true, predicate: ["documentList"], descendants: true, static: true }, { propertyName: "highlighter", first: true, predicate: HighlightDirective, descendants: true, static: true }, { propertyName: "infinitePaginationComponent", first: true, predicate: InfinitePaginationComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"adf-content-node-selector-content\">\n    <mat-form-field floatPlaceholder=\"never\" class=\"adf-content-node-selector-content-input\" *ngIf=\"showSearch\">\n        <input matInput\n            id=\"searchInput\"\n            [formControl]=\"searchInput\"\n            type=\"text\"\n            placeholder=\"{{'NODE_SELECTOR.SEARCH' | translate}}\"\n            [value]=\"searchTerm\"\n            adf-auto-focus\n            data-automation-id=\"content-node-selector-search-input\">\n\n        <mat-icon *ngIf=\"searchTerm.length > 0\"\n            matSuffix (click)=\"clear()\"\n            class=\"adf-content-node-selector-content-input-icon\"\n            data-automation-id=\"content-node-selector-search-clear\">clear\n        </mat-icon>\n\n        <mat-icon *ngIf=\"searchTerm.length === 0\"\n            matSuffix\n            class=\"adf-content-node-selector-content-input-icon\"\n            data-automation-id=\"content-node-selector-search-icon\">search\n        </mat-icon>\n\n    </mat-form-field>\n    <adf-sites-dropdown\n        *ngIf=\"showDropdownSiteList\"\n        class=\"full-width\"\n        (change)=\"siteChanged($event)\"\n        [placeholder]=\"'NODE_SELECTOR.SELECT_LIBRARY'\"\n        [hideMyFiles]=\"dropdownHideMyFiles\"\n        [siteList]=\"dropdownSiteList\"\n        [value]=\"startSiteGuid\"\n        data-automation-id=\"content-node-selector-sites-combo\">\n    </adf-sites-dropdown>\n    <button *ngIf=\"hasCustomModels()\"\n        data-automation-id=\"adf-toggle-search-panel-button\"\n        mat-icon-button\n        (click)=\"toggleSearchPanel()\">\n        <mat-icon>filter_list</mat-icon>\n        {{ 'SEARCH.SEARCH_HEADER.TITLE' | translate }}\n    </button>\n    <div class=\"adf-content-node-selector-search-panel-container\">\n        <adf-search-panel *ngIf=\"searchPanelExpanded\">\n        </adf-search-panel>\n        <div class=\"adf-content-node-selector-document-list-container\">\n    <adf-toolbar>\n        <adf-toolbar-title>\n            <ng-container *ngIf=\"!showBreadcrumbs()\">\n                <h2 class=\"adf-search-results-label\">{{ 'NODE_SELECTOR.SEARCH_RESULTS' | translate }}</h2>\n            </ng-container>\n            <adf-dropdown-breadcrumb *ngIf=\"showBreadcrumbs()\"\n                class=\"adf-content-node-selector-content-breadcrumb\"\n                (navigate)=\"clearSearch()\"\n                [target]=\"documentList\"\n                [rootId]=\"breadcrumbRootId\"\n                [transform]=\"breadcrumbTransform\"\n                [folderNode]=\"breadcrumbFolderNode\"\n                [root]=\"breadcrumbFolderTitle\"\n                data-automation-id=\"content-node-selector-content-breadcrumb\">\n            </adf-dropdown-breadcrumb>\n            <ng-container *ngIf=\"showNodeCounter\" [adf-node-counter]=\"getSelectedCount()\"></ng-container>\n        </adf-toolbar-title>\n    </adf-toolbar>\n\n    <div\n        class=\"adf-content-node-selector-content-list\"\n        [class.adf-content-node-selector-content-list-searchLayout]=\"showingSearchResults\"\n        data-automation-id=\"content-node-selector-content-list\">\n        <adf-document-list\n            #documentList\n            [adf-highlight]=\"searchTerm\"\n            adf-highlight-selector=\".adf-name-location-cell-name\"\n            [showHeader]=\"showHeader\"\n            [node]=\"nodePaging\"\n            [preselectNodes]=\"preselectedNodes\"\n            [maxItems]=\"pageSize\"\n            [rowFilter]=\"_rowFilter\"\n            [imageResolver]=\"imageResolver\"\n            [currentFolderId]=\"folderIdToShow\"\n            [selectionMode]=\"selectionMode\"\n            [contextMenuActions]=\"false\"\n            [contentActions]=\"false\"\n            [allowDropFiles]=\"false\"\n            [sorting]=\"sorting\"\n            sortingMode=\"server\"\n            [where]=\"where\"\n            (folderChange)=\"onFolderChange($event)\"\n            (ready)=\"onFolderLoaded($event)\"\n            (nodeSelected)=\"onCurrentSelection($event)\"\n            [class.adf-content-node-selector-content-list-empty]=\"emptyList\"\n            data-automation-id=\"content-node-selector-document-list\">\n\n            <adf-custom-empty-content-template>\n                <div aria-live=\"polite\">{{ 'NODE_SELECTOR.NO_RESULTS' | translate }}</div>\n            </adf-custom-empty-content-template>\n\n            <data-columns>\n                <data-column key=\"$thumbnail\" type=\"image\"></data-column>\n                <data-column key=\"name\" type=\"text\" title=\"ADF-DOCUMENT-LIST.LAYOUT.NAME\" class=\"adf-full-width adf-ellipsis-cell\">\n                    <ng-template let-context>\n                        <adf-name-location-cell [row]=\"context.row\"></adf-name-location-cell>\n                    </ng-template>\n                </data-column>\n                <data-column key=\"modifiedAt\" type=\"date\" title=\"ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON\" format=\"timeAgo\" class=\"adf-content-selector-modified-cell\"></data-column>\n                <data-column key=\"createdByUser.displayName\" type=\"text\" title=\"ADF-DOCUMENT-LIST.LAYOUT.CREATED_BY\" class=\"adf-content-selector-modifier-cell\"></data-column>\n                <data-column key=\"visibility\" type=\"text\" title=\"ADF-DOCUMENT-LIST.LAYOUT.STATUS\" class=\"adf-content-selector-visibility-cell\"></data-column>\n            </data-columns>\n\n        </adf-document-list>\n\n        <adf-infinite-pagination\n            [target]=\"target\"\n            [loading]=\"loadingSearchResults\"\n            (loadMore)=\"getNextPageOfSearch($event)\"\n            data-automation-id=\"content-node-selector-search-pagination\">\n            {{ 'ADF-DOCUMENT-LIST.LAYOUT.LOAD_MORE' | translate }}\n        </adf-infinite-pagination>\n    </div>\n        </div>\n    </div>\n</div>\n", styles: ["h2.adf-search-results-label{flex:1;font-weight:600;font-size:var(--theme-body-1-font-size);font-style:normal;font-stretch:normal;line-height:1.43;letter-spacing:-.2px;color:var(--adf-theme-foreground-text-color-087)}.adf-toolbar .mat-toolbar{max-height:48px;border-bottom-width:0;font-size:var(--theme-body-1-font-size)}.adf-toolbar .mat-toolbar.mat-toolbar-single-row{height:auto}.adf-content-node-selector-search-panel-container{display:flex}.adf-content-node-selector-document-list-container{width:100%}.adf-content-node-selector-content{padding-top:0}.adf-content-node-selector-content-input{width:100%}.adf-content-node-selector-content-input-icon{color:var(--adf-theme-foreground-icon-color-054);cursor:pointer}.adf-content-node-selector-content-input-icon:hover{color:var(--adf-theme-foreground-base-color)}.adf-content-node-selector-content .mat-form-field-underline .mat-form-field-ripple{height:1px;transition:none}.adf-content-node-selector-content .adf-site-dropdown-container .mat-form-field{display:block;margin-bottom:15px}.adf-content-node-selector-content .adf-site-dropdown-list-element{width:100%;margin-bottom:0}.adf-content-node-selector-content .adf-site-dropdown-list-element .mat-select-trigger{font-size:var(--theme-body-1-font-size)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger{outline:none}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger .mat-icon{color:var(--adf-theme-foreground-base-color-045)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger .mat-icon:hover{color:var(--adf-theme-foreground-base-color-065)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger:focus .mat-icon{color:var(--theme-primary-color)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-item-chevron{color:var(--adf-theme-foreground-base-color-045)}.adf-content-node-selector-content-list{height:40vh;overflow:auto;border:1px solid var(--adf-theme-foreground-text-color-007);border-top:0;position:relative}.adf-content-node-selector-content-list-empty+adf-infinite-pagination{position:absolute;bottom:0;width:100%}.adf-content-node-selector-content-list .adf-highlight{color:var(--theme-primary-color)}.adf-content-node-selector-content-list .adf-datatable-list{border:none}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-selected{height:100%;width:100%}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-selected>svg{fill:var(--theme-primary-color)}.adf-content-node-selector-content-list .adf-datatable-list .adf-no-content-container{text-align:center;border:none!important}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell--image{min-width:35px;width:35px;max-width:40px}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell:nth-child(2){flex:1 0 95px}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell .adf-name-location-cell-location{display:none}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell.adf-content-selector-visibility-cell{flex:0 1 auto;min-width:1px}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell.adf-content-selector-visibility-cell .adf-datatable-cell-value{padding:0}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row{min-height:40px}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row{padding-top:15px}}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row:first-child .adf-datatable-cell{border-top:none}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row:last-child .adf-datatable-cell{border-bottom:none}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row{min-height:65px!important}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell .adf-name-location-cell-location{padding:0 10px;display:block}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell .adf-name-location-cell-name{padding:5px 10px 2px}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell.adf-content-selector-modified-cell,.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell.adf-content-selector-modifier-cell,.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell.adf-content-selector-visibility-cell{display:none}\n"], dependencies: [{ kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.HighlightDirective, selector: "[adf-highlight]", inputs: ["adf-highlight-selector", "adf-highlight", "adf-highlight-class"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i1.InfinitePaginationComponent, selector: "adf-infinite-pagination", inputs: ["target", "pageSize", "loading"], outputs: ["loadMore"] }, { kind: "component", type: i1.ToolbarComponent, selector: "adf-toolbar", inputs: ["title", "color"] }, { kind: "component", type: i1.ToolbarTitleComponent, selector: "adf-toolbar-title" }, { kind: "directive", type: i1.CustomEmptyContentTemplateDirective, selector: "adf-custom-empty-content-template, empty-folder-content" }, { kind: "component", type: i1.DataColumnComponent, selector: "data-column", inputs: ["id", "key", "customData", "type", "format", "sortable", "draggable", "isHidden", "title", "formatTooltip", "sr-title", "class", "copyContent", "editable", "focus", "sortingKey"] }, { kind: "component", type: i1.DataColumnListComponent, selector: "data-columns" }, { kind: "component", type: DropdownSitesComponent, selector: "adf-sites-dropdown", inputs: ["hideMyFiles", "siteList", "value", "placeholder", "relations"], outputs: ["change"] }, { kind: "component", type: DropdownBreadcrumbComponent, selector: "adf-dropdown-breadcrumb" }, { kind: "component", type: SearchPanelComponent, selector: "adf-search-panel" }, { kind: "component", type: DocumentListComponent, selector: "adf-document-list", inputs: ["includeFields", "where", "display", "permissionsStyle", "locationFormat", "navigate", "showHeader", "navigationMode", "thumbnails", "selectionMode", "multiselect", "contentActions", "contentActionsPosition", "contextMenuActions", "emptyFolderImageUrl", "allowDropFiles", "sorting", "additionalSorting", "sortingMode", "rowStyle", "rowStyleClass", "loading", "_rowFilter", "rowFilter", "imageResolver", "stickyHeader", "headerFilters", "filterValue", "currentFolderId", "preselectNodes", "node", "maxItems"], outputs: ["nodeClick", "nodeDblClick", "folderChange", "preview", "ready", "error", "nodeSelected", "filterSelection"] }, { kind: "directive", type: NodeCounterDirective, selector: "[adf-node-counter]", inputs: ["adf-node-counter"] }, { kind: "directive", type: AutoFocusDirective, selector: "[adf-auto-focus]" }, { kind: "component", type: NameLocationCellComponent, selector: "adf-name-location-cell", inputs: ["row"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-content-node-selector-panel', encapsulation: ViewEncapsulation.None, host: { class: 'adf-content-node-selector-panel' }, providers: [{
                            provide: SEARCH_QUERY_SERVICE_TOKEN,
                            useClass: SearchQueryBuilderService
                        }], template: "<div class=\"adf-content-node-selector-content\">\n    <mat-form-field floatPlaceholder=\"never\" class=\"adf-content-node-selector-content-input\" *ngIf=\"showSearch\">\n        <input matInput\n            id=\"searchInput\"\n            [formControl]=\"searchInput\"\n            type=\"text\"\n            placeholder=\"{{'NODE_SELECTOR.SEARCH' | translate}}\"\n            [value]=\"searchTerm\"\n            adf-auto-focus\n            data-automation-id=\"content-node-selector-search-input\">\n\n        <mat-icon *ngIf=\"searchTerm.length > 0\"\n            matSuffix (click)=\"clear()\"\n            class=\"adf-content-node-selector-content-input-icon\"\n            data-automation-id=\"content-node-selector-search-clear\">clear\n        </mat-icon>\n\n        <mat-icon *ngIf=\"searchTerm.length === 0\"\n            matSuffix\n            class=\"adf-content-node-selector-content-input-icon\"\n            data-automation-id=\"content-node-selector-search-icon\">search\n        </mat-icon>\n\n    </mat-form-field>\n    <adf-sites-dropdown\n        *ngIf=\"showDropdownSiteList\"\n        class=\"full-width\"\n        (change)=\"siteChanged($event)\"\n        [placeholder]=\"'NODE_SELECTOR.SELECT_LIBRARY'\"\n        [hideMyFiles]=\"dropdownHideMyFiles\"\n        [siteList]=\"dropdownSiteList\"\n        [value]=\"startSiteGuid\"\n        data-automation-id=\"content-node-selector-sites-combo\">\n    </adf-sites-dropdown>\n    <button *ngIf=\"hasCustomModels()\"\n        data-automation-id=\"adf-toggle-search-panel-button\"\n        mat-icon-button\n        (click)=\"toggleSearchPanel()\">\n        <mat-icon>filter_list</mat-icon>\n        {{ 'SEARCH.SEARCH_HEADER.TITLE' | translate }}\n    </button>\n    <div class=\"adf-content-node-selector-search-panel-container\">\n        <adf-search-panel *ngIf=\"searchPanelExpanded\">\n        </adf-search-panel>\n        <div class=\"adf-content-node-selector-document-list-container\">\n    <adf-toolbar>\n        <adf-toolbar-title>\n            <ng-container *ngIf=\"!showBreadcrumbs()\">\n                <h2 class=\"adf-search-results-label\">{{ 'NODE_SELECTOR.SEARCH_RESULTS' | translate }}</h2>\n            </ng-container>\n            <adf-dropdown-breadcrumb *ngIf=\"showBreadcrumbs()\"\n                class=\"adf-content-node-selector-content-breadcrumb\"\n                (navigate)=\"clearSearch()\"\n                [target]=\"documentList\"\n                [rootId]=\"breadcrumbRootId\"\n                [transform]=\"breadcrumbTransform\"\n                [folderNode]=\"breadcrumbFolderNode\"\n                [root]=\"breadcrumbFolderTitle\"\n                data-automation-id=\"content-node-selector-content-breadcrumb\">\n            </adf-dropdown-breadcrumb>\n            <ng-container *ngIf=\"showNodeCounter\" [adf-node-counter]=\"getSelectedCount()\"></ng-container>\n        </adf-toolbar-title>\n    </adf-toolbar>\n\n    <div\n        class=\"adf-content-node-selector-content-list\"\n        [class.adf-content-node-selector-content-list-searchLayout]=\"showingSearchResults\"\n        data-automation-id=\"content-node-selector-content-list\">\n        <adf-document-list\n            #documentList\n            [adf-highlight]=\"searchTerm\"\n            adf-highlight-selector=\".adf-name-location-cell-name\"\n            [showHeader]=\"showHeader\"\n            [node]=\"nodePaging\"\n            [preselectNodes]=\"preselectedNodes\"\n            [maxItems]=\"pageSize\"\n            [rowFilter]=\"_rowFilter\"\n            [imageResolver]=\"imageResolver\"\n            [currentFolderId]=\"folderIdToShow\"\n            [selectionMode]=\"selectionMode\"\n            [contextMenuActions]=\"false\"\n            [contentActions]=\"false\"\n            [allowDropFiles]=\"false\"\n            [sorting]=\"sorting\"\n            sortingMode=\"server\"\n            [where]=\"where\"\n            (folderChange)=\"onFolderChange($event)\"\n            (ready)=\"onFolderLoaded($event)\"\n            (nodeSelected)=\"onCurrentSelection($event)\"\n            [class.adf-content-node-selector-content-list-empty]=\"emptyList\"\n            data-automation-id=\"content-node-selector-document-list\">\n\n            <adf-custom-empty-content-template>\n                <div aria-live=\"polite\">{{ 'NODE_SELECTOR.NO_RESULTS' | translate }}</div>\n            </adf-custom-empty-content-template>\n\n            <data-columns>\n                <data-column key=\"$thumbnail\" type=\"image\"></data-column>\n                <data-column key=\"name\" type=\"text\" title=\"ADF-DOCUMENT-LIST.LAYOUT.NAME\" class=\"adf-full-width adf-ellipsis-cell\">\n                    <ng-template let-context>\n                        <adf-name-location-cell [row]=\"context.row\"></adf-name-location-cell>\n                    </ng-template>\n                </data-column>\n                <data-column key=\"modifiedAt\" type=\"date\" title=\"ADF-DOCUMENT-LIST.LAYOUT.MODIFIED_ON\" format=\"timeAgo\" class=\"adf-content-selector-modified-cell\"></data-column>\n                <data-column key=\"createdByUser.displayName\" type=\"text\" title=\"ADF-DOCUMENT-LIST.LAYOUT.CREATED_BY\" class=\"adf-content-selector-modifier-cell\"></data-column>\n                <data-column key=\"visibility\" type=\"text\" title=\"ADF-DOCUMENT-LIST.LAYOUT.STATUS\" class=\"adf-content-selector-visibility-cell\"></data-column>\n            </data-columns>\n\n        </adf-document-list>\n\n        <adf-infinite-pagination\n            [target]=\"target\"\n            [loading]=\"loadingSearchResults\"\n            (loadMore)=\"getNextPageOfSearch($event)\"\n            data-automation-id=\"content-node-selector-search-pagination\">\n            {{ 'ADF-DOCUMENT-LIST.LAYOUT.LOAD_MORE' | translate }}\n        </adf-infinite-pagination>\n    </div>\n        </div>\n    </div>\n</div>\n", styles: ["h2.adf-search-results-label{flex:1;font-weight:600;font-size:var(--theme-body-1-font-size);font-style:normal;font-stretch:normal;line-height:1.43;letter-spacing:-.2px;color:var(--adf-theme-foreground-text-color-087)}.adf-toolbar .mat-toolbar{max-height:48px;border-bottom-width:0;font-size:var(--theme-body-1-font-size)}.adf-toolbar .mat-toolbar.mat-toolbar-single-row{height:auto}.adf-content-node-selector-search-panel-container{display:flex}.adf-content-node-selector-document-list-container{width:100%}.adf-content-node-selector-content{padding-top:0}.adf-content-node-selector-content-input{width:100%}.adf-content-node-selector-content-input-icon{color:var(--adf-theme-foreground-icon-color-054);cursor:pointer}.adf-content-node-selector-content-input-icon:hover{color:var(--adf-theme-foreground-base-color)}.adf-content-node-selector-content .mat-form-field-underline .mat-form-field-ripple{height:1px;transition:none}.adf-content-node-selector-content .adf-site-dropdown-container .mat-form-field{display:block;margin-bottom:15px}.adf-content-node-selector-content .adf-site-dropdown-list-element{width:100%;margin-bottom:0}.adf-content-node-selector-content .adf-site-dropdown-list-element .mat-select-trigger{font-size:var(--theme-body-1-font-size)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger{outline:none}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger .mat-icon{color:var(--adf-theme-foreground-base-color-045)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger .mat-icon:hover{color:var(--adf-theme-foreground-base-color-065)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-trigger:focus .mat-icon{color:var(--theme-primary-color)}.adf-content-node-selector-content-breadcrumb .adf-dropdown-breadcrumb-item-chevron{color:var(--adf-theme-foreground-base-color-045)}.adf-content-node-selector-content-list{height:40vh;overflow:auto;border:1px solid var(--adf-theme-foreground-text-color-007);border-top:0;position:relative}.adf-content-node-selector-content-list-empty+adf-infinite-pagination{position:absolute;bottom:0;width:100%}.adf-content-node-selector-content-list .adf-highlight{color:var(--theme-primary-color)}.adf-content-node-selector-content-list .adf-datatable-list{border:none}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-selected{height:100%;width:100%}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-selected>svg{fill:var(--theme-primary-color)}.adf-content-node-selector-content-list .adf-datatable-list .adf-no-content-container{text-align:center;border:none!important}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell--image{min-width:35px;width:35px;max-width:40px}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell:nth-child(2){flex:1 0 95px}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell .adf-name-location-cell-location{display:none}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell.adf-content-selector-visibility-cell{flex:0 1 auto;min-width:1px}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-cell.adf-content-selector-visibility-cell .adf-datatable-cell-value{padding:0}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row{min-height:40px}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row{padding-top:15px}}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row:first-child .adf-datatable-cell{border-top:none}.adf-content-node-selector-content-list .adf-datatable-list .adf-datatable-body .adf-datatable-row:last-child .adf-datatable-cell{border-bottom:none}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row{min-height:65px!important}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell .adf-name-location-cell-location{padding:0 10px;display:block}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell .adf-name-location-cell-name{padding:5px 10px 2px}.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell.adf-content-selector-modified-cell,.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell.adf-content-selector-modifier-cell,.adf-content-node-selector-content-list-searchLayout .adf-datatable-list .adf-datatable-row .adf-datatable-cell.adf-content-selector-visibility-cell{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: CustomResourcesService }, { type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: i1.UserPreferencesService }, { type: NodesApiService }, { type: UploadService }, { type: SitesService }, { type: i1.AppConfigService }, { type: ContentNodeSelectorPanelService }]; }, propDecorators: { restrictRootToCurrentFolderId: [{
                type: Input
            }], currentFolderId: [{
                type: Input
            }], dropdownHideMyFiles: [{
                type: Input
            }], dropdownSiteList: [{
                type: Input
            }], where: [{
                type: Input
            }], rowFilter: [{
                type: Input
            }], excludeSiteContent: [{
                type: Input
            }], imageResolver: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], isSelectionValid: [{
                type: Input
            }], breadcrumbTransform: [{
                type: Input
            }], showSearch: [{
                type: Input
            }], showDropdownSiteList: [{
                type: Input
            }], showFilesInResult: [{
                type: Input
            }], showNodeCounter: [{
                type: Input
            }], select: [{
                type: Output
            }], navigationChange: [{
                type: Output
            }], siteChange: [{
                type: Output
            }], showingSearch: [{
                type: Output
            }], currentFolder: [{
                type: Output
            }], folderLoaded: [{
                type: Output
            }], documentList: [{
                type: ViewChild,
                args: ['documentList', { static: true }]
            }], highlighter: [{
                type: ViewChild,
                args: [HighlightDirective, { static: true }]
            }], infinitePaginationComponent: [{
                type: ViewChild,
                args: [InfinitePaginationComponent, { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentNodeSelectorComponent {
    constructor(translation, contentService, notificationService, uploadService, dialog, overlayContainer, data) {
        this.translation = translation;
        this.contentService = contentService;
        this.notificationService = notificationService;
        this.uploadService = uploadService;
        this.dialog = dialog;
        this.overlayContainer = overlayContainer;
        this.data = data;
        this.showingSearch = false;
        this.hasAllowableOperations = false;
        this.isLoading = true;
        this.selectedTabIndex = 0;
        this.uploadStarted = false;
        this.emptyFolderImageUrl = './assets/images/empty_doc_lib.svg';
        this.action = data.actionName ?? NodeAction.CHOOSE;
        this.buttonActionName = `NODE_SELECTOR.${this.action}`;
        this.title = data.title;
        this.currentDirectoryId = data.currentFolderId;
    }
    ngOnInit() {
        this.dialog.keydownEvents().subscribe(event => {
            // Esc
            if (event.keyCode === 27) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.close();
            }
        });
        this.dialog.backdropClick().subscribe(() => {
            this.close();
        });
        this.dialog.afterOpened().subscribe(() => {
            this.overlayContainer.getContainerElement().setAttribute('role', 'main');
        });
        this.uploadService.fileUploadStarting.subscribe(() => {
            this.uploadStarted = true;
        });
    }
    close() {
        this.dialog.close();
        this.overlayContainer.getContainerElement().setAttribute('role', 'region');
    }
    onSelect(nodeList) {
        this.chosenNode = nodeList;
    }
    onSiteChange(siteTitle) {
        this.updateTitle(siteTitle);
    }
    onNavigationChange(pathElement) {
        this.currentDirectoryId = pathElement.value.id;
        this.isLoading = true;
    }
    onClick() {
        this.data.select.next(this.chosenNode);
        this.close();
    }
    updateTitle(siteTitle) {
        if (this.action === NodeAction.CHOOSE && siteTitle) {
            this.title = this.getTitleTranslation(this.action, siteTitle);
        }
    }
    getTitleTranslation(action, name) {
        return this.translation.instant(`NODE_SELECTOR.${action}_ITEM`, { name: this.translation.instant(name) });
    }
    getSelectedCount() {
        return this.chosenNode?.length || 0;
    }
    isCounterVisible() {
        return this.action === NodeAction.ATTACH || this.action === NodeAction.CHOOSE;
    }
    isMultipleSelection() {
        return this.data.selectionMode === 'multiple';
    }
    onError(error) {
        this.notificationService.showError(error);
    }
    isChooseButtonDisabled() {
        return this.uploadService.isUploading() || !this.hasNodeSelected();
    }
    hasNodeSelected() {
        return this.chosenNode?.length > 0;
    }
    onShowingSearch(value) {
        this.showingSearch = value;
    }
    onCurrentFolder(currentFolder) {
        this.hasAllowableOperations = this.contentService.hasAllowableOperations(currentFolder, AllowableOperationsEnum.CREATE);
        this.breadcrumbFolderNode = currentFolder;
    }
    isNotAllowedToUpload() {
        return this.showingSearch || !this.hasAllowableOperations;
    }
    onFolderLoaded() {
        this.isLoading = false;
    }
    onTabSelectionChange(tabIndex) {
        this.selectedTabIndex = tabIndex;
    }
    isFileServerTabSelected() {
        return this.selectedTabIndex === 0;
    }
    isLocalUploadTabSelected() {
        return this.selectedTabIndex === 1;
    }
    isUploadEnabled() {
        return this.canPerformLocalUpload() && this.isLocalUploadTabSelected();
    }
    canPerformLocalUpload() {
        return this.data?.showLocalUploadButton;
    }
    getWarningMessage() {
        return this.showingSearch ? 'NODE_SELECTOR.UPLOAD_BUTTON_SEARCH_WARNING_MESSAGE' :
            (this.hasNoPermissionToUpload() ? 'NODE_SELECTOR.UPLOAD_BUTTON_PERMISSION_WARNING_MESSAGE' : '');
    }
    hasNoPermissionToUpload() {
        return (!this.hasAllowableOperations && !this.showingSearch) && !this.isLoading;
    }
    hasUploadError() {
        return this.showingSearch || this.hasNoPermissionToUpload();
    }
}
ContentNodeSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorComponent, deps: [{ token: i1.TranslationService }, { token: ContentService }, { token: i1.NotificationService }, { token: UploadService }, { token: i1$1.MatDialogRef }, { token: i5$5.OverlayContainer }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
ContentNodeSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentNodeSelectorComponent, selector: "adf-content-node-selector", ngImport: i0, template: "<h1 mat-dialog-title data-automation-id=\"content-node-selector-title\">{{title}}</h1>\n<mat-tab-group class=\"adf-content-node-selector-dialog-content\"\n               mat-align-tabs=\"start\"\n               (selectedIndexChange)=\"onTabSelectionChange($event)\"\n               [class.adf-content-node-selector-headless-tabs]=\"!canPerformLocalUpload()\">\n    <mat-tab label=\"{{ 'NODE_SELECTOR.REPOSITORY' | translate }}\">\n            <adf-content-node-selector-panel\n                [currentFolderId]=\"data?.currentFolderId\"\n                [restrictRootToCurrentFolderId]=\"data?.restrictRootToCurrentFolderId\"\n                [dropdownHideMyFiles]=\"data?.dropdownHideMyFiles\"\n                [dropdownSiteList]=\"data?.dropdownSiteList\"\n                [rowFilter]=\"data?.rowFilter\"\n                [imageResolver]=\"data?.imageResolver\"\n                [isSelectionValid]=\"data?.isSelectionValid\"\n                [breadcrumbTransform]=\"data?.breadcrumbTransform\"\n                [excludeSiteContent]=\"data?.excludeSiteContent\"\n                [selectionMode]=\"data?.selectionMode\"\n                [where]=\"data?.where\"\n                [showSearch]=\"data?.showSearch\"\n                [showDropdownSiteList]=\"data?.showDropdownSiteList\"\n                [showFilesInResult]=\"data?.showFilesInResult\"\n                [showNodeCounter]=\"isCounterVisible()\"\n                (currentFolder)=\"onCurrentFolder($event)\"\n                (folderLoaded)=\"onFolderLoaded()\"\n                (select)=\"onSelect($event)\"\n                (showingSearch)=\"onShowingSearch($event)\"\n                (siteChange)=\"onSiteChange($event)\"\n                (navigationChange)=\"onNavigationChange($event)\">\n            </adf-content-node-selector-panel>\n    </mat-tab>\n    <mat-tab *ngIf=\"canPerformLocalUpload()\"\n             [disabled]=\"isNotAllowedToUpload()\">\n        <div class=\"adf-content-node-selector-local-upload-container\">\n            <div class=\"adf-content-node-selector-local-upload-header\">\n                <adf-toolbar>\n                    <adf-toolbar-title>\n                        <adf-dropdown-breadcrumb\n                            class=\"adf-content-node-selector-content-breadcrumb\"\n                            [folderNode]=\"breadcrumbFolderNode\"\n                            [rootId]=\"data?.currentFolderId\"\n                            [readOnly]=\"true\"\n                            data-automation-id=\"content-node-selector-upload-breadcrumb\"\n                        ></adf-dropdown-breadcrumb>\n                        <ng-container *ngIf=\"isCounterVisible()\" [adf-node-counter]=\"getSelectedCount()\"></ng-container>\n                    </adf-toolbar-title>\n                </adf-toolbar>\n                <ng-template mat-tab-label>\n                    {{ 'NODE_SELECTOR.UPLOAD_FROM_DEVICE' | translate }}\n                    <mat-icon *ngIf=\"hasUploadError()\"\n                              data-automation-id=\"adf-content-node-selector-disabled-tab-info-icon\"\n                              matTooltip=\"{{ getWarningMessage() | translate }}\">info\n                    </mat-icon>\n                </ng-template>\n            </div>\n            <div class=\"adf-content-node-selector-local-upload-content\">\n                <adf-upload-drag-area [rootFolderId]=\"currentDirectoryId\">\n                    <div [class.adf-upload-dialog-container]=\"uploadStarted\">\n                        <adf-file-uploading-dialog [alwaysVisible]=\"true\"></adf-file-uploading-dialog>\n                    </div>\n                    <adf-empty-list data-automation-id=\"adf-empty-list\" *ngIf=\"!uploadStarted\">\n                        <div class=\"adf-empty-list_template adf-empty-folder\">\n                            <div class=\"adf-empty-folder-drag-drop\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate }}</div>\n                            <div class=\"adf-empty-folder-any-files-here-to-add\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.SUBTITLE' | translate }}</div>\n                            <img [alt]=\"'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate\" class=\"adf-empty-folder-image\"\n                                 [src]=\"emptyFolderImageUrl\">\n                        </div>\n                    </adf-empty-list>\n                </adf-upload-drag-area>\n            </div>\n        </div>\n    </mat-tab>\n</mat-tab-group>\n\n<mat-dialog-actions>\n    <div>\n        <ng-container *ngIf=\"isUploadEnabled()\">\n            <adf-upload-button\n                [staticTitle]=\"'FORM.FIELD.UPLOAD' | translate \"\n                [multipleFiles]=\"isMultipleSelection()\"\n                [rootFolderId]=\"currentDirectoryId\"\n                [disabled]=\"isNotAllowedToUpload()\"\n                (error)=\"onError($event)\">\n            </adf-upload-button>\n        </ng-container>\n    </div>\n    <div>\n        <button\n            mat-button\n            (click)=\"close()\"\n            data-automation-id=\"content-node-selector-actions-cancel\">{{ 'NODE_SELECTOR.CANCEL' | translate }}\n        </button>\n\n        <button mat-button\n                [disabled]=\"isChooseButtonDisabled()\"\n                class=\"adf-choose-action\"\n                (click)=\"onClick()\"\n                data-automation-id=\"content-node-selector-actions-choose\">{{ buttonActionName | translate }}\n        </button>\n    </div>\n</mat-dialog-actions>\n", styles: ["adf-content-node-selector .adf-content-node-selector-headless-tabs .mat-tab-header{display:none}adf-content-node-selector .adf-upload-dialog{box-shadow:none;height:100%;width:100%;position:unset;bottom:unset}adf-content-node-selector .adf-upload-dialog__content{max-height:64%}adf-content-node-selector .adf-upload-dialog-container{height:380px}adf-content-node-selector .adf-toolbar-title{place-items:center}adf-content-node-selector .adf-content-node-selector-local-upload-content{height:50vh}adf-content-node-selector .adf-content-node-selector-local-upload-content adf-upload-drag-area adf-empty-list .adf-empty-folder-drag-drop{min-height:46px;font-size:40px}adf-content-node-selector .adf-content-node-selector-local-upload-content adf-upload-drag-area adf-empty-list .adf-empty-folder-image{height:100px;width:460px}.adf-content-node-selector-dialog-content{padding-left:24px;padding-right:24px}.adf-content-node-selector-dialog .mat-dialog-title{margin-left:24px;margin-right:24px;font-size:var(--theme-title-font-size);font-weight:600;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:-.5px;color:var(--adf-theme-foreground-text-color-087)}.adf-content-node-selector-dialog .mat-dialog-title h2{margin:unset;font-size:unset}.adf-content-node-selector-dialog .mat-dialog-container{padding-left:0;padding-right:0}.adf-content-node-selector-dialog .mat-dialog-content{margin:0;overflow:hidden}.adf-content-node-selector-dialog .mat-dialog-actions{padding:8px;height:61px;background-color:var(--theme-background-color);display:flex;flex-direction:row;justify-content:space-between;color:var(--adf-theme-foreground-text-color)}.adf-content-node-selector-dialog .mat-dialog-actions button{text-transform:uppercase;font-weight:400}.adf-content-node-selector-dialog .mat-dialog-actions .adf-choose-action[disabled]{color:var(--adf-theme-foreground-secondary-text-color)}.adf-content-node-selector-dialog .mat-dialog-actions .adf-choose-action:enabled{color:var(--theme-primary-color)}@media screen and (max-width: 768px){.adf-content-node-selector-dialog .mat-dialog-container{height:100vh}}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i9$1.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "directive", type: i9$1.MatTabLabel, selector: "[mat-tab-label], [matTabLabel]" }, { kind: "component", type: i9$1.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i1.ToolbarComponent, selector: "adf-toolbar", inputs: ["title", "color"] }, { kind: "component", type: i1.ToolbarTitleComponent, selector: "adf-toolbar-title" }, { kind: "component", type: i1.EmptyListComponent, selector: "adf-empty-list" }, { kind: "component", type: DropdownBreadcrumbComponent, selector: "adf-dropdown-breadcrumb" }, { kind: "component", type: UploadDragAreaComponent, selector: "adf-upload-drag-area" }, { kind: "component", type: UploadButtonComponent, selector: "adf-upload-button", inputs: ["uploadFolders", "multipleFiles", "staticTitle", "tooltip", "file"], outputs: ["permissionEvent"] }, { kind: "component", type: FileUploadingDialogComponent, selector: "adf-file-uploading-dialog", inputs: ["position", "alwaysVisible"], outputs: ["error"] }, { kind: "directive", type: NodeCounterDirective, selector: "[adf-node-counter]", inputs: ["adf-node-counter"] }, { kind: "component", type: ContentNodeSelectorPanelComponent, selector: "adf-content-node-selector-panel", inputs: ["restrictRootToCurrentFolderId", "currentFolderId", "dropdownHideMyFiles", "dropdownSiteList", "where", "rowFilter", "excludeSiteContent", "imageResolver", "pageSize", "selectionMode", "isSelectionValid", "breadcrumbTransform", "showSearch", "showDropdownSiteList", "showFilesInResult", "showNodeCounter"], outputs: ["select", "navigationChange", "siteChange", "showingSearch", "currentFolder", "folderLoaded"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-content-node-selector', encapsulation: ViewEncapsulation.None, template: "<h1 mat-dialog-title data-automation-id=\"content-node-selector-title\">{{title}}</h1>\n<mat-tab-group class=\"adf-content-node-selector-dialog-content\"\n               mat-align-tabs=\"start\"\n               (selectedIndexChange)=\"onTabSelectionChange($event)\"\n               [class.adf-content-node-selector-headless-tabs]=\"!canPerformLocalUpload()\">\n    <mat-tab label=\"{{ 'NODE_SELECTOR.REPOSITORY' | translate }}\">\n            <adf-content-node-selector-panel\n                [currentFolderId]=\"data?.currentFolderId\"\n                [restrictRootToCurrentFolderId]=\"data?.restrictRootToCurrentFolderId\"\n                [dropdownHideMyFiles]=\"data?.dropdownHideMyFiles\"\n                [dropdownSiteList]=\"data?.dropdownSiteList\"\n                [rowFilter]=\"data?.rowFilter\"\n                [imageResolver]=\"data?.imageResolver\"\n                [isSelectionValid]=\"data?.isSelectionValid\"\n                [breadcrumbTransform]=\"data?.breadcrumbTransform\"\n                [excludeSiteContent]=\"data?.excludeSiteContent\"\n                [selectionMode]=\"data?.selectionMode\"\n                [where]=\"data?.where\"\n                [showSearch]=\"data?.showSearch\"\n                [showDropdownSiteList]=\"data?.showDropdownSiteList\"\n                [showFilesInResult]=\"data?.showFilesInResult\"\n                [showNodeCounter]=\"isCounterVisible()\"\n                (currentFolder)=\"onCurrentFolder($event)\"\n                (folderLoaded)=\"onFolderLoaded()\"\n                (select)=\"onSelect($event)\"\n                (showingSearch)=\"onShowingSearch($event)\"\n                (siteChange)=\"onSiteChange($event)\"\n                (navigationChange)=\"onNavigationChange($event)\">\n            </adf-content-node-selector-panel>\n    </mat-tab>\n    <mat-tab *ngIf=\"canPerformLocalUpload()\"\n             [disabled]=\"isNotAllowedToUpload()\">\n        <div class=\"adf-content-node-selector-local-upload-container\">\n            <div class=\"adf-content-node-selector-local-upload-header\">\n                <adf-toolbar>\n                    <adf-toolbar-title>\n                        <adf-dropdown-breadcrumb\n                            class=\"adf-content-node-selector-content-breadcrumb\"\n                            [folderNode]=\"breadcrumbFolderNode\"\n                            [rootId]=\"data?.currentFolderId\"\n                            [readOnly]=\"true\"\n                            data-automation-id=\"content-node-selector-upload-breadcrumb\"\n                        ></adf-dropdown-breadcrumb>\n                        <ng-container *ngIf=\"isCounterVisible()\" [adf-node-counter]=\"getSelectedCount()\"></ng-container>\n                    </adf-toolbar-title>\n                </adf-toolbar>\n                <ng-template mat-tab-label>\n                    {{ 'NODE_SELECTOR.UPLOAD_FROM_DEVICE' | translate }}\n                    <mat-icon *ngIf=\"hasUploadError()\"\n                              data-automation-id=\"adf-content-node-selector-disabled-tab-info-icon\"\n                              matTooltip=\"{{ getWarningMessage() | translate }}\">info\n                    </mat-icon>\n                </ng-template>\n            </div>\n            <div class=\"adf-content-node-selector-local-upload-content\">\n                <adf-upload-drag-area [rootFolderId]=\"currentDirectoryId\">\n                    <div [class.adf-upload-dialog-container]=\"uploadStarted\">\n                        <adf-file-uploading-dialog [alwaysVisible]=\"true\"></adf-file-uploading-dialog>\n                    </div>\n                    <adf-empty-list data-automation-id=\"adf-empty-list\" *ngIf=\"!uploadStarted\">\n                        <div class=\"adf-empty-list_template adf-empty-folder\">\n                            <div class=\"adf-empty-folder-drag-drop\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate }}</div>\n                            <div class=\"adf-empty-folder-any-files-here-to-add\">{{ 'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.SUBTITLE' | translate }}</div>\n                            <img [alt]=\"'ADF-DATATABLE.EMPTY.DRAG-AND-DROP.TITLE' | translate\" class=\"adf-empty-folder-image\"\n                                 [src]=\"emptyFolderImageUrl\">\n                        </div>\n                    </adf-empty-list>\n                </adf-upload-drag-area>\n            </div>\n        </div>\n    </mat-tab>\n</mat-tab-group>\n\n<mat-dialog-actions>\n    <div>\n        <ng-container *ngIf=\"isUploadEnabled()\">\n            <adf-upload-button\n                [staticTitle]=\"'FORM.FIELD.UPLOAD' | translate \"\n                [multipleFiles]=\"isMultipleSelection()\"\n                [rootFolderId]=\"currentDirectoryId\"\n                [disabled]=\"isNotAllowedToUpload()\"\n                (error)=\"onError($event)\">\n            </adf-upload-button>\n        </ng-container>\n    </div>\n    <div>\n        <button\n            mat-button\n            (click)=\"close()\"\n            data-automation-id=\"content-node-selector-actions-cancel\">{{ 'NODE_SELECTOR.CANCEL' | translate }}\n        </button>\n\n        <button mat-button\n                [disabled]=\"isChooseButtonDisabled()\"\n                class=\"adf-choose-action\"\n                (click)=\"onClick()\"\n                data-automation-id=\"content-node-selector-actions-choose\">{{ buttonActionName | translate }}\n        </button>\n    </div>\n</mat-dialog-actions>\n", styles: ["adf-content-node-selector .adf-content-node-selector-headless-tabs .mat-tab-header{display:none}adf-content-node-selector .adf-upload-dialog{box-shadow:none;height:100%;width:100%;position:unset;bottom:unset}adf-content-node-selector .adf-upload-dialog__content{max-height:64%}adf-content-node-selector .adf-upload-dialog-container{height:380px}adf-content-node-selector .adf-toolbar-title{place-items:center}adf-content-node-selector .adf-content-node-selector-local-upload-content{height:50vh}adf-content-node-selector .adf-content-node-selector-local-upload-content adf-upload-drag-area adf-empty-list .adf-empty-folder-drag-drop{min-height:46px;font-size:40px}adf-content-node-selector .adf-content-node-selector-local-upload-content adf-upload-drag-area adf-empty-list .adf-empty-folder-image{height:100px;width:460px}.adf-content-node-selector-dialog-content{padding-left:24px;padding-right:24px}.adf-content-node-selector-dialog .mat-dialog-title{margin-left:24px;margin-right:24px;font-size:var(--theme-title-font-size);font-weight:600;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:-.5px;color:var(--adf-theme-foreground-text-color-087)}.adf-content-node-selector-dialog .mat-dialog-title h2{margin:unset;font-size:unset}.adf-content-node-selector-dialog .mat-dialog-container{padding-left:0;padding-right:0}.adf-content-node-selector-dialog .mat-dialog-content{margin:0;overflow:hidden}.adf-content-node-selector-dialog .mat-dialog-actions{padding:8px;height:61px;background-color:var(--theme-background-color);display:flex;flex-direction:row;justify-content:space-between;color:var(--adf-theme-foreground-text-color)}.adf-content-node-selector-dialog .mat-dialog-actions button{text-transform:uppercase;font-weight:400}.adf-content-node-selector-dialog .mat-dialog-actions .adf-choose-action[disabled]{color:var(--adf-theme-foreground-secondary-text-color)}.adf-content-node-selector-dialog .mat-dialog-actions .adf-choose-action:enabled{color:var(--theme-primary-color)}@media screen and (max-width: 768px){.adf-content-node-selector-dialog .mat-dialog-container{height:100vh}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: ContentService }, { type: i1.NotificationService }, { type: UploadService }, { type: i1$1.MatDialogRef }, { type: i5$5.OverlayContainer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeLockDialogComponent {
    constructor(formBuilder, dialog, alfrescoApi, data) {
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.alfrescoApi = alfrescoApi;
        this.data = data;
        this.node = null;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.alfrescoApi.getInstance());
        return this._nodesApi;
    }
    ngOnInit() {
        const { node } = this.data;
        this.nodeName = node.name;
        this.form = this.formBuilder.group({
            isLocked: node.isLocked || false,
            allowOwner: node.properties['cm:lockType'] === 'WRITE_LOCK',
            isTimeLock: !!node.properties['cm:expiryDate'],
            time: !!node.properties['cm:expiryDate'] ? moment$1(node.properties['cm:expiryDate']) : moment$1()
        });
    }
    get lockTimeInSeconds() {
        if (this.form.value.isTimeLock) {
            const duration = moment$1.duration(moment$1(this.form.value.time).diff(moment$1()));
            return duration.asSeconds();
        }
        return 0;
    }
    get nodeBodyLock() {
        return new NodeBodyLock({
            timeToExpire: this.lockTimeInSeconds,
            type: this.form.value.allowOwner ? 'ALLOW_OWNER_CHANGES' : 'FULL',
            lifetime: 'PERSISTENT'
        });
    }
    toggleLock() {
        const { data: { node } } = this;
        if (this.form.value.isLocked) {
            return this.nodesApi.lockNode(node.id, this.nodeBodyLock);
        }
        return this.nodesApi.unlockNode(node.id);
    }
    submit() {
        this.toggleLock()
            .then((node) => {
            this.data.node.isLocked = this.form.value.isLocked;
            this.dialog.close(node.entry);
        })
            .catch((error) => this.data.onError(error));
    }
}
NodeLockDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeLockDialogComponent, deps: [{ token: i2$2.UntypedFormBuilder }, { token: i1$1.MatDialogRef }, { token: i1.AlfrescoApiService }, { token: MAT_DIALOG_DATA, optional: true }], target: i0.ɵɵFactoryTarget.Component });
NodeLockDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NodeLockDialogComponent, selector: "adf-node-lock", ngImport: i0, template: "<h2 mat-dialog-title>\n    {{ 'CORE.FILE_DIALOG.FILE_LOCK' | translate }}\n</h2>\n\n<mat-dialog-content>\n    <br />\n    <form [formGroup]=\"form\" (submit)=\"submit()\">\n        <mat-checkbox  data-automation-id=\"adf-lock-node-checkbox\" class=\"adf-lock-file-name\" matTooltip=\"{{ nodeName }}\" [formControlName]=\"'isLocked'\" ngDefaultControl>\n            {{ 'CORE.FILE_DIALOG.FILE_LOCK_CHECKBOX' | translate }} <strong>\"{{ nodeName }}\"</strong>\n        </mat-checkbox>\n\n        <br />\n\n        <div *ngIf=\"form.value.isLocked\">\n            <mat-checkbox class=\"adf-lock-file-name\" [formControlName]=\"'allowOwner'\" ngDefaultControl>\n                {{ 'CORE.FILE_DIALOG.ALLOW_OTHERS_CHECKBOX' | translate }}\n            </mat-checkbox>\n\n            <br />\n\n            <mat-checkbox class=\"adf-lock-file-name\" [formControlName]=\"'isTimeLock'\" ngDefaultControl>\n                {{ 'CORE.FILE_DIALOG.TIME_LOCK_CHECKBOX' | translate }}\n            </mat-checkbox>\n\n            <br />\n\n            <mat-form-field *ngIf=\"form.value.isTimeLock\">\n                <mat-datetimepicker-toggle [for]=\"datetimePicker\" matSuffix></mat-datetimepicker-toggle>\n                <mat-datetimepicker #datetimePicker type=\"datetime\" [openOnFocus]=\"true\" [timeInterval]=\"1\"></mat-datetimepicker>\n                <input matInput [formControlName]=\"'time'\" [matDatetimepicker]=\"datetimePicker\" required autocomplete=\"false\">\n            </mat-form-field>\n        </div>\n    </form>\n    <br />\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-dialog-buttons\">\n    <span class=\"adf-fill-remaining-space\"></span>\n\n    <button mat-button mat-dialog-close data-automation-id=\"lock-dialog-btn-cancel\">\n        {{ 'CORE.FILE_DIALOG.CANCEL_BUTTON.LABEL' | translate }}\n    </button>\n\n    <button class=\"adf-dialog-action-button\" mat-button (click)=\"submit()\">\n        {{ 'CORE.FILE_DIALOG.SAVE_BUTTON.LABEL' | translate }}\n    </button>\n</mat-dialog-actions>\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i5$3.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i1$3.MatDatetimepickerComponent, selector: "mat-datetimepicker", inputs: ["multiYearSelector", "twelvehour", "startView", "mode", "timeInterval", "ariaNextMonthLabel", "ariaPrevMonthLabel", "ariaNextYearLabel", "ariaPrevYearLabel", "preventSameDateTimeSelection", "panelClass", "startAt", "openOnFocus", "type", "touchUi", "disabled"], outputs: ["selectedChanged", "opened", "closed", "viewChanged"], exportAs: ["matDatetimepicker"] }, { kind: "component", type: i1$3.MatDatetimepickerToggleComponent, selector: "mat-datetimepicker-toggle", inputs: ["for", "disabled"], exportAs: ["matDatetimepickerToggle"] }, { kind: "directive", type: i1$3.MatDatetimepickerInputDirective, selector: "input[matDatetimepicker]", inputs: ["matDatetimepicker", "matDatepickerFilter", "value", "min", "max", "disabled"], outputs: ["dateChange", "dateInput"], exportAs: ["matDatepickerInput"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeLockDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-node-lock', encapsulation: ViewEncapsulation.None, template: "<h2 mat-dialog-title>\n    {{ 'CORE.FILE_DIALOG.FILE_LOCK' | translate }}\n</h2>\n\n<mat-dialog-content>\n    <br />\n    <form [formGroup]=\"form\" (submit)=\"submit()\">\n        <mat-checkbox  data-automation-id=\"adf-lock-node-checkbox\" class=\"adf-lock-file-name\" matTooltip=\"{{ nodeName }}\" [formControlName]=\"'isLocked'\" ngDefaultControl>\n            {{ 'CORE.FILE_DIALOG.FILE_LOCK_CHECKBOX' | translate }} <strong>\"{{ nodeName }}\"</strong>\n        </mat-checkbox>\n\n        <br />\n\n        <div *ngIf=\"form.value.isLocked\">\n            <mat-checkbox class=\"adf-lock-file-name\" [formControlName]=\"'allowOwner'\" ngDefaultControl>\n                {{ 'CORE.FILE_DIALOG.ALLOW_OTHERS_CHECKBOX' | translate }}\n            </mat-checkbox>\n\n            <br />\n\n            <mat-checkbox class=\"adf-lock-file-name\" [formControlName]=\"'isTimeLock'\" ngDefaultControl>\n                {{ 'CORE.FILE_DIALOG.TIME_LOCK_CHECKBOX' | translate }}\n            </mat-checkbox>\n\n            <br />\n\n            <mat-form-field *ngIf=\"form.value.isTimeLock\">\n                <mat-datetimepicker-toggle [for]=\"datetimePicker\" matSuffix></mat-datetimepicker-toggle>\n                <mat-datetimepicker #datetimePicker type=\"datetime\" [openOnFocus]=\"true\" [timeInterval]=\"1\"></mat-datetimepicker>\n                <input matInput [formControlName]=\"'time'\" [matDatetimepicker]=\"datetimePicker\" required autocomplete=\"false\">\n            </mat-form-field>\n        </div>\n    </form>\n    <br />\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-dialog-buttons\">\n    <span class=\"adf-fill-remaining-space\"></span>\n\n    <button mat-button mat-dialog-close data-automation-id=\"lock-dialog-btn-cancel\">\n        {{ 'CORE.FILE_DIALOG.CANCEL_BUTTON.LABEL' | translate }}\n    </button>\n\n    <button class=\"adf-dialog-action-button\" mat-button (click)=\"submit()\">\n        {{ 'CORE.FILE_DIALOG.SAVE_BUTTON.LABEL' | translate }}\n    </button>\n</mat-dialog-actions>\n" }]
        }], ctorParameters: function () { return [{ type: i2$2.UntypedFormBuilder }, { type: i1$1.MatDialogRef }, { type: i1.AlfrescoApiService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class ContentNodeDialogService {
    constructor(dialog, contentService, documentListService, siteService, translation, thumbnailService) {
        this.dialog = dialog;
        this.contentService = contentService;
        this.documentListService = documentListService;
        this.siteService = siteService;
        this.translation = translation;
        this.thumbnailService = thumbnailService;
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
    }
    /**
     * Opens a file browser at a chosen folder location.
     * shows files and folders in the dialog search result.
     *
     * @param folderNodeId ID of the folder to use
     * @returns Information about the selected file(s)
     */
    openFileBrowseDialogByFolderId(folderNodeId) {
        return this.documentListService.getFolderNode(folderNodeId).pipe(switchMap((nodeEntry) => this.openUploadFileDialog(NodeAction.CHOOSE, nodeEntry.entry, true)));
    }
    /**
     * Opens a lock node dialog.
     *
     * @param contentEntry Node to lock
     * @returns Error/status message (if any)
     */
    openLockNodeDialog(contentEntry) {
        const observable = new Subject();
        if (this.contentService.hasAllowableOperations(contentEntry, AllowableOperationsEnum.LOCK)) {
            this.dialog.open(NodeLockDialogComponent, {
                data: {
                    node: contentEntry,
                    onError: (error) => {
                        this.error.emit(error);
                        observable.error(error);
                    }
                },
                width: '400px'
            });
        }
        else {
            observable.error('OPERATION.FAIL.NODE.NO_PERMISSION');
        }
        return observable;
    }
    /**
     * Opens a file browser at a chosen site location.
     * shows files and folders in the dialog search result.
     *
     * @returns Information about the selected file(s)
     */
    openFileBrowseDialogBySite() {
        return this.siteService.getSites().pipe(switchMap((response) => this.openFileBrowseDialogByFolderId(response.list.entries[0].entry.guid)));
    }
    /**
     * Opens a file browser at a default myFile location.
     * shows files and folders in the dialog search result.
     *
     * @returns Information about the selected file(s)
     */
    openFileBrowseDialogByDefaultLocation() {
        return this.openFileBrowseDialogByFolderId('-my-');
    }
    /**
     * Opens a folder browser at a chosen site location.
     *
     * @returns Information about the selected folder(s)
     */
    openFolderBrowseDialogBySite() {
        return this.openFolderBrowseDialogByFolderId('-my-');
    }
    /**
     * Opens a folder browser at a chosen folder location.
     *
     * @param folderNodeId ID of the folder to use
     * @returns Information about the selected folder(s)
     */
    openFolderBrowseDialogByFolderId(folderNodeId) {
        return this.documentListService.getFolderNode(folderNodeId).pipe(switchMap((node) => this.openUploadFolderDialog(NodeAction.CHOOSE, node.entry)));
    }
    /**
     * Opens a dialog to copy or move an item to a new location.
     *
     * @param action Name of the action (eg, "Copy" or "Move") to show in the title
     * @param contentEntry Item to be copied or moved
     * @param permission Permission for the operation
     * @param excludeSiteContent The site content that should be filtered out
     * @returns Information about files that were copied/moved
     */
    openCopyMoveDialog(action, contentEntry, permission, excludeSiteContent) {
        if (this.contentService.hasAllowableOperations(contentEntry, permission)) {
            const select = new Subject();
            const data = {
                title: this.getTitleTranslation(action, contentEntry.name),
                actionName: action,
                selectionMode: 'single',
                currentFolderId: contentEntry.parentId,
                imageResolver: this.imageResolver.bind(this),
                where: '(isFolder=true)',
                isSelectionValid: this.isCopyMoveSelectionValid.bind(this),
                excludeSiteContent: excludeSiteContent || ContentNodeDialogService.nonDocumentSiteContent,
                select
            };
            const dialogRef = this.openContentNodeDialog(data, 'adf-content-node-selector-dialog', '630px');
            dialogRef.afterClosed().subscribe({ next: () => select.complete() });
            return select;
        }
        else {
            const errors = new Error(JSON.stringify({ error: { statusCode: 403 } }));
            return throwError(errors);
        }
    }
    /**
     * Gets the translation of the dialog title.
     *
     * @param action Name of the action to display in the dialog title
     * @param name Name of the item on which the action is being performed
     * @returns Translated version of the title
     */
    getTitleTranslation(action, name) {
        return this.translation.instant(`NODE_SELECTOR.${action.toUpperCase()}_ITEM`, { name });
    }
    /**
     * Opens a dialog to choose folders to upload.
     *
     * @param action Name of the action to show in the title
     * @param contentEntry  Item to upload
     * @returns Information about the chosen folder(s)
     */
    openUploadFolderDialog(action, contentEntry) {
        const select = new Subject();
        const data = {
            title: this.getTitleTranslation(action, this.translation.instant('DROPDOWN.MY_FILES_OPTION')),
            actionName: action,
            selectionMode: 'single',
            currentFolderId: contentEntry.id,
            imageResolver: this.imageResolver.bind(this),
            isSelectionValid: this.hasAllowableOperationsOnNodeFolder.bind(this),
            where: '(isFolder=true)',
            select
        };
        const dialogRef = this.openContentNodeDialog(data, 'adf-content-node-selector-dialog', '630px');
        dialogRef.afterClosed().subscribe({ next: () => select.complete() });
        return select;
    }
    /**
     * Opens a dialog to choose a file to upload.
     *
     * @param action Name of the action to show in the title
     * @param contentEntry Item to upload
     * @param showFilesInResult Show files in dialog search result
     * @returns Information about the chosen file(s)
     */
    openUploadFileDialog(action, contentEntry, showFilesInResult = false) {
        const select = new Subject();
        const data = {
            title: this.getTitleTranslation(action, this.translation.instant('DROPDOWN.MY_FILES_OPTION')),
            actionName: action,
            selectionMode: 'single',
            currentFolderId: contentEntry.id,
            imageResolver: this.imageResolver.bind(this),
            isSelectionValid: (entry) => entry.isFile,
            select,
            showFilesInResult
        };
        const dialogRef = this.openContentNodeDialog(data, 'adf-content-node-selector-dialog', '630px');
        dialogRef.afterClosed().subscribe({ next: () => select.complete() });
        return select;
    }
    openContentNodeDialog(data, panelClass, width) {
        return this.dialog.open(ContentNodeSelectorComponent, {
            data,
            panelClass,
            width,
            disableClose: true
        });
    }
    imageResolver(row) {
        const entry = row.node.entry;
        if (!this.contentService.hasAllowableOperations(entry, 'create')) {
            if (this.isNodeFolder(entry)) {
                return this.thumbnailService.getMimeTypeIcon('disable/folder');
            }
        }
        return null;
    }
    hasAllowableOperationsOnNodeFolder(entry) {
        return this.isNodeFolder(entry) && this.contentService.hasAllowableOperations(entry, 'create');
    }
    isNodeFolder(entry) {
        return entry.isFolder;
    }
    isCopyMoveSelectionValid(entry) {
        return this.hasEntityCreatePermission(entry) && !this.isSite(entry);
    }
    hasEntityCreatePermission(entry) {
        return this.contentService.hasAllowableOperations(entry, 'create');
    }
    isSite(entry) {
        return !!entry.guid || entry.nodeType === 'st:site' || entry.nodeType === 'st:sites';
    }
}
ContentNodeDialogService.nonDocumentSiteContent = [
    'blog',
    'calendar',
    'dataLists',
    'discussions',
    'links',
    'wiki'
];
ContentNodeDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeDialogService, deps: [{ token: i1$1.MatDialog }, { token: ContentService }, { token: DocumentListService }, { token: SitesService }, { token: i1.TranslationService }, { token: i1.ThumbnailService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentNodeDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeDialogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: ContentService }, { type: DocumentListService }, { type: SitesService }, { type: i1.TranslationService }, { type: i1.ThumbnailService }]; }, propDecorators: { error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeLockDirective {
    constructor(element, renderer, contentService, contentNodeDialogService) {
        this.element = element;
        this.renderer = renderer;
        this.contentService = contentService;
        this.contentNodeDialogService = contentNodeDialogService;
    }
    onClick(event) {
        event.stopPropagation();
        this.contentNodeDialogService.openLockNodeDialog(this.node);
    }
    ngAfterViewInit() {
        const hasAllowableOperations = this.contentService.hasAllowableOperations(this.node, AllowableOperationsEnum.LOCK);
        this.renderer.setProperty(this.element.nativeElement, 'disabled', !hasAllowableOperations);
    }
}
NodeLockDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeLockDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: ContentService }, { token: ContentNodeDialogService }], target: i0.ɵɵFactoryTarget.Directive });
NodeLockDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeLockDirective, selector: "[adf-node-lock]", inputs: { node: ["adf-node-lock", "node"] }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeLockDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-node-lock]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: ContentService }, { type: ContentNodeDialogService }]; }, propDecorators: { node: [{
                type: Input,
                args: ['adf-node-lock']
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CheckAllowableOperationDirective {
    constructor(elementRef, renderer, contentService, changeDetector, parentComponent) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.contentService = contentService;
        this.changeDetector = changeDetector;
        this.parentComponent = parentComponent;
        /** Node permission to check (create, delete, update, updatePermissions,
         * !create, !delete, !update, !updatePermissions).
         */
        this.permission = null;
        /** Nodes to check permission for. */
        this.nodes = [];
    }
    ngOnChanges(changes) {
        if (changes.nodes && !changes.nodes.firstChange) {
            this.updateElement();
        }
    }
    /**
     * Updates disabled state for the decorated element
     *
     * @memberof CheckAllowableOperationDirective
     */
    updateElement() {
        const enable = this.hasAllowableOperations(this.nodes, this.permission);
        if (enable) {
            this.enable();
        }
        else {
            this.disable();
        }
        return enable;
    }
    enable() {
        if (this.parentComponent) {
            this.parentComponent.disabled = false;
            this.changeDetector.detectChanges();
        }
        else {
            this.enableElement();
        }
    }
    disable() {
        if (this.parentComponent) {
            this.parentComponent.disabled = true;
            this.changeDetector.detectChanges();
        }
        else {
            this.disableElement();
        }
    }
    /**
     * Enables decorated element
     *
     * @memberof CheckAllowableOperationDirective
     */
    enableElement() {
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
    }
    /**
     * Disables decorated element
     *
     * @memberof CheckAllowableOperationDirective
     */
    disableElement() {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
    }
    /**
     * Checks whether all nodes have a particular permission
     *
     * @param  nodes Node collection to check
     * @param  permission Permission to check for each node
     * @memberof CheckAllowableOperationDirective
     */
    hasAllowableOperations(nodes, permission) {
        if (nodes && nodes.length > 0) {
            return nodes.every((node) => this.contentService.hasAllowableOperations(node.entry, permission));
        }
        return false;
    }
}
CheckAllowableOperationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CheckAllowableOperationDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: ContentService }, { token: i0.ChangeDetectorRef }, { token: EXTENDIBLE_COMPONENT, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
CheckAllowableOperationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: CheckAllowableOperationDirective, selector: "[adf-check-allowable-operation]", inputs: { permission: ["adf-check-allowable-operation", "permission"], nodes: ["adf-nodes", "nodes"] }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CheckAllowableOperationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-check-allowable-operation]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: ContentService }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Host
                }, {
                    type: Optional
                }, {
                    type: Inject,
                    args: [EXTENDIBLE_COMPONENT]
                }] }]; }, propDecorators: { permission: [{
                type: Input,
                args: ['adf-check-allowable-operation']
            }], nodes: [{
                type: Input,
                args: ['adf-nodes']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LibraryFavoriteDirective {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
        this.library = null;
        this.toggle = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.error = new EventEmitter();
        this.targetLibrary = null;
    }
    get favoritesApi() {
        this._favoritesApi = this._favoritesApi ?? new FavoritesApi(this.alfrescoApiService.getInstance());
        return this._favoritesApi;
    }
    onClick() {
        const guid = this.targetLibrary.entry.guid;
        if (this.targetLibrary.isFavorite) {
            this.removeFavorite(guid);
        }
        else {
            this.addFavorite({
                target: {
                    site: {
                        guid
                    }
                }
            });
        }
    }
    ngOnChanges(changes) {
        if (!changes.library.currentValue) {
            this.targetLibrary = null;
            return;
        }
        this.targetLibrary = changes.library.currentValue;
        this.markFavoriteLibrary(changes.library.currentValue);
    }
    isFavorite() {
        return this.targetLibrary && this.targetLibrary.isFavorite;
    }
    async markFavoriteLibrary(library) {
        if (this.targetLibrary.isFavorite === undefined) {
            try {
                await this.favoritesApi.getFavoriteSite('-me-', library.entry.id);
                this.targetLibrary.isFavorite = true;
            }
            catch {
                this.targetLibrary.isFavorite = false;
            }
        }
        else {
            this.targetLibrary = library;
        }
    }
    addFavorite(favoriteBody) {
        this.favoritesApi
            .createFavorite('-me-', favoriteBody)
            .then((libraryEntry) => {
            this.targetLibrary.isFavorite = true;
            this.toggle.emit(libraryEntry);
        })
            .catch((error) => this.error.emit(error));
    }
    removeFavorite(favoriteId) {
        this.favoritesApi
            .deleteFavorite('-me-', favoriteId)
            .then((libraryBody) => {
            this.targetLibrary.isFavorite = false;
            this.toggle.emit(libraryBody);
        })
            .catch((error) => this.error.emit(error));
    }
}
LibraryFavoriteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryFavoriteDirective, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Directive });
LibraryFavoriteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: LibraryFavoriteDirective, selector: "[adf-favorite-library]", inputs: { library: ["adf-favorite-library", "library"] }, outputs: { toggle: "toggle", error: "error" }, host: { listeners: { "click": "onClick()" } }, exportAs: ["favoriteLibrary"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryFavoriteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-favorite-library]',
                    exportAs: 'favoriteLibrary'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; }, propDecorators: { library: [{
                type: Input,
                args: ['adf-favorite-library']
            }], toggle: [{
                type: Output
            }], error: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionCompatibilityService {
    constructor(discoveryApiService) {
        this.discoveryApiService = discoveryApiService;
        this.acsVersionInitialized$ = new ReplaySubject();
        this.discoveryApiService.ecmProductInfo$
            .pipe(filter(acsInfo => !!acsInfo))
            .subscribe((acsInfo) => this.initializeAcsVersion(acsInfo.version));
    }
    initializeAcsVersion(acsVersion) {
        this.acsVersion = acsVersion;
        this.acsVersionInitialized$.next();
    }
    getAcsVersion() {
        return this.acsVersion;
    }
    isVersionSupported(requiredVersion) {
        const parsedRequiredVersion = this.parseVersion(requiredVersion);
        const currentVersion = this.getAcsVersion();
        let versionSupported = false;
        if (currentVersion) {
            if (+currentVersion.major > +parsedRequiredVersion.major) {
                versionSupported = true;
            }
            else if (currentVersion.major === parsedRequiredVersion.major &&
                +currentVersion.minor > +parsedRequiredVersion.minor) {
                versionSupported = true;
            }
            else if (currentVersion.major === parsedRequiredVersion.major &&
                currentVersion.minor === parsedRequiredVersion.minor &&
                +currentVersion.patch >= +parsedRequiredVersion.patch) {
                versionSupported = true;
            }
        }
        return versionSupported;
    }
    parseVersion(version) {
        const major = version.split('.')[0];
        const minor = version.split('.')[1] || '0';
        const patch = version.split('.')[2] || '0';
        return {
            major,
            minor,
            patch
        };
    }
}
VersionCompatibilityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityService, deps: [{ token: DiscoveryApiService }], target: i0.ɵɵFactoryTarget.Injectable });
VersionCompatibilityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: DiscoveryApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LibraryMembershipDirective {
    constructor(alfrescoApiService, sitesService, versionCompatibilityService) {
        this.alfrescoApiService = alfrescoApiService;
        this.sitesService = sitesService;
        this.versionCompatibilityService = versionCompatibilityService;
        this.targetSite = null;
        this.isJoinRequested = new BehaviorSubject(false);
        /** Site for which to toggle the membership request. */
        this.selection = null;
        /** Site for which to toggle the membership request. */
        this.isAdmin = false;
        this.toggle = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.error = new EventEmitter();
    }
    get sitesApi() {
        this._sitesApi = this._sitesApi ?? new SitesApi(this.alfrescoApiService.getInstance());
        return this._sitesApi;
    }
    onClick() {
        this.toggleMembershipRequest();
    }
    ngOnChanges(changes) {
        if (!changes.selection.currentValue || !changes.selection.currentValue.entry) {
            this.targetSite = null;
            return;
        }
        this.targetSite = changes.selection.currentValue.entry;
        this.markMembershipRequest();
    }
    toggleMembershipRequest() {
        if (!this.targetSite) {
            return;
        }
        if (this.targetSite.joinRequested) {
            this.cancelJoinRequest().subscribe(() => {
                this.targetSite.joinRequested = false;
                this.isJoinRequested.next(false);
                const info = {
                    updatedEntry: this.targetSite,
                    shouldReload: false,
                    i18nKey: 'APP.MESSAGES.INFO.JOIN_CANCELED'
                };
                this.toggle.emit(info);
            }, (error) => {
                const errWithMessage = {
                    error,
                    i18nKey: 'APP.MESSAGES.ERRORS.JOIN_CANCEL_FAILED'
                };
                this.error.emit(errWithMessage);
            });
        }
        if (!this.targetSite.joinRequested && !this.isAdmin) {
            this.joinLibraryRequest().subscribe((createdMembership) => {
                this.targetSite.joinRequested = true;
                this.isJoinRequested.next(true);
                if (createdMembership.entry && createdMembership.entry.site && createdMembership.entry.site.role) {
                    const info = {
                        shouldReload: true,
                        i18nKey: 'APP.MESSAGES.INFO.JOINED'
                    };
                    this.toggle.emit(info);
                }
                else {
                    const info = {
                        updatedEntry: this.targetSite,
                        shouldReload: false,
                        i18nKey: 'APP.MESSAGES.INFO.JOIN_REQUESTED'
                    };
                    this.toggle.emit(info);
                }
            }, (error) => {
                const errWithMessage = {
                    error,
                    i18nKey: 'APP.MESSAGES.ERRORS.JOIN_REQUEST_FAILED'
                };
                const senderEmailCheck = 'Failed to resolve sender mail address';
                const receiverEmailCheck = 'All recipients for the mail action were invalid';
                if (error.message) {
                    if (error.message.includes(senderEmailCheck)) {
                        errWithMessage.i18nKey = 'APP.MESSAGES.ERRORS.INVALID_SENDER_EMAIL';
                    }
                    else if (error.message.includes(receiverEmailCheck)) {
                        errWithMessage.i18nKey = 'APP.MESSAGES.ERRORS.INVALID_RECEIVER_EMAIL';
                    }
                }
                this.error.emit(errWithMessage);
            });
        }
        if (this.isAdmin) {
            this.joinLibrary().subscribe((createdMembership) => {
                if (createdMembership.entry && createdMembership.entry.role) {
                    const info = {
                        shouldReload: true,
                        i18nKey: 'APP.MESSAGES.INFO.JOINED'
                    };
                    this.toggle.emit(info);
                }
            }, (error) => {
                const errWithMessage = {
                    error,
                    i18nKey: 'APP.MESSAGES.ERRORS.JOIN_REQUEST_FAILED'
                };
                const senderEmailCheck = 'Failed to resolve sender mail address';
                const receiverEmailCheck = 'All recipients for the mail action were invalid';
                if (error.message) {
                    if (error.message.includes(senderEmailCheck)) {
                        errWithMessage.i18nKey = 'APP.MESSAGES.ERRORS.INVALID_SENDER_EMAIL';
                    }
                    else if (error.message.includes(receiverEmailCheck)) {
                        errWithMessage.i18nKey = 'APP.MESSAGES.ERRORS.INVALID_RECEIVER_EMAIL';
                    }
                }
                this.error.emit(errWithMessage);
            });
        }
    }
    markMembershipRequest() {
        if (!this.targetSite) {
            return;
        }
        this.getMembershipRequest().subscribe((data) => {
            if (data.entry.id === this.targetSite.id) {
                this.targetSite.joinRequested = true;
                this.isJoinRequested.next(true);
            }
        }, () => {
            this.targetSite.joinRequested = false;
            this.isJoinRequested.next(false);
        });
    }
    joinLibraryRequest() {
        const memberBody = {
            id: this.targetSite.id
        };
        if (this.versionCompatibilityService.isVersionSupported('7.0.0')) {
            memberBody.client = 'workspace';
        }
        return from(this.sitesApi.createSiteMembershipRequestForPerson('-me-', memberBody));
    }
    joinLibrary() {
        return this.sitesService.createSiteMembership(this.targetSite.id, {
            role: 'SiteConsumer',
            id: '-me-'
        });
    }
    cancelJoinRequest() {
        return from(this.sitesApi.deleteSiteMembershipRequestForPerson('-me-', this.targetSite.id));
    }
    getMembershipRequest() {
        return from(this.sitesApi.getSiteMembershipRequestForPerson('-me-', this.targetSite.id));
    }
}
LibraryMembershipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryMembershipDirective, deps: [{ token: i1.AlfrescoApiService }, { token: SitesService }, { token: VersionCompatibilityService }], target: i0.ɵɵFactoryTarget.Directive });
LibraryMembershipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: LibraryMembershipDirective, selector: "[adf-library-membership]", inputs: { selection: ["adf-library-membership", "selection"], isAdmin: "isAdmin" }, outputs: { toggle: "toggle", error: "error" }, host: { listeners: { "click": "onClick()" } }, exportAs: ["libraryMembership"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryMembershipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-library-membership]',
                    exportAs: 'libraryMembership'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: SitesService }, { type: VersionCompatibilityService }]; }, propDecorators: { selection: [{
                type: Input,
                args: ['adf-library-membership']
            }], isAdmin: [{
                type: Input
            }], toggle: [{
                type: Output
            }], error: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeDeleteDirective {
    constructor(alfrescoApiService, translation, elementRef) {
        this.alfrescoApiService = alfrescoApiService;
        this.translation = translation;
        this.elementRef = elementRef;
        /** If true then the nodes are deleted immediately rather than being put in the trash */
        this.permanent = false;
        /** Emitted when the nodes have been deleted. */
        this.delete = new EventEmitter();
    }
    get trashcanApi() {
        this._trashcanApi = this._trashcanApi ?? new TrashcanApi(this.alfrescoApiService.getInstance());
        return this._trashcanApi;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.alfrescoApiService.getInstance());
        return this._nodesApi;
    }
    onClick() {
        this.process(this.selection);
    }
    ngOnChanges() {
        if (!this.selection || (this.selection && this.selection.length === 0)) {
            this.setDisableAttribute(true);
        }
        else {
            if (!this.elementRef.nativeElement.hasAttribute('adf-check-allowable-operation')) {
                this.setDisableAttribute(false);
            }
        }
    }
    setDisableAttribute(disable) {
        this.elementRef.nativeElement.disabled = disable;
    }
    process(selection) {
        if (selection && selection.length) {
            const batch = this.getDeleteNodesBatch(selection);
            forkJoin(...batch)
                .subscribe((data) => {
                const processedItems = this.processStatus(data);
                const message = this.getMessage(processedItems);
                if (message) {
                    this.delete.emit(message);
                }
            });
        }
    }
    getDeleteNodesBatch(selection) {
        return selection.map((node) => this.deleteNode(node));
    }
    deleteNode(node) {
        const id = node.entry.nodeId || node.entry.id;
        let promise;
        if (node.entry.hasOwnProperty('archivedAt') && node.entry['archivedAt']) {
            promise = this.trashcanApi.deleteDeletedNode(id);
        }
        else {
            promise = this.nodesApi.deleteNode(id, { permanent: this.permanent });
        }
        return from(promise).pipe(retry(3), map(() => ({
            entry: node.entry,
            status: 1
        })), catchError(() => of({
            entry: node.entry,
            status: 0
        })));
    }
    processStatus(data) {
        const deleteStatus = {
            success: [],
            failed: [],
            get someFailed() {
                return !!(this.failed.length);
            },
            get someSucceeded() {
                return !!(this.success.length);
            },
            get oneFailed() {
                return this.failed.length === 1;
            },
            get oneSucceeded() {
                return this.success.length === 1;
            },
            get allSucceeded() {
                return this.someSucceeded && !this.someFailed;
            },
            get allFailed() {
                return this.someFailed && !this.someSucceeded;
            }
        };
        return data.reduce((acc, next) => {
            if (next.status === 1) {
                acc.success.push(next);
            }
            else {
                acc.failed.push(next);
            }
            return acc;
        }, deleteStatus);
    }
    getMessage(status) {
        if (status.allFailed && !status.oneFailed) {
            return this.translation.instant('CORE.DELETE_NODE.ERROR_PLURAL', 
            // eslint-disable-next-line id-blacklist
            { number: status.failed.length });
        }
        if (status.allSucceeded && !status.oneSucceeded) {
            return this.translation.instant('CORE.DELETE_NODE.PLURAL', 
            // eslint-disable-next-line id-blacklist
            { number: status.success.length });
        }
        if (status.someFailed && status.someSucceeded && !status.oneSucceeded) {
            return this.translation.instant('CORE.DELETE_NODE.PARTIAL_PLURAL', {
                success: status.success.length,
                failed: status.failed.length
            });
        }
        if (status.someFailed && status.oneSucceeded) {
            return this.translation.instant('CORE.DELETE_NODE.PARTIAL_SINGULAR', {
                success: status.success.length,
                failed: status.failed.length
            });
        }
        if (status.oneFailed && !status.someSucceeded) {
            return this.translation.instant('CORE.DELETE_NODE.ERROR_SINGULAR', { name: status.failed[0].entry.name });
        }
        if (status.oneSucceeded && !status.someFailed) {
            return this.translation.instant('CORE.DELETE_NODE.SINGULAR', { name: status.success[0].entry.name });
        }
        return null;
    }
}
NodeDeleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeDeleteDirective, deps: [{ token: i1.AlfrescoApiService }, { token: i1.TranslationService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
NodeDeleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeDeleteDirective, selector: "[adf-delete]", inputs: { selection: ["adf-delete", "selection"], permanent: "permanent" }, outputs: { delete: "delete" }, host: { listeners: { "click": "onClick()" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeDeleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-delete]'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.TranslationService }, { type: i0.ElementRef }]; }, propDecorators: { selection: [{
                type: Input,
                args: ['adf-delete']
            }], permanent: [{
                type: Input
            }], delete: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeFavoriteDirective {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
        this.favorites = [];
        /** Array of nodes to toggle as favorites. */
        this.selection = [];
        /** Emitted when the favorite setting is complete. */
        this.toggle = new EventEmitter();
        /** Emitted when the favorite setting fails. */
        this.error = new EventEmitter();
    }
    get favoritesApi() {
        this._favoritesApi = this._favoritesApi ?? new FavoritesApi(this.alfrescoApiService.getInstance());
        return this._favoritesApi;
    }
    onClick() {
        this.toggleFavorite();
    }
    ngOnChanges(changes) {
        if (!changes.selection.currentValue.length) {
            this.favorites = [];
            return;
        }
        this.markFavoritesNodes(changes.selection.currentValue);
    }
    toggleFavorite() {
        if (!this.favorites.length) {
            return;
        }
        const every = this.favorites.every((selected) => selected.entry.isFavorite);
        if (every) {
            const batch = this.favorites.map((selected) => {
                // shared files have nodeId
                const id = selected.entry.nodeId || selected.entry.id;
                return from(this.favoritesApi.deleteFavorite('-me-', id));
            });
            forkJoin(batch).subscribe(() => {
                this.favorites.map((selected) => selected.entry.isFavorite = false);
                this.toggle.emit();
            }, (error) => this.error.emit(error));
        }
        if (!every) {
            const notFavorite = this.favorites.filter((node) => !node.entry.isFavorite);
            const body = notFavorite.map((node) => this.createFavoriteBody(node));
            from(this.favoritesApi.createFavorite('-me-', body))
                .subscribe(() => {
                notFavorite.map((selected) => selected.entry.isFavorite = true);
                this.toggle.emit();
            }, (error) => this.error.emit(error));
        }
    }
    markFavoritesNodes(selection) {
        if (selection.length <= this.favorites.length) {
            const newFavorites = this.reduce(this.favorites, selection);
            this.favorites = newFavorites;
        }
        const result = this.diff(selection, this.favorites);
        const batch = this.getProcessBatch(result);
        forkJoin(batch).subscribe((data) => {
            this.favorites.push(...data);
        });
    }
    hasFavorites() {
        if (this.favorites && !this.favorites.length) {
            return false;
        }
        return this.favorites.every((selected) => selected.entry.isFavorite);
    }
    getProcessBatch(selection) {
        return selection.map((selected) => this.getFavorite(selected));
    }
    getFavorite(selected) {
        const node = selected.entry;
        // ACS 6.x with 'isFavorite' include
        if (node && node.hasOwnProperty('isFavorite')) {
            return of(selected);
        }
        // ACS 5.x and 6.x without 'isFavorite' include
        const { name, isFile, isFolder } = node;
        const id = node.nodeId || node.id;
        const promise = this.favoritesApi.getFavorite('-me-', id);
        return from(promise).pipe(map(() => ({
            entry: {
                id,
                isFolder,
                isFile,
                name,
                isFavorite: true
            }
        })), catchError(() => of({
            entry: {
                id,
                isFolder,
                isFile,
                name,
                isFavorite: false
            }
        })));
    }
    createFavoriteBody(node) {
        const type = this.getNodeType(node);
        // shared files have nodeId
        const id = node.entry.nodeId || node.entry.id;
        return {
            target: {
                [type]: {
                    guid: id
                }
            }
        };
    }
    getNodeType(node) {
        // shared could only be files
        if (!node.entry.isFile && !node.entry.isFolder) {
            return 'file';
        }
        return node.entry.isFile ? 'file' : 'folder';
    }
    diff(list, patch) {
        const ids = patch.map((item) => item.entry.id);
        return list.filter((item) => ids.includes(item.entry.id) ? null : item);
    }
    reduce(patch, comparator) {
        const ids = comparator.map((item) => item.entry.id);
        return patch.filter((item) => ids.includes(item.entry.id) ? item : null);
    }
}
NodeFavoriteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeFavoriteDirective, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Directive });
NodeFavoriteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeFavoriteDirective, selector: "[adf-node-favorite]", inputs: { selection: ["adf-node-favorite", "selection"] }, outputs: { toggle: "toggle", error: "error" }, host: { listeners: { "click": "onClick()" } }, exportAs: ["adfFavorite"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeFavoriteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-node-favorite]',
                    exportAs: 'adfFavorite'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; }, propDecorators: { selection: [{
                type: Input,
                args: ['adf-node-favorite']
            }], toggle: [{
                type: Output
            }], error: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeRestoreDirective {
    constructor(alfrescoApiService, translation) {
        this.alfrescoApiService = alfrescoApiService;
        this.translation = translation;
        /** Emitted when restoration is complete. */
        this.restore = new EventEmitter();
        this.restoreProcessStatus = this.processStatus();
    }
    get trashcanApi() {
        this._trashcanApi = this._trashcanApi ?? new TrashcanApi(this.alfrescoApiService.getInstance());
        return this._trashcanApi;
    }
    onClick() {
        this.recover(this.selection);
    }
    recover(selection) {
        if (!selection.length) {
            return;
        }
        const nodesWithPath = this.getNodesWithPath(selection);
        if (selection.length && nodesWithPath.length) {
            this.restoreNodesBatch(nodesWithPath).pipe(tap((restoredNodes) => {
                const status = this.processStatus(restoredNodes);
                this.restoreProcessStatus.fail.push(...status.fail);
                this.restoreProcessStatus.success.push(...status.success);
            }), mergeMap(() => this.getDeletedNodes()))
                .subscribe((deletedNodesList) => {
                const { entries: nodeList } = deletedNodesList.list;
                const { fail: restoreErrorNodes } = this.restoreProcessStatus;
                const selectedNodes = this.diff(restoreErrorNodes, selection, false);
                const remainingNodes = this.diff(selectedNodes, nodeList);
                if (!remainingNodes.length) {
                    this.notification();
                }
                else {
                    this.recover(remainingNodes);
                }
            });
        }
        else {
            this.restoreProcessStatus.fail.push(...selection);
            this.notification();
            return;
        }
    }
    restoreNodesBatch(batch) {
        return forkJoin(batch.map((node) => this.restoreNode(node)));
    }
    getNodesWithPath(selection) {
        return selection.filter((node) => node.entry.path);
    }
    getDeletedNodes() {
        const promise = this.trashcanApi.listDeletedNodes({ include: ['path'] });
        return from(promise);
    }
    restoreNode(node) {
        const { entry } = node;
        const promise = this.trashcanApi.restoreDeletedNode(entry.id);
        return from(promise).pipe(map(() => ({
            status: 1,
            entry
        })), catchError((error) => {
            const { statusCode } = (JSON.parse(error.message)).error;
            return of({
                status: 0,
                statusCode,
                entry
            });
        }));
    }
    diff(selection, list, fromList = true) {
        const ids = selection.map((item) => item.entry.id);
        return list.filter((item) => {
            if (fromList) {
                return ids.includes(item.entry.id) ? item : null;
            }
            else {
                return !ids.includes(item.entry.id) ? item : null;
            }
        });
    }
    processStatus(data = []) {
        const status = {
            fail: [],
            success: [],
            get someFailed() {
                return !!(this.fail.length);
            },
            get someSucceeded() {
                return !!(this.success.length);
            },
            get oneFailed() {
                return this.fail.length === 1;
            },
            get oneSucceeded() {
                return this.success.length === 1;
            },
            get allSucceeded() {
                return this.someSucceeded && !this.someFailed;
            },
            get allFailed() {
                return this.someFailed && !this.someSucceeded;
            },
            reset() {
                this.fail = [];
                this.success = [];
            }
        };
        return data.reduce((acc, node) => {
            if (node.status) {
                acc.success.push(node);
            }
            else {
                acc.fail.push(node);
            }
            return acc;
        }, status);
    }
    getRestoreMessage() {
        const { restoreProcessStatus: status } = this;
        if (status.someFailed && !status.oneFailed) {
            return this.translation.instant('CORE.RESTORE_NODE.PARTIAL_PLURAL', {
                // eslint-disable-next-line id-blacklist
                number: status.fail.length
            });
        }
        if (status.oneFailed && status.fail[0].statusCode) {
            if (status.fail[0].statusCode === 409) {
                return this.translation.instant('CORE.RESTORE_NODE.NODE_EXISTS', {
                    name: status.fail[0].entry.name
                });
            }
            else {
                return this.translation.instant('CORE.RESTORE_NODE.GENERIC', {
                    name: status.fail[0].entry.name
                });
            }
        }
        if (status.oneFailed && !status.fail[0].statusCode) {
            return this.translation.instant('CORE.RESTORE_NODE.LOCATION_MISSING', {
                name: status.fail[0].entry.name
            });
        }
        if (status.allSucceeded && !status.oneSucceeded) {
            return this.translation.instant('CORE.RESTORE_NODE.PLURAL');
        }
        if (status.allSucceeded && status.oneSucceeded) {
            return this.translation.instant('CORE.RESTORE_NODE.SINGULAR', {
                name: status.success[0].entry.name
            });
        }
        return null;
    }
    notification() {
        const status = Object.assign({}, this.restoreProcessStatus);
        const message = this.getRestoreMessage();
        this.reset();
        const action = (status.oneSucceeded && !status.someFailed) ? this.translation.instant('CORE.RESTORE_NODE.VIEW') : '';
        let path;
        if (status.success && status.success.length > 0) {
            path = status.success[0].entry.path;
        }
        this.restore.emit({
            message,
            action,
            path
        });
    }
    reset() {
        this.restoreProcessStatus.reset();
        this.selection = [];
    }
}
NodeRestoreDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeRestoreDirective, deps: [{ token: i1.AlfrescoApiService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Directive });
NodeRestoreDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeRestoreDirective, selector: "[adf-restore]", inputs: { selection: ["adf-restore", "selection"] }, outputs: { restore: "restore" }, host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeRestoreDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-restore]'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.TranslationService }]; }, propDecorators: { selection: [{
                type: Input,
                args: ['adf-restore']
            }], restore: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentDirectiveModule {
}
ContentDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentDirectiveModule, declarations: [NodeLockDirective,
        NodeCounterDirective,
        NodeCounterComponent,
        AutoFocusDirective,
        CheckAllowableOperationDirective,
        LibraryFavoriteDirective,
        LibraryMembershipDirective,
        NodeDeleteDirective,
        NodeFavoriteDirective,
        NodeRestoreDirective,
        NodeDownloadDirective], imports: [CommonModule,
        MaterialModule,
        TranslateModule], exports: [NodeLockDirective,
        NodeCounterDirective,
        AutoFocusDirective,
        CheckAllowableOperationDirective,
        LibraryFavoriteDirective,
        LibraryMembershipDirective,
        NodeDeleteDirective,
        NodeFavoriteDirective,
        NodeRestoreDirective,
        NodeDownloadDirective] });
ContentDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentDirectiveModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule
                    ],
                    declarations: [
                        NodeLockDirective,
                        NodeCounterDirective,
                        NodeCounterComponent,
                        AutoFocusDirective,
                        CheckAllowableOperationDirective,
                        LibraryFavoriteDirective,
                        LibraryMembershipDirective,
                        NodeDeleteDirective,
                        NodeFavoriteDirective,
                        NodeRestoreDirective,
                        NodeDownloadDirective
                    ],
                    exports: [
                        NodeLockDirective,
                        NodeCounterDirective,
                        AutoFocusDirective,
                        CheckAllowableOperationDirective,
                        LibraryFavoriteDirective,
                        LibraryMembershipDirective,
                        NodeDeleteDirective,
                        NodeFavoriteDirective,
                        NodeRestoreDirective,
                        NodeDownloadDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RatingService {
    constructor(apiService, logService) {
        this.apiService = apiService;
        this.logService = logService;
    }
    get ratingsApi() {
        this._ratingsApi = this._ratingsApi ?? new RatingsApi(this.apiService.getInstance());
        return this._ratingsApi;
    }
    /**
     * Gets the current user's rating for a node.
     *
     * @param nodeId Node to get the rating from
     * @param ratingType Type of rating (can be "likes" or "fiveStar")
     * @returns The rating value
     */
    getRating(nodeId, ratingType) {
        return from(this.ratingsApi.getRating(nodeId, ratingType))
            .pipe(catchError(this.handleError));
    }
    /**
     * Adds the current user's rating for a node.
     *
     * @param nodeId Target node for the rating
     * @param ratingType Type of rating (can be "likes" or "fiveStar")
     * @param vote Rating value (boolean for "likes", numeric 0..5 for "fiveStar")
     * @returns Details about the rating, including the new value
     */
    postRating(nodeId, ratingType, vote) {
        const ratingBody = new RatingBody({
            id: ratingType,
            myRating: vote
        });
        return from(this.ratingsApi.createRating(nodeId, ratingBody))
            .pipe(catchError(this.handleError));
    }
    /**
     * Removes the current user's rating for a node.
     *
     * @param nodeId Target node
     * @param ratingType Type of rating to remove (can be "likes" or "fiveStar")
     * @returns Null response indicating that the operation is complete
     */
    deleteRating(nodeId, ratingType) {
        return from(this.ratingsApi.deleteRating(nodeId, ratingType))
            .pipe(catchError(this.handleError));
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
RatingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RatingService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
RatingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RatingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RatingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RatingComponent {
    constructor(ratingService) {
        this.ratingService = ratingService;
        this.average = 0;
        this.ratingsCounter = 0;
        this.ratingType = 'fiveStar';
        /** Emitted when the "vote" gets changed. */
        this.changeVote = new EventEmitter();
        this.stars = [];
        this.onDestroy$ = new Subject();
    }
    ngOnChanges() {
        this.ratingService.getRating(this.nodeId, this.ratingType)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((ratingEntry) => {
            this.refreshRating(ratingEntry);
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    calculateStars() {
        this.stars = [];
        const roundedAverage = Math.round(this.average);
        for (let i = 0; i < 5; i++) {
            if (i < roundedAverage) {
                this.stars.push({ fill: true });
            }
            else {
                this.stars.push({ fill: false });
            }
        }
    }
    updateVote(vote) {
        if (this.ratingValue === vote) {
            this.unRateItem();
        }
        else {
            this.rateItem(vote);
        }
    }
    rateItem(vote) {
        this.ratingService.postRating(this.nodeId, this.ratingType, vote)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((ratingEntry) => {
            this.refreshRating(ratingEntry);
        });
    }
    unRateItem() {
        this.ratingService.deleteRating(this.nodeId, this.ratingType).subscribe(() => {
            this.ratingService.getRating(this.nodeId, this.ratingType)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((ratingEntry) => {
                this.refreshRating(ratingEntry);
            });
        });
    }
    refreshRating(ratingEntry) {
        this.ratingValue = Number.parseFloat(ratingEntry.entry.myRating);
        this.average = ratingEntry.entry.aggregate.average;
        this.ratingsCounter = ratingEntry.entry.aggregate.numberOfRatings;
        this.calculateStars();
        this.changeVote.emit(this.average);
    }
}
RatingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RatingComponent, deps: [{ token: RatingService }], target: i0.ɵɵFactoryTarget.Component });
RatingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: RatingComponent, selector: "adf-rating", inputs: { nodeId: "nodeId" }, outputs: { changeVote: "changeVote" }, usesOnChanges: true, ngImport: i0, template: "<mat-list id=\"adf-rating-container\" class=\"adf-rating-container\">\n    <mat-list-item class=\"adf-rating-star\" *ngFor=\"let currentRate of stars; let idx = index;\">\n            <span id=\"adf-rate-{{idx}}\">\n                <mat-icon id=\"adf-colored-star-{{idx}}\" *ngIf=\"currentRate.fill\" class=\"adf-colored-star\"\n                          [ngClass]=\"{'adf-average-star': !ratingValue}\"\n                          (click)=\"updateVote(idx + 1)\">star_rate\n                </mat-icon>\n                <mat-icon id=\"adf-grey-star-{{idx}}\" *ngIf=\"!currentRate.fill\" class=\"adf-grey-star\"\n                          (click)=\"updateVote(idx + 1)\">star_border\n                </mat-icon>\n            </span>\n    </mat-list-item>\n    <div class=\"adf-rating-counter-container\">\n    <div id=\"adf-rating-counter\" class=\"adf-rating-counter\">{{ratingsCounter}}</div>\n    <div class=\"adf-rating-left\" *ngIf=\"ratingsCounter<=1\">Rating</div>\n    <div class=\"adf-rating-left\" *ngIf=\"ratingsCounter>1\">Ratings</div>\n    </div>\n</mat-list>\n", styles: [".adf-rating-container{display:flex;overflow:hidden;width:100%}.adf-rating-container .adf-rating-counter-container{display:flex;align-items:center;padding:0 6px}.adf-rating-container .adf-rating-left{padding:0 6px}.adf-rating-container .adf-rating-star{display:flex;justify-content:center;transition:all .3s;cursor:pointer;width:25px}.adf-rating-container .adf-rating-star .mat-list-item-content{padding:0!important}.adf-rating-container .adf-rating-star:hover{transform:rotate(13deg) scale(1.2)}.adf-rating-container .adf-colored-star{color:#ffe944}.adf-rating-container .adf-grey-star,.adf-rating-container .adf-average-star{color:gray!important}[dir=rtl] .adf-rating-container .adf-rating-star{transform:rotate(145deg)}[dir=rtl] .adf-rating-container .adf-rating-star:hover{transform:rotate(158deg) scale(1.2)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i8$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i8$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RatingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-rating', encapsulation: ViewEncapsulation.None, template: "<mat-list id=\"adf-rating-container\" class=\"adf-rating-container\">\n    <mat-list-item class=\"adf-rating-star\" *ngFor=\"let currentRate of stars; let idx = index;\">\n            <span id=\"adf-rate-{{idx}}\">\n                <mat-icon id=\"adf-colored-star-{{idx}}\" *ngIf=\"currentRate.fill\" class=\"adf-colored-star\"\n                          [ngClass]=\"{'adf-average-star': !ratingValue}\"\n                          (click)=\"updateVote(idx + 1)\">star_rate\n                </mat-icon>\n                <mat-icon id=\"adf-grey-star-{{idx}}\" *ngIf=\"!currentRate.fill\" class=\"adf-grey-star\"\n                          (click)=\"updateVote(idx + 1)\">star_border\n                </mat-icon>\n            </span>\n    </mat-list-item>\n    <div class=\"adf-rating-counter-container\">\n    <div id=\"adf-rating-counter\" class=\"adf-rating-counter\">{{ratingsCounter}}</div>\n    <div class=\"adf-rating-left\" *ngIf=\"ratingsCounter<=1\">Rating</div>\n    <div class=\"adf-rating-left\" *ngIf=\"ratingsCounter>1\">Ratings</div>\n    </div>\n</mat-list>\n", styles: [".adf-rating-container{display:flex;overflow:hidden;width:100%}.adf-rating-container .adf-rating-counter-container{display:flex;align-items:center;padding:0 6px}.adf-rating-container .adf-rating-left{padding:0 6px}.adf-rating-container .adf-rating-star{display:flex;justify-content:center;transition:all .3s;cursor:pointer;width:25px}.adf-rating-container .adf-rating-star .mat-list-item-content{padding:0!important}.adf-rating-container .adf-rating-star:hover{transform:rotate(13deg) scale(1.2)}.adf-rating-container .adf-colored-star{color:#ffe944}.adf-rating-container .adf-grey-star,.adf-rating-container .adf-average-star{color:gray!important}[dir=rtl] .adf-rating-container .adf-rating-star{transform:rotate(145deg)}[dir=rtl] .adf-rating-container .adf-rating-star:hover{transform:rotate(158deg) scale(1.2)}\n"] }]
        }], ctorParameters: function () { return [{ type: RatingService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], changeVote: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LikeComponent {
    constructor(ratingService) {
        this.ratingService = ratingService;
        /** Emitted when the "vote" gets changed. */
        this.changeVote = new EventEmitter();
        this.likesCounter = 0;
        this.ratingType = 'likes';
        this.isLike = false;
    }
    ngOnChanges() {
        this.clean();
        this.ratingService.getRating(this.nodeId, this.ratingType).subscribe((ratingEntry) => {
            if (ratingEntry.entry.aggregate) {
                this.likesCounter = ratingEntry.entry.aggregate.numberOfRatings;
                if (ratingEntry.entry.ratedAt) {
                    this.isLike = true;
                }
            }
        });
    }
    likeClick() {
        if (this.isLike) {
            this.ratingService.deleteRating(this.nodeId, this.ratingType).subscribe(() => {
                this.likesCounter -= 1;
                this.isLike = false;
                this.changeVote.emit(this.likesCounter);
            });
        }
        else {
            this.ratingService.postRating(this.nodeId, this.ratingType, true).subscribe((ratingEntry) => {
                this.likesCounter = ratingEntry.entry.aggregate.numberOfRatings;
                this.isLike = true;
                this.changeVote.emit(this.likesCounter);
            });
        }
    }
    clean() {
        this.isLike = false;
        this.likesCounter = 0;
    }
}
LikeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LikeComponent, deps: [{ token: RatingService }], target: i0.ɵɵFactoryTarget.Component });
LikeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LikeComponent, selector: "adf-like", inputs: { nodeId: "nodeId" }, outputs: { changeVote: "changeVote" }, usesOnChanges: true, ngImport: i0, template: "<div id=\"adf-like-container\" class=\"adf-like-container\">\n    <div class=\"adf-like\">\n        <span id=\"adf-like-{{nodeId}}\" [ngClass]=\"{'adf-like-select': isLike ,'adf-like-grey': !isLike  }\"\n              (click)=\"likeClick()\">\n            <mat-icon>thumb_up</mat-icon>\n        </span>\n    </div>\n    <div class=\"adf-like-counter-container\">\n        <div id=\"adf-like-counter\" class=\"adf-like-counter\">{{likesCounter}}</div>\n        <div class=\"adf-left\" *ngIf=\"likesCounter===1\">Like</div>\n        <div class=\"adf-left\" *ngIf=\"likesCounter!==1\">Likes</div>\n    </div>\n</div>\n", styles: [".adf-like-container{display:flex;overflow:hidden;width:100%;align-items:center;margin-top:13px}.adf-like-container .adf-like-counter-container{display:inherit;padding:0 6px}.adf-like-container .adf-left{padding:0 6px}.adf-like-container .adf-like-select{cursor:pointer;color:#2196f3}.adf-like-container .adf-like-select:hover{color:gray}.adf-like-container .adf-like-grey{cursor:pointer;color:gray}.adf-like-container .adf-like-grey:hover{color:#2196f3}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LikeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-like', encapsulation: ViewEncapsulation.None, template: "<div id=\"adf-like-container\" class=\"adf-like-container\">\n    <div class=\"adf-like\">\n        <span id=\"adf-like-{{nodeId}}\" [ngClass]=\"{'adf-like-select': isLike ,'adf-like-grey': !isLike  }\"\n              (click)=\"likeClick()\">\n            <mat-icon>thumb_up</mat-icon>\n        </span>\n    </div>\n    <div class=\"adf-like-counter-container\">\n        <div id=\"adf-like-counter\" class=\"adf-like-counter\">{{likesCounter}}</div>\n        <div class=\"adf-left\" *ngIf=\"likesCounter===1\">Like</div>\n        <div class=\"adf-left\" *ngIf=\"likesCounter!==1\">Likes</div>\n    </div>\n</div>\n", styles: [".adf-like-container{display:flex;overflow:hidden;width:100%;align-items:center;margin-top:13px}.adf-like-container .adf-like-counter-container{display:inherit;padding:0 6px}.adf-like-container .adf-left{padding:0 6px}.adf-like-container .adf-like-select{cursor:pointer;color:#2196f3}.adf-like-container .adf-like-select:hover{color:gray}.adf-like-container .adf-like-grey{cursor:pointer;color:gray}.adf-like-container .adf-like-grey:hover{color:#2196f3}\n"] }]
        }], ctorParameters: function () { return [{ type: RatingService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], changeVote: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SocialModule {
}
SocialModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SocialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SocialModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SocialModule, declarations: [RatingComponent,
        LikeComponent], imports: [CommonModule,
        MaterialModule], exports: [RatingComponent,
        LikeComponent] });
SocialModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SocialModule, imports: [CommonModule,
        MaterialModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SocialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule
                    ],
                    exports: [
                        RatingComponent,
                        LikeComponent
                    ],
                    declarations: [
                        RatingComponent,
                        LikeComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * This component, provide a list of the tags relative a node with actions button to add or remove new tag
 */
class TagActionsComponent {
    constructor(tagService, translateService) {
        this.tagService = tagService;
        this.translateService = translateService;
        /** Emitted when a tag is added successfully. */
        this.successAdd = new EventEmitter();
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
        /** Emitted when an action is chosen. */
        this.result = new EventEmitter();
        this.disableAddTag = true;
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.tagService.refresh
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => this.refreshTag());
    }
    ngOnChanges() {
        return this.refreshTag();
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    refreshTag() {
        if (this.nodeId) {
            this.tagService.getTagsByNodeId(this.nodeId).subscribe((tagPaging) => {
                this.tagsEntries = tagPaging.list.entries;
                this.disableAddTag = false;
                this.result.emit(this.tagsEntries);
            }, () => {
                this.tagsEntries = null;
                this.disableAddTag = true;
                this.result.emit(this.tagsEntries);
            });
        }
    }
    addTag() {
        if (this.searchTag(this.newTagName)) {
            this.errorMsg = this.translateService.instant('TAG.MESSAGES.EXIST');
            this.error.emit(this.errorMsg);
        }
        else {
            this.tagService.addTag(this.nodeId, this.newTagName).subscribe(() => {
                this.newTagName = '';
                this.successAdd.emit(this.nodeId);
            });
        }
    }
    searchTag(searchTagName) {
        if (this.tagsEntries) {
            return this.tagsEntries.find((currentTag) => (searchTagName === currentTag.entry.tag));
        }
    }
    cleanErrorMsg() {
        this.errorMsg = '';
    }
    removeTag(tag) {
        this.tagService.removeTag(this.nodeId, tag);
    }
}
TagActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagActionsComponent, deps: [{ token: TagService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Component });
TagActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TagActionsComponent, selector: "adf-tag-node-actions-list", inputs: { nodeId: "nodeId" }, outputs: { successAdd: "successAdd", error: "error", result: "result" }, host: { classAttribute: "adf-tag-node-actions-list" }, usesOnChanges: true, ngImport: i0, template: "<mat-list>\n    <mat-list-item *ngFor=\"let currentEntry of tagsEntries; let idx = index\">\n        <div class=\"adf-tag-actions-container\" id=\"tag_delete_{{currentEntry.entry.tag}}\" (click)=\"removeTag(currentEntry.entry.id)\">\n            <div class=\"adf-tag-actions-delete-text\" id=\"tag_name_{{currentEntry.entry.tag}}\">{{currentEntry.entry.tag}}</div>\n            <mat-icon class=\"adf-tag-actions-delete-icon\">delete</mat-icon>\n        </div>\n    </mat-list-item>\n</mat-list>\n<table class=\"adf-full-width\" cellspacing=\"0\">\n    <tr>\n        <td>\n            <mat-form-field class=\"adf-full-width\">\n                <input\n                    id=\"new-tag-text\"\n                    matInput placeholder=\"{{'TAG.LABEL.NEWTAG' | translate }}\"\n                    type=\"text\"\n                    (keypress)=\"cleanErrorMsg()\"\n                    [(ngModel)]=\"newTagName\"\n                />\n                <mat-hint data-automation-id=\"errorMessage\" *ngIf=\"error\" [ngStyle]=\"{'color': 'red'}\" align=\"start\">{{errorMsg}}</mat-hint>\n            </mat-form-field>\n        </td>\n        <td>\n            <button\n                id=\"add-tag\"\n                class=\"adf-full-width\"\n                color=\"primary\"\n                (click)=\"addTag()\"\n                [disabled]=\"disableAddTag\"\n                mat-raised-button\n            >{{'TAG.BUTTON.ADD' | translate }}</button>\n        </td>\n    </tr>\n</table>\n", styles: [".adf-tag-node-actions-list .adf-full-width{width:100%}.adf-tag-node-actions-list .adf-tag-actions-delete-icon{float:right;cursor:pointer}.adf-tag-node-actions-list .adf-tag-actions-delete-text{font-size:var(--theme-subheading-2-font-size);float:left}.adf-tag-node-actions-list .adf-tag-actions-container{padding:8px 0;height:20px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i8$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i8$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tag-node-actions-list', encapsulation: ViewEncapsulation.None, host: { class: 'adf-tag-node-actions-list' }, template: "<mat-list>\n    <mat-list-item *ngFor=\"let currentEntry of tagsEntries; let idx = index\">\n        <div class=\"adf-tag-actions-container\" id=\"tag_delete_{{currentEntry.entry.tag}}\" (click)=\"removeTag(currentEntry.entry.id)\">\n            <div class=\"adf-tag-actions-delete-text\" id=\"tag_name_{{currentEntry.entry.tag}}\">{{currentEntry.entry.tag}}</div>\n            <mat-icon class=\"adf-tag-actions-delete-icon\">delete</mat-icon>\n        </div>\n    </mat-list-item>\n</mat-list>\n<table class=\"adf-full-width\" cellspacing=\"0\">\n    <tr>\n        <td>\n            <mat-form-field class=\"adf-full-width\">\n                <input\n                    id=\"new-tag-text\"\n                    matInput placeholder=\"{{'TAG.LABEL.NEWTAG' | translate }}\"\n                    type=\"text\"\n                    (keypress)=\"cleanErrorMsg()\"\n                    [(ngModel)]=\"newTagName\"\n                />\n                <mat-hint data-automation-id=\"errorMessage\" *ngIf=\"error\" [ngStyle]=\"{'color': 'red'}\" align=\"start\">{{errorMsg}}</mat-hint>\n            </mat-form-field>\n        </td>\n        <td>\n            <button\n                id=\"add-tag\"\n                class=\"adf-full-width\"\n                color=\"primary\"\n                (click)=\"addTag()\"\n                [disabled]=\"disableAddTag\"\n                mat-raised-button\n            >{{'TAG.BUTTON.ADD' | translate }}</button>\n        </td>\n    </tr>\n</table>\n", styles: [".adf-tag-node-actions-list .adf-full-width{width:100%}.adf-tag-node-actions-list .adf-tag-actions-delete-icon{float:right;cursor:pointer}.adf-tag-node-actions-list .adf-tag-actions-delete-text{font-size:var(--theme-subheading-2-font-size);float:left}.adf-tag-node-actions-list .adf-tag-actions-container{padding:8px 0;height:20px}\n"] }]
        }], ctorParameters: function () { return [{ type: TagService }, { type: i1.TranslationService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], successAdd: [{
                type: Output
            }], error: [{
                type: Output
            }], result: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This component provide a list of all the tag inside the ECM
 */
class TagListComponent {
    /**
     * Constructor
     *
     * @param tagService
     */
    constructor(tagService) {
        this.tagService = tagService;
        /** Emitted when a tag is selected. */
        this.result = new EventEmitter();
        /**
         * Array of tags that are displayed
         */
        this.tagsEntries = [];
        /**
         * Number of items per iteration
         */
        this.size = 10;
        this.isLoading = false;
        this.isSizeMinimum = true;
        this.onDestroy$ = new Subject();
        this.defaultPagination = {
            skipCount: 0,
            maxItems: this.size,
            hasMoreItems: false
        };
        this.pagination = this.defaultPagination;
        this.tagService.refresh
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
            this.tagsEntries = [];
            this.refreshTag(this.defaultPagination);
        });
    }
    ngOnInit() {
        this.refreshTag(this.defaultPagination);
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    refreshTag(opts) {
        this.tagService.getAllTheTags(opts).subscribe((tags) => {
            this.tagsEntries = this.tagsEntries.concat(tags.list.entries);
            this.pagination = tags.list.pagination;
            this.result.emit(this.tagsEntries);
            this.isLoading = false;
        });
    }
    loadMoreTags() {
        if (this.pagination.hasMoreItems) {
            this.isLoading = true;
            this.isSizeMinimum = false;
            this.refreshTag({
                skipCount: this.pagination.skipCount + this.pagination.count,
                maxItems: this.size
            });
        }
    }
    loadLessTags() {
        this.isSizeMinimum = false;
        this.tagsEntries = this.tagsEntries.slice(0, this.tagsEntries.length - this.pagination.count);
        this.pagination.skipCount = this.pagination.skipCount - this.pagination.count;
        this.pagination.hasMoreItems = true;
        if (this.tagsEntries.length <= this.size) {
            this.isSizeMinimum = true;
        }
    }
}
TagListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagListComponent, deps: [{ token: TagService }], target: i0.ɵɵFactoryTarget.Component });
TagListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TagListComponent, selector: "adf-tag-list", outputs: { result: "result" }, host: { classAttribute: "adf-tag-list" }, ngImport: i0, template: "<mat-chip-list class=\"adf-tag-chips-list\">\n    <div class=\"adf-list-tag\" *ngFor=\"let currentEntry of tagsEntries; let idx = index\">\n        <mat-chip>\n            <span id=\"tag_name_{{idx}}\">{{currentEntry.entry.tag}}</span>\n        </mat-chip>\n    </div>\n</mat-chip-list>\n\n<div class=\"adf-tag-list-controls\">\n    <button\n        *ngIf=\"!isSizeMinimum\"\n        [disabled]=\"isLoading\"\n        data-automation-id=\"show-fewer-tags\"\n        mat-icon-button\n        (click)=\"loadLessTags()\">\n        <mat-icon>keyboard_arrow_up</mat-icon>\n    </button>\n    <button\n        *ngIf=\"pagination.hasMoreItems\"\n        [disabled]=\"isLoading\"\n        data-automation-id=\"show-more-tags\"\n        mat-icon-button\n        (click)=\"loadMoreTags()\">\n        <mat-icon>keyboard_arrow_down</mat-icon>\n    </button>\n</div>\n", styles: [".adf-tag-list .adf-tag-chips-list,.adf-tag-list .adf-tag-chips-list div{display:flex;flex-direction:column}.adf-tag-list .adf-tag-chips-list .adf-list-tag{display:block;font-size:var(--theme-subheading-2-font-size)}.adf-tag-list .adf-tag-chips-list .adf-list-tag .mat-chip{color:var(--theme-primary-color-default-contrast);background-color:var(--theme-primary-color)}.adf-tag-list .adf-tag-chips-list .adf-list-tag .mat-chip .mat-icon{color:var(--theme-primary-color-default-contrast)}.adf-tag-list .adf-tag-list-controls{margin-top:30px;display:flex;justify-content:center}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3$2.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tag-list', encapsulation: ViewEncapsulation.None, host: { class: 'adf-tag-list' }, template: "<mat-chip-list class=\"adf-tag-chips-list\">\n    <div class=\"adf-list-tag\" *ngFor=\"let currentEntry of tagsEntries; let idx = index\">\n        <mat-chip>\n            <span id=\"tag_name_{{idx}}\">{{currentEntry.entry.tag}}</span>\n        </mat-chip>\n    </div>\n</mat-chip-list>\n\n<div class=\"adf-tag-list-controls\">\n    <button\n        *ngIf=\"!isSizeMinimum\"\n        [disabled]=\"isLoading\"\n        data-automation-id=\"show-fewer-tags\"\n        mat-icon-button\n        (click)=\"loadLessTags()\">\n        <mat-icon>keyboard_arrow_up</mat-icon>\n    </button>\n    <button\n        *ngIf=\"pagination.hasMoreItems\"\n        [disabled]=\"isLoading\"\n        data-automation-id=\"show-more-tags\"\n        mat-icon-button\n        (click)=\"loadMoreTags()\">\n        <mat-icon>keyboard_arrow_down</mat-icon>\n    </button>\n</div>\n", styles: [".adf-tag-list .adf-tag-chips-list,.adf-tag-list .adf-tag-chips-list div{display:flex;flex-direction:column}.adf-tag-list .adf-tag-chips-list .adf-list-tag{display:block;font-size:var(--theme-subheading-2-font-size)}.adf-tag-list .adf-tag-chips-list .adf-list-tag .mat-chip{color:var(--theme-primary-color-default-contrast);background-color:var(--theme-primary-color)}.adf-tag-list .adf-tag-chips-list .adf-list-tag .mat-chip .mat-icon{color:var(--theme-primary-color-default-contrast)}.adf-tag-list .adf-tag-list-controls{margin-top:30px;display:flex;justify-content:center}\n"] }]
        }], ctorParameters: function () { return [{ type: TagService }]; }, propDecorators: { result: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * This component, ShowNodeTag a list of the tag on relative a node
 */
class TagNodeListComponent {
    /**
     * Constructor
     *
     * @param tagService
     * @param changeDetectorRef
     */
    constructor(tagService, changeDetectorRef) {
        this.tagService = tagService;
        this.changeDetectorRef = changeDetectorRef;
        /** Show delete button */
        this.showDelete = true;
        /** Should limit number of tags displayed */
        this.limitTagsDisplayed = false;
        this.tagsEntries = [];
        this.calculationsDone = false;
        this.columnFlexDirection = false;
        this.undisplayedTagsCount = 0;
        /** Emitted when a tag is selected. */
        this.results = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.initialTagsEntries = [];
        this.requestedDisplayingAllTags = false;
        this.resizeObserver = new ResizeObserver(() => {
            this.calculateTagsToDisplay();
            this.changeDetectorRef.detectChanges();
        });
    }
    ngOnChanges() {
        this.refreshTag();
    }
    ngOnInit() {
        this.initialLimitTagsDisplayed = this.limitTagsDisplayed;
        this.tagService.refresh
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => this.refreshTag());
        this.results
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
            if (this.limitTagsDisplayed && this.tagsEntries.length > 0) {
                this.calculateTagsToDisplay();
            }
        });
    }
    ngAfterViewInit() {
        this.resizeObserver.observe(this.containerView.nativeElement);
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
        this.resizeObserver.unobserve(this.containerView.nativeElement);
    }
    refreshTag() {
        if (this.nodeId) {
            this.tagService.getTagsByNodeId(this.nodeId).subscribe((tagPaging) => {
                this.tagsEntries = tagPaging.list.entries;
                this.initialTagsEntries = tagPaging.list.entries;
                this.results.emit(this.tagsEntries);
            });
        }
    }
    removeTag(tag) {
        this.tagService.removeTag(this.nodeId, tag).subscribe(() => {
            this.refreshTag();
        });
    }
    displayAllTags(event) {
        event.preventDefault();
        event.stopPropagation();
        this.limitTagsDisplayed = false;
        this.requestedDisplayingAllTags = true;
        this.resizeObserver.unobserve(this.containerView.nativeElement);
        this.refreshTag();
    }
    calculateTagsToDisplay() {
        if (!this.requestedDisplayingAllTags) {
            this.tagsEntries = this.initialTagsEntries;
            this.changeDetectorRef.detectChanges();
            this.undisplayedTagsCount = 0;
            let tagsToDisplay = 1;
            const containerWidth = this.containerView.nativeElement.clientWidth;
            const viewMoreBtnWidth = this.containerView.nativeElement.children[1].offsetWidth;
            const firstTag = this.tagChips.get(0);
            const tagChipMargin = firstTag ? this.getTagChipMargin(this.tagChips.get(0)) : 0;
            const tagChipsWidth = this.tagChips.reduce((width, val, index) => {
                width += val._elementRef.nativeElement.offsetWidth + tagChipMargin;
                if (containerWidth - viewMoreBtnWidth > width) {
                    tagsToDisplay = index + 1;
                    this.viewMoreButtonLeftOffset = width;
                    this.viewMoreButtonLeftOffsetBeforeFlexDirection = width;
                }
                return width;
            }, 0);
            if ((containerWidth - tagChipsWidth) <= 0) {
                this.columnFlexDirection = tagsToDisplay === 1 && (containerWidth < (this.tagChips.get(0)._elementRef.nativeElement.offsetWidth + viewMoreBtnWidth));
                this.undisplayedTagsCount = this.tagsEntries.length - tagsToDisplay;
                this.tagsEntries = this.tagsEntries.slice(0, tagsToDisplay);
            }
            this.limitTagsDisplayed = this.undisplayedTagsCount ? this.initialLimitTagsDisplayed : false;
            this.viewMoreButtonLeftOffset = this.columnFlexDirection ? 0 : this.viewMoreButtonLeftOffsetBeforeFlexDirection;
            this.calculationsDone = true;
        }
    }
    getTagChipMargin(chip) {
        const tagChipStyles = window.getComputedStyle(chip._elementRef.nativeElement);
        return parseInt(tagChipStyles.marginLeft, 10) + parseInt(tagChipStyles.marginRight, 10);
    }
}
TagNodeListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagNodeListComponent, deps: [{ token: TagService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
TagNodeListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TagNodeListComponent, selector: "adf-tag-node-list", inputs: { nodeId: "nodeId", showDelete: "showDelete", limitTagsDisplayed: "limitTagsDisplayed" }, outputs: { results: "results" }, viewQueries: [{ propertyName: "containerView", first: true, predicate: ["nodeListContainer"], descendants: true }, { propertyName: "tagChips", predicate: MatChip, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"adf-tag-node-list\" [class.adf-flex-column]=\"limitTagsDisplayed && (!calculationsDone || columnFlexDirection)\" #nodeListContainer>\n    <mat-chip-list [class.adf-full-width]=\"limitTagsDisplayed && !calculationsDone\">\n        <mat-chip class=\"adf-tag-chips\"\n                  *ngFor=\"let currentEntry of tagsEntries; let idx = index\"\n                  (removed)=\"removeTag(currentEntry.entry.id)\">\n            <span id=\"tag_name_{{idx}}\">{{currentEntry.entry.tag}}</span>\n            <mat-icon *ngIf=\"showDelete\" id=\"tag_chips_delete_{{currentEntry.entry.tag}}\"\n                      class=\"adf-tag-chips-delete-icon\" matChipRemove>cancel\n            </mat-icon>\n        </mat-chip>\n    </mat-chip-list>\n    <button mat-button\n        [hidden]=\"!limitTagsDisplayed\"\n        [style.left.px]=\"viewMoreButtonLeftOffset\"\n        class=\"adf-view-more-button\"\n        [class.adf-hidden-btn]=\"!calculationsDone\"\n        (click)=\"displayAllTags($event)\"\n        >{{ 'TAG_NODE_LIST.VIEW_MORE' | translate: { count: undisplayedTagsCount} }}\n    </button>\n</div>\n", styles: [".adf-tag-node-list{display:flex;align-items:center;flex-direction:row;width:inherit}.adf-tag-node-list .adf-view-more-button{margin:4px;color:var(--adf-theme-foreground-text-color-054);position:absolute}.adf-tag-node-list .adf-view-more-button[hidden]{visibility:hidden}.adf-tag-node-list.adf-flex-column{flex-direction:column}.adf-tag-node-list.adf-flex-column .adf-view-more-button{position:relative}.adf-tag-node-list .adf-full-width{width:100%}.adf-tag-node-list .adf-hidden-btn{visibility:hidden}.adf-tag-node-list .adf-tag-chips{color:var(--theme-primary-color-default-contrast);background-color:var(--theme-primary-color);height:auto;word-break:break-word}.adf-tag-node-list .adf-tag-chips-delete{overflow:visible;cursor:pointer;height:17px;width:20px;float:right;border:0;background:none;padding:0;margin:-1px 0 0 10px}.adf-tag-node-list .adf-tag-chips-delete-icon{font-size:var(--theme-title-font-size);background-repeat:no-repeat;display:inline-block;fill:currentcolor;height:20px;width:20px;color:var(--theme-primary-color-default-contrast)!important}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i3$2.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i3$2.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagNodeListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tag-node-list', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-tag-node-list\" [class.adf-flex-column]=\"limitTagsDisplayed && (!calculationsDone || columnFlexDirection)\" #nodeListContainer>\n    <mat-chip-list [class.adf-full-width]=\"limitTagsDisplayed && !calculationsDone\">\n        <mat-chip class=\"adf-tag-chips\"\n                  *ngFor=\"let currentEntry of tagsEntries; let idx = index\"\n                  (removed)=\"removeTag(currentEntry.entry.id)\">\n            <span id=\"tag_name_{{idx}}\">{{currentEntry.entry.tag}}</span>\n            <mat-icon *ngIf=\"showDelete\" id=\"tag_chips_delete_{{currentEntry.entry.tag}}\"\n                      class=\"adf-tag-chips-delete-icon\" matChipRemove>cancel\n            </mat-icon>\n        </mat-chip>\n    </mat-chip-list>\n    <button mat-button\n        [hidden]=\"!limitTagsDisplayed\"\n        [style.left.px]=\"viewMoreButtonLeftOffset\"\n        class=\"adf-view-more-button\"\n        [class.adf-hidden-btn]=\"!calculationsDone\"\n        (click)=\"displayAllTags($event)\"\n        >{{ 'TAG_NODE_LIST.VIEW_MORE' | translate: { count: undisplayedTagsCount} }}\n    </button>\n</div>\n", styles: [".adf-tag-node-list{display:flex;align-items:center;flex-direction:row;width:inherit}.adf-tag-node-list .adf-view-more-button{margin:4px;color:var(--adf-theme-foreground-text-color-054);position:absolute}.adf-tag-node-list .adf-view-more-button[hidden]{visibility:hidden}.adf-tag-node-list.adf-flex-column{flex-direction:column}.adf-tag-node-list.adf-flex-column .adf-view-more-button{position:relative}.adf-tag-node-list .adf-full-width{width:100%}.adf-tag-node-list .adf-hidden-btn{visibility:hidden}.adf-tag-node-list .adf-tag-chips{color:var(--theme-primary-color-default-contrast);background-color:var(--theme-primary-color);height:auto;word-break:break-word}.adf-tag-node-list .adf-tag-chips-delete{overflow:visible;cursor:pointer;height:17px;width:20px;float:right;border:0;background:none;padding:0;margin:-1px 0 0 10px}.adf-tag-node-list .adf-tag-chips-delete-icon{font-size:var(--theme-title-font-size);background-repeat:no-repeat;display:inline-block;fill:currentcolor;height:20px;width:20px;color:var(--theme-primary-color-default-contrast)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: TagService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { nodeId: [{
                type: Input
            }], showDelete: [{
                type: Input
            }], limitTagsDisplayed: [{
                type: Input
            }], containerView: [{
                type: ViewChild,
                args: ['nodeListContainer']
            }], tagChips: [{
                type: ViewChildren,
                args: [MatChip]
            }], results: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Available modes for tags creator.
 * Create mode allows only for creating completely new tags.
 * Create and Assign mode allows for both - creation of new tags and selection of existing tags.
 */
var TagsCreatorMode;
(function (TagsCreatorMode) {
    TagsCreatorMode[TagsCreatorMode["CREATE"] = 0] = "CREATE";
    TagsCreatorMode[TagsCreatorMode["CREATE_AND_ASSIGN"] = 1] = "CREATE_AND_ASSIGN";
})(TagsCreatorMode || (TagsCreatorMode = {}));

const DEFAULT_TAGS_SORTING = {
    orderBy: 'tag',
    direction: 'asc'
};
/**
 * Allows to create multiple tags. That component contains input and two lists. Top list is all created tags, bottom list is searched tags based on input's value.
 */
class TagsCreatorComponent {
    constructor(tagService, notificationService) {
        this.tagService = tagService;
        this.notificationService = notificationService;
        /**
         * False if tags can be removed from top list, true otherwise.
         */
        this.disabledTagsRemoving = false;
        /**
         * Emitted when bottom list is showing or hiding.
         */
        this.existingTagsPanelVisibilityChange = new EventEmitter();
        /**
         * Emitted when tags in top list are changed.
         */
        this.tagsChange = new EventEmitter();
        /**
         * Emitted when input is showing or hiding.
         */
        this.tagNameControlVisibleChange = new EventEmitter();
        this.nameErrorMessagesByErrors = new Map([
            ['duplicatedExistingTag', 'EXISTING_TAG'],
            ['duplicatedAddedTag', 'ALREADY_ADDED_TAG'],
            ['emptyTag', 'EMPTY_TAG'],
            ['required', 'REQUIRED']
        ]);
        this.existingTagsListLimit = 15;
        this.exactTagSet$ = new Subject();
        this._tags = [];
        this._tagNameControl = new FormControl('', [
            this.validateIfNotAlreadyAdded.bind(this),
            Validators.required,
            this.validateEmptyTag
        ], this.validateIfNotExistingTag.bind(this));
        this._tagNameControlVisible = false;
        this.onDestroy$ = new Subject();
        this._tagNameErrorMessageKey = '';
        this._spinnerVisible = false;
        this._typing = false;
        this._tagsListScrollbarVisible = false;
        this.cancelExistingTagsLoading$ = new Subject();
    }
    /**
     * Default top list.
     *
     * @param tags tags which should be displayed as default tags for top list.
     */
    set tags(tags) {
        this._tags = [...tags];
        this._initialExistingTags = null;
        this._existingTags = null;
        this.loadTags(this.tagNameControl.value);
        this.tagNameControl.updateValueAndValidity();
        if (this.tagNameControl.errors?.required) {
            this.tagNameControl.markAsUntouched();
        }
    }
    get tags() {
        return this._tags;
    }
    /**
     * Decides if input for tags creation/searching should be visible. When input is hidden then panel of existing tags is hidden as well.
     *
     * @param tagNameControlVisible true if input should be visible, false otherwise.
     */
    set tagNameControlVisible(tagNameControlVisible) {
        this._tagNameControlVisible = tagNameControlVisible;
        if (tagNameControlVisible) {
            this._existingTagsPanelVisible = true;
            setTimeout(() => {
                this.tagNameInputElement.nativeElement.scrollIntoView();
            });
        }
        else {
            this._existingTagsPanelVisible = false;
        }
        this.existingTagsPanelVisibilityChange.emit(this.existingTagsPanelVisible);
    }
    get tagNameControlVisible() {
        return this._tagNameControlVisible;
    }
    ngOnInit() {
        this.tagNameControl.valueChanges
            .pipe(map((name) => name.trim()), distinctUntilChanged(), tap((name) => {
            this._typing = true;
            if (name) {
                this._spinnerVisible = true;
                this._existingTagsPanelVisible = true;
            }
            this.existingTagsPanelVisibilityChange.emit(this.existingTagsPanelVisible);
            this.cancelExistingTagsLoading$.next();
            this._initialExistingTags = null;
            this._existingTags = null;
        }), debounce((name) => (name ? timer(300) : EMPTY)), takeUntil(this.onDestroy$))
            .subscribe((name) => this.onTagNameControlValueChange(name));
        this.tagNameControl.statusChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => this.setTagNameControlErrorMessageKey());
        this.setTagNameControlErrorMessageKey();
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.cancelExistingTagsLoading$.next();
        this.cancelExistingTagsLoading$.complete();
    }
    get hostClass() {
        return this.existingTagsPanelVisible;
    }
    get tagNameControl() {
        return this._tagNameControl;
    }
    get existingTags() {
        return this._existingTags;
    }
    get tagNameErrorMessageKey() {
        return this._tagNameErrorMessageKey;
    }
    get spinnerVisible() {
        return this._spinnerVisible;
    }
    get typing() {
        return this._typing;
    }
    get tagsListScrollbarVisible() {
        return this._tagsListScrollbarVisible;
    }
    get existingTagsPanelVisible() {
        return this._existingTagsPanelVisible;
    }
    /**
     * Hide input for typing name for new tag or for searching. When input is hidden then panel of existing tags is hidden as well.
     */
    hideNameInput() {
        this.tagNameControlVisible = false;
        this._existingTagsPanelVisible = false;
        this.existingTagsPanelVisibilityChange.emit(this.existingTagsPanelVisible);
        this.tagNameControlVisibleChange.emit(this.tagNameControlVisible);
    }
    /**
     * Add tags to top list using value which is set in input. Adding tag is not allowed when value in input is invalid
     * or if user is still typing what means that validation for input is not called yet.
     */
    addTag() {
        if (!this._typing && !this.tagNameControl.invalid) {
            this.tags.push(this.tagNameControl.value.trim());
            this.hideNameInput();
            this.tagNameControl.setValue('');
            this.checkScrollbarVisibility();
            this.tagNameControl.markAsUntouched();
            this.tagsChange.emit(this.tags);
        }
    }
    /**
     * Remove tag from top list. In case that tag was part of search result then that tag is moved to bottom list
     * (list of existing tags) after removing so user can reselect it again later.
     *
     * @param tag tag's name which should be removed from top list.
     */
    removeTag(tag) {
        this.removeTagFromArray(this.tags, tag);
        this.tagNameControl.updateValueAndValidity();
        this.updateExistingTagsListOnRemoveFromTagsToConfirm(tag);
        this.checkScrollbarVisibility();
        this.tagsChange.emit(this.tags);
    }
    /**
     * Called when user selects any tag from list of existing tags. It moves tag from existing tags list to top list.
     *
     * @param change
     */
    addExistingTagToTagsToAssign(change) {
        const selectedTag = change.options[0].value;
        this.tags.push(selectedTag.entry.tag);
        this.removeTagFromArray(this.existingTags, selectedTag);
        this.tagNameControl.updateValueAndValidity();
        this.exactTagSet$.next();
        this.tagsChange.emit(this.tags);
    }
    /**
     * Checks if component is in Create mode.
     *
     * @return true if Create mode, false otherwise.
     */
    isOnlyCreateMode() {
        return this.mode === TagsCreatorMode.CREATE;
    }
    onTagNameControlValueChange(name) {
        this.tagNameControl.markAsTouched();
        this.loadTags(name);
    }
    loadTags(name) {
        if (name) {
            forkJoin({
                exactResult: this.tagService.findTagByName(name),
                searchedResult: this.tagService.searchTags(name, DEFAULT_TAGS_SORTING, false, 0, this.existingTagsListLimit)
            }).pipe(takeUntil(this.cancelExistingTagsLoading$), finalize(() => (this._typing = false))).subscribe(({ exactResult, searchedResult }) => {
                if (exactResult) {
                    this.existingExactTag = exactResult;
                    this.removeExactTagFromSearchedResult(searchedResult);
                    searchedResult.list.entries.unshift(exactResult);
                }
                else {
                    this.existingExactTag = null;
                }
                this._initialExistingTags = searchedResult.list.entries;
                this.excludeAlreadyAddedTags(this._initialExistingTags);
                this.exactTagSet$.next();
                this._spinnerVisible = false;
            }, () => {
                this.notificationService.showError('TAG.TAGS_CREATOR.ERRORS.FETCH_TAGS');
                this._spinnerVisible = false;
            });
        }
        else {
            this.existingExactTag = null;
            this._spinnerVisible = false;
        }
    }
    removeExactTagFromSearchedResult(searchedResult) {
        const exactTagIndex = searchedResult.list.entries.findIndex((row) => this.compareTags(row.entry.tag, this.existingExactTag.entry.tag));
        if (exactTagIndex > -1) {
            searchedResult.list.entries.splice(exactTagIndex, 1);
        }
    }
    validateIfNotExistingTag(tagNameControl) {
        return this.exactTagSet$.pipe(map(() => this.compareTags(tagNameControl.value, this.existingExactTag?.entry?.tag) ? { duplicatedExistingTag: true }
            : null), first());
    }
    validateIfNotAlreadyAdded(tagNameControl) {
        return this.tags.some((tag) => this.compareTags(tag, tagNameControl.value))
            ? { duplicatedAddedTag: true }
            : null;
    }
    compareTags(tagName1, tagName2) {
        return tagName1?.trim().toUpperCase() === tagName2?.trim().toUpperCase();
    }
    validateEmptyTag(tagNameControl) {
        return tagNameControl.value.length && !tagNameControl.value.trim()
            ? { emptyTag: true }
            : null;
    }
    setTagNameControlErrorMessageKey() {
        this._tagNameErrorMessageKey = this.tagNameControl.invalid
            ? `TAG.TAGS_CREATOR.ERRORS.${this.nameErrorMessagesByErrors.get(Object.keys(this.tagNameControl.errors)[0])}`
            : '';
    }
    checkScrollbarVisibility() {
        setTimeout(() => {
            this._tagsListScrollbarVisible =
                this.tagsListElement.nativeElement.scrollHeight >
                    this.tagsListElement.nativeElement.clientHeight;
        });
    }
    removeTagFromArray(tags, tag) {
        tags.splice(tags.indexOf(tag), 1);
    }
    updateExistingTagsListOnRemoveFromTagsToConfirm(tag) {
        const entryForTagAddedToExistingTags = this._initialExistingTags?.find((tagEntry) => tagEntry.entry.tag === tag);
        if (entryForTagAddedToExistingTags) {
            this.existingTags.unshift(entryForTagAddedToExistingTags);
            if (this.existingExactTag) {
                if (tag !== this.existingExactTag.entry.tag) {
                    this.removeTagFromArray(this.existingTags, this.existingExactTag);
                    this.sortExistingTags();
                    this.existingTags.unshift(this.existingExactTag);
                }
            }
            else {
                this.sortExistingTags();
            }
            this.exactTagSet$.next();
        }
    }
    sortExistingTags() {
        this.existingTags.sort((tagEntry1, tagEntry2) => tagEntry1.entry.tag.localeCompare(tagEntry2.entry.tag));
    }
    excludeAlreadyAddedTags(tags) {
        this._existingTags = tags.filter((tag) => !this.tags.includes(tag.entry.tag));
    }
}
TagsCreatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagsCreatorComponent, deps: [{ token: TagService }, { token: i1.NotificationService }], target: i0.ɵɵFactoryTarget.Component });
TagsCreatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TagsCreatorComponent, selector: "adf-tags-creator", inputs: { mode: "mode", disabledTagsRemoving: "disabledTagsRemoving", tags: "tags", tagNameControlVisible: "tagNameControlVisible" }, outputs: { existingTagsPanelVisibilityChange: "existingTagsPanelVisibilityChange", tagsChange: "tagsChange", tagNameControlVisibleChange: "tagNameControlVisibleChange" }, host: { properties: { "class.adf-creator-with-existing-tags-panel": "this.hostClass" } }, viewQueries: [{ propertyName: "tagsListElement", first: true, predicate: ["tagsList"], descendants: true }, { propertyName: "tagNameInputElement", first: true, predicate: ["tagNameInput"], descendants: true }], ngImport: i0, template: "<div class=\"adf-tags-creation\">\n    <p\n       class=\"adf-no-tags-message\"\n       *ngIf=\"!tags.length && !tagNameControlVisible\">\n        {{ 'TAG.TAGS_CREATOR.NO_TAGS_CREATED' | translate }}\n    </p>\n    <div\n        class=\"adf-tags-list\"\n        [class.adf-tags-list-fixed]=\"!tagNameControlVisible\"\n        #tagsList>\n        <p\n            *ngFor=\"let tag of tags\"\n            class=\"adf-tag adf-label-with-icon-button\">\n            {{ tag }}\n            <button\n                data-automation-id=\"remove-tag-button\"\n                mat-icon-button\n                (click)=\"removeTag(tag)\"\n                [attr.title]=\"'TAG.TAGS_CREATOR.TOOLTIPS.DELETE_TAG' | translate\"\n                [disabled]=\"disabledTagsRemoving\">\n                <mat-icon>remove</mat-icon>\n            </button>\n        </p>\n    </div>\n    <div\n        class=\"adf-tag-name-field\"\n        *ngIf=\"(!tagNameControlVisible && tags.length) || tagNameControlVisible\"\n        [hidden]=\"!tagNameControlVisible\">\n        <mat-form-field *ngIf=\"tagNameControlVisible\">\n            <mat-icon matPrefix>search</mat-icon>\n            <mat-label id=\"adf-tag-name-input-label\">\n                {{ 'TAG.TAGS_CREATOR.NAME' | translate }}\n            </mat-label>\n            <input\n                #tagNameInput\n                matInput\n                autocomplete=\"off\"\n                [formControl]=\"tagNameControl\"\n                (keyup.enter)=\"addTag()\"\n                aria-labelledby=\"adf-tag-name-input-label\"\n                adf-auto-focus\n            />\n            <mat-error [hidden]=\"!tagNameControl.invalid\">{{ tagNameErrorMessageKey | translate }}</mat-error>\n        </mat-form-field>\n        <button\n            data-automation-id=\"hide-tag-name-input-button\"\n            mat-icon-button\n            (click)=\"hideNameInput()\"\n            [attr.title]=\"'TAG.TAGS_CREATOR.TOOLTIPS.HIDE_INPUT' | translate\">\n            <mat-icon>remove</mat-icon>\n        </button>\n    </div>\n</div>\n<div\n    class=\"adf-existing-tags-panel\"\n    *ngIf=\"existingTagsPanelVisible\">\n    <span *ngIf=\"!spinnerVisible || existingTags\"\n        class=\"adf-create-tag-label\"\n        (click)=\"addTag()\"\n        [hidden]=\"tagNameControl.invalid || typing\">\n        {{ 'TAG.TAGS_CREATOR.CREATE_TAG' | translate : { tag: tagNameControl.value } }}\n    </span>\n    <p *ngIf=\"!spinnerVisible && existingTags\" class=\"adf-existing-tags-label\">\n        {{ (isOnlyCreateMode() ? 'TAG.TAGS_CREATOR.EXISTING_TAGS' : 'TAG.TAGS_CREATOR.EXISTING_TAGS_SELECTION') | translate }}\n    </p>\n    <div class=\"adf-tags-list\">\n        <mat-selection-list\n            *ngIf=\"!spinnerVisible && existingTags\"\n            (selectionChange)=\"addExistingTagToTagsToAssign($event)\"\n            [disabled]=\"isOnlyCreateMode()\">\n            <mat-list-option\n                *ngFor=\"let tagRow of existingTags\"\n                class=\"adf-tag\"\n                [value]=\"tagRow\">\n                {{ tagRow.entry.tag }}\n            </mat-list-option>\n            <p *ngIf=\"!existingTags?.length\">{{ 'TAG.TAGS_CREATOR.NO_EXISTING_TAGS' | translate }}</p>\n        </mat-selection-list>\n        <mat-spinner\n            *ngIf=\"spinnerVisible\"\n            [diameter]=\"50\"\n            [attr.aria-label]=\"'TAG.TAGS_CREATOR.TAGS_LOADING' | translate\">\n        </mat-spinner>\n    </div>\n</div>\n", styles: ["adf-tags-creator{display:block;margin-left:-24px}adf-tags-creator .adf-label-with-icon-button{display:flex;justify-content:space-between;align-items:center}adf-tags-creator .adf-no-tags-message{margin-left:9px;margin-top:28.5px;margin-bottom:0;height:30px}adf-tags-creator .adf-tag-name-field,adf-tags-creator .adf-tag-name-field[hidden]{display:flex;align-items:center;min-height:57px}adf-tags-creator .adf-tag-name-field mat-form-field,adf-tags-creator .adf-tag-name-field[hidden] mat-form-field{width:100%;box-sizing:border-box;padding-right:3px;font-size:14px}adf-tags-creator .adf-create-tag-label{color:var(--theme-primary-color);cursor:pointer;margin-top:-1px;padding-left:27px;overflow-wrap:anywhere;display:inline-block;padding-right:12px;overflow:auto;max-height:7vh}adf-tags-creator .adf-tags-list{padding-left:10px;padding-right:0;overflow:auto}adf-tags-creator .adf-tag{margin-top:0;overflow-wrap:anywhere}adf-tags-creator .adf-tag+.adf-tag{margin-top:-14px}adf-tags-creator .adf-tags-creation{padding-left:27px;padding-right:22px}adf-tags-creator .adf-existing-tags-panel{border-top-left-radius:6px;border-top-right-radius:6px;padding-top:12px;width:100%}adf-tags-creator .adf-existing-tags-panel .adf-existing-tags-label{font-size:10px;color:var(--theme-secondary-text-color);padding-left:12px;margin-bottom:2px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list{padding-left:18px;margin-top:-2px;padding-right:0;display:flex;flex-direction:column}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag{margin-bottom:18px;margin-top:0;padding-right:12px;font-size:14px;height:auto;width:unset}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag+.adf-tag{margin-top:-10px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag .mat-list-item-content-reverse{padding:0 6px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag .mat-list-item-content-reverse .mat-pseudo-checkbox{display:none}adf-tags-creator .adf-existing-tags-panel .adf-tags-list mat-spinner{margin:auto;overflow:unset;min-height:62px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .mat-list-item-disabled{background-color:inherit;color:inherit}adf-tags-creator mat-dialog-actions{margin-right:-24px;background-color:inherit}adf-tags-creator mat-dialog-actions .adf-save-button{margin-right:24px}adf-tags-creator [hidden]{visibility:hidden;display:unset}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: AutoFocusDirective, selector: "[adf-auto-focus]" }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "directive", type: i6.MatPrefix, selector: "[matPrefix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i8$1.MatSelectionList, selector: "mat-selection-list", inputs: ["disableRipple", "color", "compareWith", "disabled", "multiple"], outputs: ["selectionChange"], exportAs: ["matSelectionList"] }, { kind: "component", type: i8$1.MatListOption, selector: "mat-list-option", inputs: ["disableRipple", "checkboxPosition", "color", "value", "disabled", "selected"], outputs: ["selectedChange"], exportAs: ["matListOption"] }, { kind: "component", type: i9.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagsCreatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tags-creator', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-tags-creation\">\n    <p\n       class=\"adf-no-tags-message\"\n       *ngIf=\"!tags.length && !tagNameControlVisible\">\n        {{ 'TAG.TAGS_CREATOR.NO_TAGS_CREATED' | translate }}\n    </p>\n    <div\n        class=\"adf-tags-list\"\n        [class.adf-tags-list-fixed]=\"!tagNameControlVisible\"\n        #tagsList>\n        <p\n            *ngFor=\"let tag of tags\"\n            class=\"adf-tag adf-label-with-icon-button\">\n            {{ tag }}\n            <button\n                data-automation-id=\"remove-tag-button\"\n                mat-icon-button\n                (click)=\"removeTag(tag)\"\n                [attr.title]=\"'TAG.TAGS_CREATOR.TOOLTIPS.DELETE_TAG' | translate\"\n                [disabled]=\"disabledTagsRemoving\">\n                <mat-icon>remove</mat-icon>\n            </button>\n        </p>\n    </div>\n    <div\n        class=\"adf-tag-name-field\"\n        *ngIf=\"(!tagNameControlVisible && tags.length) || tagNameControlVisible\"\n        [hidden]=\"!tagNameControlVisible\">\n        <mat-form-field *ngIf=\"tagNameControlVisible\">\n            <mat-icon matPrefix>search</mat-icon>\n            <mat-label id=\"adf-tag-name-input-label\">\n                {{ 'TAG.TAGS_CREATOR.NAME' | translate }}\n            </mat-label>\n            <input\n                #tagNameInput\n                matInput\n                autocomplete=\"off\"\n                [formControl]=\"tagNameControl\"\n                (keyup.enter)=\"addTag()\"\n                aria-labelledby=\"adf-tag-name-input-label\"\n                adf-auto-focus\n            />\n            <mat-error [hidden]=\"!tagNameControl.invalid\">{{ tagNameErrorMessageKey | translate }}</mat-error>\n        </mat-form-field>\n        <button\n            data-automation-id=\"hide-tag-name-input-button\"\n            mat-icon-button\n            (click)=\"hideNameInput()\"\n            [attr.title]=\"'TAG.TAGS_CREATOR.TOOLTIPS.HIDE_INPUT' | translate\">\n            <mat-icon>remove</mat-icon>\n        </button>\n    </div>\n</div>\n<div\n    class=\"adf-existing-tags-panel\"\n    *ngIf=\"existingTagsPanelVisible\">\n    <span *ngIf=\"!spinnerVisible || existingTags\"\n        class=\"adf-create-tag-label\"\n        (click)=\"addTag()\"\n        [hidden]=\"tagNameControl.invalid || typing\">\n        {{ 'TAG.TAGS_CREATOR.CREATE_TAG' | translate : { tag: tagNameControl.value } }}\n    </span>\n    <p *ngIf=\"!spinnerVisible && existingTags\" class=\"adf-existing-tags-label\">\n        {{ (isOnlyCreateMode() ? 'TAG.TAGS_CREATOR.EXISTING_TAGS' : 'TAG.TAGS_CREATOR.EXISTING_TAGS_SELECTION') | translate }}\n    </p>\n    <div class=\"adf-tags-list\">\n        <mat-selection-list\n            *ngIf=\"!spinnerVisible && existingTags\"\n            (selectionChange)=\"addExistingTagToTagsToAssign($event)\"\n            [disabled]=\"isOnlyCreateMode()\">\n            <mat-list-option\n                *ngFor=\"let tagRow of existingTags\"\n                class=\"adf-tag\"\n                [value]=\"tagRow\">\n                {{ tagRow.entry.tag }}\n            </mat-list-option>\n            <p *ngIf=\"!existingTags?.length\">{{ 'TAG.TAGS_CREATOR.NO_EXISTING_TAGS' | translate }}</p>\n        </mat-selection-list>\n        <mat-spinner\n            *ngIf=\"spinnerVisible\"\n            [diameter]=\"50\"\n            [attr.aria-label]=\"'TAG.TAGS_CREATOR.TAGS_LOADING' | translate\">\n        </mat-spinner>\n    </div>\n</div>\n", styles: ["adf-tags-creator{display:block;margin-left:-24px}adf-tags-creator .adf-label-with-icon-button{display:flex;justify-content:space-between;align-items:center}adf-tags-creator .adf-no-tags-message{margin-left:9px;margin-top:28.5px;margin-bottom:0;height:30px}adf-tags-creator .adf-tag-name-field,adf-tags-creator .adf-tag-name-field[hidden]{display:flex;align-items:center;min-height:57px}adf-tags-creator .adf-tag-name-field mat-form-field,adf-tags-creator .adf-tag-name-field[hidden] mat-form-field{width:100%;box-sizing:border-box;padding-right:3px;font-size:14px}adf-tags-creator .adf-create-tag-label{color:var(--theme-primary-color);cursor:pointer;margin-top:-1px;padding-left:27px;overflow-wrap:anywhere;display:inline-block;padding-right:12px;overflow:auto;max-height:7vh}adf-tags-creator .adf-tags-list{padding-left:10px;padding-right:0;overflow:auto}adf-tags-creator .adf-tag{margin-top:0;overflow-wrap:anywhere}adf-tags-creator .adf-tag+.adf-tag{margin-top:-14px}adf-tags-creator .adf-tags-creation{padding-left:27px;padding-right:22px}adf-tags-creator .adf-existing-tags-panel{border-top-left-radius:6px;border-top-right-radius:6px;padding-top:12px;width:100%}adf-tags-creator .adf-existing-tags-panel .adf-existing-tags-label{font-size:10px;color:var(--theme-secondary-text-color);padding-left:12px;margin-bottom:2px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list{padding-left:18px;margin-top:-2px;padding-right:0;display:flex;flex-direction:column}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag{margin-bottom:18px;margin-top:0;padding-right:12px;font-size:14px;height:auto;width:unset}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag+.adf-tag{margin-top:-10px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag .mat-list-item-content-reverse{padding:0 6px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .adf-tag .mat-list-item-content-reverse .mat-pseudo-checkbox{display:none}adf-tags-creator .adf-existing-tags-panel .adf-tags-list mat-spinner{margin:auto;overflow:unset;min-height:62px}adf-tags-creator .adf-existing-tags-panel .adf-tags-list .mat-list-item-disabled{background-color:inherit;color:inherit}adf-tags-creator mat-dialog-actions{margin-right:-24px;background-color:inherit}adf-tags-creator mat-dialog-actions .adf-save-button{margin-right:24px}adf-tags-creator [hidden]{visibility:hidden;display:unset}\n"] }]
        }], ctorParameters: function () { return [{ type: TagService }, { type: i1.NotificationService }]; }, propDecorators: { mode: [{
                type: Input
            }], disabledTagsRemoving: [{
                type: Input
            }], tags: [{
                type: Input
            }], tagNameControlVisible: [{
                type: Input
            }], existingTagsPanelVisibilityChange: [{
                type: Output
            }], tagsChange: [{
                type: Output
            }], tagNameControlVisibleChange: [{
                type: Output
            }], tagsListElement: [{
                type: ViewChild,
                args: ['tagsList']
            }], tagNameInputElement: [{
                type: ViewChild,
                args: ['tagNameInput']
            }], hostClass: [{
                type: HostBinding,
                args: ['class.adf-creator-with-existing-tags-panel']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TagModule {
}
TagModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TagModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: TagModule, declarations: [TagActionsComponent,
        TagListComponent,
        TagNodeListComponent,
        TagsCreatorComponent], imports: [CommonModule,
        ContentDirectiveModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule], exports: [TagActionsComponent,
        TagListComponent,
        TagNodeListComponent,
        TagsCreatorComponent] });
TagModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagModule, imports: [CommonModule,
        ContentDirectiveModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TagModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ContentDirectiveModule,
                        MaterialModule,
                        FormsModule,
                        ReactiveFormsModule,
                        CoreModule
                    ],
                    exports: [
                        TagActionsComponent,
                        TagListComponent,
                        TagNodeListComponent,
                        TagsCreatorComponent
                    ],
                    declarations: [
                        TagActionsComponent,
                        TagListComponent,
                        TagNodeListComponent,
                        TagsCreatorComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * <adf-webscript-get [scriptPath]="string"
 *                         [scriptArgs]="Object"
 *                         [contextRoot]="string"
 *                         [servicePath]="string"
 *                         [contentType]="JSON|HTML|DATATABLE"
 *                         (success)="customMethod($event)>
 * </adf-webscript-get>
 *
 * This component, provide a get webscript viewer
 *
 * @InputParam {string} scriptPath path to Web Script (as defined by Web Script)
 * @InputParam {Object} scriptArgs arguments to pass to Web Script
 * @InputParam {string} contextRoot path where application is deployed default value 'alfresco'
 * @InputParam {string} servicePath path where Web Script service is mapped default value 'service'
 * @InputParam {string} contentType JSON | HTML | DATATABLE | TEXT
 *
 * @Output - success - The event is emitted when the data are received
 *
 */
class WebscriptComponent {
    constructor(apiService, logService) {
        this.apiService = apiService;
        this.logService = logService;
        /** Toggles whether to show or hide the data. */
        this.showData = true;
        /** Path where the application is deployed */
        this.contextRoot = 'alfresco';
        /** Path that the webscript service is mapped to. */
        this.servicePath = 'service';
        /** Content type to interpret the data received from the webscript.
         * Can be "JSON" , "HTML" , "DATATABLE" or "TEXT"
         */
        this.contentType = 'TEXT';
        /** Emitted when the operation succeeds. You can get the plain data from
         * the webscript through the **success** event parameter and use it as you
         * need in your application.
         */
        this.success = new EventEmitter();
        this.data = undefined;
        this.showError = false;
    }
    get webscriptApi() {
        this._webscriptApi = this._webscriptApi ?? new WebscriptApi(this.apiService.getInstance());
        return this._webscriptApi;
    }
    ngOnChanges() {
        if (this.showData) {
            this.clean();
        }
        return new Promise((resolve, reject) => {
            this.webscriptApi.executeWebScript('GET', this.scriptPath, this.scriptArgs, this.contextRoot, this.servicePath).then((webScriptData) => {
                this.data = webScriptData;
                if (this.showData) {
                    if (this.contentType === 'DATATABLE') {
                        this.data = this.showDataAsDataTable(webScriptData);
                    }
                }
                this.success.emit(this.data);
                resolve();
            }, (error) => {
                this.logService.log('Error' + error);
                reject();
            });
        });
    }
    /**
     * show the data in a ng2-alfresco-datatable
     *
     * @param data
     *
     * @returns the data as datatable
     */
    showDataAsDataTable(data) {
        const datatableData = null;
        try {
            if (!data.schema) {
                data.schema = ObjectDataTableAdapter.generateSchema(data.data);
            }
            if (data.schema && data.schema.length > 0) {
                this.data = new ObjectDataTableAdapter(data.data, data.schema);
            }
        }
        catch (error) {
            this.logService.error('error during the cast as datatable');
        }
        return datatableData;
    }
    clean() {
        this.data = undefined;
    }
    isDataTableContent() {
        return this.contentType === 'DATATABLE';
    }
}
WebscriptComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WebscriptComponent, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Component });
WebscriptComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: WebscriptComponent, selector: "adf-webscript-get", inputs: { scriptPath: "scriptPath", scriptArgs: "scriptArgs", showData: "showData", contextRoot: "contextRoot", servicePath: "servicePath", contentType: "contentType" }, outputs: { success: "success" }, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"showData\">\n    <div *ngIf=\"contentType === 'JSON'\" id=\"webscript-data-JSON\">{{data | json}}</div>\n    <div *ngIf=\"contentType === 'HTML'\" id=\"webscript-data-HTML\" [innerHTML]=\"data\"></div>\n    <div *ngIf=\"contentType === 'TEXT'\" id=\"webscript-data-TEXT\">{{data}}</div>\n    <div *ngIf=\"isDataTableContent()\">\n        <adf-datatable id=\"webscript-datatable-wrapper\" [data]=\"data\"></adf-datatable>\n        <div>\n            <div *ngIf=\"showError\" id=\"error\">{{'WEBSCRIPT.ERROR' | translate: {\n                data: data,\n                contentType: contentType\n                }\n                }}\n            </div>\n        </div>\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1.DataTableComponent, selector: "adf-datatable", inputs: ["data", "display", "rows", "sorting", "columns", "selectionMode", "multiselect", "mainTableAction", "actions", "showMainDatatableActions", "actionsPosition", "actionsVisibleOnHover", "fallbackThumbnail", "contextMenu", "rowStyle", "rowStyleClass", "showHeader", "stickyHeader", "loading", "noPermission", "rowMenuCacheEnabled", "resolverFn", "allowFiltering", "isResizingEnabled"], outputs: ["rowClick", "rowDblClick", "showRowContextMenu", "showRowActionsMenu", "executeRowAction", "columnOrderChanged", "columnsWidthChanged"] }, { kind: "pipe", type: i2$1.JsonPipe, name: "json" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WebscriptComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-webscript-get', template: "<div *ngIf=\"showData\">\n    <div *ngIf=\"contentType === 'JSON'\" id=\"webscript-data-JSON\">{{data | json}}</div>\n    <div *ngIf=\"contentType === 'HTML'\" id=\"webscript-data-HTML\" [innerHTML]=\"data\"></div>\n    <div *ngIf=\"contentType === 'TEXT'\" id=\"webscript-data-TEXT\">{{data}}</div>\n    <div *ngIf=\"isDataTableContent()\">\n        <adf-datatable id=\"webscript-datatable-wrapper\" [data]=\"data\"></adf-datatable>\n        <div>\n            <div *ngIf=\"showError\" id=\"error\">{{'WEBSCRIPT.ERROR' | translate: {\n                data: data,\n                contentType: contentType\n                }\n                }}\n            </div>\n        </div>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }]; }, propDecorators: { scriptPath: [{
                type: Input
            }], scriptArgs: [{
                type: Input
            }], showData: [{
                type: Input
            }], contextRoot: [{
                type: Input
            }], servicePath: [{
                type: Input
            }], contentType: [{
                type: Input
            }], success: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class WebScriptModule {
}
WebScriptModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WebScriptModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
WebScriptModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: WebScriptModule, declarations: [WebscriptComponent], imports: [CommonModule,
        MaterialModule,
        CoreModule], exports: [WebscriptComponent] });
WebScriptModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WebScriptModule, imports: [CommonModule,
        MaterialModule,
        CoreModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: WebScriptModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        CoreModule
                    ],
                    exports: [
                        WebscriptComponent
                    ],
                    declarations: [
                        WebscriptComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class NodeActionsService {
    constructor(contentDialogService, dialogRef, content, documentListService, apiService, dialog, downloadService) {
        this.contentDialogService = contentDialogService;
        this.dialogRef = dialogRef;
        this.content = content;
        this.documentListService = documentListService;
        this.apiService = apiService;
        this.dialog = dialog;
        this.downloadService = downloadService;
        this.error = new EventEmitter();
    }
    downloadNode(node) {
        new NodeDownloadDirective(this.apiService, this.downloadService, this.dialog)
            .downloadNode(node);
    }
    /**
     * Copy content node
     *
     * @param contentEntry node to copy
     * @param permission permission which is needed to apply the action
     */
    copyContent(contentEntry, permission) {
        return this.doFileOperation(NodeAction.COPY, 'content', contentEntry, permission);
    }
    /**
     * Copy folder node
     *
     * @param contentEntry node to copy
     * @param permission permission which is needed to apply the action
     */
    copyFolder(contentEntry, permission) {
        return this.doFileOperation(NodeAction.COPY, 'folder', contentEntry, permission);
    }
    /**
     * Move content node
     *
     * @param contentEntry node to move
     * @param permission permission which is needed to apply the action
     */
    moveContent(contentEntry, permission) {
        return this.doFileOperation(NodeAction.MOVE, 'content', contentEntry, permission);
    }
    /**
     * Move folder node
     *
     * @param contentEntry node to move
     * @param permission permission which is needed to apply the action
     */
    moveFolder(contentEntry, permission) {
        return this.doFileOperation(NodeAction.MOVE, 'folder', contentEntry, permission);
    }
    /**
     * General method for performing the given operation (copy|move)
     *
     * @param action the action to perform (copy|move)
     * @param type type of the content (content|folder)
     * @param contentEntry the contentEntry which has to have the action performed on
     * @param permission permission which is needed to apply the action
     */
    doFileOperation(action, type, contentEntry, permission) {
        const observable = new Subject();
        this.contentDialogService
            .openCopyMoveDialog(action, contentEntry, permission)
            .subscribe((selections) => {
            const selection = selections[0];
            this.documentListService[`${action.toLowerCase()}Node`].call(this.documentListService, contentEntry.id, selection.id)
                .subscribe(observable.next.bind(observable, `OPERATION.SUCCESS.${type.toUpperCase()}.${action}`), observable.error.bind(observable));
        }, (error) => {
            observable.error(error);
            return observable;
        });
        return observable;
    }
}
NodeActionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeActionsService, deps: [{ token: ContentNodeDialogService }, { token: i1$1.MatDialog }, { token: ContentService }, { token: DocumentListService }, { token: i1.AlfrescoApiService }, { token: i1$1.MatDialog }, { token: i1.DownloadService }], target: i0.ɵɵFactoryTarget.Injectable });
NodeActionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeActionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeActionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ContentNodeDialogService }, { type: i1$1.MatDialog }, { type: ContentService }, { type: DocumentListService }, { type: i1.AlfrescoApiService }, { type: i1$1.MatDialog }, { type: i1.DownloadService }]; }, propDecorators: { error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DocumentActionsService {
    constructor(nodeActionsService, contentNodeDialogService, translation, documentListService, contentService) {
        this.nodeActionsService = nodeActionsService;
        this.contentNodeDialogService = contentNodeDialogService;
        this.translation = translation;
        this.documentListService = documentListService;
        this.contentService = contentService;
        this.permissionEvent = new Subject();
        this.error = new Subject();
        this.success = new Subject();
        this.handlers = {};
        this.setupActionHandlers();
    }
    /**
     * Gets the handler for an action.
     *
     * @param key Identifier of the action
     * @returns The handler for the action
     */
    getHandler(key) {
        if (key) {
            const lKey = key.toLowerCase();
            return this.handlers[lKey] || null;
        }
        return null;
    }
    /**
     * Sets a new handler for an action.
     *
     * @param key Identifier of the action
     * @param handler Handler for the action
     * @returns False if the key was an empty/null string, true otherwise
     */
    setHandler(key, handler) {
        if (key) {
            const lKey = key.toLowerCase();
            this.handlers[lKey] = handler;
            return true;
        }
        return false;
    }
    /**
     * Checks if actions can be executed for an item.
     *
     * @param nodeEntry Item to receive an action
     * @returns True if the action can be executed on this item, false otherwise
     */
    canExecuteAction(nodeEntry) {
        return this.documentListService && nodeEntry && nodeEntry.entry.isFile === true;
    }
    setupActionHandlers() {
        this.handlers['copy'] = this.copyNode.bind(this);
        this.handlers['move'] = this.moveNode.bind(this);
        this.handlers['delete'] = this.deleteNode.bind(this);
        this.handlers['download'] = this.downloadNode.bind(this);
        this.handlers['lock'] = this.lockNode.bind(this);
    }
    lockNode(node) {
        return this.contentNodeDialogService.openLockNodeDialog(node.entry);
    }
    downloadNode(obj) {
        this.nodeActionsService.downloadNode(obj);
    }
    copyNode(node, _target, permission) {
        const actionObservable = this.nodeActionsService.copyContent(node.entry, permission);
        this.prepareHandlers(actionObservable);
        return actionObservable;
    }
    moveNode(node, _target, permission) {
        const actionObservable = this.nodeActionsService.moveContent(node.entry, permission);
        this.prepareHandlers(actionObservable);
        return actionObservable;
    }
    prepareHandlers(actionObservable) {
        actionObservable.subscribe((fileOperationMessage) => {
            this.success.next(fileOperationMessage);
        }, this.error.next.bind(this.error));
    }
    deleteNode(node, _target, permission) {
        if (this.canExecuteAction(node)) {
            if (this.contentService.hasAllowableOperations(node.entry, permission)) {
                const handlerObservable = this.documentListService.deleteNode(node.entry.id);
                handlerObservable.subscribe(() => {
                    const message = this.translation.instant('CORE.DELETE_NODE.SINGULAR', { name: node.entry.name });
                    this.success.next(message);
                }, () => {
                    const message = this.translation.instant('CORE.DELETE_NODE.ERROR_SINGULAR', { name: node.entry.name });
                    this.error.next(message);
                });
                return handlerObservable;
            }
            else {
                this.permissionEvent.next(new PermissionModel({
                    type: 'content',
                    action: 'delete',
                    permission
                }));
                return throwError(new Error('No permission to delete'));
            }
        }
        return of();
    }
}
DocumentActionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentActionsService, deps: [{ token: NodeActionsService }, { token: ContentNodeDialogService }, { token: i1.TranslationService }, { token: DocumentListService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Injectable });
DocumentActionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentActionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentActionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: NodeActionsService }, { type: ContentNodeDialogService }, { type: i1.TranslationService }, { type: DocumentListService }, { type: ContentService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FolderActionsService {
    constructor(nodeActionsService, documentListService, contentService, translation) {
        this.nodeActionsService = nodeActionsService;
        this.documentListService = documentListService;
        this.contentService = contentService;
        this.translation = translation;
        this.permissionEvent = new Subject();
        this.error = new Subject();
        this.success = new Subject();
        this.handlers = {};
        this.setupActionHandlers();
    }
    /**
     * Gets the handler function for an action.
     *
     * @param key Identifier for the action
     * @returns The handler function
     */
    getHandler(key) {
        if (key) {
            const lKey = key.toLowerCase();
            return this.handlers[lKey] || null;
        }
        return null;
    }
    /**
     * Sets a new handler function for an action.
     *
     * @param key Identifier for the action
     * @param handler The new handler function
     * @returns True if the key was a valid action identifier, false otherwise
     */
    setHandler(key, handler) {
        if (key) {
            const lKey = key.toLowerCase();
            this.handlers[lKey] = handler;
            return true;
        }
        return false;
    }
    /**
     * Checks if an action is available for a particular item.
     *
     * @param nodeEntry Item to check
     * @returns True if the action is available, false otherwise
     */
    canExecuteAction(nodeEntry) {
        return this.documentListService && nodeEntry && nodeEntry.entry.isFolder === true;
    }
    setupActionHandlers() {
        this.handlers['copy'] = this.copyNode.bind(this);
        this.handlers['move'] = this.moveNode.bind(this);
        this.handlers['delete'] = this.deleteNode.bind(this);
        this.handlers['download'] = this.downloadNode.bind(this);
    }
    downloadNode(nodeEntry) {
        this.nodeActionsService.downloadNode(nodeEntry);
    }
    copyNode(nodeEntry, target, permission) {
        const actionObservable = this.nodeActionsService.copyFolder(nodeEntry.entry, permission);
        this.prepareHandlers(actionObservable, target);
        return actionObservable;
    }
    moveNode(nodeEntry, target, permission) {
        const actionObservable = this.nodeActionsService.moveFolder(nodeEntry.entry, permission);
        this.prepareHandlers(actionObservable, target);
        return actionObservable;
    }
    prepareHandlers(actionObservable, target) {
        actionObservable.subscribe((fileOperationMessage) => {
            if (target && typeof target.reload === 'function') {
                target.reload();
            }
            this.success.next(fileOperationMessage);
        }, this.error.next.bind(this.error));
    }
    deleteNode(node, target, permission) {
        if (this.canExecuteAction(node)) {
            if (this.contentService.hasAllowableOperations(node.entry, permission)) {
                const handlerObservable = this.documentListService.deleteNode(node.entry.id);
                handlerObservable.subscribe(() => {
                    if (target && typeof target.reload === 'function') {
                        target.reload();
                    }
                    const message = this.translation.instant('CORE.DELETE_NODE.SINGULAR', { name: node.entry.name });
                    this.success.next(message);
                }, () => {
                    const message = this.translation.instant('CORE.DELETE_NODE.ERROR_SINGULAR', { name: node.entry.name });
                    this.error.next(message);
                });
                return handlerObservable;
            }
            else {
                this.permissionEvent.next(new PermissionModel({ type: 'folder', action: 'delete', permission }));
                return throwError(new Error('No permission to delete'));
            }
        }
        return of();
    }
}
FolderActionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderActionsService, deps: [{ token: NodeActionsService }, { token: DocumentListService }, { token: ContentService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
FolderActionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderActionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderActionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: NodeActionsService }, { type: DocumentListService }, { type: ContentService }, { type: i1.TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentActionListComponent {
    constructor(documentList) {
        this.documentList = documentList;
    }
    /**
     * Registers action handler within the parent document list component.
     *
     * @param action Action model to register.
     */
    registerAction(action) {
        if (this.documentList && action) {
            this.documentList.actions.push(action);
            return true;
        }
        return false;
    }
    unregisterAction(action) {
        if (this.documentList && action) {
            const idx = this.documentList.actions.indexOf(action);
            if (idx >= 0) {
                this.documentList.actions.splice(idx, 1);
                return true;
            }
        }
        return false;
    }
}
ContentActionListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentActionListComponent, deps: [{ token: DocumentListComponent }], target: i0.ɵɵFactoryTarget.Component });
ContentActionListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentActionListComponent, selector: "content-actions", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentActionListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'content-actions',
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: DocumentListComponent }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentActionComponent {
    constructor(list, documentActions, folderActions) {
        this.list = list;
        this.documentActions = documentActions;
        this.folderActions = folderActions;
        /** The title of the action as shown in the menu. */
        this.title = 'Action';
        /** Visibility state (see examples). */
        this.visible = true;
        /** Type of item that the action applies to. Can be "document" or "folder" */
        this.target = ContentActionTarget.All;
        /** Is the menu item disabled? */
        this.disabled = false;
        /** Emitted when the user selects the action from the menu. */
        this.execute = new EventEmitter();
        /** Emitted when a permission error occurs */
        this.permissionEvent = new EventEmitter();
        /** Emitted when an error occurs during the action.
         * Applies to copy and move actions.
         */
        this.error = new EventEmitter();
        /** Emitted when the action succeeds with the success string message.
         * Applies to copy, move and delete actions.
         */
        this.success = new EventEmitter();
        this.subscriptions = [];
    }
    ngOnInit() {
        if (this.target === ContentActionTarget.All) {
            this.folderActionModel = this.generateAction(ContentActionTarget.Folder);
            this.documentActionModel = this.generateAction(ContentActionTarget.Document);
        }
        else {
            this.documentActionModel = this.generateAction(this.target);
        }
    }
    ngOnChanges(changes) {
        if (changes.visible && !changes.visible.firstChange) {
            if (this.documentActionModel) {
                this.documentActionModel.visible = changes.visible.currentValue;
            }
            if (this.folderActionModel) {
                this.folderActionModel.visible = changes.visible.currentValue;
            }
        }
        if (changes.disabled && !changes.disabled.firstChange) {
            if (this.documentActionModel) {
                this.documentActionModel.disabled = changes.disabled.currentValue;
            }
            if (this.folderActionModel) {
                this.folderActionModel.disabled = changes.disabled.currentValue;
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.subscriptions = [];
        if (this.documentActionModel) {
            this.unregister(this.documentActionModel);
            this.documentActionModel = null;
        }
        if (this.folderActionModel) {
            this.unregister(this.folderActionModel);
            this.folderActionModel = null;
        }
    }
    register(model) {
        if (this.list) {
            return this.list.registerAction(model);
        }
        return false;
    }
    unregister(model) {
        if (this.list) {
            return this.list.unregisterAction(model);
        }
        return false;
    }
    generateAction(target) {
        const model = new ContentActionModel({
            title: this.title,
            icon: this.icon,
            permission: this.permission,
            disableWithNoPermission: this.disableWithNoPermission,
            target,
            disabled: this.disabled,
            visible: this.visible
        });
        if (this.handler) {
            model.handler = this.getSystemHandler(target, this.handler);
        }
        if (this.execute) {
            model.execute = (value) => {
                this.execute.emit({ value });
            };
        }
        this.register(model);
        return model;
    }
    getSystemHandler(target, name) {
        if (target) {
            target = target.toLowerCase();
            if (target === ContentActionTarget.Document) {
                if (this.documentActions) {
                    this.subscriptions.push(this.documentActions.permissionEvent.subscribe((permission) => {
                        this.permissionEvent.emit(permission);
                    }), this.documentActions.error.subscribe((errors) => {
                        this.error.emit(errors);
                    }), this.documentActions.success.subscribe((message) => {
                        this.success.emit(message);
                    }));
                    return this.documentActions.getHandler(name);
                }
                return null;
            }
            if (target === ContentActionTarget.Folder) {
                if (this.folderActions) {
                    this.subscriptions.push(this.folderActions.permissionEvent.subscribe((permission) => {
                        this.permissionEvent.emit(permission);
                    }), this.folderActions.error.subscribe((errors) => {
                        this.error.emit(errors);
                    }), this.folderActions.success.subscribe((message) => {
                        this.success.emit(message);
                    }));
                    return this.folderActions.getHandler(name);
                }
                return null;
            }
        }
        return null;
    }
}
ContentActionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentActionComponent, deps: [{ token: ContentActionListComponent }, { token: DocumentActionsService }, { token: FolderActionsService }], target: i0.ɵɵFactoryTarget.Component });
ContentActionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentActionComponent, selector: "content-action", inputs: { title: "title", icon: "icon", visible: "visible", handler: "handler", target: "target", permission: "permission", disableWithNoPermission: "disableWithNoPermission", disabled: "disabled" }, outputs: { execute: "execute", permissionEvent: "permissionEvent", error: "error", success: "success" }, providers: [
        DocumentActionsService,
        FolderActionsService
    ], usesOnChanges: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentActionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'content-action',
                    template: '',
                    providers: [
                        DocumentActionsService,
                        FolderActionsService
                    ]
                }]
        }], ctorParameters: function () { return [{ type: ContentActionListComponent }, { type: DocumentActionsService }, { type: FolderActionsService }]; }, propDecorators: { title: [{
                type: Input
            }], icon: [{
                type: Input
            }], visible: [{
                type: Input
            }], handler: [{
                type: Input
            }], target: [{
                type: Input
            }], permission: [{
                type: Input
            }], disableWithNoPermission: [{
                type: Input
            }], disabled: [{
                type: Input
            }], execute: [{
                type: Output
            }], permissionEvent: [{
                type: Output
            }], error: [{
                type: Output
            }], success: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LibraryNameColumnComponent {
    constructor(element, nodesApiService) {
        this.element = element;
        this.nodesApiService = nodesApiService;
        this.displayTooltip$ = new BehaviorSubject('');
        this.displayText$ = new BehaviorSubject('');
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.updateValue();
        this.nodesApiService.nodeUpdated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(node => {
            const row = this.context.row;
            if (row) {
                const { entry } = row.node;
                if (entry === node) {
                    row.node = { entry };
                    this.updateValue();
                }
            }
        });
    }
    updateValue() {
        this.node = this.context.row.node;
        const rows = this.context.data.rows || [];
        if (this.node && this.node.entry) {
            this.displayText$.next(this.makeLibraryTitle(this.node.entry, rows));
            this.displayTooltip$.next(this.makeLibraryTooltip(this.node.entry));
        }
    }
    onClick() {
        this.element.nativeElement.dispatchEvent(new CustomEvent('name-click', {
            bubbles: true,
            detail: {
                node: this.node
            }
        }));
    }
    makeLibraryTooltip(library) {
        const { description, title } = library;
        return description || title || '';
    }
    makeLibraryTitle(library, rows) {
        const entries = rows.map((row) => row.node.entry);
        const { title, id } = library;
        let isDuplicate = false;
        if (entries) {
            isDuplicate = entries.some((entry) => entry.id !== id && entry.title === title);
        }
        return isDuplicate ? `${title} (${id})` : `${title}`;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
LibraryNameColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryNameColumnComponent, deps: [{ token: i0.ElementRef }, { token: NodesApiService }], target: i0.ɵɵFactoryTarget.Component });
LibraryNameColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LibraryNameColumnComponent, selector: "adf-library-name-column", inputs: { context: "context" }, host: { classAttribute: "adf-datatable-content-cell adf-datatable-link adf-library-name-column" }, ngImport: i0, template: `
        <span
            role="link"
            [attr.aria-label]="'NAME_COLUMN_LINK.ACCESSIBILITY.ARIA_LABEL' | translate:{
                name:  displayText$ | async
            }"
            class="adf-datatable-cell-value"
            title="{{ displayTooltip$ | async }}"
            (click)="onClick()">

            {{ displayText$ | async }}
        </span>
    `, isInline: true, dependencies: [{ kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryNameColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-library-name-column',
                    template: `
        <span
            role="link"
            [attr.aria-label]="'NAME_COLUMN_LINK.ACCESSIBILITY.ARIA_LABEL' | translate:{
                name:  displayText$ | async
            }"
            class="adf-datatable-cell-value"
            title="{{ displayTooltip$ | async }}"
            (click)="onClick()">

            {{ displayText$ | async }}
        </span>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'adf-datatable-content-cell adf-datatable-link adf-library-name-column'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: NodesApiService }]; }, propDecorators: { context: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LibraryRoleColumnComponent {
    constructor(nodesApiService) {
        this.nodesApiService = nodesApiService;
        this.displayText$ = new BehaviorSubject('');
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.updateValue();
        this.nodesApiService.nodeUpdated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(node => {
            const row = this.context.row;
            if (row) {
                const { entry } = row.node;
                if (entry === node) {
                    row.node = { entry };
                    this.updateValue();
                }
            }
        });
    }
    updateValue() {
        const node = this.context.row.node;
        if (node && node.entry) {
            const role = node.entry.role;
            switch (role) {
                case Site.RoleEnum.SiteManager:
                    this.displayText$.next('LIBRARY.ROLE.MANAGER');
                    break;
                case Site.RoleEnum.SiteCollaborator:
                    this.displayText$.next('LIBRARY.ROLE.COLLABORATOR');
                    break;
                case Site.RoleEnum.SiteContributor:
                    this.displayText$.next('LIBRARY.ROLE.CONTRIBUTOR');
                    break;
                case Site.RoleEnum.SiteConsumer:
                    this.displayText$.next('LIBRARY.ROLE.CONSUMER');
                    break;
                default:
                    this.displayText$.next('LIBRARY.ROLE.NONE');
                    break;
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
LibraryRoleColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryRoleColumnComponent, deps: [{ token: NodesApiService }], target: i0.ɵɵFactoryTarget.Component });
LibraryRoleColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LibraryRoleColumnComponent, selector: "adf-library-role-column", inputs: { context: "context" }, host: { classAttribute: "adf-library-role-column adf-datatable-content-cell" }, ngImport: i0, template: `
        <span class="adf-datatable-cell-value" title="{{ (displayText$ | async) | translate }}">
            {{ (displayText$ | async) | translate }}
        </span>
    `, isInline: true, dependencies: [{ kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryRoleColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-library-role-column',
                    template: `
        <span class="adf-datatable-cell-value" title="{{ (displayText$ | async) | translate }}">
            {{ (displayText$ | async) | translate }}
        </span>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-library-role-column adf-datatable-content-cell' }
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }]; }, propDecorators: { context: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LibraryStatusColumnComponent {
    constructor(nodesApiService) {
        this.nodesApiService = nodesApiService;
        this.displayText$ = new BehaviorSubject('');
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.updateValue();
        this.nodesApiService.nodeUpdated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(node => {
            const row = this.context.row;
            if (row) {
                const { entry } = row.node;
                if (entry === node) {
                    row.node = { entry };
                    this.updateValue();
                }
            }
        });
    }
    updateValue() {
        const node = this.context.row.node;
        if (node && node.entry) {
            const visibility = node.entry.visibility;
            switch (visibility) {
                case Site.VisibilityEnum.PUBLIC:
                    this.displayText$.next('LIBRARY.VISIBILITY.PUBLIC');
                    break;
                case Site.VisibilityEnum.PRIVATE:
                    this.displayText$.next('LIBRARY.VISIBILITY.PRIVATE');
                    break;
                case Site.VisibilityEnum.MODERATED:
                    this.displayText$.next('LIBRARY.VISIBILITY.MODERATED');
                    break;
                default:
                    this.displayText$.next('UNKNOWN');
                    break;
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
LibraryStatusColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryStatusColumnComponent, deps: [{ token: NodesApiService }], target: i0.ɵɵFactoryTarget.Component });
LibraryStatusColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LibraryStatusColumnComponent, selector: "adf-library-status-column", inputs: { context: "context" }, host: { classAttribute: "adf-library-status-column adf-datatable-content-cell" }, ngImport: i0, template: `
        <span class="adf-datatable-cell-value" title="{{ (displayText$ | async) | translate }}">
            {{ (displayText$ | async) | translate }}
        </span>
    `, isInline: true, dependencies: [{ kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryStatusColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-library-status-column',
                    template: `
        <span class="adf-datatable-cell-value" title="{{ (displayText$ | async) | translate }}">
            {{ (displayText$ | async) | translate }}
        </span>
    `,
                    host: { class: 'adf-library-status-column adf-datatable-content-cell' }
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }]; }, propDecorators: { context: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeNameTooltipPipe {
    transform(node) {
        if (node) {
            return this.getNodeTooltip(node);
        }
        return null;
    }
    containsLine(lines, line) {
        return lines.some((item) => item.toLowerCase() === line.toLowerCase());
    }
    removeDuplicateLines(lines) {
        const reducer = (acc, line) => {
            if (!this.containsLine(acc, line)) {
                acc.push(line);
            }
            return acc;
        };
        return lines.reduce(reducer, []);
    }
    getNodeTooltip(node) {
        if (!node || !node.entry) {
            return null;
        }
        const { entry: { properties, name } } = node;
        const lines = [name];
        if (properties) {
            const { 'cm:title': title, 'cm:description': description } = properties;
            if (title && description) {
                lines[0] = title;
                lines[1] = description;
            }
            if (title) {
                lines[1] = title;
            }
            if (description) {
                lines[1] = description;
            }
        }
        return this.removeDuplicateLines(lines).join(`\n`);
    }
}
NodeNameTooltipPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeNameTooltipPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
NodeNameTooltipPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: NodeNameTooltipPipe, name: "adfNodeNameTooltip" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeNameTooltipPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'adfNodeNameTooltip'
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NameColumnComponent {
    constructor(element, nodesApiService) {
        this.element = element;
        this.nodesApiService = nodesApiService;
        this.key = 'name';
        this.displayText$ = new BehaviorSubject('');
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        this.updateValue();
        this.nodesApiService.nodeUpdated
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(node => {
            const row = this.context.row;
            if (row) {
                const { entry } = row.node;
                if (entry === node) {
                    row.node = { entry };
                    this.updateValue();
                }
            }
        });
    }
    updateValue() {
        this.node = this.context.row.node;
        if (this.node && this.node.entry) {
            const displayText = this.context.row.getValue(this.key);
            this.displayText$.next(displayText || this.node.entry.id);
        }
    }
    onClick() {
        this.element.nativeElement.dispatchEvent(new CustomEvent('name-click', {
            bubbles: true,
            detail: {
                node: this.node
            }
        }));
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
}
NameColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NameColumnComponent, deps: [{ token: i0.ElementRef }, { token: NodesApiService }], target: i0.ɵɵFactoryTarget.Component });
NameColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NameColumnComponent, selector: "adf-name-column", inputs: { context: "context", key: "key" }, host: { classAttribute: "adf-datatable-content-cell adf-datatable-link adf-name-column" }, ngImport: i0, template: `
        <span
            role="link"
            [attr.aria-label]="'NAME_COLUMN_LINK.ACCESSIBILITY.ARIA_LABEL' | translate:{
                name:  displayText$ | async
            }"
            class="adf-datatable-cell-value"
            title="{{ node | adfNodeNameTooltip }}"
            (click)="onClick()">

            {{ displayText$ | async }}
        </span>
    `, isInline: true, dependencies: [{ kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }, { kind: "pipe", type: NodeNameTooltipPipe, name: "adfNodeNameTooltip" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NameColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-name-column',
                    template: `
        <span
            role="link"
            [attr.aria-label]="'NAME_COLUMN_LINK.ACCESSIBILITY.ARIA_LABEL' | translate:{
                name:  displayText$ | async
            }"
            class="adf-datatable-cell-value"
            title="{{ node | adfNodeNameTooltip }}"
            (click)="onClick()">

            {{ displayText$ | async }}
        </span>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-datatable-content-cell adf-datatable-link adf-name-column' }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: NodesApiService }]; }, propDecorators: { context: [{
                type: Input
            }], key: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TrashcanNameColumnComponent {
    constructor() {
        this.isLibrary = false;
    }
    ngOnInit() {
        this.node = this.context.row.node;
        const rows = this.context.data.rows || [];
        if (this.node && this.node.entry) {
            this.isLibrary = this.node.entry.nodeType === 'st:site';
            if (this.isLibrary) {
                const { properties } = this.node.entry;
                this.displayText = this.makeLibraryTitle(this.node.entry, rows);
                this.displayTooltip =
                    properties['cm:description'] || properties['cm:title'];
            }
            else {
                this.displayText = this.node.entry.name || this.node.entry.id;
            }
        }
    }
    makeLibraryTitle(library, rows) {
        const entries = rows.map((r) => r.node.entry);
        const { id } = library;
        const title = library.properties['cm:title'];
        let isDuplicate = false;
        if (entries) {
            isDuplicate = entries.some((entry) => entry.id !== id && entry.properties['cm:title'] === title);
        }
        return isDuplicate
            ? `${library.properties['cm:title']} (${library.name})`
            : `${library.properties['cm:title']}`;
    }
}
TrashcanNameColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TrashcanNameColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TrashcanNameColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TrashcanNameColumnComponent, selector: "adf-trashcan-name-column", inputs: { context: "context" }, host: { classAttribute: "adf-datatable-content-cell adf-trashcan-name-column" }, ngImport: i0, template: `
    <ng-container *ngIf="!isLibrary">
      <span class="adf-datatable-cell-value" title="{{ node | adfNodeNameTooltip }}">{{ displayText }}</span>
    </ng-container>
    <ng-container *ngIf="isLibrary">
      <span class="adf-datatable-cell-value" title="{{ displayTooltip }}">{{ displayText }}</span>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: NodeNameTooltipPipe, name: "adfNodeNameTooltip" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TrashcanNameColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-trashcan-name-column',
                    template: `
    <ng-container *ngIf="!isLibrary">
      <span class="adf-datatable-cell-value" title="{{ node | adfNodeNameTooltip }}">{{ displayText }}</span>
    </ng-container>
    <ng-container *ngIf="isLibrary">
      <span class="adf-datatable-cell-value" title="{{ displayTooltip }}">{{ displayText }}</span>
    </ng-container>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'adf-datatable-content-cell adf-trashcan-name-column' }
                }]
        }], propDecorators: { context: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodePaging {
}
class NodePagingList {
}
class NodeMinimalEntry {
}
class Pagination {
}
class NodeMinimal {
    constructor() {
        this.properties = {};
    }
}
class UserInfo {
}
class ContentInfo {
}
class PathInfoEntity {
}
class PathElementEntity {
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PermissionStyleModel {
    constructor(css, permission, isFile = true, isFolder = true) {
        this.isFolder = true;
        this.isFile = true;
        this.css = css;
        this.permission = permission;
        this.isFile = isFile;
        this.isFolder = isFolder;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadVersionButtonComponent extends UploadButtonComponent {
    createFileModel(file) {
        const fileModel = super.createFileModel(file, this.rootFolderId, (file.webkitRelativePath || '').replace(/\/[^\/]*$/, ''), this.node.id);
        if (!this.isFileAcceptable(fileModel)) {
            const message = this.translationService.instant('FILE_UPLOAD.VERSION.MESSAGES.INCOMPATIBLE_VERSION');
            this.error.emit(message);
        }
        return fileModel;
    }
    ngOnInit() {
        super.ngOnInit();
        this.checkPermission();
    }
    checkPermission() {
        this.permissionValue.next(this.nodeHasPermission(this.node, AllowableOperationsEnum.UPDATE));
    }
}
UploadVersionButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadVersionButtonComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
UploadVersionButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UploadVersionButtonComponent, selector: "adf-upload-version-button", inputs: { node: "node" }, host: { classAttribute: "adf-upload-version-button" }, usesInheritance: true, ngImport: i0, template: "<form class=\"adf-upload-button-file-container\">\n    <!--Files Upload-->\n    <div *ngIf=\"!uploadFolders\">\n\n        <!--Single Files Upload-->\n        <button *ngIf=\"!multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadSingleFile.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"upload-single-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span id=\"upload-single-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadSingleFile\n                id=\"upload-single-file\"\n                data-automation-id=\"upload-single-file\"\n                [type]=\"file ? 'button' : 'file'\"\n                name=\"uploadFiles\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\"\n                (click)=\"onClickUploadButton()\">\n        </button>\n\n        <!--Multiple Files Upload-->\n        <button *ngIf=\"multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadMultipleFiles.click()\">\n            <mat-icon>file_upload</mat-icon>\n\n            <span id=\"upload-multiple-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span\n                id=\"upload-multiple-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadMultipleFiles\n                id=\"upload-multiple-files\"\n                data-automation-id=\"upload-multiple-files\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\">\n        </button>\n    </div>\n\n    <!--Folders Upload-->\n    <div *ngIf=\"uploadFolders\">\n        <button\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadFolders.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"uploadFolder-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FOLDER' | translate }}</span>\n            <span id=\"uploadFolder-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadFolders\n                id=\"uploadFolder\"\n                data-automation-id=\"uploadFolder\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                webkitdirectory directory\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onDirectoryAdded($event)\">\n        </button>\n    </div>\n</form>\n", styles: [".adf-upload-button-file-container input{display:none}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], viewProviders: [
        { provide: EXTENDIBLE_COMPONENT, useExisting: forwardRef(() => UploadVersionButtonComponent) }
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadVersionButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-upload-version-button', viewProviders: [
                        { provide: EXTENDIBLE_COMPONENT, useExisting: forwardRef(() => UploadVersionButtonComponent) }
                    ], encapsulation: ViewEncapsulation.None, host: { class: 'adf-upload-version-button' }, template: "<form class=\"adf-upload-button-file-container\">\n    <!--Files Upload-->\n    <div *ngIf=\"!uploadFolders\">\n\n        <!--Single Files Upload-->\n        <button *ngIf=\"!multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadSingleFile.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"upload-single-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span id=\"upload-single-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadSingleFile\n                id=\"upload-single-file\"\n                data-automation-id=\"upload-single-file\"\n                [type]=\"file ? 'button' : 'file'\"\n                name=\"uploadFiles\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\"\n                (click)=\"onClickUploadButton()\">\n        </button>\n\n        <!--Multiple Files Upload-->\n        <button *ngIf=\"multipleFiles\"\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadMultipleFiles.click()\">\n            <mat-icon>file_upload</mat-icon>\n\n            <span id=\"upload-multiple-file-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FILE' | translate }}</span>\n            <span\n                id=\"upload-multiple-file-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadMultipleFiles\n                id=\"upload-multiple-files\"\n                data-automation-id=\"upload-multiple-files\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onFilesAdded($event)\">\n        </button>\n    </div>\n\n    <!--Folders Upload-->\n    <div *ngIf=\"uploadFolders\">\n        <button\n            [disabled]=\"isButtonDisabled()\"\n            mat-raised-button\n            (click)=\"uploadFolders.click()\">\n            <mat-icon>file_upload</mat-icon>\n            <span id=\"uploadFolder-label\"\n                *ngIf=\"!staticTitle\">{{ 'FILE_UPLOAD.BUTTON.UPLOAD_FOLDER' | translate }}</span>\n            <span id=\"uploadFolder-label-static\"\n                *ngIf=\"staticTitle\">{{ staticTitle }}</span>\n            <input #uploadFolders\n                id=\"uploadFolder\"\n                data-automation-id=\"uploadFolder\"\n                type=\"file\"\n                name=\"uploadFiles\"\n                multiple=\"multiple\"\n                accept=\"{{acceptedFilesType}}\"\n                webkitdirectory directory\n                [attr.disabled]=\"isButtonDisabled()\"\n                [title]=\"tooltip\"\n                (change)=\"onDirectoryAdded($event)\">\n        </button>\n    </div>\n</form>\n", styles: [".adf-upload-button-file-container input{display:none}\n"] }]
        }], propDecorators: { node: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UploadModule {
}
UploadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UploadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: UploadModule, declarations: [FileDraggableDirective,
        UploadDragAreaComponent,
        UploadButtonComponent,
        UploadVersionButtonComponent,
        FileUploadingDialogComponent,
        FileUploadingListComponent,
        FileUploadingListRowComponent,
        FileUploadErrorPipe,
        ToggleIconDirective], imports: [CoreModule,
        CommonModule,
        MaterialModule,
        A11yModule], exports: [FileDraggableDirective,
        UploadDragAreaComponent,
        UploadButtonComponent,
        UploadVersionButtonComponent,
        FileUploadingDialogComponent,
        FileUploadingListComponent,
        FileUploadingListRowComponent,
        FileUploadErrorPipe,
        ToggleIconDirective] });
UploadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadModule, imports: [CoreModule,
        CommonModule,
        MaterialModule,
        A11yModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CoreModule,
                        CommonModule,
                        MaterialModule,
                        A11yModule
                    ],
                    declarations: [
                        FileDraggableDirective,
                        UploadDragAreaComponent,
                        UploadButtonComponent,
                        UploadVersionButtonComponent,
                        FileUploadingDialogComponent,
                        FileUploadingListComponent,
                        FileUploadingListRowComponent,
                        FileUploadErrorPipe,
                        ToggleIconDirective
                    ],
                    exports: [
                        FileDraggableDirective,
                        UploadDragAreaComponent,
                        UploadButtonComponent,
                        UploadVersionButtonComponent,
                        FileUploadingDialogComponent,
                        FileUploadingListComponent,
                        FileUploadingListRowComponent,
                        FileUploadErrorPipe,
                        ToggleIconDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentPipeModule {
}
ContentPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentPipeModule, declarations: [NodeNameTooltipPipe,
        IsIncludedPipe], imports: [CommonModule,
        TranslateModule], exports: [NodeNameTooltipPipe,
        IsIncludedPipe] });
ContentPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentPipeModule, providers: [
        NodeNameTooltipPipe,
        IsIncludedPipe
    ], imports: [CommonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule
                    ],
                    declarations: [
                        NodeNameTooltipPipe,
                        IsIncludedPipe
                    ],
                    providers: [
                        NodeNameTooltipPipe,
                        IsIncludedPipe
                    ],
                    exports: [
                        NodeNameTooltipPipe,
                        IsIncludedPipe
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchComponent {
    constructor(searchService, _elementRef) {
        this.searchService = searchService;
        this._elementRef = _elementRef;
        /** Function that maps an option's value to its display value in the trigger. */
        this.displayWith = null;
        /** Maximum number of results to show in the search. */
        this.maxResults = 20;
        /** Number of results to skip from the results pagination. */
        this.skipResults = 0;
        /** Search term to use when executing the search. Updating this value will
         * run a new search and update the results.
         */
        this.searchTerm = '';
        /** Emitted when search results have fully loaded. */
        this.resultLoaded = new EventEmitter();
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
        this.showPanel = false;
        this._isOpen = false;
        this.keyPressedStream = new Subject();
        this._classList = {};
        this.onDestroy$ = new Subject();
        this.keyPressedStream
            .pipe(debounceTime(200), takeUntil(this.onDestroy$))
            .subscribe(searchedWord => {
            this.loadSearchResults(searchedWord);
        });
        searchService.dataLoaded
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(nodePaging => this.onSearchDataLoaded(nodePaging), error => this.onSearchDataError(error));
    }
    /** CSS class for display. */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    set classList(classList) {
        if (classList && classList.length) {
            classList.split(' ').forEach((className) => this._classList[className.trim()] = true);
            this._elementRef.nativeElement.className = '';
        }
    }
    get isOpen() {
        return this._isOpen && this.showPanel;
    }
    set isOpen(value) {
        this._isOpen = value;
    }
    ngAfterContentInit() {
        this.setVisibility();
    }
    ngOnChanges(changes) {
        if (changes.searchTerm && changes.searchTerm.currentValue) {
            this.loadSearchResults(changes.searchTerm.currentValue);
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    resetResults() {
        this.cleanResults();
        this.setVisibility();
    }
    reload() {
        this.loadSearchResults(this.searchTerm);
    }
    cleanResults() {
        if (this.results) {
            this.results = {};
        }
    }
    loadSearchResults(searchTerm) {
        this.resetResults();
        if (searchTerm) {
            this.searchService.search(searchTerm, this.maxResults, this.skipResults).subscribe((result) => this.onSearchDataLoaded(result), (err) => this.onSearchDataError(err));
        }
        else {
            this.cleanResults();
        }
    }
    onSearchDataLoaded(resultSetPaging) {
        if (resultSetPaging) {
            this.results = resultSetPaging;
            this.resultLoaded.emit(this.results);
            this.isOpen = true;
            this.setVisibility();
        }
    }
    onSearchDataError(error) {
        if (error && error.status !== 400) {
            this.results = null;
            this.error.emit(error);
        }
    }
    hidePanel() {
        if (this.isOpen) {
            this._classList['adf-search-show'] = false;
            this._classList['adf-search-hide'] = true;
            this.isOpen = false;
        }
    }
    setVisibility() {
        this.showPanel = !!this.results && !!this.results.list;
        this._classList['adf-search-show'] = this.showPanel;
        this._classList['adf-search-hide'] = !this.showPanel;
    }
}
SearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchComponent, deps: [{ token: SearchService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchComponent, selector: "adf-search", inputs: { displayWith: "displayWith", maxResults: "maxResults", skipResults: "skipResults", searchTerm: "searchTerm", classList: ["class", "classList"] }, outputs: { resultLoaded: "resultLoaded", error: "error" }, host: { classAttribute: "adf-search" }, queries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], viewQueries: [{ propertyName: "panel", first: true, predicate: ["panel"], descendants: true, static: true }], exportAs: ["searchAutocomplete"], usesOnChanges: true, ngImport: i0, template: "<div role=\"listbox\" id=\"adf-search-results-content\" title=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.USER-GROUP-LIST' | translate}}\"\n    [ngClass]=\"_classList\" #panel>\n    <ng-template\n        [ngTemplateOutlet]=\"template\"\n        [ngTemplateOutletContext]=\"{ $implicit: results }\">\n    </ng-template>\n</div>\n", styles: [".adf-search-hide{visibility:hidden}.adf-search-show{visibility:visible}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search', encapsulation: ViewEncapsulation.None, preserveWhitespaces: false, exportAs: 'searchAutocomplete', host: { class: 'adf-search' }, template: "<div role=\"listbox\" id=\"adf-search-results-content\" title=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.USER-GROUP-LIST' | translate}}\"\n    [ngClass]=\"_classList\" #panel>\n    <ng-template\n        [ngTemplateOutlet]=\"template\"\n        [ngTemplateOutletContext]=\"{ $implicit: results }\">\n    </ng-template>\n</div>\n", styles: [".adf-search-hide{visibility:hidden}.adf-search-show{visibility:visible}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchService }, { type: i0.ElementRef }]; }, propDecorators: { panel: [{
                type: ViewChild,
                args: ['panel', { static: true }]
            }], template: [{
                type: ContentChild,
                args: [TemplateRef]
            }], displayWith: [{
                type: Input
            }], maxResults: [{
                type: Input
            }], skipResults: [{
                type: Input
            }], searchTerm: [{
                type: Input
            }], classList: [{
                type: Input,
                args: ['class']
            }], resultLoaded: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EmptySearchResultComponent {
}
EmptySearchResultComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptySearchResultComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EmptySearchResultComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: EmptySearchResultComponent, selector: "adf-empty-search-result", ngImport: i0, template: "<div class=\"adf-empty-search-result\">\n    <ng-content></ng-content>\n</div>\n", encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: EmptySearchResultComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-empty-search-result', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-empty-search-result\">\n    <ng-content></ng-content>\n</div>\n" }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchControlComponent {
    constructor(authService, thumbnailService) {
        this.authService = authService;
        this.thumbnailService = thumbnailService;
        /** Toggles highlighting of the search term in the results. */
        this.highlight = false;
        /** Type of the input field to render, e.g. "search" or "text" (default). */
        this.inputType = 'text';
        /** Toggles "find-as-you-type" suggestions for possible matches. */
        this.liveSearchEnabled = true;
        /** Toggles auto-completion of the search input field. */
        this.autocomplete = false;
        /** Toggles whether to use an expanding search control. If false
         * then a regular input is used.
         */
        this.expandable = true;
        /** Maximum number of results to show in the live search. */
        this.liveSearchMaxResults = 5;
        /** Emitted when the search is submitted by pressing the ENTER key.
         * The search term is provided as the value of the event.
         */
        this.submit = new EventEmitter();
        /** Emitted when the search term is changed. The search term is provided
         * in the 'value' property of the returned object.  If the term is less
         * than three characters in length then it is truncated to an empty
         * string.
         */
        this.searchChange = new EventEmitter();
        /** Emitted when a file item from the list of "find-as-you-type" results is selected. */
        this.optionClicked = new EventEmitter();
        this.focusSubject = new Subject();
        this.noSearchResultTemplate = null;
        this.searchTerm = '';
        this.onDestroy$ = new Subject();
    }
    isNoSearchTemplatePresent() {
        return !!this.emptySearchTemplate;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    isLoggedIn() {
        return this.authService.isEcmLoggedIn();
    }
    inputChange(value) {
        this.searchTerm = value;
        this.searchChange.emit(value);
    }
    getMimeTypeIcon(node) {
        const mimeType = this.getMimeType(node);
        return this.thumbnailService.getMimeTypeIcon(mimeType);
    }
    getMimeType(node) {
        let mimeType;
        if (node.entry.content && node.entry.content.mimeType) {
            mimeType = node.entry.content.mimeType;
        }
        if (node.entry.isFolder) {
            mimeType = 'folder';
        }
        return mimeType;
    }
    elementClicked(item) {
        if (item.entry) {
            this.optionClicked.next(item);
            this.focusSubject.next(new FocusEvent('blur'));
        }
    }
    onFocus(event) {
        this.focusSubject.next(event);
    }
    onBlur(event) {
        const nextElement = this.getNextElementSibling(event.target);
        if (!nextElement && !this.isListElement(event)) {
            this.focusSubject.next(event);
        }
    }
    onSelectFirstResult() {
        if (this.listResultElement && this.listResultElement.length > 0) {
            const firstElement = this.listResultElement.first;
            // eslint-disable-next-line no-underscore-dangle
            firstElement._getHostElement().focus();
        }
    }
    onRowArrowDown(event) {
        const nextElement = this.getNextElementSibling(event.target);
        if (nextElement) {
            nextElement.focus();
        }
    }
    onRowArrowUp(event) {
        const previousElement = this.getPreviousElementSibling(event.target);
        if (previousElement) {
            previousElement.focus();
        }
        else {
            this.focusSubject.next(new FocusEvent('focus'));
        }
    }
    onReset(status) {
        if (status) {
            this.searchAutocomplete.resetResults();
        }
    }
    isListElement(event) {
        return event.relatedTarget && event.relatedTarget.children[0] && event.relatedTarget.children[0].className === 'mat-list-item-content';
    }
    getNextElementSibling(node) {
        return node.nextElementSibling;
    }
    getPreviousElementSibling(node) {
        return node.previousElementSibling;
    }
}
SearchControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchControlComponent, deps: [{ token: i1.AuthenticationService }, { token: i1.ThumbnailService }], target: i0.ɵɵFactoryTarget.Component });
SearchControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchControlComponent, selector: "adf-search-control", inputs: { highlight: "highlight", inputType: "inputType", liveSearchEnabled: "liveSearchEnabled", autocomplete: "autocomplete", expandable: "expandable", liveSearchMaxResults: "liveSearchMaxResults" }, outputs: { submit: "submit", searchChange: "searchChange", optionClicked: "optionClicked" }, host: { classAttribute: "adf-search-control" }, queries: [{ propertyName: "emptySearchTemplate", first: true, predicate: EmptySearchResultComponent, descendants: true }], viewQueries: [{ propertyName: "searchTextInput", first: true, predicate: ["searchTextInput"], descendants: true }, { propertyName: "searchAutocomplete", first: true, predicate: ["search"], descendants: true }, { propertyName: "listResultElement", predicate: MatListItem, descendants: true }], ngImport: i0, template: "<div *ngIf=\"isLoggedIn()\">\n    <adf-search-text-input  #searchTextInput\n                            [searchTerm]= \"searchTerm\"\n                            [expandable]=\"expandable\"\n                            [autocomplete]=\"autocomplete\"\n                            [liveSearchEnabled]=\"liveSearchEnabled\"\n                            [focusListener]=\"focusSubject.asObservable()\"\n                            [searchAutocomplete]=\"auto\"\n                            (searchChange)=\"inputChange($event)\"\n                            (reset)=\"onReset($event)\"\n                            (selectResult)=\"onSelectFirstResult()\"\n                            (submit)=\"submit.emit($event)\"></adf-search-text-input>\n\n    <adf-search #search\n                #auto=\"searchAutocomplete\"\n                class=\"adf-search-result-autocomplete\"\n                [maxResults]=\"liveSearchMaxResults\">\n        <ng-template let-data>\n            <mat-list *ngIf=\"searchTextInput?.isSearchBarActive()\" id=\"autocomplete-search-result-list\">\n                <mat-list-item\n                    *ngFor=\"let item of data?.list?.entries; let idx = index\"\n                    id=\"result_option_{{idx}}\"\n                    [attr.data-automation-id]=\"'autocomplete_for_' + item.entry.name\"\n                    [tabindex]=\"0\"\n                    (blur)=\"onBlur($event)\"\n                    (keyup.arrowdown)=\"onRowArrowDown($event)\"\n                    (keyup.arrowup)=\"onRowArrowUp($event)\"\n                    class=\"adf-search-autocomplete-item\"\n                    (click)=\"elementClicked(item)\"\n                    (keyup.enter)=\"elementClicked(item)\"\n                    (touchend)=\"elementClicked(item)\">\n                    <!-- This is a comment -->\n                    <mat-icon mat-list-icon>\n                        <img [alt]=\"getMimeType(item)\" [src]=\"getMimeTypeIcon(item)\"/>\n                    </mat-icon>\n                    <h4 mat-line id=\"result_name_{{idx}}\"\n                        *ngIf=\"highlight; else elseBlock\"\n                        class=\"adf-search-fixed-text\"\n                        [innerHtml]=\"item.entry.name | highlight: searchTerm\">\n                        {{ item?.entry.name }}\n                    </h4>\n                    <ng-template #elseBlock>\n                        <h4 class=\"adf-search-fixed-text\" mat-line id=\"result_name_{{idx}}\"\n                            [innerHtml]=\"item.entry.name\"></h4>\n                    </ng-template>\n                    <p mat-line class=\"adf-search-fixed-text\"> {{item?.entry.createdByUser.displayName}} </p>\n                </mat-list-item>\n                <mat-list-item id=\"search_no_result\"\n                            data-automation-id=\"search_no_result_found\"\n                            *ngIf=\"data?.list?.entries.length === 0\">\n                    <ng-content\n                        selector=\"adf-empty-search-result\"\n                        *ngIf=\"isNoSearchTemplatePresent() else defaultNoResult\">\n                    </ng-content>\n                    <ng-template #defaultNoResult>\n                        <p mat-line class=\"adf-search-fixed-text\">{{ 'SEARCH.RESULTS.NONE' | translate:{searchTerm:\n                            searchTerm} }}</p>\n                    </ng-template>\n                </mat-list-item>\n            </mat-list>\n        </ng-template>\n    </adf-search>\n</div>\n", styles: [".adf-search-result-autocomplete{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;transform-origin:top left;transform:translate(-40px);position:absolute;max-height:400px;margin-left:45px;margin-top:-22px;font-size:var(--theme-subheading-1-font-size);z-index:5;color:var(--adf-theme-foreground-text-color);background-color:var(--adf-theme-background-card-color);border-radius:2px}.adf-search-result-autocomplete:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}@media screen and (max-width: 959px){.adf-search-result-autocomplete{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}}.adf-search-autocomplete-item:hover{background-color:var(--adf-theme-background-hover-color);opacity:1}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i8$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i8$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i1$2.MatLine, selector: "[mat-line], [matLine]" }, { kind: "directive", type: i8$1.MatListIconCssMatStyler, selector: "[mat-list-icon], [matListIcon]" }, { kind: "component", type: i1.SearchTextInputComponent, selector: "adf-search-text-input", inputs: ["autocomplete", "expandable", "inputType", "liveSearchEnabled", "searchAutocomplete", "searchTerm", "debounceTime", "focusListener", "collapseOnSubmit", "defaultState", "collapseOnBlur", "showClearButton", "placeholder", "hintLabel"], outputs: ["searchChange", "submit", "selectResult", "reset", "searchVisibility"] }, { kind: "component", type: SearchComponent, selector: "adf-search", inputs: ["displayWith", "maxResults", "skipResults", "searchTerm", "class"], outputs: ["resultLoaded", "error"], exportAs: ["searchAutocomplete"] }, { kind: "pipe", type: i1.HighlightPipe, name: "highlight" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-control', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-control' }, template: "<div *ngIf=\"isLoggedIn()\">\n    <adf-search-text-input  #searchTextInput\n                            [searchTerm]= \"searchTerm\"\n                            [expandable]=\"expandable\"\n                            [autocomplete]=\"autocomplete\"\n                            [liveSearchEnabled]=\"liveSearchEnabled\"\n                            [focusListener]=\"focusSubject.asObservable()\"\n                            [searchAutocomplete]=\"auto\"\n                            (searchChange)=\"inputChange($event)\"\n                            (reset)=\"onReset($event)\"\n                            (selectResult)=\"onSelectFirstResult()\"\n                            (submit)=\"submit.emit($event)\"></adf-search-text-input>\n\n    <adf-search #search\n                #auto=\"searchAutocomplete\"\n                class=\"adf-search-result-autocomplete\"\n                [maxResults]=\"liveSearchMaxResults\">\n        <ng-template let-data>\n            <mat-list *ngIf=\"searchTextInput?.isSearchBarActive()\" id=\"autocomplete-search-result-list\">\n                <mat-list-item\n                    *ngFor=\"let item of data?.list?.entries; let idx = index\"\n                    id=\"result_option_{{idx}}\"\n                    [attr.data-automation-id]=\"'autocomplete_for_' + item.entry.name\"\n                    [tabindex]=\"0\"\n                    (blur)=\"onBlur($event)\"\n                    (keyup.arrowdown)=\"onRowArrowDown($event)\"\n                    (keyup.arrowup)=\"onRowArrowUp($event)\"\n                    class=\"adf-search-autocomplete-item\"\n                    (click)=\"elementClicked(item)\"\n                    (keyup.enter)=\"elementClicked(item)\"\n                    (touchend)=\"elementClicked(item)\">\n                    <!-- This is a comment -->\n                    <mat-icon mat-list-icon>\n                        <img [alt]=\"getMimeType(item)\" [src]=\"getMimeTypeIcon(item)\"/>\n                    </mat-icon>\n                    <h4 mat-line id=\"result_name_{{idx}}\"\n                        *ngIf=\"highlight; else elseBlock\"\n                        class=\"adf-search-fixed-text\"\n                        [innerHtml]=\"item.entry.name | highlight: searchTerm\">\n                        {{ item?.entry.name }}\n                    </h4>\n                    <ng-template #elseBlock>\n                        <h4 class=\"adf-search-fixed-text\" mat-line id=\"result_name_{{idx}}\"\n                            [innerHtml]=\"item.entry.name\"></h4>\n                    </ng-template>\n                    <p mat-line class=\"adf-search-fixed-text\"> {{item?.entry.createdByUser.displayName}} </p>\n                </mat-list-item>\n                <mat-list-item id=\"search_no_result\"\n                            data-automation-id=\"search_no_result_found\"\n                            *ngIf=\"data?.list?.entries.length === 0\">\n                    <ng-content\n                        selector=\"adf-empty-search-result\"\n                        *ngIf=\"isNoSearchTemplatePresent() else defaultNoResult\">\n                    </ng-content>\n                    <ng-template #defaultNoResult>\n                        <p mat-line class=\"adf-search-fixed-text\">{{ 'SEARCH.RESULTS.NONE' | translate:{searchTerm:\n                            searchTerm} }}</p>\n                    </ng-template>\n                </mat-list-item>\n            </mat-list>\n        </ng-template>\n    </adf-search>\n</div>\n", styles: [".adf-search-result-autocomplete{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;transform-origin:top left;transform:translate(-40px);position:absolute;max-height:400px;margin-left:45px;margin-top:-22px;font-size:var(--theme-subheading-1-font-size);z-index:5;color:var(--adf-theme-foreground-text-color);background-color:var(--adf-theme-background-card-color);border-radius:2px}.adf-search-result-autocomplete:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}@media screen and (max-width: 959px){.adf-search-result-autocomplete{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}}.adf-search-autocomplete-item:hover{background-color:var(--adf-theme-background-hover-color);opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.AuthenticationService }, { type: i1.ThumbnailService }]; }, propDecorators: { highlight: [{
                type: Input
            }], inputType: [{
                type: Input
            }], liveSearchEnabled: [{
                type: Input
            }], autocomplete: [{
                type: Input
            }], expandable: [{
                type: Input
            }], liveSearchMaxResults: [{
                type: Input
            }], submit: [{
                type: Output
            }], searchChange: [{
                type: Output
            }], optionClicked: [{
                type: Output
            }], searchTextInput: [{
                type: ViewChild,
                args: ['searchTextInput']
            }], searchAutocomplete: [{
                type: ViewChild,
                args: ['search']
            }], listResultElement: [{
                type: ViewChildren,
                args: [MatListItem]
            }], emptySearchTemplate: [{
                type: ContentChild,
                args: [EmptySearchResultComponent]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchChipListComponent {
    constructor(facetFiltersService) {
        this.facetFiltersService = facetFiltersService;
        /** Flag used to enable the display of a clear-all-filters button. */
        this.clearAll = false;
    }
}
SearchChipListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchChipListComponent, deps: [{ token: SearchFacetFiltersService }], target: i0.ɵɵFactoryTarget.Component });
SearchChipListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchChipListComponent, selector: "adf-search-chip-list", inputs: { searchFilter: "searchFilter", clearAll: "clearAll" }, host: { classAttribute: "adf-search-chip-list" }, ngImport: i0, template: "<mat-chip-list>\n    <ng-container *ngIf=\"facetFiltersService.selectedBuckets.length\">\n        <mat-chip *ngIf=\"clearAll && facetFiltersService.selectedBuckets.length > 1\"\n            data-automation-id=\"reset-filter\"\n            color=\"primary\"\n            selected\n            matTooltip=\"{{ 'SEARCH.FILTER.BUTTONS.CLEAR-ALL.TOOLTIP' | translate }}\"\n            matTooltipPosition=\"right\"\n            (click)=\"facetFiltersService.resetAllSelectedBuckets()\">\n            {{ 'SEARCH.FILTER.BUTTONS.CLEAR-ALL.LABEL' | translate }}\n        </mat-chip>\n\n        <mat-chip\n            data-automation-id=\"chip-list-entry\"\n            *ngFor=\"let selection of facetFiltersService.selectedBuckets\"\n            [removable]=\"true\"\n            (removed)=\"facetFiltersService.unselectFacetBucket(selection.field, selection.bucket)\">\n            {{ (selection.bucket.display || selection.bucket.label) | translate }}\n            <mat-icon matChipRemove>cancel</mat-icon>\n        </mat-chip>\n    </ng-container>\n</mat-chip-list>\n", styles: [".mat-chip:focus{color:var(--theme-accent-color-default-contrast);background-color:var(--theme-accent-color)}.mat-chip:focus .mat-chip-remove{color:var(--theme-accent-color-default-contrast);opacity:1}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$2.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "directive", type: i3$2.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchChipListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-chip-list', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-chip-list' }, template: "<mat-chip-list>\n    <ng-container *ngIf=\"facetFiltersService.selectedBuckets.length\">\n        <mat-chip *ngIf=\"clearAll && facetFiltersService.selectedBuckets.length > 1\"\n            data-automation-id=\"reset-filter\"\n            color=\"primary\"\n            selected\n            matTooltip=\"{{ 'SEARCH.FILTER.BUTTONS.CLEAR-ALL.TOOLTIP' | translate }}\"\n            matTooltipPosition=\"right\"\n            (click)=\"facetFiltersService.resetAllSelectedBuckets()\">\n            {{ 'SEARCH.FILTER.BUTTONS.CLEAR-ALL.LABEL' | translate }}\n        </mat-chip>\n\n        <mat-chip\n            data-automation-id=\"chip-list-entry\"\n            *ngFor=\"let selection of facetFiltersService.selectedBuckets\"\n            [removable]=\"true\"\n            (removed)=\"facetFiltersService.unselectFacetBucket(selection.field, selection.bucket)\">\n            {{ (selection.bucket.display || selection.bucket.label) | translate }}\n            <mat-icon matChipRemove>cancel</mat-icon>\n        </mat-chip>\n    </ng-container>\n</mat-chip-list>\n", styles: [".mat-chip:focus{color:var(--theme-accent-color-default-contrast);background-color:var(--theme-accent-color)}.mat-chip:focus .mat-chip-remove{color:var(--theme-accent-color-default-contrast);opacity:1}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchFacetFiltersService }]; }, propDecorators: { searchFilter: [{
                type: Input
            }], clearAll: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchSortingPickerComponent {
    constructor(queryBuilder) {
        this.queryBuilder = queryBuilder;
        this.options = [];
    }
    ngOnInit() {
        this.options = this.queryBuilder.getSortingOptions();
        const primary = this.queryBuilder.getPrimarySorting();
        if (primary) {
            this.value = primary.key;
            this.ascending = primary.ascending;
        }
    }
    onValueChanged(key) {
        this.value = key;
        this.ascending = this.getSortingOrder();
        this.applySorting();
    }
    onSortingChanged(ascending) {
        this.ascending = ascending;
        this.applySorting();
    }
    findOptionByKey(key) {
        if (key) {
            return this.options.find((opt) => opt.key === key);
        }
        return null;
    }
    applySorting() {
        const option = this.findOptionByKey(this.value);
        if (option) {
            this.queryBuilder.sorting = [{
                    ...option,
                    ascending: this.ascending
                }];
            this.queryBuilder.update();
        }
    }
    getSortingOrder() {
        const option = this.findOptionByKey(this.value);
        if (option) {
            return option.ascending;
        }
        return this.queryBuilder.getPrimarySorting().ascending;
    }
}
SearchSortingPickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchSortingPickerComponent, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component });
SearchSortingPickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchSortingPickerComponent, selector: "adf-search-sorting-picker", host: { classAttribute: "adf-search-sorting-picker" }, ngImport: i0, template: "<adf-sorting-picker\n    [options]=\"options\"\n    [selected]=\"value\"\n    [ascending]=\"ascending\"\n    (valueChange)=\"onValueChanged($event)\"\n    (sortingChange)=\"onSortingChanged($event)\">\n</adf-sorting-picker>\n", styles: [".adf-search-sorting-picker .mat-icon-button{color:var(--adf-theme-foreground-text-color-054)}\n"], dependencies: [{ kind: "component", type: i1.SortingPickerComponent, selector: "adf-sorting-picker", inputs: ["options", "selected", "ascending"], outputs: ["valueChange", "sortingChange"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchSortingPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-sorting-picker', encapsulation: ViewEncapsulation.None, host: { class: 'adf-search-sorting-picker' }, template: "<adf-sorting-picker\n    [options]=\"options\"\n    [selected]=\"value\"\n    [ascending]=\"ascending\"\n    (valueChange)=\"onValueChanged($event)\"\n    (sortingChange)=\"onSortingChanged($event)\">\n</adf-sorting-picker>\n", styles: [".adf-search-sorting-picker .mat-icon-button{color:var(--adf-theme-foreground-text-color-054)}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFormComponent {
    constructor(queryBuilder) {
        this.queryBuilder = queryBuilder;
        /** Emitted when the form change */
        this.formChange = new EventEmitter();
    }
    onSelectionChange(form) {
        this.queryBuilder.updateSelectedConfiguration(form.index);
        this.formChange.emit(form);
    }
    getSelected(forms) {
        return forms.find((form) => form.selected)?.name;
    }
}
SearchFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFormComponent, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component });
SearchFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFormComponent, selector: "adf-search-form", outputs: { formChange: "formChange" }, ngImport: i0, template: "<ng-container *ngIf=\"queryBuilder.searchForms | async as forms\">\n\n    <ng-container *ngIf=\"forms.length === 1\">\n        <button class=\"adf-search-form\"\n                disableRipple mat-button\n                [title]=\"getSelected(forms) | translate\"\n                [attr.aria-label]=\"getSelected(forms) | translate\">\n            <span class=\"adf-search-form-title\">\n                    {{ getSelected(forms) | translate }}\n            </span>\n        </button>\n    </ng-container>\n\n    <ng-container  *ngIf=\"forms.length > 1\">\n        <button class=\"adf-search-form\"\n                [matMenuTriggerFor]=\"menu\"\n                #menuTrigger=\"matMenuTrigger\"\n                disableRipple\n                mat-button\n                [title]=\"getSelected(forms) | translate\"\n                [attr.aria-label]=\"getSelected(forms) | translate\"\n                [matMenuTriggerRestoreFocus]=\"true\">\n\n            <span class=\"adf-search-form-title\" >\n                    {{ getSelected(forms) | translate }}\n            </span>\n\n            <mat-icon [class.adf-search-form-icon-selected]=\"menuTrigger.menuOpen\" class=\"adf-search-form-icon\">expand_more</mat-icon>\n        </button>\n\n        <mat-menu #menu=\"matMenu\" backdropClass=\"adf-search-form-menu\">\n            <button *ngFor=\"let form of forms\"\n                    mat-menu-item\n                    tabindex=\"0\"\n                    [attr.aria-label]=\"form.name | translate\"\n                    (click)=\"onSelectionChange(form)\">\n                {{form.name | translate}}\n            </button>\n        </mat-menu>\n    </ng-container>\n</ng-container>\n", styles: [".adf-search-form.mat-button{height:35px;max-width:190px;min-width:190px;align-content:center;overflow:hidden}.adf-search-form.mat-button .mat-button-wrapper{display:flex;align-items:center}.adf-search-form-title{max-width:120px;min-width:120px;font-weight:700;font-size:var(--theme-body-1-font-size);line-height:24px;padding-right:12px;text-overflow:ellipsis;overflow:hidden;text-align:left}.adf-search-form-icon{border:2px solid transparent;border-radius:6px;transition:border .5s ease-out}.adf-search-form-icon-selected{border-color:var(--theme-accent-color)}.adf-search-form-menu+* .mat-menu-panel{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:6px}.adf-search-form-menu+* .mat-menu-panel .mat-menu-content{padding:0}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i6$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-form', encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"queryBuilder.searchForms | async as forms\">\n\n    <ng-container *ngIf=\"forms.length === 1\">\n        <button class=\"adf-search-form\"\n                disableRipple mat-button\n                [title]=\"getSelected(forms) | translate\"\n                [attr.aria-label]=\"getSelected(forms) | translate\">\n            <span class=\"adf-search-form-title\">\n                    {{ getSelected(forms) | translate }}\n            </span>\n        </button>\n    </ng-container>\n\n    <ng-container  *ngIf=\"forms.length > 1\">\n        <button class=\"adf-search-form\"\n                [matMenuTriggerFor]=\"menu\"\n                #menuTrigger=\"matMenuTrigger\"\n                disableRipple\n                mat-button\n                [title]=\"getSelected(forms) | translate\"\n                [attr.aria-label]=\"getSelected(forms) | translate\"\n                [matMenuTriggerRestoreFocus]=\"true\">\n\n            <span class=\"adf-search-form-title\" >\n                    {{ getSelected(forms) | translate }}\n            </span>\n\n            <mat-icon [class.adf-search-form-icon-selected]=\"menuTrigger.menuOpen\" class=\"adf-search-form-icon\">expand_more</mat-icon>\n        </button>\n\n        <mat-menu #menu=\"matMenu\" backdropClass=\"adf-search-form-menu\">\n            <button *ngFor=\"let form of forms\"\n                    mat-menu-item\n                    tabindex=\"0\"\n                    [attr.aria-label]=\"form.name | translate\"\n                    (click)=\"onSelectionChange(form)\">\n                {{form.name | translate}}\n            </button>\n        </mat-menu>\n    </ng-container>\n</ng-container>\n", styles: [".adf-search-form.mat-button{height:35px;max-width:190px;min-width:190px;align-content:center;overflow:hidden}.adf-search-form.mat-button .mat-button-wrapper{display:flex;align-items:center}.adf-search-form-title{max-width:120px;min-width:120px;font-weight:700;font-size:var(--theme-body-1-font-size);line-height:24px;padding-right:12px;text-overflow:ellipsis;overflow:hidden;text-align:left}.adf-search-form-icon{border:2px solid transparent;border-radius:6px;transition:border .5s ease-out}.adf-search-form-icon-selected{border-color:var(--theme-accent-color)}.adf-search-form-menu+* .mat-menu-panel{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f;border-radius:6px}.adf-search-form-menu+* .mat-menu-panel .mat-menu-content{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }]; }, propDecorators: { formChange: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFilterMenuCardComponent {
    constructor() {
        this.close = new EventEmitter();
    }
    onClose() {
        this.close.emit();
    }
}
SearchFilterMenuCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterMenuCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SearchFilterMenuCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFilterMenuCardComponent, selector: "adf-search-filter-menu-card", outputs: { close: "close" }, ngImport: i0, template: "<div class=\"adf-search-filter-menu-card\">\n    <div class=\"adf-search-filter-title\">\n        <ng-content select=\"filter-title\"></ng-content>\n        <button mat-icon-button\n            class=\"adf-search-filter-title-action\"\n            aria-hidden=\"false\"\n            [attr.aria-label]=\"'SEARCH.FILTER.BUTTONS.CLOSE' | translate\"\n            (click)=\"onClose()\"\n            [matTooltip]=\"'SEARCH.FILTER.BUTTONS.CLOSE' | translate\">\n            <mat-icon>\n                close\n            </mat-icon>\n        </button>\n    </div>\n\n    <mat-divider></mat-divider>\n\n    <div class=\"adf-search-filter-content\">\n        <ng-content select=\"filter-content\"></ng-content>\n    </div>\n\n    <mat-divider></mat-divider>\n\n    <div class=\"adf-search-filter-actions\">\n        <ng-content select=\"filter-actions\"></ng-content>\n    </div>\n</div>\n", styles: [".adf-search-filter-menu-card{color:var(--adf-theme-foreground-text-color);background:var(--adf-theme-background-card-color)}.adf-search-filter-menu-card .adf-search-filter-title{display:flex;justify-content:space-between;align-items:center;padding:16px 12px;height:32px;font-size:var(--theme-body-1-font-size);letter-spacing:.15px;font-weight:700;font-style:inherit}.adf-search-filter-menu-card .adf-search-filter-title-action{float:right}.adf-search-filter-menu-card .adf-search-filter-content{padding:16px 12px;overflow:auto}.adf-search-filter-menu-card .adf-search-filter-actions{padding:16px 12px;display:flex;justify-content:space-between}.adf-search-filter-menu-card .adf-search-filter-actions .adf-search-action-button{border-radius:6px}\n"], dependencies: [{ kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterMenuCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-filter-menu-card', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-search-filter-menu-card\">\n    <div class=\"adf-search-filter-title\">\n        <ng-content select=\"filter-title\"></ng-content>\n        <button mat-icon-button\n            class=\"adf-search-filter-title-action\"\n            aria-hidden=\"false\"\n            [attr.aria-label]=\"'SEARCH.FILTER.BUTTONS.CLOSE' | translate\"\n            (click)=\"onClose()\"\n            [matTooltip]=\"'SEARCH.FILTER.BUTTONS.CLOSE' | translate\">\n            <mat-icon>\n                close\n            </mat-icon>\n        </button>\n    </div>\n\n    <mat-divider></mat-divider>\n\n    <div class=\"adf-search-filter-content\">\n        <ng-content select=\"filter-content\"></ng-content>\n    </div>\n\n    <mat-divider></mat-divider>\n\n    <div class=\"adf-search-filter-actions\">\n        <ng-content select=\"filter-actions\"></ng-content>\n    </div>\n</div>\n", styles: [".adf-search-filter-menu-card{color:var(--adf-theme-foreground-text-color);background:var(--adf-theme-background-card-color)}.adf-search-filter-menu-card .adf-search-filter-title{display:flex;justify-content:space-between;align-items:center;padding:16px 12px;height:32px;font-size:var(--theme-body-1-font-size);letter-spacing:.15px;font-weight:700;font-style:inherit}.adf-search-filter-menu-card .adf-search-filter-title-action{float:right}.adf-search-filter-menu-card .adf-search-filter-content{padding:16px 12px;overflow:auto}.adf-search-filter-menu-card .adf-search-filter-actions{padding:16px 12px;display:flex;justify-content:space-between}.adf-search-filter-menu-card .adf-search-filter-actions .adf-search-action-button{border-radius:6px}\n"] }]
        }], propDecorators: { close: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchWidgetChipComponent {
    constructor(focusTrapFactory) {
        this.focusTrapFactory = focusTrapFactory;
        this.chipIcon = 'keyboard_arrow_down';
    }
    onMenuOpen() {
        if (this.menuContainer && !this.focusTrap) {
            this.focusTrap = this.focusTrapFactory.create(this.menuContainer.nativeElement);
        }
        this.chipIcon = 'keyboard_arrow_up';
    }
    onClosed() {
        this.focusTrap.destroy();
        this.focusTrap = null;
        this.chipIcon = 'keyboard_arrow_down';
    }
    onRemove() {
        this.widgetContainerComponent.resetInnerWidget();
        this.menuTrigger.closeMenu();
    }
    onApply() {
        this.widgetContainerComponent.applyInnerWidget();
        this.menuTrigger.closeMenu();
    }
    onEnterKeydown() {
        if (!this.menuTrigger.menuOpen) {
            this.menuTrigger.openMenu();
        }
        else {
            this.menuTrigger.closeMenu();
        }
    }
    onEscKeydown() {
        if (this.menuTrigger.menuOpen) {
            this.menuTrigger.closeMenu();
        }
    }
}
SearchWidgetChipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchWidgetChipComponent, deps: [{ token: i1$4.ConfigurableFocusTrapFactory }], target: i0.ɵɵFactoryTarget.Component });
SearchWidgetChipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchWidgetChipComponent, selector: "adf-search-widget-chip", inputs: { category: "category" }, viewQueries: [{ propertyName: "menuContainer", first: true, predicate: ["menuContainer"], descendants: true }, { propertyName: "menuTrigger", first: true, predicate: ["menuTrigger"], descendants: true }, { propertyName: "widgetContainerComponent", first: true, predicate: SearchWidgetContainerComponent, descendants: true }], ngImport: i0, template: "<mat-chip [attr.data-automation-id]=\"'search-filter-chip-' + category.name\"\n          disableRipple\n          class=\"adf-search-filter-chip\"\n          [class.adf-search-toggle-chip]=\"(widget.getDisplayValue() | async) || menuTrigger.menuOpen\"\n          tabIndex=\"0\"\n          [matMenuTriggerFor]=\"menu\"\n          (onMenuOpen)=\"onMenuOpen()\"\n          (keydown.enter)=\"onEnterKeydown()\"\n          (keydown.escape)=\"onEscKeydown()\"\n          [attr.title]=\"widget.getDisplayValue() | async\"\n          #menuTrigger=\"matMenuTrigger\">\n    <span class=\"adf-search-filter-placeholder\">\n        <span class=\"adf-search-filter-ellipsis\">{{ category.name | translate }}:</span>\n    </span>\n    <span class=\"adf-search-filter-ellipsis adf-filter-value\" *ngIf=\"widget.getDisplayValue() | async as displayValue; else showAny\">\n        &nbsp;{{ displayValue | translate }}\n    </span>\n    <ng-template #showAny><span class=\"adf-search-filter-ellipsis adf-filter-value\">&nbsp;{{ 'SEARCH.FILTER.ANY' | translate }}</span></ng-template>\n    <mat-icon>{{ chipIcon }}</mat-icon>\n</mat-chip>\n\n<mat-menu #menu=\"matMenu\" backdropClass=\"adf-search-filter-chip-menu\" (closed)=\"onClosed()\">\n    <div #menuContainer [attr.data-automation-id]=\"'search-field-' + category.name\">\n        <adf-search-filter-menu-card (click)=\"$event.stopPropagation()\"\n                                     (keydown.tab)=\"$event.stopPropagation();\"\n                                     (keydown.shift.tab)=\"$event.stopPropagation()\"\n                                     (close)=\"menuTrigger.closeMenu()\">\n\n            <ng-container ngProjectAs=\"filter-title\">\n                {{ category.name | translate }} <ng-container *ngIf=\"category.component.settings.unit\">({{category.component.settings.unit}})</ng-container>\n            </ng-container>\n\n            <ng-container ngProjectAs=\"filter-content\">\n                <adf-search-widget-container #widget\n                                             [id]=\"category.id\"\n                                             [selector]=\"category.component.selector\"\n                                             [settings]=\"category.component.settings\">\n                </adf-search-widget-container>\n            </ng-container>\n\n            <ng-container ngProjectAs=\"filter-actions\">\n                <button mat-button class=\"adf-search-action-button\" (click)=\"onRemove()\" id=\"cancel-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.CLEAR' | translate }}\n                </button>\n                <button mat-flat-button class=\"adf-search-action-button\" color=\"primary\" (click)=\"onApply()\" id=\"apply-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.APPLY' | translate }}\n                </button>\n            </ng-container>\n        </adf-search-filter-menu-card>\n    </div>\n</mat-menu>\n", dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: SearchWidgetContainerComponent, selector: "adf-search-widget-container", inputs: ["id", "selector", "settings", "config", "value"] }, { kind: "component", type: SearchFilterMenuCardComponent, selector: "adf-search-filter-menu-card", outputs: ["close"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchWidgetChipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-widget-chip', encapsulation: ViewEncapsulation.None, template: "<mat-chip [attr.data-automation-id]=\"'search-filter-chip-' + category.name\"\n          disableRipple\n          class=\"adf-search-filter-chip\"\n          [class.adf-search-toggle-chip]=\"(widget.getDisplayValue() | async) || menuTrigger.menuOpen\"\n          tabIndex=\"0\"\n          [matMenuTriggerFor]=\"menu\"\n          (onMenuOpen)=\"onMenuOpen()\"\n          (keydown.enter)=\"onEnterKeydown()\"\n          (keydown.escape)=\"onEscKeydown()\"\n          [attr.title]=\"widget.getDisplayValue() | async\"\n          #menuTrigger=\"matMenuTrigger\">\n    <span class=\"adf-search-filter-placeholder\">\n        <span class=\"adf-search-filter-ellipsis\">{{ category.name | translate }}:</span>\n    </span>\n    <span class=\"adf-search-filter-ellipsis adf-filter-value\" *ngIf=\"widget.getDisplayValue() | async as displayValue; else showAny\">\n        &nbsp;{{ displayValue | translate }}\n    </span>\n    <ng-template #showAny><span class=\"adf-search-filter-ellipsis adf-filter-value\">&nbsp;{{ 'SEARCH.FILTER.ANY' | translate }}</span></ng-template>\n    <mat-icon>{{ chipIcon }}</mat-icon>\n</mat-chip>\n\n<mat-menu #menu=\"matMenu\" backdropClass=\"adf-search-filter-chip-menu\" (closed)=\"onClosed()\">\n    <div #menuContainer [attr.data-automation-id]=\"'search-field-' + category.name\">\n        <adf-search-filter-menu-card (click)=\"$event.stopPropagation()\"\n                                     (keydown.tab)=\"$event.stopPropagation();\"\n                                     (keydown.shift.tab)=\"$event.stopPropagation()\"\n                                     (close)=\"menuTrigger.closeMenu()\">\n\n            <ng-container ngProjectAs=\"filter-title\">\n                {{ category.name | translate }} <ng-container *ngIf=\"category.component.settings.unit\">({{category.component.settings.unit}})</ng-container>\n            </ng-container>\n\n            <ng-container ngProjectAs=\"filter-content\">\n                <adf-search-widget-container #widget\n                                             [id]=\"category.id\"\n                                             [selector]=\"category.component.selector\"\n                                             [settings]=\"category.component.settings\">\n                </adf-search-widget-container>\n            </ng-container>\n\n            <ng-container ngProjectAs=\"filter-actions\">\n                <button mat-button class=\"adf-search-action-button\" (click)=\"onRemove()\" id=\"cancel-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.CLEAR' | translate }}\n                </button>\n                <button mat-flat-button class=\"adf-search-action-button\" color=\"primary\" (click)=\"onApply()\" id=\"apply-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.APPLY' | translate }}\n                </button>\n            </ng-container>\n        </adf-search-filter-menu-card>\n    </div>\n</mat-menu>\n" }]
        }], ctorParameters: function () { return [{ type: i1$4.ConfigurableFocusTrapFactory }]; }, propDecorators: { category: [{
                type: Input
            }], menuContainer: [{
                type: ViewChild,
                args: ['menuContainer', { static: false }]
            }], menuTrigger: [{
                type: ViewChild,
                args: ['menuTrigger', { static: false }]
            }], widgetContainerComponent: [{
                type: ViewChild,
                args: [SearchWidgetContainerComponent, { static: false }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFacetChipComponent {
    constructor(focusTrapFactory) {
        this.focusTrapFactory = focusTrapFactory;
        this.chipIcon = 'keyboard_arrow_down';
    }
    onMenuOpen() {
        if (this.menuContainer && !this.focusTrap) {
            this.focusTrap = this.focusTrapFactory.create(this.menuContainer.nativeElement);
        }
        this.chipIcon = 'keyboard_arrow_up';
    }
    onClosed() {
        this.focusTrap.destroy();
        this.focusTrap = null;
        this.chipIcon = 'keyboard_arrow_down';
    }
    onRemove() {
        this.facetFieldComponent.reset();
        this.menuTrigger.closeMenu();
    }
    onApply() {
        this.facetFieldComponent.submitValues();
        this.menuTrigger.closeMenu();
    }
    onEnterKeydown() {
        if (this.isPopulated()) {
            if (!this.menuTrigger.menuOpen) {
                this.menuTrigger.openMenu();
            }
            else {
                this.menuTrigger.closeMenu();
            }
        }
    }
    onEscKeydown() {
        if (this.menuTrigger.menuOpen) {
            this.menuTrigger.closeMenu();
        }
    }
    isPopulated() {
        return this.field.buckets?.items.length > 0;
    }
}
SearchFacetChipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetChipComponent, deps: [{ token: i1$4.ConfigurableFocusTrapFactory }], target: i0.ɵɵFactoryTarget.Component });
SearchFacetChipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFacetChipComponent, selector: "adf-search-facet-chip", inputs: { field: "field" }, viewQueries: [{ propertyName: "menuContainer", first: true, predicate: ["menuContainer"], descendants: true }, { propertyName: "menuTrigger", first: true, predicate: ["menuTrigger"], descendants: true }, { propertyName: "facetFieldComponent", first: true, predicate: SearchFacetFieldComponent, descendants: true }], ngImport: i0, template: "<mat-chip [attr.data-automation-id]=\"'search-filter-chip-' + field.label\"\n          disableRipple\n          class=\"adf-search-filter-chip\"\n          [class.adf-search-toggle-chip]=\"(facetField.displayValue$ | async) || menuTrigger.menuOpen\"\n          [disabled]=\"!isPopulated()\"\n          tabIndex=\"0\"\n          [matMenuTriggerFor]=\"menu\"\n          (onMenuOpen)=\"onMenuOpen()\"\n          (keydown.enter)=\"onEnterKeydown()\"\n          (keydown.escape)=\"onEscKeydown()\"\n          [attr.title]=\"facetField.displayValue$ | async\"\n          #menuTrigger=\"matMenuTrigger\">\n\n    <span class=\"adf-search-filter-placeholder\">\n        <span class=\"adf-search-filter-ellipsis\">{{ field.label | translate }}:</span>\n    </span>\n\n    <span class=\"adf-search-filter-ellipsis adf-filter-value\" *ngIf=\"facetField.displayValue$ | async as displayValue; else showAny\">\n        &nbsp; {{ displayValue | translate }}\n    </span>\n    <ng-template #showAny><span class=\"adf-search-filter-ellipsis adf-filter-value\">&nbsp;{{ 'SEARCH.FILTER.ANY' | translate }}</span></ng-template>\n    <mat-icon *ngIf=\"isPopulated(); else disabledIcon\">{{ chipIcon }}</mat-icon>\n    <ng-template #disabledIcon>\n        <mat-icon>remove</mat-icon>\n    </ng-template>\n</mat-chip>\n\n<mat-menu #menu=\"matMenu\" backdropClass=\"adf-search-filter-chip-menu\" (closed)=\"onClosed()\">\n    <div #menuContainer [attr.data-automation-id]=\"'search-field-' + field.label\">\n        <adf-search-filter-menu-card (click)=\"$event.stopPropagation()\"\n                                     (keydown.tab)=\"$event.stopPropagation();\"\n                                     (keydown.shift.tab)=\"$event.stopPropagation()\"\n                                     (close)=\"menuTrigger.closeMenu()\">\n            <ng-container ngProjectAs=\"filter-title\">\n                {{ field.label | translate }}\n            </ng-container>\n            <ng-container ngProjectAs=\"filter-content\">\n                <adf-search-facet-field [field]=\"field\" #facetField></adf-search-facet-field>\n            </ng-container>\n            <ng-container ngProjectAs=\"filter-actions\">\n                <button mat-button class=\"adf-search-action-button\" (click)=\"onRemove()\" id=\"cancel-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.CLEAR' | translate }}\n                </button>\n                <button mat-flat-button class=\"adf-search-action-button\" color=\"primary\" (click)=\"onApply()\" id=\"apply-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.APPLY' | translate }}\n                </button>\n            </ng-container>\n        </adf-search-filter-menu-card>\n    </div>\n</mat-menu>\n", styles: [".adf-search-filter-chip[disabled]{pointer-events:none}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i3$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: SearchFilterMenuCardComponent, selector: "adf-search-filter-menu-card", outputs: ["close"] }, { kind: "component", type: SearchFacetFieldComponent, selector: "adf-search-facet-field", inputs: ["field"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFacetChipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-facet-chip', encapsulation: ViewEncapsulation.None, template: "<mat-chip [attr.data-automation-id]=\"'search-filter-chip-' + field.label\"\n          disableRipple\n          class=\"adf-search-filter-chip\"\n          [class.adf-search-toggle-chip]=\"(facetField.displayValue$ | async) || menuTrigger.menuOpen\"\n          [disabled]=\"!isPopulated()\"\n          tabIndex=\"0\"\n          [matMenuTriggerFor]=\"menu\"\n          (onMenuOpen)=\"onMenuOpen()\"\n          (keydown.enter)=\"onEnterKeydown()\"\n          (keydown.escape)=\"onEscKeydown()\"\n          [attr.title]=\"facetField.displayValue$ | async\"\n          #menuTrigger=\"matMenuTrigger\">\n\n    <span class=\"adf-search-filter-placeholder\">\n        <span class=\"adf-search-filter-ellipsis\">{{ field.label | translate }}:</span>\n    </span>\n\n    <span class=\"adf-search-filter-ellipsis adf-filter-value\" *ngIf=\"facetField.displayValue$ | async as displayValue; else showAny\">\n        &nbsp; {{ displayValue | translate }}\n    </span>\n    <ng-template #showAny><span class=\"adf-search-filter-ellipsis adf-filter-value\">&nbsp;{{ 'SEARCH.FILTER.ANY' | translate }}</span></ng-template>\n    <mat-icon *ngIf=\"isPopulated(); else disabledIcon\">{{ chipIcon }}</mat-icon>\n    <ng-template #disabledIcon>\n        <mat-icon>remove</mat-icon>\n    </ng-template>\n</mat-chip>\n\n<mat-menu #menu=\"matMenu\" backdropClass=\"adf-search-filter-chip-menu\" (closed)=\"onClosed()\">\n    <div #menuContainer [attr.data-automation-id]=\"'search-field-' + field.label\">\n        <adf-search-filter-menu-card (click)=\"$event.stopPropagation()\"\n                                     (keydown.tab)=\"$event.stopPropagation();\"\n                                     (keydown.shift.tab)=\"$event.stopPropagation()\"\n                                     (close)=\"menuTrigger.closeMenu()\">\n            <ng-container ngProjectAs=\"filter-title\">\n                {{ field.label | translate }}\n            </ng-container>\n            <ng-container ngProjectAs=\"filter-content\">\n                <adf-search-facet-field [field]=\"field\" #facetField></adf-search-facet-field>\n            </ng-container>\n            <ng-container ngProjectAs=\"filter-actions\">\n                <button mat-button class=\"adf-search-action-button\" (click)=\"onRemove()\" id=\"cancel-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.CLEAR' | translate }}\n                </button>\n                <button mat-flat-button class=\"adf-search-action-button\" color=\"primary\" (click)=\"onApply()\" id=\"apply-filter-button\">\n                    {{ 'SEARCH.FILTER.BUTTONS.APPLY' | translate }}\n                </button>\n            </ng-container>\n        </adf-search-filter-menu-card>\n    </div>\n</mat-menu>\n", styles: [".adf-search-filter-chip[disabled]{pointer-events:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.ConfigurableFocusTrapFactory }]; }, propDecorators: { field: [{
                type: Input
            }], menuContainer: [{
                type: ViewChild,
                args: ['menuContainer', { static: false }]
            }], menuTrigger: [{
                type: ViewChild,
                args: ['menuTrigger', { static: false }]
            }], facetFieldComponent: [{
                type: ViewChild,
                args: [SearchFacetFieldComponent, { static: false }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchFilterChipsComponent {
    constructor(queryBuilder, facetFiltersService) {
        this.queryBuilder = queryBuilder;
        this.facetFiltersService = facetFiltersService;
        /** Toggles whether to show or not the context facet filters. */
        this.showContextFacets = true;
    }
}
SearchFilterChipsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterChipsComponent, deps: [{ token: SEARCH_QUERY_SERVICE_TOKEN }, { token: SearchFacetFiltersService }], target: i0.ɵɵFactoryTarget.Component });
SearchFilterChipsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: SearchFilterChipsComponent, selector: "adf-search-filter-chips", inputs: { showContextFacets: "showContextFacets" }, ngImport: i0, template: "<mat-chip-list role=\"listbox\" [attr.aria-label]=\"'SEARCH.FILTER.ARIA-LABEL.SEARCH_FILTER' | translate\">\n    <ng-container *ngFor=\"let category of queryBuilder.categories\">\n        <adf-search-widget-chip [category]=\"category\"></adf-search-widget-chip>\n    </ng-container>\n\n    <ng-container *ngIf=\"facetFiltersService.responseFacets && showContextFacets\">\n        <ng-container *ngFor=\"let field of facetFiltersService.responseFacets\">\n            <adf-search-facet-chip [field]=\"field\" [attr.data-automation-id]=\"'search-fact-chip-' + field.field\" ></adf-search-facet-chip>\n        </ng-container>\n    </ng-container>\n</mat-chip-list>\n", styles: [".adf-search-filter-chip.mat-chip{border:2px solid transparent;transition:border .5s ease-in-out;max-width:320px;text-overflow:ellipsis;overflow:hidden;background:var(--adf-theme-background-unselected-chip-color)}.adf-search-filter-chip.mat-chip:focus{color:unset}.adf-search-filter-chip.mat-chip.mat-standard-chip:after{background:var(--adf-theme-background-unselected-chip-color);color:unset}.adf-search-filter-chip.mat-chip.mat-chip-list-wrapper{margin:4px 6px}.adf-search-filter-chip.adf-search-toggle-chip{background:var(--adf-theme-background-card-color);border:2px solid var(--theme-primary-color)}.adf-search-filter-chip.adf-search-toggle-chip.mat-chip:after{background:unset}.adf-search-filter-chip .adf-search-filter-placeholder{flex:1 1 auto;white-space:nowrap;color:var(--adf-theme-foreground-disabled-text-color)}.adf-search-filter-chip .adf-search-filter-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:300}.adf-search-filter-chip .adf-filter-value{font-weight:500}.adf-search-filter-chip .mat-icon{padding-top:5px;padding-left:5px}.adf-search-filter-chip-menu+* .cdk-overlay-pane .mat-menu-panel{min-width:320px;border-radius:12px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$2.MatChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "component", type: SearchWidgetChipComponent, selector: "adf-search-widget-chip", inputs: ["category"] }, { kind: "component", type: SearchFacetChipComponent, selector: "adf-search-facet-chip", inputs: ["field"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchFilterChipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-search-filter-chips', encapsulation: ViewEncapsulation.None, template: "<mat-chip-list role=\"listbox\" [attr.aria-label]=\"'SEARCH.FILTER.ARIA-LABEL.SEARCH_FILTER' | translate\">\n    <ng-container *ngFor=\"let category of queryBuilder.categories\">\n        <adf-search-widget-chip [category]=\"category\"></adf-search-widget-chip>\n    </ng-container>\n\n    <ng-container *ngIf=\"facetFiltersService.responseFacets && showContextFacets\">\n        <ng-container *ngFor=\"let field of facetFiltersService.responseFacets\">\n            <adf-search-facet-chip [field]=\"field\" [attr.data-automation-id]=\"'search-fact-chip-' + field.field\" ></adf-search-facet-chip>\n        </ng-container>\n    </ng-container>\n</mat-chip-list>\n", styles: [".adf-search-filter-chip.mat-chip{border:2px solid transparent;transition:border .5s ease-in-out;max-width:320px;text-overflow:ellipsis;overflow:hidden;background:var(--adf-theme-background-unselected-chip-color)}.adf-search-filter-chip.mat-chip:focus{color:unset}.adf-search-filter-chip.mat-chip.mat-standard-chip:after{background:var(--adf-theme-background-unselected-chip-color);color:unset}.adf-search-filter-chip.mat-chip.mat-chip-list-wrapper{margin:4px 6px}.adf-search-filter-chip.adf-search-toggle-chip{background:var(--adf-theme-background-card-color);border:2px solid var(--theme-primary-color)}.adf-search-filter-chip.adf-search-toggle-chip.mat-chip:after{background:unset}.adf-search-filter-chip .adf-search-filter-placeholder{flex:1 1 auto;white-space:nowrap;color:var(--adf-theme-foreground-disabled-text-color)}.adf-search-filter-chip .adf-search-filter-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:300}.adf-search-filter-chip .adf-filter-value{font-weight:500}.adf-search-filter-chip .mat-icon{padding-top:5px;padding-left:5px}.adf-search-filter-chip-menu+* .cdk-overlay-pane .mat-menu-panel{min-width:320px;border-radius:12px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchQueryBuilderService, decorators: [{
                    type: Inject,
                    args: [SEARCH_QUERY_SERVICE_TOKEN]
                }] }, { type: SearchFacetFiltersService }]; }, propDecorators: { showContextFacets: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SearchModule {
}
SearchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SearchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SearchModule, declarations: [SearchComponent,
        SearchControlComponent,
        EmptySearchResultComponent,
        SearchFilterComponent,
        SearchChipListComponent,
        SearchWidgetContainerComponent,
        SearchTextComponent,
        SearchChipAutocompleteInputComponent,
        SearchFilterAutocompleteChipsComponent,
        SearchRadioComponent,
        SearchSliderComponent,
        SearchNumberRangeComponent,
        SearchPanelComponent,
        SearchCheckListComponent,
        SearchDateRangeComponent,
        SearchDatetimeRangeComponent,
        SearchSortingPickerComponent,
        SearchFilterContainerComponent,
        SearchFormComponent,
        SearchFilterChipsComponent,
        SearchFilterMenuCardComponent,
        SearchFacetFieldComponent,
        SearchWidgetChipComponent,
        SearchFacetChipComponent,
        SearchChipInputComponent,
        SearchLogicalFilterComponent,
        ResetSearchDirective], imports: [CommonModule,
        ContentPipeModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        CoreModule,
        SearchTextModule], exports: [SearchComponent,
        SearchControlComponent,
        EmptySearchResultComponent,
        SearchFilterComponent,
        SearchChipListComponent,
        SearchWidgetContainerComponent,
        SearchTextComponent,
        SearchChipAutocompleteInputComponent,
        SearchFilterAutocompleteChipsComponent,
        SearchRadioComponent,
        SearchSliderComponent,
        SearchNumberRangeComponent,
        SearchPanelComponent,
        SearchCheckListComponent,
        SearchDateRangeComponent,
        SearchDatetimeRangeComponent,
        SearchSortingPickerComponent,
        SearchFilterContainerComponent,
        SearchFormComponent,
        SearchFilterChipsComponent,
        SearchFilterMenuCardComponent,
        SearchFacetFieldComponent,
        SearchChipInputComponent,
        SearchLogicalFilterComponent,
        ResetSearchDirective] });
SearchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchModule, providers: [
        { provide: SEARCH_QUERY_SERVICE_TOKEN, useExisting: SearchQueryBuilderService }
    ], imports: [CommonModule,
        ContentPipeModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        CoreModule,
        SearchTextModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ContentPipeModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MaterialModule,
                        CoreModule,
                        SearchTextModule
                    ],
                    declarations: [
                        SearchComponent,
                        SearchControlComponent,
                        EmptySearchResultComponent,
                        SearchFilterComponent,
                        SearchChipListComponent,
                        SearchWidgetContainerComponent,
                        SearchTextComponent,
                        SearchChipAutocompleteInputComponent,
                        SearchFilterAutocompleteChipsComponent,
                        SearchRadioComponent,
                        SearchSliderComponent,
                        SearchNumberRangeComponent,
                        SearchPanelComponent,
                        SearchCheckListComponent,
                        SearchDateRangeComponent,
                        SearchDatetimeRangeComponent,
                        SearchSortingPickerComponent,
                        SearchFilterContainerComponent,
                        SearchFormComponent,
                        SearchFilterChipsComponent,
                        SearchFilterMenuCardComponent,
                        SearchFacetFieldComponent,
                        SearchWidgetChipComponent,
                        SearchFacetChipComponent,
                        SearchChipInputComponent,
                        SearchLogicalFilterComponent,
                        ResetSearchDirective
                    ],
                    exports: [
                        SearchComponent,
                        SearchControlComponent,
                        EmptySearchResultComponent,
                        SearchFilterComponent,
                        SearchChipListComponent,
                        SearchWidgetContainerComponent,
                        SearchTextComponent,
                        SearchChipAutocompleteInputComponent,
                        SearchFilterAutocompleteChipsComponent,
                        SearchRadioComponent,
                        SearchSliderComponent,
                        SearchNumberRangeComponent,
                        SearchPanelComponent,
                        SearchCheckListComponent,
                        SearchDateRangeComponent,
                        SearchDatetimeRangeComponent,
                        SearchSortingPickerComponent,
                        SearchFilterContainerComponent,
                        SearchFormComponent,
                        SearchFilterChipsComponent,
                        SearchFilterMenuCardComponent,
                        SearchFacetFieldComponent,
                        SearchChipInputComponent,
                        SearchLogicalFilterComponent,
                        ResetSearchDirective
                    ],
                    providers: [
                        { provide: SEARCH_QUERY_SERVICE_TOKEN, useExisting: SearchQueryBuilderService }
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DocumentListModule {
}
DocumentListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DocumentListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DocumentListModule, declarations: [DocumentListComponent,
        TrashcanNameColumnComponent,
        LibraryStatusColumnComponent,
        LibraryRoleColumnComponent,
        LibraryNameColumnComponent,
        NameColumnComponent,
        ContentActionComponent,
        ContentActionListComponent,
        FilterHeaderComponent,
        FileAutoDownloadComponent], imports: [CoreModule,
        CommonModule,
        ContentPipeModule,
        MaterialModule,
        UploadModule,
        EditJsonDialogModule,
        SearchModule,
        ContentDirectiveModule], exports: [DocumentListComponent,
        TrashcanNameColumnComponent,
        LibraryStatusColumnComponent,
        LibraryRoleColumnComponent,
        LibraryNameColumnComponent,
        NameColumnComponent,
        ContentActionComponent,
        ContentActionListComponent,
        FilterHeaderComponent] });
DocumentListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListModule, imports: [CoreModule,
        CommonModule,
        ContentPipeModule,
        MaterialModule,
        UploadModule,
        EditJsonDialogModule,
        SearchModule,
        ContentDirectiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DocumentListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CoreModule,
                        CommonModule,
                        ContentPipeModule,
                        MaterialModule,
                        UploadModule,
                        EditJsonDialogModule,
                        SearchModule,
                        ContentDirectiveModule
                    ],
                    declarations: [
                        DocumentListComponent,
                        TrashcanNameColumnComponent,
                        LibraryStatusColumnComponent,
                        LibraryRoleColumnComponent,
                        LibraryNameColumnComponent,
                        NameColumnComponent,
                        ContentActionComponent,
                        ContentActionListComponent,
                        FilterHeaderComponent,
                        FileAutoDownloadComponent
                    ],
                    exports: [
                        DocumentListComponent,
                        TrashcanNameColumnComponent,
                        LibraryStatusColumnComponent,
                        LibraryRoleColumnComponent,
                        LibraryNameColumnComponent,
                        NameColumnComponent,
                        ContentActionComponent,
                        ContentActionListComponent,
                        FilterHeaderComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EcmUserModel {
    constructor(obj) {
        this.id = obj && obj.id || null;
        this.firstName = obj && obj.firstName;
        this.lastName = obj && obj.lastName;
        this.description = obj && obj.description || null;
        this.avatarId = obj && obj.avatarId || null;
        this.email = obj && obj.email || null;
        this.skypeId = obj && obj.skypeId;
        this.googleId = obj && obj.googleId;
        this.instantMessageId = obj && obj.instantMessageId;
        this.jobTitle = obj && obj.jobTitle || null;
        this.location = obj && obj.location || null;
        this.company = obj && obj.company;
        this.mobile = obj && obj.mobile;
        this.telephone = obj && obj.telephone;
        this.statusUpdatedAt = obj && obj.statusUpdatedAt;
        this.userStatus = obj && obj.userStatus;
        this.enabled = obj && obj.enabled;
        this.emailNotificationsEnabled = obj && obj.emailNotificationsEnabled;
        this.aspectNames = obj && obj.aspectNames;
        this.properties = obj && obj.properties;
        this.capabilities = obj && obj.capabilities;
    }
    isAdmin() {
        return this.capabilities?.isAdmin;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var ContentGroups;
(function (ContentGroups) {
    ContentGroups["ALFRESCO_ADMINISTRATORS"] = "ALFRESCO_ADMINISTRATORS";
})(ContentGroups || (ContentGroups = {}));
class PeopleContentService {
    constructor(apiService, authenticationService, logService, contentService) {
        this.apiService = apiService;
        this.logService = logService;
        this.contentService = contentService;
        authenticationService.onLogout.subscribe(() => {
            this.resetLocalCurrentUser();
        });
    }
    get peopleApi() {
        this._peopleApi = this._peopleApi ?? new PeopleApi(this.apiService.getInstance());
        return this._peopleApi;
    }
    /**
     * Gets information about a user identified by their username.
     *
     * @param personId ID of the target user
     * @returns User information
     */
    getPerson(personId) {
        return from(this.peopleApi.getPerson(personId))
            .pipe(map((personEntry) => new EcmUserModel(personEntry.entry)), tap(user => this.currentUser = user), catchError((error) => this.handleError(error)));
    }
    getCurrentPerson() {
        return this.getCurrentUserInfo();
    }
    /**
     * Gets information about the current user alias -me-
     *
     * @returns User information
     */
    getCurrentUserInfo() {
        if (this.currentUser) {
            return of(this.currentUser);
        }
        return this.getPerson('-me-');
    }
    /**
     * Used to know if the current user has the admin capability
     *
     * @returns true or false
     */
    isCurrentUserAdmin() {
        return this.currentUser?.isAdmin() ?? false;
    }
    /**
     * Reset the local current user object
     */
    resetLocalCurrentUser() {
        this.currentUser = undefined;
    }
    /**
     * Gets a list of people.
     *
     * @param requestQuery maxItems and skipCount parameters supported by JS-API
     * @returns Response containing pagination and list of entries
     */
    listPeople(requestQuery) {
        const requestQueryParams = { skipCount: requestQuery?.skipCount, maxItems: requestQuery?.maxItems };
        const orderBy = this.buildOrderArray(requestQuery?.sorting);
        if (orderBy.length) {
            requestQueryParams['orderBy'] = orderBy;
        }
        const promise = this.peopleApi.listPeople(requestQueryParams);
        return from(promise).pipe(map(response => ({
            pagination: response.list.pagination,
            entries: response.list.entries.map((person) => person.entry)
        })), catchError((err) => this.handleError(err)));
    }
    /**
     * Creates new person.
     *
     * @param newPerson Object containing the new person details.
     * @param opts Optional parameters
     * @returns Created new person
     */
    createPerson(newPerson, opts) {
        return from(this.peopleApi.createPerson(newPerson, opts)).pipe(map((res) => res?.entry), catchError((error) => this.handleError(error)));
    }
    /**
     * Updates the person details
     *
     * @param personId The identifier of a person
     * @param details The person details
     * @param opts Optional parameters
     * @returns Updated person model
     */
    updatePerson(personId, details, opts) {
        return from(this.peopleApi.updatePerson(personId, details, opts)).pipe(map((res) => res?.entry), catchError((error) => this.handleError(error)));
    }
    /**
     * Returns a profile image as a URL.
     *
     * @param avatarId Target avatar
     * @returns Image URL
     */
    getUserProfileImage(avatarId) {
        return this.contentService.getContentUrl(avatarId);
    }
    buildOrderArray(sorting) {
        return sorting?.orderBy && sorting?.direction ? [`${sorting.orderBy} ${sorting.direction.toUpperCase()}`] : [];
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
}
PeopleContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PeopleContentService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.AuthenticationService }, { token: i1.LogService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Injectable });
PeopleContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PeopleContentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PeopleContentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.AuthenticationService }, { type: i1.LogService }, { type: ContentService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentUserInfoComponent {
    constructor(peopleContentService) {
        this.peopleContentService = peopleContentService;
        /** current mode. */
        this.mode = UserInfoMode.CONTENT;
        /** Custom path for the background banner image for ACS users. */
        this.ecmBackgroundImage = './assets/images/ecm-background.png';
        /** Custom path for the background banner image for APS users. */
        this.bpmBackgroundImage = './assets/images/bpm-background.png';
        /** Custom choice for opening the menu at the bottom. Can be `before` or `after`. */
        this.menuPositionX = 'after';
        /** Custom choice for opening the menu at the bottom. Can be `above` or `below`. */
        this.menuPositionY = 'below';
        /** Shows/hides the username next to the user info button. */
        this.showName = true;
        /** When the username is shown, this defines its position relative to the user info button.
         * Can be `right` or `left`.
         */
        this.namePosition = 'right';
        this.userInfoMode = UserInfoMode;
        this.destroy$ = new Subject();
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    onKeyPress(event) {
        this.closeUserModal(event);
    }
    closeUserModal($event) {
        if ($event.keyCode === 27) {
            this.trigger.closeMenu();
        }
    }
    stopClosing(event) {
        event.stopPropagation();
    }
    getEcmAvatar(avatarId) {
        return this.peopleContentService.getUserProfileImage(avatarId);
    }
    get showOnRight() {
        return this.namePosition === 'right';
    }
    get canShow() {
        return this.isLoggedIn && !!this.ecmUser && !!this.mode;
    }
}
ContentUserInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentUserInfoComponent, deps: [{ token: PeopleContentService }], target: i0.ɵɵFactoryTarget.Component });
ContentUserInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentUserInfoComponent, selector: "adf-content-user-info", inputs: { isLoggedIn: "isLoggedIn", ecmUser: "ecmUser", identityUser: "identityUser", mode: "mode", ecmBackgroundImage: "ecmBackgroundImage", bpmBackgroundImage: "bpmBackgroundImage", menuPositionX: "menuPositionX", menuPositionY: "menuPositionY", showName: "showName", namePosition: "namePosition" }, viewQueries: [{ propertyName: "trigger", first: true, predicate: MatMenuTrigger, descendants: true }], ngImport: i0, template: "<div \n    id=\"userinfo_container\" \n    [class.adf-userinfo-name-right]=\"showOnRight\" \n    (keyup)=\"onKeyPress($event)\"\n    class=\"adf-userinfo-container\" \n    *ngIf=\"canShow\"\n>\n    <span *ngIf=\"showName\" id=\"adf-userinfo-ecm-name-display\" class=\"adf-userinfo-name\">\n        {{ecmUser | fullName}}\n    </span>\n    <button mat-button [matMenuTriggerFor]=\"menu\" class=\"adf-userinfo-menu_button\"\n            data-automation-id=\"adf-user-profile\">\n        <div class=\"adf-userinfo-button-profile\" id=\"user-profile\">\n            <div *ngIf=\"identityUser; else showEcmUserImage\" id=\"identity-user-image\">\n                <div *ngIf=\"ecmUser?.avatarId; else initialTemplate\">\n                    <div class=\"adf-userinfo-profile-container\">\n                        <img id=\"logged-user-img\" [src]=\"getEcmAvatar(ecmUser.avatarId)\" alt=\"user-info-profile-button\"\n                             class=\"adf-userinfo-profile-image\"/>\n                    </div>\n                </div>\n                <ng-template #initialTemplate>\n                    <div [innerHTML]=\"identityUser | usernameInitials:'adf-userinfo-pic'\"></div>\n                </ng-template>\n            </div>\n            <ng-template #showEcmUserImage>\n                <div id=\"ecm-user-image\">\n                    <div *ngIf=\"ecmUser.avatarId; else initialTemplate\" class=\"adf-userinfo-profile-container\">\n                        <img id=\"logged-user-img\" [src]=\"getEcmAvatar(ecmUser.avatarId)\" alt=\"user-info-profile-button\"\n                             class=\"adf-userinfo-profile-image\"/>\n                    </div>\n                    <ng-template #initialTemplate>\n                        <div [outerHTML]=\"ecmUser | usernameInitials:'adf-userinfo-pic'\"></div>\n                    </ng-template>\n                </div>\n            </ng-template>\n        </div>\n    </button>\n\n    <mat-menu #menu=\"matMenu\" id=\"user-profile-lists\" [xPosition]=\"menuPositionX\" [yPosition]=\"menuPositionY\"\n              [overlapTrigger]=\"false\" class=\"adf-userinfo-menu\">\n        <mat-tab-group id=\"tab-group-env\" (click)=\"stopClosing($event)\" selectedIndex=\"0\" role=\"menuitem\"\n                       class=\"adf-userinfo-tab adf-hide-tab\">\n            <mat-tab label=\"{{ 'USER_PROFILE.TAB.CS' | translate }}\" role=\"dialog\"\n                     *ngIf=\"mode === userInfoMode.CONTENT\">\n                <mat-card class=\"adf-userinfo-card\">\n                    <mat-card-header class=\"adf-userinfo-card-header\"\n                                     [style.background-image]=\"'url(' + ecmBackgroundImage + ')'\">\n                        <div *ngIf=\"ecmUser.avatarId; else initialTemplate\"\n                             class=\"adf-userinfo-profile-container adf-hide-small\">\n                            <img class=\"adf-userinfo-profile-picture\" id=\"ecm-user-detail-image\"\n                                 alt=\"ecm-profile-image\" [src]=\"getEcmAvatar(ecmUser.avatarId)\"/>\n                        </div>\n                        <ng-template #initialTemplate>\n                            <div\n                                [outerHTML]=\"ecmUser | usernameInitials:'adf-userinfo-profile-initials adf-hide-small'\"></div>\n                        </ng-template>\n\n                        <div class=\"adf-userinfo-title\" id=\"ecm-username\">{{ecmUser | fullName}}</div>\n                    </mat-card-header>\n                    <mat-card-content>\n                        <div class=\"adf-userinfo-supporting-text\">\n                            <div class=\"adf-userinfo-detail\">\n                                <span id=\"ecm-full-name\"\n                                      class=\"adf-userinfo__detail-title\">{{ecmUser | fullName}}</span>\n                                <span class=\"adf-userinfo__detail-profile\" id=\"ecm-email\"> {{ecmUser.email}} </span>\n                                <a class=\"adf-userinfo__detail-profile\" href=\"#/profile\">\n                                    {{ 'USER_PROFILE.LABELS.MY_PROFILE' | translate }}</a>\n                            </div>\n                            <div class=\"adf-userinfo-detail\">\n                                    <span class=\"adf-userinfo__secondary-info\" id=\"ecm-job-title-label\">\n                                        {{ 'USER_PROFILE.LABELS.ECM.JOB_TITLE' | translate }}\n                                        <span id=\"ecm-job-title\"\n                                              class=\"adf-userinfo__detail-profile\"> {{ ecmUser.jobTitle ? ecmUser.jobTitle : 'N/A' }} </span>\n                                    </span>\n                            </div>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </mat-tab>\n            <mat-tab id=\"identity-panel\" role=\"dialog\" *ngIf=\"mode === userInfoMode.CONTENT_SSO\">\n                <mat-card class=\"adf-userinfo-card\">\n                    <mat-card-header class=\"adf-userinfo-card-header\"\n                                     [style.background-image]=\"'url(' + bpmBackgroundImage + ')'\">\n                        <div *ngIf=\"ecmUser.avatarId; else initialTemplate\"\n                                class=\"adf-userinfo-profile-container adf-hide-small\">\n                            <img class=\"adf-userinfo-profile-picture\" id=\"ecm-user-detail-image\"\n                                    alt=\"ecm-profile-image\" [src]=\"getEcmAvatar(ecmUser.avatarId)\"/>\n                        </div>\n                        <ng-template #initialTemplate>\n                            <div\n                                [outerHTML]=\"identityUser | usernameInitials:'adf-userinfo-profile-initials adf-hide-small'\"></div>\n                        </ng-template>\n                        <div class=\"adf-userinfo-title\" id=\"identity-username\">{{identityUser | fullName}}</div>\n                    </mat-card-header>\n                    <mat-card-content>\n                        <div class=\"adf-userinfo-supporting-text\">\n                            <div class=\"adf-userinfo-detail\">\n                                <span id=\"identity-full-name\"\n                                      class=\"adf-userinfo__detail-title\">{{identityUser | fullName}}</span>\n                                <span class=\"adf-userinfo__detail-profile\"\n                                      id=\"identity-email\"> {{identityUser.email}} </span>\n                                <a class=\"adf-userinfo__detail-profile\" href=\"#/profile\">\n                                      {{ 'USER_PROFILE.LABELS.MY_PROFILE' | translate }}</a>\n                            </div>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </mat-tab>\n        </mat-tab-group>\n    </mat-menu>\n</div>\n", styles: [".adf-userinfo-container{display:flex;align-items:center;padding:0 5px}.adf-userinfo-name-right{flex-direction:row-reverse}.adf-userinfo-name{padding:0 5px}@media screen and (max-width: 959px){.adf-userinfo-name{display:none}}.adf-userinfo-pic{background:var(--adf-theme-primary-300);display:inline-block;width:40px;height:40px;border-radius:100px;text-align:center;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase;vertical-align:middle;line-height:40px}.adf-userinfo-profile-image{background:var(--adf-theme-primary-300);text-align:center;border-radius:90%;width:40px;height:40px;margin-right:0;cursor:pointer;vertical-align:middle;margin-left:0}.adf-userinfo-profile-container{display:inline-block}.adf-userinfo-menu_button.mat-button{margin-right:0;border-radius:90%;padding:0;min-width:40px;height:40px}.adf-userinfo-tab .mat-tab-header{align-self:center;width:100%;min-width:250px}.adf-userinfo-tab .mat-tab-label{flex:auto;font-weight:500;font-size:var(--theme-body-1-font-size);text-transform:uppercase;line-height:48px;text-align:center}.adf-userinfo-card-header{align-items:center;display:flex;justify-content:stretch;line-height:normal;height:100px;box-sizing:border-box}.adf-userinfo-card.mat-card{padding:0}.adf-userinfo-supporting-text{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;overflow:hidden;padding:32px;column-count:2;display:flex;justify-content:space-between}@media screen and (max-width: 599px){.adf-userinfo-supporting-text{padding:10px}}.adf-userinfo-title{font-size:var(--theme-title-font-size)}.adf-userinfo__detail-profile{align-items:flex-start;font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;display:block;padding:0;margin:0}.adf-userinfo__detail-title{text-overflow:ellipsis;font-size:var(--theme-subheading-2-font-size);font-weight:400;letter-spacing:.04em;line-height:20px;align-items:flex-start}.adf-userinfo__secondary-info{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;align-items:flex-end}.adf-userinfo-profile-picture{background:var(--adf-theme-primary-300);background-size:cover;border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px}.adf-userinfo-profile-initials{text-transform:uppercase;background-size:cover;background-color:var(--adf-theme-primary-300);border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px;font-size:35px;font-weight:400;letter-spacing:0;line-height:78px;overflow:hidden;display:flex;justify-content:space-around}.adf-userinfo-button-profile{display:inline-block;border:0;vertical-align:middle}.adf-userinfo-detail{text-align:left}.adf-hide-tab .mat-tab-label-active{display:none!important}@media only screen and (min-device-width: 480px){.mat-menu-panel.adf-userinfo-menu{max-height:450px;min-width:450px;overflow:auto;padding:0}}.mat-menu-panel.adf-userinfo-menu .mat-menu-content{padding:0}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i9$1.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i9$1.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "component", type: i6$3.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "component", type: i6$3.MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i6$3.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1.InitialUsernamePipe, name: "usernameInitials" }, { kind: "pipe", type: i1.FullNamePipe, name: "fullName" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentUserInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-content-user-info', encapsulation: ViewEncapsulation.None, template: "<div \n    id=\"userinfo_container\" \n    [class.adf-userinfo-name-right]=\"showOnRight\" \n    (keyup)=\"onKeyPress($event)\"\n    class=\"adf-userinfo-container\" \n    *ngIf=\"canShow\"\n>\n    <span *ngIf=\"showName\" id=\"adf-userinfo-ecm-name-display\" class=\"adf-userinfo-name\">\n        {{ecmUser | fullName}}\n    </span>\n    <button mat-button [matMenuTriggerFor]=\"menu\" class=\"adf-userinfo-menu_button\"\n            data-automation-id=\"adf-user-profile\">\n        <div class=\"adf-userinfo-button-profile\" id=\"user-profile\">\n            <div *ngIf=\"identityUser; else showEcmUserImage\" id=\"identity-user-image\">\n                <div *ngIf=\"ecmUser?.avatarId; else initialTemplate\">\n                    <div class=\"adf-userinfo-profile-container\">\n                        <img id=\"logged-user-img\" [src]=\"getEcmAvatar(ecmUser.avatarId)\" alt=\"user-info-profile-button\"\n                             class=\"adf-userinfo-profile-image\"/>\n                    </div>\n                </div>\n                <ng-template #initialTemplate>\n                    <div [innerHTML]=\"identityUser | usernameInitials:'adf-userinfo-pic'\"></div>\n                </ng-template>\n            </div>\n            <ng-template #showEcmUserImage>\n                <div id=\"ecm-user-image\">\n                    <div *ngIf=\"ecmUser.avatarId; else initialTemplate\" class=\"adf-userinfo-profile-container\">\n                        <img id=\"logged-user-img\" [src]=\"getEcmAvatar(ecmUser.avatarId)\" alt=\"user-info-profile-button\"\n                             class=\"adf-userinfo-profile-image\"/>\n                    </div>\n                    <ng-template #initialTemplate>\n                        <div [outerHTML]=\"ecmUser | usernameInitials:'adf-userinfo-pic'\"></div>\n                    </ng-template>\n                </div>\n            </ng-template>\n        </div>\n    </button>\n\n    <mat-menu #menu=\"matMenu\" id=\"user-profile-lists\" [xPosition]=\"menuPositionX\" [yPosition]=\"menuPositionY\"\n              [overlapTrigger]=\"false\" class=\"adf-userinfo-menu\">\n        <mat-tab-group id=\"tab-group-env\" (click)=\"stopClosing($event)\" selectedIndex=\"0\" role=\"menuitem\"\n                       class=\"adf-userinfo-tab adf-hide-tab\">\n            <mat-tab label=\"{{ 'USER_PROFILE.TAB.CS' | translate }}\" role=\"dialog\"\n                     *ngIf=\"mode === userInfoMode.CONTENT\">\n                <mat-card class=\"adf-userinfo-card\">\n                    <mat-card-header class=\"adf-userinfo-card-header\"\n                                     [style.background-image]=\"'url(' + ecmBackgroundImage + ')'\">\n                        <div *ngIf=\"ecmUser.avatarId; else initialTemplate\"\n                             class=\"adf-userinfo-profile-container adf-hide-small\">\n                            <img class=\"adf-userinfo-profile-picture\" id=\"ecm-user-detail-image\"\n                                 alt=\"ecm-profile-image\" [src]=\"getEcmAvatar(ecmUser.avatarId)\"/>\n                        </div>\n                        <ng-template #initialTemplate>\n                            <div\n                                [outerHTML]=\"ecmUser | usernameInitials:'adf-userinfo-profile-initials adf-hide-small'\"></div>\n                        </ng-template>\n\n                        <div class=\"adf-userinfo-title\" id=\"ecm-username\">{{ecmUser | fullName}}</div>\n                    </mat-card-header>\n                    <mat-card-content>\n                        <div class=\"adf-userinfo-supporting-text\">\n                            <div class=\"adf-userinfo-detail\">\n                                <span id=\"ecm-full-name\"\n                                      class=\"adf-userinfo__detail-title\">{{ecmUser | fullName}}</span>\n                                <span class=\"adf-userinfo__detail-profile\" id=\"ecm-email\"> {{ecmUser.email}} </span>\n                                <a class=\"adf-userinfo__detail-profile\" href=\"#/profile\">\n                                    {{ 'USER_PROFILE.LABELS.MY_PROFILE' | translate }}</a>\n                            </div>\n                            <div class=\"adf-userinfo-detail\">\n                                    <span class=\"adf-userinfo__secondary-info\" id=\"ecm-job-title-label\">\n                                        {{ 'USER_PROFILE.LABELS.ECM.JOB_TITLE' | translate }}\n                                        <span id=\"ecm-job-title\"\n                                              class=\"adf-userinfo__detail-profile\"> {{ ecmUser.jobTitle ? ecmUser.jobTitle : 'N/A' }} </span>\n                                    </span>\n                            </div>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </mat-tab>\n            <mat-tab id=\"identity-panel\" role=\"dialog\" *ngIf=\"mode === userInfoMode.CONTENT_SSO\">\n                <mat-card class=\"adf-userinfo-card\">\n                    <mat-card-header class=\"adf-userinfo-card-header\"\n                                     [style.background-image]=\"'url(' + bpmBackgroundImage + ')'\">\n                        <div *ngIf=\"ecmUser.avatarId; else initialTemplate\"\n                                class=\"adf-userinfo-profile-container adf-hide-small\">\n                            <img class=\"adf-userinfo-profile-picture\" id=\"ecm-user-detail-image\"\n                                    alt=\"ecm-profile-image\" [src]=\"getEcmAvatar(ecmUser.avatarId)\"/>\n                        </div>\n                        <ng-template #initialTemplate>\n                            <div\n                                [outerHTML]=\"identityUser | usernameInitials:'adf-userinfo-profile-initials adf-hide-small'\"></div>\n                        </ng-template>\n                        <div class=\"adf-userinfo-title\" id=\"identity-username\">{{identityUser | fullName}}</div>\n                    </mat-card-header>\n                    <mat-card-content>\n                        <div class=\"adf-userinfo-supporting-text\">\n                            <div class=\"adf-userinfo-detail\">\n                                <span id=\"identity-full-name\"\n                                      class=\"adf-userinfo__detail-title\">{{identityUser | fullName}}</span>\n                                <span class=\"adf-userinfo__detail-profile\"\n                                      id=\"identity-email\"> {{identityUser.email}} </span>\n                                <a class=\"adf-userinfo__detail-profile\" href=\"#/profile\">\n                                      {{ 'USER_PROFILE.LABELS.MY_PROFILE' | translate }}</a>\n                            </div>\n                        </div>\n                    </mat-card-content>\n                </mat-card>\n            </mat-tab>\n        </mat-tab-group>\n    </mat-menu>\n</div>\n", styles: [".adf-userinfo-container{display:flex;align-items:center;padding:0 5px}.adf-userinfo-name-right{flex-direction:row-reverse}.adf-userinfo-name{padding:0 5px}@media screen and (max-width: 959px){.adf-userinfo-name{display:none}}.adf-userinfo-pic{background:var(--adf-theme-primary-300);display:inline-block;width:40px;height:40px;border-radius:100px;text-align:center;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase;vertical-align:middle;line-height:40px}.adf-userinfo-profile-image{background:var(--adf-theme-primary-300);text-align:center;border-radius:90%;width:40px;height:40px;margin-right:0;cursor:pointer;vertical-align:middle;margin-left:0}.adf-userinfo-profile-container{display:inline-block}.adf-userinfo-menu_button.mat-button{margin-right:0;border-radius:90%;padding:0;min-width:40px;height:40px}.adf-userinfo-tab .mat-tab-header{align-self:center;width:100%;min-width:250px}.adf-userinfo-tab .mat-tab-label{flex:auto;font-weight:500;font-size:var(--theme-body-1-font-size);text-transform:uppercase;line-height:48px;text-align:center}.adf-userinfo-card-header{align-items:center;display:flex;justify-content:stretch;line-height:normal;height:100px;box-sizing:border-box}.adf-userinfo-card.mat-card{padding:0}.adf-userinfo-supporting-text{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;overflow:hidden;padding:32px;column-count:2;display:flex;justify-content:space-between}@media screen and (max-width: 599px){.adf-userinfo-supporting-text{padding:10px}}.adf-userinfo-title{font-size:var(--theme-title-font-size)}.adf-userinfo__detail-profile{align-items:flex-start;font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;display:block;padding:0;margin:0}.adf-userinfo__detail-title{text-overflow:ellipsis;font-size:var(--theme-subheading-2-font-size);font-weight:400;letter-spacing:.04em;line-height:20px;align-items:flex-start}.adf-userinfo__secondary-info{font-size:var(--theme-body-1-font-size);font-weight:400;letter-spacing:0;line-height:18px;align-items:flex-end}.adf-userinfo-profile-picture{background:var(--adf-theme-primary-300);background-size:cover;border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px}.adf-userinfo-profile-initials{text-transform:uppercase;background-size:cover;background-color:var(--adf-theme-primary-300);border-radius:50%;height:80px;width:80px;margin-left:0;margin-right:8px;font-size:35px;font-weight:400;letter-spacing:0;line-height:78px;overflow:hidden;display:flex;justify-content:space-around}.adf-userinfo-button-profile{display:inline-block;border:0;vertical-align:middle}.adf-userinfo-detail{text-align:left}.adf-hide-tab .mat-tab-label-active{display:none!important}@media only screen and (min-device-width: 480px){.mat-menu-panel.adf-userinfo-menu{max-height:450px;min-width:450px;overflow:auto;padding:0}}.mat-menu-panel.adf-userinfo-menu .mat-menu-content{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: PeopleContentService }]; }, propDecorators: { trigger: [{
                type: ViewChild,
                args: [MatMenuTrigger]
            }], isLoggedIn: [{
                type: Input
            }], ecmUser: [{
                type: Input
            }], identityUser: [{
                type: Input
            }], mode: [{
                type: Input
            }], ecmBackgroundImage: [{
                type: Input
            }], bpmBackgroundImage: [{
                type: Input
            }], menuPositionX: [{
                type: Input
            }], menuPositionY: [{
                type: Input
            }], showName: [{
                type: Input
            }], namePosition: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentUserInfoModule {
}
ContentUserInfoModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentUserInfoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentUserInfoModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentUserInfoModule, declarations: [ContentUserInfoComponent], imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatCardModule,
        TranslateModule,
        PipeModule], exports: [ContentUserInfoComponent] });
ContentUserInfoModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentUserInfoModule, imports: [CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatCardModule,
        TranslateModule,
        PipeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentUserInfoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ContentUserInfoComponent],
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatMenuModule,
                        MatTabsModule,
                        MatCardModule,
                        TranslateModule,
                        PipeModule
                    ],
                    exports: [ContentUserInfoComponent]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fakeSearch = {
    list: {
        pagination: {
            count: 1,
            hasMoreItems: false,
            totalItems: 1,
            skipCount: 0,
            maxItems: 100
        },
        entries: [
            {
                entry: {
                    id: '123',
                    name: 'MyDoc',
                    content: {
                        mimetype: 'text/plain'
                    },
                    createdByUser: {
                        displayName: 'John Doe'
                    },
                    modifiedByUser: {
                        displayName: 'John Doe'
                    }
                }
            }
        ]
    }
};
const mockError = {
    error: {
        errorKey: 'Search failed',
        statusCode: 400,
        briefSummary: '08220082 search failed',
        stackTrace: 'For security reasons the stack trace is no longer displayed, but the property is kept for previous versions.',
        descriptionURL: 'https://api-explorer.alfresco.com'
    }
};
const searchMockApi = {
    findNodes: () => Promise.resolve(fakeSearch)
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SitesDropdownModule {
}
SitesDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SitesDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SitesDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SitesDropdownModule, declarations: [DropdownSitesComponent], imports: [CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule], exports: [DropdownSitesComponent] });
SitesDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SitesDropdownModule, imports: [CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SitesDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        FormsModule,
                        ReactiveFormsModule,
                        CoreModule
                    ],
                    exports: [
                        DropdownSitesComponent
                    ],
                    declarations: [
                        DropdownSitesComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BreadcrumbModule {
}
BreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbComponent,
        DropdownBreadcrumbComponent], imports: [CommonModule,
        MaterialModule,
        CoreModule], exports: [BreadcrumbComponent,
        DropdownBreadcrumbComponent] });
BreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BreadcrumbModule, imports: [CommonModule,
        MaterialModule,
        CoreModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        CoreModule
                    ],
                    exports: [
                        BreadcrumbComponent,
                        DropdownBreadcrumbComponent
                    ],
                    declarations: [
                        BreadcrumbComponent,
                        DropdownBreadcrumbComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ConfirmDialogComponent {
    constructor(data, sanitizer) {
        this.sanitizer = sanitizer;
        data = data || {};
        this.title = data.title || 'ADF_CONFIRM_DIALOG.TITLE';
        this.message = data.message || 'ADF_CONFIRM_DIALOG.MESSAGE';
        this.yesLabel = data.yesLabel || 'ADF_CONFIRM_DIALOG.YES_LABEL';
        this.thirdOptionLabel = data.thirdOptionLabel;
        this.noLabel = data.noLabel || 'ADF_CONFIRM_DIALOG.NO_LABEL';
        this.htmlContent = data.htmlContent;
    }
    sanitizedHtmlContent() {
        return this.sanitizer.sanitize(SecurityContext.HTML, this.htmlContent);
    }
}
ConfirmDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ConfirmDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$5.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
ConfirmDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ConfirmDialogComponent, selector: "adf-confirm-dialog", host: { classAttribute: "adf-confirm-dialog" }, ngImport: i0, template: "<h1 mat-dialog-title data-automation-id=\"adf-confirm-dialog-title\">{{ title | translate }}</h1>\n<mat-dialog-content>\n    <p *ngIf=\"!htmlContent; else cutomContent\" data-automation-id=\"adf-confirm-dialog-base-message\">\n        {{ message | translate }}\n    </p>\n    <ng-template #cutomContent>\n        <span [innerHTML]=\"sanitizedHtmlContent()\" data-automation-id=\"adf-confirm-dialog-custom-content\">\n        </span>\n    </ng-template>\n</mat-dialog-content>\n<mat-dialog-actions>\n    <span class=\"adf-dialog-spacer\" data-automation-id=\"adf-confirm-dialog-spacer\"></span>\n    <button id=\"adf-confirm-accept\" mat-button color=\"primary\" data-automation-id=\"adf-confirm-dialog-confirmation\"\n        [mat-dialog-close]=\"true\">{{ yesLabel | translate }}</button>\n    <button id=\"adf-confirm-all\" mat-button *ngIf=\"thirdOptionLabel\" [mat-dialog-close]=\"thirdOptionLabel\" data-automation-id=\"adf-confirm-dialog-confirm-all\">{{ thirdOptionLabel | translate }}</button>\n    <button id=\"adf-confirm-cancel\" mat-button [mat-dialog-close]=\"false\" data-automation-id=\"adf-confirm-dialog-reject\"\n        cdkFocusInitial>{{ noLabel | translate }}</button>\n</mat-dialog-actions>\n", styles: [".adf-dialog-spacer{flex:1 1 auto}.adf-confirm-dialog .mat-dialog-actions .mat-button-wrapper{text-transform:uppercase}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-confirm-dialog', host: { class: 'adf-confirm-dialog' }, encapsulation: ViewEncapsulation.None, template: "<h1 mat-dialog-title data-automation-id=\"adf-confirm-dialog-title\">{{ title | translate }}</h1>\n<mat-dialog-content>\n    <p *ngIf=\"!htmlContent; else cutomContent\" data-automation-id=\"adf-confirm-dialog-base-message\">\n        {{ message | translate }}\n    </p>\n    <ng-template #cutomContent>\n        <span [innerHTML]=\"sanitizedHtmlContent()\" data-automation-id=\"adf-confirm-dialog-custom-content\">\n        </span>\n    </ng-template>\n</mat-dialog-content>\n<mat-dialog-actions>\n    <span class=\"adf-dialog-spacer\" data-automation-id=\"adf-confirm-dialog-spacer\"></span>\n    <button id=\"adf-confirm-accept\" mat-button color=\"primary\" data-automation-id=\"adf-confirm-dialog-confirmation\"\n        [mat-dialog-close]=\"true\">{{ yesLabel | translate }}</button>\n    <button id=\"adf-confirm-all\" mat-button *ngIf=\"thirdOptionLabel\" [mat-dialog-close]=\"thirdOptionLabel\" data-automation-id=\"adf-confirm-dialog-confirm-all\">{{ thirdOptionLabel | translate }}</button>\n    <button id=\"adf-confirm-cancel\" mat-button [mat-dialog-close]=\"false\" data-automation-id=\"adf-confirm-dialog-reject\"\n        cdkFocusInitial>{{ noLabel | translate }}</button>\n</mat-dialog-actions>\n", styles: [".adf-dialog-spacer{flex:1 1 auto}.adf-confirm-dialog .mat-dialog-actions .mat-button-wrapper{text-transform:uppercase}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$5.DomSanitizer }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentVersionService {
    constructor(alfrescoApi) {
        this.alfrescoApi = alfrescoApi;
    }
    get contentApi() {
        if (!this._contentApi) {
            this._contentApi = new ContentApi(this.alfrescoApi.getInstance());
        }
        return this._contentApi;
    }
    /**
     * Get content URL for the given nodeId and specific version.
     *
     * @param nodeId The ID of the node
     * @param versionId The ID of the version
     * @param attachment Retrieve content as an attachment for download
     * @returns The URL address pointing to the content.
     */
    getVersionContentUrl(nodeId, versionId, attachment) {
        let nodeDownloadUrl = this.contentApi.getContentUrl(nodeId, attachment);
        nodeDownloadUrl = nodeDownloadUrl.replace('/content', '/versions/' + versionId + '/content');
        return of(nodeDownloadUrl);
    }
}
ContentVersionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentVersionService, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentVersionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentVersionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentVersionService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionCompatibilityDirective {
    constructor(templateRef, viewContainer, versionCompatibilityService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.versionCompatibilityService = versionCompatibilityService;
    }
    /** Minimum version required for component to work correctly . */
    set version(requiredVersion) {
        this.validateAcsVersion(requiredVersion);
    }
    validateAcsVersion(requiredVersion) {
        this.versionCompatibilityService.acsVersionInitialized$.pipe(take(1)).subscribe(() => {
            this.viewContainer.clear();
            if (requiredVersion && this.versionCompatibilityService.isVersionSupported(requiredVersion)) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }
}
VersionCompatibilityDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: VersionCompatibilityService }], target: i0.ɵɵFactoryTarget.Directive });
VersionCompatibilityDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: VersionCompatibilityDirective, selector: "[adf-acs-version]", inputs: { version: ["adf-acs-version", "version"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-acs-version]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: VersionCompatibilityService }]; }, propDecorators: { version: [{
                type: Input,
                args: ['adf-acs-version']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionListComponent {
    constructor(alfrescoApi, contentService, contentVersionService, dialog) {
        this.alfrescoApi = alfrescoApi;
        this.contentService = contentService;
        this.contentVersionService = contentVersionService;
        this.dialog = dialog;
        this.versions = [];
        this.isLoading = true;
        /** Toggles showing/hiding of comments */
        this.showComments = true;
        /** Enable/disable downloading a version of the current node. */
        this.allowDownload = true;
        /** Enable/disable viewing a version of the current node. */
        this.allowViewVersions = true;
        /** Toggles showing/hiding of version actions */
        this.showActions = true;
        /** Emitted when a version is restored */
        this.restored = new EventEmitter();
        /** Emitted when a version is deleted */
        this.deleted = new EventEmitter();
        /** Emitted when viewing a version */
        this.viewVersion = new EventEmitter();
    }
    get contentApi() {
        this._contentApi = this._contentApi ?? new ContentApi(this.alfrescoApi.getInstance());
        return this._contentApi;
    }
    get versionsApi() {
        this._versionsApi = this._versionsApi ?? new VersionsApi(this.alfrescoApi.getInstance());
        return this._versionsApi;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.alfrescoApi.getInstance());
        return this._nodesApi;
    }
    ngOnChanges() {
        this.loadVersionHistory();
    }
    canUpdate() {
        return this.contentService.hasAllowableOperations(this.node, 'update') && this.versions.length > 1;
    }
    canDelete() {
        return this.contentService.hasAllowableOperations(this.node, 'delete') && this.versions.length > 1;
    }
    restore(versionId) {
        if (this.canUpdate()) {
            this.versionsApi
                .revertVersion(this.node.id, versionId, { majorVersion: true, comment: '' })
                .then(() => this.nodesApi.getNode(this.node.id, { include: ['permissions', 'path', 'isFavorite', 'allowableOperations'] }))
                .then((node) => this.onVersionRestored(node));
        }
    }
    onViewVersion(versionId) {
        this.viewVersion.emit(versionId);
    }
    loadVersionHistory() {
        this.isLoading = true;
        this.versionsApi.listVersionHistory(this.node.id).then((versionPaging) => {
            this.versions = versionPaging.list.entries;
            this.isLoading = false;
        });
    }
    downloadVersion(versionId) {
        if (this.allowDownload) {
            this.contentVersionService
                .getVersionContentUrl(this.node.id, versionId, true)
                .subscribe(versionDownloadUrl => this.downloadContent(versionDownloadUrl));
        }
    }
    deleteVersion(versionId) {
        if (this.canUpdate()) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                data: {
                    title: 'ADF_VERSION_LIST.CONFIRM_DELETE.TITLE',
                    message: 'ADF_VERSION_LIST.CONFIRM_DELETE.MESSAGE',
                    yesLabel: 'ADF_VERSION_LIST.CONFIRM_DELETE.YES_LABEL',
                    noLabel: 'ADF_VERSION_LIST.CONFIRM_DELETE.NO_LABEL'
                },
                minWidth: '250px'
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result === true) {
                    this.versionsApi
                        .deleteVersion(this.node.id, versionId)
                        .then(() => this.onVersionDeleted(this.node));
                }
            });
        }
    }
    onVersionDeleted(node) {
        this.loadVersionHistory();
        this.deleted.emit(node);
    }
    onVersionRestored(node) {
        this.loadVersionHistory();
        this.restored.emit(node?.entry);
    }
    downloadContent(url) {
        if (url) {
            const link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
VersionListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionListComponent, deps: [{ token: i1.AlfrescoApiService }, { token: ContentService }, { token: ContentVersionService }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
VersionListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: VersionListComponent, selector: "adf-version-list", inputs: { node: "node", showComments: "showComments", allowDownload: "allowDownload", allowViewVersions: "allowViewVersions", showActions: "showActions" }, outputs: { restored: "restored", deleted: "deleted", viewVersion: "viewVersion" }, host: { classAttribute: "adf-version-list" }, usesOnChanges: true, ngImport: i0, template: "<mat-list class=\"adf-version-list\" *ngIf=\"!isLoading; else loading_template\">\n    <mat-list-item *ngFor=\"let version of versions; let idx = index\">\n        <mat-icon mat-list-icon>insert_drive_file</mat-icon>\n        <p mat-line class=\"adf-version-list-item-name\" [id]=\"'adf-version-list-item-name-' + version.entry.id\" >{{version.entry.name}}</p>\n        <p mat-line>\n            <span class=\"adf-version-list-item-version\"  [id]=\"'adf-version-list-item-version-' + version.entry.id\" >{{version.entry.id}}</span> -\n            <span class=\"adf-version-list-item-date\"     [id]=\"'adf-version-list-item-date-' + version.entry.id\" >{{version.entry.modifiedAt | date}}</span>\n        </p>\n        <p mat-line [id]=\"'adf-version-list-item-comment-'+ version.entry.id\" class=\"adf-version-list-item-comment\"\n           *ngIf=\"showComments\">{{version.entry.versionComment}}</p>\n\n        <div *ngIf=\"showActions\">\n            <mat-menu [id]=\"'adf-version-list-action-menu-'+version.entry.id\"\n                      #versionMenu=\"matMenu\" yPosition=\"below\" xPosition=\"before\">\n                <ng-container *adf-acs-version=\"'7'\">\n                    <button *ngIf=\"allowViewVersions\"\n                            [id]=\"'adf-version-list-action-view-'+version.entry.id\"\n                            mat-menu-item\n                            (click)=\"onViewVersion(version.entry.id)\">\n                        {{ 'ADF_VERSION_LIST.ACTIONS.VIEW' | translate }}\n                    </button>\n                </ng-container>\n                <button\n                    [id]=\"'adf-version-list-action-restore-'+version.entry.id\"\n                    [disabled]=\"!canUpdate()\"\n                    mat-menu-item\n                    (click)=\"restore(version.entry.id)\">\n                    {{ 'ADF_VERSION_LIST.ACTIONS.RESTORE' | translate }}\n                </button>\n                <button *ngIf=\"allowDownload\"\n                        [id]=\"'adf-version-list-action-download-'+version.entry.id\"\n                        mat-menu-item\n                        (click)=\"downloadVersion(version.entry.id)\">\n                    {{ 'ADF_VERSION_LIST.ACTIONS.DOWNLOAD' | translate }}\n                </button>\n                <button\n                    [disabled]=\"!canDelete()\"\n                    [id]=\"'adf-version-list-action-delete-'+version.entry.id\"\n                    (click)=\"deleteVersion(version.entry.id)\"\n                    mat-menu-item>\n                    {{ 'ADF_VERSION_LIST.ACTIONS.DELETE' | translate }}\n                </button>\n            </mat-menu>\n\n            <button mat-icon-button [matMenuTriggerFor]=\"versionMenu\" [id]=\"'adf-version-list-action-menu-button-'+version.entry.id\" title=\"{{ 'ADF_VERSION_LIST.MANAGE_VERSION_OPTIONS' | translate }}\">\n                <mat-icon>more_vert</mat-icon>\n            </button>\n        </div>\n    </mat-list-item>\n</mat-list>\n\n<ng-template #loading_template>\n    <mat-progress-bar data-automation-id=\"version-history-loading-bar\" mode=\"indeterminate\"\n                      color=\"accent\"></mat-progress-bar>\n</ng-template>\n", styles: [".adf-version-list .mat-list-item-content{border-bottom:1px solid #d8d8d8}.adf-version-list-item-version{font-weight:700}.adf-version-list-item-date{opacity:.6}.adf-version-list-item-comment{opacity:.5}.adf-version-list-item-name,.adf-version-list-item-date{white-space:normal!important}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i8$1.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }, { kind: "component", type: i8$1.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i1$2.MatLine, selector: "[mat-line], [matLine]" }, { kind: "directive", type: i8$1.MatListIconCssMatStyler, selector: "[mat-list-icon], [matListIcon]" }, { kind: "component", type: i10.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i6$2.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: VersionCompatibilityDirective, selector: "[adf-acs-version]", inputs: ["adf-acs-version"] }, { kind: "pipe", type: i2$1.DatePipe, name: "date" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-version-list', encapsulation: ViewEncapsulation.None, host: { class: 'adf-version-list' }, template: "<mat-list class=\"adf-version-list\" *ngIf=\"!isLoading; else loading_template\">\n    <mat-list-item *ngFor=\"let version of versions; let idx = index\">\n        <mat-icon mat-list-icon>insert_drive_file</mat-icon>\n        <p mat-line class=\"adf-version-list-item-name\" [id]=\"'adf-version-list-item-name-' + version.entry.id\" >{{version.entry.name}}</p>\n        <p mat-line>\n            <span class=\"adf-version-list-item-version\"  [id]=\"'adf-version-list-item-version-' + version.entry.id\" >{{version.entry.id}}</span> -\n            <span class=\"adf-version-list-item-date\"     [id]=\"'adf-version-list-item-date-' + version.entry.id\" >{{version.entry.modifiedAt | date}}</span>\n        </p>\n        <p mat-line [id]=\"'adf-version-list-item-comment-'+ version.entry.id\" class=\"adf-version-list-item-comment\"\n           *ngIf=\"showComments\">{{version.entry.versionComment}}</p>\n\n        <div *ngIf=\"showActions\">\n            <mat-menu [id]=\"'adf-version-list-action-menu-'+version.entry.id\"\n                      #versionMenu=\"matMenu\" yPosition=\"below\" xPosition=\"before\">\n                <ng-container *adf-acs-version=\"'7'\">\n                    <button *ngIf=\"allowViewVersions\"\n                            [id]=\"'adf-version-list-action-view-'+version.entry.id\"\n                            mat-menu-item\n                            (click)=\"onViewVersion(version.entry.id)\">\n                        {{ 'ADF_VERSION_LIST.ACTIONS.VIEW' | translate }}\n                    </button>\n                </ng-container>\n                <button\n                    [id]=\"'adf-version-list-action-restore-'+version.entry.id\"\n                    [disabled]=\"!canUpdate()\"\n                    mat-menu-item\n                    (click)=\"restore(version.entry.id)\">\n                    {{ 'ADF_VERSION_LIST.ACTIONS.RESTORE' | translate }}\n                </button>\n                <button *ngIf=\"allowDownload\"\n                        [id]=\"'adf-version-list-action-download-'+version.entry.id\"\n                        mat-menu-item\n                        (click)=\"downloadVersion(version.entry.id)\">\n                    {{ 'ADF_VERSION_LIST.ACTIONS.DOWNLOAD' | translate }}\n                </button>\n                <button\n                    [disabled]=\"!canDelete()\"\n                    [id]=\"'adf-version-list-action-delete-'+version.entry.id\"\n                    (click)=\"deleteVersion(version.entry.id)\"\n                    mat-menu-item>\n                    {{ 'ADF_VERSION_LIST.ACTIONS.DELETE' | translate }}\n                </button>\n            </mat-menu>\n\n            <button mat-icon-button [matMenuTriggerFor]=\"versionMenu\" [id]=\"'adf-version-list-action-menu-button-'+version.entry.id\" title=\"{{ 'ADF_VERSION_LIST.MANAGE_VERSION_OPTIONS' | translate }}\">\n                <mat-icon>more_vert</mat-icon>\n            </button>\n        </div>\n    </mat-list-item>\n</mat-list>\n\n<ng-template #loading_template>\n    <mat-progress-bar data-automation-id=\"version-history-loading-bar\" mode=\"indeterminate\"\n                      color=\"accent\"></mat-progress-bar>\n</ng-template>\n", styles: [".adf-version-list .mat-list-item-content{border-bottom:1px solid #d8d8d8}.adf-version-list-item-version{font-weight:700}.adf-version-list-item-date{opacity:.6}.adf-version-list-item-comment{opacity:.5}.adf-version-list-item-name,.adf-version-list-item-date{white-space:normal!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: ContentService }, { type: ContentVersionService }, { type: i1$1.MatDialog }]; }, propDecorators: { node: [{
                type: Input
            }], showComments: [{
                type: Input
            }], allowDownload: [{
                type: Input
            }], allowViewVersions: [{
                type: Input
            }], showActions: [{
                type: Input
            }], restored: [{
                type: Output
            }], deleted: [{
                type: Output
            }], viewVersion: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionUploadComponent {
    constructor(contentService, uploadService) {
        this.contentService = contentService;
        this.uploadService = uploadService;
        this.semanticVersion = 'minor';
        this.uploadVersion = false;
        this.disabled = false;
        this.onDestroy$ = new Subject();
        this.majorVersion = '2.0';
        this.minorVersion = '1.1';
        /** Toggles showing/hiding upload button. */
        this.showUploadButton = true;
        /** Toggles showing/hiding of cancel button. */
        this.showCancelButton = true;
        /** Emitted when the file is uploaded successfully. */
        this.success = new EventEmitter();
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
        /** Emitted when an cancelling during upload. */
        this.cancel = new EventEmitter();
        /** Emitted when the version is changed. */
        this.versionChanged = new EventEmitter();
        /** Emitted when the comment is changed. */
        this.commentChanged = new EventEmitter();
        /** Emitted when the upload starts */
        this.uploadStarted = new EventEmitter();
    }
    /** Current version for a target node */
    set currentVersion(version) {
        if (version) {
            this.minorVersion = this.getNextMinorVersion(version.id);
            this.majorVersion = this.getNextMajorVersion(version.id);
        }
    }
    ngOnInit() {
        this.uploadService.fileUploadStarting
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((event) => {
            this.disabled = true;
            this.uploadStarted.emit(event);
        });
    }
    canUpload() {
        return this.contentService.hasAllowableOperations(this.node, 'update') && !this.disabled;
    }
    isMajorVersion() {
        return this.semanticVersion !== 'minor';
    }
    cancelUpload() {
        this.disabled = false;
        this.cancel.emit();
    }
    onVersionChange() {
        this.versionChanged.emit(this.isMajorVersion());
    }
    onCommentChange() {
        this.commentChanged.emit(this.comment);
    }
    onSuccess(event) {
        this.disabled = false;
        this.success.emit(event);
    }
    onError(event) {
        this.disabled = false;
        this.error.emit(event);
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    getNextMinorVersion(version) {
        const { major, minor } = this.getParsedVersion(version);
        return `${major}.${minor + 1}`;
    }
    getNextMajorVersion(version) {
        const { major } = this.getParsedVersion(version);
        return `${major + 1}.0`;
    }
    getParsedVersion(version) {
        const minor = version.indexOf('.') !== -1 ? Number(version.substr(version.indexOf('.') + 1)) : 0;
        const major = parseInt(version, 10);
        return { minor, major };
    }
}
VersionUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionUploadComponent, deps: [{ token: ContentService }, { token: UploadService }], target: i0.ɵɵFactoryTarget.Component });
VersionUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: VersionUploadComponent, selector: "adf-version-upload", inputs: { node: "node", newFileVersion: "newFileVersion", showUploadButton: "showUploadButton", showCancelButton: "showCancelButton", currentVersion: "currentVersion" }, outputs: { success: "success", error: "error", cancel: "cancel", versionChanged: "versionChanged", commentChanged: "commentChanged", uploadStarted: "uploadStarted" }, host: { classAttribute: "adf-version-upload" }, ngImport: i0, template: "<div class=\"adf-new-version-max-width\">\n    <mat-radio-group class=\"adf-new-version-radio-group\" [(ngModel)]=\"semanticVersion\" (change)=\"onVersionChange()\">\n        <mat-radio-button class=\"adf-new-version-radio-button\" id=\"adf-new-version-minor\"[value]=\"'minor'\">\n            {{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.MINOR' | translate: { version: minorVersion } }}\n        </mat-radio-button>\n        <mat-radio-button class=\"adf-new-version-radio-button\" id=\"adf-new-version-major\" [value]=\"'major'\">\n            {{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.MAJOR' | translate: { version: majorVersion } }}\n        </mat-radio-button>\n    </mat-radio-group>\n    <mat-form-field class=\"adf-new-version-max-width\">\n                    <textarea matInput [(ngModel)]=\"comment\" class=\"adf-new-version-text-area\" id=\"adf-new-version-text-area\"\n                              (change)=\"onCommentChange()\"\n                              placeholder=\"{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.COMMENT' | translate }}\"></textarea>\n    </mat-form-field>\n\n</div>\n<div class=\"adf-version-upload-buttons\">\n    <adf-upload-version-button *ngIf=\"showUploadButton\"\n        data-automation-id=\"adf-new-version-file-upload\"\n        staticTitle=\"{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.TITLE' | translate }}\"\n        [node]=\"node\"\n        [disabled]=\"!canUpload()\"\n        [rootFolderId]=\"node.parentId\"\n        tooltip=\"{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.TOOLTIP' | translate }}\"\n        [comment]=\"comment\"\n        [versioning]=\"true\"\n        [file]=\"newFileVersion\"\n        [majorVersion]=\"isMajorVersion()\"\n        (success)=\"onSuccess($event)\"\n        (error)=\"onError($event)\">\n    </adf-upload-version-button>\n    <button mat-raised-button (click)=\"cancelUpload()\" id=\"adf-new-version-cancel\"  *ngIf=\"showCancelButton\" >{{\n        'ADF_VERSION_LIST.ACTIONS.UPLOAD.CANCEL'| translate }}\n    </button>\n</div>\n", styles: [".adf-new-version-radio-group{display:inline-flex;flex-direction:column}.adf-new-version-radio-button{margin:5px}.adf-version-upload-buttons{display:flex;float:right;justify-content:space-between;width:100%}.adf-new-version-max-width{width:100%;float:right}.adf-new-version-text-area{resize:none!important}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i5$2.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i5$2.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: UploadVersionButtonComponent, selector: "adf-upload-version-button", inputs: ["node"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-version-upload', encapsulation: ViewEncapsulation.None, host: { class: 'adf-version-upload' }, template: "<div class=\"adf-new-version-max-width\">\n    <mat-radio-group class=\"adf-new-version-radio-group\" [(ngModel)]=\"semanticVersion\" (change)=\"onVersionChange()\">\n        <mat-radio-button class=\"adf-new-version-radio-button\" id=\"adf-new-version-minor\"[value]=\"'minor'\">\n            {{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.MINOR' | translate: { version: minorVersion } }}\n        </mat-radio-button>\n        <mat-radio-button class=\"adf-new-version-radio-button\" id=\"adf-new-version-major\" [value]=\"'major'\">\n            {{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.MAJOR' | translate: { version: majorVersion } }}\n        </mat-radio-button>\n    </mat-radio-group>\n    <mat-form-field class=\"adf-new-version-max-width\">\n                    <textarea matInput [(ngModel)]=\"comment\" class=\"adf-new-version-text-area\" id=\"adf-new-version-text-area\"\n                              (change)=\"onCommentChange()\"\n                              placeholder=\"{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.COMMENT' | translate }}\"></textarea>\n    </mat-form-field>\n\n</div>\n<div class=\"adf-version-upload-buttons\">\n    <adf-upload-version-button *ngIf=\"showUploadButton\"\n        data-automation-id=\"adf-new-version-file-upload\"\n        staticTitle=\"{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.TITLE' | translate }}\"\n        [node]=\"node\"\n        [disabled]=\"!canUpload()\"\n        [rootFolderId]=\"node.parentId\"\n        tooltip=\"{{ 'ADF_VERSION_LIST.ACTIONS.UPLOAD.TOOLTIP' | translate }}\"\n        [comment]=\"comment\"\n        [versioning]=\"true\"\n        [file]=\"newFileVersion\"\n        [majorVersion]=\"isMajorVersion()\"\n        (success)=\"onSuccess($event)\"\n        (error)=\"onError($event)\">\n    </adf-upload-version-button>\n    <button mat-raised-button (click)=\"cancelUpload()\" id=\"adf-new-version-cancel\"  *ngIf=\"showCancelButton\" >{{\n        'ADF_VERSION_LIST.ACTIONS.UPLOAD.CANCEL'| translate }}\n    </button>\n</div>\n", styles: [".adf-new-version-radio-group{display:inline-flex;flex-direction:column}.adf-new-version-radio-button{margin:5px}.adf-version-upload-buttons{display:flex;float:right;justify-content:space-between;width:100%}.adf-new-version-max-width{width:100%;float:right}.adf-new-version-text-area{resize:none!important}\n"] }]
        }], ctorParameters: function () { return [{ type: ContentService }, { type: UploadService }]; }, propDecorators: { node: [{
                type: Input
            }], newFileVersion: [{
                type: Input
            }], showUploadButton: [{
                type: Input
            }], showCancelButton: [{
                type: Input
            }], currentVersion: [{
                type: Input
            }], success: [{
                type: Output
            }], error: [{
                type: Output
            }], cancel: [{
                type: Output
            }], versionChanged: [{
                type: Output
            }], commentChanged: [{
                type: Output
            }], uploadStarted: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionComparisonComponent {
    constructor(thumbnailService) {
        this.thumbnailService = thumbnailService;
    }
}
VersionComparisonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionComparisonComponent, deps: [{ token: i1.ThumbnailService }], target: i0.ɵɵFactoryTarget.Component });
VersionComparisonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: VersionComparisonComponent, selector: "adf-version-comparison", inputs: { node: "node", newFileVersion: "newFileVersion" }, ngImport: i0, template: "<div class=\"adf-version-comparison-content\">\n    <div class=\"adf-version-current\">\n        <p>{{'ADF_VERSION_COMPARISON.CURRENT_VERSION'|translate }}</p>\n        <img [attr.aria-label]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n        { type: (node.content.mimeType | fileType | uppercase) | translate  }\"\n             [attr.alt]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n             { type: (node.content.mimeType | fileType | uppercase) | translate }\"\n             src=\"{{thumbnailService.getMimeTypeIcon(node.content.mimeType)}}\"/>\n        <p class=\"adf-version-comparison-node-name\" title=\"{{node.name}}\">{{node.name}}</p>\n    </div>\n    <span class=\"material-icons adf-version-arrow-icon\">keyboard_arrow_right</span>\n    <div class=\"adf-version-new\">\n        <p>{{'ADF_VERSION_COMPARISON.NEW_VERSION'|translate }}</p>\n        <img [attr.aria-label]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n        { type: (newFileVersion.type | fileType | uppercase) | translate  }\"\n             [attr.alt]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n             { type: (newFileVersion.type | fileType | uppercase) | translate }\"\n            src=\"{{thumbnailService.getMimeTypeIcon(newFileVersion.type)}}\"/>\n        <p class=\"adf-version-comparison-file-name\" title=\"{{newFileVersion.name}}\">{{newFileVersion.name}}</p>\n    </div>\n</div>\n", styles: [".adf-version-comparison-content{display:flex;align-items:center;align-content:center;justify-content:space-around}.adf-version-current,.adf-version-new{display:flex;flex-direction:column;align-items:center}.adf-version-current img,.adf-version-new img{width:100px}.adf-version-arrow-icon{font-size:var(--theme-display-4-font-size)}.adf-version-comparison-node-name,.adf-version-comparison-file-name{width:120px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:center}\n"], dependencies: [{ kind: "pipe", type: i2$1.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: i1.FileTypePipe, name: "fileType" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionComparisonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-version-comparison', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-version-comparison-content\">\n    <div class=\"adf-version-current\">\n        <p>{{'ADF_VERSION_COMPARISON.CURRENT_VERSION'|translate }}</p>\n        <img [attr.aria-label]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n        { type: (node.content.mimeType | fileType | uppercase) | translate  }\"\n             [attr.alt]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n             { type: (node.content.mimeType | fileType | uppercase) | translate }\"\n             src=\"{{thumbnailService.getMimeTypeIcon(node.content.mimeType)}}\"/>\n        <p class=\"adf-version-comparison-node-name\" title=\"{{node.name}}\">{{node.name}}</p>\n    </div>\n    <span class=\"material-icons adf-version-arrow-icon\">keyboard_arrow_right</span>\n    <div class=\"adf-version-new\">\n        <p>{{'ADF_VERSION_COMPARISON.NEW_VERSION'|translate }}</p>\n        <img [attr.aria-label]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n        { type: (newFileVersion.type | fileType | uppercase) | translate  }\"\n             [attr.alt]=\"'ADF_VERSION_COMPARISON.ACCESSIBILITY.ICON_TEXT' | translate:\n             { type: (newFileVersion.type | fileType | uppercase) | translate }\"\n            src=\"{{thumbnailService.getMimeTypeIcon(newFileVersion.type)}}\"/>\n        <p class=\"adf-version-comparison-file-name\" title=\"{{newFileVersion.name}}\">{{newFileVersion.name}}</p>\n    </div>\n</div>\n", styles: [".adf-version-comparison-content{display:flex;align-items:center;align-content:center;justify-content:space-around}.adf-version-current,.adf-version-new{display:flex;flex-direction:column;align-items:center}.adf-version-current img,.adf-version-new img{width:100px}.adf-version-arrow-icon{font-size:var(--theme-display-4-font-size)}.adf-version-comparison-node-name,.adf-version-comparison-file-name{width:120px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-align:center}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.ThumbnailService }]; }, propDecorators: { node: [{
                type: Input
            }], newFileVersion: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionManagerComponent {
    constructor(contentService, nodesApiService) {
        this.contentService = contentService;
        this.nodesApiService = nodesApiService;
        /** Toggles showing/hiding of comments. */
        this.showComments = true;
        /** Toggles showing/hiding the version comparison component. */
        this.showVersionComparison = false;
        /** Enable/disable downloading a version of the current node. */
        this.allowDownload = true;
        /** Emitted when a file is uploaded successfully. */
        this.uploadSuccess = new EventEmitter();
        /** Emitted when an error occurs during upload. */
        this.uploadError = new EventEmitter();
        /** Emitted when an cancelling during upload. */
        this.uploadCancel = new EventEmitter();
        /** Emitted when viewing a version. */
        this.viewVersion = new EventEmitter();
        this.uploadState = 'close';
    }
    ngOnInit() {
        if (this.newFileVersion) {
            this.toggleNewVersion();
        }
    }
    refresh(node) {
        this.nodesApiService.nodeUpdated.next(node);
        this.versionListComponent.loadVersionHistory();
        this.uploadSuccess.emit(node);
        this.uploadState = 'close';
    }
    onUploadSuccess(event) {
        this.showVersionComparison = false;
        this.newFileVersion = null;
        this.nodesApiService.nodeUpdated.next(event.value.entry);
        this.versionListComponent.loadVersionHistory();
        this.uploadSuccess.emit(event.value.entry);
        this.uploadState = 'close';
    }
    onUploadError(event) {
        this.uploadError.emit(event);
    }
    onUploadCancel() {
        this.uploadState = 'close';
        this.showVersionComparison = false;
        this.newFileVersion = null;
        this.uploadCancel.emit(true);
    }
    onViewVersion(versionId) {
        this.viewVersion.emit(versionId);
    }
    toggleNewVersion() {
        this.uploadState = this.uploadState === 'open' ? 'close' : 'open';
    }
    canUpdate() {
        return this.contentService.hasAllowableOperations(this.node, 'update');
    }
}
VersionManagerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionManagerComponent, deps: [{ token: ContentService }, { token: NodesApiService }], target: i0.ɵɵFactoryTarget.Component });
VersionManagerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: VersionManagerComponent, selector: "adf-version-manager", inputs: { node: "node", newFileVersion: "newFileVersion", showComments: "showComments", showVersionComparison: "showVersionComparison", allowDownload: "allowDownload" }, outputs: { uploadSuccess: "uploadSuccess", uploadError: "uploadError", uploadCancel: "uploadCancel", viewVersion: "viewVersion" }, viewQueries: [{ propertyName: "versionListComponent", first: true, predicate: ["versionList"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"adf-new-version-container\">\n\n    <adf-version-comparison *ngIf=\"showVersionComparison\" [node]=\"node\" [newFileVersion]=\"newFileVersion\"></adf-version-comparison>\n\n    <div class=\"adf-new-version-uploader-container\" id=\"adf-new-version-uploader-container\" [@uploadToggle]=\"uploadState\">\n        <table class=\"adf-version-upload\" *ngIf=\"uploadState !== 'close' && !versionList.isLoading\">\n            <tr>\n                <td>\n                    <adf-version-upload\n                        id=\"adf-version-upload-button\"\n                        [node]=\"node\"\n                        [newFileVersion]=\"newFileVersion\"\n                        [currentVersion]=\"versionList?.versions[0]?.entry\"\n                        (success)=\"onUploadSuccess($event)\"\n                        (cancel)=\"onUploadCancel()\"\n                        (error)=\"onUploadError($event)\">\n                    </adf-version-upload>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <div class=\"adf-version-list-container\">\n        <div class=\"adf-version-list-table\">\n            <div>\n                <button mat-raised-button\n                        id=\"adf-show-version-upload-button\"\n                        (click)=\"toggleNewVersion()\" color=\"primary\"\n                        *ngIf=\"uploadState ==='close'\">{{\n                    'ADF_VERSION_LIST.ACTIONS.UPLOAD.ADD'|\n                    translate }}\n                </button>\n            </div>\n            <div>\n\n                <adf-version-list\n                    #versionList\n                    [node]=\"node\"\n                    [allowDownload]=\"allowDownload\"\n                    [showComments]=\"showComments\"\n                    (deleted)=\"refresh($event)\"\n                    (restored)=\"refresh($event)\"\n                    (viewVersion)=\"onViewVersion($event)\">\n                </adf-version-list>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["adf-version-manager .mat-list .mat-3-line{height:auto!important;width:100%!important}adf-version-manager .mat-list-item-content{padding:16px 0!important}.adf-version-list-item-comment.mat-line{height:100%;word-break:break-all;white-space:unset!important;overflow:unset!important}.adf-button.adf-upload-new-version{box-shadow:none;width:100%;height:175px;float:left;position:relative}.adf-new-version-uploader-container{padding:16px 0;width:100%;height:0;float:left!important;position:relative}.adf-new-version-container{height:inherit;overflow:hidden}.adf-version-list-table,.adf-version-upload-table{width:100%}.adf-version-list{width:100%!important;float:left!important}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: VersionUploadComponent, selector: "adf-version-upload", inputs: ["node", "newFileVersion", "showUploadButton", "showCancelButton", "currentVersion"], outputs: ["success", "error", "cancel", "versionChanged", "commentChanged", "uploadStarted"] }, { kind: "component", type: VersionListComponent, selector: "adf-version-list", inputs: ["node", "showComments", "allowDownload", "allowViewVersions", "showActions"], outputs: ["restored", "deleted", "viewVersion"] }, { kind: "component", type: VersionComparisonComponent, selector: "adf-version-comparison", inputs: ["node", "newFileVersion"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], animations: [
        trigger('uploadToggle', [
            state('open', style({ height: '175px', opacity: 1, visibility: 'visible' })),
            state('close', style({ height: '0%', opacity: 0, visibility: 'hidden' })),
            transition('open => close', [
                style({ visibility: 'hidden' }),
                animate('0.4s cubic-bezier(0.25, 0.8, 0.25, 1)')
            ]),
            transition('close => open', [
                style({ visibility: 'visible' }),
                animate('0.4s cubic-bezier(0.25, 0.8, 0.25, 1)')
            ])
        ])
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionManagerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-version-manager', animations: [
                        trigger('uploadToggle', [
                            state('open', style({ height: '175px', opacity: 1, visibility: 'visible' })),
                            state('close', style({ height: '0%', opacity: 0, visibility: 'hidden' })),
                            transition('open => close', [
                                style({ visibility: 'hidden' }),
                                animate('0.4s cubic-bezier(0.25, 0.8, 0.25, 1)')
                            ]),
                            transition('close => open', [
                                style({ visibility: 'visible' }),
                                animate('0.4s cubic-bezier(0.25, 0.8, 0.25, 1)')
                            ])
                        ])
                    ], encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-new-version-container\">\n\n    <adf-version-comparison *ngIf=\"showVersionComparison\" [node]=\"node\" [newFileVersion]=\"newFileVersion\"></adf-version-comparison>\n\n    <div class=\"adf-new-version-uploader-container\" id=\"adf-new-version-uploader-container\" [@uploadToggle]=\"uploadState\">\n        <table class=\"adf-version-upload\" *ngIf=\"uploadState !== 'close' && !versionList.isLoading\">\n            <tr>\n                <td>\n                    <adf-version-upload\n                        id=\"adf-version-upload-button\"\n                        [node]=\"node\"\n                        [newFileVersion]=\"newFileVersion\"\n                        [currentVersion]=\"versionList?.versions[0]?.entry\"\n                        (success)=\"onUploadSuccess($event)\"\n                        (cancel)=\"onUploadCancel()\"\n                        (error)=\"onUploadError($event)\">\n                    </adf-version-upload>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <div class=\"adf-version-list-container\">\n        <div class=\"adf-version-list-table\">\n            <div>\n                <button mat-raised-button\n                        id=\"adf-show-version-upload-button\"\n                        (click)=\"toggleNewVersion()\" color=\"primary\"\n                        *ngIf=\"uploadState ==='close'\">{{\n                    'ADF_VERSION_LIST.ACTIONS.UPLOAD.ADD'|\n                    translate }}\n                </button>\n            </div>\n            <div>\n\n                <adf-version-list\n                    #versionList\n                    [node]=\"node\"\n                    [allowDownload]=\"allowDownload\"\n                    [showComments]=\"showComments\"\n                    (deleted)=\"refresh($event)\"\n                    (restored)=\"refresh($event)\"\n                    (viewVersion)=\"onViewVersion($event)\">\n                </adf-version-list>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["adf-version-manager .mat-list .mat-3-line{height:auto!important;width:100%!important}adf-version-manager .mat-list-item-content{padding:16px 0!important}.adf-version-list-item-comment.mat-line{height:100%;word-break:break-all;white-space:unset!important;overflow:unset!important}.adf-button.adf-upload-new-version{box-shadow:none;width:100%;height:175px;float:left;position:relative}.adf-new-version-uploader-container{padding:16px 0;width:100%;height:0;float:left!important;position:relative}.adf-new-version-container{height:inherit;overflow:hidden}.adf-version-list-table,.adf-version-upload-table{width:100%}.adf-version-list{width:100%!important;float:left!important}\n"] }]
        }], ctorParameters: function () { return [{ type: ContentService }, { type: NodesApiService }]; }, propDecorators: { node: [{
                type: Input
            }], newFileVersion: [{
                type: Input
            }], showComments: [{
                type: Input
            }], showVersionComparison: [{
                type: Input
            }], allowDownload: [{
                type: Input
            }], uploadSuccess: [{
                type: Output
            }], uploadError: [{
                type: Output
            }], uploadCancel: [{
                type: Output
            }], viewVersion: [{
                type: Output
            }], versionListComponent: [{
                type: ViewChild,
                args: ['versionList', { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionCompatibilityModule {
}
VersionCompatibilityModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VersionCompatibilityModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityModule, declarations: [VersionCompatibilityDirective], imports: [CommonModule], exports: [VersionCompatibilityDirective] });
VersionCompatibilityModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionCompatibilityModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [VersionCompatibilityDirective],
                    declarations: [VersionCompatibilityDirective]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VersionManagerModule {
}
VersionManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VersionManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: VersionManagerModule, declarations: [VersionUploadComponent,
        VersionManagerComponent,
        VersionListComponent,
        VersionComparisonComponent], imports: [CommonModule,
        MaterialModule,
        CoreModule,
        UploadModule,
        VersionCompatibilityModule,
        FormsModule], exports: [VersionUploadComponent,
        VersionManagerComponent,
        VersionListComponent,
        FormsModule,
        VersionComparisonComponent] });
VersionManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionManagerModule, imports: [CommonModule,
        MaterialModule,
        CoreModule,
        UploadModule,
        VersionCompatibilityModule,
        FormsModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: VersionManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        CoreModule,
                        UploadModule,
                        VersionCompatibilityModule,
                        FormsModule
                    ],
                    exports: [
                        VersionUploadComponent,
                        VersionManagerComponent,
                        VersionListComponent,
                        FormsModule,
                        VersionComparisonComponent
                    ],
                    declarations: [
                        VersionUploadComponent,
                        VersionManagerComponent,
                        VersionListComponent,
                        VersionComparisonComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentNodeSelectorModule {
}
ContentNodeSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentNodeSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorModule, declarations: [ContentNodeSelectorPanelComponent,
        NameLocationCellComponent,
        ContentNodeSelectorComponent], imports: [FormsModule,
        ReactiveFormsModule,
        CoreModule,
        CommonModule,
        MaterialModule,
        SitesDropdownModule,
        BreadcrumbModule,
        SearchModule,
        DocumentListModule,
        UploadModule,
        ContentDirectiveModule], exports: [ContentNodeSelectorPanelComponent,
        NameLocationCellComponent,
        ContentNodeSelectorComponent] });
ContentNodeSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorModule, providers: [SearchQueryBuilderService], imports: [FormsModule,
        ReactiveFormsModule,
        CoreModule,
        CommonModule,
        MaterialModule,
        SitesDropdownModule,
        BreadcrumbModule,
        SearchModule,
        DocumentListModule,
        UploadModule,
        ContentDirectiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        ReactiveFormsModule,
                        CoreModule,
                        CommonModule,
                        MaterialModule,
                        SitesDropdownModule,
                        BreadcrumbModule,
                        SearchModule,
                        DocumentListModule,
                        UploadModule,
                        ContentDirectiveModule
                    ],
                    exports: [
                        ContentNodeSelectorPanelComponent,
                        NameLocationCellComponent,
                        ContentNodeSelectorComponent
                    ],
                    declarations: [
                        ContentNodeSelectorPanelComponent,
                        NameLocationCellComponent,
                        ContentNodeSelectorComponent
                    ],
                    providers: [SearchQueryBuilderService]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const I18N_ERRORS_PATH = 'CORE.FOLDER_DIALOG.FOLDER_NAME.ERRORS';
const forbidSpecialCharacters = ({ value }) => {
    const specialCharacters = /([\*\"\<\>\\\/\?\:\|])/;
    const isValid = !specialCharacters.test(value);
    return (isValid) ? null : {
        message: `${I18N_ERRORS_PATH}.SPECIAL_CHARACTERS`
    };
};
const forbidEndingDot = ({ value }) => {
    const isValid = ((value || '').trim().split('').pop() !== '.');
    return isValid ? null : {
        message: `${I18N_ERRORS_PATH}.ENDING_DOT`
    };
};
const forbidOnlySpaces = ({ value }) => {
    const isValid = !!((value || '')).trim();
    return isValid ? null : {
        message: `${I18N_ERRORS_PATH}.ONLY_SPACES`
    };
};

class FolderDialogComponent {
    constructor(formBuilder, dialog, nodesApi, translation, data) {
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.nodesApi = nodesApi;
        this.translation = translation;
        this.data = data;
        this.folder = null;
        /** Emitted when the edit/create folder give error for example a folder with same name already exist
         */
        this.error = new EventEmitter();
        /** Emitted when the edit/create folder is successfully created/modified
         */
        this.success = new EventEmitter();
        this.editTitle = 'CORE.FOLDER_DIALOG.EDIT_FOLDER_TITLE';
        this.createTitle = 'CORE.FOLDER_DIALOG.CREATE_FOLDER_TITLE';
        this.nodeType = 'cm:folder';
        if (data) {
            this.editTitle = data.editTitle || this.editTitle;
            this.createTitle = data.createTitle || this.createTitle;
            this.nodeType = data.nodeType || this.nodeType;
        }
    }
    get editing() {
        return !!this.data.folder;
    }
    ngOnInit() {
        const { folder } = this.data;
        let name = '';
        let title = '';
        let description = '';
        if (folder) {
            const { properties } = folder;
            name = folder.name || '';
            title = properties?.['cm:title'] ?? '';
            description = properties?.['cm:description'] ?? '';
        }
        const validators = {
            name: [
                Validators.required,
                forbidSpecialCharacters,
                forbidEndingDot,
                forbidOnlySpaces
            ]
        };
        this.form = this.formBuilder.group({
            name: [name, validators.name],
            title: [title],
            description: [description]
        });
    }
    get name() {
        const { name } = this.form.value;
        return (name || '').trim();
    }
    get title() {
        const { title } = this.form.value;
        return (title || '').trim();
    }
    get description() {
        const { description } = this.form.value;
        return (description || '').trim();
    }
    get properties() {
        const { title, description } = this;
        return {
            'cm:title': title,
            'cm:description': description
        };
    }
    create() {
        const { name, properties, nodeType, nodesApi, data: { parentNodeId } } = this;
        return nodesApi.createFolder(parentNodeId, { name, properties, nodeType });
    }
    edit() {
        const { name, properties, nodesApi, data: { folder: { id: nodeId } } } = this;
        return nodesApi.updateNode(nodeId, { name, properties });
    }
    submit() {
        const { form, dialog, editing } = this;
        if (!form.valid) {
            return;
        }
        (editing ? this.edit() : this.create())
            .subscribe((folder) => {
            this.success.emit(folder);
            dialog.close(folder);
        }, (error) => this.handleError(error));
    }
    handleError(error) {
        let errorMessage = 'CORE.MESSAGES.ERRORS.GENERIC';
        try {
            const { error: { statusCode } } = JSON.parse(error.message);
            if (statusCode === 409) {
                errorMessage = 'CORE.MESSAGES.ERRORS.EXISTENT_FOLDER';
            }
        }
        catch (err) { /* Do nothing, keep the original message */ }
        this.error.emit(this.translation.instant(errorMessage));
        return error;
    }
}
FolderDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderDialogComponent, deps: [{ token: i2$2.UntypedFormBuilder }, { token: i1$1.MatDialogRef }, { token: NodesApiService }, { token: i1.TranslationService }, { token: MAT_DIALOG_DATA, optional: true }], target: i0.ɵɵFactoryTarget.Component });
FolderDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: FolderDialogComponent, selector: "adf-folder-dialog", outputs: { error: "error", success: "success" }, ngImport: i0, template: "<h2 mat-dialog-title>\n    {{ (editing ? editTitle : createTitle) | translate }}\n</h2>\n\n<mat-dialog-content>\n    <form [formGroup]=\"form\" (submit)=\"submit()\">\n        <mat-form-field class=\"adf-full-width\">\n            <input\n                id=\"adf-folder-name-input\"\n                placeholder=\"{{ 'CORE.FOLDER_DIALOG.FOLDER_NAME.LABEL' | translate }}\"\n                [attr.aria-label]=\"'CORE.FOLDER_DIALOG.FOLDER_NAME.LABEL' | translate\"\n                matInput\n                required\n                [formControlName]=\"'name'\"\n                adf-auto-focus\n            />\n\n            <mat-hint *ngIf=\"form.controls['name'].dirty\">\n                <span *ngIf=\"form.controls['name'].errors?.required\">\n                    {{ 'CORE.FOLDER_DIALOG.FOLDER_NAME.ERRORS.REQUIRED' | translate }}\n                </span>\n\n                <span *ngIf=\"!form.controls['name'].errors?.required && form.controls['name'].errors?.message\">\n                    {{ form.controls['name'].errors?.message | translate }}\n                </span>\n            </mat-hint>\n        </mat-form-field>\n\n        <mat-form-field class=\"adf-full-width\">\n            <input\n                id=\"adf-folder-title-input\"\n                matInput\n                placeholder=\"{{ 'CORE.FOLDER_DIALOG.FOLDER_TITLE.LABEL' | translate }}\"\n                [attr.aria-label]=\"'CORE.FOLDER_DIALOG.FOLDER_TITLE.LABEL' | translate\"\n                [formControlName]=\"'title'\"\n            />\n        </mat-form-field>\n\n        <mat-form-field class=\"adf-full-width\">\n            <textarea\n                id=\"adf-folder-description-input\"\n                matInput\n                placeholder=\"{{ 'CORE.FOLDER_DIALOG.FOLDER_DESCRIPTION.LABEL' | translate }}\"\n                [attr.aria-label]=\"'CORE.FOLDER_DIALOG.FOLDER_DESCRIPTION.LABEL' | translate\"\n                rows=\"4\"\n                [formControlName]=\"'description'\">\n            </textarea>\n        </mat-form-field>\n    </form>\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-dialog-buttons\">\n    <span class=\"adf-fill-remaining-space\"></span>\n\n    <button\n        mat-button\n        id=\"adf-folder-cancel-button\"\n        mat-dialog-close>\n        {{ 'CORE.FOLDER_DIALOG.CANCEL_BUTTON.LABEL' | translate }}\n    </button>\n\n    <button class=\"adf-dialog-action-button\"\n            id=\"adf-folder-create-button\"\n            mat-button\n            (click)=\"submit()\"\n            [disabled]=\"!form.valid\">\n        {{\n        (editing\n        ? 'CORE.FOLDER_DIALOG.UPDATE_BUTTON.LABEL'\n        : 'CORE.FOLDER_DIALOG.CREATE_BUTTON.LABEL'\n        ) | translate\n        }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-fill-remaining-space{flex:1 1 auto}.adf-full-width,.adf-lock-file-name .mat-checkbox-layout{width:100%}.adf-lock-file-name .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden}.adf-lock-file-name .mat-checkbox-inner-container{margin:auto 8px auto 0}.adf-dialog-buttons button{text-transform:uppercase}.adf-dialog-action-button:enabled{color:var(--theme-primary-color)}.adf-dialog-action-button:disabled>span{color:var(--adf-theme-foreground-text-color-054)}@media screen and (max-width: 380px){.mat-form-field{font-size:6px}.mat-dialog-title{margin:0}.adf-dialog-buttons{padding:0}}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: AutoFocusDirective, selector: "[adf-auto-focus]" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-folder-dialog', encapsulation: ViewEncapsulation.None, template: "<h2 mat-dialog-title>\n    {{ (editing ? editTitle : createTitle) | translate }}\n</h2>\n\n<mat-dialog-content>\n    <form [formGroup]=\"form\" (submit)=\"submit()\">\n        <mat-form-field class=\"adf-full-width\">\n            <input\n                id=\"adf-folder-name-input\"\n                placeholder=\"{{ 'CORE.FOLDER_DIALOG.FOLDER_NAME.LABEL' | translate }}\"\n                [attr.aria-label]=\"'CORE.FOLDER_DIALOG.FOLDER_NAME.LABEL' | translate\"\n                matInput\n                required\n                [formControlName]=\"'name'\"\n                adf-auto-focus\n            />\n\n            <mat-hint *ngIf=\"form.controls['name'].dirty\">\n                <span *ngIf=\"form.controls['name'].errors?.required\">\n                    {{ 'CORE.FOLDER_DIALOG.FOLDER_NAME.ERRORS.REQUIRED' | translate }}\n                </span>\n\n                <span *ngIf=\"!form.controls['name'].errors?.required && form.controls['name'].errors?.message\">\n                    {{ form.controls['name'].errors?.message | translate }}\n                </span>\n            </mat-hint>\n        </mat-form-field>\n\n        <mat-form-field class=\"adf-full-width\">\n            <input\n                id=\"adf-folder-title-input\"\n                matInput\n                placeholder=\"{{ 'CORE.FOLDER_DIALOG.FOLDER_TITLE.LABEL' | translate }}\"\n                [attr.aria-label]=\"'CORE.FOLDER_DIALOG.FOLDER_TITLE.LABEL' | translate\"\n                [formControlName]=\"'title'\"\n            />\n        </mat-form-field>\n\n        <mat-form-field class=\"adf-full-width\">\n            <textarea\n                id=\"adf-folder-description-input\"\n                matInput\n                placeholder=\"{{ 'CORE.FOLDER_DIALOG.FOLDER_DESCRIPTION.LABEL' | translate }}\"\n                [attr.aria-label]=\"'CORE.FOLDER_DIALOG.FOLDER_DESCRIPTION.LABEL' | translate\"\n                rows=\"4\"\n                [formControlName]=\"'description'\">\n            </textarea>\n        </mat-form-field>\n    </form>\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-dialog-buttons\">\n    <span class=\"adf-fill-remaining-space\"></span>\n\n    <button\n        mat-button\n        id=\"adf-folder-cancel-button\"\n        mat-dialog-close>\n        {{ 'CORE.FOLDER_DIALOG.CANCEL_BUTTON.LABEL' | translate }}\n    </button>\n\n    <button class=\"adf-dialog-action-button\"\n            id=\"adf-folder-create-button\"\n            mat-button\n            (click)=\"submit()\"\n            [disabled]=\"!form.valid\">\n        {{\n        (editing\n        ? 'CORE.FOLDER_DIALOG.UPDATE_BUTTON.LABEL'\n        : 'CORE.FOLDER_DIALOG.CREATE_BUTTON.LABEL'\n        ) | translate\n        }}\n    </button>\n</mat-dialog-actions>\n", styles: [".adf-fill-remaining-space{flex:1 1 auto}.adf-full-width,.adf-lock-file-name .mat-checkbox-layout{width:100%}.adf-lock-file-name .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden}.adf-lock-file-name .mat-checkbox-inner-container{margin:auto 8px auto 0}.adf-dialog-buttons button{text-transform:uppercase}.adf-dialog-action-button:enabled{color:var(--theme-primary-color)}.adf-dialog-action-button:disabled>span{color:var(--adf-theme-foreground-text-color-054)}@media screen and (max-width: 380px){.mat-form-field{font-size:6px}.mat-dialog-title{margin:0}.adf-dialog-buttons{padding:0}}\n"] }]
        }], ctorParameters: function () { return [{ type: i2$2.UntypedFormBuilder }, { type: i1$1.MatDialogRef }, { type: NodesApiService }, { type: i1.TranslationService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { error: [{
                type: Output
            }], success: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LibraryDialogComponent {
    constructor(alfrescoApiService, sitesService, formBuilder, dialog) {
        this.alfrescoApiService = alfrescoApiService;
        this.sitesService = sitesService;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
        /** Emitted when the new library is created successfully. The
         * event parameter is a SiteEntry object with the details of the
         * newly-created library.
         */
        this.success = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.createTitle = 'LIBRARY.DIALOG.CREATE_TITLE';
        this.libraryTitleExists = false;
        this.visibilityOptions = [
            { value: 'PUBLIC', label: 'LIBRARY.VISIBILITY.PUBLIC', disabled: false },
            { value: 'PRIVATE', label: 'LIBRARY.VISIBILITY.PRIVATE', disabled: false },
            {
                value: 'MODERATED',
                label: 'LIBRARY.VISIBILITY.MODERATED',
                disabled: false
            }
        ];
        this.disableCreateButton = false;
    }
    get queriesApi() {
        this._queriesApi = this._queriesApi ?? new QueriesApi(this.alfrescoApiService.getInstance());
        return this._queriesApi;
    }
    ngOnInit() {
        const validators = {
            id: [
                Validators.required,
                Validators.maxLength(72),
                this.forbidSpecialCharacters
            ],
            title: [
                Validators.required,
                this.forbidOnlySpaces,
                Validators.minLength(2),
                Validators.maxLength(256)
            ],
            description: [Validators.maxLength(512)]
        };
        this.form = this.formBuilder.group({
            title: [null, validators.title],
            id: [null, validators.id, this.createSiteIdValidator()],
            description: ['', validators.description]
        });
        this.visibilityOption = this.visibilityOptions[0].value;
        this.form.controls['title'].valueChanges
            .pipe(debounceTime(500), mergeMap((title) => this.checkLibraryNameExists(title), (title) => title), takeUntil(this.onDestroy$))
            .subscribe((title) => {
            if (!this.form.controls['id'].dirty && this.canGenerateId(title)) {
                this.form.patchValue({ id: this.sanitize(title.trim()) });
                this.form.controls['id'].markAsTouched();
            }
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    get title() {
        const { title } = this.form.value;
        return (title || '').trim();
    }
    get id() {
        const { id } = this.form.value;
        return (id || '').trim();
    }
    get description() {
        const { description } = this.form.value;
        return (description || '').trim();
    }
    get visibility() {
        return this.visibilityOption || '';
    }
    submit() {
        const { form, dialog } = this;
        if (!form.valid) {
            return;
        }
        this.disableCreateButton = true;
        this.create().pipe(finalize(() => this.disableCreateButton = false)).subscribe((node) => {
            this.success.emit(node);
            dialog.close(node);
        }, (error) => this.handleError(error));
    }
    visibilityChangeHandler(event) {
        this.visibilityOption = event.value;
    }
    create() {
        const { title, id, description, visibility } = this;
        const siteBody = {
            id,
            title,
            description,
            visibility
        };
        return this.sitesService.createSite(siteBody);
    }
    sanitize(input) {
        return input.replace(/[\s\s]+/g, '-').replace(/[^A-Za-z0-9-]/g, '');
    }
    canGenerateId(title) {
        return Boolean(title.replace(/[^A-Za-z0-9-]/g, '').length);
    }
    handleError(error) {
        try {
            const { error: { statusCode } } = JSON.parse(error.message);
            if (statusCode === 409) {
                this.form.controls['id'].setErrors({
                    message: 'LIBRARY.ERRORS.CONFLICT'
                });
            }
        }
        catch {
        }
        return error;
    }
    async checkLibraryNameExists(libraryTitle) {
        let entries = [];
        try {
            entries = (await this.findLibraryByTitle(libraryTitle)).list.entries;
        }
        catch {
            entries = [];
        }
        if (entries.length) {
            this.libraryTitleExists = entries[0].entry.title.toLowerCase() === libraryTitle.toLowerCase();
        }
        else {
            this.libraryTitleExists = false;
        }
    }
    findLibraryByTitle(libraryTitle) {
        return this.queriesApi.findSites(libraryTitle, {
            maxItems: 1,
            fields: ['title']
        });
    }
    forbidSpecialCharacters({ value }) {
        if (value === null || value.length === 0) {
            return null;
        }
        const validCharacters = /[^A-Za-z0-9-]/;
        const isValid = !validCharacters.test(value);
        return isValid
            ? null
            : {
                message: 'LIBRARY.ERRORS.ILLEGAL_CHARACTERS'
            };
    }
    forbidOnlySpaces({ value }) {
        if (value === null || value.length === 0) {
            return null;
        }
        const isValid = !!(value || '').trim();
        return isValid
            ? null
            : {
                message: 'LIBRARY.ERRORS.ONLY_SPACES'
            };
    }
    createSiteIdValidator() {
        let timer;
        return (control) => {
            if (timer) {
                clearTimeout(timer);
            }
            return new Promise((resolve) => {
                timer = setTimeout(() => this.sitesService.getSite(control.value).subscribe(() => resolve({ message: 'LIBRARY.ERRORS.EXISTENT_SITE' }), () => resolve(null)), 300);
            });
        };
    }
}
LibraryDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryDialogComponent, deps: [{ token: i1.AlfrescoApiService }, { token: SitesService }, { token: i2$2.UntypedFormBuilder }, { token: i1$1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
LibraryDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: LibraryDialogComponent, selector: "adf-library-dialog", outputs: { error: "error", success: "success" }, host: { classAttribute: "adf-library-dialog" }, ngImport: i0, template: "<h2 mat-dialog-title>{{ createTitle | translate }}</h2>\n\n<mat-dialog-content>\n  <form novalidate [formGroup]=\"form\" (submit)=\"submit()\">\n    <mat-form-field>\n      <input\n        placeholder=\"{{ 'LIBRARY.DIALOG.FORM.NAME' | translate }}\"\n        required\n        matInput\n        formControlName=\"title\"\n        autocomplete=\"off\"\n        adf-auto-focus\n      />\n\n      <mat-hint *ngIf=\"libraryTitleExists\">{{\n        'LIBRARY.HINTS.SITE_TITLE_EXISTS' | translate\n      }}</mat-hint>\n      <mat-error *ngIf=\"form.controls['title'].hasError('maxlength')\">\n        {{ 'LIBRARY.ERRORS.TITLE_TOO_LONG' | translate }}\n      </mat-error>\n\n      <mat-error *ngIf=\"form.controls['title'].hasError('minlength')\">\n        {{ 'LIBRARY.ERRORS.TITLE_TOO_SHORT' | translate }}\n      </mat-error>\n\n      <mat-error *ngIf=\"form.controls['title'].errors?.message\">\n        {{ form.controls['title'].errors?.message | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n      <input\n        required\n        placeholder=\"{{ 'LIBRARY.DIALOG.FORM.SITE_ID' | translate }}\"\n        matInput\n        formControlName=\"id\"\n        autocomplete=\"off\"\n      />\n\n      <mat-error *ngIf=\"form.controls['id'].errors?.message\">\n        {{ form.controls['id'].errors?.message | translate }}\n      </mat-error>\n\n      <mat-error *ngIf=\"form.controls['id'].hasError('maxlength')\">\n        {{ 'LIBRARY.ERRORS.ID_TOO_LONG' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n      <textarea\n        matInput\n        placeholder=\"{{ 'LIBRARY.DIALOG.FORM.DESCRIPTION' | translate }}\"\n        rows=\"3\"\n        formControlName=\"description\"\n      ></textarea>\n\n      <mat-error *ngIf=\"form.controls['description'].hasError('maxlength')\">\n        {{ 'LIBRARY.ERRORS.DESCRIPTION_TOO_LONG' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-radio-group\n      [ngModelOptions]=\"{ standalone: true }\"\n      [(ngModel)]=\"visibilityOption\"\n      (change)=\"visibilityChangeHandler($event)\"\n    >\n      <mat-radio-button\n        color=\"primary\"\n        [disabled]=\"option.disabled\"\n        *ngFor=\"let option of visibilityOptions\"\n        [attr.data-automation-id]=\"option.value\"\n        [value]=\"option.value\"\n        [checked]=\"visibilityOption.value === option.value\"\n      >\n        {{ option.label | translate }}\n      </mat-radio-button>\n    </mat-radio-group>\n  </form>\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-action-buttons\">\n  <button mat-button mat-dialog-close data-automation-id=\"cancel-library-id\">\n    {{ 'LIBRARY.DIALOG.CANCEL' | translate }}\n  </button>\n\n  <button\n    color=\"primary\"\n    mat-button\n    (click)=\"submit()\"\n    [disabled]=\"!form.valid || disableCreateButton\"\n    data-automation-id=\"create-library-id\"\n  >\n    {{ 'LIBRARY.DIALOG.CREATE' | translate }}\n  </button>\n</mat-dialog-actions>\n", styles: [".adf-library-dialog .mat-radio-group{display:flex;flex-direction:column;margin:0 0 20px}.adf-library-dialog .mat-radio-group .mat-radio-button{margin:10px 0}.adf-library-dialog .mat-form-field{width:100%}.adf-library-dialog mat-form-field{padding-top:20px}.adf-library-dialog .adf-action-buttons{display:flex;flex-direction:row;justify-content:flex-end}.adf-library-dialog .adf-action-buttons .mat-button{text-transform:uppercase}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i5$2.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i5$2.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: AutoFocusDirective, selector: "[adf-auto-focus]" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: LibraryDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-library-dialog', encapsulation: ViewEncapsulation.None, host: { class: 'adf-library-dialog' }, template: "<h2 mat-dialog-title>{{ createTitle | translate }}</h2>\n\n<mat-dialog-content>\n  <form novalidate [formGroup]=\"form\" (submit)=\"submit()\">\n    <mat-form-field>\n      <input\n        placeholder=\"{{ 'LIBRARY.DIALOG.FORM.NAME' | translate }}\"\n        required\n        matInput\n        formControlName=\"title\"\n        autocomplete=\"off\"\n        adf-auto-focus\n      />\n\n      <mat-hint *ngIf=\"libraryTitleExists\">{{\n        'LIBRARY.HINTS.SITE_TITLE_EXISTS' | translate\n      }}</mat-hint>\n      <mat-error *ngIf=\"form.controls['title'].hasError('maxlength')\">\n        {{ 'LIBRARY.ERRORS.TITLE_TOO_LONG' | translate }}\n      </mat-error>\n\n      <mat-error *ngIf=\"form.controls['title'].hasError('minlength')\">\n        {{ 'LIBRARY.ERRORS.TITLE_TOO_SHORT' | translate }}\n      </mat-error>\n\n      <mat-error *ngIf=\"form.controls['title'].errors?.message\">\n        {{ form.controls['title'].errors?.message | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n      <input\n        required\n        placeholder=\"{{ 'LIBRARY.DIALOG.FORM.SITE_ID' | translate }}\"\n        matInput\n        formControlName=\"id\"\n        autocomplete=\"off\"\n      />\n\n      <mat-error *ngIf=\"form.controls['id'].errors?.message\">\n        {{ form.controls['id'].errors?.message | translate }}\n      </mat-error>\n\n      <mat-error *ngIf=\"form.controls['id'].hasError('maxlength')\">\n        {{ 'LIBRARY.ERRORS.ID_TOO_LONG' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-form-field>\n      <textarea\n        matInput\n        placeholder=\"{{ 'LIBRARY.DIALOG.FORM.DESCRIPTION' | translate }}\"\n        rows=\"3\"\n        formControlName=\"description\"\n      ></textarea>\n\n      <mat-error *ngIf=\"form.controls['description'].hasError('maxlength')\">\n        {{ 'LIBRARY.ERRORS.DESCRIPTION_TOO_LONG' | translate }}\n      </mat-error>\n    </mat-form-field>\n\n    <mat-radio-group\n      [ngModelOptions]=\"{ standalone: true }\"\n      [(ngModel)]=\"visibilityOption\"\n      (change)=\"visibilityChangeHandler($event)\"\n    >\n      <mat-radio-button\n        color=\"primary\"\n        [disabled]=\"option.disabled\"\n        *ngFor=\"let option of visibilityOptions\"\n        [attr.data-automation-id]=\"option.value\"\n        [value]=\"option.value\"\n        [checked]=\"visibilityOption.value === option.value\"\n      >\n        {{ option.label | translate }}\n      </mat-radio-button>\n    </mat-radio-group>\n  </form>\n</mat-dialog-content>\n\n<mat-dialog-actions class=\"adf-action-buttons\">\n  <button mat-button mat-dialog-close data-automation-id=\"cancel-library-id\">\n    {{ 'LIBRARY.DIALOG.CANCEL' | translate }}\n  </button>\n\n  <button\n    color=\"primary\"\n    mat-button\n    (click)=\"submit()\"\n    [disabled]=\"!form.valid || disableCreateButton\"\n    data-automation-id=\"create-library-id\"\n  >\n    {{ 'LIBRARY.DIALOG.CREATE' | translate }}\n  </button>\n</mat-dialog-actions>\n", styles: [".adf-library-dialog .mat-radio-group{display:flex;flex-direction:column;margin:0 0 20px}.adf-library-dialog .mat-radio-group .mat-radio-button{margin:10px 0}.adf-library-dialog .mat-form-field{width:100%}.adf-library-dialog mat-form-field{padding-top:20px}.adf-library-dialog .adf-action-buttons{display:flex;flex-direction:row;justify-content:flex-end}.adf-library-dialog .adf-action-buttons .mat-button{text-transform:uppercase}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: SitesService }, { type: i2$2.UntypedFormBuilder }, { type: i1$1.MatDialogRef }]; }, propDecorators: { error: [{
                type: Output
            }], success: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DownloadZipDialogModule {
}
DownloadZipDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DownloadZipDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipDialogModule, declarations: [DownloadZipDialogComponent], imports: [CommonModule,
        PipeModule,
        MatDialogModule,
        MatProgressBarModule,
        MatButtonModule,
        TranslateModule], exports: [DownloadZipDialogComponent] });
DownloadZipDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipDialogModule, imports: [CommonModule,
        PipeModule,
        MatDialogModule,
        MatProgressBarModule,
        MatButtonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DownloadZipDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DownloadZipDialogComponent],
                    imports: [
                        CommonModule,
                        PipeModule,
                        MatDialogModule,
                        MatProgressBarModule,
                        MatButtonModule,
                        TranslateModule
                    ],
                    exports: [DownloadZipDialogComponent]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DialogModule {
}
DialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: DialogModule, declarations: [FolderDialogComponent,
        NodeLockDialogComponent,
        ConfirmDialogComponent,
        LibraryDialogComponent], imports: [CommonModule,
        MaterialModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        MatMomentDatetimeModule,
        MatDatetimepickerModule,
        ContentDirectiveModule,
        DownloadZipDialogModule], exports: [FolderDialogComponent,
        NodeLockDialogComponent,
        ConfirmDialogComponent,
        LibraryDialogComponent] });
DialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DialogModule, imports: [CommonModule,
        MaterialModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        MatMomentDatetimeModule,
        MatDatetimepickerModule,
        ContentDirectiveModule,
        DownloadZipDialogModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        CoreModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatMomentDatetimeModule,
                        MatDatetimepickerModule,
                        ContentDirectiveModule,
                        DownloadZipDialogModule
                    ],
                    declarations: [
                        FolderDialogComponent,
                        NodeLockDialogComponent,
                        ConfirmDialogComponent,
                        LibraryDialogComponent
                    ],
                    exports: [
                        FolderDialogComponent,
                        NodeLockDialogComponent,
                        ConfirmDialogComponent,
                        LibraryDialogComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_FOLDER_PARENT_ID = '-my-';
const DIALOG_WIDTH$1 = 400;
class FolderCreateDirective {
    constructor(dialogRef, content) {
        this.dialogRef = dialogRef;
        this.content = content;
        /** Parent folder where the new folder will be located after creation. */
        this.parentNodeId = DEFAULT_FOLDER_PARENT_ID;
        /** Title of folder creation dialog. */
        this.title = null;
        /** Type of node to create. */
        this.nodeType = 'cm:folder';
        /** Emitted when an error occurs (eg, a folder with same name already exists). */
        this.error = new EventEmitter();
        /** Emitted when the folder is created successfully. */
        this.success = new EventEmitter();
    }
    onClick(event) {
        event.preventDefault();
        this.openDialog();
    }
    get dialogConfig() {
        const { parentNodeId, title: createTitle, nodeType } = this;
        return {
            data: { parentNodeId, createTitle, nodeType },
            width: `${DIALOG_WIDTH$1}px`
        };
    }
    openDialog() {
        const { dialogRef, dialogConfig, content } = this;
        const dialogInstance = dialogRef.open(FolderDialogComponent, dialogConfig);
        dialogInstance.componentInstance.error.subscribe((error) => {
            this.error.emit(error);
        });
        dialogInstance.componentInstance.success.subscribe((node) => {
            this.success.emit(node);
        });
        dialogInstance.afterClosed().subscribe((node) => {
            if (node) {
                content.folderCreate.next(node);
            }
        });
    }
}
FolderCreateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderCreateDirective, deps: [{ token: i1$1.MatDialog }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Directive });
FolderCreateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: FolderCreateDirective, selector: "[adf-create-folder]", inputs: { parentNodeId: ["adf-create-folder", "parentNodeId"], title: "title", nodeType: "nodeType" }, outputs: { error: "error", success: "success" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderCreateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-create-folder]'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: ContentService }]; }, propDecorators: { parentNodeId: [{
                type: Input,
                args: ['adf-create-folder']
            }], title: [{
                type: Input
            }], nodeType: [{
                type: Input
            }], error: [{
                type: Output
            }], success: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DIALOG_WIDTH = 400;
class FolderEditDirective {
    constructor(dialogRef, elementRef, content) {
        this.dialogRef = dialogRef;
        this.elementRef = elementRef;
        this.content = content;
        /** Emitted when an error occurs (eg, a folder with same name already exists). */
        this.error = new EventEmitter();
        /** Title of folder edit dialog. */
        this.title = null;
        /** Emitted when the folder has been edited successfully. */
        this.success = new EventEmitter();
    }
    onClick(event) {
        event.preventDefault();
        if (this.folder) {
            this.openDialog();
        }
    }
    get dialogConfig() {
        const { folder } = this;
        return {
            data: {
                folder,
                editTitle: this.title
            },
            width: `${DIALOG_WIDTH}px`
        };
    }
    openDialog() {
        const { dialogRef, dialogConfig, content } = this;
        const dialogInstance = dialogRef.open(FolderDialogComponent, dialogConfig);
        dialogInstance.componentInstance.error.subscribe((error) => {
            this.error.emit(error);
        });
        dialogInstance.componentInstance.success.subscribe((node) => {
            this.success.emit(node);
        });
        dialogInstance.afterClosed().subscribe((node) => {
            if (node) {
                content.folderEdit.next(node);
            }
        });
    }
}
FolderEditDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderEditDirective, deps: [{ token: i1$1.MatDialog }, { token: i0.ElementRef }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Directive });
FolderEditDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: FolderEditDirective, selector: "[adf-edit-folder]", inputs: { folder: ["adf-edit-folder", "folder"], title: "title" }, outputs: { error: "error", success: "success" }, host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderEditDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-edit-folder]'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i0.ElementRef }, { type: ContentService }]; }, propDecorators: { folder: [{
                type: Input,
                args: ['adf-edit-folder']
            }], error: [{
                type: Output
            }], title: [{
                type: Input
            }], success: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FolderDirectiveModule {
}
FolderDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FolderDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: FolderDirectiveModule, declarations: [FolderCreateDirective,
        FolderEditDirective], imports: [CommonModule,
        MaterialModule], exports: [FolderCreateDirective,
        FolderEditDirective] });
FolderDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderDirectiveModule, imports: [CommonModule,
        MaterialModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FolderDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule
                    ],
                    declarations: [
                        FolderCreateDirective,
                        FolderEditDirective
                    ],
                    exports: [
                        FolderCreateDirective,
                        FolderEditDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BasicPropertiesService {
    constructor(fileSizePipe) {
        this.fileSizePipe = fileSizePipe;
    }
    getProperties(node) {
        const sizeInBytes = node.content ? node.content.sizeInBytes : '';
        const mimeTypeName = node.content ? node.content.mimeTypeName : '';
        const author = node.properties ? node.properties['cm:author'] : '';
        const description = node.properties ? node.properties['cm:description'] : '';
        const title = node.properties ? node.properties['cm:title'] : '';
        return [
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.NAME',
                value: node.name,
                key: 'properties.cm:name',
                editable: true
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.TITLE',
                value: title,
                key: 'properties.cm:title',
                editable: true
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.CREATOR',
                value: node.createdByUser.displayName,
                key: 'createdByUser.displayName',
                editable: false
            }),
            new CardViewDateItemModel({
                label: 'CORE.METADATA.BASIC.CREATED_DATE',
                value: node.createdAt,
                key: 'createdAt',
                editable: false,
                format: 'mediumDate'
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.SIZE',
                value: sizeInBytes,
                key: 'content.sizeInBytes',
                pipes: [{ pipe: this.fileSizePipe }],
                editable: false
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.MODIFIER',
                value: node.modifiedByUser.displayName,
                key: 'modifiedByUser.displayName',
                editable: false
            }),
            new CardViewDateItemModel({
                label: 'CORE.METADATA.BASIC.MODIFIED_DATE',
                value: node.modifiedAt,
                key: 'modifiedAt',
                editable: false,
                format: 'mediumDate'
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.MIMETYPE',
                value: mimeTypeName,
                key: 'content.mimeTypeName',
                editable: false
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.AUTHOR',
                value: author,
                key: 'properties.cm:author',
                editable: true
            }),
            new CardViewTextItemModel({
                label: 'CORE.METADATA.BASIC.DESCRIPTION',
                value: description,
                key: 'properties.cm:description',
                multiline: true,
                editable: true
            })
        ];
    }
}
BasicPropertiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BasicPropertiesService, deps: [{ token: i1.FileSizePipe }], target: i0.ɵɵFactoryTarget.Injectable });
BasicPropertiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BasicPropertiesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: BasicPropertiesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.FileSizePipe }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const D_TEXT = 'd:text';
const D_MLTEXT = 'd:mltext';
const D_DATE = 'd:date';
const D_DATETIME = 'd:datetime';
const D_INT = 'd:int';
const D_LONG = 'd:long';
const D_FLOAT = 'd:float';
const D_DOUBLE = 'd:double';
const D_BOOLEAN = 'd:boolean';
const RECOGNISED_ECM_TYPES = [D_TEXT, D_MLTEXT, D_DATE, D_DATETIME, D_INT, D_LONG, D_FLOAT, D_DOUBLE, D_BOOLEAN];
class PropertyGroupTranslatorService {
    constructor(logService, multiValuePipe, decimalNumberPipe, appConfig) {
        this.logService = logService;
        this.multiValuePipe = multiValuePipe;
        this.decimalNumberPipe = decimalNumberPipe;
        this.appConfig = appConfig;
        this.valueSeparator = this.appConfig.get('content-metadata.multi-value-pipe-separator');
    }
    translateToCardViewGroups(propertyGroups, propertyValues, definition) {
        return propertyGroups.map((propertyGroup) => {
            const translatedPropertyGroup = Object.assign({}, propertyGroup);
            translatedPropertyGroup.properties = this.translateArray(propertyGroup.properties, propertyValues, definition);
            return translatedPropertyGroup;
        });
    }
    translateProperty(property, startValue, allowEditing = false) {
        this.checkECMTypeValidity(property.dataType);
        const prefix = 'properties.';
        const propertyDefinition = {
            label: property.title || property.id,
            value: startValue ? startValue : property.defaultValue,
            key: `${prefix}${property.id}`,
            default: property.defaultValue,
            editable: property.isProtected ? false : allowEditing,
            constraints: property?.constraints
        };
        return this.transform(propertyDefinition, property.dataType, property.isMultiValued);
    }
    translateArray(properties, propertyValues, definition) {
        return properties.map((property) => this.translate(property, propertyValues, this.getPropertyConstraints(property.name, definition)));
    }
    translate(property, propertyValues, constraints) {
        let propertyValue;
        if (propertyValues && !this.isEmpty(propertyValues[property.name])) {
            propertyValue = propertyValues[property.name];
        }
        this.checkECMTypeValidity(property.dataType);
        const prefix = 'properties.';
        const propertyDefinition = {
            label: property.title || property.name,
            value: propertyValue,
            key: `${prefix}${property.name}`,
            default: property.defaultValue,
            editable: property.protected ? false : property.editable !== undefined ? property.editable : true,
            constraints
        };
        return this.transform(propertyDefinition, property.dataType, property.multiValued);
    }
    transform(propertyDefinition, dataType, isMultiValued) {
        let cardViewItemProperty;
        if (this.isListOfValues(propertyDefinition.constraints)) {
            const options = propertyDefinition.constraints[0].parameters.allowedValues.map((value) => ({ key: value, label: value }));
            const properties = Object.assign(propertyDefinition, { options$: of(options) });
            cardViewItemProperty = new CardViewSelectItemModel(properties);
        }
        else {
            switch (dataType) {
                case D_MLTEXT:
                    cardViewItemProperty = new CardViewTextItemModel(Object.assign(propertyDefinition, {
                        multiline: true
                    }));
                    break;
                case D_INT:
                case D_LONG:
                    cardViewItemProperty = new CardViewIntItemModel(Object.assign(propertyDefinition, {
                        multivalued: isMultiValued,
                        pipes: [{ pipe: this.multiValuePipe, params: [this.valueSeparator] }]
                    }));
                    break;
                case D_FLOAT:
                case D_DOUBLE:
                    cardViewItemProperty = new CardViewFloatItemModel(Object.assign(propertyDefinition, {
                        multivalued: isMultiValued,
                        pipes: [
                            { pipe: this.decimalNumberPipe },
                            { pipe: this.multiValuePipe, params: [this.valueSeparator] }
                        ]
                    }));
                    break;
                case D_DATE:
                    cardViewItemProperty = new CardViewDateItemModel(Object.assign(propertyDefinition, {
                        multivalued: isMultiValued,
                        pipes: [{ pipe: this.multiValuePipe, params: [this.valueSeparator] }]
                    }));
                    break;
                case D_DATETIME:
                    cardViewItemProperty = new CardViewDatetimeItemModel(Object.assign(propertyDefinition, {
                        multivalued: isMultiValued,
                        pipes: [{ pipe: this.multiValuePipe, params: [this.valueSeparator] }]
                    }));
                    break;
                case D_BOOLEAN:
                    cardViewItemProperty = new CardViewBoolItemModel(propertyDefinition);
                    break;
                case D_TEXT:
                default:
                    cardViewItemProperty = new CardViewTextItemModel(Object.assign(propertyDefinition, {
                        multivalued: isMultiValued,
                        multiline: isMultiValued,
                        pipes: [{ pipe: this.multiValuePipe, params: [this.valueSeparator] }]
                    }));
            }
        }
        return cardViewItemProperty;
    }
    isListOfValues(constraint) {
        return constraint?.[0]?.type === 'LIST';
    }
    getPropertyConstraints(propertyName, definition) {
        return definition?.properties.find((item) => item.id === propertyName)?.constraints ?? [];
    }
    checkECMTypeValidity(ecmPropertyType) {
        if (RECOGNISED_ECM_TYPES.indexOf(ecmPropertyType) === -1) {
            this.logService.error(`Unknown type for mapping: ${ecmPropertyType}`);
        }
    }
    isEmpty(value) {
        return value === undefined || value === null || value === '';
    }
}
PropertyGroupTranslatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PropertyGroupTranslatorService, deps: [{ token: i1.LogService }, { token: i1.MultiValuePipe }, { token: i1.DecimalNumberPipe }, { token: i1.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
PropertyGroupTranslatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PropertyGroupTranslatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PropertyGroupTranslatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.LogService }, { type: i1.MultiValuePipe }, { type: i1.DecimalNumberPipe }, { type: i1.AppConfigService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const emptyGroup = {
    properties: {}
};
const convertObjectToArray = (object) => Object.keys(object).map((key) => object[key]);
const getGroup = (propertyGroups, groupName) => propertyGroups[groupName];
const getProperty = (propertyGroups, groupName, propertyName) => {
    const groupDefinition = getGroup(propertyGroups, groupName) || emptyGroup;
    let propertyDefinitions;
    if (propertyName === '*') {
        propertyDefinitions = convertObjectToArray(groupDefinition.properties);
    }
    else {
        propertyDefinitions = groupDefinition.properties[propertyName];
    }
    return propertyDefinitions;
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AspectOrientedConfigService {
    constructor(config) {
        this.config = config;
    }
    isGroupAllowed(groupName) {
        if (this.isIncludeAllEnabled()) {
            return true;
        }
        const groupNames = Object.keys(this.config);
        return groupNames.indexOf(groupName) !== -1;
    }
    reorganiseByConfig(propertyGroups) {
        const aspects = this.config;
        const aspectNames = Object.keys(aspects);
        return aspectNames
            .reduce((groupAccumulator, aspectName) => {
            const newGroup = this.getOrganisedPropertyGroup(propertyGroups, aspectName);
            return groupAccumulator.concat(newGroup);
        }, [])
            .filter((organisedPropertyGroup) => organisedPropertyGroup.properties.length > 0);
    }
    appendAllPreset(propertyGroups) {
        const groups = Object.keys(propertyGroups)
            .map((groupName) => {
            const propertyGroup = propertyGroups[groupName];
            const properties = propertyGroup.properties;
            if (this.isAspectReadOnly(groupName)) {
                Object.keys(properties).map((propertyName) => this.setReadOnlyProperty(properties[propertyName]));
            }
            return Object.assign({}, propertyGroup, {
                properties: Object.keys(properties).map((propertyName) => {
                    if (this.isPropertyReadOnly(propertyName)) {
                        this.setReadOnlyProperty(properties[propertyName]);
                    }
                    return properties[propertyName];
                })
            });
        });
        return groups;
    }
    setReadOnlyProperty(property) {
        property.editable = false;
    }
    isPropertyReadOnly(propertyName) {
        const readOnlyAspects = this.config.readOnlyProperties;
        if (Array.isArray(readOnlyAspects)) {
            return readOnlyAspects.includes(propertyName);
        }
        else {
            return readOnlyAspects === propertyName;
        }
    }
    isAspectReadOnly(propertyGroupName) {
        const readOnlyAspects = this.config.readOnlyAspects;
        if (Array.isArray(readOnlyAspects)) {
            return readOnlyAspects.includes(propertyGroupName);
        }
        else {
            return readOnlyAspects === propertyGroupName;
        }
    }
    filterExcludedPreset(propertyGroups) {
        if (this.config.exclude) {
            return propertyGroups.filter((preset) => !this.config.exclude.includes(preset.name));
        }
        return propertyGroups;
    }
    isIncludeAllEnabled() {
        return this.config.includeAll;
    }
    getOrganisedPropertyGroup(propertyGroups, aspectName) {
        const group = getGroup(propertyGroups, aspectName);
        let newGroup = [];
        if (group) {
            const aspectProperties = this.config[aspectName];
            let properties;
            if (aspectProperties === '*') {
                properties = getProperty(propertyGroups, aspectName, aspectProperties);
            }
            else {
                properties = aspectProperties
                    .map((propertyName) => getProperty(propertyGroups, aspectName, propertyName))
                    .filter((props) => props !== undefined);
            }
            newGroup = [{ title: group.title, properties }];
        }
        return newGroup;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IndifferentConfigService {
    isGroupAllowed() {
        return true;
    }
    reorganiseByConfig(propertyGroups) {
        return Object.keys(propertyGroups)
            .map((groupName) => {
            const propertyGroup = propertyGroups[groupName];
            const properties = propertyGroup.properties;
            return Object.assign({}, propertyGroup, {
                properties: Object.keys(properties).map((propertyName) => properties[propertyName])
            });
        });
    }
    filterExcludedPreset(propertyGroups) {
        return propertyGroups;
    }
    appendAllPreset() {
        return [];
    }
    isIncludeAllEnabled() {
        return true;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class LayoutOrientedConfigService {
    constructor(config) {
        this.config = config;
    }
    isGroupAllowed(groupName) {
        if (this.isIncludeAllEnabled()) {
            return true;
        }
        return this.getMatchingGroups(groupName).length > 0;
    }
    reorganiseByConfig(propertyGroups) {
        const layoutBlocks = this.config.filter((itemsGroup) => itemsGroup.items);
        const organisedPropertyGroup = layoutBlocks.map((layoutBlock) => {
            const flattenedItems = this.flattenItems(layoutBlock.items);
            const properties = flattenedItems.reduce((props, explodedItem) => {
                const isProperty = typeof explodedItem.property === 'object';
                const propertyName = isProperty ? explodedItem.property.name : explodedItem.property;
                let property = getProperty(propertyGroups, explodedItem.groupName, propertyName) || [];
                if (isProperty) {
                    property = this.setPropertyTitle(property, explodedItem.property);
                }
                property = this.setEditableProperty(property, explodedItem);
                return props.concat(property);
            }, []);
            return {
                title: layoutBlock.title,
                properties
            };
        });
        return organisedPropertyGroup;
    }
    appendAllPreset(propertyGroups) {
        return Object.keys(propertyGroups)
            .map((groupName) => {
            const propertyGroup = propertyGroups[groupName];
            const properties = propertyGroup.properties;
            return Object.assign({}, propertyGroup, {
                properties: Object.keys(properties).map((propertyName) => properties[propertyName])
            });
        });
    }
    filterExcludedPreset(propertyGroups) {
        let excludedConfig = this.config
            .map((config) => config.exclude)
            .find((exclude) => exclude !== undefined);
        if (excludedConfig === undefined) {
            excludedConfig = [];
        }
        else if (typeof excludedConfig === 'string') {
            excludedConfig = [excludedConfig];
        }
        return propertyGroups.filter((props) => !excludedConfig.includes(props.name));
    }
    isIncludeAllEnabled() {
        const includeAllProperty = this.config
            .map((config) => config.includeAll)
            .find((includeAll) => includeAll !== undefined);
        return includeAllProperty !== undefined ? includeAllProperty : false;
    }
    setEditableProperty(propertyGroup, itemConfig) {
        if (Array.isArray(propertyGroup)) {
            propertyGroup.map((property) => property.editable = itemConfig.editable !== undefined ? itemConfig.editable : true);
        }
        else {
            propertyGroup.editable = itemConfig.editable !== undefined ? itemConfig.editable : true;
        }
        return propertyGroup;
    }
    setPropertyTitle(item, property) {
        if (!Array.isArray(item)) {
            return { ...item, ...(item.name === property.name && !!property.title) && { title: property.title } };
        }
        return item;
    }
    flattenItems(items) {
        return items.reduce((accumulator, item) => {
            const properties = Array.isArray(item.properties) ? item.properties : [item.properties];
            const flattenedProperties = properties.map((property) => ({
                groupName: item.aspect || item.type,
                property,
                editable: item.editable
            }));
            return accumulator.concat(flattenedProperties);
        }, []);
    }
    getMatchingGroups(groupName) {
        return this.config
            .map((layoutBlock) => layoutBlock.items)
            .reduce((accumulator, items) => accumulator.concat(items), [])
            .filter((item) => item.aspect === groupName || item.type === groupName);
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INDIFFERENT_PRESET = '*';
const DEFAULT_PRESET_NAME = 'default';
class ContentMetadataConfigFactory {
    constructor(appConfigService, logService) {
        this.appConfigService = appConfigService;
        this.logService = logService;
    }
    get(presetName = 'default') {
        let presetConfig;
        try {
            presetConfig = this.appConfigService.config['content-metadata'].presets[presetName];
        }
        catch {
            if (presetName !== DEFAULT_PRESET_NAME) {
                this.logService.error(`No content-metadata preset for: ${presetName}`);
            }
            presetConfig = INDIFFERENT_PRESET;
        }
        return this.createConfig(presetConfig);
    }
    createConfig(presetConfig) {
        let config;
        if (this.isLayoutOrientedPreset(presetConfig)) {
            config = new LayoutOrientedConfigService(presetConfig);
        }
        else if (this.isAspectOrientedPreset(presetConfig)) {
            config = new AspectOrientedConfigService(presetConfig);
        }
        else {
            config = new IndifferentConfigService();
        }
        Object.freeze(config);
        return config;
    }
    isAspectOrientedPreset(presetConfig) {
        return this.isObject(presetConfig);
    }
    isLayoutOrientedPreset(presetConfig) {
        return Array.isArray(presetConfig);
    }
    isObject(x) {
        return x != null && typeof x === 'object';
    }
}
ContentMetadataConfigFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataConfigFactory, deps: [{ token: i1.AppConfigService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentMetadataConfigFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataConfigFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataConfigFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AppConfigService }, { type: i1.LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PropertyDescriptorsService {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
    }
    get classesApi() {
        this._classesApi = this._classesApi ?? new ClassesApi(this.alfrescoApiService.getInstance());
        return this._classesApi;
    }
    load(groupNames) {
        const groupFetchStreams = groupNames
            .map((groupName) => groupName.replace(':', '_'))
            .map((groupName) => defer(() => this.classesApi.getClass(groupName)));
        return forkJoin(groupFetchStreams).pipe(map(this.convertToObject));
    }
    convertToObject(propertyGroupsArray) {
        return propertyGroupsArray.reduce((propertyGroups, propertyGroup) => Object.assign({}, propertyGroups, {
            [propertyGroup.name]: propertyGroup
        }), {});
    }
}
PropertyDescriptorsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PropertyDescriptorsService, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
PropertyDescriptorsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PropertyDescriptorsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PropertyDescriptorsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentTypeService {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
    }
    get typesApi() {
        this._typesApi = this._typesApi ?? new TypesApi(this.alfrescoApiService.getInstance());
        return this._typesApi;
    }
    getContentTypeByPrefix(prefixedType) {
        return from(this.typesApi.getType(prefixedType));
    }
    getContentTypeChildren(nodeType) {
        const where = `(parentId in ('${nodeType}') and not namespaceUri matches('http://www.alfresco.*'))`;
        const opts = {
            where,
            include: ['properties']
        };
        return from(this.typesApi.listTypes(opts)).pipe(map((result) => result.list.entries));
    }
}
ContentTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeService, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; } });

class ContentTypeDialogComponent {
    constructor(dialog, data, contentTypeService) {
        this.dialog = dialog;
        this.data = data;
        this.contentTypeService = contentTypeService;
        this.typeProperties = [];
        this.propertyColumns = ['name', 'title', 'dataType'];
        this.title = data.title;
        this.description = data.description;
        this.confirmMessage = data.confirmMessage;
        this.nodeType = data.nodeType;
        this.contentTypeService.getContentTypeByPrefix(this.nodeType).subscribe((contentTypeEntry) => {
            this.currentContentType = contentTypeEntry;
            this.typeProperties = this.currentContentType.entry.properties.filter((property) => property.id.startsWith(this.currentContentType.entry.model.namespacePrefix));
        });
    }
    ngOnInit() {
        this.dialog.backdropClick().subscribe(() => {
            this.close();
        });
    }
    close() {
        this.data.select.complete();
    }
    onCancel() {
        this.close();
    }
    onApply() {
        this.data.select.next(true);
        this.close();
    }
}
ContentTypeDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: ContentTypeService }], target: i0.ɵɵFactoryTarget.Component });
ContentTypeDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentTypeDialogComponent, selector: "adf-content-type-dialog", ngImport: i0, template: "<div class=\"adf-content-type-dialog\">\n    <h2 mat-dialog-title class=\"adf-content-type-dialog-title\" data-automation-id=\"content-type-dialog-title\">{{title |\n        translate}}</h2>\n    <mat-dialog-content class=\"mat-typography\" class=\"adf-content-type-dialog-content\"\n        data-automation-id=\"content-type-dialog-content\">\n        <h4 data-automation-id=\"content-type-dialog-description\">{{description | translate}}</h4>\n        <p data-automation-id=\"content-type-dialog-confirm-message\">{{confirmMessage | translate}}</p>\n        <mat-accordion>\n            <mat-expansion-panel class=\"adf-content-type-accordion\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title>\n                        {{'CORE.METADATA.CONTENT_TYPE.DIALOG.VIEW_DETAILS' | translate}}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <table mat-table [dataSource]=\"typeProperties\"\n                    *ngIf=\"typeProperties?.length > 0\" class=\"adf-content-type-table\">\n                    <ng-container matColumnDef=\"name\">\n                        <th mat-header-cell *matHeaderCellDef> {{'CORE.METADATA.CONTENT_TYPE.DIALOG.PROPERTY.NAME' |\n                            translate}} </th>\n                        <td mat-cell *matCellDef=\"let property\"> {{property.id}} </td>\n                    </ng-container>\n                    <ng-container matColumnDef=\"title\">\n                        <th mat-header-cell *matHeaderCellDef>\n                            {{'CORE.METADATA.CONTENT_TYPE.DIALOG.PROPERTY.DESCRIPTION' | translate}} </th>\n                        <td mat-cell *matCellDef=\"let property\"> {{property.title}} </td>\n                    </ng-container>\n                    <ng-container matColumnDef=\"dataType\">\n                        <th mat-header-cell *matHeaderCellDef> {{'CORE.METADATA.CONTENT_TYPE.DIALOG.PROPERTY.DATA_TYPE'\n                            | translate}} </th>\n                        <td mat-cell *matCellDef=\"let property\"> {{property.dataType}} </td>\n                    </ng-container>\n                    <tr mat-header-row *matHeaderRowDef=\"propertyColumns\"></tr>\n                    <tr mat-row *matRowDef=\"let row; columns: propertyColumns;\"></tr>\n                </table>\n            </mat-expansion-panel>\n        </mat-accordion>\n    </mat-dialog-content>\n    <mat-dialog-actions align=\"end\">\n        <button mat-button mat-dialog-close\n            id=\"content-type-dialog-actions-cancel\">{{'CORE.METADATA.CONTENT_TYPE.DIALOG.CANCEL' | translate }}</button>\n        <button mat-button class=\"adf-content-type-dialog-apply-button\" id=\"content-type-dialog-apply-button\"\n            [mat-dialog-close]=\"true\" cdkFocusInitial (click)=\"onApply()\">{{'CORE.METADATA.CONTENT_TYPE.DIALOG.APPLY' |\n            translate}}</button>\n    </mat-dialog-actions>\n</div>\n", styles: [".adf-content-type-dialog .mat-expansion-panel{margin-bottom:10px}.adf-content-type-accordion{margin:10px}.adf-content-type-dialog-title{font-size:large;font-weight:200;margin-top:0}.adf-content-type-dialog-description{font-size:small;line-height:normal}.adf-content-type-table{width:100%}.adf-content-type-dialog-apply-button{color:var(--theme-primary-color)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i4$2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i4$2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i4$2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i4$2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i4$2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i4$2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i4$2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i4$2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i4$2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: i5$4.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i5$4.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i5$4.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i5$4.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-content-type-dialog', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-content-type-dialog\">\n    <h2 mat-dialog-title class=\"adf-content-type-dialog-title\" data-automation-id=\"content-type-dialog-title\">{{title |\n        translate}}</h2>\n    <mat-dialog-content class=\"mat-typography\" class=\"adf-content-type-dialog-content\"\n        data-automation-id=\"content-type-dialog-content\">\n        <h4 data-automation-id=\"content-type-dialog-description\">{{description | translate}}</h4>\n        <p data-automation-id=\"content-type-dialog-confirm-message\">{{confirmMessage | translate}}</p>\n        <mat-accordion>\n            <mat-expansion-panel class=\"adf-content-type-accordion\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title>\n                        {{'CORE.METADATA.CONTENT_TYPE.DIALOG.VIEW_DETAILS' | translate}}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <table mat-table [dataSource]=\"typeProperties\"\n                    *ngIf=\"typeProperties?.length > 0\" class=\"adf-content-type-table\">\n                    <ng-container matColumnDef=\"name\">\n                        <th mat-header-cell *matHeaderCellDef> {{'CORE.METADATA.CONTENT_TYPE.DIALOG.PROPERTY.NAME' |\n                            translate}} </th>\n                        <td mat-cell *matCellDef=\"let property\"> {{property.id}} </td>\n                    </ng-container>\n                    <ng-container matColumnDef=\"title\">\n                        <th mat-header-cell *matHeaderCellDef>\n                            {{'CORE.METADATA.CONTENT_TYPE.DIALOG.PROPERTY.DESCRIPTION' | translate}} </th>\n                        <td mat-cell *matCellDef=\"let property\"> {{property.title}} </td>\n                    </ng-container>\n                    <ng-container matColumnDef=\"dataType\">\n                        <th mat-header-cell *matHeaderCellDef> {{'CORE.METADATA.CONTENT_TYPE.DIALOG.PROPERTY.DATA_TYPE'\n                            | translate}} </th>\n                        <td mat-cell *matCellDef=\"let property\"> {{property.dataType}} </td>\n                    </ng-container>\n                    <tr mat-header-row *matHeaderRowDef=\"propertyColumns\"></tr>\n                    <tr mat-row *matRowDef=\"let row; columns: propertyColumns;\"></tr>\n                </table>\n            </mat-expansion-panel>\n        </mat-accordion>\n    </mat-dialog-content>\n    <mat-dialog-actions align=\"end\">\n        <button mat-button mat-dialog-close\n            id=\"content-type-dialog-actions-cancel\">{{'CORE.METADATA.CONTENT_TYPE.DIALOG.CANCEL' | translate }}</button>\n        <button mat-button class=\"adf-content-type-dialog-apply-button\" id=\"content-type-dialog-apply-button\"\n            [mat-dialog-close]=\"true\" cdkFocusInitial (click)=\"onApply()\">{{'CORE.METADATA.CONTENT_TYPE.DIALOG.APPLY' |\n            translate}}</button>\n    </mat-dialog-actions>\n</div>\n", styles: [".adf-content-type-dialog .mat-expansion-panel{margin-bottom:10px}.adf-content-type-accordion{margin:10px}.adf-content-type-dialog-title{font-size:large;font-weight:200;margin-top:0}.adf-content-type-dialog-description{font-size:small;line-height:normal}.adf-content-type-table{width:100%}.adf-content-type-dialog-apply-button{color:var(--theme-primary-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: ContentTypeService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentTypePropertiesService {
    constructor(contentTypeService, dialog, versionCompatibilityService, propertyGroupTranslatorService) {
        this.contentTypeService = contentTypeService;
        this.dialog = dialog;
        this.versionCompatibilityService = versionCompatibilityService;
        this.propertyGroupTranslatorService = propertyGroupTranslatorService;
    }
    getContentTypeCardItem(node) {
        if (this.versionCompatibilityService.isVersionSupported('7')) {
            return this.contentTypeService.getContentTypeByPrefix(node.nodeType).
                pipe(map((contentType) => {
                const contentTypesOptions$ = this.getContentTypesAsSelectOption(contentType);
                const contentTypeCard = this.buildContentTypeSelectCardModel(contentType.entry.id, contentTypesOptions$);
                const filteredProperties = this.getContentTypeSpecificProperties(contentType);
                const propertiesCard = this.buildCardItemsFromPropertyList(filteredProperties, node.properties);
                return [contentTypeCard, ...propertiesCard];
            }));
        }
        else {
            return of([this.buildContentTypeTextCardModel(node.nodeType)]);
        }
    }
    buildCardItemsFromPropertyList(properties, currentProperties) {
        return properties.map((property) => {
            const propertyValue = currentProperties ? currentProperties[property.id] : null;
            return this.buildCardItemFromProperty(property, propertyValue);
        });
    }
    buildCardItemFromProperty(property, propertyValue) {
        return this.propertyGroupTranslatorService.translateProperty(property, propertyValue, true);
    }
    getContentTypeSpecificProperties(contentType) {
        return contentType.entry.properties.filter((property) => property.id.startsWith(contentType.entry.model.namespacePrefix));
    }
    buildContentTypeTextCardModel(currentValue) {
        const contentTypeCard = new CardViewTextItemModel({
            label: 'CORE.METADATA.BASIC.CONTENT_TYPE',
            value: currentValue,
            key: 'nodeType',
            editable: false
        });
        return contentTypeCard;
    }
    buildContentTypeSelectCardModel(currentValue, options$) {
        const contentTypeCard = new CardViewSelectItemModel({
            label: 'CORE.METADATA.BASIC.CONTENT_TYPE',
            value: currentValue,
            key: 'nodeType',
            editable: true,
            options$,
            displayNoneOption: false
        });
        return contentTypeCard;
    }
    getContentTypesAsSelectOption(currentType) {
        const childrenTypes$ = this.contentTypeService.getContentTypeChildren(currentType.entry.id);
        return zip(childrenTypes$, of(currentType)).pipe(distinctUntilChanged(), map(([contentTypesEntries, currentContentType]) => {
            const updatedTypes = this.appendCurrentType(currentContentType, contentTypesEntries);
            return updatedTypes.map((contentType) => ({ key: contentType.entry.id, label: contentType.entry.title ?? contentType.entry.id }));
        }));
    }
    appendCurrentType(currentType, contentTypesEntries) {
        const resultTypes = [...contentTypesEntries];
        const currentTypePresent = contentTypesEntries.find((type) => type.entry.id === currentType.entry.id);
        if (!currentTypePresent) {
            resultTypes.push(currentType);
        }
        return resultTypes;
    }
    openContentTypeDialogConfirm(nodeType) {
        const select = new Subject();
        select.subscribe({
            complete: this.close.bind(this)
        });
        const data = {
            title: 'CORE.METADATA.CONTENT_TYPE.DIALOG.TITLE',
            description: 'CORE.METADATA.CONTENT_TYPE.DIALOG.DESCRIPTION',
            confirmMessage: 'CORE.METADATA.CONTENT_TYPE.DIALOG.CONFIRM',
            select,
            nodeType
        };
        this.openDialog(data, 'adf-content-type-dialog', '600px');
        return select;
    }
    close() {
        this.dialog.closeAll();
    }
    openDialog(data, panelClass, width) {
        this.dialog.open(ContentTypeDialogComponent, {
            data,
            panelClass,
            width,
            disableClose: true
        });
    }
}
ContentTypePropertiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypePropertiesService, deps: [{ token: ContentTypeService }, { token: i1$1.MatDialog }, { token: VersionCompatibilityService }, { token: PropertyGroupTranslatorService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentTypePropertiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypePropertiesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypePropertiesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ContentTypeService }, { type: i1$1.MatDialog }, { type: VersionCompatibilityService }, { type: PropertyGroupTranslatorService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentMetadataService {
    constructor(basicPropertiesService, contentMetadataConfigFactory, propertyGroupTranslatorService, propertyDescriptorsService, contentTypePropertyService) {
        this.basicPropertiesService = basicPropertiesService;
        this.contentMetadataConfigFactory = contentMetadataConfigFactory;
        this.propertyGroupTranslatorService = propertyGroupTranslatorService;
        this.propertyDescriptorsService = propertyDescriptorsService;
        this.contentTypePropertyService = contentTypePropertyService;
        this.error = new Subject();
    }
    getBasicProperties(node) {
        return of(this.basicPropertiesService.getProperties(node));
    }
    getContentTypeProperty(node) {
        return this.contentTypePropertyService.getContentTypeCardItem(node);
    }
    openConfirmDialog(changedProperties) {
        return this.contentTypePropertyService.openContentTypeDialogConfirm(changedProperties.nodeType);
    }
    getGroupedProperties(node, preset = 'default') {
        let groupedProperties = of([]);
        if (node.aspectNames) {
            let contentMetadataConfig;
            if (typeof preset === 'string') {
                contentMetadataConfig = this.contentMetadataConfigFactory.get(preset);
            }
            else {
                contentMetadataConfig = this.contentMetadataConfigFactory.createConfig(preset);
            }
            const groupNames = node.aspectNames
                .concat(node.nodeType)
                .filter((groupName) => contentMetadataConfig.isGroupAllowed(groupName));
            if (groupNames.length > 0) {
                groupedProperties = this.propertyDescriptorsService.load(groupNames).pipe(switchMap((groups) => iif(() => contentMetadataConfig.isIncludeAllEnabled(), of(contentMetadataConfig.appendAllPreset(groups).concat(contentMetadataConfig.reorganiseByConfig(groups))), of(contentMetadataConfig.reorganiseByConfig(groups)))), map((groups) => contentMetadataConfig.filterExcludedPreset(groups)), map((groups) => this.filterEmptyPreset(groups)), map((groups) => this.setTitleToNameIfNotSet(groups)), map((groups) => this.propertyGroupTranslatorService.translateToCardViewGroups(groups, node.properties, node.definition)));
            }
        }
        return groupedProperties;
    }
    setTitleToNameIfNotSet(propertyGroups) {
        propertyGroups.map((propertyGroup) => {
            propertyGroup.title = propertyGroup.title || propertyGroup.name;
        });
        return propertyGroups;
    }
    filterEmptyPreset(propertyGroups) {
        return propertyGroups.filter((props) => props.properties.length);
    }
}
ContentMetadataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataService, deps: [{ token: BasicPropertiesService }, { token: ContentMetadataConfigFactory }, { token: PropertyGroupTranslatorService }, { token: PropertyDescriptorsService }, { token: ContentTypePropertiesService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentMetadataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: BasicPropertiesService }, { type: ContentMetadataConfigFactory }, { type: PropertyGroupTranslatorService }, { type: PropertyDescriptorsService }, { type: ContentTypePropertiesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CardViewContentUpdateService {
    constructor(cardViewUpdateService) {
        this.cardViewUpdateService = cardViewUpdateService;
        this.itemUpdated$ = new Subject();
        this.updatedAspect$ = new Subject();
        this.linkVariables();
    }
    update(property, newValue) {
        this.cardViewUpdateService.update(property, newValue);
    }
    updateElement(notification) {
        this.cardViewUpdateService.updateElement(notification);
    }
    updateNodeAspect(node) {
        this.updatedAspect$.next(node);
    }
    linkVariables() {
        this.linkItemUpdated();
    }
    linkItemUpdated() {
        this.cardViewUpdateService.itemUpdated$.subscribe(res => {
            this.itemUpdated$.next(res);
        });
    }
}
CardViewContentUpdateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewContentUpdateService, deps: [{ token: i1.CardViewUpdateService }], target: i0.ɵɵFactoryTarget.Injectable });
CardViewContentUpdateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewContentUpdateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CardViewContentUpdateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.CardViewUpdateService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CategoriesManagementMode;
(function (CategoriesManagementMode) {
    CategoriesManagementMode[CategoriesManagementMode["CRUD"] = 0] = "CRUD";
    CategoriesManagementMode[CategoriesManagementMode["ASSIGN"] = 1] = "ASSIGN";
})(CategoriesManagementMode || (CategoriesManagementMode = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CategoriesManagementComponent {
    constructor(categoryService) {
        this.categoryService = categoryService;
        this.nameErrorMessagesByErrors = new Map([
            ['duplicatedExistingCategory', 'ALREADY_EXISTS'],
            ['duplicatedCategory', 'DUPLICATED_CATEGORY'],
            ['emptyCategory', 'EMPTY_CATEGORY'],
            ['required', 'REQUIRED']
        ]);
        this.existingCategoryLoaded$ = new Subject();
        this.cancelExistingCategoriesLoading$ = new Subject();
        this.onDestroy$ = new Subject();
        this._categoryNameControl = new FormControl('', [
            this.validateIfNotAlreadyAdded.bind(this),
            this.validateEmptyCategory,
            Validators.required
        ], this.validateIfNotAlreadyCreated.bind(this));
        this._categoryNameErrorMessageKey = '';
        this._existingCategoriesLoading = false;
        this._typing = false;
        this._categoryNameControlVisible = false;
        this.existingCategoriesListLimit = 15;
        this.initialCategories = [];
        this.noCategoriesMsg = '';
        this.removeCategoryTitle = '';
        this.existingCategoriesMsg = '';
        /** Categories to display initially */
        this.categories = [];
        /** Disables remove button in upper categories list */
        this.disableRemoval = false;
        /** Emits when state of upper categories list changes */
        this.categoriesChange = new EventEmitter();
        /** Emits when categoryNameControl visibility changes */
        this.categoryNameControlVisibleChange = new EventEmitter();
    }
    /**
     * Decides if categoryNameControl should be visible. Sets also existing categories panel visibility
     * and scrolls control into view when visible.
     *
     * @param categoryNameControlVisible control visibility.
     */
    set categoryNameControlVisible(categoryNameControlVisible) {
        this._categoryNameControlVisible = categoryNameControlVisible;
        if (categoryNameControlVisible) {
            setTimeout(() => {
                this.categoryNameInputElement.nativeElement.scrollIntoView();
            });
            this._existingCategoriesPanelVisible = true;
        }
        else {
            this._existingCategoriesPanelVisible = false;
        }
    }
    get categoryNameControlVisible() {
        return this._categoryNameControlVisible;
    }
    ngOnInit() {
        this.categoryNameControl.valueChanges
            .pipe(map((name) => name.trim()), tap((name) => {
            this._typing = true;
            if (name) {
                this._existingCategoriesLoading = true;
                this._existingCategoriesPanelVisible = true;
            }
            this.cancelExistingCategoriesLoading$.next();
        }), debounce((name) => (name ? timer(300) : EMPTY)), takeUntil(this.onDestroy$))
            .subscribe((name) => this.onNameControlValueChange(name));
        this.categoryNameControl.statusChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => this.setCategoryNameControlErrorMessageKey());
        this.setCategoryNameControlErrorMessageKey();
        this.noCategoriesMsg = this.isCRUDMode ? 'CATEGORIES_MANAGEMENT.NO_CATEGORIES_CREATED' : 'CATEGORIES_MANAGEMENT.NO_CATEGORIES_ASSIGNED';
        this.removeCategoryTitle = this.isCRUDMode ? 'CATEGORIES_MANAGEMENT.DELETE_CATEGORY' : 'CATEGORIES_MANAGEMENT.UNASSIGN_CATEGORY';
        this.existingCategoriesMsg = this.isCRUDMode ? 'CATEGORIES_MANAGEMENT.EXISTING_CATEGORIES' : 'CATEGORIES_MANAGEMENT.SELECT_EXISTING_CATEGORY';
        if (!this.isCRUDMode) {
            this._categoryNameControl.removeValidators(Validators.required);
            this.categories.forEach((category) => this.initialCategories.push(category));
            this.classifiableChanged
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(() => {
                this.categories = [];
                this.categoryNameControlVisible = false;
                this.categoryNameControlVisibleChange.emit(false);
            });
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.cancelExistingCategoriesLoading$.next();
        this.cancelExistingCategoriesLoading$.complete();
    }
    get categoryNameControl() {
        return this._categoryNameControl;
    }
    get existingCategories() {
        return this._existingCategories;
    }
    get categoryNameErrorMessageKey() {
        return this._categoryNameErrorMessageKey;
    }
    get existingCategoriesLoading() {
        return this._existingCategoriesLoading;
    }
    get typing() {
        return this._typing;
    }
    get existingCategoriesPanelVisible() {
        return this._existingCategoriesPanelVisible;
    }
    get isCRUDMode() {
        return this.managementMode === CategoriesManagementMode.CRUD;
    }
    /**
     * Hides and emits categoryNameControl and hides existing categories panel.
     */
    hideNameInput() {
        this.categoryNameControlVisible = false;
        this.categoryNameControlVisibleChange.emit(false);
        this._existingCategoriesPanelVisible = false;
    }
    /**
     * Adds category that has been typed to a categoryNameControl and hides it afterwards.
     */
    addCategory() {
        if (this.isCRUDMode && !this._typing && !this.categoryNameControl.invalid) {
            const newCatName = this.categoryNameControl.value.trim();
            const newCat = new Category({ id: newCatName, name: newCatName });
            this.categories.push(newCat);
            this.hideNameInput();
            this.categoryNameControl.setValue('');
            this.categoryNameControl.markAsUntouched();
            this._existingCategories = null;
            this.categoriesChange.emit(this.categories);
        }
    }
    /**
     * Adds existing category to categories list and removes it from existing categories list.
     *
     * @param change - selection list change containing selected category
     */
    addCategoryToAssign(change) {
        const selectedCategory = change.options[0].value;
        this.categories.push(selectedCategory);
        this._existingCategories.splice(this._existingCategories.indexOf(selectedCategory), 1);
        this.categoryNameControl.updateValueAndValidity();
        this.categoriesChange.emit(this.categories);
    }
    /**
     * Removes the category from categories list and adds it to existing categories list in ASSIGN mode.
     *
     * @param category - category to remove
     */
    removeCategory(category) {
        this.categories.splice(this.categories.indexOf(category), 1);
        if (!this.isCRUDMode && !!this._existingCategories && !this.initialCategories.some((cat) => cat.id === category.id)) {
            this._existingCategories.push(category);
            this.sortCategoriesList(this._existingCategories);
        }
        this.categoryNameControl.updateValueAndValidity({
            emitEvent: false
        });
        this.categoriesChange.emit(this.categories);
    }
    onNameControlValueChange(name) {
        this.categoryNameControl.markAsTouched();
        if (name) {
            if (this.isCRUDMode) {
                this.getChildrenCategories(name);
            }
            else {
                this.searchForExistingCategories(name);
            }
        }
        else {
            this._existingCategories = null;
        }
    }
    searchForExistingCategories(searchTerm) {
        this.categoryService.searchCategories(searchTerm, 0, this.existingCategoriesListLimit).subscribe((existingCategoriesResult) => {
            this._existingCategories = existingCategoriesResult.list.entries.map((rowEntry) => {
                const existingCat = new Category();
                existingCat.id = rowEntry.entry.id;
                const path = rowEntry.entry.path.name.split('/').splice(3).join('/');
                existingCat.name = path ? `${path}/${rowEntry.entry.name}` : rowEntry.entry.name;
                return existingCat;
            });
            this._existingCategories = this._existingCategories.filter((existingCat) => this.categories.find((category) => existingCat.id === category.id) === undefined);
            this.sortCategoriesList(this._existingCategories);
            this._existingCategoriesLoading = false;
            this._typing = false;
            this.existingCategoryLoaded$.next();
        });
    }
    getChildrenCategories(searchTerm) {
        this.categoryService.getSubcategories(this.parentId).subscribe((childrenCategories) => {
            this._existingCategories = childrenCategories.list.entries.map((categoryEntry) => categoryEntry.entry);
            this._existingCategories = this._existingCategories.filter((existingCat) => existingCat.name.toLowerCase().includes(searchTerm.toLowerCase()));
            this.sortCategoriesList(this._existingCategories);
            this._existingCategoriesLoading = false;
            this._typing = false;
            this.existingCategoryLoaded$.next();
        });
    }
    validateIfNotAlreadyAdded(nameControl) {
        return this.categories?.some((category) => this.compareCategories(category, nameControl.value)) && this.isCRUDMode
            ? { duplicatedCategory: true }
            : null;
    }
    validateIfNotAlreadyCreated(nameControl) {
        return this.existingCategoryLoaded$.pipe(map(() => this.existingCategories.some((category) => this.compareCategories(category, nameControl.value)) && this.isCRUDMode
            ? { duplicatedExistingCategory: true }
            : null), first());
    }
    compareCategories(category1, cat2Name) {
        return category1?.name.trim().toUpperCase() === cat2Name?.trim().toUpperCase();
    }
    validateEmptyCategory(categoryNameControl) {
        return categoryNameControl.value.length && !categoryNameControl.value.trim()
            ? { emptyCategory: true }
            : null;
    }
    setCategoryNameControlErrorMessageKey() {
        this._categoryNameErrorMessageKey = this.categoryNameControl.invalid
            ? `CATEGORIES_MANAGEMENT.ERRORS.${this.nameErrorMessagesByErrors.get(Object.keys(this.categoryNameControl.errors)[0])}`
            : '';
    }
    sortCategoriesList(categoriesList) {
        categoriesList.sort((category1, category2) => category1.name.localeCompare(category2.name));
    }
}
CategoriesManagementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoriesManagementComponent, deps: [{ token: CategoryService }], target: i0.ɵɵFactoryTarget.Component });
CategoriesManagementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: CategoriesManagementComponent, selector: "adf-categories-management", inputs: { categories: "categories", categoryNameControlVisible: "categoryNameControlVisible", classifiableChanged: "classifiableChanged", disableRemoval: "disableRemoval", managementMode: "managementMode", parentId: "parentId" }, outputs: { categoriesChange: "categoriesChange", categoryNameControlVisibleChange: "categoryNameControlVisibleChange" }, viewQueries: [{ propertyName: "categoryNameInputElement", first: true, predicate: ["categoryNameInput"], descendants: true }], ngImport: i0, template: "<div class=\"adf-categories-management\">\n    <p *ngIf=\"!categories.length && !categoryNameControlVisible\"\n       class=\"adf-no-categories-message\">\n        {{ noCategoriesMsg | translate }}\n    </p>\n    <div class=\"adf-categories-list\"\n         [class.adf-categories-list-fixed]=\"!categoryNameControlVisible\">\n        <span\n            *ngFor=\"let category of categories\"\n            [class.adf-categories-padded]=\"!isCRUDMode\"\n            class=\"adf-assigned-categories\">\n            {{ category.name }}\n            <button\n                data-automation-id=\"categories-remove-category-button\"\n                mat-icon-button\n                [class.adf-btn-padded]=\"!isCRUDMode\"\n                (click)=\"removeCategory(category)\"\n                [attr.title]=\"removeCategoryTitle | translate\"\n                [disabled]=\"disableRemoval\">\n                <mat-icon>remove</mat-icon>\n            </button>\n        </span>\n    </div>\n    <div *ngIf=\"((!categoryNameControlVisible && categories.length)) || categoryNameControlVisible\"\n        [hidden]=\"!categoryNameControlVisible\"\n        class=\"adf-category-name-field\">\n        <mat-form-field>\n            <mat-icon matPrefix>search</mat-icon>\n            <mat-label id=\"adf-category-name-input-label\">\n                {{ 'CATEGORIES_MANAGEMENT.NAME' | translate }}\n            </mat-label>\n            <input\n                #categoryNameInput\n                matInput\n                autocomplete=\"off\"\n                [formControl]=\"categoryNameControl\"\n                (keyup.enter)=\"addCategory()\"\n                aria-labelledby=\"adf-category-name-input-label\"\n                adf-auto-focus\n            />\n            <mat-error [hidden]=\"!categoryNameControl.invalid\">{{ categoryNameErrorMessageKey | translate }}</mat-error>\n        </mat-form-field>\n        <button\n            mat-icon-button\n            [class.adf-btn-padded]=\"!isCRUDMode\"\n            (click)=\"hideNameInput()\"\n            [attr.title]=\"'CATEGORIES_MANAGEMENT.HIDE_INPUT' | translate\">\n            <mat-icon>remove</mat-icon>\n        </button>\n    </div>\n</div>\n<div class=\"adf-existing-categories-panel\" *ngIf=\"existingCategoriesPanelVisible\">\n    <ng-container *ngIf=\"isCRUDMode && (!existingCategoriesLoading || existingCategories)\">\n        <span class=\"adf-create-category-label\"\n            (click)=\"addCategory()\"\n            [hidden]=\"categoryNameControl.invalid || typing\">\n            {{ 'CATEGORIES_MANAGEMENT.GENERIC_CREATE' | translate : { name: categoryNameControl.value } }}\n        </span>\n    </ng-container>\n    <div *ngIf=\"categoryNameControlVisible\" class=\"adf-categories-list\">\n        <ng-container *ngIf=\"!existingCategoriesLoading && existingCategories\">\n            <p class=\"adf-existing-categories-label\">\n                {{ existingCategoriesMsg | translate }}\n            </p>\n            <mat-selection-list\n                [disabled]=\"isCRUDMode\"\n                (selectionChange)=\"addCategoryToAssign($event)\">\n                <mat-list-option\n                    *ngFor=\"let category of existingCategories\"\n                    class=\"adf-category\"\n                    [value]=\"category\">\n                    {{ category.name }}\n                </mat-list-option>\n                <p *ngIf=\"!existingCategories?.length && !existingCategoriesLoading\">\n                    {{ 'CATEGORIES_MANAGEMENT.NO_EXISTING_CATEGORIES' | translate }}\n                </p>\n            </mat-selection-list>\n        </ng-container>\n        <mat-spinner\n            *ngIf=\"existingCategoriesLoading\"\n            [diameter]=\"50\"\n            [attr.aria-label]=\"'CATEGORIES_MANAGEMENT.LOADING' | translate\">\n        </mat-spinner>\n    </div>\n</div>\n", styles: [".adf-categories-management .adf-category-name-field{display:flex;justify-content:space-between;width:100%}.adf-categories-management .adf-category-name-field mat-form-field{width:100%}.adf-categories-management .adf-category-name-field .adf-btn-padded{margin-right:-14px}.adf-categories-management .adf-assigned-categories{display:flex;justify-content:space-between;align-items:center;word-break:break-word}.adf-categories-management .adf-assigned-categories .adf-btn-padded{margin-right:-14px}.adf-categories-management .adf-categories-padded{padding:5px 0}.adf-categories-management [hidden]{visibility:hidden}.adf-categories-list{padding-bottom:10px}.adf-categories-list .mat-list-base .mat-list-item,.adf-categories-list .mat-list-base .mat-list-option{display:flex;height:100%;overflow-wrap:anywhere;padding:5px 0;font-size:14px}.adf-categories-list .mat-list-base .mat-list-item.mat-list-item-disabled,.adf-categories-list .mat-list-base .mat-list-option.mat-list-item-disabled{background-color:inherit;color:inherit}.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content,.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content-reverse,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content-reverse{padding:0}.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content .mat-pseudo-checkbox,.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content-reverse .mat-pseudo-checkbox,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content .mat-pseudo-checkbox,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content-reverse .mat-pseudo-checkbox{display:none}.adf-categories-list .adf-existing-categories-label{font-size:10px;color:var(--theme-secondary-text-color);margin-bottom:2px}.adf-categories-list mat-spinner{margin:auto}.adf-existing-categories-panel .adf-create-category-label{color:var(--theme-primary-color);cursor:pointer;overflow-wrap:anywhere}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i6.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "directive", type: i6.MatPrefix, selector: "[matPrefix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i8$1.MatSelectionList, selector: "mat-selection-list", inputs: ["disableRipple", "color", "compareWith", "disabled", "multiple"], outputs: ["selectionChange"], exportAs: ["matSelectionList"] }, { kind: "component", type: i8$1.MatListOption, selector: "mat-list-option", inputs: ["disableRipple", "checkboxPosition", "color", "value", "disabled", "selected"], outputs: ["selectedChange"], exportAs: ["matListOption"] }, { kind: "component", type: i9.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "directive", type: AutoFocusDirective, selector: "[adf-auto-focus]" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoriesManagementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-categories-management', encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-categories-management\">\n    <p *ngIf=\"!categories.length && !categoryNameControlVisible\"\n       class=\"adf-no-categories-message\">\n        {{ noCategoriesMsg | translate }}\n    </p>\n    <div class=\"adf-categories-list\"\n         [class.adf-categories-list-fixed]=\"!categoryNameControlVisible\">\n        <span\n            *ngFor=\"let category of categories\"\n            [class.adf-categories-padded]=\"!isCRUDMode\"\n            class=\"adf-assigned-categories\">\n            {{ category.name }}\n            <button\n                data-automation-id=\"categories-remove-category-button\"\n                mat-icon-button\n                [class.adf-btn-padded]=\"!isCRUDMode\"\n                (click)=\"removeCategory(category)\"\n                [attr.title]=\"removeCategoryTitle | translate\"\n                [disabled]=\"disableRemoval\">\n                <mat-icon>remove</mat-icon>\n            </button>\n        </span>\n    </div>\n    <div *ngIf=\"((!categoryNameControlVisible && categories.length)) || categoryNameControlVisible\"\n        [hidden]=\"!categoryNameControlVisible\"\n        class=\"adf-category-name-field\">\n        <mat-form-field>\n            <mat-icon matPrefix>search</mat-icon>\n            <mat-label id=\"adf-category-name-input-label\">\n                {{ 'CATEGORIES_MANAGEMENT.NAME' | translate }}\n            </mat-label>\n            <input\n                #categoryNameInput\n                matInput\n                autocomplete=\"off\"\n                [formControl]=\"categoryNameControl\"\n                (keyup.enter)=\"addCategory()\"\n                aria-labelledby=\"adf-category-name-input-label\"\n                adf-auto-focus\n            />\n            <mat-error [hidden]=\"!categoryNameControl.invalid\">{{ categoryNameErrorMessageKey | translate }}</mat-error>\n        </mat-form-field>\n        <button\n            mat-icon-button\n            [class.adf-btn-padded]=\"!isCRUDMode\"\n            (click)=\"hideNameInput()\"\n            [attr.title]=\"'CATEGORIES_MANAGEMENT.HIDE_INPUT' | translate\">\n            <mat-icon>remove</mat-icon>\n        </button>\n    </div>\n</div>\n<div class=\"adf-existing-categories-panel\" *ngIf=\"existingCategoriesPanelVisible\">\n    <ng-container *ngIf=\"isCRUDMode && (!existingCategoriesLoading || existingCategories)\">\n        <span class=\"adf-create-category-label\"\n            (click)=\"addCategory()\"\n            [hidden]=\"categoryNameControl.invalid || typing\">\n            {{ 'CATEGORIES_MANAGEMENT.GENERIC_CREATE' | translate : { name: categoryNameControl.value } }}\n        </span>\n    </ng-container>\n    <div *ngIf=\"categoryNameControlVisible\" class=\"adf-categories-list\">\n        <ng-container *ngIf=\"!existingCategoriesLoading && existingCategories\">\n            <p class=\"adf-existing-categories-label\">\n                {{ existingCategoriesMsg | translate }}\n            </p>\n            <mat-selection-list\n                [disabled]=\"isCRUDMode\"\n                (selectionChange)=\"addCategoryToAssign($event)\">\n                <mat-list-option\n                    *ngFor=\"let category of existingCategories\"\n                    class=\"adf-category\"\n                    [value]=\"category\">\n                    {{ category.name }}\n                </mat-list-option>\n                <p *ngIf=\"!existingCategories?.length && !existingCategoriesLoading\">\n                    {{ 'CATEGORIES_MANAGEMENT.NO_EXISTING_CATEGORIES' | translate }}\n                </p>\n            </mat-selection-list>\n        </ng-container>\n        <mat-spinner\n            *ngIf=\"existingCategoriesLoading\"\n            [diameter]=\"50\"\n            [attr.aria-label]=\"'CATEGORIES_MANAGEMENT.LOADING' | translate\">\n        </mat-spinner>\n    </div>\n</div>\n", styles: [".adf-categories-management .adf-category-name-field{display:flex;justify-content:space-between;width:100%}.adf-categories-management .adf-category-name-field mat-form-field{width:100%}.adf-categories-management .adf-category-name-field .adf-btn-padded{margin-right:-14px}.adf-categories-management .adf-assigned-categories{display:flex;justify-content:space-between;align-items:center;word-break:break-word}.adf-categories-management .adf-assigned-categories .adf-btn-padded{margin-right:-14px}.adf-categories-management .adf-categories-padded{padding:5px 0}.adf-categories-management [hidden]{visibility:hidden}.adf-categories-list{padding-bottom:10px}.adf-categories-list .mat-list-base .mat-list-item,.adf-categories-list .mat-list-base .mat-list-option{display:flex;height:100%;overflow-wrap:anywhere;padding:5px 0;font-size:14px}.adf-categories-list .mat-list-base .mat-list-item.mat-list-item-disabled,.adf-categories-list .mat-list-base .mat-list-option.mat-list-item-disabled{background-color:inherit;color:inherit}.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content,.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content-reverse,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content-reverse{padding:0}.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content .mat-pseudo-checkbox,.adf-categories-list .mat-list-base .mat-list-item .mat-list-item-content-reverse .mat-pseudo-checkbox,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content .mat-pseudo-checkbox,.adf-categories-list .mat-list-base .mat-list-option .mat-list-item-content-reverse .mat-pseudo-checkbox{display:none}.adf-categories-list .adf-existing-categories-label{font-size:10px;color:var(--theme-secondary-text-color);margin-bottom:2px}.adf-categories-list mat-spinner{margin:auto}.adf-existing-categories-panel .adf-create-category-label{color:var(--theme-primary-color);cursor:pointer;overflow-wrap:anywhere}\n"] }]
        }], ctorParameters: function () { return [{ type: CategoryService }]; }, propDecorators: { categories: [{
                type: Input
            }], categoryNameControlVisible: [{
                type: Input
            }], classifiableChanged: [{
                type: Input
            }], disableRemoval: [{
                type: Input
            }], managementMode: [{
                type: Input
            }], parentId: [{
                type: Input
            }], categoriesChange: [{
                type: Output
            }], categoryNameControlVisibleChange: [{
                type: Output
            }], categoryNameInputElement: [{
                type: ViewChild,
                args: ['categoryNameInput']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SEPARATOR = ', ';
class ContentMetadataComponent {
    constructor(contentMetadataService, cardViewContentUpdateService, nodesApiService, logService, translationService, appConfig, tagService, categoryService) {
        this.contentMetadataService = contentMetadataService;
        this.cardViewContentUpdateService = cardViewContentUpdateService;
        this.nodesApiService = nodesApiService;
        this.logService = logService;
        this.translationService = translationService;
        this.appConfig = appConfig;
        this.tagService = tagService;
        this.categoryService = categoryService;
        this.onDestroy$ = new Subject();
        /** Toggles whether to display empty values in the card view */
        this.displayEmpty = false;
        /** Toggles between expanded (ie, full information) and collapsed
         * (ie, reduced information) in the display
         */
        this.expanded = false;
        /** The multi parameter of the underlying material expansion panel, set to true to allow multi accordion to be expanded at the same time */
        this.multi = false;
        /** Toggles whether the metadata properties should be shown */
        this.displayDefaultProperties = true;
        /** (optional) shows the given aspect in the expanded  card */
        this.displayAspect = null;
        /** Toggles whether or not to enable copy to clipboard action. */
        this.copyToClipboardAction = true;
        /** Toggles whether or not to enable chips for multivalued properties. */
        this.useChipsForMultiValueProperty = true;
        /** True if tags should be displayed, false otherwise */
        this.displayTags = false;
        /** True if categories should be displayed, false otherwise */
        this.displayCategories = false;
        this._assignedTags = [];
        this._editable = false;
        this._tagsCreatorMode = TagsCreatorMode.CREATE_AND_ASSIGN;
        this._tags = [];
        this.classifiableChangedSubject = new Subject();
        this._saving = false;
        this.changedProperties = {};
        this.hasMetadataChanged = false;
        this.tagNameControlVisible = false;
        this.assignedCategories = [];
        this.categories = [];
        this.categoriesManagementMode = CategoriesManagementMode.ASSIGN;
        this.categoryControlVisible = false;
        this.classifiableChanged = this.classifiableChangedSubject.asObservable();
        this.copyToClipboardAction = this.appConfig.get('content-metadata.copy-to-clipboard-action');
        this.multiValueSeparator = this.appConfig.get('content-metadata.multi-value-pipe-separator') || DEFAULT_SEPARATOR;
        this.useChipsForMultiValueProperty = this.appConfig.get('content-metadata.multi-value-chips');
    }
    /** Toggles whether the edit button should be shown */
    set editable(editable) {
        this._editable = editable;
        this._assignedTags = [...this.tags];
    }
    get editable() {
        return this._editable;
    }
    ngOnInit() {
        this.cardViewContentUpdateService.itemUpdated$
            .pipe(debounceTime(500), takeUntil(this.onDestroy$))
            .subscribe((updatedNode) => {
            this.hasMetadataChanged = true;
            this.targetProperty = updatedNode.target;
            this.updateChanges(updatedNode.changed);
        });
        this.cardViewContentUpdateService.updatedAspect$.pipe(debounceTime(500), takeUntil(this.onDestroy$))
            .subscribe((node) => this.loadProperties(node));
        this.loadProperties(this.node);
    }
    get assignedTags() {
        return this._assignedTags;
    }
    get tags() {
        return this._tags;
    }
    get tagsCreatorMode() {
        return this._tagsCreatorMode;
    }
    get saving() {
        return this._saving;
    }
    handleUpdateError(error) {
        this.logService.error(error);
        let statusCode = 0;
        try {
            statusCode = JSON.parse(error.message).error.statusCode;
        }
        catch {
        }
        let message = `METADATA.ERRORS.${statusCode}`;
        if (this.translationService.instant(message) === message) {
            message = 'METADATA.ERRORS.GENERIC';
        }
        this.contentMetadataService.error.next({
            statusCode,
            message
        });
    }
    ngOnChanges(changes) {
        if (changes.node && !changes.node.firstChange) {
            this.loadProperties(changes.node.currentValue);
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    updateChanges(updatedNodeChanges) {
        Object.keys(updatedNodeChanges).map((propertyGroup) => {
            if (typeof updatedNodeChanges[propertyGroup] === 'object') {
                this.changedProperties[propertyGroup] = {
                    ...this.changedProperties[propertyGroup],
                    ...updatedNodeChanges[propertyGroup]
                };
            }
            else {
                this.changedProperties[propertyGroup] = updatedNodeChanges[propertyGroup];
            }
        });
    }
    /**
     * Called after clicking save button. It confirms all changes done for metadata and hides both category and tag name controls.
     * Before clicking on that button they are not saved.
     */
    saveChanges() {
        this._saving = true;
        this.tagNameControlVisible = false;
        this.categoryControlVisible = false;
        if (this.hasContentTypeChanged(this.changedProperties)) {
            this.contentMetadataService.openConfirmDialog(this.changedProperties).subscribe(() => {
                this.updateNode();
            });
        }
        else {
            this.updateNode();
        }
    }
    /**
     * Register all tags which should be assigned to node. Please note that they are just in "register" state and are not yet saved
     * until button for saving data is clicked. Calling that function causes that save button is enabled.
     *
     * @param tags array of tags to register, they are not saved yet until we click save button.
     */
    storeTagsToAssign(tags) {
        this._tags = tags;
        this.hasMetadataChanged = true;
    }
    /**
     * Store all categories that node should be assigned to. Please note that they are just in "stored" state and are not yet saved
     * until button for saving data is clicked. Calling that function causes that save button is enabled.
     *
     * @param categoriesToAssign array of categories to store.
     */
    storeCategoriesToAssign(categoriesToAssign) {
        this.categories = categoriesToAssign;
        this.hasMetadataChanged = true;
    }
    revertChanges() {
        this.changedProperties = {};
        this.hasMetadataChanged = false;
    }
    cancelChanges() {
        this.revertChanges();
        this.loadProperties(this.node);
    }
    showGroup(group) {
        const properties = group.properties.filter((property) => !this.isEmpty(property.displayValue));
        return properties.length > 0;
    }
    canExpandTheCard(group) {
        return group.title === this.displayAspect;
    }
    canExpandProperties() {
        return !this.expanded || this.displayAspect === 'Properties';
    }
    keyDown(event) {
        if (event.keyCode === 37 || event.keyCode === 39) { // ArrowLeft && ArrowRight
            event.stopPropagation();
        }
    }
    updateNode() {
        forkJoin({
            updatedNode: this.nodesApiService.updateNode(this.node.id, this.changedProperties),
            ...(this.displayTags ? this.saveTags() : {}),
            ...(this.displayCategories ? this.saveCategories() : {})
        }).pipe(catchError((err) => {
            this.cardViewContentUpdateService.updateElement(this.targetProperty);
            this.handleUpdateError(err);
            this._saving = false;
            return of(null);
        }))
            .subscribe((result) => {
            if (result) {
                if (this.hasContentTypeChanged(this.changedProperties)) {
                    this.cardViewContentUpdateService.updateNodeAspect(this.node);
                }
                this.revertChanges();
                Object.assign(this.node, result.updatedNode);
                this.nodesApiService.nodeUpdated.next(this.node);
                if (Object.keys(result).length > 1 && this.displayTags) {
                    this.loadTagsForNode(this.node.id);
                }
                if (this.displayCategories && !!result.LinkingCategories) {
                    this.assignedCategories = !!result.LinkingCategories.list ?
                        result.LinkingCategories.list.entries.map((entry) => entry.entry) :
                        [result.LinkingCategories.entry];
                }
            }
            this._saving = false;
        });
    }
    hasContentTypeChanged(changedProperties) {
        return !!changedProperties?.nodeType;
    }
    loadProperties(node) {
        if (node) {
            this.basicProperties$ = this.getProperties(node);
            this.groupedProperties$ = this.contentMetadataService.getGroupedProperties(node, this.preset);
            if (this.displayTags) {
                this.loadTagsForNode(node.id);
            }
            if (this.displayCategories) {
                this.loadCategoriesForNode(node.id);
                if (!this.node.aspectNames.includes('generalclassifiable')) {
                    this.categories = [];
                    this.classifiableChangedSubject.next();
                }
            }
        }
    }
    getProperties(node) {
        const properties$ = this.contentMetadataService.getBasicProperties(node);
        const contentTypeProperty$ = this.contentMetadataService.getContentTypeProperty(node);
        return zip(properties$, contentTypeProperty$)
            .pipe(map(([properties, contentTypeProperty]) => {
            const filteredProperties = contentTypeProperty.filter((property) => properties.findIndex((baseProperty) => baseProperty.key === property.key) === -1);
            return [...properties, ...filteredProperties];
        }));
    }
    isEmpty(value) {
        return value === undefined || value === null || value === '';
    }
    loadCategoriesForNode(nodeId) {
        this.assignedCategories = [];
        this.categoryService.getCategoryLinksForNode(nodeId).subscribe((categoryPaging) => {
            this.categories = categoryPaging.list.entries.map((categoryEntry) => {
                const path = categoryEntry.entry.path ? categoryEntry.entry.path.split('/').splice(3).join('/') : null;
                categoryEntry.entry.name = path ? `${path}/${categoryEntry.entry.name}` : categoryEntry.entry.name;
                return categoryEntry.entry;
            });
            this.assignedCategories = [...this.categories];
        });
    }
    saveCategories() {
        const observables = {};
        if (this.categories) {
            this.assignedCategories.forEach((assignedCategory) => {
                if (this.categories.every((category) => category.name !== assignedCategory.name)) {
                    observables[`Removing ${assignedCategory.id}`] = this.categoryService.unlinkNodeFromCategory(this.node.id, assignedCategory.id);
                }
            });
            const categoryLinkBodies = this.categories.map((category) => {
                const categoryLinkBody = new CategoryLinkBody();
                categoryLinkBody.categoryId = category.id;
                return categoryLinkBody;
            });
            if (categoryLinkBodies.length > 0) {
                observables['LinkingCategories'] = this.categoryService.linkNodeToCategory(this.node.id, categoryLinkBodies);
            }
        }
        return observables;
    }
    loadTagsForNode(id) {
        this.tagService.getTagsByNodeId(id).subscribe((tagPaging) => {
            this.assignedTagsEntries = tagPaging.list.entries;
            this._tags = tagPaging.list.entries.map((tagEntry) => tagEntry.entry.tag);
            this._assignedTags = [...this._tags];
        });
    }
    saveTags() {
        const observables = {};
        if (this.tags) {
            this.assignedTagsEntries.forEach((tagEntry) => {
                if (!this.tags.some((tag) => tagEntry.entry.tag === tag)) {
                    observables[`${tagEntry.entry.id}Removing`] = this.tagService.removeTag(this.node.id, tagEntry.entry.id);
                }
            });
            if (this.tags.length) {
                observables.tagsAssigning = this.tagService.assignTagsToNode(this.node.id, this.tags.map((tag) => {
                    const tagBody = new TagBody();
                    tagBody.tag = tag;
                    return tagBody;
                }));
            }
        }
        return observables;
    }
}
ContentMetadataComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataComponent, deps: [{ token: ContentMetadataService }, { token: CardViewContentUpdateService }, { token: NodesApiService }, { token: i1.LogService }, { token: i1.TranslationService }, { token: i1.AppConfigService }, { token: TagService }, { token: CategoryService }], target: i0.ɵɵFactoryTarget.Component });
ContentMetadataComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentMetadataComponent, selector: "adf-content-metadata", inputs: { node: "node", editable: "editable", displayEmpty: "displayEmpty", expanded: "expanded", multi: "multi", preset: "preset", displayDefaultProperties: "displayDefaultProperties", displayAspect: "displayAspect", copyToClipboardAction: "copyToClipboardAction", useChipsForMultiValueProperty: "useChipsForMultiValueProperty", displayTags: "displayTags", displayCategories: "displayCategories" }, host: { classAttribute: "adf-content-metadata" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"adf-metadata-properties\">\n    <mat-accordion displayMode=\"flat\"\n                   [multi]=\"multi\">\n        <mat-expansion-panel *ngIf=\"displayDefaultProperties\"\n                             [expanded]=\"canExpandProperties()\"\n                             [attr.data-automation-id]=\"'adf-metadata-group-properties'\">\n            <mat-expansion-panel-header>\n                <mat-panel-title class=\"adf-metadata-properties-title\">\n                    {{ 'CORE.METADATA.BASIC.HEADER' | translate }}\n                </mat-panel-title>\n            </mat-expansion-panel-header>\n            <adf-card-view\n                (keydown)=\"keyDown($event)\"\n                [properties]=\"basicProperties$ | async\"\n                [editable]=\"editable\"\n                [displayEmpty]=\"displayEmpty\"\n                [copyToClipboardAction]=\"copyToClipboardAction\"\n                [useChipsForMultiValueProperty]=\"useChipsForMultiValueProperty\"\n                [multiValueSeparator]=\"multiValueSeparator\">\n            </adf-card-view>\n        </mat-expansion-panel>\n        <ng-container *ngIf=\"displayTags\">\n            <mat-expansion-panel *ngIf=\"!editable\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title>{{ 'METADATA.BASIC.TAGS' | translate }}</mat-panel-title>\n                </mat-expansion-panel-header>\n                <p *ngFor=\"let tag of tags\" class=\"adf-metadata-properties-tag\">{{ tag }}</p>\n            </mat-expansion-panel>\n            <div\n                *ngIf=\"editable\"\n                class=\"adf-metadata-properties-tags\">\n                <div class=\"adf-metadata-properties-tags-title\">\n                    <p>{{ 'METADATA.BASIC.TAGS' | translate }}</p>\n                    <button\n                        data-automation-id=\"showing-tag-input-button\"\n                        mat-icon-button\n                        [attr.title]=\"'METADATA.BASIC.ADD_TAG_TOOLTIP' | translate\"\n                        (click)=\"tagNameControlVisible = true\"\n                        [hidden]=\"tagNameControlVisible || saving\">\n                        <mat-icon>add</mat-icon>\n                    </button>\n                </div>\n                <adf-tags-creator\n                    [(tagNameControlVisible)]=\"tagNameControlVisible\"\n                    (tagsChange)=\"storeTagsToAssign($event)\"\n                    [mode]=\"tagsCreatorMode\"\n                    [tags]=\"assignedTags\"\n                    [disabledTagsRemoving]=\"saving\">\n                </adf-tags-creator>\n            </div>\n        </ng-container>\n        <ng-container *ngIf=\"displayCategories\">\n            <mat-expansion-panel *ngIf=\"!editable\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title>{{ 'CATEGORIES_MANAGEMENT.CATEGORIES_TITLE' | translate }}</mat-panel-title>\n                </mat-expansion-panel-header>\n                <p *ngFor=\"let category of categories\" class=\"adf-metadata-categories\">{{ category.name }}</p>\n            </mat-expansion-panel>\n            <div *ngIf=\"editable\"\n                class=\"adf-metadata-categories-header\">\n                <div class=\"adf-metadata-categories-title\">\n                    <p>{{ 'CATEGORIES_MANAGEMENT.CATEGORIES_TITLE' | translate }}</p>\n                    <button\n                        mat-icon-button\n                        [attr.title]=\"'CATEGORIES_MANAGEMENT.ASSIGN_CATEGORIES' | translate\"\n                        [hidden]=\"categoryControlVisible || saving\"\n                        (click)=\"categoryControlVisible = true\">\n                        <mat-icon>add</mat-icon>\n                    </button>\n                </div>\n                <adf-categories-management\n                    [(categoryNameControlVisible)]=\"categoryControlVisible\"\n                    [disableRemoval]=\"saving\"\n                    [categories]=\"categories\"\n                    [managementMode]=\"categoriesManagementMode\"\n                    [classifiableChanged]=\"classifiableChanged\"\n                    (categoriesChange)=\"storeCategoriesToAssign($event)\">\n                </adf-categories-management>\n            </div>\n        </ng-container>\n        <ng-container *ngIf=\"expanded\">\n            <ng-container *ngIf=\"groupedProperties$ | async; else loading; let groupedProperties\">\n                <div *ngFor=\"let group of groupedProperties; let first = first;\"\n                     class=\"adf-metadata-grouped-properties-container\">\n                    <mat-expansion-panel *ngIf=\"showGroup(group) || editable\"\n                                         [attr.data-automation-id]=\"'adf-metadata-group-' + group.title\"\n                                         [expanded]=\"canExpandTheCard(group) || !displayDefaultProperties && first\">\n                        <mat-expansion-panel-header>\n                            <mat-panel-title>\n                                {{ group.title | translate }}\n                            </mat-panel-title>\n                        </mat-expansion-panel-header>\n\n                        <adf-card-view\n                            (keydown)=\"keyDown($event)\"\n                            [properties]=\"group.properties\"\n                            [editable]=\"editable\"\n                            [displayEmpty]=\"displayEmpty\"\n                            [copyToClipboardAction]=\"copyToClipboardAction\"\n                            [useChipsForMultiValueProperty]=\"useChipsForMultiValueProperty\"\n                            [multiValueSeparator]=\"multiValueSeparator\">\n                        </adf-card-view>\n                    </mat-expansion-panel>\n\n                </div>\n            </ng-container>\n            <ng-template #loading>\n                <mat-progress-bar mode=\"indeterminate\" [attr.aria-label]=\"'DATA_LOADING' | translate\">\n                </mat-progress-bar>\n            </ng-template>\n        </ng-container>\n    </mat-accordion>\n\n    <div class=\"adf-metadata-action-buttons\"\n         *ngIf=\"editable\">\n        <button mat-button\n                (click)=\"cancelChanges()\"\n                data-automation-id=\"reset-metadata\"\n                [disabled]=\"!hasMetadataChanged\">\n                {{ 'CORE.METADATA.ACTIONS.CANCEL' | translate }}\n        </button>\n        <button mat-raised-button\n                (click)=\"saveChanges()\"\n                color=\"primary\"\n                data-automation-id=\"save-metadata\"\n                [disabled]=\"!hasMetadataChanged\">\n                {{ 'CORE.METADATA.ACTIONS.SAVE' | translate }}\n            </button>\n    </div>\n\n</div>\n", styles: [".adf-metadata-properties .mat-expansion-panel-header.mat-expanded:hover,.adf-metadata-properties .mat-expansion-panel-header.mat-expanded:focus{background:var(--adf-theme-background-hover-color)}.adf-metadata-properties mat-expansion-panel-header{height:64px}.adf-metadata-properties mat-expansion-panel-header .adf-metadata-properties-title{font-weight:400;font-size:15px}.adf-metadata-properties .mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:none}.adf-metadata-properties .adf-metadata-properties-tag{height:40px;display:flex;align-items:center;margin-top:-14px;margin-bottom:1em}.adf-metadata-properties .adf-metadata-properties-tag:first-of-type{margin-top:5px}.adf-metadata-properties-tags{padding:0 10px 0 26px}.adf-metadata-properties-tags-title{display:flex;justify-content:space-between;align-items:center;font-size:15px;height:68px}.adf-metadata-properties-tags adf-tags-creator{margin-top:19px}.adf-metadata-properties-tags adf-tags-creator .adf-tags-creation{padding-right:0;padding-left:12px}.adf-metadata-properties-tags adf-tags-creator .adf-tags-creation .adf-tag{margin-top:-14px}.adf-metadata-properties-tags adf-tags-creator.adf-creator-with-existing-tags-panel{background:var(--adf-theme-background-dialog-color)}.adf-metadata-properties-tags [hidden]{visibility:hidden}.adf-metadata-action-buttons{display:flex;justify-content:space-evenly;margin:10px}.adf-metadata-categories-header{display:flex;flex-direction:column;padding:0 24px}.adf-metadata-categories-header .adf-metadata-categories-title{display:flex;justify-content:space-between;align-items:center;font-size:15px;height:64px}.adf-metadata-categories-header .adf-metadata-categories-title button{margin-right:-14px}.adf-metadata-categories-header .adf-metadata-categories-title [hidden]{visibility:hidden}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i10.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "directive", type: i5$4.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i5$4.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i5$4.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i5$4.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "component", type: i1.CardViewComponent, selector: "adf-card-view", inputs: ["properties", "editable", "displayEmpty", "displayNoneOption", "displayClearAction", "copyToClipboardAction", "useChipsForMultiValueProperty", "multiValueSeparator"] }, { kind: "component", type: TagsCreatorComponent, selector: "adf-tags-creator", inputs: ["mode", "disabledTagsRemoving", "tags", "tagNameControlVisible"], outputs: ["existingTagsPanelVisibilityChange", "tagsChange", "tagNameControlVisibleChange"] }, { kind: "component", type: CategoriesManagementComponent, selector: "adf-categories-management", inputs: ["categories", "categoryNameControlVisible", "classifiableChanged", "disableRemoval", "managementMode", "parentId"], outputs: ["categoriesChange", "categoryNameControlVisibleChange"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-content-metadata', host: { class: 'adf-content-metadata' }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-metadata-properties\">\n    <mat-accordion displayMode=\"flat\"\n                   [multi]=\"multi\">\n        <mat-expansion-panel *ngIf=\"displayDefaultProperties\"\n                             [expanded]=\"canExpandProperties()\"\n                             [attr.data-automation-id]=\"'adf-metadata-group-properties'\">\n            <mat-expansion-panel-header>\n                <mat-panel-title class=\"adf-metadata-properties-title\">\n                    {{ 'CORE.METADATA.BASIC.HEADER' | translate }}\n                </mat-panel-title>\n            </mat-expansion-panel-header>\n            <adf-card-view\n                (keydown)=\"keyDown($event)\"\n                [properties]=\"basicProperties$ | async\"\n                [editable]=\"editable\"\n                [displayEmpty]=\"displayEmpty\"\n                [copyToClipboardAction]=\"copyToClipboardAction\"\n                [useChipsForMultiValueProperty]=\"useChipsForMultiValueProperty\"\n                [multiValueSeparator]=\"multiValueSeparator\">\n            </adf-card-view>\n        </mat-expansion-panel>\n        <ng-container *ngIf=\"displayTags\">\n            <mat-expansion-panel *ngIf=\"!editable\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title>{{ 'METADATA.BASIC.TAGS' | translate }}</mat-panel-title>\n                </mat-expansion-panel-header>\n                <p *ngFor=\"let tag of tags\" class=\"adf-metadata-properties-tag\">{{ tag }}</p>\n            </mat-expansion-panel>\n            <div\n                *ngIf=\"editable\"\n                class=\"adf-metadata-properties-tags\">\n                <div class=\"adf-metadata-properties-tags-title\">\n                    <p>{{ 'METADATA.BASIC.TAGS' | translate }}</p>\n                    <button\n                        data-automation-id=\"showing-tag-input-button\"\n                        mat-icon-button\n                        [attr.title]=\"'METADATA.BASIC.ADD_TAG_TOOLTIP' | translate\"\n                        (click)=\"tagNameControlVisible = true\"\n                        [hidden]=\"tagNameControlVisible || saving\">\n                        <mat-icon>add</mat-icon>\n                    </button>\n                </div>\n                <adf-tags-creator\n                    [(tagNameControlVisible)]=\"tagNameControlVisible\"\n                    (tagsChange)=\"storeTagsToAssign($event)\"\n                    [mode]=\"tagsCreatorMode\"\n                    [tags]=\"assignedTags\"\n                    [disabledTagsRemoving]=\"saving\">\n                </adf-tags-creator>\n            </div>\n        </ng-container>\n        <ng-container *ngIf=\"displayCategories\">\n            <mat-expansion-panel *ngIf=\"!editable\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title>{{ 'CATEGORIES_MANAGEMENT.CATEGORIES_TITLE' | translate }}</mat-panel-title>\n                </mat-expansion-panel-header>\n                <p *ngFor=\"let category of categories\" class=\"adf-metadata-categories\">{{ category.name }}</p>\n            </mat-expansion-panel>\n            <div *ngIf=\"editable\"\n                class=\"adf-metadata-categories-header\">\n                <div class=\"adf-metadata-categories-title\">\n                    <p>{{ 'CATEGORIES_MANAGEMENT.CATEGORIES_TITLE' | translate }}</p>\n                    <button\n                        mat-icon-button\n                        [attr.title]=\"'CATEGORIES_MANAGEMENT.ASSIGN_CATEGORIES' | translate\"\n                        [hidden]=\"categoryControlVisible || saving\"\n                        (click)=\"categoryControlVisible = true\">\n                        <mat-icon>add</mat-icon>\n                    </button>\n                </div>\n                <adf-categories-management\n                    [(categoryNameControlVisible)]=\"categoryControlVisible\"\n                    [disableRemoval]=\"saving\"\n                    [categories]=\"categories\"\n                    [managementMode]=\"categoriesManagementMode\"\n                    [classifiableChanged]=\"classifiableChanged\"\n                    (categoriesChange)=\"storeCategoriesToAssign($event)\">\n                </adf-categories-management>\n            </div>\n        </ng-container>\n        <ng-container *ngIf=\"expanded\">\n            <ng-container *ngIf=\"groupedProperties$ | async; else loading; let groupedProperties\">\n                <div *ngFor=\"let group of groupedProperties; let first = first;\"\n                     class=\"adf-metadata-grouped-properties-container\">\n                    <mat-expansion-panel *ngIf=\"showGroup(group) || editable\"\n                                         [attr.data-automation-id]=\"'adf-metadata-group-' + group.title\"\n                                         [expanded]=\"canExpandTheCard(group) || !displayDefaultProperties && first\">\n                        <mat-expansion-panel-header>\n                            <mat-panel-title>\n                                {{ group.title | translate }}\n                            </mat-panel-title>\n                        </mat-expansion-panel-header>\n\n                        <adf-card-view\n                            (keydown)=\"keyDown($event)\"\n                            [properties]=\"group.properties\"\n                            [editable]=\"editable\"\n                            [displayEmpty]=\"displayEmpty\"\n                            [copyToClipboardAction]=\"copyToClipboardAction\"\n                            [useChipsForMultiValueProperty]=\"useChipsForMultiValueProperty\"\n                            [multiValueSeparator]=\"multiValueSeparator\">\n                        </adf-card-view>\n                    </mat-expansion-panel>\n\n                </div>\n            </ng-container>\n            <ng-template #loading>\n                <mat-progress-bar mode=\"indeterminate\" [attr.aria-label]=\"'DATA_LOADING' | translate\">\n                </mat-progress-bar>\n            </ng-template>\n        </ng-container>\n    </mat-accordion>\n\n    <div class=\"adf-metadata-action-buttons\"\n         *ngIf=\"editable\">\n        <button mat-button\n                (click)=\"cancelChanges()\"\n                data-automation-id=\"reset-metadata\"\n                [disabled]=\"!hasMetadataChanged\">\n                {{ 'CORE.METADATA.ACTIONS.CANCEL' | translate }}\n        </button>\n        <button mat-raised-button\n                (click)=\"saveChanges()\"\n                color=\"primary\"\n                data-automation-id=\"save-metadata\"\n                [disabled]=\"!hasMetadataChanged\">\n                {{ 'CORE.METADATA.ACTIONS.SAVE' | translate }}\n            </button>\n    </div>\n\n</div>\n", styles: [".adf-metadata-properties .mat-expansion-panel-header.mat-expanded:hover,.adf-metadata-properties .mat-expansion-panel-header.mat-expanded:focus{background:var(--adf-theme-background-hover-color)}.adf-metadata-properties mat-expansion-panel-header{height:64px}.adf-metadata-properties mat-expansion-panel-header .adf-metadata-properties-title{font-weight:400;font-size:15px}.adf-metadata-properties .mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:none}.adf-metadata-properties .adf-metadata-properties-tag{height:40px;display:flex;align-items:center;margin-top:-14px;margin-bottom:1em}.adf-metadata-properties .adf-metadata-properties-tag:first-of-type{margin-top:5px}.adf-metadata-properties-tags{padding:0 10px 0 26px}.adf-metadata-properties-tags-title{display:flex;justify-content:space-between;align-items:center;font-size:15px;height:68px}.adf-metadata-properties-tags adf-tags-creator{margin-top:19px}.adf-metadata-properties-tags adf-tags-creator .adf-tags-creation{padding-right:0;padding-left:12px}.adf-metadata-properties-tags adf-tags-creator .adf-tags-creation .adf-tag{margin-top:-14px}.adf-metadata-properties-tags adf-tags-creator.adf-creator-with-existing-tags-panel{background:var(--adf-theme-background-dialog-color)}.adf-metadata-properties-tags [hidden]{visibility:hidden}.adf-metadata-action-buttons{display:flex;justify-content:space-evenly;margin:10px}.adf-metadata-categories-header{display:flex;flex-direction:column;padding:0 24px}.adf-metadata-categories-header .adf-metadata-categories-title{display:flex;justify-content:space-between;align-items:center;font-size:15px;height:64px}.adf-metadata-categories-header .adf-metadata-categories-title button{margin-right:-14px}.adf-metadata-categories-header .adf-metadata-categories-title [hidden]{visibility:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: ContentMetadataService }, { type: CardViewContentUpdateService }, { type: NodesApiService }, { type: i1.LogService }, { type: i1.TranslationService }, { type: i1.AppConfigService }, { type: TagService }, { type: CategoryService }]; }, propDecorators: { node: [{
                type: Input
            }], editable: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }], expanded: [{
                type: Input
            }], multi: [{
                type: Input
            }], preset: [{
                type: Input
            }], displayDefaultProperties: [{
                type: Input
            }], displayAspect: [{
                type: Input
            }], copyToClipboardAction: [{
                type: Input
            }], useChipsForMultiValueProperty: [{
                type: Input
            }], displayTags: [{
                type: Input
            }], displayCategories: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AspectListService {
    constructor(alfrescoApiService, appConfigService, logService) {
        this.alfrescoApiService = alfrescoApiService;
        this.appConfigService = appConfigService;
        this.logService = logService;
    }
    get aspectsApi() {
        this._aspectsApi = this._aspectsApi ?? new AspectsApi(this.alfrescoApiService.getInstance());
        return this._aspectsApi;
    }
    getAspects() {
        const visibleAspectList = this.getVisibleAspects();
        const standardAspects$ = this.getStandardAspects(visibleAspectList);
        const customAspects$ = this.getCustomAspects();
        return zip(standardAspects$, customAspects$).pipe(map(([standardAspectList, customAspectList]) => [...standardAspectList, ...customAspectList]));
    }
    getStandardAspects(whiteList) {
        const where = `(modelId in ('cm:contentmodel', 'emailserver:emailserverModel', 'smf:smartFolder', 'app:applicationmodel' ))`;
        const opts = {
            where,
            include: ['properties']
        };
        return from(this.aspectsApi.listAspects(opts))
            .pipe(map((result) => this.filterAspectByConfig(whiteList, result?.list?.entries)), catchError((error) => {
            this.logService.error(error);
            return of([]);
        }));
    }
    getCustomAspects() {
        const where = `(not namespaceUri matches('http://www.alfresco.*'))`;
        const opts = {
            where,
            include: ['properties']
        };
        return from(this.aspectsApi.listAspects(opts))
            .pipe(map((result) => result?.list?.entries), catchError((error) => {
            this.logService.error(error);
            return of([]);
        }));
    }
    filterAspectByConfig(visibleAspectList, aspectEntries) {
        let result = aspectEntries ? aspectEntries : [];
        if (visibleAspectList?.length > 0 && aspectEntries) {
            result = aspectEntries.filter((value) => visibleAspectList.includes(value?.entry?.id));
        }
        return result;
    }
    getVisibleAspects() {
        let visibleAspectList = [];
        const aspectVisibleConfig = this.appConfigService.get('aspect-visible');
        if (aspectVisibleConfig) {
            for (const aspectGroup of Object.keys(aspectVisibleConfig)) {
                visibleAspectList = visibleAspectList.concat(aspectVisibleConfig[aspectGroup]);
            }
        }
        return visibleAspectList;
    }
}
AspectListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.AppConfigService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Injectable });
AspectListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.AppConfigService }, { type: i1.LogService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AspectListComponent {
    constructor(aspectListService, nodeApiService) {
        this.aspectListService = aspectListService;
        this.nodeApiService = nodeApiService;
        /** Node Id of the node that we want to update */
        this.nodeId = '';
        /** Emitted every time the user select a new aspect */
        this.valueChanged = new EventEmitter();
        this.propertyColumns = ['name', 'title', 'dataType'];
        this.aspects$ = null;
        this.nodeAspects = [];
        this.nodeAspectStatus = [];
        this.hasEqualAspect = true;
        this.onDestroy$ = new Subject();
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    ngOnInit() {
        if (this.nodeId) {
            const node$ = this.nodeApiService.getNode(this.nodeId);
            const customAspect$ = this.aspectListService.getCustomAspects()
                .pipe(map((customAspects) => customAspects.flatMap((customAspect) => customAspect.entry.id)));
            this.aspects$ = zip(node$, customAspect$).pipe(tap(([node, customAspects]) => {
                this.nodeAspects = node.aspectNames.filter((aspect) => this.aspectListService.getVisibleAspects().includes(aspect) || customAspects.includes(aspect));
                this.nodeAspectStatus = [...this.nodeAspects];
                this.valueChanged.emit(this.nodeAspects);
            }), concatMap(() => this.aspectListService.getAspects()), takeUntil(this.onDestroy$));
        }
        else {
            this.aspects$ = this.aspectListService.getAspects()
                .pipe(takeUntil(this.onDestroy$));
        }
    }
    onCheckBoxClick(event) {
        event.stopImmediatePropagation();
    }
    onChange(change, prefixedName) {
        if (change.checked) {
            this.nodeAspects.push(prefixedName);
        }
        else {
            this.nodeAspects.splice(this.nodeAspects.indexOf(prefixedName), 1);
        }
        this.updateEqualityOfAspectList();
        this.valueChanged.emit(this.nodeAspects);
    }
    reset() {
        if (this.nodeAspectStatus && this.nodeAspectStatus.length > 0) {
            this.nodeAspects.splice(0, this.nodeAspects.length, ...this.nodeAspectStatus);
            this.hasEqualAspect = true;
            this.valueChanged.emit(this.nodeAspects);
        }
        else {
            this.clear();
        }
    }
    clear() {
        this.nodeAspects = [];
        this.updateEqualityOfAspectList();
        this.valueChanged.emit(this.nodeAspects);
    }
    getId(aspect) {
        return aspect?.entry?.title ? aspect?.entry?.title : aspect?.entry?.id.replace(':', '-');
    }
    getTitle(aspect) {
        return aspect?.entry?.title ? aspect?.entry?.title : aspect?.entry?.id;
    }
    updateEqualityOfAspectList() {
        if (this.nodeAspectStatus.length !== this.nodeAspects.length) {
            this.hasEqualAspect = false;
        }
        else {
            this.hasEqualAspect = this.nodeAspects.every((aspect) => this.nodeAspectStatus.includes(aspect));
        }
    }
}
AspectListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListComponent, deps: [{ token: AspectListService }, { token: NodesApiService }], target: i0.ɵɵFactoryTarget.Component });
AspectListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AspectListComponent, selector: "adf-aspect-list", inputs: { nodeId: "nodeId" }, outputs: { valueChanged: "valueChanged" }, ngImport: i0, template: "<div id=\"aspect-list-container\" class=\"adf-aspect-list-container\" *ngIf=\"aspects$ | async as aspects; else loading\">\n    <mat-accordion class=\"adf-accordion-aspect-list\">\n        <mat-expansion-panel *ngFor=\"let aspect of aspects; let colIndex = index\" [id]=\"'aspect-list-'+getId(aspect)\">\n            <mat-expansion-panel-header [id]=\"'aspect-list-'+(getId(aspect))+'header'\">\n                <mat-panel-title>\n                    <mat-checkbox class=\"adf-aspect-list-check-button\" [id]=\"'aspect-list-'+colIndex+'-check'\"\n                                  [checked]=\"nodeAspects?.includes(aspect?.entry?.id)\"\n                                  (click)=\"onCheckBoxClick($event)\"\n                                  (change)=\"onChange($event, aspect?.entry?.id)\">\n                                  <p class=\"adf-aspect-list-element-title\">{{getTitle(aspect)}}</p>\n                    </mat-checkbox>                    \n                </mat-panel-title>\n                <mat-panel-description [id]=\"'aspect-list-'+colIndex+'-title'\"\n                                        [matTooltip]=\"getTitle(aspect)\">\n                    {{getTitle(aspect)}}\n                </mat-panel-description>\n            </mat-expansion-panel-header>\n            <p class=\"adf-property-paragraph\" [id]=\"'aspect-list-'+colIndex+'-description'\"> {{aspect?.entry?.description}}</p>\n\n            <table mat-table [dataSource]=\"aspect?.entry?.properties\" *ngIf=\"aspect?.entry?.properties?.length > 0\" class=\"adf-aspect-property-table\" [id]=\"'aspect-list-'+colIndex+'-properties-table'\">\n                <ng-container matColumnDef=\"name\">\n                  <th mat-header-cell *matHeaderCellDef> {{'ADF-ASPECT-LIST.PROPERTY_NAME' | translate}} </th>\n                  <td mat-cell *matCellDef=\"let property\"> {{property.id}} </td>\n                </ng-container>\n                <ng-container matColumnDef=\"title\">\n                  <th mat-header-cell *matHeaderCellDef> {{'ADF-ASPECT-LIST.DESCRIPTION' | translate}} </th>\n                  <td mat-cell *matCellDef=\"let property\"> {{property.title}} </td>\n                </ng-container>\n                <ng-container matColumnDef=\"dataType\">\n                  <th mat-header-cell *matHeaderCellDef> {{'ADF-ASPECT-LIST.DATA_TYPE' | translate}} </th>\n                  <td mat-cell *matCellDef=\"let property\"> {{property.dataType}} </td>\n                </ng-container>\n                <tr mat-header-row *matHeaderRowDef=\"propertyColumns\"></tr>\n                <tr mat-row *matRowDef=\"let row; columns: propertyColumns;\"></tr>\n              </table>\n        </mat-expansion-panel>\n    </mat-accordion>\n</div>\n\n<ng-template #loading>\n    <div class=\"adf-aspect-list-spinner\">\n       <mat-spinner id=\"adf-aspect-spinner\"></mat-spinner>\n    </div>\n</ng-template>\n", styles: [".adf-aspect-list-spinner{display:flex;align-items:center;justify-content:center;min-height:400px}.adf-aspect-list-container{padding-top:3px;height:400px;overflow:auto;border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-aspect-list-container .adf-aspect-list-check-button{margin-right:5px;align-items:center;display:flex}.adf-aspect-list-container .adf-aspect-list-element-title{display:flex;align-items:center}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-spacing{margin:0}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-header{font-size:smaller}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-header-title{flex:1 1 0}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-header-description{justify-content:flex-start;align-items:center;flex:1 1 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.adf-aspect-property-table{width:100%}.adf-aspect-property-table .mat-column-name{width:15%}.adf-aspect-property-table .mat-column-description{width:65%}.adf-aspect-property-table .mat-column-type{width:20%;padding-left:10px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$2.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i4$2.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i4$2.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i4$2.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i4$2.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i4$2.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i4$2.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i4$2.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i4$2.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i4$2.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: i5$4.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i5$4.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i5$4.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i5$4.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "directive", type: i5$4.MatExpansionPanelDescription, selector: "mat-panel-description" }, { kind: "component", type: i5$3.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i6$1.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i9.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-aspect-list', encapsulation: ViewEncapsulation.None, template: "<div id=\"aspect-list-container\" class=\"adf-aspect-list-container\" *ngIf=\"aspects$ | async as aspects; else loading\">\n    <mat-accordion class=\"adf-accordion-aspect-list\">\n        <mat-expansion-panel *ngFor=\"let aspect of aspects; let colIndex = index\" [id]=\"'aspect-list-'+getId(aspect)\">\n            <mat-expansion-panel-header [id]=\"'aspect-list-'+(getId(aspect))+'header'\">\n                <mat-panel-title>\n                    <mat-checkbox class=\"adf-aspect-list-check-button\" [id]=\"'aspect-list-'+colIndex+'-check'\"\n                                  [checked]=\"nodeAspects?.includes(aspect?.entry?.id)\"\n                                  (click)=\"onCheckBoxClick($event)\"\n                                  (change)=\"onChange($event, aspect?.entry?.id)\">\n                                  <p class=\"adf-aspect-list-element-title\">{{getTitle(aspect)}}</p>\n                    </mat-checkbox>                    \n                </mat-panel-title>\n                <mat-panel-description [id]=\"'aspect-list-'+colIndex+'-title'\"\n                                        [matTooltip]=\"getTitle(aspect)\">\n                    {{getTitle(aspect)}}\n                </mat-panel-description>\n            </mat-expansion-panel-header>\n            <p class=\"adf-property-paragraph\" [id]=\"'aspect-list-'+colIndex+'-description'\"> {{aspect?.entry?.description}}</p>\n\n            <table mat-table [dataSource]=\"aspect?.entry?.properties\" *ngIf=\"aspect?.entry?.properties?.length > 0\" class=\"adf-aspect-property-table\" [id]=\"'aspect-list-'+colIndex+'-properties-table'\">\n                <ng-container matColumnDef=\"name\">\n                  <th mat-header-cell *matHeaderCellDef> {{'ADF-ASPECT-LIST.PROPERTY_NAME' | translate}} </th>\n                  <td mat-cell *matCellDef=\"let property\"> {{property.id}} </td>\n                </ng-container>\n                <ng-container matColumnDef=\"title\">\n                  <th mat-header-cell *matHeaderCellDef> {{'ADF-ASPECT-LIST.DESCRIPTION' | translate}} </th>\n                  <td mat-cell *matCellDef=\"let property\"> {{property.title}} </td>\n                </ng-container>\n                <ng-container matColumnDef=\"dataType\">\n                  <th mat-header-cell *matHeaderCellDef> {{'ADF-ASPECT-LIST.DATA_TYPE' | translate}} </th>\n                  <td mat-cell *matCellDef=\"let property\"> {{property.dataType}} </td>\n                </ng-container>\n                <tr mat-header-row *matHeaderRowDef=\"propertyColumns\"></tr>\n                <tr mat-row *matRowDef=\"let row; columns: propertyColumns;\"></tr>\n              </table>\n        </mat-expansion-panel>\n    </mat-accordion>\n</div>\n\n<ng-template #loading>\n    <div class=\"adf-aspect-list-spinner\">\n       <mat-spinner id=\"adf-aspect-spinner\"></mat-spinner>\n    </div>\n</ng-template>\n", styles: [".adf-aspect-list-spinner{display:flex;align-items:center;justify-content:center;min-height:400px}.adf-aspect-list-container{padding-top:3px;height:400px;overflow:auto;border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-aspect-list-container .adf-aspect-list-check-button{margin-right:5px;align-items:center;display:flex}.adf-aspect-list-container .adf-aspect-list-element-title{display:flex;align-items:center}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-spacing{margin:0}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-header{font-size:smaller}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-header-title{flex:1 1 0}.adf-aspect-list-container .adf-accordion-aspect-list .mat-expansion-panel-header-description{justify-content:flex-start;align-items:center;flex:1 1 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.adf-aspect-property-table{width:100%}.adf-aspect-property-table .mat-column-name{width:15%}.adf-aspect-property-table .mat-column-description{width:65%}.adf-aspect-property-table .mat-column-type{width:20%;padding-left:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: AspectListService }, { type: NodesApiService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AspectListDialogComponent {
    constructor(dialog, data) {
        this.dialog = dialog;
        this.data = data;
        this.currentAspectSelection = [];
        this.title = data.title;
        this.description = data.description;
        this.overTableMessage = data.overTableMessage;
        this.currentNodeId = data.nodeId;
    }
    ngOnInit() {
        this.dialog.backdropClick().subscribe(() => {
            this.close();
        });
        this.dialog.keydownEvents().subscribe(event => {
            // Esc
            if (event.keyCode === 27) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.close();
            }
        });
    }
    onValueChanged(aspectList) {
        this.currentAspectSelection = aspectList;
    }
    close() {
        this.data.select.complete();
    }
    onCancel() {
        this.close();
    }
    onApply() {
        this.data.select.next(this.currentAspectSelection);
        this.close();
    }
}
AspectListDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
AspectListDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AspectListDialogComponent, selector: "adf-aspect-list-dialog", ngImport: i0, template: "<div mat-dialog-title data-automation-id=\"aspect-list-dialog-title\" class=\"adf-aspect-list-dialog\">\n    <h1 class=\"adf-aspect-list-dialog-title\">{{title | translate}}</h1>\n    <div class=\"adf-aspect-list-dialog-description\">{{description | translate}}</div>\n</div>\n\n<div class=\"adf-aspect-list-dialog-information\">\n    <p id=\"aspect-list-dialog-over-table-message\">{{overTableMessage | translate}}</p>\n    <p id=\"aspect-list-dialog-counter\">{{currentAspectSelection ? currentAspectSelection.length : 0}}\n        {{'ADF-ASPECT-LIST.DIALOG.SELECTED' | translate}}</p>\n</div>\n<mat-dialog-content class=\"adf-aspect-dialog-content\">\n    <adf-aspect-list #aspectList (valueChanged)=\"onValueChanged($event)\" [nodeId]=\"currentNodeId\">\n    </adf-aspect-list>\n</mat-dialog-content>\n\n<mat-dialog-actions>\n    <div>\n        <button mat-button (click)=\"aspectList.reset()\" id=\"aspect-list-dialog-actions-reset\"\n            data-automation-id=\"aspect-list-dialog-actions-reset\">{{\n            'ADF-ASPECT-LIST.DIALOG.RESET' | translate }}\n        </button>\n\n        <button mat-button (click)=\"aspectList.clear()\" id=\"aspect-list-dialog-actions-clear\"\n            data-automation-id=\"aspect-list-dialog-actions-clear\">{{\n            'ADF-ASPECT-LIST.DIALOG.CLEAR' | translate }}\n        </button>\n    </div>\n    <div>\n        <button mat-button adf-auto-focus (click)=\"onCancel()\" id=\"aspect-list-dialog-actions-cancel\"\n            data-automation-id=\"aspect-list-dialog-actions-cancel\">{{\n            'ADF-ASPECT-LIST.DIALOG.CANCEL' | translate }}\n        </button>\n\n        <button mat-button (click)=\"onApply()\" id=\"aspect-list-dialog-actions-apply\"\n            [disabled]=\"aspectList.hasEqualAspect\"\n            data-automation-id=\"aspect-list-dialog-actions-apply\">{{\n            'ADF-ASPECT-LIST.DIALOG.APPLY' | translate }}\n        </button>\n    </div>\n</mat-dialog-actions>\n", styles: [".adf-aspect-list-dialog-title{font-size:large;font-weight:200;margin-top:0}.adf-aspect-list-dialog-description{font-size:small;line-height:normal}.adf-aspect-list-dialog-information{display:flex;justify-content:space-between;padding-left:5px;padding-right:5px;font-size:small}.adf-aspect-list-dialog .mat-dialog-actions{justify-content:space-between}.adf-aspect-dialog-content{padding-top:3px}.adf-aspect-dialog-content .adf-aspect-property-table .mat-cell{font-size:smaller}.adf-aspect-dialog-content .adf-aspect-property-table .mat-column-name{width:30%}\n"], dependencies: [{ kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: AutoFocusDirective, selector: "[adf-auto-focus]" }, { kind: "component", type: AspectListComponent, selector: "adf-aspect-list", inputs: ["nodeId"], outputs: ["valueChanged"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-aspect-list-dialog', encapsulation: ViewEncapsulation.None, template: "<div mat-dialog-title data-automation-id=\"aspect-list-dialog-title\" class=\"adf-aspect-list-dialog\">\n    <h1 class=\"adf-aspect-list-dialog-title\">{{title | translate}}</h1>\n    <div class=\"adf-aspect-list-dialog-description\">{{description | translate}}</div>\n</div>\n\n<div class=\"adf-aspect-list-dialog-information\">\n    <p id=\"aspect-list-dialog-over-table-message\">{{overTableMessage | translate}}</p>\n    <p id=\"aspect-list-dialog-counter\">{{currentAspectSelection ? currentAspectSelection.length : 0}}\n        {{'ADF-ASPECT-LIST.DIALOG.SELECTED' | translate}}</p>\n</div>\n<mat-dialog-content class=\"adf-aspect-dialog-content\">\n    <adf-aspect-list #aspectList (valueChanged)=\"onValueChanged($event)\" [nodeId]=\"currentNodeId\">\n    </adf-aspect-list>\n</mat-dialog-content>\n\n<mat-dialog-actions>\n    <div>\n        <button mat-button (click)=\"aspectList.reset()\" id=\"aspect-list-dialog-actions-reset\"\n            data-automation-id=\"aspect-list-dialog-actions-reset\">{{\n            'ADF-ASPECT-LIST.DIALOG.RESET' | translate }}\n        </button>\n\n        <button mat-button (click)=\"aspectList.clear()\" id=\"aspect-list-dialog-actions-clear\"\n            data-automation-id=\"aspect-list-dialog-actions-clear\">{{\n            'ADF-ASPECT-LIST.DIALOG.CLEAR' | translate }}\n        </button>\n    </div>\n    <div>\n        <button mat-button adf-auto-focus (click)=\"onCancel()\" id=\"aspect-list-dialog-actions-cancel\"\n            data-automation-id=\"aspect-list-dialog-actions-cancel\">{{\n            'ADF-ASPECT-LIST.DIALOG.CANCEL' | translate }}\n        </button>\n\n        <button mat-button (click)=\"onApply()\" id=\"aspect-list-dialog-actions-apply\"\n            [disabled]=\"aspectList.hasEqualAspect\"\n            data-automation-id=\"aspect-list-dialog-actions-apply\">{{\n            'ADF-ASPECT-LIST.DIALOG.APPLY' | translate }}\n        </button>\n    </div>\n</mat-dialog-actions>\n", styles: [".adf-aspect-list-dialog-title{font-size:large;font-weight:200;margin-top:0}.adf-aspect-list-dialog-description{font-size:small;line-height:normal}.adf-aspect-list-dialog-information{display:flex;justify-content:space-between;padding-left:5px;padding-right:5px;font-size:small}.adf-aspect-list-dialog .mat-dialog-actions{justify-content:space-between}.adf-aspect-dialog-content{padding-top:3px}.adf-aspect-dialog-content .adf-aspect-property-table .mat-cell{font-size:smaller}.adf-aspect-dialog-content .adf-aspect-property-table .mat-column-name{width:30%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DialogAspectListService {
    constructor(dialog, overlayContainer) {
        this.dialog = dialog;
        this.overlayContainer = overlayContainer;
    }
    openAspectListDialog(nodeId, selectorAutoFocusedOnClose) {
        const select = new Subject();
        select.subscribe({
            complete: this.close.bind(this)
        });
        const data = {
            title: 'ADF-ASPECT-LIST.DIALOG.TITLE',
            description: 'ADF-ASPECT-LIST.DIALOG.DESCRIPTION',
            overTableMessage: 'ADF-ASPECT-LIST.DIALOG.OVER-TABLE-MESSAGE',
            select,
            nodeId
        };
        this.openDialog(data, 'adf-aspect-list-dialog', '750px', selectorAutoFocusedOnClose);
        return select;
    }
    openDialog(data, panelClass, width, selectorAutoFocusedOnClose) {
        this.dialog.open(AspectListDialogComponent, {
            data,
            panelClass,
            width,
            role: 'dialog',
            disableClose: true
        }).afterClosed().subscribe(() => this.focusOnClose(selectorAutoFocusedOnClose));
        this.overlayContainer.getContainerElement().setAttribute('role', 'main');
    }
    close() {
        this.dialog.closeAll();
        this.overlayContainer.getContainerElement().setAttribute('role', 'region');
    }
    focusOnClose(selectorAutoFocusedOnClose) {
        if (selectorAutoFocusedOnClose) {
            document.querySelector(selectorAutoFocusedOnClose).focus();
        }
    }
}
DialogAspectListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DialogAspectListService, deps: [{ token: i1$1.MatDialog }, { token: i5$5.OverlayContainer }], target: i0.ɵɵFactoryTarget.Injectable });
DialogAspectListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DialogAspectListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: DialogAspectListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i5$5.OverlayContainer }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeAspectService {
    constructor(nodesApiService, dialogAspectListService, cardViewContentUpdateService, tagService) {
        this.nodesApiService = nodesApiService;
        this.dialogAspectListService = dialogAspectListService;
        this.cardViewContentUpdateService = cardViewContentUpdateService;
        this.tagService = tagService;
    }
    updateNodeAspects(nodeId, selectorAutoFocusedOnClose) {
        this.dialogAspectListService.openAspectListDialog(nodeId, selectorAutoFocusedOnClose).subscribe((aspectList) => {
            this.nodesApiService.updateNode(nodeId, { aspectNames: [...aspectList] }).subscribe((updatedNode) => {
                this.nodesApiService.nodeUpdated.next(updatedNode);
                this.cardViewContentUpdateService.updateNodeAspect(updatedNode);
                this.tagService.refresh.emit();
            });
        });
    }
}
NodeAspectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeAspectService, deps: [{ token: NodesApiService }, { token: DialogAspectListService }, { token: CardViewContentUpdateService }, { token: TagService }], target: i0.ɵɵFactoryTarget.Injectable });
NodeAspectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeAspectService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeAspectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }, { type: DialogAspectListService }, { type: CardViewContentUpdateService }, { type: TagService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentMetadataCardComponent {
    constructor(contentService, nodeAspectService, versionCompatibilityService) {
        this.contentService = contentService;
        this.nodeAspectService = nodeAspectService;
        this.versionCompatibilityService = versionCompatibilityService;
        /** (optional) This flag displays/hides empty metadata
         * fields.
         */
        this.displayEmpty = false;
        /** (optional) This flag displays desired aspect when open for the first time
         * fields.
         */
        this.displayAspect = null;
        /** (optional) This flag sets the metadata in read only mode
         * preventing changes.
         */
        this.readOnly = false;
        /** (optional) This flag allows the component to display more
         * than one accordion at a time.
         */
        this.multi = false;
        this._displayDefaultProperties = true;
        this.editable = false;
        this.editAspectSupported = false;
        this.editAspectSupported = this.versionCompatibilityService.isVersionSupported('7');
    }
    /** (optional) This flag displays/hides the metadata
     * properties.
     */
    set displayDefaultProperties(value) {
        this._displayDefaultProperties = value;
        this.onDisplayDefaultPropertiesChange();
    }
    get displayDefaultProperties() {
        return this._displayDefaultProperties;
    }
    ngOnChanges(changes) {
        if (changes.displayAspect && changes.displayAspect.currentValue) {
            this.expanded = true;
        }
    }
    onDisplayDefaultPropertiesChange() {
        this.expanded = !this._displayDefaultProperties;
    }
    toggleEdit() {
        this.editable = !this.editable;
    }
    toggleExpanded() {
        this.expanded = !this.expanded;
    }
    hasAllowableOperations() {
        return this.contentService.hasAllowableOperations(this.node, AllowableOperationsEnum.UPDATE);
    }
    openAspectDialog() {
        this.nodeAspectService.updateNodeAspects(this.node.id);
    }
    isEditAspectSupported() {
        return !this.readOnly && this.hasAllowableOperations() && this.editAspectSupported;
    }
}
ContentMetadataCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataCardComponent, deps: [{ token: ContentService }, { token: NodeAspectService }, { token: VersionCompatibilityService }], target: i0.ɵɵFactoryTarget.Component });
ContentMetadataCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ContentMetadataCardComponent, selector: "adf-content-metadata-card", inputs: { node: "node", displayEmpty: "displayEmpty", displayAspect: "displayAspect", preset: "preset", readOnly: "readOnly", multi: "multi", displayDefaultProperties: "displayDefaultProperties" }, host: { classAttribute: "adf-content-metadata-card" }, usesOnChanges: true, ngImport: i0, template: "<mat-card *ngIf=\"node\">\n    <mat-card-content>\n        <adf-content-metadata\n            [displayDefaultProperties]=\"displayDefaultProperties\"\n            [expanded]=\"expanded\"\n            [node]=\"node\"\n            [displayEmpty]=\"displayEmpty\"\n            [editable]=\"editable\"\n            [multi]=\"multi\"\n            [displayAspect]=\"displayAspect\"\n            [preset]=\"preset\"\n            [displayTags]=\"true\"\n            [displayCategories]=\"true\">\n        </adf-content-metadata>\n    </mat-card-content>\n    <mat-card-footer class=\"adf-content-metadata-card-footer\">\n        <div>\n            <button *ngIf=\"isEditAspectSupported()\"\n                mat-icon-button\n                (click)=\"openAspectDialog()\"\n                [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT_ASPECTS' | translate\"\n                [attr.aria-label]=\"'CORE.METADATA.ACCESSIBILITY.EDIT_ASPECTS' | translate\"\n                data-automation-id=\"meta-data-card-edit-aspect\">\n                <mat-icon>menu</mat-icon>\n            </button>\n            <button *ngIf=\"!readOnly && hasAllowableOperations()\"\n                mat-icon-button\n                (click)=\"toggleEdit()\"\n                [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                [attr.aria-label]=\"'CORE.METADATA.ACCESSIBILITY.EDIT' | translate\"\n                data-automation-id=\"meta-data-card-toggle-edit\">\n                <mat-icon>mode_edit</mat-icon>\n            </button>\n        </div>\n        <button *ngIf=\"displayDefaultProperties\" mat-button (click)=\"toggleExpanded()\" data-automation-id=\"meta-data-card-toggle-expand\">\n            <ng-container *ngIf=\"!expanded\">\n                <span data-automation-id=\"meta-data-card-toggle-expand-label\">{{ 'ADF_VIEWER.SIDEBAR.METADATA.MORE_INFORMATION' | translate }}</span>\n                <mat-icon>keyboard_arrow_down</mat-icon>\n            </ng-container>\n            <ng-container *ngIf=\"expanded\">\n                <span data-automation-id=\"meta-data-card-toggle-expand-label\">{{ 'ADF_VIEWER.SIDEBAR.METADATA.LESS_INFORMATION' | translate }}</span>\n                <mat-icon>keyboard_arrow_up</mat-icon>\n            </ng-container>\n        </button>\n    </mat-card-footer>\n</mat-card>\n", styles: [".adf-content-metadata-card .mat-card{padding:0}.adf-content-metadata-card .mat-card .mat-card-content{margin-bottom:0}.adf-content-metadata-card-footer.mat-card-footer{margin:0;padding:8px 12px;border-top:1px solid var(--adf-theme-foreground-text-color-007);display:flex;place-content:stretch space-between;align-items:stretch;max-height:100%}.adf-content-metadata-card-footer.mat-card-footer button{color:var(--adf-theme-foreground-text-color-054)}.adf-content-metadata-card-footer.mat-card-footer button:hover{color:var(--adf-theme-foreground-text-color-087)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6$3.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i6$3.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "directive", type: i6$3.MatCardFooter, selector: "mat-card-footer" }, { kind: "component", type: ContentMetadataComponent, selector: "adf-content-metadata", inputs: ["node", "editable", "displayEmpty", "expanded", "multi", "preset", "displayDefaultProperties", "displayAspect", "copyToClipboardAction", "useChipsForMultiValueProperty", "displayTags", "displayCategories"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-content-metadata-card', encapsulation: ViewEncapsulation.None, host: { class: 'adf-content-metadata-card' }, template: "<mat-card *ngIf=\"node\">\n    <mat-card-content>\n        <adf-content-metadata\n            [displayDefaultProperties]=\"displayDefaultProperties\"\n            [expanded]=\"expanded\"\n            [node]=\"node\"\n            [displayEmpty]=\"displayEmpty\"\n            [editable]=\"editable\"\n            [multi]=\"multi\"\n            [displayAspect]=\"displayAspect\"\n            [preset]=\"preset\"\n            [displayTags]=\"true\"\n            [displayCategories]=\"true\">\n        </adf-content-metadata>\n    </mat-card-content>\n    <mat-card-footer class=\"adf-content-metadata-card-footer\">\n        <div>\n            <button *ngIf=\"isEditAspectSupported()\"\n                mat-icon-button\n                (click)=\"openAspectDialog()\"\n                [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT_ASPECTS' | translate\"\n                [attr.aria-label]=\"'CORE.METADATA.ACCESSIBILITY.EDIT_ASPECTS' | translate\"\n                data-automation-id=\"meta-data-card-edit-aspect\">\n                <mat-icon>menu</mat-icon>\n            </button>\n            <button *ngIf=\"!readOnly && hasAllowableOperations()\"\n                mat-icon-button\n                (click)=\"toggleEdit()\"\n                [attr.title]=\"'CORE.METADATA.ACTIONS.EDIT' | translate\"\n                [attr.aria-label]=\"'CORE.METADATA.ACCESSIBILITY.EDIT' | translate\"\n                data-automation-id=\"meta-data-card-toggle-edit\">\n                <mat-icon>mode_edit</mat-icon>\n            </button>\n        </div>\n        <button *ngIf=\"displayDefaultProperties\" mat-button (click)=\"toggleExpanded()\" data-automation-id=\"meta-data-card-toggle-expand\">\n            <ng-container *ngIf=\"!expanded\">\n                <span data-automation-id=\"meta-data-card-toggle-expand-label\">{{ 'ADF_VIEWER.SIDEBAR.METADATA.MORE_INFORMATION' | translate }}</span>\n                <mat-icon>keyboard_arrow_down</mat-icon>\n            </ng-container>\n            <ng-container *ngIf=\"expanded\">\n                <span data-automation-id=\"meta-data-card-toggle-expand-label\">{{ 'ADF_VIEWER.SIDEBAR.METADATA.LESS_INFORMATION' | translate }}</span>\n                <mat-icon>keyboard_arrow_up</mat-icon>\n            </ng-container>\n        </button>\n    </mat-card-footer>\n</mat-card>\n", styles: [".adf-content-metadata-card .mat-card{padding:0}.adf-content-metadata-card .mat-card .mat-card-content{margin-bottom:0}.adf-content-metadata-card-footer.mat-card-footer{margin:0;padding:8px 12px;border-top:1px solid var(--adf-theme-foreground-text-color-007);display:flex;place-content:stretch space-between;align-items:stretch;max-height:100%}.adf-content-metadata-card-footer.mat-card-footer button{color:var(--adf-theme-foreground-text-color-054)}.adf-content-metadata-card-footer.mat-card-footer button:hover{color:var(--adf-theme-foreground-text-color-087)}\n"] }]
        }], ctorParameters: function () { return [{ type: ContentService }, { type: NodeAspectService }, { type: VersionCompatibilityService }]; }, propDecorators: { node: [{
                type: Input
            }], displayEmpty: [{
                type: Input
            }], displayAspect: [{
                type: Input
            }], preset: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], multi: [{
                type: Input
            }], displayDefaultProperties: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CategoriesModule {
}
CategoriesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoriesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CategoriesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: CategoriesModule, declarations: [CategoriesManagementComponent], imports: [CommonModule,
        CoreModule,
        MaterialModule,
        TranslateModule,
        ContentDirectiveModule], exports: [CategoriesManagementComponent] });
CategoriesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoriesModule, imports: [CommonModule,
        CoreModule,
        MaterialModule,
        TranslateModule,
        ContentDirectiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoriesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoreModule,
                        MaterialModule,
                        TranslateModule,
                        ContentDirectiveModule
                    ],
                    declarations: [
                        CategoriesManagementComponent
                    ],
                    exports: [
                        CategoriesManagementComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentMetadataModule {
}
ContentMetadataModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentMetadataModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataModule, declarations: [ContentMetadataComponent,
        ContentMetadataCardComponent], imports: [CommonModule,
        MaterialModule,
        CoreModule,
        TagModule,
        CategoriesModule], exports: [ContentMetadataComponent,
        ContentMetadataCardComponent] });
ContentMetadataModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataModule, imports: [CommonModule,
        MaterialModule,
        CoreModule,
        TagModule,
        CategoriesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentMetadataModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        CoreModule,
                        TagModule,
                        CategoriesModule
                    ],
                    exports: [
                        ContentMetadataComponent,
                        ContentMetadataCardComponent
                    ],
                    declarations: [
                        ContentMetadataComponent,
                        ContentMetadataCardComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PermissionDisplayModel {
    constructor(obj) {
        this.isInherited = false;
        if (obj) {
            this.authorityId = obj.authorityId;
            this.name = obj.name;
            this.accessStatus = obj.accessStatus;
            this.isInherited = obj.isInherited !== null && obj.isInherited !== undefined ? obj.isInherited : false;
            this.icon = obj.icon ? obj.icon : 'vpn_key';
        }
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodePermissionService {
    constructor(apiService, searchApiService, nodeService, translation) {
        this.apiService = apiService;
        this.searchApiService = searchApiService;
        this.nodeService = nodeService;
        this.translation = translation;
    }
    get groupsApi() {
        this._groupsApi = this._groupsApi ?? new GroupsApi(this.apiService.getInstance());
        return this._groupsApi;
    }
    /**
     * Gets a list of roles for the current node.
     *
     * @param node The target node
     * @returns Array of strings representing the roles
     */
    getNodeRoles(node) {
        const retrieveSiteQueryBody = this.buildRetrieveSiteQueryBody(node.path.elements);
        return this.searchApiService.searchByQueryBody(retrieveSiteQueryBody)
            .pipe(switchMap((siteNodeList) => {
            if (siteNodeList.list.entries.length > 0) {
                const siteName = siteNodeList.list.entries[0].entry.name;
                return this.getGroupMembersBySiteName(siteName);
            }
            else {
                return of(node.permissions?.settable);
            }
        }));
    }
    getNodePermissions(node) {
        const result = [];
        if (node?.permissions?.locallySet) {
            node.permissions.locallySet.map((permissionElement) => {
                result.push(new PermissionDisplayModel(permissionElement));
            });
        }
        if (node?.permissions?.inherited) {
            node.permissions.inherited.map((permissionElement) => {
                const permissionInherited = new PermissionDisplayModel(permissionElement);
                permissionInherited.isInherited = true;
                result.push(permissionInherited);
            });
        }
        return result;
    }
    /**
     * Updates the permission role for a node.
     *
     * @param node Target node
     * @param updatedPermissionRole Permission role to update or add
     * @returns Node with updated permission
     */
    updatePermissionRole(node, updatedPermissionRole) {
        const permissionBody = { permissions: { locallySet: [] } };
        const index = node.permissions.locallySet.map((permission) => permission.authorityId).indexOf(updatedPermissionRole.authorityId);
        permissionBody.permissions.locallySet = permissionBody.permissions.locallySet.concat(node.permissions.locallySet);
        if (index !== -1) {
            permissionBody.permissions.locallySet[index] = updatedPermissionRole;
        }
        else {
            permissionBody.permissions.locallySet.push(updatedPermissionRole);
        }
        return this.nodeService.updateNode(node.id, permissionBody);
    }
    /**
     * Update permissions for a node.
     *
     * @param nodeId ID of the target node
     * @param permissionList New permission settings
     * @returns Node with updated permissions
     */
    updateNodePermissions(nodeId, permissionList) {
        return this.nodeService.getNode(nodeId).pipe(switchMap((node) => this.updateLocallySetPermissions(node, permissionList)));
    }
    /**
     * Updates the locally set permissions for a node.
     *
     * @param node ID of the target node
     * @param permissions Permission settings
     * @returns Node with updated permissions
     */
    updateLocallySetPermissions(node, permissions) {
        const permissionBody = { permissions: { locallySet: [] } };
        const permissionList = permissions;
        const duplicatedPermissions = this.getDuplicatedPermissions(node.permissions.locallySet, permissionList);
        if (duplicatedPermissions.length > 0) {
            const list = duplicatedPermissions.map((permission) => 'authority -> ' + permission.authorityId + ' / role -> ' + permission.name).join(', ');
            const duplicatePermissionMessage = this.translation.instant('PERMISSION_MANAGER.ERROR.DUPLICATE-PERMISSION', { list });
            return throwError(duplicatePermissionMessage);
        }
        permissionBody.permissions.locallySet = node.permissions.locallySet ? node.permissions.locallySet.concat(permissionList) : permissionList;
        return this.nodeService.updateNode(node.id, permissionBody);
    }
    getDuplicatedPermissions(nodeLocallySet, permissionListAdded) {
        const duplicatePermissions = [];
        if (nodeLocallySet) {
            permissionListAdded.forEach((permission) => {
                const duplicate = nodeLocallySet.find((localPermission) => this.isEqualPermission(localPermission, permission));
                if (duplicate) {
                    duplicatePermissions.push(duplicate);
                }
            });
        }
        return duplicatePermissions;
    }
    isEqualPermission(oldPermission, newPermission) {
        return oldPermission.accessStatus === newPermission.accessStatus &&
            oldPermission.authorityId === newPermission.authorityId &&
            oldPermission.name === newPermission.name;
    }
    /**
     * Removes a permission setting from a node.
     *
     * @param node ID of the target node
     * @param permissionToRemove Permission setting to remove
     * @returns Node with modified permissions
     */
    removePermission(node, permissionToRemove) {
        const permissionBody = { permissions: { locallySet: [] } };
        const index = node.permissions.locallySet.map((permission) => permission.authorityId).indexOf(permissionToRemove.authorityId);
        if (index !== -1) {
            node.permissions.locallySet.splice(index, 1);
            permissionBody.permissions.locallySet = node.permissions.locallySet;
            return this.nodeService.updateNode(node.id, permissionBody);
        }
        else {
            return of(node);
        }
    }
    getGroupMembersBySiteName(siteName) {
        const groupName = 'GROUP_site_' + siteName;
        return this.getGroupMemberByGroupName(groupName)
            .pipe(map((groupMemberPaging) => {
            const displayResult = [];
            groupMemberPaging.list.entries.forEach((member) => {
                displayResult.push(this.formattedRoleName(member.entry.displayName, 'site_' + siteName));
            });
            return displayResult;
        }));
    }
    /**
     * Gets all members related to a group name.
     *
     * @param groupName Name of group to look for members
     * @param opts Extra options supported by JS-API
     * @returns List of members
     */
    getGroupMemberByGroupName(groupName, opts) {
        return from(this.groupsApi.listGroupMemberships(groupName, opts));
    }
    formattedRoleName(displayName, siteName) {
        return displayName.replace(siteName + '_', '');
    }
    buildRetrieveSiteQueryBody(nodePath) {
        const pathNames = nodePath.map((node) => 'name: "' + node.name + '"');
        const builtPathNames = pathNames.join(' OR ');
        return {
            query: {
                query: builtPathNames
            },
            paging: {
                maxItems: 100,
                skipCount: 0
            },
            include: ['aspectNames', 'properties'],
            filterQueries: [
                {
                    query: `TYPE:'st:site'`
                }
            ]
        };
    }
    getLocalPermissions(node) {
        const result = [];
        if (node?.permissions?.locallySet) {
            node.permissions.locallySet.forEach((permissionElement) => {
                result.push(new PermissionDisplayModel(permissionElement));
            });
        }
        return result;
    }
    getInheritedPermission(node) {
        const result = [];
        if (node?.permissions?.inherited) {
            node.permissions.inherited.forEach((permissionElement) => {
                const permissionInherited = new PermissionDisplayModel(permissionElement);
                permissionInherited.isInherited = true;
                result.push(permissionInherited);
            });
        }
        return result;
    }
    /**
     * Removes permissions setting from a node.
     *
     * @param node target node with permission
     * @param permissions Permissions to remove
     * @returns Node with modified permissions
     */
    removePermissions(node, permissions) {
        const permissionBody = { permissions: { locallySet: [] } };
        permissions.forEach((permission) => {
            const index = node.permissions.locallySet.findIndex((locallySet) => locallySet.authorityId === permission.authorityId);
            if (index !== -1) {
                node.permissions.locallySet.splice(index, 1);
            }
        });
        permissionBody.permissions.locallySet = node.permissions.locallySet;
        return this.nodeService.updateNode(node.id, permissionBody);
    }
    /**
     * updates permissions setting from a node.
     *
     * @param node target node with permission
     * @param permissions Permissions to update
     * @returns Node with modified permissions
     */
    updatePermissions(node, permissions) {
        const permissionBody = { permissions: { locallySet: [] } };
        permissionBody.permissions.locallySet = permissions;
        return this.nodeService.updateNode(node.id, permissionBody);
    }
    /**
     * Gets all node detail for nodeId along with settable permissions.
     *
     * @param nodeId Id of the node
     * @returns node and it's associated roles { node: Node; roles: RoleModel[] }
     */
    getNodeWithRoles(nodeId) {
        return this.nodeService.getNode(nodeId).pipe(switchMap(node => forkJoin({
            node: of(node),
            roles: this.getNodeRoles(node)
                .pipe(catchError(() => of(node.permissions?.settable)), map(_roles => _roles.map(role => ({ role, label: role }))))
        })));
    }
    transformNodeToUserPerson(node) {
        let person = null;
        let group = null;
        if (node.nodeType === 'cm:person') {
            const firstName = node.properties['cm:firstName'];
            const lastName = node.properties['cm:lastName'];
            const email = node.properties['cm:email'];
            const id = node.properties['cm:userName'];
            person = new EcmUserModel({ id, firstName, lastName, email });
        }
        if (node.nodeType === 'cm:authorityContainer') {
            const displayName = node.properties['cm:authorityDisplayName'] || node.properties['cm:authorityName'];
            const id = node.properties['cm:authorityName'];
            group = new Group({ displayName, id });
        }
        return { person, group };
    }
}
NodePermissionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePermissionService, deps: [{ token: i1.AlfrescoApiService }, { token: SearchService }, { token: NodesApiService }, { token: i1.TranslationService }], target: i0.ɵɵFactoryTarget.Injectable });
NodePermissionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePermissionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePermissionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: SearchService }, { type: NodesApiService }, { type: i1.TranslationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MemberModel {
    constructor(input) {
        this.readonly = false;
        if (input) {
            Object.assign(this, input);
        }
    }
    static parseFromSearchResult({ entry }) {
        const result = new MemberModel();
        if (entry.nodeType === 'cm:person') {
            const person = new EcmUserModel({
                firstName: entry.properties['cm:firstName'],
                lastName: entry.properties['cm:lastName'],
                email: entry.properties['cm:email'],
                id: entry.properties['cm:userName']
            });
            result.id = person.id;
            result.entry = { person };
            result.accessStatus = 'ALLOWED';
            return result;
        }
        if (entry.nodeType === 'cm:authorityContainer') {
            const group = new Group({
                id: entry.properties['cm:authorityName'],
                displayName: entry.properties['cm:authorityDisplayName'] || entry.properties['cm:authorityName']
            });
            result.id = group.id;
            result.entry = { group };
            result.accessStatus = 'ALLOWED';
            return result;
        }
        return null;
    }
    toPermissionElement() {
        return {
            authorityId: this.id,
            name: this.role,
            accessStatus: this.accessStatus
        };
    }
}

const SEARCH_QUERY_TOKEN = new InjectionToken('Alfresco Search Query Token');
class SearchPermissionConfigurationService {
    constructor(queryProvider) {
        this.queryProvider = queryProvider;
    }
    generateQueryBody(searchTerm, maxResults, skipCount) {
        const defaultQueryBody = {
            query: {
                query: this.getQuery(searchTerm)
            },
            include: ['properties', 'aspectNames'],
            paging: {
                maxItems: maxResults,
                skipCount
            },
            filterQueries: [
                /* eslint-disable-next-line */
                { query: "TYPE:'cm:authority'" }
            ]
        };
        return defaultQueryBody;
    }
    getQuery(searchTerm) {
        let query;
        if (this.queryProvider && this.queryProvider.query) {
            query = this.queryProvider.query.replace(new RegExp(/\${([^}]+)}/g), searchTerm);
        }
        else {
            query = `(email:*${searchTerm}* OR firstName:*${searchTerm}* OR lastName:*${searchTerm}* OR displayName:*${searchTerm}* OR authorityName:*${searchTerm}* OR authorityDisplayName:*${searchTerm}*) AND ANAME:(\"0/APP.DEFAULT\")`;
        }
        return query;
    }
}
SearchPermissionConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchPermissionConfigurationService, deps: [{ token: SEARCH_QUERY_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
SearchPermissionConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchPermissionConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SearchPermissionConfigurationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SEARCH_QUERY_TOKEN]
                }] }]; } });

class UserIconColumnComponent {
    constructor(nodePermissionService) {
        this.nodePermissionService = nodePermissionService;
        this.selected = false;
        this.displayText$ = new BehaviorSubject(null);
        this.group = false;
    }
    get isSelected() {
        return this.context?.row?.isSelected || this.selected;
    }
    ngOnInit() {
        if (this.context) {
            const { person, group, authorityId } = this.context.row.obj?.entry ?? this.context.row.obj;
            this.group = this.isGroup(group, authorityId);
            this.displayText$.next(person || group || { displayName: authorityId });
        }
        if (this.node) {
            const { person, group } = this.nodePermissionService.transformNodeToUserPerson(this.node.entry);
            this.group = this.isGroup(group, null);
            this.displayText$.next(person || group);
        }
    }
    isGroup(group, authorityId) {
        return !!group || authorityId?.startsWith('GROUP_') || authorityId?.startsWith('ROLE_');
    }
}
UserIconColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserIconColumnComponent, deps: [{ token: NodePermissionService }], target: i0.ɵɵFactoryTarget.Component });
UserIconColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UserIconColumnComponent, selector: "adf-user-icon-column", inputs: { context: "context", node: "node", selected: "selected" }, host: { classAttribute: "adf-user-icon-column adf-datatable-content-cell" }, ngImport: i0, template: `
        <div class="adf-cell-value" [attr.id]="group ? 'group-icon' : 'person-icon'"  *ngIf="!isSelected">
            <ng-container *ngIf="displayText$ | async as user">
                <mat-icon *ngIf="group" class="adf-group-icon">people_alt_outline</mat-icon>
                <div *ngIf="!group" [outerHTML]="user | usernameInitials: 'adf-people-initial'"></div>
            </ng-container>
        </div>
        <div class="adf-cell-value" *ngIf="isSelected">
            <mat-icon class="adf-people-select-icon adf-datatable-selected" svgIcon="selected"></mat-icon>
        </div>
    `, isInline: true, styles: [".adf-people-initial{background:var(--theme-primary-color);border-radius:50%;display:flex;justify-content:center;align-items:center;width:40px;height:40px;color:var(--theme-primary-color-default-contrast)!important;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase}.adf-group-icon{height:20px!important;width:20px!important;background:var(--theme-primary-color);border-radius:50%;padding:10px;color:var(--theme-primary-color-default-contrast)!important;font-weight:bolder;font-size:var(--theme-title-font-size)}.adf-people-select-icon{margin:0!important}.adf-people-select-icon svg{fill:var(--theme-accent-color);width:40px;height:40px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: i1.InitialUsernamePipe, name: "usernameInitials" }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserIconColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-user-icon-column', template: `
        <div class="adf-cell-value" [attr.id]="group ? 'group-icon' : 'person-icon'"  *ngIf="!isSelected">
            <ng-container *ngIf="displayText$ | async as user">
                <mat-icon *ngIf="group" class="adf-group-icon">people_alt_outline</mat-icon>
                <div *ngIf="!group" [outerHTML]="user | usernameInitials: 'adf-people-initial'"></div>
            </ng-container>
        </div>
        <div class="adf-cell-value" *ngIf="isSelected">
            <mat-icon class="adf-people-select-icon adf-datatable-selected" svgIcon="selected"></mat-icon>
        </div>
    `, encapsulation: ViewEncapsulation.None, host: { class: 'adf-user-icon-column adf-datatable-content-cell' }, styles: [".adf-people-initial{background:var(--theme-primary-color);border-radius:50%;display:flex;justify-content:center;align-items:center;width:40px;height:40px;color:var(--theme-primary-color-default-contrast)!important;font-weight:bolder;font-size:var(--theme-adf-picture-1-font-size);text-transform:uppercase}.adf-group-icon{height:20px!important;width:20px!important;background:var(--theme-primary-color);border-radius:50%;padding:10px;color:var(--theme-primary-color-default-contrast)!important;font-weight:bolder;font-size:var(--theme-title-font-size)}.adf-people-select-icon{margin:0!important}.adf-people-select-icon svg{fill:var(--theme-accent-color);width:40px;height:40px}\n"] }]
        }], ctorParameters: function () { return [{ type: NodePermissionService }]; }, propDecorators: { context: [{
                type: Input
            }], node: [{
                type: Input
            }], selected: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AddPermissionPanelComponent {
    constructor() {
        /** Emitted when a permission list item is selected. */
        this.select = new EventEmitter();
        this.searchInput = new UntypedFormControl();
        this.searchedWord = '';
        this.debounceSearch = 200;
        this.selectedItems = [];
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.EVERYONE = new NodeEntry({ entry: { nodeType: 'cm:authorityContainer', properties: { 'cm:authorityName': 'GROUP_EVERYONE' } } });
        this.searchInput.valueChanges
            .pipe(debounceTime(this.debounceSearch))
            .subscribe((searchValue) => {
            const selectionOptions = this.matSelectionList.selectedOptions.selected.map(option => option.value);
            this.selectedItems.push(...selectionOptions);
            this.matSelectionList.deselectAll();
            this.searchedWord = searchValue;
            if (!searchValue) {
                this.search.resetResults();
            }
        });
    }
    onSelectionChange() {
        const currentSelection = this.matSelectionList.selectedOptions.selected.map(option => option.value);
        const uniqueSelection = [...currentSelection, ...this.selectedItems]
            .reduce((uniquesElements, currentElement) => {
            const isExist = uniquesElements.find(uniqueElement => uniqueElement.entry.id === currentElement.entry.id);
            if (!isExist) {
                uniquesElements.push(currentElement);
            }
            return uniquesElements;
        }, []);
        this.select.emit(uniqueSelection);
    }
    clearSearch() {
        this.searchedWord = '';
        this.selectedItems.splice(0, this.selectedItems.length);
        this.search.resetResults();
    }
}
AddPermissionPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddPermissionPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AddPermissionPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AddPermissionPanelComponent, selector: "adf-add-permission-panel", outputs: { select: "select" }, providers: [
        { provide: SearchConfigurationService, useClass: SearchPermissionConfigurationService },
        SearchService
    ], viewQueries: [{ propertyName: "search", first: true, predicate: ["search"], descendants: true, static: true }, { propertyName: "matSelectionList", first: true, predicate: MatSelectionList, descendants: true }], ngImport: i0, template: "<mat-form-field floatPlaceholder=\"never\"\n                class=\"adf-permission-search-input\">\n    <input matInput\n           id=\"searchInput\"\n           [formControl]=\"searchInput\"\n           type=\"text\"\n           title=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.SEARCH' | translate}}\"\n           placeholder=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.SEARCH' | translate}}\"\n           [value]=\"searchedWord\">\n\n    <mat-icon *ngIf=\"searchedWord?.length > 0\"\n              class=\"adf-permission-search-icon\"\n              data-automation-id=\"adf-permission-clear-input\"\n              id=\"adf-permission-clear-input\"\n              matSuffix\n              (click)=\"clearSearch()\">clear\n    </mat-icon>\n\n    <mat-icon *ngIf=\"searchedWord?.length === 0\"\n              class=\"adf-permission-search-icon\"\n              data-automation-id=\"adf-permission-search-icon\"\n              matSuffix>search\n    </mat-icon>\n</mat-form-field>\n\n<div *ngIf=\"searchedWord?.length === 0\"\n     class=\"adf-permission-start-message\"\n     id=\"adf-add-permission-type-search\">\n    <span>{{'PERMISSION_MANAGER.ADD-PERMISSION.TYPE-MESSAGE' | translate}}</span>\n</div>\n\n<adf-search #search\n            [searchTerm]=\"searchedWord\"\n            id=\"adf-add-permission-authority-results\"\n            class=\"adf-permission-result-list\"\n            [class.adf-permission-result-list-search]=\"searchedWord.length === 0\">\n    <ng-template let-data>\n        <mat-selection-list class=\"adf-permission-result-list-elements\"\n                            title=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.USER-GROUP-LIST' | translate}}\"\n                            (selectionChange)=\"onSelectionChange()\">\n            <mat-list-option id=\"adf-add-permission-group-everyone\"\n                             class=\"adf-list-option-item\"\n                             #eveyone\n                             disableRipple\n                             [value]=\"EVERYONE\">\n                <adf-user-icon-column [node]=\"EVERYONE\" id=\"add-group-icon\" [selected]=\"eveyone.selected\"></adf-user-icon-column>\n                <p class=\"adf-result-name\">\n                    {{'PERMISSION_MANAGER.ADD-PERMISSION.EVERYONE' | translate}}\n                </p>\n            </mat-list-option>\n\n            <mat-list-option *ngFor=\"let item of data?.list?.entries; let idx = index\"\n                             disableRipple\n                             [value]=\"item\"\n                             class=\"adf-list-option-item\"\n                             id=\"result_option_{{idx}}\"\n                             #option>\n                <adf-user-icon-column [node]=\"item\" [selected]=\"option.selected\"></adf-user-icon-column>\n                <p class=\"adf-result-name\">\n                    <ng-container *ngIf=\"item.entry?.properties['cm:authorityDisplayName']; else authorityName\">\n                        {{item.entry.properties['cm:authorityDisplayName']}}\n                    </ng-container>\n                    <ng-template #authorityName>\n                        <ng-container *ngIf=\"item.entry?.properties['cm:authorityName']; else owner\">\n                            {{item.entry.properties['cm:authorityName']}}\n                        </ng-container>\n                    </ng-template>\n                    <ng-template #owner>\n                        {{item.entry?.properties['cm:firstName'] ? item.entry?.properties['cm:firstName'] : '' }}\n                        {{item.entry?.properties['cm:lastName'] ? item.entry?.properties['cm:lastName']: ''}}\n                    </ng-template>\n                </p>\n            </mat-list-option>\n        </mat-selection-list>\n    </ng-template>\n</adf-search>\n", styles: [".adf-permission-result-list{display:flex;height:calc(100% - 75px);overflow:auto;border:2px solid var(--adf-theme-foreground-text-color-007)}.adf-permission-result-list-elements{width:100%}.adf-permission-result-list-search{display:none}.adf-permission-start-message{display:flex;align-items:center;justify-content:space-around;height:calc(100% - 75px);overflow:auto;border:2px solid var(--adf-theme-foreground-text-color-007)}.adf-permission-no-result{display:flex;align-items:center;justify-content:space-around;width:100%}.adf-permission-search-input{width:100%}.adf-permission-search-input-icon{color:var(--adf-theme-background-selected-button-color);cursor:pointer}.adf-permission-search-input-icon:hover{color:var(--adf-theme-foreground-base-color)}.adf-list-option-item mat-pseudo-checkbox{display:none}.adf-list-option-item .mat-list-text{display:flex;flex-direction:row!important;align-items:center}.adf-list-option-item .mat-list-text .adf-result-name{padding-left:16px!important}.adf-permission-action[disabled]{opacity:.6}.adf-permission-action:enabled{color:var(--theme-primary-color)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i8$1.MatSelectionList, selector: "mat-selection-list", inputs: ["disableRipple", "color", "compareWith", "disabled", "multiple"], outputs: ["selectionChange"], exportAs: ["matSelectionList"] }, { kind: "component", type: i8$1.MatListOption, selector: "mat-list-option", inputs: ["disableRipple", "checkboxPosition", "color", "value", "disabled", "selected"], outputs: ["selectedChange"], exportAs: ["matListOption"] }, { kind: "component", type: SearchComponent, selector: "adf-search", inputs: ["displayWith", "maxResults", "skipResults", "searchTerm", "class"], outputs: ["resultLoaded", "error"], exportAs: ["searchAutocomplete"] }, { kind: "component", type: UserIconColumnComponent, selector: "adf-user-icon-column", inputs: ["context", "node", "selected"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddPermissionPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-add-permission-panel', encapsulation: ViewEncapsulation.None, providers: [
                        { provide: SearchConfigurationService, useClass: SearchPermissionConfigurationService },
                        SearchService
                    ], template: "<mat-form-field floatPlaceholder=\"never\"\n                class=\"adf-permission-search-input\">\n    <input matInput\n           id=\"searchInput\"\n           [formControl]=\"searchInput\"\n           type=\"text\"\n           title=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.SEARCH' | translate}}\"\n           placeholder=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.SEARCH' | translate}}\"\n           [value]=\"searchedWord\">\n\n    <mat-icon *ngIf=\"searchedWord?.length > 0\"\n              class=\"adf-permission-search-icon\"\n              data-automation-id=\"adf-permission-clear-input\"\n              id=\"adf-permission-clear-input\"\n              matSuffix\n              (click)=\"clearSearch()\">clear\n    </mat-icon>\n\n    <mat-icon *ngIf=\"searchedWord?.length === 0\"\n              class=\"adf-permission-search-icon\"\n              data-automation-id=\"adf-permission-search-icon\"\n              matSuffix>search\n    </mat-icon>\n</mat-form-field>\n\n<div *ngIf=\"searchedWord?.length === 0\"\n     class=\"adf-permission-start-message\"\n     id=\"adf-add-permission-type-search\">\n    <span>{{'PERMISSION_MANAGER.ADD-PERMISSION.TYPE-MESSAGE' | translate}}</span>\n</div>\n\n<adf-search #search\n            [searchTerm]=\"searchedWord\"\n            id=\"adf-add-permission-authority-results\"\n            class=\"adf-permission-result-list\"\n            [class.adf-permission-result-list-search]=\"searchedWord.length === 0\">\n    <ng-template let-data>\n        <mat-selection-list class=\"adf-permission-result-list-elements\"\n                            title=\"{{'PERMISSION_MANAGER.ADD-PERMISSION.USER-GROUP-LIST' | translate}}\"\n                            (selectionChange)=\"onSelectionChange()\">\n            <mat-list-option id=\"adf-add-permission-group-everyone\"\n                             class=\"adf-list-option-item\"\n                             #eveyone\n                             disableRipple\n                             [value]=\"EVERYONE\">\n                <adf-user-icon-column [node]=\"EVERYONE\" id=\"add-group-icon\" [selected]=\"eveyone.selected\"></adf-user-icon-column>\n                <p class=\"adf-result-name\">\n                    {{'PERMISSION_MANAGER.ADD-PERMISSION.EVERYONE' | translate}}\n                </p>\n            </mat-list-option>\n\n            <mat-list-option *ngFor=\"let item of data?.list?.entries; let idx = index\"\n                             disableRipple\n                             [value]=\"item\"\n                             class=\"adf-list-option-item\"\n                             id=\"result_option_{{idx}}\"\n                             #option>\n                <adf-user-icon-column [node]=\"item\" [selected]=\"option.selected\"></adf-user-icon-column>\n                <p class=\"adf-result-name\">\n                    <ng-container *ngIf=\"item.entry?.properties['cm:authorityDisplayName']; else authorityName\">\n                        {{item.entry.properties['cm:authorityDisplayName']}}\n                    </ng-container>\n                    <ng-template #authorityName>\n                        <ng-container *ngIf=\"item.entry?.properties['cm:authorityName']; else owner\">\n                            {{item.entry.properties['cm:authorityName']}}\n                        </ng-container>\n                    </ng-template>\n                    <ng-template #owner>\n                        {{item.entry?.properties['cm:firstName'] ? item.entry?.properties['cm:firstName'] : '' }}\n                        {{item.entry?.properties['cm:lastName'] ? item.entry?.properties['cm:lastName']: ''}}\n                    </ng-template>\n                </p>\n            </mat-list-option>\n        </mat-selection-list>\n    </ng-template>\n</adf-search>\n", styles: [".adf-permission-result-list{display:flex;height:calc(100% - 75px);overflow:auto;border:2px solid var(--adf-theme-foreground-text-color-007)}.adf-permission-result-list-elements{width:100%}.adf-permission-result-list-search{display:none}.adf-permission-start-message{display:flex;align-items:center;justify-content:space-around;height:calc(100% - 75px);overflow:auto;border:2px solid var(--adf-theme-foreground-text-color-007)}.adf-permission-no-result{display:flex;align-items:center;justify-content:space-around;width:100%}.adf-permission-search-input{width:100%}.adf-permission-search-input-icon{color:var(--adf-theme-background-selected-button-color);cursor:pointer}.adf-permission-search-input-icon:hover{color:var(--adf-theme-foreground-base-color)}.adf-list-option-item mat-pseudo-checkbox{display:none}.adf-list-option-item .mat-list-text{display:flex;flex-direction:row!important;align-items:center}.adf-list-option-item .mat-list-text .adf-result-name{padding-left:16px!important}.adf-permission-action[disabled]{opacity:.6}.adf-permission-action:enabled{color:var(--theme-primary-color)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { search: [{
                type: ViewChild,
                args: ['search', { static: true }]
            }], matSelectionList: [{
                type: ViewChild,
                args: [MatSelectionList, { static: false }]
            }], select: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserNameColumnComponent {
    constructor(nodePermissionService) {
        this.nodePermissionService = nodePermissionService;
        this.displayText$ = new BehaviorSubject('');
        this.subTitleText$ = new BehaviorSubject('');
    }
    ngOnInit() {
        if (this.context != null) {
            const { person, group, authorityId } = this.context.row.obj?.entry ?? this.context.row.obj;
            const permissionGroup = authorityId ? { displayName: authorityId } : null;
            this.updatePerson(person);
            this.updateGroup(group || permissionGroup);
        }
        if (this.node) {
            const { person, group } = this.nodePermissionService.transformNodeToUserPerson(this.node.entry);
            this.updatePerson(person);
            this.updateGroup(group);
        }
    }
    updatePerson(person) {
        if (person) {
            this.displayText$.next(`${person.firstName ?? ''} ${person.lastName ?? ''}`);
            this.subTitleText$.next(person.email ?? '');
        }
    }
    updateGroup(group) {
        if (group) {
            this.displayText$.next(group.displayName);
        }
    }
}
UserNameColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserNameColumnComponent, deps: [{ token: NodePermissionService }], target: i0.ɵɵFactoryTarget.Component });
UserNameColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UserNameColumnComponent, selector: "adf-user-name-column", inputs: { context: "context", node: "node" }, host: { classAttribute: "adf-user-name-column adf-datatable-content-cell adf-expand-cell-5 adf-ellipsis-cell" }, ngImport: i0, template: `
        <div class="adf-ellipsis-cell" [attr.data-automation-id]="displayText$ | async">
            <span class="adf-user-name-column" title="{{ displayText$ | async }}"> {{ displayText$ | async }}</span>
            <br/>
            <span class="adf-user-email-column" title="{{ subTitleText$ | async }}" *ngIf="subTitleText$ | async">
                {{ subTitleText$ | async }}
            </span>
        </div>
    `, isInline: true, styles: [".adf-user-name-column{font-weight:600;font-size:var(--theme-body-1-font-size)}.adf-user-email-column{font-size:var(--theme-body-1-font-size);letter-spacing:-.2px;line-height:1.43;color:var(--adf-theme-foreground-text-color)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserNameColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-user-name-column', template: `
        <div class="adf-ellipsis-cell" [attr.data-automation-id]="displayText$ | async">
            <span class="adf-user-name-column" title="{{ displayText$ | async }}"> {{ displayText$ | async }}</span>
            <br/>
            <span class="adf-user-email-column" title="{{ subTitleText$ | async }}" *ngIf="subTitleText$ | async">
                {{ subTitleText$ | async }}
            </span>
        </div>
    `, encapsulation: ViewEncapsulation.None, host: { class: 'adf-user-name-column adf-datatable-content-cell adf-expand-cell-5 adf-ellipsis-cell' }, styles: [".adf-user-name-column{font-weight:600;font-size:var(--theme-body-1-font-size)}.adf-user-email-column{font-size:var(--theme-body-1-font-size);letter-spacing:-.2px;line-height:1.43;color:var(--adf-theme-foreground-text-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: NodePermissionService }]; }, propDecorators: { context: [{
                type: Input
            }], node: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserRoleColumnComponent {
    constructor() {
        this.readonly = false;
        this.placeholder = 'PERMISSION_MANAGER.LABELS.SELECT-ROLE';
        this.roleChanged = new EventEmitter();
    }
    onRoleChanged(newRole) {
        this.value = newRole;
        this.roleChanged.emit(newRole);
    }
}
UserRoleColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserRoleColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
UserRoleColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: UserRoleColumnComponent, selector: "adf-user-role-column", inputs: { roles: "roles", value: "value", readonly: "readonly", placeholder: "placeholder" }, outputs: { roleChanged: "roleChanged" }, host: { classAttribute: "adf-user-role-column adf-datatable-content-cell adf-expand-cell-4" }, ngImport: i0, template: `
        <mat-form-field floatLabel="never" class="adf-role-selector-field" *ngIf="!readonly">
            <mat-select
                (click)="$event.stopPropagation()"
                [placeholder]="placeholder | translate"
                [value]="value"
                (selectionChange)="onRoleChanged($event.value)"
                (keyup.arrowdown)="$event.stopPropagation()"
                (keyup.arrowup)="$event.stopPropagation()">
                <mat-option *ngFor="let role of roles" [value]="role.role">
                    {{ role.label | adfLocalizedRole }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <span class="adf-datatable-cell-value adf-readonly-role" [title]="value | adfLocalizedRole" *ngIf="readonly">
          {{value | adfLocalizedRole}}
      </span>
    `, isInline: true, styles: [".adf-role-selector-field{width:100%}.adf-role-selector-field .mat-form-field{width:100%;max-width:200px}.adf-readonly-role{padding-left:0!important}\n"], dependencies: [{ kind: "directive", type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$2.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "component", type: i4$1.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "pipe", type: i1.LocalizedRolePipe, name: "adfLocalizedRole" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: UserRoleColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-user-role-column', template: `
        <mat-form-field floatLabel="never" class="adf-role-selector-field" *ngIf="!readonly">
            <mat-select
                (click)="$event.stopPropagation()"
                [placeholder]="placeholder | translate"
                [value]="value"
                (selectionChange)="onRoleChanged($event.value)"
                (keyup.arrowdown)="$event.stopPropagation()"
                (keyup.arrowup)="$event.stopPropagation()">
                <mat-option *ngFor="let role of roles" [value]="role.role">
                    {{ role.label | adfLocalizedRole }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <span class="adf-datatable-cell-value adf-readonly-role" [title]="value | adfLocalizedRole" *ngIf="readonly">
          {{value | adfLocalizedRole}}
      </span>
    `, host: { class: 'adf-user-role-column adf-datatable-content-cell adf-expand-cell-4' }, styles: [".adf-role-selector-field{width:100%}.adf-role-selector-field .mat-form-field{width:100%;max-width:200px}.adf-readonly-role{padding-left:0!important}\n"] }]
        }], propDecorators: { roles: [{
                type: Input
            }], value: [{
                type: Input
            }], readonly: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], roleChanged: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AddPermissionDialogComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.isSearchActive = true;
        this.selectedMembers = [];
        this.existingMembers = [];
        this.currentSelection = [];
        this.existingMembers = this.data.node.permissions.locallySet || [];
    }
    onSelect(items) {
        this.currentSelection = items;
    }
    onAddClicked() {
        const selection = this.selectedMembers.filter(member => !member.readonly).map(member => member.toPermissionElement());
        this.data.confirm.next(selection);
        this.data.confirm.complete();
    }
    onSearchAddClicked() {
        const newMembers = this.currentSelection.map(item => MemberModel.parseFromSearchResult(item))
            .filter(({ id }) => !this.selectedMembers.find((member) => member.id === id));
        this.selectedMembers = this.selectedMembers.concat(newMembers);
        this.selectedMembers.forEach((member) => {
            const existingMember = this.existingMembers.find(({ authorityId }) => authorityId === member.id);
            if (!!existingMember) {
                member.role = existingMember.name;
                member.accessStatus = existingMember.accessStatus;
                member.readonly = true; // make role non editable
            }
        });
        this.disableSearch();
    }
    canCloseDialog() {
        if (!!this.selectedMembers.length) {
            this.disableSearch();
        }
        else {
            this.dialogRef.close();
        }
    }
    enableSearch() {
        this.isSearchActive = true;
    }
    disableSearch() {
        this.isSearchActive = false;
    }
    onBulkUpdate(role) {
        this.selectedMembers.filter(member => !member.readonly)
            .forEach(member => (member.role = role));
    }
    onMemberDelete({ id }) {
        const index = this.selectedMembers.findIndex((member) => member.id === id);
        this.selectedMembers.splice(index, 1);
        if (this.selectedMembers.length === 0) {
            this.enableSearch();
            this.currentSelection = [];
        }
    }
    onMemberUpdate(role, member) {
        const memberInstance = this.selectedMembers.find(({ id }) => id === member.id);
        memberInstance.role = role;
    }
    isValid() {
        return this.selectedMembers.filter(({ readonly }) => !readonly).length && this.selectedMembers.every(({ role }) => !!role);
    }
}
AddPermissionDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddPermissionDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
AddPermissionDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AddPermissionDialogComponent, selector: "adf-add-permission-dialog", ngImport: i0, template: "<h2 mat-dialog-title id=\"add-permission-dialog-title\">\n    {{ (data?.title ? data?.title : \"PERMISSION_MANAGER.ADD-PERMISSION.BASE-DIALOG-TITLE\") | translate }}\n</h2>\n\n<ng-container *ngIf=\"!isSearchActive\">\n    <mat-dialog-content>\n        <button mat-button (click)=\"enableSearch()\" class=\"adf-search-user-button\">\n            {{ \"PERMISSION_MANAGER.ADD-PERMISSION.SEARCH\" | translate }}\n            <span class=\"adf-toolbar--spacer\"></span>\n            <mat-icon>search</mat-icon>\n        </button>\n\n        <div class=\"adf-new-permission-table\">\n            <adf-datatable [rows]=\"selectedMembers\"\n                           class=\"adf-datatable-permission\"\n                           selectionMode=\"none\"\n                           [stickyHeader]=\"true\"\n                           data-automation-id=\"adf-user-role-selection-table\"\n                           *ngIf=\"selectedMembers.length\">\n                <data-columns>\n                    <data-column class=\"adf-datatable-cell--image adf-authority-icon-column\" key=\"$thumbunail\" [sortable]=\"false\">\n                        <ng-template let-context>\n                            <adf-user-icon-column [context]=\"context\"></adf-user-icon-column>\n                        </ng-template>\n                    </data-column>\n\n                    <data-column class=\"adf-ellipsis-cell adf-expand-cell-5 adf-authorityId-column\"\n                                 [title]=\"'PERMISSION_MANAGER.COLUMN.NAME' | translate:{count:selectedMembers.length}\"\n                                 key=\"id\">\n                        <ng-template let-context>\n                            <adf-user-name-column [context]=\"context\"></adf-user-name-column>\n                        </ng-template>\n                    </data-column>\n\n                    <data-column class=\"adf-ellipsis-cell adf-expand-cell-4\"\n                                 title=\"PERMISSION_MANAGER.PERMISSION_DISPLAY.ROLE\"\n                                 key=\"role\">\n                        <ng-template let-entry=\"$implicit\">\n                            <adf-user-role-column [readonly]=\"entry.row.obj.readonly\"\n                                                  [value]=\"entry.data.getValue(entry.row, entry.col)\"\n                                                  [roles]=\"data.roles\"\n                                                  id=\"adf-select-role-permission\"\n                                                  (roleChanged)=\"onMemberUpdate($event, entry.row.obj)\">\n                            </adf-user-role-column>\n                        </ng-template>\n\n                        <adf-data-column-header>\n                            <ng-template>\n                                <adf-user-role-column  class=\"adf-permission-role-column-header\"\n                                                       placeholder=\"PERMISSION_MANAGER.COLUMN.BULK-ROLE\"\n                                                       [roles]=\"data.roles\"\n                                                       id=\"adf-bulk-select-role-permission\"\n                                                       (roleChanged)=\"onBulkUpdate($event)\">\n                                </adf-user-role-column>\n                            </ng-template>\n                        </adf-data-column-header>\n                    </data-column>\n\n                    <data-column class=\"adf-datatable-cell adf-delete-permission-column\" key=\"\" [sortable]=\"false\">\n                        <ng-template let-entry=\"$implicit\">\n                            <button mat-icon-button\n                                    class=\"adf-add-member-action\"\n                                    [style.display]=\"entry.row.obj.readonly ? 'none': 'block'\"\n                                    (click)=\"onMemberDelete(entry.row.obj)\"\n                                    data-automation-id=\"adf-delete-permission-button\">\n                                <mat-icon>highlight_off</mat-icon>\n                            </button>\n                        </ng-template>\n                    </data-column>\n                </data-columns>\n            </adf-datatable>\n        </div>\n\n    </mat-dialog-content>\n\n    <mat-dialog-actions>\n        <button mat-button\n                mat-dialog-close\n                data-automation-id=\"add-permission-dialog-close-button\">\n            {{ \"PERMISSION_MANAGER.ADD-PERMISSION.CLOSE-ACTION\" | translate }}\n        </button>\n        <button mat-button\n                data-automation-id=\"add-permission-dialog-confirm-button\"\n                [mat-dialog-close]=\"true\"\n                class=\"adf-choose-action\"\n                [disabled]=\"!isValid()\"\n                (click)=\"onAddClicked()\">\n            {{ \"PERMISSION_MANAGER.ADD-PERMISSION.ADD-ACTION\" | translate }}\n        </button>\n    </mat-dialog-actions>\n</ng-container>\n\n<ng-container *ngIf=\"isSearchActive\">\n    <mat-dialog-content>\n        <adf-add-permission-panel class=\"adf-search-container\" (select)=\"onSelect($event)\"></adf-add-permission-panel>\n    </mat-dialog-content>\n\n    <mat-dialog-actions>\n            <button mat-button\n                    (click)=\"canCloseDialog()\"\n                    data-automation-id=\"add-permission-dialog-close-button\">\n                {{ \"PERMISSION_MANAGER.ADD-PERMISSION.CLOSE-ACTION\" | translate }}\n            </button>\n            <button mat-button\n                    data-automation-id=\"add-permission-dialog-confirm-button\"\n                    [disabled]=\"!currentSelection.length\"\n                    (click)=\"onSearchAddClicked()\">\n                {{ \"PERMISSION_MANAGER.ADD-PERMISSION.SELECT-ACTION\" | translate }}\n            </button>\n    </mat-dialog-actions>\n</ng-container>\n", styles: [".adf-add-permission-dialog .mat-dialog-title{margin-left:24px;margin-right:24px;font-size:var(--theme-title-font-size);font-weight:600;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:-.5px;color:var(--adf-theme-foreground-text-color-087)}.adf-add-permission-dialog .mat-dialog-container{padding-left:0;padding-right:0}.adf-add-permission-dialog .mat-dialog-content{margin:0;overflow:hidden;flex-grow:1;height:80vh}.adf-add-permission-dialog .mat-dialog-content .adf-new-permission-table{height:90%}.adf-add-permission-dialog .mat-dialog-content .adf-search-container{height:100%}.adf-add-permission-dialog .mat-dialog-actions{padding:0 24px;background-color:var(--theme-background-color);display:flex;justify-content:flex-end;color:var(--adf-theme-foreground-text-color)}.adf-add-permission-dialog .mat-dialog-actions button{text-transform:uppercase;font-weight:400}.adf-add-permission-dialog .mat-dialog-actions .adf-choose-action[disabled]{color:var(--adf-theme-foreground-secondary-text-color)}.adf-add-permission-dialog .mat-dialog-actions .adf-choose-action:enabled{color:var(--theme-primary-color)}.adf-add-permission-dialog .adf-search-user-button{width:100%}.adf-add-permission-dialog .adf-search-user-button .mat-button-wrapper{display:flex;align-items:center}.adf-add-permission-dialog .adf-add-member-action{padding:0 15px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i1.DataTableComponent, selector: "adf-datatable", inputs: ["data", "display", "rows", "sorting", "columns", "selectionMode", "multiselect", "mainTableAction", "actions", "showMainDatatableActions", "actionsPosition", "actionsVisibleOnHover", "fallbackThumbnail", "contextMenu", "rowStyle", "rowStyleClass", "showHeader", "stickyHeader", "loading", "noPermission", "rowMenuCacheEnabled", "resolverFn", "allowFiltering", "isResizingEnabled"], outputs: ["rowClick", "rowDblClick", "showRowContextMenu", "showRowActionsMenu", "executeRowAction", "columnOrderChanged", "columnsWidthChanged"] }, { kind: "component", type: i1.DataColumnComponent, selector: "data-column", inputs: ["id", "key", "customData", "type", "format", "sortable", "draggable", "isHidden", "title", "formatTooltip", "sr-title", "class", "copyContent", "editable", "focus", "sortingKey"] }, { kind: "component", type: i1.DataColumnListComponent, selector: "data-columns" }, { kind: "component", type: i1.DateColumnHeaderComponent, selector: "adf-data-column-header" }, { kind: "component", type: AddPermissionPanelComponent, selector: "adf-add-permission-panel", outputs: ["select"] }, { kind: "component", type: UserNameColumnComponent, selector: "adf-user-name-column", inputs: ["context", "node"] }, { kind: "component", type: UserIconColumnComponent, selector: "adf-user-icon-column", inputs: ["context", "node", "selected"] }, { kind: "component", type: UserRoleColumnComponent, selector: "adf-user-role-column", inputs: ["roles", "value", "readonly", "placeholder"], outputs: ["roleChanged"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddPermissionDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-add-permission-dialog', encapsulation: ViewEncapsulation.None, template: "<h2 mat-dialog-title id=\"add-permission-dialog-title\">\n    {{ (data?.title ? data?.title : \"PERMISSION_MANAGER.ADD-PERMISSION.BASE-DIALOG-TITLE\") | translate }}\n</h2>\n\n<ng-container *ngIf=\"!isSearchActive\">\n    <mat-dialog-content>\n        <button mat-button (click)=\"enableSearch()\" class=\"adf-search-user-button\">\n            {{ \"PERMISSION_MANAGER.ADD-PERMISSION.SEARCH\" | translate }}\n            <span class=\"adf-toolbar--spacer\"></span>\n            <mat-icon>search</mat-icon>\n        </button>\n\n        <div class=\"adf-new-permission-table\">\n            <adf-datatable [rows]=\"selectedMembers\"\n                           class=\"adf-datatable-permission\"\n                           selectionMode=\"none\"\n                           [stickyHeader]=\"true\"\n                           data-automation-id=\"adf-user-role-selection-table\"\n                           *ngIf=\"selectedMembers.length\">\n                <data-columns>\n                    <data-column class=\"adf-datatable-cell--image adf-authority-icon-column\" key=\"$thumbunail\" [sortable]=\"false\">\n                        <ng-template let-context>\n                            <adf-user-icon-column [context]=\"context\"></adf-user-icon-column>\n                        </ng-template>\n                    </data-column>\n\n                    <data-column class=\"adf-ellipsis-cell adf-expand-cell-5 adf-authorityId-column\"\n                                 [title]=\"'PERMISSION_MANAGER.COLUMN.NAME' | translate:{count:selectedMembers.length}\"\n                                 key=\"id\">\n                        <ng-template let-context>\n                            <adf-user-name-column [context]=\"context\"></adf-user-name-column>\n                        </ng-template>\n                    </data-column>\n\n                    <data-column class=\"adf-ellipsis-cell adf-expand-cell-4\"\n                                 title=\"PERMISSION_MANAGER.PERMISSION_DISPLAY.ROLE\"\n                                 key=\"role\">\n                        <ng-template let-entry=\"$implicit\">\n                            <adf-user-role-column [readonly]=\"entry.row.obj.readonly\"\n                                                  [value]=\"entry.data.getValue(entry.row, entry.col)\"\n                                                  [roles]=\"data.roles\"\n                                                  id=\"adf-select-role-permission\"\n                                                  (roleChanged)=\"onMemberUpdate($event, entry.row.obj)\">\n                            </adf-user-role-column>\n                        </ng-template>\n\n                        <adf-data-column-header>\n                            <ng-template>\n                                <adf-user-role-column  class=\"adf-permission-role-column-header\"\n                                                       placeholder=\"PERMISSION_MANAGER.COLUMN.BULK-ROLE\"\n                                                       [roles]=\"data.roles\"\n                                                       id=\"adf-bulk-select-role-permission\"\n                                                       (roleChanged)=\"onBulkUpdate($event)\">\n                                </adf-user-role-column>\n                            </ng-template>\n                        </adf-data-column-header>\n                    </data-column>\n\n                    <data-column class=\"adf-datatable-cell adf-delete-permission-column\" key=\"\" [sortable]=\"false\">\n                        <ng-template let-entry=\"$implicit\">\n                            <button mat-icon-button\n                                    class=\"adf-add-member-action\"\n                                    [style.display]=\"entry.row.obj.readonly ? 'none': 'block'\"\n                                    (click)=\"onMemberDelete(entry.row.obj)\"\n                                    data-automation-id=\"adf-delete-permission-button\">\n                                <mat-icon>highlight_off</mat-icon>\n                            </button>\n                        </ng-template>\n                    </data-column>\n                </data-columns>\n            </adf-datatable>\n        </div>\n\n    </mat-dialog-content>\n\n    <mat-dialog-actions>\n        <button mat-button\n                mat-dialog-close\n                data-automation-id=\"add-permission-dialog-close-button\">\n            {{ \"PERMISSION_MANAGER.ADD-PERMISSION.CLOSE-ACTION\" | translate }}\n        </button>\n        <button mat-button\n                data-automation-id=\"add-permission-dialog-confirm-button\"\n                [mat-dialog-close]=\"true\"\n                class=\"adf-choose-action\"\n                [disabled]=\"!isValid()\"\n                (click)=\"onAddClicked()\">\n            {{ \"PERMISSION_MANAGER.ADD-PERMISSION.ADD-ACTION\" | translate }}\n        </button>\n    </mat-dialog-actions>\n</ng-container>\n\n<ng-container *ngIf=\"isSearchActive\">\n    <mat-dialog-content>\n        <adf-add-permission-panel class=\"adf-search-container\" (select)=\"onSelect($event)\"></adf-add-permission-panel>\n    </mat-dialog-content>\n\n    <mat-dialog-actions>\n            <button mat-button\n                    (click)=\"canCloseDialog()\"\n                    data-automation-id=\"add-permission-dialog-close-button\">\n                {{ \"PERMISSION_MANAGER.ADD-PERMISSION.CLOSE-ACTION\" | translate }}\n            </button>\n            <button mat-button\n                    data-automation-id=\"add-permission-dialog-confirm-button\"\n                    [disabled]=\"!currentSelection.length\"\n                    (click)=\"onSearchAddClicked()\">\n                {{ \"PERMISSION_MANAGER.ADD-PERMISSION.SELECT-ACTION\" | translate }}\n            </button>\n    </mat-dialog-actions>\n</ng-container>\n", styles: [".adf-add-permission-dialog .mat-dialog-title{margin-left:24px;margin-right:24px;font-size:var(--theme-title-font-size);font-weight:600;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:-.5px;color:var(--adf-theme-foreground-text-color-087)}.adf-add-permission-dialog .mat-dialog-container{padding-left:0;padding-right:0}.adf-add-permission-dialog .mat-dialog-content{margin:0;overflow:hidden;flex-grow:1;height:80vh}.adf-add-permission-dialog .mat-dialog-content .adf-new-permission-table{height:90%}.adf-add-permission-dialog .mat-dialog-content .adf-search-container{height:100%}.adf-add-permission-dialog .mat-dialog-actions{padding:0 24px;background-color:var(--theme-background-color);display:flex;justify-content:flex-end;color:var(--adf-theme-foreground-text-color)}.adf-add-permission-dialog .mat-dialog-actions button{text-transform:uppercase;font-weight:400}.adf-add-permission-dialog .mat-dialog-actions .adf-choose-action[disabled]{color:var(--adf-theme-foreground-secondary-text-color)}.adf-add-permission-dialog .mat-dialog-actions .adf-choose-action:enabled{color:var(--theme-primary-color)}.adf-add-permission-dialog .adf-search-user-button{width:100%}.adf-add-permission-dialog .adf-search-user-button .mat-button-wrapper{display:flex;align-items:center}.adf-add-permission-dialog .adf-add-member-action{padding:0 15px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }]; } });

class NodePermissionDialogService {
    constructor(dialog, nodePermissionService, contentService) {
        this.dialog = dialog;
        this.nodePermissionService = nodePermissionService;
        this.contentService = contentService;
    }
    /**
     * Opens a dialog to add permissions to a node.
     *
     * @param node target node
     * @param roles settable roles for the node
     * @param title Dialog title
     * @returns Node with updated permissions
     */
    openAddPermissionDialog(node, roles, title) {
        if (this.contentService.hasAllowableOperations(node, AllowableOperationsEnum.UPDATEPERMISSIONS)) {
            const confirm = new Subject();
            confirm.subscribe({
                complete: this.close.bind(this)
            });
            const data = {
                node,
                title,
                confirm,
                roles
            };
            this.openDialog(data, 'adf-add-permission-dialog', '800px');
            return confirm;
        }
        else {
            const errors = new Error(JSON.stringify({ error: { statusCode: 403 } }));
            errors.message = 'PERMISSION_MANAGER.ERROR.NOT-ALLOWED';
            return throwError(errors);
        }
    }
    openDialog(data, currentPanelClass, chosenWidth) {
        this.dialog.open(AddPermissionDialogComponent, { data, panelClass: currentPanelClass, width: chosenWidth, restoreFocus: true });
    }
    /**
     * Closes the currently-open dialog.
     */
    close() {
        this.dialog.closeAll();
    }
    /**
     * Opens a dialog to update permissions for a node.
     *
     * @param nodeId ID of the target node
     * @param title Dialog title
     * @returns Node with updated permissions
     */
    updateNodePermissionByDialog(nodeId, title) {
        return this.nodePermissionService.getNodeWithRoles(nodeId)
            .pipe(switchMap(({ node, roles }) => this.openAddPermissionDialog(node, roles, title)
            .pipe(switchMap((selection) => this.nodePermissionService.updateNodePermissions(nodeId, selection)))));
    }
}
NodePermissionDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePermissionDialogService, deps: [{ token: i1$1.MatDialog }, { token: NodePermissionService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Injectable });
NodePermissionDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePermissionDialogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePermissionDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: NodePermissionService }, { type: ContentService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SITE_MANAGER_ROLE = 'SiteManager';
class PermissionListService {
    constructor(nodeService, nodePermissionService, nodePermissionDialogService, contentService, notificationService) {
        this.nodeService = nodeService;
        this.nodePermissionService = nodePermissionService;
        this.nodePermissionDialogService = nodePermissionDialogService;
        this.contentService = contentService;
        this.notificationService = notificationService;
        this.updated = new EventEmitter();
        this.errored = new EventEmitter();
        this.loading$ = new BehaviorSubject(true);
        this.error$ = new Subject();
        this.nodeWithRoles$ = new Subject();
        this.data$ = this.nodeWithRoles$.pipe(map(({ node, roles }) => {
            const nodeLocalPermissions = this.nodePermissionService.getLocalPermissions(node);
            const localPermissions = this.updateReadOnlyPermission(node, nodeLocalPermissions);
            return {
                node,
                roles,
                localPermissions,
                inheritedPermissions: this.nodePermissionService.getInheritedPermission(node)
            };
        }));
    }
    fetchPermission(nodeId) {
        this.loading$.next(true);
        this.nodePermissionService.getNodeWithRoles(nodeId)
            .pipe(finalize(() => this.loading$.next(false)))
            .subscribe(({ node, roles }) => {
            this.node = node;
            this.roles = roles;
            this.nodeWithRoles$.next({ node, roles });
        }, () => this.error$.next(true));
    }
    toggleInherited(change) {
        if (this.contentService.hasAllowableOperations(this.node, AllowableOperationsEnum.UPDATEPERMISSIONS)) {
            let updateLocalPermission$ = of(null);
            const nodeBody = {
                permissions: {
                    isInheritanceEnabled: !this.node.permissions.isInheritanceEnabled
                }
            };
            const authorityId = this.getManagerAuthority(this.node);
            if (authorityId) {
                const permissions = [
                    ...(this.node.permissions.locallySet || []),
                    { authorityId, name: SITE_MANAGER_ROLE, accessStatus: 'ALLOWED' }
                ];
                updateLocalPermission$ = this.nodePermissionService.updatePermissions(this.node, permissions);
            }
            updateLocalPermission$.pipe(switchMap(() => this.nodeService.updateNode(this.node.id, nodeBody, { include: ['permissions'] })))
                .subscribe((nodeUpdated) => {
                const message = nodeUpdated.permissions.isInheritanceEnabled ? 'PERMISSION_MANAGER.MESSAGE.INHERIT-ENABLE-SUCCESS' : 'PERMISSION_MANAGER.MESSAGE.INHERIT-DISABLE-SUCCESS';
                this.notificationService.showInfo(message);
                nodeUpdated.permissions.inherited = nodeUpdated.permissions?.inherited ?? [];
                this.reloadNode(nodeUpdated);
            }, () => {
                change.source.checked = this.node.permissions.isInheritanceEnabled;
                this.notificationService.showWarning('PERMISSION_MANAGER.MESSAGE.TOGGLE-PERMISSION-FAILED');
            });
        }
        else {
            change.source.checked = this.node.permissions.isInheritanceEnabled;
            this.notificationService.showError('PERMISSION_MANAGER.ERROR.NOT-ALLOWED');
        }
    }
    updateNodePermissionByDialog() {
        this.nodePermissionDialogService
            .openAddPermissionDialog(this.node, this.roles, 'PERMISSION_MANAGER.ADD-PERMISSION.TITLE')
            .pipe(switchMap(selection => {
            const total = selection.length;
            const group = selection.filter(({ authorityId }) => this.isGroup(authorityId)).length;
            return forkJoin({
                user: of(total - group),
                group: of(group),
                node: this.nodePermissionService.updateNodePermissions(this.node.id, selection)
            });
        }))
            .subscribe(({ user, group, node }) => {
            this.notificationService.showInfo('PERMISSION_MANAGER.MESSAGE.PERMISSION-ADD-SUCCESS', null, { user, group });
            this.reloadNode(node);
        }, () => {
            this.notificationService.showError('PERMISSION_MANAGER.MESSAGE.PERMISSION-ADD-FAIL');
            this.reloadNode();
        });
    }
    deletePermissions(permissions) {
        this.nodePermissionService.removePermissions(this.node, permissions)
            .subscribe((node) => {
            const total = permissions.length;
            const group = permissions.filter(({ authorityId }) => this.isGroup(authorityId)).length;
            this.notificationService.showInfo('PERMISSION_MANAGER.MESSAGE.PERMISSION-BULK-DELETE-SUCCESS', null, { user: total - group, group });
            this.reloadNode(node);
        }, () => {
            this.notificationService.showError('PERMISSION_MANAGER.MESSAGE.PERMISSION-DELETE-FAIL');
            this.reloadNode();
        });
    }
    updateRole(role, permission) {
        const updatedPermissionRole = this.buildUpdatedPermission(role, permission);
        this.nodePermissionService.updatePermissionRole(this.node, updatedPermissionRole)
            .subscribe((node) => {
            this.notificationService.showInfo('PERMISSION_MANAGER.MESSAGE.PERMISSION-UPDATE-SUCCESS');
            this.reloadNode(node);
            this.updated.emit(permission);
        }, () => {
            this.notificationService.showError('PERMISSION_MANAGER.MESSAGE.PERMISSION-UPDATE-FAIL');
            this.reloadNode();
            this.errored.emit(permission);
        });
    }
    bulkRoleUpdate(role) {
        const permissions = [...this.node.permissions.locallySet].map((permission) => this.buildUpdatedPermission(role, permission));
        this.nodePermissionService.updatePermissions(this.node, permissions)
            .subscribe((node) => {
            const total = permissions.length;
            const group = permissions.filter(({ authorityId }) => this.isGroup(authorityId)).length;
            this.notificationService.showInfo('PERMISSION_MANAGER.MESSAGE.PERMISSION-BULK-UPDATE-SUCCESS', null, { user: total - group, group });
            this.reloadNode(node);
        }, () => {
            this.notificationService.showError('PERMISSION_MANAGER.MESSAGE.PERMISSION-UPDATE-FAIL');
            this.reloadNode();
        });
    }
    deletePermission(permission) {
        const cloneNode = { ...this.node, permissions: { ...this.node.permissions, locallySet: [...this.node.permissions.locallySet] } };
        this.nodePermissionService
            .removePermission(cloneNode, permission)
            .subscribe((node) => {
            this.notificationService.showInfo('PERMISSION_MANAGER.MESSAGE.PERMISSION-DELETE-SUCCESS');
            if (!node.permissions.locallySet) {
                node.permissions.locallySet = [];
            }
            this.reloadNode(node);
        }, () => {
            this.notificationService.showError('PERMISSION_MANAGER.MESSAGE.PERMISSION-DELETE-FAIL');
            this.reloadNode();
        });
    }
    buildUpdatedPermission(role, permission) {
        return {
            accessStatus: permission.accessStatus,
            name: this.canUpdateThePermission(this.node, permission) ? role : permission.name,
            authorityId: permission.authorityId
        };
    }
    reloadNode(node) {
        if (node != null) {
            Object.assign(this.node.permissions, node.permissions);
        }
        this.nodeWithRoles$.next({ node: this.node, roles: this.roles });
    }
    getManagerAuthority(node) {
        const sitePath = node.path.elements.find((path) => path.nodeType === 'st:site');
        let hasLocalManagerPermission = false;
        let authorityId;
        if (sitePath) {
            authorityId = `GROUP_site_${sitePath.name}_${SITE_MANAGER_ROLE}`;
            hasLocalManagerPermission = !!node.permissions.locallySet?.find((permission) => permission.authorityId === authorityId && permission.name === SITE_MANAGER_ROLE);
        }
        if (!hasLocalManagerPermission && authorityId) {
            return authorityId;
        }
        return null;
    }
    updateReadOnlyPermission(node, permissions) {
        permissions.forEach((permission) => {
            if (!this.canUpdateThePermission(node, permission)) {
                permission.readonly = true;
            }
        });
        return permissions;
    }
    canUpdateThePermission(node, permission) {
        const sitePath = node.path.elements.find((path) => path.nodeType === 'st:site');
        if (!node.permissions.isInheritanceEnabled && sitePath) {
            const authorityId = `GROUP_site_${sitePath.name}_${SITE_MANAGER_ROLE}`;
            return !(permission.authorityId === authorityId && permission.name === SITE_MANAGER_ROLE);
        }
        return true;
    }
    isGroup(authorityId) {
        return authorityId.startsWith('GROUP_') || authorityId.startsWith('ROLE_');
    }
}
PermissionListService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionListService, deps: [{ token: NodesApiService }, { token: NodePermissionService }, { token: NodePermissionDialogService }, { token: ContentService }, { token: i1.NotificationService }], target: i0.ɵɵFactoryTarget.Injectable });
PermissionListService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionListService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionListService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }, { type: NodePermissionService }, { type: NodePermissionDialogService }, { type: ContentService }, { type: i1.NotificationService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PopOverDirective {
    constructor(element, overlay, vcr, focusTrapFactory) {
        this.element = element;
        this.overlay = overlay;
        this.vcr = vcr;
        this.focusTrapFactory = focusTrapFactory;
        this.panelClass = 'adf-permission-pop-over';
        this._open = false;
        this.destroy$ = new Subject();
    }
    get open() {
        return this._open;
    }
    ngOnInit() {
        this.createOverlay();
    }
    ngAfterViewInit() {
        this.element.nativeElement.addEventListener('click', () => this.toggleOverlay());
        this.element.nativeElement.addEventListener('keydown', this.preventDefaultForEnter);
    }
    ngOnDestroy() {
        this.element.nativeElement.removeEventListener('keydown', this.preventDefaultForEnter);
        this.detachOverlay();
        this.destroy$.next();
        this.destroy$.complete();
    }
    createOverlay() {
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.target)
            .withPositions([
            new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
            new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' })
        ])
            .withPush(false);
        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            panelClass: this.panelClass
        });
        this.overlayRef
            .backdropClick()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.detachOverlay();
        });
    }
    toggleOverlay() {
        if (!this.overlayRef.hasAttached()) {
            this.attachOverlay();
        }
        else {
            this.detachOverlay();
        }
    }
    attachOverlay() {
        if (!this.overlayRef.hasAttached()) {
            const periodSelectorPortal = new TemplatePortal(this.popOver, this.vcr);
            this.overlayRef.attach(periodSelectorPortal);
            this._open = true;
            if (this.autofocusedElementSelector) {
                this.overlayRef.overlayElement.querySelector(this.autofocusedElementSelector).focus();
            }
            if (this.popOver && !this.focusTrap) {
                this.focusTrap = this.focusTrapFactory.create(this.overlayRef.overlayElement);
            }
        }
    }
    detachOverlay() {
        if (this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
            this._open = false;
            this.focusTrap.destroy();
            this.focusTrap = null;
            this.element.nativeElement.focus();
        }
    }
    preventDefaultForEnter(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }
}
PopOverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PopOverDirective, deps: [{ token: i0.ElementRef }, { token: i5$5.Overlay }, { token: i0.ViewContainerRef }, { token: i1$4.ConfigurableFocusTrapFactory }], target: i0.ɵɵFactoryTarget.Directive });
PopOverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: PopOverDirective, selector: "[adf-pop-over]", inputs: { popOver: ["adf-pop-over", "popOver"], target: "target", panelClass: "panelClass", autofocusedElementSelector: "autofocusedElementSelector" }, host: { listeners: { "keyup.enter": "toggleOverlay()", "document:keyup.esc": "detachOverlay()" } }, exportAs: ["adfPopOver"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PopOverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-pop-over]',
                    exportAs: 'adfPopOver'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i5$5.Overlay }, { type: i0.ViewContainerRef }, { type: i1$4.ConfigurableFocusTrapFactory }]; }, propDecorators: { popOver: [{
                type: Input,
                args: ['adf-pop-over']
            }], target: [{
                type: Input
            }], panelClass: [{
                type: Input
            }], autofocusedElementSelector: [{
                type: Input
            }], toggleOverlay: [{
                type: HostListener,
                args: ['keyup.enter']
            }], detachOverlay: [{
                type: HostListener,
                args: ['document:keyup.esc']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodePathColumnComponent {
    constructor() {
        this.displayText$ = new BehaviorSubject('');
    }
    ngOnInit() {
        this.updateValue();
    }
    updateValue() {
        this.displayText$.next(this.node.path.name);
    }
}
NodePathColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePathColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NodePathColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NodePathColumnComponent, selector: "adf-node-path-column", inputs: { node: "node" }, host: { classAttribute: "adf-node-path-column adf-datatable-content-cell" }, ngImport: i0, template: `
        <span class="adf-user-name-column adf-datatable-cell-value"  title="{{ displayText$ | async }}">
            {{ displayText$ | async }}
        </span>
    `, isInline: true, dependencies: [{ kind: "pipe", type: i2$1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodePathColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'adf-node-path-column',
                    template: `
        <span class="adf-user-name-column adf-datatable-cell-value"  title="{{ displayText$ | async }}">
            {{ displayText$ | async }}
        </span>
    `,
                    host: { class: 'adf-node-path-column adf-datatable-content-cell' }
                }]
        }], propDecorators: { node: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PermissionContainerComponent {
    constructor() {
        this.permissions = [];
        this.isReadOnly = false;
        this.showLocation = false;
        this.selectionMode = 'multiple'; // none|single|multiple
        /** Emitted when the permission is updated. */
        this.update = new EventEmitter();
        this.updateAll = new EventEmitter();
        /** Emitted when the permission is updated. */
        this.delete = new EventEmitter();
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
    }
    ngOnChanges() {
        this.bulkSelectionRole = '';
    }
    updateRole(role, permission) {
        this.update.emit({ role, permission });
    }
    bulkRoleUpdate(role) {
        this.updateAll.emit(role);
    }
    removePermission(event, permissionRow) {
        event.stopPropagation();
        this.delete.emit(permissionRow);
    }
}
PermissionContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PermissionContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PermissionContainerComponent, selector: "adf-permission-container", inputs: { node: "node", permissions: "permissions", roles: "roles", isReadOnly: "isReadOnly", showLocation: "showLocation", selectionMode: "selectionMode" }, outputs: { update: "update", updateAll: "updateAll", delete: "delete", error: "error" }, usesOnChanges: true, ngImport: i0, template: "<adf-datatable class=\"adf-datatable-permission\"\n               id=\"adf-permission-display-container\"\n               [rows]=\"permissions\"\n               [stickyHeader]=\"true\"\n               [selectionMode]=\"selectionMode\">\n\n    <data-columns>\n        <data-column class=\"adf-datatable-cell--image adf-authority-icon-column\" key=\"$thumbunail\" [sortable]=\"false\">\n            <ng-template let-context>\n                <adf-user-icon-column [context]=\"context\"></adf-user-icon-column>\n            </ng-template>\n        </data-column>\n\n        <data-column class=\"adf-ellipsis-cell adf-expand-cell-5 adf-authorityId-column\"\n                     [title]=\"'PERMISSION_MANAGER.COLUMN.NAME' | translate:{count:permissions.length}\"\n                     key=\"authorityId\">\n            <ng-template let-context>\n                <adf-user-name-column [context]=\"context\"></adf-user-name-column>\n            </ng-template>\n        </data-column>d\n\n        <data-column class=\"adf-ellipsis-cell adf-expand-cell-5 adf-authorityId-column\"\n                     title=\"PERMISSION_MANAGER.COLUMN.LOCATION\"\n                     key=\"location\"\n                     *ngIf=\"node && showLocation\">\n            <ng-template>\n                <adf-node-path-column [node]=\"node\"></adf-node-path-column>\n            </ng-template>\n        </data-column>\n\n        <data-column\n            class=\"adf-ellipsis-cell adf-expand-cell-4\"\n            title=\"PERMISSION_MANAGER.PERMISSION_DISPLAY.ROLE\"\n            key=\"name\"\n            [sortable]=\"false\">\n            <ng-template let-entry=\"$implicit\">\n                <adf-user-role-column [readonly]=\"entry.row.obj.readonly || isReadOnly\"\n                                      [placeholder]=\"entry.data.getValue(entry.row, entry.col)\"\n                                      [value]=\"entry.data.getValue(entry.row, entry.col)\"\n                                      [roles]=\"roles\"\n                                      id=\"adf-select-role-permission\"\n                                      (roleChanged)=\"updateRole($event, entry.row.obj)\">\n                </adf-user-role-column>\n            </ng-template>\n\n            <adf-data-column-header *ngIf=\"!isReadOnly\">\n                <ng-template>\n                    <adf-user-role-column class=\"adf-permission-role-column-header\"\n                                          placeholder=\"PERMISSION_MANAGER.COLUMN.BULK-ROLE\"\n                                          [roles]=\"roles\"\n                                          [value]=\"bulkSelectionRole\"\n                                          id=\"adf-bulk-select-role-permission\"\n                                          (roleChanged)=\"bulkRoleUpdate($event)\">\n                    </adf-user-role-column>\n                </ng-template>\n            </adf-data-column-header>\n        </data-column>\n\n        <data-column class=\"adf-datatable-cell adf-delete-permission-column\" key=\"\" *ngIf=\"!isReadOnly\" [sortable]=\"false\">\n            <ng-template let-entry=\"$implicit\">\n                <button mat-icon-button\n                        [disabled]=\"entry.row.obj.readonly\"\n                        (click)=\"removePermission($event, entry.row.obj)\"\n                        (keydown.enter)=\"removePermission($event, entry.row.obj)\"\n                        [attr.data-automation-id]=\"'adf-delete-permission-button-' + entry.row.obj.authorityId\"\n                        [attr.aria-label]=\"'PERMISSION_MANAGER.ACTION.DELETE' | translate\">\n                    <mat-icon>delete_outline</mat-icon>\n                </button>\n            </ng-template>\n        </data-column>\n    </data-columns>\n\n    <adf-no-content-template>\n        <ng-template>\n            <adf-empty-content\n                id=\"adf-no-permissions-template\"\n                icon=\"supervisor_account\"\n                [title]=\"'PERMISSION_MANAGER.MESSAGE.EMPTY-PERMISSION' | translate\"\n                [subtitle]=\"'PERMISSION_MANAGER.MESSAGE.EMPTY-SUBTITLE' | translate\">\n            </adf-empty-content>\n        </ng-template>\n    </adf-no-content-template>\n\n</adf-datatable>\n", styles: [".adf-datatable-permission{display:flex;min-width:450px;width:100%}.adf-datatable-permission.adf-datatable{overflow:hidden}.adf-datatable-permission.adf-datatable .adf-delete-permission-column{min-width:80px}.adf-datatable-permission.adf-datatable .adf-delete-permission-column .adf-cell-value{width:80px;padding-right:10px;place-content:flex-end}.adf-datatable-permission.adf-datatable .adf-authorityId-column{flex:40%}.adf-datatable-permission.adf-datatable .adf-authority-icon-column{min-width:40px}.adf-datatable-permission.adf-datatable .adf-authority-icon-column .adf-datatable-cell-container{padding:0}.adf-datatable-permission.adf-datatable .adf-datatable-selected>svg{width:40px;height:40px}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i1.DataTableComponent, selector: "adf-datatable", inputs: ["data", "display", "rows", "sorting", "columns", "selectionMode", "multiselect", "mainTableAction", "actions", "showMainDatatableActions", "actionsPosition", "actionsVisibleOnHover", "fallbackThumbnail", "contextMenu", "rowStyle", "rowStyleClass", "showHeader", "stickyHeader", "loading", "noPermission", "rowMenuCacheEnabled", "resolverFn", "allowFiltering", "isResizingEnabled"], outputs: ["rowClick", "rowDblClick", "showRowContextMenu", "showRowActionsMenu", "executeRowAction", "columnOrderChanged", "columnsWidthChanged"] }, { kind: "directive", type: i1.NoContentTemplateDirective, selector: "adf-no-content-template, no-content-template" }, { kind: "component", type: i1.DataColumnComponent, selector: "data-column", inputs: ["id", "key", "customData", "type", "format", "sortable", "draggable", "isHidden", "title", "formatTooltip", "sr-title", "class", "copyContent", "editable", "focus", "sortingKey"] }, { kind: "component", type: i1.DataColumnListComponent, selector: "data-columns" }, { kind: "component", type: i1.DateColumnHeaderComponent, selector: "adf-data-column-header" }, { kind: "component", type: i1.EmptyContentComponent, selector: "adf-empty-content", inputs: ["icon", "title", "subtitle"] }, { kind: "component", type: UserNameColumnComponent, selector: "adf-user-name-column", inputs: ["context", "node"] }, { kind: "component", type: UserIconColumnComponent, selector: "adf-user-icon-column", inputs: ["context", "node", "selected"] }, { kind: "component", type: UserRoleColumnComponent, selector: "adf-user-role-column", inputs: ["roles", "value", "readonly", "placeholder"], outputs: ["roleChanged"] }, { kind: "component", type: NodePathColumnComponent, selector: "adf-node-path-column", inputs: ["node"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-permission-container', encapsulation: ViewEncapsulation.None, template: "<adf-datatable class=\"adf-datatable-permission\"\n               id=\"adf-permission-display-container\"\n               [rows]=\"permissions\"\n               [stickyHeader]=\"true\"\n               [selectionMode]=\"selectionMode\">\n\n    <data-columns>\n        <data-column class=\"adf-datatable-cell--image adf-authority-icon-column\" key=\"$thumbunail\" [sortable]=\"false\">\n            <ng-template let-context>\n                <adf-user-icon-column [context]=\"context\"></adf-user-icon-column>\n            </ng-template>\n        </data-column>\n\n        <data-column class=\"adf-ellipsis-cell adf-expand-cell-5 adf-authorityId-column\"\n                     [title]=\"'PERMISSION_MANAGER.COLUMN.NAME' | translate:{count:permissions.length}\"\n                     key=\"authorityId\">\n            <ng-template let-context>\n                <adf-user-name-column [context]=\"context\"></adf-user-name-column>\n            </ng-template>\n        </data-column>d\n\n        <data-column class=\"adf-ellipsis-cell adf-expand-cell-5 adf-authorityId-column\"\n                     title=\"PERMISSION_MANAGER.COLUMN.LOCATION\"\n                     key=\"location\"\n                     *ngIf=\"node && showLocation\">\n            <ng-template>\n                <adf-node-path-column [node]=\"node\"></adf-node-path-column>\n            </ng-template>\n        </data-column>\n\n        <data-column\n            class=\"adf-ellipsis-cell adf-expand-cell-4\"\n            title=\"PERMISSION_MANAGER.PERMISSION_DISPLAY.ROLE\"\n            key=\"name\"\n            [sortable]=\"false\">\n            <ng-template let-entry=\"$implicit\">\n                <adf-user-role-column [readonly]=\"entry.row.obj.readonly || isReadOnly\"\n                                      [placeholder]=\"entry.data.getValue(entry.row, entry.col)\"\n                                      [value]=\"entry.data.getValue(entry.row, entry.col)\"\n                                      [roles]=\"roles\"\n                                      id=\"adf-select-role-permission\"\n                                      (roleChanged)=\"updateRole($event, entry.row.obj)\">\n                </adf-user-role-column>\n            </ng-template>\n\n            <adf-data-column-header *ngIf=\"!isReadOnly\">\n                <ng-template>\n                    <adf-user-role-column class=\"adf-permission-role-column-header\"\n                                          placeholder=\"PERMISSION_MANAGER.COLUMN.BULK-ROLE\"\n                                          [roles]=\"roles\"\n                                          [value]=\"bulkSelectionRole\"\n                                          id=\"adf-bulk-select-role-permission\"\n                                          (roleChanged)=\"bulkRoleUpdate($event)\">\n                    </adf-user-role-column>\n                </ng-template>\n            </adf-data-column-header>\n        </data-column>\n\n        <data-column class=\"adf-datatable-cell adf-delete-permission-column\" key=\"\" *ngIf=\"!isReadOnly\" [sortable]=\"false\">\n            <ng-template let-entry=\"$implicit\">\n                <button mat-icon-button\n                        [disabled]=\"entry.row.obj.readonly\"\n                        (click)=\"removePermission($event, entry.row.obj)\"\n                        (keydown.enter)=\"removePermission($event, entry.row.obj)\"\n                        [attr.data-automation-id]=\"'adf-delete-permission-button-' + entry.row.obj.authorityId\"\n                        [attr.aria-label]=\"'PERMISSION_MANAGER.ACTION.DELETE' | translate\">\n                    <mat-icon>delete_outline</mat-icon>\n                </button>\n            </ng-template>\n        </data-column>\n    </data-columns>\n\n    <adf-no-content-template>\n        <ng-template>\n            <adf-empty-content\n                id=\"adf-no-permissions-template\"\n                icon=\"supervisor_account\"\n                [title]=\"'PERMISSION_MANAGER.MESSAGE.EMPTY-PERMISSION' | translate\"\n                [subtitle]=\"'PERMISSION_MANAGER.MESSAGE.EMPTY-SUBTITLE' | translate\">\n            </adf-empty-content>\n        </ng-template>\n    </adf-no-content-template>\n\n</adf-datatable>\n", styles: [".adf-datatable-permission{display:flex;min-width:450px;width:100%}.adf-datatable-permission.adf-datatable{overflow:hidden}.adf-datatable-permission.adf-datatable .adf-delete-permission-column{min-width:80px}.adf-datatable-permission.adf-datatable .adf-delete-permission-column .adf-cell-value{width:80px;padding-right:10px;place-content:flex-end}.adf-datatable-permission.adf-datatable .adf-authorityId-column{flex:40%}.adf-datatable-permission.adf-datatable .adf-authority-icon-column{min-width:40px}.adf-datatable-permission.adf-datatable .adf-authority-icon-column .adf-datatable-cell-container{padding:0}.adf-datatable-permission.adf-datatable .adf-datatable-selected>svg{width:40px;height:40px}\n"] }]
        }], propDecorators: { node: [{
                type: Input
            }], permissions: [{
                type: Input
            }], roles: [{
                type: Input
            }], isReadOnly: [{
                type: Input
            }], showLocation: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], update: [{
                type: Output
            }], updateAll: [{
                type: Output
            }], delete: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

class PermissionListComponent {
    constructor(permissionList) {
        this.permissionList = permissionList;
        this.selectedPermissions = [];
        this.error = this.permissionList.errored;
        this.update = this.permissionList.updated;
    }
    ngOnInit() {
        this.permissionList.fetchPermission(this.nodeId);
    }
    openAddPermissionDialog() {
        this.permissionList.updateNodePermissionByDialog();
    }
    onSelect(selections) {
        this.selectedPermissions = selections.map((selection) => selection['obj']).filter((permission) => !permission.readonly);
    }
    deleteSelection() {
        this.permissionList.deletePermissions(this.selectedPermissions);
        this.selectedPermissions = [];
    }
    updatePermission({ role, permission }) {
        this.permissionList.updateRole(role, permission);
    }
    deletePermission(permission) {
        this.selectedPermissions = [];
        this.permissionList.deletePermission(permission);
    }
    updateAllPermission(role) {
        this.permissionList.bulkRoleUpdate(role);
        this.selectedPermissions = [];
    }
}
PermissionListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionListComponent, deps: [{ token: PermissionListService }], target: i0.ɵɵFactoryTarget.Component });
PermissionListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: PermissionListComponent, selector: "adf-permission-list", inputs: { nodeId: "nodeId" }, outputs: { update: "update", error: "error" }, ngImport: i0, template: "<mat-card class=\"adf-permission-card\" id=\"adf-permission-manager-card\">\n    <div *ngIf=\"(permissionList.data$ | async) === null && permissionList.loading$ | async\" class=\"adf-permission-loader\">\n        <mat-progress-spinner [color]=\"'primary'\"\n                              [mode]=\"'indeterminate'\">\n        </mat-progress-spinner>\n    </div>\n\n    <ng-container *ngIf=\"permissionList.error$ | async\">\n        <div class=\"adf-no-permission__template\" id=\"adf-permission-manager-error\">\n            <mat-icon color=\"warn\">error</mat-icon>\n            <p class=\"adf-no-permission__template--text\">{{ 'PERMISSION_MANAGER.ERROR.NOT-FOUND'| translate }}</p>\n        </div>\n    </ng-container>\n\n    <ng-container *ngIf=\"permissionList.data$ | async as model\">\n        <div class=\"adf-permission-container\" #target>\n\n            <div class=\"adf-permission-header\">\n                <span class=\"adf-inherit-container\">\n                    <h3 class=\"adf-inherit-container-header\">\n                        {{'PERMISSION_MANAGER.LABELS.INHERITED-PERMISSIONS' | translate }}\n\n                        {{ (model.node.permissions.isInheritanceEnabled ? \"PERMISSION_MANAGER.LABELS.ON\" : \"PERMISSION_MANAGER.LABELS.OFF\") | translate }}\n                    </h3>\n\n                    <mat-slide-toggle\n                        class=\"adf-inherit-toggle\"\n                        title=\"{{'PERMISSION_MANAGER.LABELS.INHERITED_PERMISSION_TOGGLE' | translate }}\"\n                        color=\"primary\"\n                        aria-label=\"{{'PERMISSION_MANAGER.LABELS.INHERITED_PERMISSION_TOGGLE' | translate}}\"\n                        data-automation-id=\"adf-inherit-toggle-button\"\n                        [checked]=\"model.node.permissions.isInheritanceEnabled\"\n                        (change)=\"permissionList.toggleInherited($event)\">\n                    </mat-slide-toggle>\n                </span>\n\n                <span class=\"adf-inherit-subtitle\" title=\"total\">\n                    {{'PERMISSION_MANAGER.LABELS.INHERITED-SUBTITLE' | translate: { count: model.inheritedPermissions.length } }}\n                </span>\n            </div>\n\n            <button\n                mat-button\n                data-automation-id=\"permission-info-button\"\n                [adf-pop-over]=\"inheritedPermission\"\n                [target]=\"target\"\n                #popOver=\"adfPopOver\"\n                *ngIf=\"model.node.permissions.isInheritanceEnabled\">\n                {{ (popOver.open ? 'PERMISSION_MANAGER.LABELS.HIDE' : 'PERMISSION_MANAGER.LABELS.SHOW') | translate }}\n                <mat-icon *ngIf=\"popOver.open\"> keyboard_arrow_up </mat-icon>\n                <mat-icon *ngIf=\"!popOver.open\"> keyboard_arrow_down </mat-icon>\n            </button>\n        </div>\n\n        <ng-template #inheritedPermission>\n            <div class=\"adf-pop-over-card\">\n                <adf-permission-container\n                    data-automation-id=\"adf-inherited-permission\"\n                    [isReadOnly]=\"true\"\n                    [node]=\"model.node\"\n                    [permissions]=\"model.inheritedPermissions\"\n                    [showLocation]=\"true\"\n                    [selectionMode]=\"'none'\"\n                    [roles]=\"model.roles\">\n                </adf-permission-container>\n            </div>\n        </ng-template>\n\n        <mat-card-content class=\"adf-local-permission-container\">\n            <section class=\"adf-permission-content-header\">\n                <h3>{{'PERMISSION_MANAGER.LABELS.DIRECT-PERMISSIONS' | translate }}</h3>\n\n                <div class=\"adf-toolbar--spacer\"></div>\n\n                <button\n                    mat-button\n                    title=\"{{'PERMISSION_MANAGER.ACTION.ADD-PERMISSION' | translate}}\"\n                    (click)=\"openAddPermissionDialog()\"\n                    data-automation-id=\"adf-add-permission-button\">\n                    <mat-icon>person_add_outline</mat-icon>\n                </button>\n\n                <button\n                    mat-button\n                    title=\"{{'PERMISSION_MANAGER.ACTION.DELETE' | translate}}\"\n                    [disabled]=\"!selectedPermissions?.length\"\n                    (click)=\"deleteSelection()\"\n                    data-automation-id=\"adf-delete-selected-permission\">\n                    <mat-icon>delete_outline</mat-icon>\n                </button>\n            </section>\n\n            <adf-permission-container\n                class=\"adf-permission-list\"\n                data-automation-id=\"adf-locally-set-permission\"\n                [node]=\"model.node\"\n                [permissions]=\"model.localPermissions\"\n                (update)=\"updatePermission($event)\"\n                (delete)=\"deletePermission($event)\"\n                (updateAll)=\"updateAllPermission($event)\"\n                (row-select)=\"onSelect($any($event).detail.selection)\"\n                (row-unselect)=\"onSelect($any($event).detail.selection)\"\n                [roles]=\"model.roles\">\n            </adf-permission-container>\n\n        </mat-card-content>\n    </ng-container>\n</mat-card>\n", styles: [".adf-permission-card{height:100%;box-sizing:border-box;display:flex!important;flex-direction:column;overflow:hidden}.adf-permission-loader{margin-left:45%;overflow:hidden}.adf-permission-container{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:10px 15px;border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-inherit-container{display:flex;flex-direction:row;align-items:center}.adf-inherit-container-header{margin-bottom:10px;margin-top:10px}.adf-inherit-toggle{padding-left:30px}.adf-inherit-subtitle{padding-bottom:5px}.adf-permission-content-header{display:flex;flex-direction:row;align-items:center;padding:5px 15px}.adf-permission-role-column-header{position:relative!important;height:40px}.adf-permission-role-column-header .mat-form-field-infix{border:none}.adf-permission-header{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}.adf-permission-list{display:flex;height:calc(100% - 63px)}.adf-local-permission-container{overflow:hidden;flex:1 1 auto}[aria-sort=Ascending] adf-user-role-column,[aria-sort=Descending] adf-user-role-column{padding-left:10px;padding-right:10px}.adf-permission-pop-over{padding-right:15px;width:100%}.adf-permission-pop-over .adf-pop-over-card{width:100%;overflow:hidden;box-shadow:0 8px 9px -5px var(--adf-theme-foreground-divider-color),0 15px 22px 2px var(--adf-theme-foreground-divider-color)}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i6$3.MatCard, selector: "mat-card", exportAs: ["matCard"] }, { kind: "directive", type: i6$3.MatCardContent, selector: "mat-card-content, [mat-card-content], [matCardContent]" }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i9.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: i7$3.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }, { kind: "directive", type: PopOverDirective, selector: "[adf-pop-over]", inputs: ["adf-pop-over", "target", "panelClass", "autofocusedElementSelector"], exportAs: ["adfPopOver"] }, { kind: "component", type: PermissionContainerComponent, selector: "adf-permission-container", inputs: ["node", "permissions", "roles", "isReadOnly", "showLocation", "selectionMode"], outputs: ["update", "updateAll", "delete", "error"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-permission-list', encapsulation: ViewEncapsulation.None, template: "<mat-card class=\"adf-permission-card\" id=\"adf-permission-manager-card\">\n    <div *ngIf=\"(permissionList.data$ | async) === null && permissionList.loading$ | async\" class=\"adf-permission-loader\">\n        <mat-progress-spinner [color]=\"'primary'\"\n                              [mode]=\"'indeterminate'\">\n        </mat-progress-spinner>\n    </div>\n\n    <ng-container *ngIf=\"permissionList.error$ | async\">\n        <div class=\"adf-no-permission__template\" id=\"adf-permission-manager-error\">\n            <mat-icon color=\"warn\">error</mat-icon>\n            <p class=\"adf-no-permission__template--text\">{{ 'PERMISSION_MANAGER.ERROR.NOT-FOUND'| translate }}</p>\n        </div>\n    </ng-container>\n\n    <ng-container *ngIf=\"permissionList.data$ | async as model\">\n        <div class=\"adf-permission-container\" #target>\n\n            <div class=\"adf-permission-header\">\n                <span class=\"adf-inherit-container\">\n                    <h3 class=\"adf-inherit-container-header\">\n                        {{'PERMISSION_MANAGER.LABELS.INHERITED-PERMISSIONS' | translate }}\n\n                        {{ (model.node.permissions.isInheritanceEnabled ? \"PERMISSION_MANAGER.LABELS.ON\" : \"PERMISSION_MANAGER.LABELS.OFF\") | translate }}\n                    </h3>\n\n                    <mat-slide-toggle\n                        class=\"adf-inherit-toggle\"\n                        title=\"{{'PERMISSION_MANAGER.LABELS.INHERITED_PERMISSION_TOGGLE' | translate }}\"\n                        color=\"primary\"\n                        aria-label=\"{{'PERMISSION_MANAGER.LABELS.INHERITED_PERMISSION_TOGGLE' | translate}}\"\n                        data-automation-id=\"adf-inherit-toggle-button\"\n                        [checked]=\"model.node.permissions.isInheritanceEnabled\"\n                        (change)=\"permissionList.toggleInherited($event)\">\n                    </mat-slide-toggle>\n                </span>\n\n                <span class=\"adf-inherit-subtitle\" title=\"total\">\n                    {{'PERMISSION_MANAGER.LABELS.INHERITED-SUBTITLE' | translate: { count: model.inheritedPermissions.length } }}\n                </span>\n            </div>\n\n            <button\n                mat-button\n                data-automation-id=\"permission-info-button\"\n                [adf-pop-over]=\"inheritedPermission\"\n                [target]=\"target\"\n                #popOver=\"adfPopOver\"\n                *ngIf=\"model.node.permissions.isInheritanceEnabled\">\n                {{ (popOver.open ? 'PERMISSION_MANAGER.LABELS.HIDE' : 'PERMISSION_MANAGER.LABELS.SHOW') | translate }}\n                <mat-icon *ngIf=\"popOver.open\"> keyboard_arrow_up </mat-icon>\n                <mat-icon *ngIf=\"!popOver.open\"> keyboard_arrow_down </mat-icon>\n            </button>\n        </div>\n\n        <ng-template #inheritedPermission>\n            <div class=\"adf-pop-over-card\">\n                <adf-permission-container\n                    data-automation-id=\"adf-inherited-permission\"\n                    [isReadOnly]=\"true\"\n                    [node]=\"model.node\"\n                    [permissions]=\"model.inheritedPermissions\"\n                    [showLocation]=\"true\"\n                    [selectionMode]=\"'none'\"\n                    [roles]=\"model.roles\">\n                </adf-permission-container>\n            </div>\n        </ng-template>\n\n        <mat-card-content class=\"adf-local-permission-container\">\n            <section class=\"adf-permission-content-header\">\n                <h3>{{'PERMISSION_MANAGER.LABELS.DIRECT-PERMISSIONS' | translate }}</h3>\n\n                <div class=\"adf-toolbar--spacer\"></div>\n\n                <button\n                    mat-button\n                    title=\"{{'PERMISSION_MANAGER.ACTION.ADD-PERMISSION' | translate}}\"\n                    (click)=\"openAddPermissionDialog()\"\n                    data-automation-id=\"adf-add-permission-button\">\n                    <mat-icon>person_add_outline</mat-icon>\n                </button>\n\n                <button\n                    mat-button\n                    title=\"{{'PERMISSION_MANAGER.ACTION.DELETE' | translate}}\"\n                    [disabled]=\"!selectedPermissions?.length\"\n                    (click)=\"deleteSelection()\"\n                    data-automation-id=\"adf-delete-selected-permission\">\n                    <mat-icon>delete_outline</mat-icon>\n                </button>\n            </section>\n\n            <adf-permission-container\n                class=\"adf-permission-list\"\n                data-automation-id=\"adf-locally-set-permission\"\n                [node]=\"model.node\"\n                [permissions]=\"model.localPermissions\"\n                (update)=\"updatePermission($event)\"\n                (delete)=\"deletePermission($event)\"\n                (updateAll)=\"updateAllPermission($event)\"\n                (row-select)=\"onSelect($any($event).detail.selection)\"\n                (row-unselect)=\"onSelect($any($event).detail.selection)\"\n                [roles]=\"model.roles\">\n            </adf-permission-container>\n\n        </mat-card-content>\n    </ng-container>\n</mat-card>\n", styles: [".adf-permission-card{height:100%;box-sizing:border-box;display:flex!important;flex-direction:column;overflow:hidden}.adf-permission-loader{margin-left:45%;overflow:hidden}.adf-permission-container{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:10px 15px;border:1px solid var(--adf-theme-foreground-text-color-007)}.adf-inherit-container{display:flex;flex-direction:row;align-items:center}.adf-inherit-container-header{margin-bottom:10px;margin-top:10px}.adf-inherit-toggle{padding-left:30px}.adf-inherit-subtitle{padding-bottom:5px}.adf-permission-content-header{display:flex;flex-direction:row;align-items:center;padding:5px 15px}.adf-permission-role-column-header{position:relative!important;height:40px}.adf-permission-role-column-header .mat-form-field-infix{border:none}.adf-permission-header{display:flex;flex-direction:column;flex:1;height:100%;overflow:hidden;min-height:0}.adf-permission-list{display:flex;height:calc(100% - 63px)}.adf-local-permission-container{overflow:hidden;flex:1 1 auto}[aria-sort=Ascending] adf-user-role-column,[aria-sort=Descending] adf-user-role-column{padding-left:10px;padding-right:10px}.adf-permission-pop-over{padding-right:15px;width:100%}.adf-permission-pop-over .adf-pop-over-card{width:100%;overflow:hidden;box-shadow:0 8px 9px -5px var(--adf-theme-foreground-divider-color),0 15px 22px 2px var(--adf-theme-foreground-divider-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: PermissionListService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], update: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InheritPermissionDirective {
    constructor(nodeService, contentService) {
        this.nodeService = nodeService;
        this.contentService = contentService;
        /** Emitted when the node is updated. */
        this.updated = new EventEmitter();
        /** Emitted when an error occurs. */
        this.error = new EventEmitter();
    }
    onInheritPermissionClicked() {
        this.nodeService.getNode(this.nodeId).subscribe((node) => {
            if (this.contentService.hasAllowableOperations(node, AllowableOperationsEnum.UPDATEPERMISSIONS)) {
                const nodeBody = { permissions: { isInheritanceEnabled: !node?.permissions?.isInheritanceEnabled ?? false } };
                this.nodeService.updateNode(this.nodeId, nodeBody, { include: ['permissions'] }).subscribe((nodeUpdated) => {
                    this.updated.emit(nodeUpdated);
                }, (error) => this.error.emit(error));
            }
            else {
                this.error.emit('PERMISSION_MANAGER.ERROR.NOT-ALLOWED');
            }
        });
    }
}
InheritPermissionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InheritPermissionDirective, deps: [{ token: NodesApiService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Directive });
InheritPermissionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: InheritPermissionDirective, selector: "button[adf-inherit-permission], mat-button-toggle[adf-inherit-permission]", inputs: { nodeId: "nodeId" }, outputs: { updated: "updated", error: "error" }, host: { attributes: { "role": "button" }, listeners: { "click": "onInheritPermissionClicked()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: InheritPermissionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[adf-inherit-permission], mat-button-toggle[adf-inherit-permission]',
                    host: {
                        role: 'button',
                        '(click)': 'onInheritPermissionClicked()'
                    }
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }, { type: ContentService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], updated: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * @deprecated in 4.4.0, use adf-add-permission-panel instead.
 */
class AddPermissionComponent {
    constructor(nodePermissionService, contentService) {
        this.nodePermissionService = nodePermissionService;
        this.contentService = contentService;
        /** Emitted when the node is updated successfully. */
        this.success = new EventEmitter();
        /** Emitted when an error occurs during the update. */
        this.error = new EventEmitter();
        this.selectedItems = [];
    }
    ngOnInit() {
        this.nodePermissionService.getNodeWithRoles(this.nodeId).subscribe(({ node, roles }) => {
            this.currentNode = node;
            this.currentNodeRoles = roles;
        });
    }
    onSelect(selection) {
        this.selectedItems = selection;
    }
    isAddEnabled() {
        return this.contentService.hasAllowableOperations(this.currentNode, AllowableOperationsEnum.UPDATEPERMISSIONS) &&
            this.selectedItems.length !== 0;
    }
    applySelection() {
        if (this.contentService.hasAllowableOperations(this.currentNode, AllowableOperationsEnum.UPDATEPERMISSIONS)) {
            const permissions = this.transformNodeToPermissionElement(this.selectedItems, this.currentNodeRoles[0].role);
            this.nodePermissionService.updateNodePermissions(this.nodeId, permissions)
                .subscribe((node) => {
                this.success.emit(node);
            }, (error) => {
                this.error.emit(error);
            });
        }
    }
    transformNodeToPermissionElement(nodes, role) {
        return nodes.map((node) => ({
            authorityId: node.entry.properties['cm:authorityName'] ?? node.entry.properties['cm:userName'],
            name: role,
            accessStatus: 'ALLOWED'
        }));
    }
}
AddPermissionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddPermissionComponent, deps: [{ token: NodePermissionService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Component });
AddPermissionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AddPermissionComponent, selector: "adf-add-permission", inputs: { nodeId: "nodeId" }, outputs: { success: "success", error: "error" }, ngImport: i0, template: "<adf-add-permission-panel\n    (select)=\"onSelect($event)\">\n</adf-add-permission-panel>\n<div id=\"adf-add-permission-actions\">\n   <button mat-button\n          id=\"adf-add-permission-action-button\"\n          class=\"adf-permission-action\"\n          [disabled]=\"!isAddEnabled()\"\n          (click)=\"applySelection()\">\n     {{'PERMISSION_MANAGER.ADD-PERMISSION.ADD-ACTION' | translate}}\n    </button>\n</div>\n", styles: [".adf-permission-action[disabled]{opacity:.6}.adf-permission-action:enabled{color:var(--theme-primary-color)}\n"], dependencies: [{ kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: AddPermissionPanelComponent, selector: "adf-add-permission-panel", outputs: ["select"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AddPermissionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-add-permission', encapsulation: ViewEncapsulation.None, template: "<adf-add-permission-panel\n    (select)=\"onSelect($event)\">\n</adf-add-permission-panel>\n<div id=\"adf-add-permission-actions\">\n   <button mat-button\n          id=\"adf-add-permission-action-button\"\n          class=\"adf-permission-action\"\n          [disabled]=\"!isAddEnabled()\"\n          (click)=\"applySelection()\">\n     {{'PERMISSION_MANAGER.ADD-PERMISSION.ADD-ACTION' | translate}}\n    </button>\n</div>\n", styles: [".adf-permission-action[disabled]{opacity:.6}.adf-permission-action:enabled{color:var(--theme-primary-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: NodePermissionService }, { type: ContentService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], success: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PermissionManagerModule {
}
PermissionManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PermissionManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: PermissionManagerModule, declarations: [PermissionListComponent,
        AddPermissionPanelComponent,
        InheritPermissionDirective,
        AddPermissionComponent,
        AddPermissionDialogComponent,
        UserNameColumnComponent,
        UserIconColumnComponent,
        UserRoleColumnComponent,
        PopOverDirective,
        NodePathColumnComponent,
        PermissionContainerComponent], imports: [CoreModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        SearchModule,
        PipeModule], exports: [PermissionListComponent,
        AddPermissionPanelComponent,
        InheritPermissionDirective,
        AddPermissionComponent,
        AddPermissionDialogComponent,
        UserNameColumnComponent,
        UserIconColumnComponent,
        UserRoleColumnComponent,
        PopOverDirective,
        NodePathColumnComponent] });
PermissionManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionManagerModule, imports: [CoreModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        SearchModule,
        PipeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: PermissionManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CoreModule,
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MaterialModule,
                        SearchModule,
                        PipeModule
                    ],
                    declarations: [
                        PermissionListComponent,
                        AddPermissionPanelComponent,
                        InheritPermissionDirective,
                        AddPermissionComponent,
                        AddPermissionDialogComponent,
                        UserNameColumnComponent,
                        UserIconColumnComponent,
                        UserRoleColumnComponent,
                        PopOverDirective,
                        NodePathColumnComponent,
                        PermissionContainerComponent
                    ],
                    exports: [
                        PermissionListComponent,
                        AddPermissionPanelComponent,
                        InheritPermissionDirective,
                        AddPermissionComponent,
                        AddPermissionDialogComponent,
                        UserNameColumnComponent,
                        UserIconColumnComponent,
                        UserRoleColumnComponent,
                        PopOverDirective,
                        NodePathColumnComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SharedLinksApiService {
    constructor(apiService, preferences) {
        this.apiService = apiService;
        this.preferences = preferences;
        this.error = new Subject();
    }
    get sharedLinksApi() {
        this._sharedLinksApi = this._sharedLinksApi ?? new SharedlinksApi(this.apiService.getInstance());
        return this._sharedLinksApi;
    }
    /**
     * Gets shared links available to the current user.
     *
     * @param options Options supported by JS-API
     * @returns List of shared links
     */
    getSharedLinks(options = {}) {
        const defaultOptions = {
            maxItems: this.preferences.paginationSize,
            skipCount: 0,
            include: ['properties', 'allowableOperations']
        };
        const queryOptions = Object.assign({}, defaultOptions, options);
        const promise = this.sharedLinksApi.listSharedLinks(queryOptions);
        return from(promise).pipe(catchError((err) => of(err)));
    }
    /**
     * Creates a shared link available to the current user.
     *
     * @param nodeId ID of the node to link to
     * @param sharedLinkWithExpirySettings shared link with nodeId and expiryDate
     * @param options Options supported by JS-API
     * @returns The shared link just created
     */
    createSharedLinks(nodeId, sharedLinkWithExpirySettings, options = {}) {
        const promise = this.sharedLinksApi.createSharedLink(sharedLinkWithExpirySettings ? sharedLinkWithExpirySettings : { nodeId }, options);
        return from(promise).pipe(catchError((err) => of(err)));
    }
    /**
     * Deletes a shared link.
     *
     * @param sharedId ID of the link to delete
     * @returns Null response notifying when the operation is complete
     */
    deleteSharedLink(sharedId) {
        const promise = this.sharedLinksApi.deleteSharedLink(sharedId);
        return from(promise).pipe(catchError((err) => of(err)));
    }
}
SharedLinksApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SharedLinksApiService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
SharedLinksApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SharedLinksApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SharedLinksApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RenditionService {
    constructor(apiService, logService, translateService, viewUtilsService) {
        this.apiService = apiService;
        this.logService = logService;
        this.translateService = translateService;
        this.viewUtilsService = viewUtilsService;
        /**
         * Based on ViewerRenderComponent Implementation, this value is used to determine how many times we try
         * to get the rendition of a file for preview, or printing.
         */
        this.maxRetries = 5;
        /**
         * Timeout used for setInterval.
         */
        this.TRY_TIMEOUT = 10000;
        this.DEFAULT_RENDITION = 'imgpreview';
    }
    get renditionsApi() {
        this._renditionsApi = this._renditionsApi ?? new RenditionsApi(this.apiService.getInstance());
        return this._renditionsApi;
    }
    get contentApi() {
        this._contentApi = this._contentApi ?? new ContentApi(this.apiService.getInstance());
        return this._contentApi;
    }
    get versionsApi() {
        this._versionsApi = this._versionsApi ?? new VersionsApi(this.apiService.getInstance());
        return this._versionsApi;
    }
    getRenditionUrl(nodeId, type, renditionExists) {
        return (renditionExists && type !== RenditionService.ContentGroup.IMAGE) ?
            this.contentApi.getRenditionUrl(nodeId, RenditionService.ContentGroup.PDF) :
            this.contentApi.getContentUrl(nodeId, false);
    }
    async waitRendition(nodeId, renditionId, retries) {
        const rendition = await this.renditionsApi.getRendition(nodeId, renditionId);
        if (this.maxRetries < retries) {
            const status = rendition.entry.status.toString();
            if (status === 'CREATED') {
                return rendition;
            }
            else {
                retries += 1;
                await this.wait(1000);
                return this.waitRendition(nodeId, renditionId, retries);
            }
        }
        return Promise.resolve(null);
    }
    wait(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    async getRendition(nodeId, renditionId) {
        const renditionPaging = await this.renditionsApi.listRenditions(nodeId);
        let rendition = renditionPaging.list.entries.find((renditionEntry) => renditionEntry.entry.id.toLowerCase() === renditionId);
        if (rendition) {
            const status = rendition.entry.status.toString();
            if (status === 'NOT_CREATED') {
                try {
                    await this.renditionsApi.createRendition(nodeId, { id: renditionId });
                    rendition = await this.waitRendition(nodeId, renditionId, 0);
                }
                catch (err) {
                    this.logService.error(err);
                }
            }
        }
        return new Promise((resolve) => resolve(rendition));
    }
    async getNodeRendition(nodeId, versionId) {
        try {
            return versionId ? await this.resolveNodeRendition(nodeId, 'pdf', versionId) :
                await this.resolveNodeRendition(nodeId, 'pdf');
        }
        catch (err) {
            this.logService.error(err);
            return null;
        }
    }
    async resolveNodeRendition(nodeId, renditionId, versionId) {
        renditionId = renditionId.toLowerCase();
        const supportedRendition = versionId ? await this.versionsApi.listVersionRenditions(nodeId, versionId) :
            await this.renditionsApi.listRenditions(nodeId);
        let rendition = this.findRenditionById(supportedRendition, renditionId);
        if (!rendition) {
            renditionId = this.DEFAULT_RENDITION;
            rendition = this.findRenditionById(supportedRendition, this.DEFAULT_RENDITION);
        }
        if (rendition) {
            const status = rendition.entry.status.toString();
            const mimeType = rendition.entry.content.mimeType;
            if (status === 'NOT_CREATED') {
                return { url: await this.requestCreateRendition(nodeId, renditionId, versionId), mimeType };
            }
            else {
                return { url: await this.handleNodeRendition(nodeId, renditionId, versionId), mimeType };
            }
        }
        return null;
    }
    async requestCreateRendition(nodeId, renditionId, versionId) {
        try {
            if (versionId) {
                await this.versionsApi.createVersionRendition(nodeId, versionId, { id: renditionId });
            }
            else {
                await this.renditionsApi.createRendition(nodeId, { id: renditionId });
            }
            try {
                return versionId ? await this.waitNodeRendition(nodeId, renditionId, versionId) : await this.waitNodeRendition(nodeId, renditionId);
            }
            catch (e) {
                return null;
            }
        }
        catch (err) {
            this.logService.error(err);
            return null;
        }
    }
    findRenditionById(supportedRendition, renditionId) {
        const rendition = supportedRendition.list.entries.find((renditionEntry) => renditionEntry.entry.id.toLowerCase() === renditionId);
        return rendition;
    }
    async waitNodeRendition(nodeId, renditionId, versionId) {
        let currentRetry = 0;
        return new Promise((resolve, reject) => {
            const intervalId = setInterval(() => {
                currentRetry++;
                if (this.maxRetries >= currentRetry) {
                    if (versionId) {
                        this.versionsApi.getVersionRendition(nodeId, versionId, renditionId).then((rendition) => {
                            const status = rendition.entry.status.toString();
                            if (status === 'CREATED') {
                                clearInterval(intervalId);
                                return resolve(this.handleNodeRendition(nodeId, rendition.entry.content.mimeType, versionId));
                            }
                        }, () => reject());
                    }
                    else {
                        this.renditionsApi.getRendition(nodeId, renditionId).then((rendition) => {
                            const status = rendition.entry.status.toString();
                            if (status === 'CREATED') {
                                clearInterval(intervalId);
                                return resolve(this.handleNodeRendition(nodeId, renditionId, versionId));
                            }
                        }, () => reject());
                    }
                }
                else {
                    clearInterval(intervalId);
                    return reject();
                }
            }, this.TRY_TIMEOUT);
        });
    }
    async handleNodeRendition(nodeId, renditionId, versionId) {
        const url = versionId ? this.contentApi.getVersionRenditionUrl(nodeId, versionId, renditionId) :
            this.contentApi.getRenditionUrl(nodeId, renditionId);
        return url;
    }
    async generateMediaTracksRendition(nodeId) {
        return this.isRenditionAvailable(nodeId, RenditionService.SUBTITLES_RENDITION_NAME)
            .then((value) => {
            const tracks = [];
            if (value) {
                tracks.push({
                    kind: 'subtitles',
                    src: this.contentApi.getRenditionUrl(nodeId, RenditionService.SUBTITLES_RENDITION_NAME),
                    label: this.translateService.instant('ADF_VIEWER.SUBTITLES')
                });
            }
            return tracks;
        })
            .catch((err) => {
            this.logService.error('Error while retrieving ' + RenditionService.SUBTITLES_RENDITION_NAME + ' rendition');
            this.logService.error(err);
            return [];
        });
    }
    async isRenditionAvailable(nodeId, renditionId) {
        const renditionPaging = await this.renditionsApi.listRenditions(nodeId);
        const rendition = renditionPaging.list.entries.find((renditionEntry) => renditionEntry.entry.id.toLowerCase() === renditionId);
        return rendition?.entry?.status?.toString() === 'CREATED' || false;
    }
    /**
     * This method takes a url to trigger the print dialog against, and the type of artifact that it
     * is.
     * This URL should be one that can be rendered in the browser, for example PDF, Image, or Text
     */
    printFile(url, type) {
        const pwa = window.open(url, RenditionService.TARGET);
        if (pwa) {
            // Because of the way chrome focus and close image window vs. pdf preview window
            if (type === RenditionService.ContentGroup.IMAGE) {
                pwa.onfocus = () => {
                    setTimeout(() => {
                        pwa.close();
                    }, 500);
                };
            }
            pwa.onload = () => {
                pwa.print();
            };
        }
    }
    /**
     * Launch the File Print dialog from anywhere other than the preview service, which resolves the
     * rendition of the object that can be printed from a web browser.
     * These are: images, PDF files, or PDF rendition of files.
     * We also force PDF rendition for TEXT type objects, otherwise the default URL is to download.
     * TODO there are different TEXT type objects, (HTML, plaintext, xml, etc. we should determine how these are handled)
     */
    printFileGeneric(objectId, mimeType) {
        const nodeId = objectId;
        const type = this.viewUtilsService.getViewerTypeByMimeType(mimeType);
        this.getRendition(nodeId, RenditionService.ContentGroup.PDF)
            .then((value) => {
            const url = this.getRenditionUrl(nodeId, type, (!!value));
            const printType = (type === RenditionService.ContentGroup.PDF
                || type === RenditionService.ContentGroup.TEXT)
                ? RenditionService.ContentGroup.PDF : type;
            this.printFile(url, printType);
        })
            .catch((err) => {
            this.logService.error('Error with Printing');
            this.logService.error(err);
        });
    }
}
RenditionService.TARGET = '_new';
/**
 * Content groups based on categorization of files that can be viewed in the web browser. This
 * implementation or grouping is tied to the definition the ng component: ViewerRenderComponent
 */
RenditionService.ContentGroup = {
    IMAGE: 'image',
    MEDIA: 'media',
    PDF: 'pdf',
    TEXT: 'text'
};
/**
 * The name of the rendition with the media subtitles in the supported format
 */
RenditionService.SUBTITLES_RENDITION_NAME = 'webvtt';
RenditionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RenditionService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }, { token: i1.TranslationService }, { token: i1.ViewUtilService }], target: i0.ɵɵFactoryTarget.Injectable });
RenditionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RenditionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: RenditionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }, { type: i1.TranslationService }, { type: i1.ViewUtilService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ShareDialogComponent {
    constructor(sharedLinksApiService, dialogRef, dialog, contentService, renditionService, data) {
        this.sharedLinksApiService = sharedLinksApiService;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.contentService = contentService;
        this.renditionService = renditionService;
        this.data = data;
        this.minDate = add(new Date(), { days: 1 });
        this.isFileShared = false;
        this.isDisabled = false;
        this.isLinkWithExpiryDate = false;
        this.form = new UntypedFormGroup({
            sharedUrl: new UntypedFormControl(''),
            time: new UntypedFormControl({ value: '', disabled: true })
        });
        this.type = 'date';
        this.maxDebounceTime = 500;
        this.onDestroy$ = new Subject();
    }
    ngOnInit() {
        if (this.data.node && this.data.node.entry) {
            this.fileName = this.data.node.entry.name;
            this.baseShareUrl = this.data.baseShareUrl;
            const properties = this.data.node.entry.properties;
            if (!properties || !properties['qshare:sharedId']) {
                this.createSharedLinks(this.data.node.entry.id);
            }
            else {
                this.sharedId = properties['qshare:sharedId'];
                this.isFileShared = true;
                const expiryDate = this.updateForm();
                this.isExpiryDateToggleChecked = this.isLinkWithExpiryDate = !!expiryDate;
                this.isLinkWithExpiryDate ? this.time.enable() : this.time.disable();
            }
        }
        this.time.valueChanges
            .pipe(debounceTime(this.maxDebounceTime), takeUntil(this.onDestroy$))
            .subscribe(value => this.onTimeChanged(value));
    }
    onTimeChanged(date) {
        this.updateNode(date);
    }
    get time() {
        return this.form.controls['time'];
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    onSlideShareChange(event) {
        if (event.checked) {
            this.createSharedLinks(this.data.node.entry.id);
        }
        else {
            this.openConfirmationDialog();
        }
    }
    get canUpdate() {
        const { entry } = this.data.node;
        if (entry && entry.allowableOperations) {
            return this.contentService.hasAllowableOperations(entry, 'update');
        }
        return true;
    }
    onToggleExpirationDate(slideToggle) {
        if (slideToggle.checked) {
            this.time.enable();
            this.isExpiryDateToggleChecked = true;
        }
        else {
            this.time.disable();
            this.time.setValue(null);
            this.deleteSharedLink(this.sharedId, true);
        }
    }
    onDatePickerClosed() {
        this.datePickerInput.nativeElement.blur();
        if (!this.time.value) {
            this.slideToggleExpirationDate.checked = false;
        }
    }
    openConfirmationDialog() {
        this.isFileShared = false;
        this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: 'SHARE.CONFIRMATION.DIALOG-TITLE',
                message: 'SHARE.CONFIRMATION.MESSAGE',
                yesLabel: 'SHARE.CONFIRMATION.REMOVE',
                noLabel: 'SHARE.CONFIRMATION.CANCEL'
            },
            minWidth: '250px',
            closeOnNavigation: true
        })
            .beforeClosed()
            .subscribe((deleteSharedLink) => {
            if (deleteSharedLink) {
                this.deleteSharedLink(this.sharedId);
            }
            else {
                this.isFileShared = true;
            }
        });
    }
    createSharedLinks(nodeId, sharedLinkWithExpirySettings) {
        this.isDisabled = true;
        this.sharedLinksApiService.createSharedLinks(nodeId, sharedLinkWithExpirySettings).subscribe((sharedLink) => {
            if (sharedLink.entry) {
                this.sharedId = sharedLink.entry.id;
                if (this.data.node.entry.properties) {
                    this.data.node.entry.properties['qshare:sharedId'] = this.sharedId;
                }
                else {
                    this.data.node.entry.properties = {
                        'qshare:sharedId': this.sharedId
                    };
                }
                this.isDisabled = false;
                this.isFileShared = true;
                // eslint-disable-next-line
                this.renditionService.getNodeRendition(this.data.node.entry.id);
                this.updateForm();
            }
        }, () => {
            this.isDisabled = false;
            this.isFileShared = false;
        });
    }
    deleteSharedLink(sharedId, dialogOpenFlag) {
        this.isDisabled = true;
        this.sharedLinksApiService
            .deleteSharedLink(sharedId)
            .subscribe((response) => {
            if (response instanceof Error) {
                this.isDisabled = false;
                this.isFileShared = true;
                this.handleError(response);
            }
            else {
                if (this.data.node.entry.properties) {
                    this.data.node.entry.properties['qshare:sharedId'] = null;
                    this.data.node.entry.properties['qshare:expiryDate'] = null;
                }
                if (dialogOpenFlag) {
                    this.createSharedLinks(this.data.node.entry.id);
                    this.isExpiryDateToggleChecked = false;
                    this.isLinkWithExpiryDate = false;
                }
                else {
                    this.dialogRef.close(false);
                }
            }
        });
    }
    handleError(error) {
        let message = 'SHARE.UNSHARE_ERROR';
        let statusCode = 0;
        try {
            statusCode = JSON.parse(error.message).error.statusCode;
        }
        catch {
        }
        if (statusCode === 403) {
            message = 'SHARE.UNSHARE_PERMISSION_ERROR';
        }
        this.sharedLinksApiService.error.next({
            statusCode,
            message
        });
    }
    updateForm() {
        const { entry } = this.data.node;
        let expiryDate = null;
        if (entry && entry.properties) {
            expiryDate = entry.properties['qshare:expiryDate'];
        }
        this.form.setValue({
            sharedUrl: `${this.baseShareUrl}${this.sharedId}`,
            time: expiryDate ? new Date(expiryDate) : null
        }, { emitEvent: false });
        return expiryDate;
    }
    updateNode(date) {
        let expiryDate;
        if (date) {
            if (this.type === 'date') {
                expiryDate = format(endOfDay(new Date(date)), `yyyy-MM-dd'T'HH:mm:ss.SSSxx`);
            }
            else {
                expiryDate = format((new Date(date)), `yyyy-MM-dd'T'HH:mm:ss.SSSxx`);
            }
        }
        else {
            expiryDate = null;
        }
        if (this.sharedId && expiryDate) {
            this.isDisabled = true;
            this.sharedLinksApiService.deleteSharedLink(this.sharedId).subscribe((response) => {
                if (response instanceof Error) {
                    this.isDisabled = false;
                    this.isFileShared = true;
                    this.handleError(response);
                }
                else {
                    this.sharedLinkWithExpirySettings(expiryDate);
                    this.isLinkWithExpiryDate = true;
                    this.updateEntryExpiryDate(date);
                }
            });
        }
    }
    sharedLinkWithExpirySettings(expiryDate) {
        const nodeObject = {
            nodeId: this.data.node.entry.id,
            expiresAt: expiryDate
        };
        this.createSharedLinks(this.data.node.entry.id, nodeObject);
    }
    updateEntryExpiryDate(date) {
        const { properties } = this.data.node.entry;
        if (properties) {
            properties['qshare:expiryDate'] = date
                ? new Date(date)
                : null;
        }
    }
}
ShareDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ShareDialogComponent, deps: [{ token: SharedLinksApiService }, { token: i1$1.MatDialogRef }, { token: i1$1.MatDialog }, { token: ContentService }, { token: RenditionService }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
ShareDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: ShareDialogComponent, selector: "adf-share-dialog", host: { classAttribute: "adf-share-dialog" }, viewQueries: [{ propertyName: "slideToggleExpirationDate", first: true, predicate: ["slideToggleExpirationDate"], descendants: true, static: true }, { propertyName: "datePickerInput", first: true, predicate: ["datePickerInput"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"adf-share-link__dialog-content\">\n    <div class=\"adf-share-link__dialog-container\">\n        <div class=\"adf-share-link--row\">\n            <div\n                data-automation-id=\"adf-share-dialog-title\"\n                class=\"adf-share-link__title adf-share-link__label adf-share-link__heading\"\n                role=\"heading\"\n                aria-level=\"1\">\n                {{ 'SHARE.DIALOG-TITLE' | translate }} {{ fileName }}\n            </div>\n            <mat-icon mat-dialog-close class=\"adf-share-link__close adf-share-link__icon\">close</mat-icon>\n        </div>\n        <mat-dialog-content>\n            <hr class=\"adf-share-link__separation-line\" />\n            <form [formGroup]=\"form\" class=\"adf-share-link__form\">\n                <div class=\"adf-share-link--row\">\n                    <mat-icon class=\"adf-share-link__icon\">timer</mat-icon>\n                    <div class=\"adf-share-link__label adf-sharable-link\">{{ 'SHARE.LINK-EXPIRY-DATE' | translate }}\n                    </div>\n                    <mat-slide-toggle\n                        #slideToggleExpirationDate\n                        [disabled]=\"!canUpdate\"\n                        color=\"primary\"\n                        data-automation-id=\"adf-expire-toggle\"\n                        aria-label=\"{{ 'SHARE.EXPIRES' | translate }}\"\n                        [checked]=\"time.value\"\n                        (change)=\"onToggleExpirationDate($event)\">\n                    </mat-slide-toggle>\n                </div>\n                <div\n                    [style.display]=\"isExpiryDateToggleChecked ? 'block' : 'none'\"\n                    data-automation-id=\"adf-slide-toggle-checked\"\n                    class=\"adf-share-link__date-time-container\">\n                    <mat-form-field class=\"adf-full-width adf-float-label\" floatLabel='always'>\n                        <mat-label>{{ 'SHARE.EXPIRATION-PLACEHOLDER' | translate }}</mat-label>\n                        <mat-datepicker-toggle\n                            [disabled]=\"time.disabled\"\n                            [for]=\"datePicker\"\n                            matSuffix\n                            class=\"adf-share-link__icon adf-share-link__calender-icon\">\n                        </mat-datepicker-toggle>\n                        <mat-datepicker\n                            #datePicker\n                            (closed)=\"onDatePickerClosed()\">\n                        </mat-datepicker>\n                        <input\n                            class=\"adf-share-link__input\"\n                            #datePickerInput\n                            matInput\n                            placeholder=\"{{ 'SHARE.EXPIRATION-PLACEHOLDER' | translate }}\"\n                            [attr.aria-label]=\"'SHARE.EXPIRATION-LABEL' | translate\"\n                            [min]=\"minDate\"\n                            formControlName=\"time\"\n                            [matDatepicker]=\"datePicker\" />\n                    </mat-form-field>\n                </div>\n                <p class=\"adf-share-link__info adf-share-link__para\">{{ 'SHARE.SHARE-LINK' | translate }}</p>\n                <div class=\"adf-share-link--row\">\n                    <mat-slide-toggle\n                        color=\"primary\"\n                        data-automation-id=\"adf-share-toggle\"\n                        aria-label=\"{{ 'SHARE.TITLE' | translate }}\"\n                        [checked]=\"isFileShared\"\n                        [disabled]=\"!canUpdate || isDisabled\"\n                        (change)=\"onSlideShareChange($event)\">\n                    </mat-slide-toggle>\n                    <div class=\"adf-share-link__label adf-sharable-link\">{{ 'SHARE.SHARABLE-LINK-CREATED' | translate }}\n                    </div>\n                </div>\n                <mat-form-field\n                    class=\"adf-full-width adf-float-label\"\n                    floatLabel='always'\n                    [ngClass]=\"isLinkWithExpiryDate? 'adf-share-link__border-color' : ''\">\n                    <input\n                        #sharedLinkInput\n                        data-automation-id=\"adf-share-link\"\n                        class=\"adf-share-link__input\"\n                        matInput\n                        cdkFocusInitial\n                        placeholder=\"{{ 'SHARE.PUBLIC-LINK' | translate }}\"\n                        [attr.aria-label]=\"'SHARE.PUBLIC-LINK' | translate\"\n                        formControlName=\"sharedUrl\"\n                        readonly=\"readonly\">\n                    <mat-icon\n                        class=\"adf-input-action adf-share-link__icon\"\n                        role=\"button\"\n                        matSuffix\n                        [clipboard-notification]=\"'SHARE.CLIPBOARD-MESSAGE' | translate\"\n                        [adf-clipboard]\n                        [attr.aria-label]=\"'SHARE.COPY_BUTTON_LABEL' | translate\"\n                        [target]=\"sharedLinkInput\"\n                        tabindex=\"0\">\n                        content_copy\n                    </mat-icon>\n                </mat-form-field>\n                <p class=\"adf-share-link__warn adf-share-link__para\" *ngIf=\"isLinkWithExpiryDate\">\n                    {{ 'SHARE.LINK-WITH-EXPIRY-SETTINGS' | translate }}\n                </p>\n                <div class=\"adf-share-link--row\">\n                    <mat-icon class=\"adf-share-link__icon\">public</mat-icon>\n                    <p\n                        class=\"adf-share-link__info adf-sharable-link adf-share-link__public-content adf-share-link__para\">\n                        {{ 'SHARE.PUBLIC-CONTENT' | translate }}\n                    </p>\n                </div>\n            </form>\n            <hr class=\"adf-share-link__separation-line\" />\n        </mat-dialog-content>\n        <div mat-dialog-actions>\n            <button data-automation-id=\"adf-share-dialog-close\" mat-button color=\"primary\" mat-dialog-close>\n                {{ 'SHARE.CLOSE' | translate }}\n            </button>\n        </div>\n    </div>\n</div>\n", styles: [".adf-float-label{padding-top:20px}.adf-share-link-dialog .adf-share-link__dialog-content{display:flex;flex-direction:column;padding:24px;background-color:var(--theme-grey-text-background-color)}.adf-share-link-dialog .adf-share-link__dialog-container{background-color:var(--theme-card-background-color);border-radius:16px;padding:16px 24px}.adf-share-link-dialog .adf-share-link__label,.adf-share-link-dialog .adf-share-link__title,.adf-share-link-dialog .adf-share-link__info{letter-spacing:-.4px;line-height:2;font-weight:400;font-style:normal;font-stretch:normal;font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087)}.adf-share-link-dialog .adf-share-link__label{flex:1 1 auto}.adf-share-link-dialog .adf-share-link__form{padding-top:8px}.adf-share-link-dialog .adf-share-link__public-content{color:var(--adf-theme-foreground-text-color-054);font-size:var(--theme-caption-font-size)}.adf-share-link-dialog .adf-share-link__warn{color:var(--theme-warn-color);font-size:var(--theme-caption-font-size)}.adf-share-link-dialog .adf-share-link--row{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin:8px 0}.adf-share-link-dialog .adf-share-link__input{color:var(--adf-theme-foreground-text-color-087)}.adf-share-link-dialog .adf-share-link__separation-line{border:1px solid var(--theme-grey-background-color);margin:8px -24px}.adf-share-link-dialog .adf-share-link__close{cursor:pointer;margin-left:12px}.adf-share-link-dialog .adf-share-link__icon{color:var(--adf-theme-foreground-icon-color-054)}.adf-share-link-dialog .adf-share-link__para{margin-top:8px;margin-bottom:8px}.adf-share-link-dialog .adf-share-link__heading{font-weight:700;font-size:var(--theme-subheading-2-font-size)}.adf-share-link-dialog .adf-share-link__calender-icon{font-size:18px}.adf-share-link-dialog .adf-share-link__date-time-container{padding-bottom:8px}.adf-share-link-dialog .adf-share-link__border-color{border:1px solid var(--theme-warn-color)}.adf-share-link-dialog .adf-input-action{cursor:pointer}.adf-share-link-dialog .adf-full-width{width:100%;background-color:var(--theme-grey-text-background-color);border-radius:6px;padding-top:8px}.adf-share-link-dialog .adf-sharable-link{margin-left:8px}.adf-share-link-dialog .mat-form-field-infix{border-top:unset}.adf-share-link-dialog .mat-dialog-actions{justify-content:flex-end;padding:0;margin:8px 0 0}.adf-share-link-dialog .mat-dialog-actions>button{color:var(--adf-theme-foreground-base-color);background-color:var(--theme-grey-text-background-color);margin-right:12px}.adf-share-link-dialog .mat-form-field-flex{align-items:center}.adf-share-link-dialog .mat-dialog-container{padding:0}.adf-share-link-dialog .mat-form-field-appearance-legacy .mat-form-field-underline{display:none}.adf-share-link-dialog .mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:8px;margin-right:8px;margin-left:8px}@media screen and (max-width: 380px){.adf-share-link-dialog .mat-dialog-container{padding:0 15px}.adf-share-link-dialog .mat-dialog-actions{margin-bottom:0;padding:2px 0}.adf-share-link-dialog .mat-form-field-suffix{padding-left:8px}}\n"], dependencies: [{ kind: "directive", type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ClipboardDirective, selector: "[adf-clipboard]", inputs: ["adf-clipboard", "target", "clipboard-notification"], exportAs: ["adfClipboard"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i8.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i8.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i8.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i6.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i6.MatLabel, selector: "mat-label" }, { kind: "directive", type: i6.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i7.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i7$3.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ShareDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-share-dialog', host: { class: 'adf-share-dialog' }, encapsulation: ViewEncapsulation.None, template: "<div class=\"adf-share-link__dialog-content\">\n    <div class=\"adf-share-link__dialog-container\">\n        <div class=\"adf-share-link--row\">\n            <div\n                data-automation-id=\"adf-share-dialog-title\"\n                class=\"adf-share-link__title adf-share-link__label adf-share-link__heading\"\n                role=\"heading\"\n                aria-level=\"1\">\n                {{ 'SHARE.DIALOG-TITLE' | translate }} {{ fileName }}\n            </div>\n            <mat-icon mat-dialog-close class=\"adf-share-link__close adf-share-link__icon\">close</mat-icon>\n        </div>\n        <mat-dialog-content>\n            <hr class=\"adf-share-link__separation-line\" />\n            <form [formGroup]=\"form\" class=\"adf-share-link__form\">\n                <div class=\"adf-share-link--row\">\n                    <mat-icon class=\"adf-share-link__icon\">timer</mat-icon>\n                    <div class=\"adf-share-link__label adf-sharable-link\">{{ 'SHARE.LINK-EXPIRY-DATE' | translate }}\n                    </div>\n                    <mat-slide-toggle\n                        #slideToggleExpirationDate\n                        [disabled]=\"!canUpdate\"\n                        color=\"primary\"\n                        data-automation-id=\"adf-expire-toggle\"\n                        aria-label=\"{{ 'SHARE.EXPIRES' | translate }}\"\n                        [checked]=\"time.value\"\n                        (change)=\"onToggleExpirationDate($event)\">\n                    </mat-slide-toggle>\n                </div>\n                <div\n                    [style.display]=\"isExpiryDateToggleChecked ? 'block' : 'none'\"\n                    data-automation-id=\"adf-slide-toggle-checked\"\n                    class=\"adf-share-link__date-time-container\">\n                    <mat-form-field class=\"adf-full-width adf-float-label\" floatLabel='always'>\n                        <mat-label>{{ 'SHARE.EXPIRATION-PLACEHOLDER' | translate }}</mat-label>\n                        <mat-datepicker-toggle\n                            [disabled]=\"time.disabled\"\n                            [for]=\"datePicker\"\n                            matSuffix\n                            class=\"adf-share-link__icon adf-share-link__calender-icon\">\n                        </mat-datepicker-toggle>\n                        <mat-datepicker\n                            #datePicker\n                            (closed)=\"onDatePickerClosed()\">\n                        </mat-datepicker>\n                        <input\n                            class=\"adf-share-link__input\"\n                            #datePickerInput\n                            matInput\n                            placeholder=\"{{ 'SHARE.EXPIRATION-PLACEHOLDER' | translate }}\"\n                            [attr.aria-label]=\"'SHARE.EXPIRATION-LABEL' | translate\"\n                            [min]=\"minDate\"\n                            formControlName=\"time\"\n                            [matDatepicker]=\"datePicker\" />\n                    </mat-form-field>\n                </div>\n                <p class=\"adf-share-link__info adf-share-link__para\">{{ 'SHARE.SHARE-LINK' | translate }}</p>\n                <div class=\"adf-share-link--row\">\n                    <mat-slide-toggle\n                        color=\"primary\"\n                        data-automation-id=\"adf-share-toggle\"\n                        aria-label=\"{{ 'SHARE.TITLE' | translate }}\"\n                        [checked]=\"isFileShared\"\n                        [disabled]=\"!canUpdate || isDisabled\"\n                        (change)=\"onSlideShareChange($event)\">\n                    </mat-slide-toggle>\n                    <div class=\"adf-share-link__label adf-sharable-link\">{{ 'SHARE.SHARABLE-LINK-CREATED' | translate }}\n                    </div>\n                </div>\n                <mat-form-field\n                    class=\"adf-full-width adf-float-label\"\n                    floatLabel='always'\n                    [ngClass]=\"isLinkWithExpiryDate? 'adf-share-link__border-color' : ''\">\n                    <input\n                        #sharedLinkInput\n                        data-automation-id=\"adf-share-link\"\n                        class=\"adf-share-link__input\"\n                        matInput\n                        cdkFocusInitial\n                        placeholder=\"{{ 'SHARE.PUBLIC-LINK' | translate }}\"\n                        [attr.aria-label]=\"'SHARE.PUBLIC-LINK' | translate\"\n                        formControlName=\"sharedUrl\"\n                        readonly=\"readonly\">\n                    <mat-icon\n                        class=\"adf-input-action adf-share-link__icon\"\n                        role=\"button\"\n                        matSuffix\n                        [clipboard-notification]=\"'SHARE.CLIPBOARD-MESSAGE' | translate\"\n                        [adf-clipboard]\n                        [attr.aria-label]=\"'SHARE.COPY_BUTTON_LABEL' | translate\"\n                        [target]=\"sharedLinkInput\"\n                        tabindex=\"0\">\n                        content_copy\n                    </mat-icon>\n                </mat-form-field>\n                <p class=\"adf-share-link__warn adf-share-link__para\" *ngIf=\"isLinkWithExpiryDate\">\n                    {{ 'SHARE.LINK-WITH-EXPIRY-SETTINGS' | translate }}\n                </p>\n                <div class=\"adf-share-link--row\">\n                    <mat-icon class=\"adf-share-link__icon\">public</mat-icon>\n                    <p\n                        class=\"adf-share-link__info adf-sharable-link adf-share-link__public-content adf-share-link__para\">\n                        {{ 'SHARE.PUBLIC-CONTENT' | translate }}\n                    </p>\n                </div>\n            </form>\n            <hr class=\"adf-share-link__separation-line\" />\n        </mat-dialog-content>\n        <div mat-dialog-actions>\n            <button data-automation-id=\"adf-share-dialog-close\" mat-button color=\"primary\" mat-dialog-close>\n                {{ 'SHARE.CLOSE' | translate }}\n            </button>\n        </div>\n    </div>\n</div>\n", styles: [".adf-float-label{padding-top:20px}.adf-share-link-dialog .adf-share-link__dialog-content{display:flex;flex-direction:column;padding:24px;background-color:var(--theme-grey-text-background-color)}.adf-share-link-dialog .adf-share-link__dialog-container{background-color:var(--theme-card-background-color);border-radius:16px;padding:16px 24px}.adf-share-link-dialog .adf-share-link__label,.adf-share-link-dialog .adf-share-link__title,.adf-share-link-dialog .adf-share-link__info{letter-spacing:-.4px;line-height:2;font-weight:400;font-style:normal;font-stretch:normal;font-size:var(--theme-body-1-font-size);color:var(--adf-theme-foreground-text-color-087)}.adf-share-link-dialog .adf-share-link__label{flex:1 1 auto}.adf-share-link-dialog .adf-share-link__form{padding-top:8px}.adf-share-link-dialog .adf-share-link__public-content{color:var(--adf-theme-foreground-text-color-054);font-size:var(--theme-caption-font-size)}.adf-share-link-dialog .adf-share-link__warn{color:var(--theme-warn-color);font-size:var(--theme-caption-font-size)}.adf-share-link-dialog .adf-share-link--row{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin:8px 0}.adf-share-link-dialog .adf-share-link__input{color:var(--adf-theme-foreground-text-color-087)}.adf-share-link-dialog .adf-share-link__separation-line{border:1px solid var(--theme-grey-background-color);margin:8px -24px}.adf-share-link-dialog .adf-share-link__close{cursor:pointer;margin-left:12px}.adf-share-link-dialog .adf-share-link__icon{color:var(--adf-theme-foreground-icon-color-054)}.adf-share-link-dialog .adf-share-link__para{margin-top:8px;margin-bottom:8px}.adf-share-link-dialog .adf-share-link__heading{font-weight:700;font-size:var(--theme-subheading-2-font-size)}.adf-share-link-dialog .adf-share-link__calender-icon{font-size:18px}.adf-share-link-dialog .adf-share-link__date-time-container{padding-bottom:8px}.adf-share-link-dialog .adf-share-link__border-color{border:1px solid var(--theme-warn-color)}.adf-share-link-dialog .adf-input-action{cursor:pointer}.adf-share-link-dialog .adf-full-width{width:100%;background-color:var(--theme-grey-text-background-color);border-radius:6px;padding-top:8px}.adf-share-link-dialog .adf-sharable-link{margin-left:8px}.adf-share-link-dialog .mat-form-field-infix{border-top:unset}.adf-share-link-dialog .mat-dialog-actions{justify-content:flex-end;padding:0;margin:8px 0 0}.adf-share-link-dialog .mat-dialog-actions>button{color:var(--adf-theme-foreground-base-color);background-color:var(--theme-grey-text-background-color);margin-right:12px}.adf-share-link-dialog .mat-form-field-flex{align-items:center}.adf-share-link-dialog .mat-dialog-container{padding:0}.adf-share-link-dialog .mat-form-field-appearance-legacy .mat-form-field-underline{display:none}.adf-share-link-dialog .mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:8px;margin-right:8px;margin-left:8px}@media screen and (max-width: 380px){.adf-share-link-dialog .mat-dialog-container{padding:0 15px}.adf-share-link-dialog .mat-dialog-actions{margin-bottom:0;padding:2px 0}.adf-share-link-dialog .mat-form-field-suffix{padding-left:8px}}\n"] }]
        }], ctorParameters: function () { return [{ type: SharedLinksApiService }, { type: i1$1.MatDialogRef }, { type: i1$1.MatDialog }, { type: ContentService }, { type: RenditionService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { slideToggleExpirationDate: [{
                type: ViewChild,
                args: ['slideToggleExpirationDate', { static: true }]
            }], datePickerInput: [{
                type: ViewChild,
                args: ['datePickerInput', { static: true }]
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeSharedDirective {
    constructor(dialog, zone, alfrescoApiService) {
        this.dialog = dialog;
        this.zone = zone;
        this.alfrescoApiService = alfrescoApiService;
        this.isFile = false;
        this.isShared = false;
        this.onDestroy$ = new Subject();
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.alfrescoApiService.getInstance());
        return this._nodesApi;
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    shareNode(nodeEntry) {
        if (nodeEntry && nodeEntry.entry && nodeEntry.entry.isFile) {
            // shared and favorite
            const nodeId = nodeEntry.entry['nodeId'] || nodeEntry.entry['guid'];
            if (nodeId) {
                this.getNodeInfo(nodeId).subscribe((node) => {
                    this.openShareLinkDialog(node);
                });
            }
            else {
                this.openShareLinkDialog(nodeEntry);
            }
        }
    }
    getNodeInfo(nodeId) {
        const options = {
            include: ['allowableOperations']
        };
        return from(this.nodesApi.getNode(nodeId, options));
    }
    openShareLinkDialog(node) {
        this.dialog.open(ShareDialogComponent, {
            width: '600px',
            panelClass: 'adf-share-link-dialog',
            data: {
                node,
                baseShareUrl: this.baseShareUrl
            }
        });
    }
    ngOnChanges() {
        this.zone.onStable
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
            if (this.node && this.node.entry) {
                this.isFile = this.node.entry.isFile;
                this.isShared = this.node.entry.properties ? this.node.entry.properties['qshare:sharedId'] : false;
            }
        });
    }
    onClick() {
        if (this.node) {
            this.shareNode(this.node);
        }
    }
}
NodeSharedDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeSharedDirective, deps: [{ token: i1$1.MatDialog }, { token: i0.NgZone }, { token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Directive });
NodeSharedDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.3", type: NodeSharedDirective, selector: "[adf-share]", inputs: { node: ["adf-share", "node"], baseShareUrl: "baseShareUrl" }, host: { listeners: { "click": "onClick()" } }, exportAs: ["adfShare"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeSharedDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[adf-share]',
                    exportAs: 'adfShare'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i0.NgZone }, { type: i1.AlfrescoApiService }]; }, propDecorators: { node: [{
                type: Input,
                args: ['adf-share']
            }], baseShareUrl: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentNodeShareModule {
    static forRoot() {
        return {
            ngModule: ContentNodeShareModule
        };
    }
    static forChild() {
        return {
            ngModule: ContentNodeShareModule
        };
    }
}
ContentNodeShareModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeShareModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentNodeShareModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeShareModule, declarations: [ShareDialogComponent,
        NodeSharedDirective], imports: [CoreModule,
        CommonModule,
        MaterialModule], exports: [ShareDialogComponent,
        NodeSharedDirective] });
ContentNodeShareModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeShareModule, imports: [CoreModule,
        CommonModule,
        MaterialModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentNodeShareModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CoreModule,
                        CommonModule,
                        MaterialModule
                    ],
                    declarations: [
                        ShareDialogComponent,
                        NodeSharedDirective
                    ],
                    exports: [
                        ShareDialogComponent,
                        NodeSharedDirective
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeBaseNode {
    constructor(nodeEntry, level, expandable) {
        this.expandable = true;
        this.name = nodeEntry.entry.name;
        this.nodeId = nodeEntry.entry.id;
        this.level = level ? level : 0;
        this.expandable = expandable ? expandable : true;
        this.node = nodeEntry ? new NodeEntry(nodeEntry) : undefined;
    }
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeViewService {
    constructor(nodeApi) {
        this.nodeApi = nodeApi;
    }
    getTreeNodes(nodeId) {
        return this.nodeApi.getNodeChildren(nodeId)
            .pipe(map((nodePage) => nodePage.list.entries.filter((node) => node.entry.isFolder ? node : null)), map((nodes) => nodes.map((node) => new TreeBaseNode(node))));
    }
}
TreeViewService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewService, deps: [{ token: NodesApiService }], target: i0.ɵɵFactoryTarget.Injectable });
TreeViewService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: NodesApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeViewDataSource {
    constructor(treeControl, treeViewService) {
        this.treeControl = treeControl;
        this.treeViewService = treeViewService;
        this.dataChange = new BehaviorSubject([]);
        this.childrenSubscription = null;
        this.changeSubscription = null;
        this.dataChange.subscribe((treeNodes) => this.treeNodes = treeNodes);
    }
    get data() {
        return this.treeNodes;
    }
    set data(value) {
        this.treeControl.dataNodes = value;
        this.dataChange.next(value);
    }
    connect(collectionViewer) {
        this.changeSubscription = this.treeControl.expansionModel.changed.subscribe((change) => {
            if (change.added &&
                change.added.length > 0) {
                this.expandTreeNodes(change);
            }
            else if (change.removed) {
                this.reduceTreeNodes(change);
            }
        });
        return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
    }
    disconnect() {
        if (this.childrenSubscription) {
            this.childrenSubscription.unsubscribe();
        }
        if (this.changeSubscription) {
            this.changeSubscription.unsubscribe();
        }
    }
    expandTreeNodes(change) {
        change.added.forEach((node) => this.expandNode(node));
    }
    reduceTreeNodes(change) {
        change.removed.slice().reverse().forEach((node) => this.toggleNode(node));
    }
    expandNode(node) {
        this.childrenSubscription = this.treeViewService.getTreeNodes(node.nodeId)
            .subscribe((children) => {
            const index = this.data.indexOf(node);
            if (!children || index < 0) {
                node.expandable = false;
                return;
            }
            const nodes = children.map((actualNode) => {
                actualNode.level = node.level + 1;
                return actualNode;
            });
            this.data.splice(index + 1, 0, ...nodes);
            this.dataChange.next(this.data);
        });
    }
    toggleNode(node) {
        const index = this.data.indexOf(node);
        let count = 0;
        for (let i = index + 1; i < this.data.length
            && this.data[i].level > node.level; i++, count++) { }
        this.data.splice(index + 1, count);
        this.dataChange.next(this.data);
    }
}
TreeViewDataSource.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewDataSource, deps: [{ token: i1$6.FlatTreeControl }, { token: TreeViewService }], target: i0.ɵɵFactoryTarget.Injectable });
TreeViewDataSource.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewDataSource });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewDataSource, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$6.FlatTreeControl }, { type: TreeViewService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeViewComponent {
    constructor(treeViewService) {
        this.treeViewService = treeViewService;
        /** Emitted when a node in the tree view is clicked. */
        this.nodeClicked = new EventEmitter();
        /** Emitted when an invalid node id is given. */
        this.error = new EventEmitter();
        this.getLevel = (node) => node.level;
        this.isExpandable = (node) => node.expandable;
        this.hasChild = (_, nodeData) => nodeData.expandable;
        this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
        this.dataSource = new TreeViewDataSource(this.treeControl, this.treeViewService);
    }
    ngOnChanges(changes) {
        if (changes['nodeId'] && changes['nodeId'].currentValue &&
            changes['nodeId'].currentValue !== changes['nodeId'].previousValue) {
            this.loadTreeNode();
        }
        else {
            this.dataSource.data = [];
        }
    }
    onNodeClicked(node) {
        this.nodeClicked.emit(node);
    }
    loadTreeNode() {
        this.treeViewService.getTreeNodes(this.nodeId)
            .subscribe((treeNode) => {
            this.dataSource.data = treeNode;
        }, (error) => this.error.emit(error));
    }
}
TreeViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewComponent, deps: [{ token: TreeViewService }], target: i0.ɵɵFactoryTarget.Component });
TreeViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TreeViewComponent, selector: "adf-tree-view-list", inputs: { nodeId: "nodeId" }, outputs: { nodeClicked: "nodeClicked", error: "error" }, usesOnChanges: true, ngImport: i0, template: "<mat-tree class=\"adf-tree-view-main\" [dataSource]=\"dataSource\"\n          [treeControl]=\"treeControl\" *ngIf=\"nodeId; else missingNodeId\">\n    <mat-tree-node class=\"adf-tree-view-node\"\n        *matTreeNodeDef=\"let treeNode\" id=\"{{treeNode.name + '-tree-node'}}\"\n        matTreeNodePadding [matTreeNodePaddingIndent]=\"15\">\n        {{treeNode.name}}\n    </mat-tree-node>\n    <mat-tree-node class=\"adf-tree-view-node\"\n        id=\"{{treeNode.name + '-tree-child-node'}}\" *matTreeNodeDef=\"let treeNode; when: hasChild\"\n        matTreeNodePadding [matTreeNodePaddingIndent]=\"15\">\n        <button matTreeNodeToggle id=\"{{'button-'+treeNode.name}}\" (click)=\"onNodeClicked(treeNode.node)\"\n                mat-icon-button [attr.aria-label]=\"'ADF-TREE-VIEW.ACCESSIBILITY.ARIA_LABEL' | translate: {\n                    name:  treeNode.name\n                }\">\n            <mat-icon class=\"adf-tree-view-icon\">\n                {{treeControl.isExpanded(treeNode) ? 'folder_open' : 'folder'}}\n            </mat-icon>\n        </button>\n        <span class=\"adf-tree-view-label\" matTreeNodeToggle (click)=\"onNodeClicked(treeNode.node)\">{{treeNode.name}}</span>\n    </mat-tree-node>\n</mat-tree>\n<ng-template #missingNodeId>\n    <div id=\"adf-tree-view-missing-node\">\n        {{'ADF-TREE-VIEW.MISSING-ID' | translate}}\n    </div>\n</ng-template>\n", styles: [".adf-tree-view-icon{color:#d9e022}.adf-tree-view-node.mat-tree-node{min-height:40px;font-size:var(--theme-caption-font-size);align-items:baseline}.adf-tree-view-label{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i5$6.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { kind: "directive", type: i5$6.MatTreeNodePadding, selector: "[matTreeNodePadding]", inputs: ["matTreeNodePadding", "matTreeNodePaddingIndent"] }, { kind: "directive", type: i5$6.MatTreeNodeToggle, selector: "[matTreeNodeToggle]", inputs: ["matTreeNodeToggleRecursive"] }, { kind: "component", type: i5$6.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { kind: "directive", type: i5$6.MatTreeNode, selector: "mat-tree-node", inputs: ["role", "disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tree-view-list', template: "<mat-tree class=\"adf-tree-view-main\" [dataSource]=\"dataSource\"\n          [treeControl]=\"treeControl\" *ngIf=\"nodeId; else missingNodeId\">\n    <mat-tree-node class=\"adf-tree-view-node\"\n        *matTreeNodeDef=\"let treeNode\" id=\"{{treeNode.name + '-tree-node'}}\"\n        matTreeNodePadding [matTreeNodePaddingIndent]=\"15\">\n        {{treeNode.name}}\n    </mat-tree-node>\n    <mat-tree-node class=\"adf-tree-view-node\"\n        id=\"{{treeNode.name + '-tree-child-node'}}\" *matTreeNodeDef=\"let treeNode; when: hasChild\"\n        matTreeNodePadding [matTreeNodePaddingIndent]=\"15\">\n        <button matTreeNodeToggle id=\"{{'button-'+treeNode.name}}\" (click)=\"onNodeClicked(treeNode.node)\"\n                mat-icon-button [attr.aria-label]=\"'ADF-TREE-VIEW.ACCESSIBILITY.ARIA_LABEL' | translate: {\n                    name:  treeNode.name\n                }\">\n            <mat-icon class=\"adf-tree-view-icon\">\n                {{treeControl.isExpanded(treeNode) ? 'folder_open' : 'folder'}}\n            </mat-icon>\n        </button>\n        <span class=\"adf-tree-view-label\" matTreeNodeToggle (click)=\"onNodeClicked(treeNode.node)\">{{treeNode.name}}</span>\n    </mat-tree-node>\n</mat-tree>\n<ng-template #missingNodeId>\n    <div id=\"adf-tree-view-missing-node\">\n        {{'ADF-TREE-VIEW.MISSING-ID' | translate}}\n    </div>\n</ng-template>\n", styles: [".adf-tree-view-icon{color:#d9e022}.adf-tree-view-node.mat-tree-node{min-height:40px;font-size:var(--theme-caption-font-size);align-items:baseline}.adf-tree-view-label{cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: TreeViewService }]; }, propDecorators: { nodeId: [{
                type: Input
            }], nodeClicked: [{
                type: Output
            }], error: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeViewModule {
}
TreeViewModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TreeViewModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: TreeViewModule, declarations: [TreeViewComponent], imports: [CommonModule,
        MaterialModule,
        TranslateModule], exports: [TreeViewComponent] });
TreeViewModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewModule, imports: [CommonModule,
        MaterialModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        TranslateModule
                    ],
                    declarations: [
                        TreeViewComponent
                    ],
                    exports: [
                        TreeViewComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GroupService {
    constructor(alfrescoApiService) {
        this.alfrescoApiService = alfrescoApiService;
    }
    get groupsApi() {
        this._groupsApi = this._groupsApi ?? new GroupsApi(this.alfrescoApiService.getInstance());
        return this._groupsApi;
    }
    async listAllGroupMembershipsForPerson(personId, opts, accumulator = []) {
        const groupsPaginated = await this.groupsApi.listGroupMembershipsForPerson(personId, opts);
        accumulator = [...accumulator, ...groupsPaginated.list.entries];
        if (groupsPaginated.list.pagination.hasMoreItems) {
            const skip = groupsPaginated.list.pagination.skipCount + groupsPaginated.list.pagination.count;
            return this.listAllGroupMembershipsForPerson(personId, {
                maxItems: opts.maxItems,
                skipCount: skip
            }, accumulator);
        }
        else {
            return accumulator;
        }
    }
}
GroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: GroupService, deps: [{ token: i1.AlfrescoApiService }], target: i0.ɵɵFactoryTarget.Injectable });
GroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: GroupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: GroupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AspectListModule {
}
AspectListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AspectListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AspectListModule, declarations: [AspectListComponent,
        AspectListDialogComponent], imports: [CommonModule,
        MatTableModule,
        MatExpansionModule,
        MatCheckboxModule,
        PipeModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        ContentDirectiveModule], exports: [AspectListComponent,
        AspectListDialogComponent] });
AspectListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListModule, imports: [CommonModule,
        MatTableModule,
        MatExpansionModule,
        MatCheckboxModule,
        PipeModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        ContentDirectiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AspectListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatTableModule,
                        MatExpansionModule,
                        MatCheckboxModule,
                        PipeModule,
                        TranslateModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatTooltipModule,
                        MatProgressSpinnerModule,
                        ContentDirectiveModule
                    ],
                    exports: [
                        AspectListComponent,
                        AspectListDialogComponent
                    ],
                    declarations: [
                        AspectListComponent,
                        AspectListDialogComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentTypeModule {
}
ContentTypeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentTypeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeModule, declarations: [ContentTypeDialogComponent], imports: [CommonModule,
        MatTableModule,
        MatExpansionModule,
        MatCheckboxModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule], exports: [ContentTypeDialogComponent] });
ContentTypeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeModule, imports: [CommonModule,
        MatTableModule,
        MatExpansionModule,
        MatCheckboxModule,
        TranslateModule,
        MatDialogModule,
        MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentTypeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatTableModule,
                        MatExpansionModule,
                        MatCheckboxModule,
                        TranslateModule,
                        MatDialogModule,
                        MatButtonModule
                    ],
                    exports: [
                        ContentTypeDialogComponent
                    ],
                    declarations: [
                        ContentTypeDialogComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeCommentsService {
    constructor(apiService, logService, contentService) {
        this.apiService = apiService;
        this.logService = logService;
        this.contentService = contentService;
    }
    get commentsApi() {
        this._commentsApi = this._commentsApi ?? new CommentsApi(this.apiService.getInstance());
        return this._commentsApi;
    }
    /**
     * Gets all comments that have been added to a task.
     *
     * @param id ID of the target task
     * @returns Details for each comment
     */
    get(id) {
        return from(this.commentsApi.listComments(id))
            .pipe(map((response) => {
            const comments = [];
            response.list.entries.forEach((comment) => {
                this.addToComments(comments, comment);
            });
            return comments;
        }), catchError((err) => this.handleError(err)));
    }
    /**
     * Adds a comment to a task.
     *
     * @param id ID of the target task
     * @param message Text for the comment
     * @returns Details about the comment
     */
    add(id, message) {
        return from(this.commentsApi.createComment(id, { content: message }))
            .pipe(map((response) => this.newCommentModel(response.entry)), catchError((err) => this.handleError(err)));
    }
    addToComments(comments, comment) {
        const newComment = comment.entry;
        comments.push(this.newCommentModel(newComment));
    }
    newCommentModel(comment) {
        return new CommentModel({
            id: comment.id,
            message: comment.content,
            created: comment.createdAt,
            createdBy: comment.createdBy
        });
    }
    handleError(error) {
        this.logService.error(error);
        return throwError(error || 'Server error');
    }
    getUserImage(avatarId) {
        return this.contentService.getContentUrl(avatarId);
    }
}
NodeCommentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.LogService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Injectable });
NodeCommentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.LogService }, { type: ContentService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeCommentsComponent {
}
NodeCommentsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NodeCommentsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NodeCommentsComponent, selector: "adf-node-comments", inputs: { nodeId: "nodeId", readOnly: "readOnly" }, providers: [{
            provide: ADF_COMMENTS_SERVICE,
            useClass: NodeCommentsService
        }], ngImport: i0, template: "<adf-comments \n    [readOnly]=\"readOnly\"\n    [id]=\"nodeId\"\n>\n</adf-comments>", dependencies: [{ kind: "component", type: i1.CommentsComponent, selector: "adf-comments", inputs: ["id", "readOnly"], outputs: ["error"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-node-comments', encapsulation: ViewEncapsulation.None, providers: [{
                            provide: ADF_COMMENTS_SERVICE,
                            useClass: NodeCommentsService
                        }], template: "<adf-comments \n    [readOnly]=\"readOnly\"\n    [id]=\"nodeId\"\n>\n</adf-comments>" }]
        }], propDecorators: { nodeId: [{
                type: Input
            }], readOnly: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NodeCommentsModule {
}
NodeCommentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NodeCommentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsModule, declarations: [NodeCommentsComponent], imports: [CommonModule, CoreModule], exports: [NodeCommentsComponent] });
NodeCommentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsModule, imports: [CommonModule, CoreModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NodeCommentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CoreModule],
                    declarations: [NodeCommentsComponent],
                    exports: [NodeCommentsComponent]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line no-shadow
var NewVersionUploaderDataAction;
(function (NewVersionUploaderDataAction) {
    NewVersionUploaderDataAction["refresh"] = "refresh";
    NewVersionUploaderDataAction["upload"] = "upload";
    NewVersionUploaderDataAction["view"] = "view";
})(NewVersionUploaderDataAction || (NewVersionUploaderDataAction = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

class NewVersionUploaderDialogComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        /** Emitted when an action is done. */
        this.dialogAction = new EventEmitter();
        /** Emitted when an error occurs. */
        this.uploadError = new EventEmitter();
    }
    ngOnInit() {
        this.setDialogTitle();
    }
    setDialogTitle() {
        if (!this.data.title) {
            this.title = this.data.showVersionsOnly ? 'ADF-NEW-VERSION-UPLOADER.DIALOG_LIST.TITLE' : 'ADF-NEW-VERSION-UPLOADER.DIALOG_UPLOAD.TITLE';
        }
        else {
            this.title = this.data.title;
        }
    }
    handleUpload(newFileVersion) {
        this.dialogAction.emit({ action: NewVersionUploaderDataAction.upload, newVersion: newFileVersion, currentVersion: this.data.node });
        this.dialogRef.close();
    }
    handleCancel() {
        this.dialogRef.close();
    }
    onUploadError(error) {
        this.uploadError.emit(error);
    }
    onViewingVersion(versionId) {
        this.dialogAction.emit({ action: NewVersionUploaderDataAction.view, versionId });
    }
    refresh(node) {
        this.dialogAction.emit({ action: NewVersionUploaderDataAction.refresh, node });
    }
}
NewVersionUploaderDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
NewVersionUploaderDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: NewVersionUploaderDialogComponent, selector: "adf-new-version-uploader-dialog", outputs: { dialogAction: "dialogAction", uploadError: "uploadError" }, ngImport: i0, template: "<h1 mat-dialog-title>{{ title | translate }}</h1>\n<section mat-dialog-content *ngIf=\"!data.showVersionsOnly\">\n  <adf-version-comparison id=\"adf-version-comparison\" [newFileVersion]=\"data.file\" [node]=\"data.node\"></adf-version-comparison>\n  <adf-version-upload\n    id=\"adf-version-upload-button\"\n    [node]=\"data.node\"\n    [newFileVersion]=\"data.file\"\n    [currentVersion]=\"data.currentVersion\"\n    (success)=\"handleUpload($event)\"\n    (cancel)=\"handleCancel()\"\n    (error)=\"onUploadError($event)\"\n  >\n  </adf-version-upload>\n</section>\n<ng-container *ngIf=\"data.showVersionsOnly\">\n  <section mat-dialog-content>\n    <div class=\"adf-version-list-container\">\n      <div class=\"adf-version-list-table\">\n        <adf-version-list\n          [node]=\"data.node\"\n          [showComments]=\"'adf-version-manager.allowComments' | adfAppConfig: true\"\n          [allowDownload]=\"'adf-version-manager.allowDownload' | adfAppConfig: true\"\n          (deleted)=\"refresh($event)\"\n          (restored)=\"refresh($event)\"\n          (viewVersion)=\"onViewingVersion($event)\"\n        ></adf-version-list>\n      </div>\n    </div>\n  </section>\n  <div mat-dialog-actions>\n    <button mat-button color=\"primary\" [mat-dialog-close]=\"true\">{{ 'ADF-NEW-VERSION-UPLOADER.DIALOG_LIST.CLOSE' | translate }}</button>\n  </div>\n</ng-container>\n", styles: ["@charset \"UTF-8\";/*!\n * @license\n * Copyright \u00A9 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */.adf-new-version-uploader-dialog-list{height:400px}.adf-new-version-uploader-dialog-upload{height:500px}.adf-new-version-uploader-dialog .mat-dialog-title{flex:0 0 auto;font-size:20px;font-weight:600;font-style:normal;font-stretch:normal;line-height:1.6;margin:0;letter-spacing:-.5px;color:var(--adf-theme-foreground-text-color-087)}.adf-new-version-uploader-dialog .mat-dialog-content{flex:1 1 auto;position:relative;overflow-y:auto;max-height:100vh;overflow:hidden;padding:2px 26px}.adf-new-version-uploader-dialog .mat-dialog-actions{padding:8px 8px 24px;display:flex;justify-content:flex-end;color:var(--adf-theme-foreground-text-color-054)}.adf-new-version-uploader-dialog .mat-dialog-actions button{text-transform:uppercase;font-weight:400}.adf-new-version-uploader-dialog .mat-list-item-content{padding:0;margin:0 16px}.adf-new-version-uploader-dialog .adf-version-list-container .adf-version-list{height:250px;overflow:hidden;padding:0}.adf-new-version-uploader-dialog .adf-version-list-container .mat-list.adf-version-list{overflow:auto}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: VersionUploadComponent, selector: "adf-version-upload", inputs: ["node", "newFileVersion", "showUploadButton", "showCancelButton", "currentVersion"], outputs: ["success", "error", "cancel", "versionChanged", "commentChanged", "uploadStarted"] }, { kind: "component", type: VersionListComponent, selector: "adf-version-list", inputs: ["node", "showComments", "allowDownload", "allowViewVersions", "showActions"], outputs: ["restored", "deleted", "viewVersion"] }, { kind: "component", type: VersionComparisonComponent, selector: "adf-version-comparison", inputs: ["node", "newFileVersion"] }, { kind: "pipe", type: i1.AppConfigPipe, name: "adfAppConfig" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-new-version-uploader-dialog', encapsulation: ViewEncapsulation.None, template: "<h1 mat-dialog-title>{{ title | translate }}</h1>\n<section mat-dialog-content *ngIf=\"!data.showVersionsOnly\">\n  <adf-version-comparison id=\"adf-version-comparison\" [newFileVersion]=\"data.file\" [node]=\"data.node\"></adf-version-comparison>\n  <adf-version-upload\n    id=\"adf-version-upload-button\"\n    [node]=\"data.node\"\n    [newFileVersion]=\"data.file\"\n    [currentVersion]=\"data.currentVersion\"\n    (success)=\"handleUpload($event)\"\n    (cancel)=\"handleCancel()\"\n    (error)=\"onUploadError($event)\"\n  >\n  </adf-version-upload>\n</section>\n<ng-container *ngIf=\"data.showVersionsOnly\">\n  <section mat-dialog-content>\n    <div class=\"adf-version-list-container\">\n      <div class=\"adf-version-list-table\">\n        <adf-version-list\n          [node]=\"data.node\"\n          [showComments]=\"'adf-version-manager.allowComments' | adfAppConfig: true\"\n          [allowDownload]=\"'adf-version-manager.allowDownload' | adfAppConfig: true\"\n          (deleted)=\"refresh($event)\"\n          (restored)=\"refresh($event)\"\n          (viewVersion)=\"onViewingVersion($event)\"\n        ></adf-version-list>\n      </div>\n    </div>\n  </section>\n  <div mat-dialog-actions>\n    <button mat-button color=\"primary\" [mat-dialog-close]=\"true\">{{ 'ADF-NEW-VERSION-UPLOADER.DIALOG_LIST.CLOSE' | translate }}</button>\n  </div>\n</ng-container>\n", styles: ["@charset \"UTF-8\";/*!\n * @license\n * Copyright \u00A9 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */.adf-new-version-uploader-dialog-list{height:400px}.adf-new-version-uploader-dialog-upload{height:500px}.adf-new-version-uploader-dialog .mat-dialog-title{flex:0 0 auto;font-size:20px;font-weight:600;font-style:normal;font-stretch:normal;line-height:1.6;margin:0;letter-spacing:-.5px;color:var(--adf-theme-foreground-text-color-087)}.adf-new-version-uploader-dialog .mat-dialog-content{flex:1 1 auto;position:relative;overflow-y:auto;max-height:100vh;overflow:hidden;padding:2px 26px}.adf-new-version-uploader-dialog .mat-dialog-actions{padding:8px 8px 24px;display:flex;justify-content:flex-end;color:var(--adf-theme-foreground-text-color-054)}.adf-new-version-uploader-dialog .mat-dialog-actions button{text-transform:uppercase;font-weight:400}.adf-new-version-uploader-dialog .mat-list-item-content{padding:0;margin:0 16px}.adf-new-version-uploader-dialog .adf-version-list-container .adf-version-list{height:250px;overflow:hidden;padding:0}.adf-new-version-uploader-dialog .adf-version-list-container .mat-list.adf-version-list{overflow:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }]; }, propDecorators: { dialogAction: [{
                type: Output
            }], uploadError: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NewVersionUploaderModule {
}
NewVersionUploaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NewVersionUploaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderModule, declarations: [NewVersionUploaderDialogComponent], imports: [CommonModule,
        MaterialModule,
        CoreModule,
        UploadModule,
        FormsModule,
        VersionManagerModule], exports: [NewVersionUploaderDialogComponent,
        FormsModule] });
NewVersionUploaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderModule, imports: [CommonModule,
        MaterialModule,
        CoreModule,
        UploadModule,
        FormsModule,
        VersionManagerModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MaterialModule,
                        CoreModule,
                        UploadModule,
                        FormsModule,
                        VersionManagerModule
                    ],
                    declarations: [
                        NewVersionUploaderDialogComponent
                    ],
                    exports: [
                        NewVersionUploaderDialogComponent,
                        FormsModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NewVersionUploaderService {
    constructor(apiService, dialog, overlayContainer) {
        this.apiService = apiService;
        this.dialog = dialog;
        this.overlayContainer = overlayContainer;
    }
    get versionsApi() {
        this._versionsApi = this._versionsApi ?? new VersionsApi(this.apiService.getInstance());
        return this._versionsApi;
    }
    /**
     * Open a dialog NewVersionUploaderDialogComponent to display:
     * - a side by side comparison between the current target node (type, name, icon) and the new file that should update it's version
     * - the new version's minor/major changes and the optional comment of a node and the ability to upload a new file version
     * - if data.showVersionsOnly is set to true, displays the version history of a node, with the ability to restore, delete and view version of the current node
     *
     * @param data data to pass to MatDialog
     * @param config allow to override default MatDialogConfig
     * @param selectorAutoFocusedOnClose element's selector which should be autofocused after closing modal
     * @returns an Observable represents the triggered dialog action or an error in case of an error condition
     */
    openUploadNewVersionDialog(data, config, selectorAutoFocusedOnClose) {
        const { file, node, showVersionsOnly } = data;
        const showComments = true;
        const allowDownload = true;
        return new Observable((observer) => {
            this.versionsApi.listVersionHistory(node.id).then((versionPaging) => {
                const dialogRef = this.dialog.open(NewVersionUploaderDialogComponent, {
                    data: { file, node, currentVersion: versionPaging.list.entries[0].entry, showComments, allowDownload, showVersionsOnly },
                    panelClass: this.composePanelClass(showVersionsOnly),
                    width: '630px',
                    ...(config && Object.keys(config).length > 0 && config)
                });
                dialogRef.componentInstance.dialogAction.asObservable()
                    .subscribe((newVersionUploaderData) => {
                    observer.next(newVersionUploaderData);
                });
                dialogRef.componentInstance.uploadError.asObservable().subscribe(error => {
                    observer.error(error);
                });
                dialogRef.afterClosed().subscribe(() => {
                    this.overlayContainer.getContainerElement().setAttribute('role', 'region');
                    NewVersionUploaderService.focusOnClose(selectorAutoFocusedOnClose);
                });
                this.overlayContainer.getContainerElement().setAttribute('role', 'main');
            });
        });
    }
    composePanelClass(showVersionsOnly) {
        const dialogCssClass = 'adf-new-version-uploader-dialog';
        return [dialogCssClass, `${dialogCssClass}-${showVersionsOnly ? 'list' : 'upload'}`];
    }
    static focusOnClose(selectorAutoFocusedOnClose) {
        if (selectorAutoFocusedOnClose) {
            document.querySelector(selectorAutoFocusedOnClose).focus();
        }
    }
}
NewVersionUploaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderService, deps: [{ token: i1.AlfrescoApiService }, { token: i1$1.MatDialog }, { token: i5$5.OverlayContainer }], target: i0.ɵɵFactoryTarget.Injectable });
NewVersionUploaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: NewVersionUploaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1$1.MatDialog }, { type: i5$5.OverlayContainer }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class RestoreMessageModel {
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FavoritesApiService {
    constructor(apiService, preferences) {
        this.apiService = apiService;
        this.preferences = preferences;
    }
    get favoritesApi() {
        this._favoritesApi = this._favoritesApi ?? new FavoritesApi(this.apiService.getInstance());
        return this._favoritesApi;
    }
    static remapEntry({ entry }) {
        entry.properties = {
            'cm:title': entry.title,
            'cm:description': entry.description
        };
        return { entry };
    }
    remapFavoritesData(data = {}) {
        const pagination = (data?.list?.pagination || {});
        const entries = this
            .remapFavoriteEntries(data?.list?.entries || []);
        return {
            list: { entries, pagination }
        };
    }
    remapFavoriteEntries(entries) {
        return entries
            .map(({ entry: { target } }) => ({
            entry: target.file || target.folder
        }))
            .filter(({ entry }) => (!!entry))
            .map(FavoritesApiService.remapEntry);
    }
    /**
     * Gets the favorites for a user.
     *
     * @param personId ID of the user
     * @param options Options supported by JS-API
     * @returns List of favorites
     */
    getFavorites(personId, options) {
        const defaultOptions = {
            maxItems: this.preferences.paginationSize,
            skipCount: 0,
            where: '(EXISTS(target/file) OR EXISTS(target/folder))',
            include: ['properties', 'allowableOperations']
        };
        const queryOptions = Object.assign(defaultOptions, options);
        const promise = this.favoritesApi
            .listFavorites(personId, queryOptions)
            .then(this.remapFavoritesData);
        return from(promise).pipe(catchError((err) => of(err)));
    }
}
FavoritesApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FavoritesApiService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
FavoritesApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FavoritesApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: FavoritesApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class EcmCompanyModel {
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fakeEcmUser = {
    id: 'fake-id',
    firstName: 'fake-ecm-first-name',
    lastName: 'fake-ecm-last-name',
    description: 'i am a fake user for test',
    avatarId: 'fake-avatar-id',
    email: 'fakeEcm@ecmUser.com',
    skypeId: 'fake-skype-id',
    googleId: 'fake-googleId-id',
    instantMessageId: 'fake-instantMessageId-id',
    company: null,
    jobTitle: 'job-ecm-test',
    location: 'fake location',
    mobile: '000000000',
    telephone: '11111111',
    statusUpdatedAt: 'fake-date',
    userStatus: 'active',
    enabled: true,
    emailNotificationsEnabled: true
};
const fakeEcmAdminUser = {
    ...fakeEcmUser,
    capabilities: {
        isAdmin: true
    }
};
const fakeEcmUser2 = {
    id: 'another-fake-id',
    firstName: 'another-fake-first-name',
    lastName: 'another',
    displayName: 'admin.adf User',
    email: 'admin.adf@alfresco.com',
    company: null,
    enabled: true,
    emailNotificationsEnabled: true
};
const fakeEcmUserNoImage = {
    id: 'fake-id',
    firstName: 'fake-first-name',
    lastName: 'fake-last-name',
    description: 'i am a fake user for test',
    avatarId: null,
    email: 'fakeEcm@ecmUser.com',
    skypeId: 'fake-skype-id',
    googleId: 'fake-googleId-id',
    instantMessageId: 'fake-instantMessageId-id',
    company: null,
    jobTitle: null,
    location: 'fake location',
    mobile: '000000000',
    telephone: '11111111',
    statusUpdatedAt: 'fake-date',
    userStatus: 'active',
    enabled: true,
    emailNotificationsEnabled: true
};
const fakeEcmEditedUser = {
    id: 'fake-id',
    firstName: null,
    lastName: 'fake-last-name',
    description: 'i am a fake user for test',
    avatarId: 'fake-avatar-id',
    email: 'fakeEcm@ecmUser.com',
    skypeId: 'fake-skype-id',
    googleId: 'fake-googleId-id',
    instantMessageId: 'fake-instantMessageId-id',
    company: null,
    jobTitle: 'test job',
    location: 'fake location',
    mobile: '000000000',
    telephone: '11111111',
    statusUpdatedAt: 'fake-date',
    userStatus: 'active',
    enabled: true,
    emailNotificationsEnabled: true
};
const fakeEcmUserList = new PersonPaging({
    list: {
        pagination: {
            count: 2,
            hasMoreItems: false,
            totalItems: 2,
            skipCount: 0,
            maxItems: 100
        },
        entries: [
            {
                entry: fakeEcmUser
            },
            {
                entry: fakeEcmUser2
            }
        ]
    }
});
const createNewPersonMock = {
    id: 'fake-id',
    firstName: 'fake-ecm-first-name',
    lastName: 'fake-ecm-last-name',
    description: 'i am a fake user for test',
    password: 'fake-avatar-id',
    email: 'fakeEcm@ecmUser.com'
};
const getFakeUserWithContentAdminCapability = () => {
    const fakeEcmUserWithAdminCapabilities = {
        ...fakeEcmUser,
        capabilities: {
            isAdmin: true
        }
    };
    const mockPerson = new Person(fakeEcmUserWithAdminCapabilities);
    return { entry: mockPerson };
};
const getFakeUserWithContentUserCapability = () => {
    const fakeEcmUserWithAdminCapabilities = {
        ...fakeEcmUser,
        capabilities: {
            isAdmin: false
        }
    };
    const mockPerson = new Person(fakeEcmUserWithAdminCapabilities);
    return { entry: mockPerson };
};

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TreeNodeType;
(function (TreeNodeType) {
    TreeNodeType[TreeNodeType["RegularNode"] = 0] = "RegularNode";
    TreeNodeType[TreeNodeType["LoadMoreNode"] = 1] = "LoadMoreNode";
})(TreeNodeType || (TreeNodeType = {}));

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeService extends DataSource {
    constructor() {
        super();
        this.treeNodesSource = new BehaviorSubject([]);
        this.treeControl = new FlatTreeControl(node => node.level, node => node.hasChildren);
        this.treeNodes = [];
    }
    get treeNodes() {
        return this.treeControl.dataNodes;
    }
    set treeNodes(nodes) {
        this.treeControl.dataNodes = nodes;
        this.treeNodesSource.next(nodes);
    }
    /**
     * Expands node applying subnodes to it.
     *
     * @param nodeToExpand Node to be expanded
     * @param subNodes List of nodes that will be added as children of expanded node
     */
    expandNode(nodeToExpand, subNodes) {
        if (nodeToExpand != null && subNodes != null && nodeToExpand.hasChildren) {
            this.treeControl.expand(nodeToExpand);
            const index = this.treeNodes.indexOf(nodeToExpand);
            this.treeNodes.splice(index + 1, 0, ...subNodes);
            nodeToExpand.isLoading = false;
            this.treeNodesSource.next(this.treeNodes);
        }
    }
    /**
     * Collapses a node removing all children from it.
     *
     * @param nodeToCollapse Node to be collapsed
     */
    collapseNode(nodeToCollapse) {
        if (nodeToCollapse != null && nodeToCollapse.hasChildren) {
            this.treeControl.collapse(nodeToCollapse);
            const children = this.treeNodes.filter((node) => nodeToCollapse.id === node.parentId);
            children.forEach((child) => {
                this.collapseInnerNode(child);
            });
            this.treeNodesSource.next(this.treeNodes);
        }
    }
    /**
     * Append more child nodes to already expanded parent node
     *
     * @param nodeToAppend Expanded parent node
     * @param subNodes List of nodes that will be added as children of expanded node
     */
    appendNodes(nodeToAppend, subNodes) {
        if (nodeToAppend != null && subNodes != null) {
            const lastChild = this.treeNodes.filter((treeNode) => nodeToAppend.id === treeNode.parentId).pop();
            const index = this.treeNodes.indexOf(lastChild);
            const children = this.treeControl.getDescendants(lastChild).length;
            this.treeNodes.splice(index + children + 1, 0, ...subNodes);
            nodeToAppend.isLoading = false;
            this.treeNodesSource.next(this.treeNodes);
        }
    }
    /**
     * Removes provided node from the tree
     *
     * @param node Node to be removed
     */
    removeNode(node) {
        this.treeNodes.splice(this.treeNodes.indexOf(node), 1);
    }
    /**
     * Gets children of the node
     *
     * @param parentNode Parent node
     *
     * @returns children of parent node
     */
    getChildren(parentNode) {
        return this.treeNodes.filter((treeNode) => treeNode.parentId === parentNode.id);
    }
    /**
     * Checks if tree is empty
     *
     * @returns boolean
     */
    isEmpty() {
        return !this.treeNodes.length;
    }
    /**
     * Gets parent node of given node. If node with parentNodeId is not found it returns undefined.
     *
     * @param parentNodeId Id of a parent node to be found
     * @returns parent node or undefined when not found
     */
    getParentNode(parentNodeId) {
        return this.treeNodes.find((treeNode) => treeNode.id === parentNodeId);
    }
    connect() {
        return this.treeNodesSource.asObservable();
    }
    disconnect() { }
    collapseInnerNode(nodeToCollapse) {
        const index = this.treeNodes.indexOf(nodeToCollapse);
        this.treeNodes.splice(index, 1);
        if (nodeToCollapse.hasChildren) {
            this.treeNodes
                .filter((node) => nodeToCollapse.id === node.parentId)
                .forEach((child) => this.collapseInnerNode(child));
        }
    }
}
TreeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TreeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeComponent {
    constructor(treeService, userPreferenceService) {
        this.treeService = treeService;
        this.userPreferenceService = userPreferenceService;
        /** Variable defining if tree header should be sticky. By default set to false */
        this.stickyHeader = false;
        /** Variable defining if tree nodes should be selectable. By default set to false */
        this.selectableNodes = false;
        /** Icon shown when node has children and is collapsed. By default set to chevron_right */
        this.expandIcon = 'chevron_right';
        /** Icon shown when node is expanded. By default set to expand_more */
        this.collapseIcon = 'expand_more';
        /** Emitted when pagination has been changed */
        this.paginationChanged = new EventEmitter();
        /** Emitted when any context menu option is selected */
        this.contextMenuOptionSelected = new EventEmitter();
        this.loadingRootSource = new BehaviorSubject(false);
        this.contextMenuOptionsChanged$ = new Subject();
        this.treeNodesSelection = new SelectionModel(true, [], true, (node1, node2) => node1.id === node2.id);
    }
    set contextMenuSource(contextMenuSource) {
        this._contextMenuSource = contextMenuSource;
    }
    /** Array of context menu options which should be displayed for each row. */
    set contextMenuOptions(contextMenuOptions) {
        this.contextMenuOptionsChanged$.next();
        if (contextMenuOptions) {
            this._contextMenuOptions = contextMenuOptions.map((option) => {
                if (!option.subject) {
                    option = {
                        ...option,
                        subject: new Subject()
                    };
                }
                return option;
            });
            merge(...this.contextMenuOptions.map((option) => option.subject)).pipe(takeUntil(this.contextMenuOptionsChanged$))
                .subscribe((option) => {
                this.contextMenuOptionSelected.emit({
                    row: this._contextMenuSource,
                    contextMenuOption: option
                });
            });
        }
        else {
            this._contextMenuOptions = contextMenuOptions;
        }
    }
    get contextMenuOptions() {
        return this._contextMenuOptions;
    }
    ngOnInit() {
        this.loadingRoot$ = this.loadingRootSource.asObservable();
        this.refreshTree(0, this.userPreferenceService.paginationSize);
        this.treeNodesSelection.changed.subscribe((selectionChange) => {
            this.onTreeSelectionChange(selectionChange);
        });
    }
    ngOnDestroy() {
        this.contextMenuOptionsChanged$.next();
        this.contextMenuOptionsChanged$.complete();
    }
    /**
     * Checks if node is LoadMoreNode node
     *
     * @param node node to be checked
     * @returns boolean
     */
    isLoadMoreNode(_, node) {
        return node.nodeType === TreeNodeType.LoadMoreNode;
    }
    /**
     * Checks if tree is empty
     *
     * @returns boolean
     */
    isEmpty() {
        return this.treeService.isEmpty();
    }
    /**
     * Returns action icon based on expanded/collapsed node state.
     *
     * @param node node to be checked
     * @returns collapse or expand icon
     */
    expandCollapseIconValue(node) {
        return this.treeService.treeControl.isExpanded(node) ? this.collapseIcon : this.expandIcon;
    }
    /**
     * Refreshes the tree, root nodes are reloaded, tree selection is cleared.
     *
     * @param skipCount Number of root nodes to skip.
     * @param maxItems Maximum number of nodes returned from Observable.
     * @param searchTerm Specifies if categories should be filtered out by name or not. If not specified then returns categories without filtering.
     */
    refreshTree(skipCount, maxItems, searchTerm) {
        this.loadingRootSource.next(true);
        this.treeNodesSelection.clear();
        this.treeService.getSubNodes('-root-', skipCount, maxItems, searchTerm).subscribe((response) => {
            this.treeService.treeNodes = response.entries;
            this.treeNodesSelection.deselect(...response.entries);
            this.paginationChanged.emit(response.pagination);
            this.loadingRootSource.next(false);
        });
    }
    /**
     * Collapses or expanding the node based on its current state
     *
     * @param node node to be collapsed/expanded
     */
    expandCollapseNode(node) {
        if (node.hasChildren && !node.isLoading) {
            if (this.treeService.treeControl.isExpanded(node)) {
                this.treeService.collapseNode(node);
            }
            else {
                node.isLoading = true;
                this.treeService.getSubNodes(node.id, 0, this.userPreferenceService.paginationSize).subscribe((response) => {
                    this.treeService.expandNode(node, response.entries);
                    node.isLoading = false;
                    if (this.treeNodesSelection.isSelected(node)) {
                        //timeout used to update nodeCheckboxes query list after new nodes are added so they can be selected
                        setTimeout(() => {
                            this.treeNodesSelection.select(...response.entries);
                        });
                    }
                });
            }
        }
    }
    /**
     * Loads more subnode for a given parent node
     *
     * @param node parent node
     */
    loadMoreSubnodes(node) {
        node.isLoading = true;
        const parentNode = this.treeService.getParentNode(node.parentId);
        this.treeService.removeNode(node);
        const loadedChildren = this.treeService.getChildren(parentNode).length;
        this.treeService.getSubNodes(parentNode.id, loadedChildren, this.userPreferenceService.paginationSize).subscribe((response) => {
            this.treeService.appendNodes(parentNode, response.entries);
            node.isLoading = false;
            if (this.treeNodesSelection.isSelected(parentNode)) {
                //timeout used to update nodeCheckboxes query list after new nodes are added so they can be selected
                setTimeout(() => {
                    this.treeNodesSelection.select(...response.entries);
                });
            }
        });
    }
    /**
     * When node is selected it selects all its descendants
     *
     * @param node selected node
     */
    onNodeSelected(node) {
        this.treeNodesSelection.toggle(node);
        const descendants = this.treeService.treeControl.getDescendants(node).filter(this.isRegularNode);
        if (descendants.length > 0) {
            this.treeNodesSelection.isSelected(node) ? this.treeNodesSelection.select(...descendants) : this.treeNodesSelection.deselect(...descendants);
        }
        this.checkParentsSelection(node);
    }
    /**
     * Checks if all descendants of a node are selected
     *
     * @param node selected node
     * @returns boolean
     */
    descendantsAllSelected(node) {
        const descendants = this.treeService.treeControl.getDescendants(node).filter(this.isRegularNode);
        return descendants.length > 0 && descendants.every((descendant) => this.treeNodesSelection.isSelected(descendant));
    }
    /**
     * Checks if some descendants of a node are selected
     *
     * @param node selected node
     * @returns boolean
     */
    descendantsPartiallySelected(node) {
        const descendants = this.treeService.treeControl.getDescendants(node).filter(this.isRegularNode);
        return descendants.length > 0 && !this.descendantsAllSelected(node) && descendants.some((descendant) => this.treeNodesSelection.isSelected(descendant));
    }
    checkParentsSelection(node) {
        let parent = this.treeService.getParentNode(node.parentId);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.treeService.getParentNode(parent.parentId);
        }
    }
    checkRootNodeSelection(node) {
        const nodeSelected = this.treeNodesSelection.isSelected(node);
        const descAllSelected = this.descendantsAllSelected(node);
        if (nodeSelected && !descAllSelected) {
            this.treeNodesSelection.deselect(node);
        }
        else if (!nodeSelected && descAllSelected) {
            this.treeNodesSelection.select(node);
        }
    }
    onTreeSelectionChange(selectionChange) {
        selectionChange.removed.forEach((unselectedNode) => {
            if (this.isRegularNode(unselectedNode)) {
                this.nodeCheckboxes.find((checkbox) => checkbox.id === unselectedNode.id).checked = false;
            }
        });
        selectionChange.added.forEach((selectedNode) => {
            if (this.isRegularNode(selectedNode)) {
                this.nodeCheckboxes.find((checkbox) => checkbox.id === selectedNode.id).checked = true;
            }
        });
    }
    isRegularNode(node) {
        return node.nodeType !== TreeNodeType.LoadMoreNode;
    }
}
TreeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeComponent, deps: [{ token: TreeService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
TreeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: TreeComponent, selector: "adf-tree", inputs: { emptyContentTemplate: "emptyContentTemplate", nodeActionsMenuTemplate: "nodeActionsMenuTemplate", stickyHeader: "stickyHeader", selectableNodes: "selectableNodes", displayName: "displayName", loadMoreSuffix: "loadMoreSuffix", expandIcon: "expandIcon", collapseIcon: "collapseIcon", contextMenuOptions: "contextMenuOptions" }, outputs: { paginationChanged: "paginationChanged", contextMenuOptionSelected: "contextMenuOptionSelected" }, host: { properties: { "class.adf-tree-sticky-header": "this.stickyHeader" }, classAttribute: "adf-tree" }, viewQueries: [{ propertyName: "nodeCheckboxes", predicate: MatCheckbox, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"(loadingRoot$ | async) === false; else loadingSpinner\">\n    <ng-container *ngIf=\"!this.isEmpty(); else emptyContent\">\n        <div class=\"adf-tree-row adf-tree-header\" *ngIf=\"displayName\">\n            <div class=\"adf-tree-cell adf-tree-cell-header\" data-automation-id=\"tree-header-display-name\">\n                <span class=\"adf-tree-cell-value\">\n                    {{ displayName | translate }}\n                </span>\n            </div>\n        </div>\n        <mat-tree\n            class=\"adf-tree-body\"\n            [dataSource]=\"treeService\"\n            [treeControl]=\"treeService.treeControl\">\n            <mat-tree-node\n                class=\"adf-tree-load-more-row\"\n                [attr.data-automation-id]=\"'loadMoreSubnodes_' + node.parentId\"\n                *matTreeNodeDef=\"let node when isLoadMoreNode\"\n                matTreeNodePadding>\n                <div class=\"adf-tree-expand-collapse-container\">\n                    <button class=\"adf-tree-load-more-button\" mat-icon-button>\n                        <mat-progress-spinner\n                            color=\"primary\"\n                            mode=\"indeterminate\"\n                            [diameter]=\"24\"\n                            *ngIf=\"node.isLoading; else loadMoreIcon\">\n                        </mat-progress-spinner>\n                        <ng-template #loadMoreIcon>\n                            <adf-icon\n                                [value]=\"'chevron_right'\"\n                                (click)=\"loadMoreSubnodes(node)\">\n                            </adf-icon>\n                        </ng-template>\n                    </button>\n                </div>\n                <div class=\"adf-tree-cell\">\n                    <span\n                        class=\"adf-tree-cell-value\"\n                        (click)=\"loadMoreSubnodes(node)\">\n                        {{ 'ADF-TREE.LOAD-MORE-BUTTON' | translate: { name: loadMoreSuffix } }}\n                    </span>\n                </div>\n            </mat-tree-node>\n            <mat-tree-node\n                class=\"adf-tree-row\"\n                [attr.data-automation-id]=\"'node_' + node.id\"\n                *matTreeNodeDef=\"let node\"\n                matTreeNodePadding\n                [adf-context-menu]=\"contextMenuOptions\"\n                [adf-context-menu-enabled]=\"!!contextMenuOptions\"\n                (contextmenu)=\"contextMenuSource = node\">\n                <div class=\"adf-tree-expand-collapse-container\">\n                    <button *ngIf=\"node.hasChildren\"\n                        class=\"adf-tree-expand-collapse-button\"\n                        mat-icon-button>\n                        <mat-progress-spinner\n                            color=\"primary\"\n                            mode=\"indeterminate\"\n                            [diameter]=\"24\"\n                            *ngIf=\"node.isLoading; else expandCollapseIcon\">\n                        </mat-progress-spinner>\n                        <ng-template #expandCollapseIcon>\n                            <adf-icon\n                                [value]=\"expandCollapseIconValue(node)\"\n                                (click)=\"expandCollapseNode(node)\">\n                            </adf-icon>\n                        </ng-template>\n                    </button>\n                </div>\n                <ng-container *ngIf=\"selectableNodes\">\n                    <mat-checkbox *ngIf=\"node.hasChildren; else noChildrenNodeCheckbox\"\n                        color=\"primary\"\n                        [id]=\"node.id\"\n                        [checked]=\"descendantsAllSelected(node)\"\n                        [indeterminate]=\"descendantsPartiallySelected(node)\"\n                        (change)=\"onNodeSelected(node)\">\n                    </mat-checkbox>\n                    <ng-template #noChildrenNodeCheckbox>\n                        <mat-checkbox\n                            color=\"primary\"\n                            [id]=\"node.id\"\n                            [checked]=\"treeNodesSelection.isSelected(node)\"\n                            (change)=\"onNodeSelected(node)\">\n                        </mat-checkbox>\n                    </ng-template>\n                </ng-container>\n                <div class=\"adf-tree-cell\">\n                    <span\n                        class=\"adf-tree-cell-value\"\n                        [class.adf-tree-clickable-cell-value]=\"node.hasChildren\"\n                        (click)=\"expandCollapseNode(node)\">\n                        {{ node.nodeName }}\n                    </span>\n                </div>\n                <div class=\"adf-tree-actions\">\n                    <button mat-icon-button\n                        [matMenuTriggerFor]=\"menu\"\n                        [attr.id]=\"'action_menu_right_' + node.id\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n                    <mat-menu #menu=\"matMenu\">\n                        <ng-template\n                            [ngTemplateOutlet]=\"nodeActionsMenuTemplate\"\n                            [ngTemplateOutletContext]=\"{ node: node }\">\n                    </ng-template>\n                    </mat-menu>\n                </div>\n            </mat-tree-node>\n        </mat-tree>\n    </ng-container>\n</ng-container>\n\n<ng-template #emptyContent>\n    <ng-template [ngTemplateOutlet]=\"emptyContentTemplate\">\n    </ng-template>\n</ng-template>\n\n<ng-template #loadingSpinner>\n    <div class=\"adf-tree-loading-spinner-container\">\n        <mat-progress-spinner\n            color=\"primary\"\n            mode=\"indeterminate\">\n        </mat-progress-spinner>\n    </div>\n</ng-template>\n", styles: [".adf-tree-sticky-header{display:flex;flex-direction:column;height:100%}.adf-tree-sticky-header mat-tree{overflow-y:scroll}.adf-tree-load-more-row .adf-tree-cell-value,.adf-tree-clickable-cell-value{cursor:pointer}.adf-tree-row,.adf-tree-load-more-row{transition:all .3s ease;display:flex;align-items:center;padding-left:15px;padding-right:15px;transition-property:background-color;border-bottom:1px solid var(--adf-theme-foreground-text-color-007);min-height:56px;-webkit-user-select:none;user-select:none}.adf-tree-row .adf-tree-expand-collapse-container,.adf-tree-load-more-row .adf-tree-expand-collapse-container{min-width:55px}.adf-tree-row:hover,.adf-tree-load-more-row:hover{background-color:var(--adf-theme-background-hover-color)}.adf-tree-row:hover .adf-tree-actions,.adf-tree-load-more-row:hover .adf-tree-actions{display:flex}.adf-tree-row:focus,.adf-tree-load-more-row:focus{background-color:var(--adf-theme-background-hover-color);outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-tree-row .adf-tree-expand-collapse-button,.adf-tree-row .adf-tree-load-more-button,.adf-tree-load-more-row .adf-tree-expand-collapse-button,.adf-tree-load-more-row .adf-tree-load-more-button{display:flex;align-items:center;justify-content:center;margin-left:15px}.adf-tree-row .adf-tree-cell,.adf-tree-load-more-row .adf-tree-cell{color:var(--adf-theme-foreground-text-color);width:100%}.adf-tree-row .adf-tree-cell .adf-tree-cell-value,.adf-tree-load-more-row .adf-tree-cell .adf-tree-cell-value{display:inline-block;padding:10px;word-break:break-word}.adf-tree-header{display:flex;width:-moz-fit-content;width:fit-content;min-width:100%;box-sizing:border-box}.adf-tree-header .adf-tree-cell-header{cursor:pointer;position:relative;vertical-align:bottom;text-overflow:ellipsis;font-weight:700;line-height:24px;letter-spacing:0;min-height:56px!important;font-size:12px;color:var(--adf-theme-foreground-text-color);box-sizing:border-box;padding-top:12px!important}.adf-tree-header .adf-tree-cell-header:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-tree-loading-spinner-container{width:100%;height:100%;display:flex;align-items:center;justify-content:center}\n"], dependencies: [{ kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i5$3.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i9.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: i6$2.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i6$2.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i1.ContextMenuDirective, selector: "[adf-context-menu]", inputs: ["adf-context-menu", "adf-context-menu-enabled"] }, { kind: "component", type: i1.IconComponent, selector: "adf-icon", inputs: ["color", "fontSet", "value"] }, { kind: "directive", type: i5$6.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { kind: "directive", type: i5$6.MatTreeNodePadding, selector: "[matTreeNodePadding]", inputs: ["matTreeNodePadding", "matTreeNodePaddingIndent"] }, { kind: "component", type: i5$6.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { kind: "directive", type: i5$6.MatTreeNode, selector: "mat-tree-node", inputs: ["role", "disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { kind: "pipe", type: i2$1.AsyncPipe, name: "async" }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-tree', host: { class: 'adf-tree' }, encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"(loadingRoot$ | async) === false; else loadingSpinner\">\n    <ng-container *ngIf=\"!this.isEmpty(); else emptyContent\">\n        <div class=\"adf-tree-row adf-tree-header\" *ngIf=\"displayName\">\n            <div class=\"adf-tree-cell adf-tree-cell-header\" data-automation-id=\"tree-header-display-name\">\n                <span class=\"adf-tree-cell-value\">\n                    {{ displayName | translate }}\n                </span>\n            </div>\n        </div>\n        <mat-tree\n            class=\"adf-tree-body\"\n            [dataSource]=\"treeService\"\n            [treeControl]=\"treeService.treeControl\">\n            <mat-tree-node\n                class=\"adf-tree-load-more-row\"\n                [attr.data-automation-id]=\"'loadMoreSubnodes_' + node.parentId\"\n                *matTreeNodeDef=\"let node when isLoadMoreNode\"\n                matTreeNodePadding>\n                <div class=\"adf-tree-expand-collapse-container\">\n                    <button class=\"adf-tree-load-more-button\" mat-icon-button>\n                        <mat-progress-spinner\n                            color=\"primary\"\n                            mode=\"indeterminate\"\n                            [diameter]=\"24\"\n                            *ngIf=\"node.isLoading; else loadMoreIcon\">\n                        </mat-progress-spinner>\n                        <ng-template #loadMoreIcon>\n                            <adf-icon\n                                [value]=\"'chevron_right'\"\n                                (click)=\"loadMoreSubnodes(node)\">\n                            </adf-icon>\n                        </ng-template>\n                    </button>\n                </div>\n                <div class=\"adf-tree-cell\">\n                    <span\n                        class=\"adf-tree-cell-value\"\n                        (click)=\"loadMoreSubnodes(node)\">\n                        {{ 'ADF-TREE.LOAD-MORE-BUTTON' | translate: { name: loadMoreSuffix } }}\n                    </span>\n                </div>\n            </mat-tree-node>\n            <mat-tree-node\n                class=\"adf-tree-row\"\n                [attr.data-automation-id]=\"'node_' + node.id\"\n                *matTreeNodeDef=\"let node\"\n                matTreeNodePadding\n                [adf-context-menu]=\"contextMenuOptions\"\n                [adf-context-menu-enabled]=\"!!contextMenuOptions\"\n                (contextmenu)=\"contextMenuSource = node\">\n                <div class=\"adf-tree-expand-collapse-container\">\n                    <button *ngIf=\"node.hasChildren\"\n                        class=\"adf-tree-expand-collapse-button\"\n                        mat-icon-button>\n                        <mat-progress-spinner\n                            color=\"primary\"\n                            mode=\"indeterminate\"\n                            [diameter]=\"24\"\n                            *ngIf=\"node.isLoading; else expandCollapseIcon\">\n                        </mat-progress-spinner>\n                        <ng-template #expandCollapseIcon>\n                            <adf-icon\n                                [value]=\"expandCollapseIconValue(node)\"\n                                (click)=\"expandCollapseNode(node)\">\n                            </adf-icon>\n                        </ng-template>\n                    </button>\n                </div>\n                <ng-container *ngIf=\"selectableNodes\">\n                    <mat-checkbox *ngIf=\"node.hasChildren; else noChildrenNodeCheckbox\"\n                        color=\"primary\"\n                        [id]=\"node.id\"\n                        [checked]=\"descendantsAllSelected(node)\"\n                        [indeterminate]=\"descendantsPartiallySelected(node)\"\n                        (change)=\"onNodeSelected(node)\">\n                    </mat-checkbox>\n                    <ng-template #noChildrenNodeCheckbox>\n                        <mat-checkbox\n                            color=\"primary\"\n                            [id]=\"node.id\"\n                            [checked]=\"treeNodesSelection.isSelected(node)\"\n                            (change)=\"onNodeSelected(node)\">\n                        </mat-checkbox>\n                    </ng-template>\n                </ng-container>\n                <div class=\"adf-tree-cell\">\n                    <span\n                        class=\"adf-tree-cell-value\"\n                        [class.adf-tree-clickable-cell-value]=\"node.hasChildren\"\n                        (click)=\"expandCollapseNode(node)\">\n                        {{ node.nodeName }}\n                    </span>\n                </div>\n                <div class=\"adf-tree-actions\">\n                    <button mat-icon-button\n                        [matMenuTriggerFor]=\"menu\"\n                        [attr.id]=\"'action_menu_right_' + node.id\">\n                        <mat-icon>more_vert</mat-icon>\n                    </button>\n                    <mat-menu #menu=\"matMenu\">\n                        <ng-template\n                            [ngTemplateOutlet]=\"nodeActionsMenuTemplate\"\n                            [ngTemplateOutletContext]=\"{ node: node }\">\n                    </ng-template>\n                    </mat-menu>\n                </div>\n            </mat-tree-node>\n        </mat-tree>\n    </ng-container>\n</ng-container>\n\n<ng-template #emptyContent>\n    <ng-template [ngTemplateOutlet]=\"emptyContentTemplate\">\n    </ng-template>\n</ng-template>\n\n<ng-template #loadingSpinner>\n    <div class=\"adf-tree-loading-spinner-container\">\n        <mat-progress-spinner\n            color=\"primary\"\n            mode=\"indeterminate\">\n        </mat-progress-spinner>\n    </div>\n</ng-template>\n", styles: [".adf-tree-sticky-header{display:flex;flex-direction:column;height:100%}.adf-tree-sticky-header mat-tree{overflow-y:scroll}.adf-tree-load-more-row .adf-tree-cell-value,.adf-tree-clickable-cell-value{cursor:pointer}.adf-tree-row,.adf-tree-load-more-row{transition:all .3s ease;display:flex;align-items:center;padding-left:15px;padding-right:15px;transition-property:background-color;border-bottom:1px solid var(--adf-theme-foreground-text-color-007);min-height:56px;-webkit-user-select:none;user-select:none}.adf-tree-row .adf-tree-expand-collapse-container,.adf-tree-load-more-row .adf-tree-expand-collapse-container{min-width:55px}.adf-tree-row:hover,.adf-tree-load-more-row:hover{background-color:var(--adf-theme-background-hover-color)}.adf-tree-row:hover .adf-tree-actions,.adf-tree-load-more-row:hover .adf-tree-actions{display:flex}.adf-tree-row:focus,.adf-tree-load-more-row:focus{background-color:var(--adf-theme-background-hover-color);outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-tree-row .adf-tree-expand-collapse-button,.adf-tree-row .adf-tree-load-more-button,.adf-tree-load-more-row .adf-tree-expand-collapse-button,.adf-tree-load-more-row .adf-tree-load-more-button{display:flex;align-items:center;justify-content:center;margin-left:15px}.adf-tree-row .adf-tree-cell,.adf-tree-load-more-row .adf-tree-cell{color:var(--adf-theme-foreground-text-color);width:100%}.adf-tree-row .adf-tree-cell .adf-tree-cell-value,.adf-tree-load-more-row .adf-tree-cell .adf-tree-cell-value{display:inline-block;padding:10px;word-break:break-word}.adf-tree-header{display:flex;width:-moz-fit-content;width:fit-content;min-width:100%;box-sizing:border-box}.adf-tree-header .adf-tree-cell-header{cursor:pointer;position:relative;vertical-align:bottom;text-overflow:ellipsis;font-weight:700;line-height:24px;letter-spacing:0;min-height:56px!important;font-size:12px;color:var(--adf-theme-foreground-text-color);box-sizing:border-box;padding-top:12px!important}.adf-tree-header .adf-tree-cell-header:focus{outline-offset:-1px;outline:1px solid var(--theme-accent-color-a200)}.adf-tree-loading-spinner-container{width:100%;height:100%;display:flex;align-items:center;justify-content:center}\n"] }]
        }], ctorParameters: function () { return [{ type: TreeService }, { type: i1.UserPreferencesService }]; }, propDecorators: { emptyContentTemplate: [{
                type: Input
            }], nodeActionsMenuTemplate: [{
                type: Input
            }], stickyHeader: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.adf-tree-sticky-header']
            }], selectableNodes: [{
                type: Input
            }], displayName: [{
                type: Input
            }], loadMoreSuffix: [{
                type: Input
            }], expandIcon: [{
                type: Input
            }], collapseIcon: [{
                type: Input
            }], paginationChanged: [{
                type: Output
            }], contextMenuOptionSelected: [{
                type: Output
            }], nodeCheckboxes: [{
                type: ViewChildren,
                args: [MatCheckbox]
            }], contextMenuOptions: [{
                type: Input
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class TreeModule {
}
TreeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TreeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: TreeModule, declarations: [TreeComponent], imports: [CommonModule,
        CoreModule,
        MaterialModule,
        TranslateModule,
        ContextMenuModule], exports: [TreeComponent] });
TreeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeModule, imports: [CommonModule,
        CoreModule,
        MaterialModule,
        TranslateModule,
        ContextMenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: TreeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoreModule,
                        MaterialModule,
                        TranslateModule,
                        ContextMenuModule
                    ],
                    declarations: [
                        TreeComponent
                    ],
                    exports: [
                        TreeComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CategoryTreeDatasourceService extends TreeService {
    constructor(categoryService) {
        super();
        this.categoryService = categoryService;
    }
    getSubNodes(parentNodeId, skipCount, maxItems, name) {
        return !name ? this.categoryService.getSubcategories(parentNodeId, skipCount, maxItems).pipe(map((response) => {
            const parentNode = this.getParentNode(parentNodeId);
            const nodesList = response.list.entries.map((entry) => ({
                id: entry.entry.id,
                nodeName: entry.entry.name,
                parentId: entry.entry.parentId,
                hasChildren: entry.entry.hasChildren,
                level: parentNode ? parentNode.level + 1 : 0,
                isLoading: false,
                nodeType: TreeNodeType.RegularNode
            }));
            if (response.list.pagination.hasMoreItems && parentNode) {
                const loadMoreNode = {
                    id: 'loadMore',
                    nodeName: '',
                    parentId: parentNode.id,
                    hasChildren: false,
                    level: parentNode.level + 1,
                    isLoading: false,
                    nodeType: TreeNodeType.LoadMoreNode
                };
                nodesList.push(loadMoreNode);
            }
            const treeResponse = { entries: nodesList, pagination: response.list.pagination };
            return treeResponse;
        })) : this.categoryService.searchCategories(name, skipCount, maxItems).pipe(mergeMap((pagingResult) => {
            const nextAfterGeneralPathPartIndex = 3;
            const pathSeparator = '/';
            return from(pagingResult.list.entries).pipe(mergeMap((category) => {
                const path = category.entry.path.name.split(pathSeparator).slice(nextAfterGeneralPathPartIndex)
                    .join(pathSeparator);
                return this.categoryService.getCategory(category.entry.id).pipe(map((res) => {
                    return {
                        id: category.entry.id,
                        nodeName: path ? `${path}/${category.entry.name}` : category.entry.name,
                        parentId: category.entry.parentId,
                        level: 0,
                        nodeType: TreeNodeType.RegularNode,
                        hasChildren: res.entry.hasChildren,
                        isLoading: false
                    };
                }));
            }), toArray(), map(res => ({ entries: res, pagination: pagingResult.list.pagination })));
        }));
    }
}
CategoryTreeDatasourceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoryTreeDatasourceService, deps: [{ token: CategoryService }], target: i0.ɵɵFactoryTarget.Injectable });
CategoryTreeDatasourceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoryTreeDatasourceService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: CategoryTreeDatasourceService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: CategoryService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AlfrescoViewerComponent {
    constructor(apiService, nodesApiService, renditionService, viewUtilService, logService, contentService, uploadService, dialog, cdr, nodeActionsService) {
        this.apiService = apiService;
        this.nodesApiService = nodesApiService;
        this.renditionService = renditionService;
        this.viewUtilService = viewUtilService;
        this.logService = logService;
        this.contentService = contentService;
        this.uploadService = uploadService;
        this.dialog = dialog;
        this.cdr = cdr;
        this.nodeActionsService = nodeActionsService;
        /** Node Id of the file to load. */
        this.nodeId = null;
        /** Version Id of the file to load. */
        this.versionId = null;
        /** Shared link id (to display shared file). */
        this.sharedLinkId = null;
        /** Hide or show the viewer */
        this.showViewer = true;
        /** Number of times the Viewer will retry fetching content Rendition.
         * There is a delay of at least one second between attempts.
         */
        this.maxRetries = 30;
        /** Allows `back` navigation */
        this.allowGoBack = true;
        /** Hide or show the toolbar */
        this.showToolbar = true;
        /** If `true` then show the Viewer as a full page over the current content.
         * Otherwise fit inside the parent div.
         */
        this.overlayMode = false;
        /** Toggles before/next navigation. You can use the arrow buttons to navigate
         * between documents in the collection.
         */
        this.allowNavigate = false;
        /** Toggles the "before" ("<") button. Requires `allowNavigate` to be enabled. */
        this.canNavigateBefore = true;
        /** Toggles the next (">") button. Requires `allowNavigate` to be enabled. */
        this.canNavigateNext = true;
        /** Allow the left the sidebar. */
        this.allowLeftSidebar = false;
        /** Allow the right sidebar. */
        this.allowRightSidebar = false;
        /** Toggles right sidebar visibility. Requires `allowRightSidebar` to be set to `true`. */
        this.showRightSidebar = false;
        /** Toggles left sidebar visibility. Requires `allowLeftSidebar` to be set to `true`. */
        this.showLeftSidebar = false;
        /** Toggles downloading. */
        this.allowDownload = true;
        /** Toggles printing. */
        this.allowPrint = false;
        /** Toggles the 'Full Screen' feature. */
        this.allowFullScreen = true;
        /** The template for the right sidebar. The template context contains the loaded node data. */
        this.sidebarRightTemplate = null;
        /** The template for the left sidebar. The template context contains the loaded node data. */
        this.sidebarLeftTemplate = null;
        /** Emitted when the shared link used is not valid. */
        this.invalidSharedLink = new EventEmitter();
        /** Emitted when user clicks 'Navigate Before' ("<") button. */
        this.navigateBefore = new EventEmitter();
        /** Emitted when user clicks 'Navigate Next' (">") button. */
        this.navigateNext = new EventEmitter();
        /** Emitted when the viewer close */
        this.showViewerChange = new EventEmitter();
        this.onDestroy$ = new Subject();
        this.tracks = [];
        this.readOnly = true;
        this.sidebarRightTemplateContext = { node: null };
        this.sidebarLeftTemplateContext = { node: null };
        renditionService.maxRetries = this.maxRetries;
    }
    get sharedLinksApi() {
        this._sharedLinksApi = this._sharedLinksApi ?? new SharedlinksApi(this.apiService.getInstance());
        return this._sharedLinksApi;
    }
    get versionsApi() {
        this._versionsApi = this._versionsApi ?? new VersionsApi(this.apiService.getInstance());
        return this._versionsApi;
    }
    get nodesApi() {
        this._nodesApi = this._nodesApi ?? new NodesApi(this.apiService.getInstance());
        return this._nodesApi;
    }
    get contentApi() {
        this._contentApi = this._contentApi ?? new ContentApi(this.apiService.getInstance());
        return this._contentApi;
    }
    ngOnInit() {
        this.nodesApiService.nodeUpdated.pipe(filter((node) => node && node.id === this.nodeId &&
            (node.name !== this.fileName ||
                this.getNodeVersionProperty(this.nodeEntry.entry) !== this.getNodeVersionProperty(node))), takeUntil(this.onDestroy$)).subscribe((node) => this.onNodeUpdated(node));
    }
    async onNodeUpdated(node) {
        if (node && node.id === this.nodeId) {
            this.generateCacheBusterNumber();
            await this.setUpNodeFile(node);
        }
    }
    getNodeVersionProperty(node) {
        return node?.properties['cm:versionLabel'] ?? '';
    }
    async setupSharedLink() {
        this.allowGoBack = false;
        try {
            const sharedLinkEntry = await this.sharedLinksApi.getSharedLink(this.sharedLinkId);
            await this.setUpSharedLinkFile(sharedLinkEntry);
        }
        catch (error) {
            this.logService.error('This sharedLink does not exist');
            this.invalidSharedLink.next();
            this.mimeType = 'invalid-link';
            this.urlFileContent = 'invalid-file';
        }
    }
    async setupNode() {
        try {
            this.nodeEntry = await this.nodesApi.getNode(this.nodeId, { include: ['allowableOperations'] });
            if (this.versionId) {
                this.versionEntry = await this.versionsApi.getVersion(this.nodeId, this.versionId);
                await this.setUpNodeFile(this.nodeEntry.entry, this.versionEntry.entry);
            }
            else {
                await this.setUpNodeFile(this.nodeEntry.entry);
                this.cdr.detectChanges();
            }
        }
        catch (error) {
            this.urlFileContent = 'invalid-node';
            this.logService.error('This node does not exist');
        }
    }
    async setUpNodeFile(nodeData, versionData) {
        this.readOnly = !this.contentService.hasAllowableOperations(nodeData, 'update');
        let mimeType;
        let urlFileContent;
        if (versionData && versionData.content) {
            mimeType = versionData.content.mimeType;
        }
        else if (nodeData.content) {
            mimeType = nodeData.content.mimeType;
        }
        const currentFileVersion = this.nodeEntry?.entry?.properties && this.nodeEntry.entry.properties['cm:versionLabel'] ?
            encodeURI(this.nodeEntry?.entry?.properties['cm:versionLabel']) : encodeURI('1.0');
        urlFileContent = versionData ? this.contentApi.getVersionContentUrl(this.nodeId, versionData.id) :
            this.contentApi.getContentUrl(this.nodeId);
        urlFileContent = this.cacheBusterNumber ? urlFileContent + '&' + currentFileVersion + '&' + this.cacheBusterNumber :
            urlFileContent + '&' + currentFileVersion;
        const fileExtension = this.viewUtilService.getFileExtension(versionData ? versionData.name : nodeData.name);
        this.fileName = versionData ? versionData.name : nodeData.name;
        const viewerType = this.viewUtilService.getViewerType(fileExtension, mimeType);
        if (viewerType === 'unknown') {
            let nodeRendition;
            if (versionData) {
                nodeRendition = await this.renditionService.getNodeRendition(nodeData.id, versionData.id);
            }
            else {
                nodeRendition = await this.renditionService.getNodeRendition(nodeData.id);
            }
            if (nodeRendition) {
                urlFileContent = nodeRendition.url;
                mimeType = nodeRendition.mimeType;
            }
        }
        else if (viewerType === 'media') {
            this.tracks = await this.renditionService.generateMediaTracksRendition(this.nodeId);
        }
        this.mimeType = mimeType;
        this.urlFileContent = urlFileContent;
        this.sidebarRightTemplateContext.node = nodeData;
        this.sidebarLeftTemplateContext.node = nodeData;
    }
    async setUpSharedLinkFile(details) {
        let mimeType = details.entry.content.mimeType;
        const fileExtension = this.viewUtilService.getFileExtension(details.entry.name);
        this.fileName = details.entry.name;
        let urlFileContent = this.contentApi.getSharedLinkContentUrl(this.sharedLinkId, false);
        const viewerType = this.viewUtilService.getViewerType(fileExtension, mimeType);
        if (viewerType === 'unknown') {
            ({
                url: urlFileContent,
                mimeType
            } = await this.getSharedLinkRendition(this.sharedLinkId));
        }
        this.mimeType = mimeType;
        this.urlFileContent = urlFileContent;
    }
    async getSharedLinkRendition(sharedId) {
        try {
            const rendition = await this.sharedLinksApi.getSharedLinkRendition(sharedId, 'pdf');
            if (rendition.entry.status.toString() === 'CREATED') {
                const urlFileContent = this.contentApi.getSharedLinkRenditionUrl(sharedId, 'pdf');
                return { url: urlFileContent, mimeType: 'application/pdf' };
            }
        }
        catch (error) {
            this.logService.error(error);
            try {
                const rendition = await this.sharedLinksApi.getSharedLinkRendition(sharedId, 'imgpreview');
                if (rendition.entry.status.toString() === 'CREATED') {
                    const urlFileContent = this.contentApi.getSharedLinkRenditionUrl(sharedId, 'imgpreview');
                    return { url: urlFileContent, mimeType: 'image/png' };
                }
            }
            catch (renditionError) {
                this.logService.error(renditionError);
                return null;
            }
        }
        return null;
    }
    generateCacheBusterNumber() {
        this.cacheBusterNumber = Date.now();
    }
    /**
     * close the viewer
     */
    onClose() {
        this.showViewerChange.emit(this.showViewer);
    }
    onPrintContent(event) {
        if (this.allowPrint) {
            if (!event.defaultPrevented) {
                this.renditionService.printFileGeneric(this.nodeId, this.mimeType);
            }
        }
    }
    onSubmitFile(newImageBlob) {
        if (this?.nodeEntry?.entry?.id && !this.readOnly) {
            const newImageFile = new File([newImageBlob], this?.nodeEntry?.entry?.name, { type: this?.nodeEntry?.entry?.content?.mimeType });
            const newFile = new FileModel(newImageFile, {
                majorVersion: false,
                newVersion: true,
                parentId: this?.nodeEntry?.entry?.parentId,
                nodeType: this?.nodeEntry?.entry?.content?.mimeType
            }, this?.nodeEntry?.entry?.id);
            this.uploadService.addToQueue(...[newFile]);
            this.uploadService.uploadFilesInTheQueue();
        }
    }
    onNavigateBeforeClick(event) {
        this.navigateBefore.next(event);
    }
    onNavigateNextClick(event) {
        this.navigateNext.next(event);
    }
    isSourceDefined() {
        return !!(this.nodeId || this.sharedLinkId);
    }
    ngOnChanges() {
        if (this.showViewer) {
            if (!this.isSourceDefined()) {
                throw new Error('A content source attribute value is missing.');
            }
            if (this.nodeId) {
                this.setupNode();
            }
            else if (this.sharedLinkId) {
                this.setupSharedLink();
            }
        }
    }
    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }
    onDownloadFile() {
        this.nodeActionsService.downloadNode(this.nodeEntry);
    }
}
AlfrescoViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoViewerComponent, deps: [{ token: i1.AlfrescoApiService }, { token: NodesApiService }, { token: RenditionService }, { token: i1.ViewUtilService }, { token: i1.LogService }, { token: ContentService }, { token: UploadService }, { token: i1$1.MatDialog }, { token: i0.ChangeDetectorRef }, { token: NodeActionsService }], target: i0.ɵɵFactoryTarget.Component });
AlfrescoViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.3", type: AlfrescoViewerComponent, selector: "adf-alfresco-viewer", inputs: { nodeId: "nodeId", versionId: "versionId", sharedLinkId: "sharedLinkId", showViewer: "showViewer", maxRetries: "maxRetries", allowGoBack: "allowGoBack", showToolbar: "showToolbar", overlayMode: "overlayMode", allowNavigate: "allowNavigate", canNavigateBefore: "canNavigateBefore", canNavigateNext: "canNavigateNext", allowLeftSidebar: "allowLeftSidebar", allowRightSidebar: "allowRightSidebar", showRightSidebar: "showRightSidebar", showLeftSidebar: "showLeftSidebar", allowDownload: "allowDownload", allowPrint: "allowPrint", allowFullScreen: "allowFullScreen", sidebarRightTemplate: "sidebarRightTemplate", sidebarLeftTemplate: "sidebarLeftTemplate" }, outputs: { invalidSharedLink: "invalidSharedLink", navigateBefore: "navigateBefore", navigateNext: "navigateNext", showViewerChange: "showViewerChange" }, host: { classAttribute: "adf-alfresco-viewer" }, providers: [ViewUtilService], queries: [{ propertyName: "toolbar", first: true, predicate: ViewerToolbarComponent, descendants: true }, { propertyName: "sidebar", first: true, predicate: ViewerSidebarComponent, descendants: true }, { propertyName: "toolbarActions", first: true, predicate: ViewerToolbarActionsComponent, descendants: true }, { propertyName: "moreActions", first: true, predicate: ViewerMoreActionsComponent, descendants: true }, { propertyName: "openWith", first: true, predicate: ViewerOpenWithComponent, descendants: true }], viewQueries: [{ propertyName: "adfViewer", first: true, predicate: ["adfViewer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<adf-viewer\n    #adfViewer\n    [(showViewer)]=\"showViewer\"\n    [allowGoBack]=\"allowGoBack\"\n    [showToolbar]=\"showToolbar\"\n    [overlayMode]=\"overlayMode\"\n    [allowNavigate]=\"allowNavigate\"\n    [canNavigateBefore]=\"canNavigateBefore\"\n    [canNavigateNext]=\"canNavigateNext\"\n    [allowLeftSidebar]=\"allowLeftSidebar\"\n    [allowRightSidebar]=\"allowRightSidebar\"\n    [showRightSidebar]=\"showRightSidebar\"\n    [showLeftSidebar]=\"showLeftSidebar\"\n    [allowFullScreen]=\"allowFullScreen\"\n    [sidebarRightTemplate]=\"sidebarRightTemplate\"\n    [sidebarLeftTemplate]=\"sidebarLeftTemplate\"\n    [sidebarRightTemplateContext]=\"sidebarRightTemplateContext\"\n    [sidebarLeftTemplateContext]=\"sidebarLeftTemplateContext\"\n    [fileName]=\"fileName\"\n    [mimeType]=\"mimeType\"\n    [urlFile]=\"urlFileContent\"\n    [tracks]=\"tracks\"\n    [readOnly]=\"readOnly\"\n    (downloadFile)=\"onDownloadFile()\"\n    (navigateBefore)=\"onNavigateBeforeClick($event)\"\n    (navigateNext)=\"onNavigateNextClick($event)\"\n    (showViewerChange)=\"onClose()\"\n    (submitFile)=\"onSubmitFile($event)\">\n\n    <adf-viewer-toolbar *ngIf=\"toolbar\">\n        <ng-content select=\"adf-viewer-toolbar\"></ng-content>\n    </adf-viewer-toolbar>\n\n    <adf-viewer-toolbar-actions *ngIf=\"toolbarActions\">\n        <ng-content select=\"adf-viewer-toolbar-actions\"></ng-content>\n    </adf-viewer-toolbar-actions>\n\n    <adf-viewer-more-actions *ngIf=\"moreActions\">\n        <ng-content select=\"adf-viewer-more-actions\"></ng-content>\n    </adf-viewer-more-actions>\n\n    <adf-viewer-open-with *ngIf=\"openWith\">\n        <ng-content select=\"adf-viewer-open-with\"></ng-content>\n    </adf-viewer-open-with>\n\n    <adf-viewer-sidebar *ngIf=\"sidebar\">\n        <ng-content select=\"adf-viewer-sidebar\"></ng-content>\n    </adf-viewer-sidebar>\n\n    <adf-viewer-toolbar-custom-actions>\n        <button id=\"adf-alfresco-viewer-download\"\n                *ngIf=\"allowDownload\"\n                mat-icon-button\n                [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate\"\n                title=\"{{ 'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate }}\"\n                data-automation-id=\"adf-toolbar-download\"\n                [adfNodeDownload]=\"nodeEntry\"\n                [version]=\"versionEntry\">\n            <mat-icon>file_download</mat-icon>\n        </button>\n\n        <button id=\"adf-alfresco-viewer-print\"\n                *ngIf=\"allowPrint\"\n                mat-icon-button\n                [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.PRINT' | translate\"\n                title=\"{{ 'ADF_VIEWER.ACTIONS.PRINT' | translate }}\"\n                data-automation-id=\"adf-toolbar-print\"\n                (click)=\"onPrintContent($event)\">\n            <mat-icon>print</mat-icon>\n        </button>\n    </adf-viewer-toolbar-custom-actions>\n</adf-viewer>\n", styles: [""], dependencies: [{ kind: "component", type: i1.ViewerToolbarComponent, selector: "adf-viewer-toolbar" }, { kind: "component", type: i1.ViewerSidebarComponent, selector: "adf-viewer-sidebar" }, { kind: "component", type: i1.ViewerOpenWithComponent, selector: "adf-viewer-open-with" }, { kind: "component", type: i1.ViewerMoreActionsComponent, selector: "adf-viewer-more-actions" }, { kind: "component", type: i1.ViewerToolbarActionsComponent, selector: "adf-viewer-toolbar-actions" }, { kind: "component", type: i1.ViewerComponent, selector: "adf-viewer", inputs: ["urlFile", "blobFile", "fileName", "showViewer", "allowGoBack", "allowFullScreen", "showToolbar", "overlayMode", "allowNavigate", "canNavigateBefore", "canNavigateNext", "allowLeftSidebar", "allowRightSidebar", "showRightSidebar", "showLeftSidebar", "sidebarRightTemplate", "sidebarLeftTemplate", "readOnly", "tracks", "mimeType", "sidebarRightTemplateContext", "sidebarLeftTemplateContext"], outputs: ["downloadFile", "navigateBefore", "navigateNext", "showViewerChange", "submitFile"] }, { kind: "component", type: i1.ViewerToolbarCustomActionsComponent, selector: "adf-viewer-toolbar-custom-actions" }, { kind: "directive", type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: NodeDownloadDirective, selector: "[adfNodeDownload]", inputs: ["adfNodeDownload", "version"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'adf-alfresco-viewer', host: { class: 'adf-alfresco-viewer' }, encapsulation: ViewEncapsulation.None, providers: [ViewUtilService], template: "<adf-viewer\n    #adfViewer\n    [(showViewer)]=\"showViewer\"\n    [allowGoBack]=\"allowGoBack\"\n    [showToolbar]=\"showToolbar\"\n    [overlayMode]=\"overlayMode\"\n    [allowNavigate]=\"allowNavigate\"\n    [canNavigateBefore]=\"canNavigateBefore\"\n    [canNavigateNext]=\"canNavigateNext\"\n    [allowLeftSidebar]=\"allowLeftSidebar\"\n    [allowRightSidebar]=\"allowRightSidebar\"\n    [showRightSidebar]=\"showRightSidebar\"\n    [showLeftSidebar]=\"showLeftSidebar\"\n    [allowFullScreen]=\"allowFullScreen\"\n    [sidebarRightTemplate]=\"sidebarRightTemplate\"\n    [sidebarLeftTemplate]=\"sidebarLeftTemplate\"\n    [sidebarRightTemplateContext]=\"sidebarRightTemplateContext\"\n    [sidebarLeftTemplateContext]=\"sidebarLeftTemplateContext\"\n    [fileName]=\"fileName\"\n    [mimeType]=\"mimeType\"\n    [urlFile]=\"urlFileContent\"\n    [tracks]=\"tracks\"\n    [readOnly]=\"readOnly\"\n    (downloadFile)=\"onDownloadFile()\"\n    (navigateBefore)=\"onNavigateBeforeClick($event)\"\n    (navigateNext)=\"onNavigateNextClick($event)\"\n    (showViewerChange)=\"onClose()\"\n    (submitFile)=\"onSubmitFile($event)\">\n\n    <adf-viewer-toolbar *ngIf=\"toolbar\">\n        <ng-content select=\"adf-viewer-toolbar\"></ng-content>\n    </adf-viewer-toolbar>\n\n    <adf-viewer-toolbar-actions *ngIf=\"toolbarActions\">\n        <ng-content select=\"adf-viewer-toolbar-actions\"></ng-content>\n    </adf-viewer-toolbar-actions>\n\n    <adf-viewer-more-actions *ngIf=\"moreActions\">\n        <ng-content select=\"adf-viewer-more-actions\"></ng-content>\n    </adf-viewer-more-actions>\n\n    <adf-viewer-open-with *ngIf=\"openWith\">\n        <ng-content select=\"adf-viewer-open-with\"></ng-content>\n    </adf-viewer-open-with>\n\n    <adf-viewer-sidebar *ngIf=\"sidebar\">\n        <ng-content select=\"adf-viewer-sidebar\"></ng-content>\n    </adf-viewer-sidebar>\n\n    <adf-viewer-toolbar-custom-actions>\n        <button id=\"adf-alfresco-viewer-download\"\n                *ngIf=\"allowDownload\"\n                mat-icon-button\n                [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate\"\n                title=\"{{ 'ADF_VIEWER.ACTIONS.DOWNLOAD' | translate }}\"\n                data-automation-id=\"adf-toolbar-download\"\n                [adfNodeDownload]=\"nodeEntry\"\n                [version]=\"versionEntry\">\n            <mat-icon>file_download</mat-icon>\n        </button>\n\n        <button id=\"adf-alfresco-viewer-print\"\n                *ngIf=\"allowPrint\"\n                mat-icon-button\n                [attr.aria-label]=\"'ADF_VIEWER.ACTIONS.PRINT' | translate\"\n                title=\"{{ 'ADF_VIEWER.ACTIONS.PRINT' | translate }}\"\n                data-automation-id=\"adf-toolbar-print\"\n                (click)=\"onPrintContent($event)\">\n            <mat-icon>print</mat-icon>\n        </button>\n    </adf-viewer-toolbar-custom-actions>\n</adf-viewer>\n" }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: NodesApiService }, { type: RenditionService }, { type: i1.ViewUtilService }, { type: i1.LogService }, { type: ContentService }, { type: UploadService }, { type: i1$1.MatDialog }, { type: i0.ChangeDetectorRef }, { type: NodeActionsService }]; }, propDecorators: { adfViewer: [{
                type: ViewChild,
                args: ['adfViewer']
            }], toolbar: [{
                type: ContentChild,
                args: [ViewerToolbarComponent]
            }], sidebar: [{
                type: ContentChild,
                args: [ViewerSidebarComponent]
            }], toolbarActions: [{
                type: ContentChild,
                args: [ViewerToolbarActionsComponent]
            }], moreActions: [{
                type: ContentChild,
                args: [ViewerMoreActionsComponent]
            }], openWith: [{
                type: ContentChild,
                args: [ViewerOpenWithComponent]
            }], nodeId: [{
                type: Input
            }], versionId: [{
                type: Input
            }], sharedLinkId: [{
                type: Input
            }], showViewer: [{
                type: Input
            }], maxRetries: [{
                type: Input
            }], allowGoBack: [{
                type: Input
            }], showToolbar: [{
                type: Input
            }], overlayMode: [{
                type: Input
            }], allowNavigate: [{
                type: Input
            }], canNavigateBefore: [{
                type: Input
            }], canNavigateNext: [{
                type: Input
            }], allowLeftSidebar: [{
                type: Input
            }], allowRightSidebar: [{
                type: Input
            }], showRightSidebar: [{
                type: Input
            }], showLeftSidebar: [{
                type: Input
            }], allowDownload: [{
                type: Input
            }], allowPrint: [{
                type: Input
            }], allowFullScreen: [{
                type: Input
            }], sidebarRightTemplate: [{
                type: Input
            }], sidebarLeftTemplate: [{
                type: Input
            }], invalidSharedLink: [{
                type: Output
            }], navigateBefore: [{
                type: Output
            }], navigateNext: [{
                type: Output
            }], showViewerChange: [{
                type: Output
            }] } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AlfrescoViewerModule {
}
AlfrescoViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlfrescoViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoViewerModule, declarations: [AlfrescoViewerComponent], imports: [CoreModule,
        CommonModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        A11yModule,
        ExtensionsModule,
        ContentDirectiveModule], exports: [AlfrescoViewerComponent] });
AlfrescoViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoViewerModule, imports: [CoreModule,
        CommonModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        A11yModule,
        ExtensionsModule,
        ContentDirectiveModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: AlfrescoViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CoreModule,
                        CommonModule,
                        MaterialModule,
                        TranslateModule,
                        FormsModule,
                        ReactiveFormsModule,
                        A11yModule,
                        ExtensionsModule,
                        ContentDirectiveModule
                    ],
                    declarations: [
                        AlfrescoViewerComponent
                    ],
                    exports: [
                        AlfrescoViewerComponent
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SKIP_COUNT = 0;
const DEFAULT_INCLUDE = 'inUse';
class SecurityControlsService {
    constructor(apiService, userPreferencesService) {
        this.apiService = apiService;
        this.userPreferencesService = userPreferencesService;
        this.groupsPaginatedSource = new Subject();
        this.groupsPaginated$ = this.groupsPaginatedSource.asObservable();
        this.reloadSecurityControls = new Subject();
        this.reloadSecurityControls$ = this.reloadSecurityControls.asObservable();
        this._reloadAuthorityClearance = new Subject();
        this.reloadAuthorityClearance$ = this._reloadAuthorityClearance.asObservable();
        this.marksPaginatedSource = new Subject();
        this.marksPaginated$ = this.marksPaginatedSource.asObservable();
        this.loadingSource = new BehaviorSubject(true);
        this.loading$ = this.loadingSource.asObservable();
    }
    get groupsApi() {
        return this.securityGroup || (this.securityGroup = new SecurityGroupsApi(this.apiService.getInstance()));
    }
    get marksApi() {
        return this.securityMark || (this.securityMark = new SecurityMarksApi(this.apiService.getInstance()));
    }
    get authorityClearanceApi() {
        return this.authorityClearance || (this.authorityClearance = new AuthorityClearanceApi(this.apiService.getInstance()));
    }
    get reloadAuthorityClearance() {
        return this._reloadAuthorityClearance;
    }
    /**
     * Get All security groups
     *
     * @param include Additional information about the security group
     * @param skipCount The number of entities that exist in the collection before those included in this list.
     * @param maxItems The maximum number of items to return in the list. Default is specified by UserPreferencesService.
     * @return Promise<SecurityControlsGroupResponse>
     */
    getSecurityGroup(skipCount = DEFAULT_SKIP_COUNT, maxItems = this.userPreferencesService.paginationSize, include = DEFAULT_INCLUDE) {
        let securityControlsGroupResponse;
        return new Promise((resolve, reject) => {
            this.groupsApi
                .getSecurityGroups({
                include,
                skipCount,
                maxItems
            })
                .then((response) => {
                this.groupsPaginatedSource.next((securityControlsGroupResponse = {
                    pagination: response.list.pagination,
                    entries: response.list.entries.map((group) => group.entry)
                }));
                resolve(securityControlsGroupResponse);
            })
                .catch((error) => reject(error));
        });
    }
    /**
     * Create security group
     *
     * @param input securityGroupBody.
     * @return Observable<SecurityGroupEntry>
     */
    createSecurityGroup(input) {
        this.loadingSource.next(true);
        const payload = {
            ...input
        };
        const opts = {
            DEFAULT_INCLUDE
        };
        const promise = this.groupsApi.createSecurityGroup(payload, opts);
        return from(promise).pipe(finalize(() => this.loadingSource.next(false)));
    }
    /**
     * Create security marks
     *
     * @param securityGroupId The key for the security group id.
     * @param input securityMarkBody[].
     * @return Promise<SecurityMarkPaging | SecurityMarkEntry>
     */
    createSecurityMarks(securityGroupId, input) {
        this.loadingSource.next(true);
        const promise = this.marksApi.createSecurityMarks(securityGroupId, input)
            .then((result) => {
            this.loadingSource.next(false);
            return result;
        })
            .catch((error) => {
            this.loadingSource.next(false);
            return error;
        });
        return promise;
    }
    /**
     * Get security mark value
     * Gets the value for a selected **securityGroupId**.
     *
     * @param securityGroupId The key for the security group id.
     * @param skipCount The number of entities that exist in the collection before those included in this list.
     * @param include The key for the security mark is in use or not
     * @return Promise<SecurityControlsMarkResponse>
     */
    getSecurityMark(securityGroupId, skipCount = DEFAULT_SKIP_COUNT, include = DEFAULT_INCLUDE) {
        let securityControlsMarkResponse;
        return new Promise((resolve, reject) => {
            this.marksApi
                .getSecurityMarks(securityGroupId, {
                include,
                skipCount
            })
                .then((response) => {
                this.marksPaginatedSource.next((securityControlsMarkResponse = {
                    pagination: response.list.pagination,
                    entries: response.list.entries.map((mark) => mark.entry)
                }));
                resolve(securityControlsMarkResponse);
            })
                .catch((error) => reject(error));
        });
    }
    /**
     * Update a security groups information
     *
     * @param securityGroupId The Key of Security Group id for which info is required
     * @param input SecurityGroupBody
     * @param opts additional information about the security group
     * @return Promise<SecurityGroupEntry>
     */
    updateSecurityGroup(securityGroupId, input, opts) {
        this.loadingSource.next(true);
        const payload = {
            ...input
        };
        if (!opts) {
            opts = {
                DEFAULT_INCLUDE
            };
        }
        const promise = this.groupsApi.updateSecurityGroup(securityGroupId, payload, opts)
            .then((result) => {
            this.loadingSource.next(false);
            return result;
        })
            .catch((error) => {
            this.loadingSource.next(false);
            return error;
        });
        return promise;
    }
    /**
     * Updates Security Mark value
     *
     * @param securityGroupId The key for the security group id.
     * @param securityMarkId The key for the security mark is in use or not.
     * @param input securityMarkBody.
     * @return Promise<SecurityMarkEntry>
     */
    updateSecurityMark(securityGroupId, securityMarkId, input) {
        this.loadingSource.next(true);
        const payload = {
            ...input
        };
        const promise = this.marksApi.updateSecurityMark(securityGroupId, securityMarkId, payload)
            .then((result) => {
            this.loadingSource.next(false);
            return result;
        })
            .catch((error) => {
            this.loadingSource.next(false);
            return error;
        });
        return promise;
    }
    /**
     * Delete security group
     *
     * @param securityGroupId The key for the security group id.
     * @return Observable<SecurityGroupEntry>
     */
    deleteSecurityGroup(securityGroupId) {
        this.loadingSource.next(true);
        const promise = this.groupsApi.deleteSecurityGroup(securityGroupId);
        return from(promise).pipe(finalize(() => this.loadingSource.next(false)));
    }
    /**
     * Delete security mark
     *
     * @param securityGroupId The key for the security group id.
     * @param securityMarkId The key for the security mark id.
     * @return Promise<SecurityMarkEntry>
     */
    deleteSecurityMark(securityGroupId, securityMarkId) {
        this.loadingSource.next(true);
        const promise = this.marksApi.deleteSecurityMark(securityGroupId, securityMarkId)
            .then((result) => {
            this.loadingSource.next(false);
            return result;
        })
            .catch((error) => {
            this.loadingSource.next(false);
            return error;
        });
        return promise;
    }
    /**
     * Get the authority clearances for a single user/group
     *
     * @param authorityName The name for the authority for which the clearance is to be fetched. Can be left blank in which case it will fetch it for all users with pagination
     * @param skipCount The number of entities that exist in the collection before those included in this list.
     * @param maxItems The maximum number of items to return in the list. Default is specified by UserPreferencesService.
     * @return Observable<AuthorityClearanceGroupPaging>
     */
    getClearancesForAuthority(authorityName, skipCount = DEFAULT_SKIP_COUNT, maxItems = this.userPreferencesService.paginationSize) {
        this.loadingSource.next(true);
        const opts = {
            skipCount, maxItems
        };
        const promise = this.authorityClearanceApi.getAuthorityClearanceForAuthority(authorityName, opts);
        return from(promise).pipe(finalize(() => this.loadingSource.next(false)));
    }
    /**
     * Updates the authority clearance.
     *
     * @param authorityName The name for the authority for which the clearance is to be updated
     * @param securityMarksList NodeSecurityMarkBody[]
     * @return Observable<SecurityMarkEntry | SecurityMarkPaging>
     */
    updateClearancesForAuthority(authorityName, securityMarksList) {
        this.loadingSource.next(true);
        const promise = this.authorityClearanceApi.updateAuthorityClearance(authorityName, securityMarksList);
        return from(promise).pipe(finalize(() => {
            this.loadingSource.next(false);
            this._reloadAuthorityClearance.next();
        }));
    }
    reloadSecurityGroups() {
        this.reloadSecurityControls.next();
    }
}
SecurityControlsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsService, deps: [{ token: i1.AlfrescoApiService }, { token: i1.UserPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
SecurityControlsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.AlfrescoApiService }, { type: i1.UserPreferencesService }]; } });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class SecurityControlsServiceModule {
}
SecurityControlsServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SecurityControlsServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsServiceModule, imports: [CommonModule] });
SecurityControlsServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsServiceModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: SecurityControlsServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function versionCompatibilityFactory(versionCompatibilityService) {
    return () => versionCompatibilityService;
}

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ContentModule {
    static forRoot() {
        return {
            ngModule: ContentModule,
            providers: [
                {
                    provide: TRANSLATION_PROVIDER,
                    multi: true,
                    useValue: {
                        name: 'adf-content-services',
                        source: 'assets/adf-content-services'
                    }
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: versionCompatibilityFactory,
                    deps: [VersionCompatibilityService],
                    multi: true
                }
            ]
        };
    }
    static forChild() {
        return {
            ngModule: ContentModule
        };
    }
}
ContentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.3", ngImport: i0, type: ContentModule, imports: [ContentPipeModule,
        CoreModule,
        SocialModule,
        TagModule,
        CommonModule,
        WebScriptModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        SearchModule,
        DocumentListModule,
        ContentUserInfoModule,
        UploadModule,
        MaterialModule,
        SitesDropdownModule,
        BreadcrumbModule,
        ContentNodeSelectorModule,
        ContentNodeShareModule,
        ContentMetadataModule,
        FolderDirectiveModule,
        ContentDirectiveModule,
        PermissionManagerModule,
        VersionManagerModule,
        TreeViewModule,
        ContentTypeModule,
        AspectListModule,
        VersionCompatibilityModule,
        NodeCommentsModule,
        TreeModule,
        SearchTextModule,
        AlfrescoViewerModule,
        SecurityControlsServiceModule,
        CategoriesModule], exports: [ContentPipeModule,
        SocialModule,
        TagModule,
        WebScriptModule,
        DocumentListModule,
        ContentUserInfoModule,
        UploadModule,
        SearchModule,
        SitesDropdownModule,
        BreadcrumbModule,
        ContentNodeSelectorModule,
        ContentNodeShareModule,
        ContentMetadataModule,
        DialogModule,
        FolderDirectiveModule,
        ContentDirectiveModule,
        PermissionManagerModule,
        VersionManagerModule,
        TreeViewModule,
        AspectListModule,
        ContentTypeModule,
        VersionCompatibilityModule,
        NodeCommentsModule,
        TreeModule,
        SearchTextModule,
        AlfrescoViewerModule,
        SecurityControlsServiceModule,
        CategoriesModule] });
ContentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentModule, providers: [
        {
            provide: TRANSLATION_PROVIDER,
            multi: true,
            useValue: {
                name: 'adf-content-services',
                source: 'assets/adf-content-services'
            }
        }
    ], imports: [ContentPipeModule,
        CoreModule,
        SocialModule,
        TagModule,
        CommonModule,
        WebScriptModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        SearchModule,
        DocumentListModule,
        ContentUserInfoModule,
        UploadModule,
        MaterialModule,
        SitesDropdownModule,
        BreadcrumbModule,
        ContentNodeSelectorModule,
        ContentNodeShareModule,
        ContentMetadataModule,
        FolderDirectiveModule,
        ContentDirectiveModule,
        PermissionManagerModule,
        VersionManagerModule,
        TreeViewModule,
        ContentTypeModule,
        AspectListModule,
        VersionCompatibilityModule,
        NodeCommentsModule,
        TreeModule,
        SearchTextModule,
        AlfrescoViewerModule,
        SecurityControlsServiceModule,
        CategoriesModule, ContentPipeModule,
        SocialModule,
        TagModule,
        WebScriptModule,
        DocumentListModule,
        ContentUserInfoModule,
        UploadModule,
        SearchModule,
        SitesDropdownModule,
        BreadcrumbModule,
        ContentNodeSelectorModule,
        ContentNodeShareModule,
        ContentMetadataModule,
        DialogModule,
        FolderDirectiveModule,
        ContentDirectiveModule,
        PermissionManagerModule,
        VersionManagerModule,
        TreeViewModule,
        AspectListModule,
        ContentTypeModule,
        VersionCompatibilityModule,
        NodeCommentsModule,
        TreeModule,
        SearchTextModule,
        AlfrescoViewerModule,
        SecurityControlsServiceModule,
        CategoriesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.3", ngImport: i0, type: ContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ContentPipeModule,
                        CoreModule,
                        SocialModule,
                        TagModule,
                        CommonModule,
                        WebScriptModule,
                        FormsModule,
                        ReactiveFormsModule,
                        DialogModule,
                        SearchModule,
                        DocumentListModule,
                        ContentUserInfoModule,
                        UploadModule,
                        MaterialModule,
                        SitesDropdownModule,
                        BreadcrumbModule,
                        ContentNodeSelectorModule,
                        ContentNodeShareModule,
                        ContentMetadataModule,
                        FolderDirectiveModule,
                        ContentDirectiveModule,
                        PermissionManagerModule,
                        VersionManagerModule,
                        TreeViewModule,
                        ContentTypeModule,
                        AspectListModule,
                        VersionCompatibilityModule,
                        NodeCommentsModule,
                        TreeModule,
                        SearchTextModule,
                        AlfrescoViewerModule,
                        SecurityControlsServiceModule,
                        CategoriesModule
                    ],
                    providers: [
                        {
                            provide: TRANSLATION_PROVIDER,
                            multi: true,
                            useValue: {
                                name: 'adf-content-services',
                                source: 'assets/adf-content-services'
                            }
                        }
                    ],
                    exports: [
                        ContentPipeModule,
                        SocialModule,
                        TagModule,
                        WebScriptModule,
                        DocumentListModule,
                        ContentUserInfoModule,
                        UploadModule,
                        SearchModule,
                        SitesDropdownModule,
                        BreadcrumbModule,
                        ContentNodeSelectorModule,
                        ContentNodeShareModule,
                        ContentMetadataModule,
                        DialogModule,
                        FolderDirectiveModule,
                        ContentDirectiveModule,
                        PermissionManagerModule,
                        VersionManagerModule,
                        TreeViewModule,
                        AspectListModule,
                        ContentTypeModule,
                        VersionCompatibilityModule,
                        NodeCommentsModule,
                        TreeModule,
                        SearchTextModule,
                        AlfrescoViewerModule,
                        SecurityControlsServiceModule,
                        CategoriesModule
                    ]
                }]
        }] });

/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddPermissionComponent, AddPermissionDialogComponent, AddPermissionPanelComponent, AlfrescoViewerComponent, AlfrescoViewerModule, AllowableOperationsEnum, AspectListComponent, AspectListDialogComponent, AspectListModule, AspectListService, AspectOrientedConfigService, AutoFocusDirective, BasicPropertiesService, BreadcrumbComponent, BreadcrumbModule, CardViewContentUpdateService, CategoriesManagementComponent, CategoriesManagementMode, CategoriesModule, CategoryService, CategoryTreeDatasourceService, CheckAllowableOperationDirective, ConfirmDialogComponent, ContentActionComponent, ContentActionListComponent, ContentActionModel, ContentActionTarget, ContentDirectiveModule, ContentGroups, ContentInfo, ContentMetadataCardComponent, ContentMetadataComponent, ContentMetadataConfigFactory, ContentMetadataModule, ContentMetadataService, ContentModule, ContentNodeDialogService, ContentNodeSelectorComponent, ContentNodeSelectorModule, ContentNodeSelectorPanelComponent, ContentNodeSelectorPanelService, ContentNodeShareModule, ContentPipeModule, ContentService, ContentTypeDialogComponent, ContentTypeModule, ContentTypePropertiesService, ContentTypeService, ContentUserInfoComponent, ContentUserInfoModule, ContentVersionService, CustomResourcesService, DROP_EFFECT, DialogAspectListService, DialogModule, DiscoveryApiService, DocumentActionModel, DocumentActionsService, DocumentListComponent, DocumentListModule, DocumentListService, DownloadZipDialogComponent, DownloadZipDialogModule, DropdownBreadcrumbComponent, DropdownSitesComponent, ERR_COL_NOT_FOUND, ERR_OBJECT_NOT_FOUND, ERR_ROW_NOT_FOUND, EcmCompanyModel, EcmUserModel, EmptySearchResultComponent, FacetBucketSortBy, FacetBucketSortDirection, FavoritesApiService, FileAutoDownloadComponent, FileDraggableDirective, FileModel, FileUploadCompleteEvent, FileUploadDeleteEvent, FileUploadErrorEvent, FileUploadErrorPipe, FileUploadEvent, FileUploadOptions, FileUploadStatus, FileUploadingDialogComponent, FileUploadingListComponent, FileUploadingListRowComponent, FilterHeaderComponent, FolderActionModel, FolderActionsService, FolderCreateDirective, FolderDialogComponent, FolderDirectiveModule, FolderEditDirective, GroupService, INPUT_FOCUS_CSS_CLASS, IndifferentConfigService, InheritPermissionDirective, IsIncludedPipe, LayoutOrientedConfigService, LibraryDialogComponent, LibraryFavoriteDirective, LibraryMembershipDirective, LibraryNameColumnComponent, LibraryRoleColumnComponent, LibraryStatusColumnComponent, LikeComponent, LockService, LogicalSearchFields, MemberModel, NameColumnComponent, NameLocationCellComponent, NewVersionUploaderDataAction, NewVersionUploaderDialogComponent, NewVersionUploaderModule, NewVersionUploaderService, NodeAction, NodeActionsService, NodeAspectService, NodeCommentsComponent, NodeCommentsModule, NodeCommentsService, NodeCounterComponent, NodeCounterDirective, NodeDeleteDirective, NodeDownloadDirective, NodeEntityEvent, NodeEntryEvent, NodeFavoriteDirective, NodeLockDialogComponent, NodeLockDirective, NodeMetadata, NodeMinimal, NodeMinimalEntry, NodeNameTooltipPipe, NodePaging, NodePagingList, NodePathColumnComponent, NodePermissionDialogService, NodePermissionService, NodeRestoreDirective, NodeSharedDirective, NodesApiService, Pagination, PathElementEntity, PathInfoEntity, PeopleContentService, PermissionContainerComponent, PermissionDisplayModel, PermissionListComponent, PermissionManagerModule, PermissionModel, PermissionStyleModel, PermissionsEnum, PopOverDirective, PropertyDescriptorsService, PropertyGroupTranslatorService, RECOGNISED_ECM_TYPES, RatingComponent, RatingService, Relations, RenditionService, ResetSearchDirective, RestoreMessageModel, SEARCH_QUERY_SERVICE_TOKEN, SEARCH_QUERY_TOKEN, SearchCheckListComponent, SearchChipAutocompleteInputComponent, SearchChipInputComponent, SearchChipListComponent, SearchComponent, SearchConfigurationService, SearchControlComponent, SearchDateRangeComponent, SearchDatetimeRangeComponent, SearchFacetFieldComponent, SearchFacetFiltersService, SearchFilterAutocompleteChipsComponent, SearchFilterChipsComponent, SearchFilterComponent, SearchFilterContainerComponent, SearchFilterMenuCardComponent, SearchFilterService, SearchFormComponent, SearchHeaderQueryBuilderService, SearchLogicalFilterComponent, SearchModule, SearchNumberRangeComponent, SearchPanelComponent, SearchPermissionConfigurationService, SearchQueryBuilderService, SearchRadioComponent, SearchService, SearchSliderComponent, SearchSortingPickerComponent, SearchTextComponent, SearchWidgetContainerComponent, SecurityControlsService, SecurityControlsServiceModule, ShareDataRow, ShareDataTableAdapter, ShareDialogComponent, SharedLinksApiService, SitesDropdownModule, SitesService, SocialModule, TagActionsComponent, TagListComponent, TagModule, TagNodeListComponent, TagService, TagsCreatorComponent, TagsCreatorMode, ToggleIconDirective, TrashcanNameColumnComponent, TreeBaseNode, TreeComponent, TreeModule, TreeNodeType, TreeService, TreeViewComponent, TreeViewDataSource, TreeViewModule, TreeViewService, UploadBase, UploadButtonComponent, UploadDragAreaComponent, UploadFilesEvent, UploadModule, UploadService, UploadVersionButtonComponent, UserIconColumnComponent, UserInfo, UserNameColumnComponent, UserRoleColumnComponent, VersionComparisonComponent, VersionCompatibilityDirective, VersionCompatibilityModule, VersionCompatibilityService, VersionListComponent, VersionManagerComponent, VersionManagerModule, VersionUploadComponent, WebScriptModule, WebscriptComponent, createNewPersonMock, defaultValidation, fakeEcmAdminUser, fakeEcmEditedUser, fakeEcmUser, fakeEcmUser2, fakeEcmUserList, fakeEcmUserNoImage, fakeSearch, forbidEndingDot, forbidOnlySpaces, forbidSpecialCharacters, getFakeUserWithContentAdminCapability, getFakeUserWithContentUserCapability, mockError, searchMockApi };
